// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%238b96a0%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%2394a0ad%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%238b96a0%27 opacity=%270.5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27var%28--ct-border-color%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%231abc9c%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23f1556c%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23f1556c%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28var%28--ct-emphasis-color-rgb%29, 0.65%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%236c757d%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%2881.6, 70.4, 176.8%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%28163.2, 154.8, 234.6%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%238b96a0%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../images/megamenu-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/cerebrisans-light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/cerebrisans-light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/cerebrisans-regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/cerebrisans-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/cerebrisans-medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/cerebrisans-medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/cerebrisans-semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/cerebrisans-semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/cerebrisans-bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../fonts/cerebrisans-bold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:400,600,700,900);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
Template Name: Ubold - Responsive Bootstrap 5 Admin Dashboard
Version: 7.0.0
Author: CoderThemes
Email: support@coderthemes.com
File: Bootstrap Css File
*/
/*!
 * Bootstrap  v5.3.0-alpha1 (https://getbootstrap.com/)
 * Copyright 2011-2022 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --ct-blue: #4a81d4;
  --ct-indigo: #675aa9;
  --ct-purple: #6658dd;
  --ct-pink: #f672a7;
  --ct-red: #f1556c;
  --ct-orange: #fd7e14;
  --ct-yellow: #f7b84b;
  --ct-green: #1abc9c;
  --ct-teal: #02a8b5;
  --ct-cyan: #43bfe5;
  --ct-black: #000;
  --ct-white: #fff;
  --ct-gray: #98a6ad;
  --ct-gray-dark: #343a40;
  --ct-gray-100: #f3f7f9;
  --ct-gray-200: #f7f7f7;
  --ct-gray-300: #dee2e6;
  --ct-gray-400: #ced4da;
  --ct-gray-500: #adb5bd;
  --ct-gray-600: #98a6ad;
  --ct-gray-700: #6c757d;
  --ct-gray-800: #343a40;
  --ct-gray-900: #323a46;
  --ct-primary: #6658dd;
  --ct-secondary: #6c757d;
  --ct-success: #1abc9c;
  --ct-info: #43bfe5;
  --ct-warning: #f7b84b;
  --ct-danger: #f1556c;
  --ct-light: #f3f7f9;
  --ct-dark: #323a46;
  --ct-pink: #f672a7;
  --ct-blue: #4a81d4;
  --ct-primary-rgb: 102, 88, 221;
  --ct-secondary-rgb: 108, 117, 125;
  --ct-success-rgb: 26, 188, 156;
  --ct-info-rgb: 67, 191, 229;
  --ct-warning-rgb: 247, 184, 75;
  --ct-danger-rgb: 241, 85, 108;
  --ct-light-rgb: 243, 247, 249;
  --ct-dark-rgb: 50, 58, 70;
  --ct-pink-rgb: 246, 114, 167;
  --ct-blue-rgb: 74, 129, 212;
  --ct-primary-text: rgb(81.6, 70.4, 176.8);
  --ct-secondary-text: #98a6ad;
  --ct-success-text: rgb(20.8, 150.4, 124.8);
  --ct-info-text: rgb(40.2, 114.6, 137.4);
  --ct-warning-text: rgb(148.2, 110.4, 45);
  --ct-danger-text: rgb(192.8, 68, 86.4);
  --ct-light-text: #98a6ad;
  --ct-dark-text: #6c757d;
  --ct-primary-bg-subtle: rgb(224.4, 221.6, 248.2);
  --ct-secondary-bg-subtle: #f3f7f9;
  --ct-success-bg-subtle: rgb(209.2, 241.6, 235.2);
  --ct-info-bg-subtle: rgb(217.4, 242.2, 249.8);
  --ct-warning-bg-subtle: rgb(253.4, 240.8, 219);
  --ct-danger-bg-subtle: rgb(252.2, 221, 225.6);
  --ct-light-bg-subtle: #f9fbfc;
  --ct-dark-bg-subtle: #ced4da;
  --ct-primary-border-subtle: rgb(193.8, 188.2, 241.4);
  --ct-secondary-border-subtle: #f7f7f7;
  --ct-success-border-subtle: rgb(163.4, 228.2, 215.4);
  --ct-info-border-subtle: rgb(179.8, 229.4, 244.6);
  --ct-warning-border-subtle: rgb(251.8, 226.6, 183);
  --ct-danger-border-subtle: rgb(249.4, 187, 196.2);
  --ct-light-border-subtle: #f7f7f7;
  --ct-dark-border-subtle: #adb5bd;
  --ct-white-rgb: 255, 255, 255;
  --ct-black-rgb: 0, 0, 0;
  --ct-body-color-rgb: 108, 117, 125;
  --ct-body-bg-rgb: 245, 246, 248;
  --ct-font-sans-serif: "Nunito", sans-serif;
  --ct-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --ct-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --ct-body-font-family: var(--ct-font-sans-serif);
  --ct-body-font-size: 0.875rem;
  --ct-body-font-weight: 400;
  --ct-body-line-height: 1.5;
  --ct-body-color: #6c757d;
  --ct-emphasis-color: #000;
  --ct-emphasis-color-rgb: 0, 0, 0;
  --ct-secondary-color: #6c757d;
  --ct-secondary-color-rgb: 108, 117, 125;
  --ct-secondary-bg: #fff;
  --ct-secondary-bg-rgb: 255, 255, 255;
  --ct-tertiary-color: rgba(108, 117, 125, 0.5);
  --ct-tertiary-color-rgb: 108, 117, 125;
  --ct-tertiary-bg: #e9ecef;
  --ct-tertiary-bg-rgb: 233, 236, 239;
  --ct-body-bg: #f5f6f8;
  --ct-body-bg-rgb: 245, 246, 248;
  --ct-heading-color: #343a40;
  --ct-link-color: #6658dd;
  --ct-link-color-rgb: 102, 88, 221;
  --ct-link-decoration: none;
  --ct-link-hover-color: rgb(86.7, 74.8, 187.85);
  --ct-link-hover-color-rgb: 87, 75, 188;
  --ct-code-color: #43bfe5;
  --ct-highlight-bg: rgb(253.4, 240.8, 219);
  --ct-border-width: 1px;
  --ct-border-style: solid;
  --ct-border-color: #dee2e6;
  --ct-border-color-translucent: rgba(0, 0, 0, 0.175);
  --ct-border-radius: 0.25rem;
  --ct-border-radius-sm: 0.2rem;
  --ct-border-radius-lg: 0.3rem;
  --ct-border-radius-xl: 1rem;
  --ct-border-radius-2xl: 2rem;
  --ct-border-radius-pill: 50rem;
  --ct-box-shadow: var(--ct-box-shadow);
  --ct-box-shadow-sm: var(--ct-box-shadow-sm);
  --ct-box-shadow-lg: var(--ct-box-shadow-lg);
  --ct-box-shadow-inset: var(--ct-box-shadow-inset);
  --ct-emphasis-color: #000;
  --ct-form-control-bg: var(--ct-body-bg);
  --ct-form-control-disabled-bg: var(--ct-secondary-bg);
  --ct-breakpoint-xs: 0;
  --ct-breakpoint-sm: 576px;
  --ct-breakpoint-md: 768px;
  --ct-breakpoint-lg: 992px;
  --ct-breakpoint-xl: 1200px;
  --ct-breakpoint-xxl: 1400px;
}

@supports (color: rgb(0 0 0 / 0)){
:root,
[data-bs-theme=light] {
  --ct-highlight-bg: rgb(253.4, 240.8, 219);
}
}

[data-bs-theme=dark] {
  --ct-body-color: #94a0ad;
  --ct-body-color-rgb: 148, 160, 173;
  --ct-body-bg: #303841;
  --ct-body-bg-rgb: 48, 56, 65;
  --ct-emphasis-color: #f3f7f9;
  --ct-emphasis-color-rgb: 243, 247, 249;
  --ct-secondary-color: #94a0ad;
  --ct-secondary-color-rgb: 148, 160, 173;
  --ct-secondary-bg: #36404a;
  --ct-secondary-bg-rgb: 54, 64, 74;
  --ct-tertiary-color: rgba(148, 160, 173, 0.5);
  --ct-tertiary-color-rgb: 148, 160, 173;
  --ct-tertiary-bg: #333a43;
  --ct-tertiary-bg-rgb: 51, 58, 67;
  --ct-emphasis-color: #fff;
  --ct-primary-text: rgb(163.2, 154.8, 234.6);
  --ct-secondary-text: #dee2e6;
  --ct-success-text: rgb(117.6, 214.8, 195.6);
  --ct-info-text: rgb(142.2, 216.6, 239.4);
  --ct-warning-text: rgb(250.2, 212.4, 147);
  --ct-danger-text: rgb(246.6, 153, 166.8);
  --ct-light-text: #f3f7f9;
  --ct-dark-text: #dee2e6;
  --ct-primary-bg-subtle: rgb(20.4, 17.6, 44.2);
  --ct-secondary-bg-subtle: #323a46;
  --ct-success-bg-subtle: rgb(5.2, 37.6, 31.2);
  --ct-info-bg-subtle: rgb(13.4, 38.2, 45.8);
  --ct-warning-bg-subtle: rgb(49.4, 36.8, 15);
  --ct-danger-bg-subtle: rgb(48.2, 17, 21.6);
  --ct-light-bg-subtle: #343a40;
  --ct-dark-bg-subtle: #1a1d20;
  --ct-primary-border-subtle: rgb(61.2, 52.8, 132.6);
  --ct-secondary-border-subtle: #6c757d;
  --ct-success-border-subtle: rgb(15.6, 112.8, 93.6);
  --ct-info-border-subtle: rgb(26.8, 76.4, 91.6);
  --ct-warning-border-subtle: rgb(98.8, 73.6, 30);
  --ct-danger-border-subtle: rgb(144.6, 51, 64.8);
  --ct-light-border-subtle: #6c757d;
  --ct-dark-border-subtle: #343a40;
  --ct-heading-color: #fff;
  --ct-link-color: rgb(163.2, 154.8, 234.6);
  --ct-link-hover-color: rgb(193.8, 188.2, 241.4);
  --ct-link-color-rgb: 163, 155, 235;
  --ct-link-hover-color-rgb: 194, 188, 241;
  --ct-code-color: rgb(249.6, 170.4, 202.2);
  --ct-border-color: #424e5a;
  --ct-border-color-translucent: rgba(255, 255, 255, 0.15);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--ct-body-font-family);
  font-size: var(--ct-body-font-size);
  font-weight: var(--ct-body-font-weight);
  line-height: var(--ct-body-line-height);
  color: var(--ct-body-color);
  text-align: var(--ct-body-text-align);
  background-color: var(--ct-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1.5rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.75rem;
  font-family: "Cerebri Sans", sans-serif;
  font-weight: 500;
  line-height: 1.1;
  color: var(--ct-heading-color, inherit);
}

h1, .h1 {
  font-size: calc(1.35rem + 1.2vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.25rem;
  }
}

h2, .h2 {
  font-size: calc(1.3125rem + 0.75vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.875rem;
  }
}

h3, .h3 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.5rem;
  }
}

h4, .h4 {
  font-size: 1.125rem;
}

h5, .h5 {
  font-size: 0.9375rem;
}

h6, .h6 {
  font-size: 0.75rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.75rem;
}

mark, .mark {
  padding: 0.1875em;
  background-color: var(--ct-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--ct-link-color-rgb), var(--ct-link-opacity, 1));
  text-decoration: none;
}
a:hover {
  --ct-link-color-rgb: var(--ct-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--ct-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 87.5%;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 87.5%;
  color: var(--ct-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: var(--ct-body-color);
  background-color: var(--ct-secondary-bg);
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.85rem;
  padding-bottom: 0.85rem;
  color: var(--ct-gray);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.09375rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.1;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.1;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.1;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.1;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.1;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.1;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.75rem;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1.5rem;
  font-size: 1.09375rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1.5rem;
  margin-bottom: 1.5rem;
  font-size: 0.75rem;
  color: #98a6ad;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--ct-secondary-bg);
  border: var(--ct-border-width) solid var(--ct-border-color);
  border-radius: var(--ct-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.75rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.75rem;
  color: var(--ct-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --ct-gutter-x: 24px;
  --ct-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--ct-gutter-x) * 0.5);
  padding-left: calc(var(--ct-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
.row {
  --ct-gutter-x: 24px;
  --ct-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--ct-gutter-y));
  margin-right: calc(-0.5 * var(--ct-gutter-x));
  margin-left: calc(-0.5 * var(--ct-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--ct-gutter-x) * 0.5);
  padding-left: calc(var(--ct-gutter-x) * 0.5);
  margin-top: var(--ct-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --ct-gutter-x: 0;
}

.g-0,
.gy-0 {
  --ct-gutter-y: 0;
}

.g-1,
.gx-1 {
  --ct-gutter-x: 0.375rem;
}

.g-1,
.gy-1 {
  --ct-gutter-y: 0.375rem;
}

.g-2,
.gx-2 {
  --ct-gutter-x: 0.75rem;
}

.g-2,
.gy-2 {
  --ct-gutter-y: 0.75rem;
}

.g-3,
.gx-3 {
  --ct-gutter-x: 1.5rem;
}

.g-3,
.gy-3 {
  --ct-gutter-y: 1.5rem;
}

.g-4,
.gx-4 {
  --ct-gutter-x: 2.25rem;
}

.g-4,
.gy-4 {
  --ct-gutter-y: 2.25rem;
}

.g-5,
.gx-5 {
  --ct-gutter-x: 4.5rem;
}

.g-5,
.gy-5 {
  --ct-gutter-y: 4.5rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --ct-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --ct-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --ct-gutter-x: 0.375rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --ct-gutter-y: 0.375rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --ct-gutter-x: 0.75rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --ct-gutter-y: 0.75rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --ct-gutter-x: 1.5rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --ct-gutter-y: 1.5rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --ct-gutter-x: 2.25rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --ct-gutter-y: 2.25rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --ct-gutter-x: 4.5rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --ct-gutter-y: 4.5rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --ct-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --ct-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --ct-gutter-x: 0.375rem;
  }
  .g-md-1,
  .gy-md-1 {
    --ct-gutter-y: 0.375rem;
  }
  .g-md-2,
  .gx-md-2 {
    --ct-gutter-x: 0.75rem;
  }
  .g-md-2,
  .gy-md-2 {
    --ct-gutter-y: 0.75rem;
  }
  .g-md-3,
  .gx-md-3 {
    --ct-gutter-x: 1.5rem;
  }
  .g-md-3,
  .gy-md-3 {
    --ct-gutter-y: 1.5rem;
  }
  .g-md-4,
  .gx-md-4 {
    --ct-gutter-x: 2.25rem;
  }
  .g-md-4,
  .gy-md-4 {
    --ct-gutter-y: 2.25rem;
  }
  .g-md-5,
  .gx-md-5 {
    --ct-gutter-x: 4.5rem;
  }
  .g-md-5,
  .gy-md-5 {
    --ct-gutter-y: 4.5rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --ct-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --ct-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --ct-gutter-x: 0.375rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --ct-gutter-y: 0.375rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --ct-gutter-x: 0.75rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --ct-gutter-y: 0.75rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --ct-gutter-x: 1.5rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --ct-gutter-y: 1.5rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --ct-gutter-x: 2.25rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --ct-gutter-y: 2.25rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --ct-gutter-x: 4.5rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --ct-gutter-y: 4.5rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --ct-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --ct-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --ct-gutter-x: 0.375rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --ct-gutter-y: 0.375rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --ct-gutter-x: 0.75rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --ct-gutter-y: 0.75rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --ct-gutter-x: 1.5rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --ct-gutter-y: 1.5rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --ct-gutter-x: 2.25rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --ct-gutter-y: 2.25rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --ct-gutter-x: 4.5rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --ct-gutter-y: 4.5rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --ct-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --ct-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --ct-gutter-x: 0.375rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --ct-gutter-y: 0.375rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --ct-gutter-x: 0.75rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --ct-gutter-y: 0.75rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --ct-gutter-x: 1.5rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --ct-gutter-y: 1.5rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --ct-gutter-x: 2.25rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --ct-gutter-y: 2.25rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --ct-gutter-x: 4.5rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --ct-gutter-y: 4.5rem;
  }
}
.table {
  --ct-table-color: var(--ct-body-color);
  --ct-table-bg: transparent;
  --ct-table-border-color: var(--ct-border-color);
  --ct-table-accent-bg: transparent;
  --ct-table-striped-color: var(--ct-body-color);
  --ct-table-striped-bg: rgba(0, 0, 0, 0.025);
  --ct-table-active-color: var(--ct-body-color);
  --ct-table-active-bg: rgba(0, 0, 0, 0.1);
  --ct-table-hover-color: var(--ct-body-color);
  --ct-table-hover-bg: rgba(0, 0, 0, 0.075);
  width: 100%;
  margin-bottom: 1.5rem;
  color: var(--ct-table-color);
  vertical-align: top;
  border-color: var(--ct-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.85rem 0.85rem;
  background-color: var(--ct-table-bg);
  border-bottom-width: var(--ct-border-width);
  box-shadow: inset 0 0 0 9999px var(--ct-table-accent-bg);
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--ct-border-width) * 2) solid var(--ct-border-color);
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--ct-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--ct-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --ct-table-accent-bg: var(--ct-table-striped-bg);
  color: var(--ct-table-striped-color);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --ct-table-accent-bg: var(--ct-table-striped-bg);
  color: var(--ct-table-striped-color);
}

.table-active {
  --ct-table-accent-bg: var(--ct-table-active-bg);
  color: var(--ct-table-active-color);
}

.table-hover > tbody > tr:hover > * {
  --ct-table-accent-bg: var(--ct-table-hover-bg);
  color: var(--ct-table-hover-color);
}

.table-primary {
  --ct-table-color: #323a46;
  --ct-table-bg: rgb(224.4, 221.6, 248.2);
  --ct-table-border-color: rgb(206.96, 205.24, 230.38);
  --ct-table-striped-bg: rgb(220.04, 217.51, 243.745);
  --ct-table-striped-color: #323a46;
  --ct-table-active-bg: rgb(206.96, 205.24, 230.38);
  --ct-table-active-color: #323a46;
  --ct-table-hover-bg: rgb(211.32, 209.33, 234.835);
  --ct-table-hover-color: #323a46;
  color: var(--ct-table-color);
  border-color: var(--ct-table-border-color);
}

.table-secondary {
  --ct-table-color: #323a46;
  --ct-table-bg: rgb(225.6, 227.4, 229);
  --ct-table-border-color: rgb(208.04, 210.46, 213.1);
  --ct-table-striped-bg: rgb(221.21, 223.165, 225.025);
  --ct-table-striped-color: #323a46;
  --ct-table-active-bg: rgb(208.04, 210.46, 213.1);
  --ct-table-active-color: #323a46;
  --ct-table-hover-bg: rgb(212.43, 214.695, 217.075);
  --ct-table-hover-color: #323a46;
  color: var(--ct-table-color);
  border-color: var(--ct-table-border-color);
}

.table-success {
  --ct-table-color: #323a46;
  --ct-table-bg: rgb(209.2, 241.6, 235.2);
  --ct-table-border-color: rgb(193.28, 223.24, 218.68);
  --ct-table-striped-bg: rgb(205.22, 237.01, 231.07);
  --ct-table-striped-color: #323a46;
  --ct-table-active-bg: rgb(193.28, 223.24, 218.68);
  --ct-table-active-color: #323a46;
  --ct-table-hover-bg: rgb(197.26, 227.83, 222.81);
  --ct-table-hover-color: #323a46;
  color: var(--ct-table-color);
  border-color: var(--ct-table-border-color);
}

.table-info {
  --ct-table-color: #323a46;
  --ct-table-bg: rgb(217.4, 242.2, 249.8);
  --ct-table-border-color: rgb(200.66, 223.78, 231.82);
  --ct-table-striped-bg: rgb(213.215, 237.595, 245.305);
  --ct-table-striped-color: #323a46;
  --ct-table-active-bg: rgb(200.66, 223.78, 231.82);
  --ct-table-active-color: #323a46;
  --ct-table-hover-bg: rgb(204.845, 228.385, 236.315);
  --ct-table-hover-color: #323a46;
  color: var(--ct-table-color);
  border-color: var(--ct-table-border-color);
}

.table-warning {
  --ct-table-color: #323a46;
  --ct-table-bg: rgb(253.4, 240.8, 219);
  --ct-table-border-color: rgb(233.06, 222.52, 204.1);
  --ct-table-striped-bg: rgb(248.315, 236.23, 215.275);
  --ct-table-striped-color: #323a46;
  --ct-table-active-bg: rgb(233.06, 222.52, 204.1);
  --ct-table-active-color: #323a46;
  --ct-table-hover-bg: rgb(238.145, 227.09, 207.825);
  --ct-table-hover-color: #323a46;
  color: var(--ct-table-color);
  border-color: var(--ct-table-border-color);
}

.table-danger {
  --ct-table-color: #323a46;
  --ct-table-bg: rgb(252.2, 221, 225.6);
  --ct-table-border-color: rgb(231.98, 204.7, 210.04);
  --ct-table-striped-bg: rgb(247.145, 216.925, 221.71);
  --ct-table-striped-color: #323a46;
  --ct-table-active-bg: rgb(231.98, 204.7, 210.04);
  --ct-table-active-color: #323a46;
  --ct-table-hover-bg: rgb(237.035, 208.775, 213.93);
  --ct-table-hover-color: #323a46;
  color: var(--ct-table-color);
  border-color: var(--ct-table-border-color);
}

.table-light {
  --ct-table-color: #323a46;
  --ct-table-bg: #f3f7f9;
  --ct-table-border-color: rgb(223.7, 228.1, 231.1);
  --ct-table-striped-bg: rgb(238.175, 242.275, 244.525);
  --ct-table-striped-color: #323a46;
  --ct-table-active-bg: rgb(223.7, 228.1, 231.1);
  --ct-table-active-color: #323a46;
  --ct-table-hover-bg: rgb(228.525, 232.825, 235.575);
  --ct-table-hover-color: #323a46;
  color: var(--ct-table-color);
  border-color: var(--ct-table-border-color);
}

.table-dark {
  --ct-table-color: #fff;
  --ct-table-bg: #323a46;
  --ct-table-border-color: rgb(70.5, 77.7, 88.5);
  --ct-table-striped-bg: rgb(55.125, 62.925, 74.625);
  --ct-table-striped-color: #fff;
  --ct-table-active-bg: rgb(70.5, 77.7, 88.5);
  --ct-table-active-color: #fff;
  --ct-table-hover-bg: rgb(65.375, 72.775, 83.875);
  --ct-table-hover-color: #fff;
  color: var(--ct-table-color);
  border-color: var(--ct-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.45rem + 1px);
  padding-bottom: calc(0.45rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.09375rem;
}

.col-form-label-sm {
  padding-top: calc(0.28rem + 1px);
  padding-bottom: calc(0.28rem + 1px);
  font-size: 0.765625rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: var(--ct-gray);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.45rem 0.9rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--ct-body-color);
  background-color: var(--ct-secondary-bg);
  background-clip: padding-box;
  border: 1px solid var(--ct-border-color);
  appearance: none;
  border-radius: var(--ct-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--ct-body-color);
  background-color: var(--ct-secondary-bg);
  border-color: var(--ct-border-color);
  outline: 0;
  box-shadow: none;
}
.form-control::-webkit-date-and-time-value {
  height: 1.5em;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--ct-secondary-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--ct-form-control-disabled-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.45rem 0.9rem;
  margin: -0.45rem -0.9rem;
  margin-inline-end: 0.9rem;
  color: var(--ct-body-color);
  background-color: var(--ct-gray-100);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--ct-gray-100);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.45rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--ct-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.56rem + 2px);
  padding: 0.28rem 0.8rem;
  font-size: 0.765625rem;
  border-radius: var(--ct-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.28rem 0.8rem;
  margin: -0.28rem -0.8rem;
  margin-inline-end: 0.8rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.09375rem;
  border-radius: var(--ct-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.9rem + 2px);
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.56rem + 2px);
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + 2px);
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.9rem + 2px);
  padding: 0.45rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--ct-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border-radius: var(--ct-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.56rem + 2px);
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
}

.form-select {
  --ct-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.45rem 2.7rem 0.45rem 0.9rem;
  -moz-padding-start: calc(0.9rem - 3px);
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--ct-body-color);
  background-color: var(--ct-secondary-bg);
  background-image: var(--ct-form-select-bg-img), var(--ct-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.9rem center;
  background-size: 14px 10px;
  border: 1px solid var(--ct-border-color);
  border-radius: var(--ct-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: var(--ct-border-color);
  outline: 0;
  box-shadow: none;
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.9rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--ct-form-control-disabled-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--ct-body-color);
}

.form-select-sm {
  padding-top: 0.28rem;
  padding-bottom: 0.28rem;
  padding-left: 0.8rem;
  font-size: 0.765625rem;
  border-radius: var(--ct-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.09375rem;
  border-radius: var(--ct-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --ct-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.3125rem;
  padding-left: 1.643em;
  margin-bottom: 0;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.643em;
}

.form-check-reverse {
  padding-right: 1.643em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.643em;
  margin-left: 0;
}

.form-check-input {
  --ct-form-check-bg: var(--ct-secondary-bg);
  width: 1.143em;
  height: 1.143em;
  margin-top: 0.1785em;
  vertical-align: top;
  background-color: var(--ct-form-check-bg);
  background-image: var(--ct-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid var(--ct-border-color);
  appearance: none;
  print-color-adjust: exact;
  transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-check-input {
    transition: none;
  }
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: var(--ct-border-color);
  outline: 0;
  box-shadow: none;
}
.form-check-input:checked {
  background-color: #6658dd;
  border-color: #6658dd;
}
.form-check-input:checked[type=checkbox] {
  --ct-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input:checked[type=radio] {
  --ct-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #6658dd;
  border-color: #6658dd;
  --ct-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --ct-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--ct-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --ct-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --ct-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --ct-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.form-range {
  width: 100%;
  height: 1.3rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f5f6f8, none;
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f5f6f8, none;
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #6658dd;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(209.1, 204.9, 244.8);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--ct-gray-100);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #6658dd;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(209.1, 204.9, 244.8);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--ct-gray-100);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--ct-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--ct-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating::before:not(.form-control:disabled) {
  position: absolute;
  top: 1px;
  left: 1px;
  width: calc(100% - (calc(calc(0.375em + 0.225rem) + calc(0.75em + 0.45rem))));
  height: 1.875em;
  content: "";
  background-color: var(--ct-secondary-bg);
  border-radius: var(--ct-border-radius);
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + 2px);
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 1rem 0.9rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.9rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: 1px 0;
}
.form-floating > .form-control:disabled ~ label {
  color: #98a6ad;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.45rem 0.9rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--ct-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--ct-gray-100);
  border: 1px solid var(--ct-border-color);
  border-radius: var(--ct-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.09375rem;
  border-radius: var(--ct-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.28rem 0.8rem;
  font-size: 0.765625rem;
  border-radius: var(--ct-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3.6rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: var(--ct-success-text);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.8rem;
  margin-top: 0.1rem;
  font-size: 0.765625rem;
  color: #fff;
  background-color: var(--ct-success);
  border-radius: 0.2rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--ct-success);
  padding-right: calc(1.5em + 0.9rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.225rem) center;
  background-size: calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--ct-success);
  box-shadow: 0 0 0 0.15rem rgba(var(--ct-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.9rem);
  background-position: top calc(0.375em + 0.225rem) right calc(0.375em + 0.225rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--ct-success);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --ct-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 4.95rem;
  background-position: right 0.9rem center, center right 2.7rem;
  background-size: 14px 10px, calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--ct-success);
  box-shadow: 0 0 0 0.15rem rgba(var(--ct-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.9rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--ct-success);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--ct-success-text);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.15rem rgba(var(--ct-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--ct-success-text);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: var(--ct-danger-text);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.8rem;
  margin-top: 0.1rem;
  font-size: 0.765625rem;
  color: #fff;
  background-color: var(--ct-danger);
  border-radius: 0.2rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--ct-danger);
  padding-right: calc(1.5em + 0.9rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.225rem) center;
  background-size: calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--ct-danger);
  box-shadow: 0 0 0 0.15rem rgba(var(--ct-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.9rem);
  background-position: top calc(0.375em + 0.225rem) right calc(0.375em + 0.225rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--ct-danger);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --ct-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-right: 4.95rem;
  background-position: right 0.9rem center, center right 2.7rem;
  background-size: 14px 10px, calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--ct-danger);
  box-shadow: 0 0 0 0.15rem rgba(var(--ct-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.9rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--ct-danger);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--ct-danger-text);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.15rem rgba(var(--ct-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--ct-danger-text);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --ct-btn-padding-x: 0.9rem;
  --ct-btn-padding-y: 0.45rem;
  --ct-btn-font-family: ;
  --ct-btn-font-size: 0.875rem;
  --ct-btn-font-weight: 400;
  --ct-btn-line-height: 1.5;
  --ct-btn-color: #6c757d;
  --ct-btn-bg: transparent;
  --ct-btn-border-width: var(--ct-border-width);
  --ct-btn-border-color: transparent;
  --ct-btn-border-radius: var(--ct-border-radius);
  --ct-btn-hover-border-color: transparent;
  --ct-btn-box-shadow: 0px 2px 6px 0px;
  --ct-btn-disabled-opacity: 0.65;
  --ct-btn-focus-box-shadow: 0 0 0 0.15rem rgba(var(--ct-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--ct-btn-padding-y) var(--ct-btn-padding-x);
  font-family: var(--ct-btn-font-family);
  font-size: var(--ct-btn-font-size);
  font-weight: var(--ct-btn-font-weight);
  line-height: var(--ct-btn-line-height);
  color: var(--ct-btn-color);
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--ct-btn-border-width) solid var(--ct-btn-border-color);
  border-radius: var(--ct-btn-border-radius);
  background-color: var(--ct-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--ct-btn-hover-color);
  background-color: var(--ct-btn-hover-bg);
  border-color: var(--ct-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--ct-btn-color);
  background-color: var(--ct-btn-bg);
  border-color: var(--ct-btn-border-color);
}
.btn:focus-visible {
  color: var(--ct-btn-hover-color);
  background-color: var(--ct-btn-hover-bg);
  border-color: var(--ct-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--ct-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--ct-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--ct-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--ct-btn-active-color);
  background-color: var(--ct-btn-active-bg);
  border-color: var(--ct-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--ct-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--ct-btn-disabled-color);
  pointer-events: none;
  background-color: var(--ct-btn-disabled-bg);
  border-color: var(--ct-btn-disabled-border-color);
  opacity: var(--ct-btn-disabled-opacity);
}

.btn-primary {
  --ct-btn-color: #fff;
  --ct-btn-bg: #6658dd;
  --ct-btn-border-color: #6658dd;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: rgb(86.7, 74.8, 187.85);
  --ct-btn-hover-border-color: rgb(81.6, 70.4, 176.8);
  --ct-btn-focus-shadow-rgb: 125, 113, 226;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: rgb(81.6, 70.4, 176.8);
  --ct-btn-active-border-color: rgb(76.5, 66, 165.75);
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #fff;
  --ct-btn-disabled-bg: #6658dd;
  --ct-btn-disabled-border-color: #6658dd;
}

.btn-secondary {
  --ct-btn-color: #fff;
  --ct-btn-bg: #6c757d;
  --ct-btn-border-color: #6c757d;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: rgb(91.8, 99.45, 106.25);
  --ct-btn-hover-border-color: rgb(86.4, 93.6, 100);
  --ct-btn-focus-shadow-rgb: 130, 138, 145;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: rgb(86.4, 93.6, 100);
  --ct-btn-active-border-color: rgb(81, 87.75, 93.75);
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #fff;
  --ct-btn-disabled-bg: #6c757d;
  --ct-btn-disabled-border-color: #6c757d;
}

.btn-success {
  --ct-btn-color: #fff;
  --ct-btn-bg: #1abc9c;
  --ct-btn-border-color: #1abc9c;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: rgb(22.1, 159.8, 132.6);
  --ct-btn-hover-border-color: rgb(20.8, 150.4, 124.8);
  --ct-btn-focus-shadow-rgb: 60, 198, 171;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: rgb(20.8, 150.4, 124.8);
  --ct-btn-active-border-color: rgb(19.5, 141, 117);
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #fff;
  --ct-btn-disabled-bg: #1abc9c;
  --ct-btn-disabled-border-color: #1abc9c;
}

.btn-info {
  --ct-btn-color: #fff;
  --ct-btn-bg: #43bfe5;
  --ct-btn-border-color: #43bfe5;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: rgb(56.95, 162.35, 194.65);
  --ct-btn-hover-border-color: rgb(53.6, 152.8, 183.2);
  --ct-btn-focus-shadow-rgb: 95, 201, 233;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: rgb(53.6, 152.8, 183.2);
  --ct-btn-active-border-color: rgb(50.25, 143.25, 171.75);
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #fff;
  --ct-btn-disabled-bg: #43bfe5;
  --ct-btn-disabled-border-color: #43bfe5;
}

.btn-warning {
  --ct-btn-color: #323a46;
  --ct-btn-bg: #f7b84b;
  --ct-btn-border-color: #f7b84b;
  --ct-btn-hover-color: #323a46;
  --ct-btn-hover-bg: rgb(248.2, 194.65, 102);
  --ct-btn-hover-border-color: rgb(247.8, 191.1, 93);
  --ct-btn-focus-shadow-rgb: 217, 165, 74;
  --ct-btn-active-color: #323a46;
  --ct-btn-active-bg: rgb(248.6, 198.2, 111);
  --ct-btn-active-border-color: rgb(247.8, 191.1, 93);
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #323a46;
  --ct-btn-disabled-bg: #f7b84b;
  --ct-btn-disabled-border-color: #f7b84b;
}

.btn-danger {
  --ct-btn-color: #fff;
  --ct-btn-bg: #f1556c;
  --ct-btn-border-color: #f1556c;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: rgb(204.85, 72.25, 91.8);
  --ct-btn-hover-border-color: rgb(192.8, 68, 86.4);
  --ct-btn-focus-shadow-rgb: 243, 111, 130;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: rgb(192.8, 68, 86.4);
  --ct-btn-active-border-color: rgb(180.75, 63.75, 81);
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #fff;
  --ct-btn-disabled-bg: #f1556c;
  --ct-btn-disabled-border-color: #f1556c;
}

.btn-light {
  --ct-btn-color: #323a46;
  --ct-btn-bg: #f3f7f9;
  --ct-btn-border-color: #f3f7f9;
  --ct-btn-hover-color: #323a46;
  --ct-btn-hover-bg: rgb(206.55, 209.95, 211.65);
  --ct-btn-hover-border-color: rgb(194.4, 197.6, 199.2);
  --ct-btn-focus-shadow-rgb: 214, 219, 222;
  --ct-btn-active-color: #323a46;
  --ct-btn-active-bg: rgb(194.4, 197.6, 199.2);
  --ct-btn-active-border-color: rgb(182.25, 185.25, 186.75);
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #323a46;
  --ct-btn-disabled-bg: #f3f7f9;
  --ct-btn-disabled-border-color: #f3f7f9;
}

.btn-dark {
  --ct-btn-color: #fff;
  --ct-btn-bg: #323a46;
  --ct-btn-border-color: #323a46;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: rgb(80.75, 87.55, 97.75);
  --ct-btn-hover-border-color: rgb(70.5, 77.7, 88.5);
  --ct-btn-focus-shadow-rgb: 81, 88, 98;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: rgb(91, 97.4, 107);
  --ct-btn-active-border-color: rgb(70.5, 77.7, 88.5);
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #fff;
  --ct-btn-disabled-bg: #323a46;
  --ct-btn-disabled-border-color: #323a46;
}

.btn-pink {
  --ct-btn-color: #fff;
  --ct-btn-bg: #f672a7;
  --ct-btn-border-color: #f672a7;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: rgb(209.1, 96.9, 141.95);
  --ct-btn-hover-border-color: rgb(196.8, 91.2, 133.6);
  --ct-btn-focus-shadow-rgb: 247, 135, 180;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: rgb(196.8, 91.2, 133.6);
  --ct-btn-active-border-color: rgb(184.5, 85.5, 125.25);
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #fff;
  --ct-btn-disabled-bg: #f672a7;
  --ct-btn-disabled-border-color: #f672a7;
}

.btn-blue {
  --ct-btn-color: #fff;
  --ct-btn-bg: #4a81d4;
  --ct-btn-border-color: #4a81d4;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: rgb(62.9, 109.65, 180.2);
  --ct-btn-hover-border-color: rgb(59.2, 103.2, 169.6);
  --ct-btn-focus-shadow-rgb: 101, 148, 218;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: rgb(59.2, 103.2, 169.6);
  --ct-btn-active-border-color: rgb(55.5, 96.75, 159);
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #fff;
  --ct-btn-disabled-bg: #4a81d4;
  --ct-btn-disabled-border-color: #4a81d4;
}

.btn-outline-primary {
  --ct-btn-color: #6658dd;
  --ct-btn-border-color: #6658dd;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: #6658dd;
  --ct-btn-hover-border-color: #6658dd;
  --ct-btn-focus-shadow-rgb: 102, 88, 221;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: #6658dd;
  --ct-btn-active-border-color: #6658dd;
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #6658dd;
  --ct-btn-disabled-bg: transparent;
  --ct-btn-disabled-border-color: #6658dd;
  --ct-gradient: none;
}

.btn-outline-secondary {
  --ct-btn-color: #6c757d;
  --ct-btn-border-color: #6c757d;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: #6c757d;
  --ct-btn-hover-border-color: #6c757d;
  --ct-btn-focus-shadow-rgb: 108, 117, 125;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: #6c757d;
  --ct-btn-active-border-color: #6c757d;
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #6c757d;
  --ct-btn-disabled-bg: transparent;
  --ct-btn-disabled-border-color: #6c757d;
  --ct-gradient: none;
}

.btn-outline-success {
  --ct-btn-color: #1abc9c;
  --ct-btn-border-color: #1abc9c;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: #1abc9c;
  --ct-btn-hover-border-color: #1abc9c;
  --ct-btn-focus-shadow-rgb: 26, 188, 156;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: #1abc9c;
  --ct-btn-active-border-color: #1abc9c;
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #1abc9c;
  --ct-btn-disabled-bg: transparent;
  --ct-btn-disabled-border-color: #1abc9c;
  --ct-gradient: none;
}

.btn-outline-info {
  --ct-btn-color: #43bfe5;
  --ct-btn-border-color: #43bfe5;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: #43bfe5;
  --ct-btn-hover-border-color: #43bfe5;
  --ct-btn-focus-shadow-rgb: 67, 191, 229;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: #43bfe5;
  --ct-btn-active-border-color: #43bfe5;
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #43bfe5;
  --ct-btn-disabled-bg: transparent;
  --ct-btn-disabled-border-color: #43bfe5;
  --ct-gradient: none;
}

.btn-outline-warning {
  --ct-btn-color: #f7b84b;
  --ct-btn-border-color: #f7b84b;
  --ct-btn-hover-color: #323a46;
  --ct-btn-hover-bg: #f7b84b;
  --ct-btn-hover-border-color: #f7b84b;
  --ct-btn-focus-shadow-rgb: 247, 184, 75;
  --ct-btn-active-color: #323a46;
  --ct-btn-active-bg: #f7b84b;
  --ct-btn-active-border-color: #f7b84b;
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #f7b84b;
  --ct-btn-disabled-bg: transparent;
  --ct-btn-disabled-border-color: #f7b84b;
  --ct-gradient: none;
}

.btn-outline-danger {
  --ct-btn-color: #f1556c;
  --ct-btn-border-color: #f1556c;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: #f1556c;
  --ct-btn-hover-border-color: #f1556c;
  --ct-btn-focus-shadow-rgb: 241, 85, 108;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: #f1556c;
  --ct-btn-active-border-color: #f1556c;
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #f1556c;
  --ct-btn-disabled-bg: transparent;
  --ct-btn-disabled-border-color: #f1556c;
  --ct-gradient: none;
}

.btn-outline-light {
  --ct-btn-color: #f3f7f9;
  --ct-btn-border-color: #f3f7f9;
  --ct-btn-hover-color: #323a46;
  --ct-btn-hover-bg: #f3f7f9;
  --ct-btn-hover-border-color: #f3f7f9;
  --ct-btn-focus-shadow-rgb: 243, 247, 249;
  --ct-btn-active-color: #323a46;
  --ct-btn-active-bg: #f3f7f9;
  --ct-btn-active-border-color: #f3f7f9;
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #f3f7f9;
  --ct-btn-disabled-bg: transparent;
  --ct-btn-disabled-border-color: #f3f7f9;
  --ct-gradient: none;
}

.btn-outline-dark {
  --ct-btn-color: #323a46;
  --ct-btn-border-color: #323a46;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: #323a46;
  --ct-btn-hover-border-color: #323a46;
  --ct-btn-focus-shadow-rgb: 50, 58, 70;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: #323a46;
  --ct-btn-active-border-color: #323a46;
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #323a46;
  --ct-btn-disabled-bg: transparent;
  --ct-btn-disabled-border-color: #323a46;
  --ct-gradient: none;
}

.btn-outline-pink {
  --ct-btn-color: #f672a7;
  --ct-btn-border-color: #f672a7;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: #f672a7;
  --ct-btn-hover-border-color: #f672a7;
  --ct-btn-focus-shadow-rgb: 246, 114, 167;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: #f672a7;
  --ct-btn-active-border-color: #f672a7;
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #f672a7;
  --ct-btn-disabled-bg: transparent;
  --ct-btn-disabled-border-color: #f672a7;
  --ct-gradient: none;
}

.btn-outline-blue {
  --ct-btn-color: #4a81d4;
  --ct-btn-border-color: #4a81d4;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: #4a81d4;
  --ct-btn-hover-border-color: #4a81d4;
  --ct-btn-focus-shadow-rgb: 74, 129, 212;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: #4a81d4;
  --ct-btn-active-border-color: #4a81d4;
  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-disabled-color: #4a81d4;
  --ct-btn-disabled-bg: transparent;
  --ct-btn-disabled-border-color: #4a81d4;
  --ct-gradient: none;
}

.btn-link {
  --ct-btn-font-weight: 400;
  --ct-btn-color: var(--ct-link-color);
  --ct-btn-bg: transparent;
  --ct-btn-border-color: transparent;
  --ct-btn-hover-color: var(--ct-link-hover-color);
  --ct-btn-hover-border-color: transparent;
  --ct-btn-active-color: var(--ct-link-hover-color);
  --ct-btn-active-border-color: transparent;
  --ct-btn-disabled-color: #98a6ad;
  --ct-btn-disabled-border-color: transparent;
  --ct-btn-box-shadow: none;
  --ct-btn-focus-shadow-rgb: 125, 113, 226;
  text-decoration: none;
}
.btn-link:focus-visible {
  color: var(--ct-btn-color);
}
.btn-link:hover {
  color: var(--ct-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --ct-btn-padding-y: 0.5rem;
  --ct-btn-padding-x: 1rem;
  --ct-btn-font-size: 1.09375rem;
  --ct-btn-border-radius: var(--ct-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --ct-btn-padding-y: 0.28rem;
  --ct-btn-padding-x: 0.8rem;
  --ct-btn-font-size: 0.765625rem;
  --ct-btn-border-radius: var(--ct-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-menu {
  --ct-dropdown-zindex: 1000;
  --ct-dropdown-min-width: 10rem;
  --ct-dropdown-padding-x: 0.25rem;
  --ct-dropdown-padding-y: 0.25rem;
  --ct-dropdown-spacer: 0.125rem;
  --ct-dropdown-font-size: 0.875rem;
  --ct-dropdown-color: var(--ct-body-color);
  --ct-dropdown-bg: var(--ct-secondary-bg);
  --ct-dropdown-border-color: var(--ct-border-color);
  --ct-dropdown-border-radius: var(--ct-border-radius);
  --ct-dropdown-border-width: 1px;
  --ct-dropdown-inner-border-radius: calc(var(--ct-border-radius) - 1px);
  --ct-dropdown-divider-bg: var(--ct-border-color);
  --ct-dropdown-divider-margin-y: 0.375rem;
  --ct-dropdown-box-shadow: var(--ct-box-shadow);
  --ct-dropdown-link-color: var(--ct-body-color);
  --ct-dropdown-link-hover-color: var(--ct-dark);
  --ct-dropdown-link-hover-bg: var(--ct-light);
  --ct-dropdown-link-active-color: var(--ct-dark);
  --ct-dropdown-link-active-bg: var(--ct-light);
  --ct-dropdown-link-disabled-color: var(--ct-gray-500);
  --ct-dropdown-item-padding-x: 1.5rem;
  --ct-dropdown-item-padding-y: 0.375rem;
  --ct-dropdown-header-color: inherit;
  --ct-dropdown-header-padding-x: 1.5rem;
  --ct-dropdown-header-padding-y: 0.25rem;
  position: absolute;
  z-index: var(--ct-dropdown-zindex);
  display: none;
  min-width: var(--ct-dropdown-min-width);
  padding: var(--ct-dropdown-padding-y) var(--ct-dropdown-padding-x);
  margin: 0;
  font-size: var(--ct-dropdown-font-size);
  color: var(--ct-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--ct-dropdown-bg);
  background-clip: padding-box;
  border: var(--ct-dropdown-border-width) solid var(--ct-dropdown-border-color);
  border-radius: var(--ct-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--ct-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--ct-dropdown-spacer);
}
.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--ct-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--ct-dropdown-spacer);
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--ct-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--ct-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--ct-dropdown-item-padding-y) var(--ct-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--ct-dropdown-link-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--ct-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--ct-dropdown-link-hover-color);
  background-color: var(--ct-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--ct-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--ct-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--ct-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--ct-dropdown-header-padding-y) var(--ct-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.765625rem;
  color: var(--ct-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--ct-dropdown-item-padding-y) var(--ct-dropdown-item-padding-x);
  color: var(--ct-dropdown-link-color);
}

.dropdown-menu-dark {
  --ct-dropdown-color: #dee2e6;
  --ct-dropdown-bg: #343a40;
  --ct-dropdown-border-color: var(--ct-border-color);
  --ct-dropdown-box-shadow: ;
  --ct-dropdown-link-color: #dee2e6;
  --ct-dropdown-link-hover-color: #fff;
  --ct-dropdown-divider-bg: var(--ct-border-color);
  --ct-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --ct-dropdown-link-active-color: var(--ct-dark);
  --ct-dropdown-link-active-bg: var(--ct-light);
  --ct-dropdown-link-disabled-color: #adb5bd;
  --ct-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--ct-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--ct-border-width) * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.675rem;
  padding-left: 0.675rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.6rem;
  padding-left: 0.6rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--ct-border-width) * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --ct-nav-link-padding-x: 1rem;
  --ct-nav-link-padding-y: 0.5rem;
  --ct-nav-link-font-weight: ;
  --ct-nav-link-color: var(--ct-link-color);
  --ct-nav-link-hover-color: var(--ct-link-hover-color);
  --ct-nav-link-disabled-color: var(--ct-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--ct-nav-link-padding-y) var(--ct-nav-link-padding-x);
  font-size: var(--ct-nav-link-font-size);
  font-weight: var(--ct-nav-link-font-weight);
  color: var(--ct-nav-link-color);
  transition: color 0.3s ease-in-out, background-color 0.3s ease-in-out, border-color 0.3s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--ct-nav-link-hover-color);
}
.nav-link.disabled {
  color: var(--ct-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --ct-nav-tabs-border-width: var(--ct-border-width);
  --ct-nav-tabs-border-color: var(--ct-border-color);
  --ct-nav-tabs-border-radius: var(--ct-border-radius);
  --ct-nav-tabs-link-hover-border-color: var(--ct-secondary-bg) var(--ct-secondary-bg) var(--ct-border-color);
  --ct-nav-tabs-link-active-color: var(--ct-emphasis-color);
  --ct-nav-tabs-link-active-bg: var(--bs-body-bg);
  --ct-nav-tabs-link-active-border-color: var(--ct-border-color) var(--ct-border-color) var(--ct-border-color);
  border-bottom: var(--ct-nav-tabs-border-width) solid var(--ct-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--ct-nav-tabs-border-width));
  background: none;
  border: var(--ct-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--ct-nav-tabs-border-radius);
  border-top-right-radius: var(--ct-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--ct-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {
  color: var(--ct-nav-link-disabled-color);
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--ct-nav-tabs-link-active-color);
  background-color: var(--ct-nav-tabs-link-active-bg);
  border-color: var(--ct-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--ct-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --ct-nav-pills-border-radius: var(--ct-border-radius);
  --ct-nav-pills-link-active-color: #fff;
  --ct-nav-pills-link-active-bg: #6658dd;
}
.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: var(--ct-nav-pills-border-radius);
}
.nav-pills .nav-link:disabled {
  color: var(--ct-nav-link-disabled-color);
  background-color: transparent;
  border-color: transparent;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--ct-nav-pills-link-active-color);
  background-color: var(--ct-nav-pills-link-active-bg);
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --ct-navbar-padding-x: 0;
  --ct-navbar-padding-y: 0.75rem;
  --ct-navbar-color: rgba(var(--ct-emphasis-color-rgb), 0.65);
  --ct-navbar-hover-color: rgba(var(--ct-emphasis-color-rgb), 0.8);
  --ct-navbar-disabled-color: rgba(var(--ct-emphasis-color-rgb), 0.3);
  --ct-navbar-active-color: rgba(var(--ct-emphasis-color-rgb), 1);
  --ct-navbar-brand-padding-y: 0.3359375rem;
  --ct-navbar-brand-margin-end: 1rem;
  --ct-navbar-brand-font-size: 1.09375rem;
  --ct-navbar-brand-color: rgba(var(--ct-emphasis-color-rgb), 1);
  --ct-navbar-brand-hover-color: rgba(var(--ct-emphasis-color-rgb), 1);
  --ct-navbar-nav-link-padding-x: 0.5rem;
  --ct-navbar-toggler-padding-y: 0.25rem;
  --ct-navbar-toggler-padding-x: 0.75rem;
  --ct-navbar-toggler-font-size: 1.09375rem;
  --ct-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --ct-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);
  --ct-navbar-toggler-border-radius: var(--ct-border-radius);
  --ct-navbar-toggler-focus-width: 0.15rem;
  --ct-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--ct-navbar-padding-y) var(--ct-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--ct-navbar-brand-padding-y);
  padding-bottom: var(--ct-navbar-brand-padding-y);
  margin-right: var(--ct-navbar-brand-margin-end);
  font-size: var(--ct-navbar-brand-font-size);
  color: var(--ct-navbar-brand-color);
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--ct-navbar-brand-hover-color);
}

.navbar-nav {
  --ct-nav-link-padding-x: 0;
  --ct-nav-link-padding-y: 0.5rem;
  --ct-nav-link-font-weight: ;
  --ct-nav-link-color: var(--ct-navbar-color);
  --ct-nav-link-hover-color: var(--ct-navbar-hover-color);
  --ct-nav-link-disabled-color: var(--ct-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .show > .nav-link,
.navbar-nav .nav-link.active {
  color: var(--ct-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--ct-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--ct-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--ct-navbar-toggler-padding-y) var(--ct-navbar-toggler-padding-x);
  font-size: var(--ct-navbar-toggler-font-size);
  line-height: 1;
  color: var(--ct-navbar-color);
  background-color: transparent;
  border: var(--ct-border-width) solid var(--ct-navbar-toggler-border-color);
  border-radius: var(--ct-navbar-toggler-border-radius);
  transition: var(--ct-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--ct-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--ct-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--ct-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--ct-navbar-nav-link-padding-x);
    padding-left: var(--ct-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--ct-navbar-nav-link-padding-x);
    padding-left: var(--ct-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--ct-navbar-nav-link-padding-x);
    padding-left: var(--ct-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--ct-navbar-nav-link-padding-x);
    padding-left: var(--ct-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--ct-navbar-nav-link-padding-x);
    padding-left: var(--ct-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--ct-navbar-nav-link-padding-x);
  padding-left: var(--ct-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark {
  --ct-navbar-color: rgba(255, 255, 255, 0.55);
  --ct-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --ct-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --ct-navbar-active-color: #fff;
  --ct-navbar-brand-color: #fff;
  --ct-navbar-brand-hover-color: #fff;
  --ct-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --ct-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

[data-bs-theme=dark] .navbar {
  --ct-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.card {
  --ct-card-spacer-y: 1.5rem;
  --ct-card-spacer-x: 1.5rem;
  --ct-card-title-spacer-y: 0.75rem;
  --ct-card-title-color: ;
  --ct-card-subtitle-color: ;
  --ct-card-border-width: var(--ct-theme-border-width);
  --ct-card-border-color: var(--ct-border-color);
  --ct-card-border-radius: var(--ct-border-radius);
  --ct-card-box-shadow: var(--ct-box-shadow-sm);
  --ct-card-inner-border-radius: calc(var(--ct-border-radius) - (var(--ct-theme-border-width)));
  --ct-card-cap-padding-y: 1.125rem;
  --ct-card-cap-padding-x: 1.5rem;
  --ct-card-cap-bg: var(--ct-secondary-bg);
  --ct-card-cap-color: ;
  --ct-card-height: ;
  --ct-card-color: ;
  --ct-card-bg: var(--ct-secondary-bg);
  --ct-card-img-overlay-padding: 1.5rem;
  --ct-card-group-margin: 12px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--ct-card-height);
  word-wrap: break-word;
  background-color: var(--ct-card-bg);
  background-clip: border-box;
  border: var(--ct-card-border-width) solid var(--ct-card-border-color);
  border-radius: var(--ct-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--ct-card-inner-border-radius);
  border-top-right-radius: var(--ct-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--ct-card-inner-border-radius);
  border-bottom-left-radius: var(--ct-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--ct-card-spacer-y) var(--ct-card-spacer-x);
  color: var(--ct-card-color);
}

.card-title {
  margin-bottom: var(--ct-card-title-spacer-y);
  color: var(--ct-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--ct-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--ct-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--ct-card-spacer-x);
}

.card-header {
  padding: var(--ct-card-cap-padding-y) var(--ct-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--ct-card-cap-color);
  background-color: var(--ct-card-cap-bg);
  border-bottom: var(--ct-card-border-width) solid var(--ct-card-border-color);
}
.card-header:first-child {
  border-radius: var(--ct-card-inner-border-radius) var(--ct-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--ct-card-cap-padding-y) var(--ct-card-cap-padding-x);
  color: var(--ct-card-cap-color);
  background-color: var(--ct-card-cap-bg);
  border-top: var(--ct-card-border-width) solid var(--ct-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--ct-card-inner-border-radius) var(--ct-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--ct-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--ct-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--ct-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--ct-card-bg);
  border-bottom-color: var(--ct-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--ct-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--ct-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--ct-card-img-overlay-padding);
  border-radius: var(--ct-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--ct-card-inner-border-radius);
  border-top-right-radius: var(--ct-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--ct-card-inner-border-radius);
  border-bottom-left-radius: var(--ct-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--ct-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --ct-accordion-color: var(--ct-body-color);
  --ct-accordion-bg: var(--ct-secondary-bg);
  --ct-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --ct-accordion-border-color: var(--ct-border-color);
  --ct-accordion-border-width: var(--ct-border-width);
  --ct-accordion-border-radius: var(--ct-border-radius);
  --ct-accordion-inner-border-radius: calc(var(--ct-border-radius) - (var(--ct-border-width)));
  --ct-accordion-btn-padding-x: 1.25rem;
  --ct-accordion-btn-padding-y: 1rem;
  --ct-accordion-btn-color: var(--ct-body-color);
  --ct-accordion-btn-bg: var(--ct-accordion-bg);
  --ct-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --ct-accordion-btn-icon-width: 0.75rem;
  --ct-accordion-btn-icon-transform: rotate(-180deg);
  --ct-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --ct-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --ct-accordion-btn-focus-border-color: var(--ct-border-color);
  --ct-accordion-btn-focus-box-shadow: 0 0 0 0.15rem rgba(102, 88, 221, 0.25);
  --ct-accordion-body-padding-x: 1.25rem;
  --ct-accordion-body-padding-y: 1rem;
  --ct-accordion-active-color: var(--ct-primary-text);
  --ct-accordion-active-bg: var(--ct-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--ct-accordion-btn-padding-y) var(--ct-accordion-btn-padding-x);
  font-size: 0.875rem;
  color: var(--ct-accordion-btn-color);
  text-align: left;
  background-color: var(--ct-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--ct-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--ct-accordion-active-color);
  background-color: var(--ct-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--ct-accordion-border-width)) 0 var(--ct-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--ct-accordion-btn-active-icon);
  transform: var(--ct-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--ct-accordion-btn-icon-width);
  height: var(--ct-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--ct-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--ct-accordion-btn-icon-width);
  transition: var(--ct-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: var(--ct-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--ct-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--ct-accordion-color);
  background-color: var(--ct-accordion-bg);
  border: var(--ct-accordion-border-width) solid var(--ct-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--ct-accordion-border-radius);
  border-top-right-radius: var(--ct-accordion-border-radius);
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--ct-accordion-inner-border-radius);
  border-top-right-radius: var(--ct-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--ct-accordion-border-radius);
  border-bottom-left-radius: var(--ct-accordion-border-radius);
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--ct-accordion-inner-border-radius);
  border-bottom-left-radius: var(--ct-accordion-inner-border-radius);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--ct-accordion-border-radius);
  border-bottom-left-radius: var(--ct-accordion-border-radius);
}

.accordion-body {
  padding: var(--ct-accordion-body-padding-y) var(--ct-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --ct-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --ct-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.breadcrumb {
  --ct-breadcrumb-padding-x: 0;
  --ct-breadcrumb-padding-y: 0;
  --ct-breadcrumb-margin-bottom: 1rem;
  --ct-breadcrumb-bg: ;
  --ct-breadcrumb-border-radius: ;
  --ct-breadcrumb-divider-color: var(--ct-secondary-color);
  --ct-breadcrumb-item-padding-x: 0.5rem;
  --ct-breadcrumb-item-active-color: var(--ct-gray-500);
  display: flex;
  flex-wrap: wrap;
  padding: var(--ct-breadcrumb-padding-y) var(--ct-breadcrumb-padding-x);
  margin-bottom: var(--ct-breadcrumb-margin-bottom);
  font-size: var(--ct-breadcrumb-font-size);
  list-style: none;
  background-color: var(--ct-breadcrumb-bg);
  border-radius: var(--ct-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--ct-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--ct-breadcrumb-item-padding-x);
  color: var(--ct-breadcrumb-divider-color);
  content: var(--ct-breadcrumb-divider, "\\f0142") /* rtl: var(--ct-breadcrumb-divider, "\\f0142") */;
}
.breadcrumb-item.active {
  color: var(--ct-breadcrumb-item-active-color);
}

.pagination {
  --ct-pagination-padding-x: 0.75rem;
  --ct-pagination-padding-y: 0.375rem;
  --ct-pagination-font-size: 0.875rem;
  --ct-pagination-color: var(--ct-dark);
  --ct-pagination-bg: var(--bs-body-bg);
  --ct-pagination-border-width: var(--ct-border-width);
  --ct-pagination-border-color: var(--ct-border-color);
  --ct-pagination-border-radius: var(--ct-border-radius);
  --ct-pagination-hover-color: var(--ct-dark);
  --ct-pagination-hover-bg: var(--ct-gray-100);
  --ct-pagination-hover-border-color: var(--ct-border-color);
  --ct-pagination-focus-color: rgb(86.7, 74.8, 187.85);
  --ct-pagination-focus-bg: var(--ct-secondary-bg);
  --ct-pagination-focus-box-shadow: 0 0 0 0.15rem rgba(102, 88, 221, 0.25);
  --ct-pagination-active-color: #fff;
  --ct-pagination-active-bg: #6658dd;
  --ct-pagination-active-border-color: #6658dd;
  --ct-pagination-disabled-color: var(--ct-secondary-color);
  --ct-pagination-disabled-bg: var(--ct-secondary-bg);
  --ct-pagination-disabled-border-color: var(--ct-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--ct-pagination-padding-y) var(--ct-pagination-padding-x);
  font-size: var(--ct-pagination-font-size);
  color: var(--ct-pagination-color);
  background-color: var(--ct-pagination-bg);
  border: var(--ct-pagination-border-width) solid var(--ct-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--ct-pagination-hover-color);
  background-color: var(--ct-pagination-hover-bg);
  border-color: var(--ct-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--ct-pagination-focus-color);
  background-color: var(--ct-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--ct-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--ct-pagination-active-color);
  background-color: var(--ct-pagination-active-bg);
  border-color: var(--ct-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--ct-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--ct-pagination-disabled-bg);
  border-color: var(--ct-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(var(--ct-border-width) * -1);
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--ct-pagination-border-radius);
  border-bottom-left-radius: var(--ct-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--ct-pagination-border-radius);
  border-bottom-right-radius: var(--ct-pagination-border-radius);
}

.pagination-lg {
  --ct-pagination-padding-x: 1.5rem;
  --ct-pagination-padding-y: 0.75rem;
  --ct-pagination-font-size: 1.09375rem;
  --ct-pagination-border-radius: var(--ct-border-radius-lg);
}

.pagination-sm {
  --ct-pagination-padding-x: 0.5rem;
  --ct-pagination-padding-y: 0.25rem;
  --ct-pagination-font-size: 0.765625rem;
  --ct-pagination-border-radius: var(--ct-border-radius-sm);
}

.badge {
  --ct-badge-padding-x: 0.4em;
  --ct-badge-padding-y: 0.25em;
  --ct-badge-font-size: 0.75em;
  --ct-badge-font-weight: 700;
  --ct-badge-color: #fff;
  --ct-badge-border-radius: var(--ct-border-radius);
  display: inline-block;
  padding: var(--ct-badge-padding-y) var(--ct-badge-padding-x);
  font-size: var(--ct-badge-font-size);
  font-weight: var(--ct-badge-font-weight);
  line-height: 1;
  color: var(--ct-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--ct-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --ct-alert-bg: transparent;
  --ct-alert-padding-x: 1.25rem;
  --ct-alert-padding-y: 0.8rem;
  --ct-alert-margin-bottom: 1rem;
  --ct-alert-color: inherit;
  --ct-alert-border-color: transparent;
  --ct-alert-border: var(--ct-border-width) solid var(--ct-alert-border-color);
  --ct-alert-border-radius: var(--ct-border-radius);
  --ct-alert-link-color: inherit;
  position: relative;
  padding: var(--ct-alert-padding-y) var(--ct-alert-padding-x);
  margin-bottom: var(--ct-alert-margin-bottom);
  color: var(--ct-alert-color);
  background-color: var(--ct-alert-bg);
  border: var(--ct-alert-border);
  border-radius: var(--ct-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--ct-alert-link-color);
}

.alert-dismissible {
  padding-right: 3.75rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1rem 1.25rem;
}

.alert-primary {
  --ct-alert-color: var(--ct-primary-text);
  --ct-alert-bg: var(--ct-primary-bg-subtle);
  --ct-alert-border-color: var(--ct-primary-border-subtle);
  --ct-alert-link-color: var(--ct-primary-text);
}

.alert-secondary {
  --ct-alert-color: var(--ct-secondary-text);
  --ct-alert-bg: var(--ct-secondary-bg-subtle);
  --ct-alert-border-color: var(--ct-secondary-border-subtle);
  --ct-alert-link-color: var(--ct-secondary-text);
}

.alert-success {
  --ct-alert-color: var(--ct-success-text);
  --ct-alert-bg: var(--ct-success-bg-subtle);
  --ct-alert-border-color: var(--ct-success-border-subtle);
  --ct-alert-link-color: var(--ct-success-text);
}

.alert-info {
  --ct-alert-color: var(--ct-info-text);
  --ct-alert-bg: var(--ct-info-bg-subtle);
  --ct-alert-border-color: var(--ct-info-border-subtle);
  --ct-alert-link-color: var(--ct-info-text);
}

.alert-warning {
  --ct-alert-color: var(--ct-warning-text);
  --ct-alert-bg: var(--ct-warning-bg-subtle);
  --ct-alert-border-color: var(--ct-warning-border-subtle);
  --ct-alert-link-color: var(--ct-warning-text);
}

.alert-danger {
  --ct-alert-color: var(--ct-danger-text);
  --ct-alert-bg: var(--ct-danger-bg-subtle);
  --ct-alert-border-color: var(--ct-danger-border-subtle);
  --ct-alert-link-color: var(--ct-danger-text);
}

.alert-light {
  --ct-alert-color: var(--ct-light-text);
  --ct-alert-bg: var(--ct-light-bg-subtle);
  --ct-alert-border-color: var(--ct-light-border-subtle);
  --ct-alert-link-color: var(--ct-light-text);
}

.alert-dark {
  --ct-alert-color: var(--ct-dark-text);
  --ct-alert-bg: var(--ct-dark-bg-subtle);
  --ct-alert-border-color: var(--ct-dark-border-subtle);
  --ct-alert-link-color: var(--ct-dark-text);
}

.alert-pink {
  --ct-alert-color: var(--ct-pink-text);
  --ct-alert-bg: var(--ct-pink-bg-subtle);
  --ct-alert-border-color: var(--ct-pink-border-subtle);
  --ct-alert-link-color: var(--ct-pink-text);
}

.alert-blue {
  --ct-alert-color: var(--ct-blue-text);
  --ct-alert-bg: var(--ct-blue-bg-subtle);
  --ct-alert-border-color: var(--ct-blue-border-subtle);
  --ct-alert-link-color: var(--ct-blue-text);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --ct-progress-height: 1rem;
  --ct-progress-font-size: 0.65625rem;
  --ct-progress-bg: var(--ct-light);
  --ct-progress-border-radius: var(--ct-border-radius);
  --ct-progress-box-shadow: var(--ct-box-shadow-inset);
  --ct-progress-bar-color: #fff;
  --ct-progress-bar-bg: #6658dd;
  --ct-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--ct-progress-height);
  overflow: hidden;
  font-size: var(--ct-progress-font-size);
  background-color: var(--ct-progress-bg);
  border-radius: var(--ct-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--ct-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--ct-progress-bar-bg);
  transition: var(--ct-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--ct-progress-height) var(--ct-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --ct-list-group-color: var(--ct-body-color);
  --ct-list-group-bg: var(--ct-secondary-bg);
  --ct-list-group-border-color: var(--ct-border-color);
  --ct-list-group-border-width: var(--ct-border-width);
  --ct-list-group-border-radius: var(--ct-border-radius);
  --ct-list-group-item-padding-x: 1.2rem;
  --ct-list-group-item-padding-y: 0.75rem;
  --ct-list-group-action-color: var(--ct-secondary-color);
  --ct-list-group-action-hover-color: var(--ct-emphasis-color);
  --ct-list-group-action-hover-bg: var(--ct-gray-300);
  --ct-list-group-action-active-color: var(--ct-body-color);
  --ct-list-group-action-active-bg: var(--ct-secondary-bg);
  --ct-list-group-disabled-color: var(--ct-secondary-color);
  --ct-list-group-disabled-bg: var(--ct-secondary-bg);
  --ct-list-group-active-color: #fff;
  --ct-list-group-active-bg: #6658dd;
  --ct-list-group-active-border-color: #6658dd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--ct-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--ct-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--ct-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--ct-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--ct-list-group-action-active-color);
  background-color: var(--ct-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--ct-list-group-item-padding-y) var(--ct-list-group-item-padding-x);
  color: var(--ct-list-group-color);
  background-color: var(--ct-list-group-bg);
  border: var(--ct-list-group-border-width) solid var(--ct-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--ct-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--ct-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--ct-list-group-active-color);
  background-color: var(--ct-list-group-active-bg);
  border-color: var(--ct-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--ct-list-group-border-width));
  border-top-width: var(--ct-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--ct-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--ct-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--ct-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--ct-list-group-border-width));
  border-left-width: var(--ct-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--ct-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--ct-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--ct-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--ct-list-group-border-width));
    border-left-width: var(--ct-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--ct-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--ct-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--ct-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--ct-list-group-border-width));
    border-left-width: var(--ct-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--ct-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--ct-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--ct-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--ct-list-group-border-width));
    border-left-width: var(--ct-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--ct-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--ct-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--ct-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--ct-list-group-border-width));
    border-left-width: var(--ct-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--ct-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--ct-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--ct-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--ct-list-group-border-width));
    border-left-width: var(--ct-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--ct-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --ct-list-group-color: var(--ct-primary-text);
  --ct-list-group-bg: var(--ct-primary-bg-subtle);
  --ct-list-group-border-color: var(--ct-primary-border-subtle);
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  --ct-list-group-action-hover-color: var(--ct-emphasis-color);
  --ct-list-group-action-hover-bg: var(--ct-primary-border-subtle);
}
.list-group-item-primary.list-group-item-action:active {
  --ct-list-group-active-color: var(--ct-emphasis-color);
  --ct-list-group-active-bg: var(--ct-primary-text);
  --ct-list-group-active-border-color: var(--ct-primary-text);
}

.list-group-item-secondary {
  --ct-list-group-color: var(--ct-secondary-text);
  --ct-list-group-bg: var(--ct-secondary-bg-subtle);
  --ct-list-group-border-color: var(--ct-secondary-border-subtle);
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  --ct-list-group-action-hover-color: var(--ct-emphasis-color);
  --ct-list-group-action-hover-bg: var(--ct-secondary-border-subtle);
}
.list-group-item-secondary.list-group-item-action:active {
  --ct-list-group-active-color: var(--ct-emphasis-color);
  --ct-list-group-active-bg: var(--ct-secondary-text);
  --ct-list-group-active-border-color: var(--ct-secondary-text);
}

.list-group-item-success {
  --ct-list-group-color: var(--ct-success-text);
  --ct-list-group-bg: var(--ct-success-bg-subtle);
  --ct-list-group-border-color: var(--ct-success-border-subtle);
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  --ct-list-group-action-hover-color: var(--ct-emphasis-color);
  --ct-list-group-action-hover-bg: var(--ct-success-border-subtle);
}
.list-group-item-success.list-group-item-action:active {
  --ct-list-group-active-color: var(--ct-emphasis-color);
  --ct-list-group-active-bg: var(--ct-success-text);
  --ct-list-group-active-border-color: var(--ct-success-text);
}

.list-group-item-info {
  --ct-list-group-color: var(--ct-info-text);
  --ct-list-group-bg: var(--ct-info-bg-subtle);
  --ct-list-group-border-color: var(--ct-info-border-subtle);
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  --ct-list-group-action-hover-color: var(--ct-emphasis-color);
  --ct-list-group-action-hover-bg: var(--ct-info-border-subtle);
}
.list-group-item-info.list-group-item-action:active {
  --ct-list-group-active-color: var(--ct-emphasis-color);
  --ct-list-group-active-bg: var(--ct-info-text);
  --ct-list-group-active-border-color: var(--ct-info-text);
}

.list-group-item-warning {
  --ct-list-group-color: var(--ct-warning-text);
  --ct-list-group-bg: var(--ct-warning-bg-subtle);
  --ct-list-group-border-color: var(--ct-warning-border-subtle);
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  --ct-list-group-action-hover-color: var(--ct-emphasis-color);
  --ct-list-group-action-hover-bg: var(--ct-warning-border-subtle);
}
.list-group-item-warning.list-group-item-action:active {
  --ct-list-group-active-color: var(--ct-emphasis-color);
  --ct-list-group-active-bg: var(--ct-warning-text);
  --ct-list-group-active-border-color: var(--ct-warning-text);
}

.list-group-item-danger {
  --ct-list-group-color: var(--ct-danger-text);
  --ct-list-group-bg: var(--ct-danger-bg-subtle);
  --ct-list-group-border-color: var(--ct-danger-border-subtle);
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  --ct-list-group-action-hover-color: var(--ct-emphasis-color);
  --ct-list-group-action-hover-bg: var(--ct-danger-border-subtle);
}
.list-group-item-danger.list-group-item-action:active {
  --ct-list-group-active-color: var(--ct-emphasis-color);
  --ct-list-group-active-bg: var(--ct-danger-text);
  --ct-list-group-active-border-color: var(--ct-danger-text);
}

.list-group-item-light {
  --ct-list-group-color: var(--ct-light-text);
  --ct-list-group-bg: var(--ct-light-bg-subtle);
  --ct-list-group-border-color: var(--ct-light-border-subtle);
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  --ct-list-group-action-hover-color: var(--ct-emphasis-color);
  --ct-list-group-action-hover-bg: var(--ct-light-border-subtle);
}
.list-group-item-light.list-group-item-action:active {
  --ct-list-group-active-color: var(--ct-emphasis-color);
  --ct-list-group-active-bg: var(--ct-light-text);
  --ct-list-group-active-border-color: var(--ct-light-text);
}

.list-group-item-dark {
  --ct-list-group-color: var(--ct-dark-text);
  --ct-list-group-bg: var(--ct-dark-bg-subtle);
  --ct-list-group-border-color: var(--ct-dark-border-subtle);
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  --ct-list-group-action-hover-color: var(--ct-emphasis-color);
  --ct-list-group-action-hover-bg: var(--ct-dark-border-subtle);
}
.list-group-item-dark.list-group-item-action:active {
  --ct-list-group-active-color: var(--ct-emphasis-color);
  --ct-list-group-active-bg: var(--ct-dark-text);
  --ct-list-group-active-border-color: var(--ct-dark-text);
}

.list-group-item-pink {
  --ct-list-group-color: var(--ct-pink-text);
  --ct-list-group-bg: var(--ct-pink-bg-subtle);
  --ct-list-group-border-color: var(--ct-pink-border-subtle);
}
.list-group-item-pink.list-group-item-action:hover, .list-group-item-pink.list-group-item-action:focus {
  --ct-list-group-action-hover-color: var(--ct-emphasis-color);
  --ct-list-group-action-hover-bg: var(--ct-pink-border-subtle);
}
.list-group-item-pink.list-group-item-action:active {
  --ct-list-group-active-color: var(--ct-emphasis-color);
  --ct-list-group-active-bg: var(--ct-pink-text);
  --ct-list-group-active-border-color: var(--ct-pink-text);
}

.list-group-item-blue {
  --ct-list-group-color: var(--ct-blue-text);
  --ct-list-group-bg: var(--ct-blue-bg-subtle);
  --ct-list-group-border-color: var(--ct-blue-border-subtle);
}
.list-group-item-blue.list-group-item-action:hover, .list-group-item-blue.list-group-item-action:focus {
  --ct-list-group-action-hover-color: var(--ct-emphasis-color);
  --ct-list-group-action-hover-bg: var(--ct-blue-border-subtle);
}
.list-group-item-blue.list-group-item-action:active {
  --ct-list-group-active-color: var(--ct-emphasis-color);
  --ct-list-group-active-bg: var(--ct-blue-text);
  --ct-list-group-active-border-color: var(--ct-blue-text);
}

.btn-close {
  --ct-btn-close-color: #000;
  --ct-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --ct-btn-close-opacity: 1;
  --ct-btn-close-hover-opacity: 0.8;
  --ct-btn-close-focus-shadow: 0 0 0 0.15rem rgba(102, 88, 221, 0.25);
  --ct-btn-close-focus-opacity: 1;
  --ct-btn-close-disabled-opacity: 0.25;
  --ct-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--ct-btn-close-color);
  background: transparent var(--ct-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: var(--ct-btn-close-opacity);
}
.btn-close:hover {
  color: var(--ct-btn-close-color);
  text-decoration: none;
  opacity: var(--ct-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--ct-btn-close-focus-shadow);
  opacity: var(--ct-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--ct-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--ct-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--ct-btn-close-white-filter);
}

.toast {
  --ct-toast-zindex: 1090;
  --ct-toast-padding-x: 0.75rem;
  --ct-toast-padding-y: 0.5rem;
  --ct-toast-spacing: 24px;
  --ct-toast-max-width: 350px;
  --ct-toast-font-size: 0.875rem;
  --ct-toast-color: inherit;
  --ct-toast-bg: var(--ct-secondary-bg);
  --ct-toast-border-width: var(--ct-border-width);
  --ct-toast-border-color: var(--ct-border-color);
  --ct-toast-border-radius: var(--ct-border-radius);
  --ct-toast-box-shadow: var(--ct-box-shadow);
  --ct-toast-header-color: var(--ct-secondary-color);
  --ct-toast-header-bg: rgba(var(--ct-body-bg-rgb), 0.85);
  --ct-toast-header-border-color: var(--ct-border-color);
  width: var(--ct-toast-max-width);
  max-width: 100%;
  font-size: var(--ct-toast-font-size);
  color: var(--ct-toast-color);
  pointer-events: auto;
  background-color: var(--ct-toast-bg);
  background-clip: padding-box;
  border: var(--ct-toast-border-width) solid var(--ct-toast-border-color);
  box-shadow: var(--ct-toast-box-shadow);
  border-radius: var(--ct-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --ct-toast-zindex: 1090;
  position: absolute;
  z-index: var(--ct-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--ct-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--ct-toast-padding-y) var(--ct-toast-padding-x);
  color: var(--ct-toast-header-color);
  background-color: var(--ct-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--ct-toast-border-width) solid var(--ct-toast-header-border-color);
  border-top-left-radius: calc(var(--ct-toast-border-radius) - var(--ct-toast-border-width));
  border-top-right-radius: calc(var(--ct-toast-border-radius) - var(--ct-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--ct-toast-padding-x));
  margin-left: var(--ct-toast-padding-x);
}

.toast-body {
  padding: var(--ct-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --ct-modal-zindex: 1055;
  --ct-modal-width: 500px;
  --ct-modal-padding: 1rem;
  --ct-modal-margin: 0.5rem;
  --ct-modal-color: ;
  --ct-modal-bg: var(--ct-secondary-bg);
  --ct-modal-border-color: var(--ct-border-color-translucent);
  --ct-modal-border-width: var(--ct-border-width);
  --ct-modal-border-radius: var(--ct-border-radius-lg);
  --ct-modal-box-shadow: var(--ct-box-shadow-sm);
  --ct-modal-inner-border-radius: calc(var(--ct-border-radius-lg) - (var(--ct-border-width)));
  --ct-modal-header-padding-x: 1rem;
  --ct-modal-header-padding-y: 1rem;
  --ct-modal-header-padding: 1rem 1rem;
  --ct-modal-header-border-color: var(--ct-border-color);
  --ct-modal-header-border-width: var(--ct-border-width);
  --ct-modal-title-line-height: 1.5;
  --ct-modal-footer-gap: 0.5rem;
  --ct-modal-footer-bg: ;
  --ct-modal-footer-border-color: var(--ct-border-color);
  --ct-modal-footer-border-width: var(--ct-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--ct-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--ct-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--ct-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--ct-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--ct-modal-color);
  pointer-events: auto;
  background-color: var(--ct-modal-bg);
  background-clip: padding-box;
  border: var(--ct-modal-border-width) solid var(--ct-modal-border-color);
  border-radius: var(--ct-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --ct-backdrop-zindex: 1050;
  --ct-backdrop-bg: #000;
  --ct-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--ct-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--ct-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--ct-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--ct-modal-header-padding);
  border-bottom: var(--ct-modal-header-border-width) solid var(--ct-modal-header-border-color);
  border-top-left-radius: var(--ct-modal-inner-border-radius);
  border-top-right-radius: var(--ct-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--ct-modal-header-padding-y) * 0.5) calc(var(--ct-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--ct-modal-header-padding-y)) calc(-0.5 * var(--ct-modal-header-padding-x)) calc(-0.5 * var(--ct-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--ct-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--ct-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--ct-modal-padding) - var(--ct-modal-footer-gap) * 0.5);
  background-color: var(--ct-modal-footer-bg);
  border-top: var(--ct-modal-footer-border-width) solid var(--ct-modal-footer-border-color);
  border-bottom-right-radius: var(--ct-modal-inner-border-radius);
  border-bottom-left-radius: var(--ct-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--ct-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --ct-modal-margin: 1.75rem;
    --ct-modal-box-shadow: var(--ct-box-shadow);
  }
  .modal-dialog {
    max-width: var(--ct-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --ct-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --ct-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --ct-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --ct-tooltip-zindex: 1080;
  --ct-tooltip-max-width: 200px;
  --ct-tooltip-padding-x: 0.8rem;
  --ct-tooltip-padding-y: 0.4rem;
  --ct-tooltip-margin: 0;
  --ct-tooltip-font-size: 0.765625rem;
  --ct-tooltip-color: #fff;
  --ct-tooltip-bg: #000;
  --ct-tooltip-border-radius: 0.2rem;
  --ct-tooltip-opacity: 0.9;
  --ct-tooltip-arrow-width: 0.8rem;
  --ct-tooltip-arrow-height: 0.4rem;
  z-index: var(--ct-tooltip-zindex);
  display: block;
  padding: var(--ct-tooltip-arrow-height);
  margin: var(--ct-tooltip-margin);
  font-family: var(--ct-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--ct-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--ct-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--ct-tooltip-arrow-width);
  height: var(--ct-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: 0;
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--ct-tooltip-arrow-height) calc(var(--ct-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--ct-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: 0;
  width: var(--ct-tooltip-arrow-height);
  height: var(--ct-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--ct-tooltip-arrow-width) * 0.5) var(--ct-tooltip-arrow-height) calc(var(--ct-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--ct-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: 0;
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--ct-tooltip-arrow-width) * 0.5) var(--ct-tooltip-arrow-height);
  border-bottom-color: var(--ct-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: 0;
  width: var(--ct-tooltip-arrow-height);
  height: var(--ct-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--ct-tooltip-arrow-width) * 0.5) 0 calc(var(--ct-tooltip-arrow-width) * 0.5) var(--ct-tooltip-arrow-height);
  border-left-color: var(--ct-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--ct-tooltip-max-width);
  padding: var(--ct-tooltip-padding-y) var(--ct-tooltip-padding-x);
  color: var(--ct-tooltip-color);
  text-align: center;
  background-color: var(--ct-tooltip-bg);
  border-radius: var(--ct-tooltip-border-radius);
}

.popover {
  --ct-popover-zindex: 1070;
  --ct-popover-max-width: 276px;
  --ct-popover-font-size: 0.765625rem;
  --ct-popover-bg: var(--ct-secondary-bg);
  --ct-popover-border-width: var(--ct-border-width);
  --ct-popover-border-color: var(--ct-border-color);
  --ct-popover-border-radius: var(--ct-border-radius-lg);
  --ct-popover-inner-border-radius: calc(var(--ct-border-radius-lg) - (var(--ct-border-width)));
  --ct-popover-box-shadow: var(--ct-box-shadow);
  --ct-popover-header-padding-x: 0.8rem;
  --ct-popover-header-padding-y: 0.7rem;
  --ct-popover-header-font-size: 0.875rem;
  --ct-popover-header-color: var(--ct-headings-color);
  --ct-popover-header-bg: var(--ct-secondary-bg);
  --ct-popover-body-padding-x: 0.75rem;
  --ct-popover-body-padding-y: 0.5rem;
  --ct-popover-body-color: var(--ct-body-color);
  --ct-popover-arrow-width: 1rem;
  --ct-popover-arrow-height: 0.5rem;
  --ct-popover-arrow-border: var(--ct-popover-border-color);
  z-index: var(--ct-popover-zindex);
  display: block;
  max-width: var(--ct-popover-max-width);
  font-family: var(--ct-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--ct-popover-font-size);
  word-wrap: break-word;
  background-color: var(--ct-popover-bg);
  background-clip: padding-box;
  border: var(--ct-popover-border-width) solid var(--ct-popover-border-color);
  border-radius: var(--ct-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--ct-popover-arrow-width);
  height: var(--ct-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--ct-popover-arrow-height)) - var(--ct-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--ct-popover-arrow-height) calc(var(--ct-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--ct-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--ct-popover-border-width);
  border-top-color: var(--ct-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--ct-popover-arrow-height)) - var(--ct-popover-border-width));
  width: var(--ct-popover-arrow-height);
  height: var(--ct-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--ct-popover-arrow-width) * 0.5) var(--ct-popover-arrow-height) calc(var(--ct-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--ct-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--ct-popover-border-width);
  border-right-color: var(--ct-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--ct-popover-arrow-height)) - var(--ct-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--ct-popover-arrow-width) * 0.5) var(--ct-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--ct-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--ct-popover-border-width);
  border-bottom-color: var(--ct-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--ct-popover-arrow-width);
  margin-left: calc(-0.5 * var(--ct-popover-arrow-width));
  content: "";
  border-bottom: var(--ct-popover-border-width) solid var(--ct-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--ct-popover-arrow-height)) - var(--ct-popover-border-width));
  width: var(--ct-popover-arrow-height);
  height: var(--ct-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--ct-popover-arrow-width) * 0.5) 0 calc(var(--ct-popover-arrow-width) * 0.5) var(--ct-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--ct-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--ct-popover-border-width);
  border-left-color: var(--ct-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--ct-popover-header-padding-y) var(--ct-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--ct-popover-header-font-size);
  color: var(--ct-popover-header-color);
  background-color: var(--ct-popover-header-bg);
  border-bottom: var(--ct-popover-border-width) solid var(--ct-popover-border-color);
  border-top-left-radius: var(--ct-popover-inner-border-radius);
  border-top-right-radius: var(--ct-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--ct-popover-body-padding-y) var(--ct-popover-body-padding-x);
  color: var(--ct-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.carousel-dark .carousel-caption {
  color: #000;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target] {
  background-color: #000;
}
[data-bs-theme=dark] .carousel .carousel-caption {
  color: #000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--ct-spinner-width);
  height: var(--ct-spinner-height);
  vertical-align: var(--ct-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--ct-spinner-animation-speed) linear infinite var(--ct-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --ct-spinner-width: 2rem;
  --ct-spinner-height: 2rem;
  --ct-spinner-vertical-align: -0.125em;
  --ct-spinner-border-width: 0.25em;
  --ct-spinner-animation-speed: 0.75s;
  --ct-spinner-animation-name: spinner-border;
  border: var(--ct-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --ct-spinner-width: 1rem;
  --ct-spinner-height: 1rem;
  --ct-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --ct-spinner-width: 2rem;
  --ct-spinner-height: 2rem;
  --ct-spinner-vertical-align: -0.125em;
  --ct-spinner-animation-speed: 0.75s;
  --ct-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --ct-spinner-width: 1rem;
  --ct-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --ct-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --ct-offcanvas-zindex: 1045;
  --ct-offcanvas-width: 400px;
  --ct-offcanvas-height: 30vh;
  --ct-offcanvas-padding-x: 1rem;
  --ct-offcanvas-padding-y: 1rem;
  --ct-offcanvas-color: var(--ct-body-color);
  --ct-offcanvas-bg: var(--ct-secondary-bg);
  --ct-offcanvas-border-width: var(--ct-border-width);
  --ct-offcanvas-border-color: var(--ct-border-color-translucent);
  --ct-offcanvas-box-shadow: var(--ct-box-shadow-sm);
  --ct-offcanvas-transition: transform 0.3s ease-in-out;
  --ct-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--ct-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--ct-offcanvas-color);
    visibility: hidden;
    background-color: var(--ct-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--ct-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--ct-offcanvas-width);
    border-right: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--ct-offcanvas-width);
    border-left: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--ct-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--ct-offcanvas-height);
    max-height: 100%;
    border-top: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --ct-offcanvas-height: auto;
    --ct-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--ct-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--ct-offcanvas-color);
    visibility: hidden;
    background-color: var(--ct-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--ct-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--ct-offcanvas-width);
    border-right: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--ct-offcanvas-width);
    border-left: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--ct-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--ct-offcanvas-height);
    max-height: 100%;
    border-top: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --ct-offcanvas-height: auto;
    --ct-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--ct-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--ct-offcanvas-color);
    visibility: hidden;
    background-color: var(--ct-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--ct-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--ct-offcanvas-width);
    border-right: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--ct-offcanvas-width);
    border-left: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--ct-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--ct-offcanvas-height);
    max-height: 100%;
    border-top: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --ct-offcanvas-height: auto;
    --ct-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--ct-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--ct-offcanvas-color);
    visibility: hidden;
    background-color: var(--ct-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--ct-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--ct-offcanvas-width);
    border-right: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--ct-offcanvas-width);
    border-left: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--ct-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--ct-offcanvas-height);
    max-height: 100%;
    border-top: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --ct-offcanvas-height: auto;
    --ct-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--ct-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--ct-offcanvas-color);
    visibility: hidden;
    background-color: var(--ct-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--ct-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--ct-offcanvas-width);
    border-right: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--ct-offcanvas-width);
    border-left: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--ct-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--ct-offcanvas-height);
    max-height: 100%;
    border-top: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --ct-offcanvas-height: auto;
    --ct-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--ct-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--ct-offcanvas-color);
  visibility: hidden;
  background-color: var(--ct-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--ct-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--ct-offcanvas-width);
  border-right: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--ct-offcanvas-width);
  border-left: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--ct-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--ct-offcanvas-height);
  max-height: 100%;
  border-top: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--ct-offcanvas-padding-y) var(--ct-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--ct-offcanvas-padding-y) * 0.5) calc(var(--ct-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--ct-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--ct-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--ct-offcanvas-padding-y));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--ct-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--ct-offcanvas-padding-y) var(--ct-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(102, 88, 221, var(--ct-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(108, 117, 125, var(--ct-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(26, 188, 156, var(--ct-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #fff !important;
  background-color: RGBA(67, 191, 229, var(--ct-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #323a46 !important;
  background-color: RGBA(247, 184, 75, var(--ct-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(241, 85, 108, var(--ct-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #323a46 !important;
  background-color: RGBA(243, 247, 249, var(--ct-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(50, 58, 70, var(--ct-bg-opacity, 1)) !important;
}

.text-bg-pink {
  color: #fff !important;
  background-color: RGBA(246, 114, 167, var(--ct-bg-opacity, 1)) !important;
}

.text-bg-blue {
  color: #fff !important;
  background-color: RGBA(74, 129, 212, var(--ct-bg-opacity, 1)) !important;
}

.link-primary {
  color: #6658dd !important;
}
.link-primary:hover, .link-primary:focus {
  color: rgb(86.7, 74.8, 187.85) !important;
}

.link-secondary {
  color: #6c757d !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: rgb(91.8, 99.45, 106.25) !important;
}

.link-success {
  color: #1abc9c !important;
}
.link-success:hover, .link-success:focus {
  color: rgb(22.1, 159.8, 132.6) !important;
}

.link-info {
  color: #43bfe5 !important;
}
.link-info:hover, .link-info:focus {
  color: rgb(56.95, 162.35, 194.65) !important;
}

.link-warning {
  color: #f7b84b !important;
}
.link-warning:hover, .link-warning:focus {
  color: rgb(248.2, 194.65, 102) !important;
}

.link-danger {
  color: #f1556c !important;
}
.link-danger:hover, .link-danger:focus {
  color: rgb(204.85, 72.25, 91.8) !important;
}

.link-light {
  color: #f3f7f9 !important;
}
.link-light:hover, .link-light:focus {
  color: rgb(244.8, 248.2, 249.9) !important;
}

.link-dark {
  color: #323a46 !important;
}
.link-dark:hover, .link-dark:focus {
  color: rgb(42.5, 49.3, 59.5) !important;
}

.link-pink {
  color: #f672a7 !important;
}
.link-pink:hover, .link-pink:focus {
  color: rgb(209.1, 96.9, 141.95) !important;
}

.link-blue {
  color: #4a81d4 !important;
}
.link-blue:hover, .link-blue:focus {
  color: rgb(62.9, 109.65, 180.2) !important;
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--ct-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --ct-aspect-ratio: 100%;
}

.ratio-4x3 {
  --ct-aspect-ratio: 75%;
}

.ratio-16x9 {
  --ct-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --ct-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--ct-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--ct-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--ct-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--ct-border-width) var(--ct-border-style) var(--ct-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--ct-border-width) var(--ct-border-style) var(--ct-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--ct-border-width) var(--ct-border-style) var(--ct-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--ct-border-width) var(--ct-border-style) var(--ct-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--ct-border-width) var(--ct-border-style) var(--ct-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --ct-border-opacity: 1;
  border-color: rgba(var(--ct-primary-rgb), var(--ct-border-opacity)) !important;
}

.border-secondary {
  --ct-border-opacity: 1;
  border-color: rgba(var(--ct-secondary-rgb), var(--ct-border-opacity)) !important;
}

.border-success {
  --ct-border-opacity: 1;
  border-color: rgba(var(--ct-success-rgb), var(--ct-border-opacity)) !important;
}

.border-info {
  --ct-border-opacity: 1;
  border-color: rgba(var(--ct-info-rgb), var(--ct-border-opacity)) !important;
}

.border-warning {
  --ct-border-opacity: 1;
  border-color: rgba(var(--ct-warning-rgb), var(--ct-border-opacity)) !important;
}

.border-danger {
  --ct-border-opacity: 1;
  border-color: rgba(var(--ct-danger-rgb), var(--ct-border-opacity)) !important;
}

.border-light {
  --ct-border-opacity: 1;
  border-color: rgba(var(--ct-light-rgb), var(--ct-border-opacity)) !important;
}

.border-dark {
  --ct-border-opacity: 1;
  border-color: rgba(var(--ct-dark-rgb), var(--ct-border-opacity)) !important;
}

.border-pink {
  --ct-border-opacity: 1;
  border-color: rgba(var(--ct-pink-rgb), var(--ct-border-opacity)) !important;
}

.border-blue {
  --ct-border-opacity: 1;
  border-color: rgba(var(--ct-blue-rgb), var(--ct-border-opacity)) !important;
}

.border-white {
  --ct-border-opacity: 1;
  border-color: rgba(var(--ct-white-rgb), var(--ct-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--ct-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--ct-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--ct-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--ct-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--ct-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--ct-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--ct-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--ct-dark-border-subtle) !important;
}

.border-0 {
  --ct-border-width: 0;
}

.border-1 {
  --ct-border-width: 1px;
}

.border-2 {
  --ct-border-width: 2px;
}

.border-3 {
  --ct-border-width: 3px;
}

.border-4 {
  --ct-border-width: 4px;
}

.border-5 {
  --ct-border-width: 5px;
}

.border-opacity-10 {
  --ct-border-opacity: 0.1;
}

.border-opacity-25 {
  --ct-border-opacity: 0.25;
}

.border-opacity-50 {
  --ct-border-opacity: 0.5;
}

.border-opacity-75 {
  --ct-border-opacity: 0.75;
}

.border-opacity-100 {
  --ct-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.375rem !important;
}

.m-2 {
  margin: 0.75rem !important;
}

.m-3 {
  margin: 1.5rem !important;
}

.m-4 {
  margin: 2.25rem !important;
}

.m-5 {
  margin: 4.5rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.375rem !important;
  margin-left: 0.375rem !important;
}

.mx-2 {
  margin-right: 0.75rem !important;
  margin-left: 0.75rem !important;
}

.mx-3 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-4 {
  margin-right: 2.25rem !important;
  margin-left: 2.25rem !important;
}

.mx-5 {
  margin-right: 4.5rem !important;
  margin-left: 4.5rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.375rem !important;
  margin-bottom: 0.375rem !important;
}

.my-2 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}

.my-3 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-4 {
  margin-top: 2.25rem !important;
  margin-bottom: 2.25rem !important;
}

.my-5 {
  margin-top: 4.5rem !important;
  margin-bottom: 4.5rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.375rem !important;
}

.mt-2 {
  margin-top: 0.75rem !important;
}

.mt-3 {
  margin-top: 1.5rem !important;
}

.mt-4 {
  margin-top: 2.25rem !important;
}

.mt-5 {
  margin-top: 4.5rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.375rem !important;
}

.me-2 {
  margin-right: 0.75rem !important;
}

.me-3 {
  margin-right: 1.5rem !important;
}

.me-4 {
  margin-right: 2.25rem !important;
}

.me-5 {
  margin-right: 4.5rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.375rem !important;
}

.mb-2 {
  margin-bottom: 0.75rem !important;
}

.mb-3 {
  margin-bottom: 1.5rem !important;
}

.mb-4 {
  margin-bottom: 2.25rem !important;
}

.mb-5 {
  margin-bottom: 4.5rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.375rem !important;
}

.ms-2 {
  margin-left: 0.75rem !important;
}

.ms-3 {
  margin-left: 1.5rem !important;
}

.ms-4 {
  margin-left: 2.25rem !important;
}

.ms-5 {
  margin-left: 4.5rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.375rem !important;
}

.m-n2 {
  margin: -0.75rem !important;
}

.m-n3 {
  margin: -1.5rem !important;
}

.m-n4 {
  margin: -2.25rem !important;
}

.m-n5 {
  margin: -4.5rem !important;
}

.mx-n1 {
  margin-right: -0.375rem !important;
  margin-left: -0.375rem !important;
}

.mx-n2 {
  margin-right: -0.75rem !important;
  margin-left: -0.75rem !important;
}

.mx-n3 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n4 {
  margin-right: -2.25rem !important;
  margin-left: -2.25rem !important;
}

.mx-n5 {
  margin-right: -4.5rem !important;
  margin-left: -4.5rem !important;
}

.my-n1 {
  margin-top: -0.375rem !important;
  margin-bottom: -0.375rem !important;
}

.my-n2 {
  margin-top: -0.75rem !important;
  margin-bottom: -0.75rem !important;
}

.my-n3 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n4 {
  margin-top: -2.25rem !important;
  margin-bottom: -2.25rem !important;
}

.my-n5 {
  margin-top: -4.5rem !important;
  margin-bottom: -4.5rem !important;
}

.mt-n1 {
  margin-top: -0.375rem !important;
}

.mt-n2 {
  margin-top: -0.75rem !important;
}

.mt-n3 {
  margin-top: -1.5rem !important;
}

.mt-n4 {
  margin-top: -2.25rem !important;
}

.mt-n5 {
  margin-top: -4.5rem !important;
}

.me-n1 {
  margin-right: -0.375rem !important;
}

.me-n2 {
  margin-right: -0.75rem !important;
}

.me-n3 {
  margin-right: -1.5rem !important;
}

.me-n4 {
  margin-right: -2.25rem !important;
}

.me-n5 {
  margin-right: -4.5rem !important;
}

.mb-n1 {
  margin-bottom: -0.375rem !important;
}

.mb-n2 {
  margin-bottom: -0.75rem !important;
}

.mb-n3 {
  margin-bottom: -1.5rem !important;
}

.mb-n4 {
  margin-bottom: -2.25rem !important;
}

.mb-n5 {
  margin-bottom: -4.5rem !important;
}

.ms-n1 {
  margin-left: -0.375rem !important;
}

.ms-n2 {
  margin-left: -0.75rem !important;
}

.ms-n3 {
  margin-left: -1.5rem !important;
}

.ms-n4 {
  margin-left: -2.25rem !important;
}

.ms-n5 {
  margin-left: -4.5rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.375rem !important;
}

.p-2 {
  padding: 0.75rem !important;
}

.p-3 {
  padding: 1.5rem !important;
}

.p-4 {
  padding: 2.25rem !important;
}

.p-5 {
  padding: 4.5rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.375rem !important;
  padding-left: 0.375rem !important;
}

.px-2 {
  padding-right: 0.75rem !important;
  padding-left: 0.75rem !important;
}

.px-3 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-4 {
  padding-right: 2.25rem !important;
  padding-left: 2.25rem !important;
}

.px-5 {
  padding-right: 4.5rem !important;
  padding-left: 4.5rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}

.py-2 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}

.py-3 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-4 {
  padding-top: 2.25rem !important;
  padding-bottom: 2.25rem !important;
}

.py-5 {
  padding-top: 4.5rem !important;
  padding-bottom: 4.5rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.375rem !important;
}

.pt-2 {
  padding-top: 0.75rem !important;
}

.pt-3 {
  padding-top: 1.5rem !important;
}

.pt-4 {
  padding-top: 2.25rem !important;
}

.pt-5 {
  padding-top: 4.5rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.375rem !important;
}

.pe-2 {
  padding-right: 0.75rem !important;
}

.pe-3 {
  padding-right: 1.5rem !important;
}

.pe-4 {
  padding-right: 2.25rem !important;
}

.pe-5 {
  padding-right: 4.5rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.375rem !important;
}

.pb-2 {
  padding-bottom: 0.75rem !important;
}

.pb-3 {
  padding-bottom: 1.5rem !important;
}

.pb-4 {
  padding-bottom: 2.25rem !important;
}

.pb-5 {
  padding-bottom: 4.5rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.375rem !important;
}

.ps-2 {
  padding-left: 0.75rem !important;
}

.ps-3 {
  padding-left: 1.5rem !important;
}

.ps-4 {
  padding-left: 2.25rem !important;
}

.ps-5 {
  padding-left: 4.5rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.375rem !important;
}

.gap-2 {
  gap: 0.75rem !important;
}

.gap-3 {
  gap: 1.5rem !important;
}

.gap-4 {
  gap: 2.25rem !important;
}

.gap-5 {
  gap: 4.5rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.375rem !important;
}

.row-gap-2 {
  row-gap: 0.75rem !important;
}

.row-gap-3 {
  row-gap: 1.5rem !important;
}

.row-gap-4 {
  row-gap: 2.25rem !important;
}

.row-gap-5 {
  row-gap: 4.5rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.375rem !important;
}

.column-gap-2 {
  column-gap: 0.75rem !important;
}

.column-gap-3 {
  column-gap: 1.5rem !important;
}

.column-gap-4 {
  column-gap: 2.25rem !important;
}

.column-gap-5 {
  column-gap: 4.5rem !important;
}

.font-monospace {
  font-family: var(--ct-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.35rem + 1.2vw) !important;
}

.fs-2 {
  font-size: calc(1.3125rem + 0.75vw) !important;
}

.fs-3 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-4 {
  font-size: 1.125rem !important;
}

.fs-5 {
  font-size: 0.9375rem !important;
}

.fs-6 {
  font-size: 0.75rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --ct-text-opacity: 1;
  color: rgba(var(--ct-primary-rgb), var(--ct-text-opacity)) !important;
}

.text-secondary {
  --ct-text-opacity: 1;
  color: rgba(var(--ct-secondary-rgb), var(--ct-text-opacity)) !important;
}

.text-success {
  --ct-text-opacity: 1;
  color: rgba(var(--ct-success-rgb), var(--ct-text-opacity)) !important;
}

.text-info {
  --ct-text-opacity: 1;
  color: rgba(var(--ct-info-rgb), var(--ct-text-opacity)) !important;
}

.text-warning {
  --ct-text-opacity: 1;
  color: rgba(var(--ct-warning-rgb), var(--ct-text-opacity)) !important;
}

.text-danger {
  --ct-text-opacity: 1;
  color: rgba(var(--ct-danger-rgb), var(--ct-text-opacity)) !important;
}

.text-light {
  --ct-text-opacity: 1;
  color: rgba(var(--ct-light-rgb), var(--ct-text-opacity)) !important;
}

.text-dark {
  --ct-text-opacity: 1;
  color: rgba(var(--ct-dark-rgb), var(--ct-text-opacity)) !important;
}

.text-pink {
  --ct-text-opacity: 1;
  color: rgba(var(--ct-pink-rgb), var(--ct-text-opacity)) !important;
}

.text-blue {
  --ct-text-opacity: 1;
  color: rgba(var(--ct-blue-rgb), var(--ct-text-opacity)) !important;
}

.text-black {
  --ct-text-opacity: 1;
  color: rgba(var(--ct-black-rgb), var(--ct-text-opacity)) !important;
}

.text-white {
  --ct-text-opacity: 1;
  color: rgba(var(--ct-white-rgb), var(--ct-text-opacity)) !important;
}

.text-body {
  --ct-text-opacity: 1;
  color: rgba(var(--ct-body-color-rgb), var(--ct-text-opacity)) !important;
}

.text-muted {
  --ct-text-opacity: 1;
  color: var(--ct-gray) !important;
}

.text-black-50 {
  --ct-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --ct-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --ct-text-opacity: 1;
  color: var(--ct-secondary-color) !important;
}

.text-body-tertiary {
  --ct-text-opacity: 1;
  color: var(--ct-tertiary-color) !important;
}

.text-body-emphasis {
  --ct-text-opacity: 1;
  color: var(--ct-emphasis-color) !important;
}

.text-reset {
  --ct-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --ct-text-opacity: 0.25;
}

.text-opacity-50 {
  --ct-text-opacity: 0.5;
}

.text-opacity-75 {
  --ct-text-opacity: 0.75;
}

.text-opacity-100 {
  --ct-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--ct-primary-text) !important;
}

.text-secondary-emphasis {
  color: var(--ct-secondary-text) !important;
}

.text-success-emphasis {
  color: var(--ct-success-text) !important;
}

.text-info-emphasis {
  color: var(--ct-info-text) !important;
}

.text-warning-emphasis {
  color: var(--ct-warning-text) !important;
}

.text-danger-emphasis {
  color: var(--ct-danger-text) !important;
}

.text-light-emphasis {
  color: var(--ct-light-text) !important;
}

.text-dark-emphasis {
  color: var(--ct-dark-text) !important;
}

.bg-primary {
  --ct-bg-opacity: 1;
  background-color: rgba(var(--ct-primary-rgb), var(--ct-bg-opacity)) !important;
}

.bg-secondary {
  --ct-bg-opacity: 1;
  background-color: rgba(var(--ct-secondary-rgb), var(--ct-bg-opacity)) !important;
}

.bg-success {
  --ct-bg-opacity: 1;
  background-color: rgba(var(--ct-success-rgb), var(--ct-bg-opacity)) !important;
}

.bg-info {
  --ct-bg-opacity: 1;
  background-color: rgba(var(--ct-info-rgb), var(--ct-bg-opacity)) !important;
}

.bg-warning {
  --ct-bg-opacity: 1;
  background-color: rgba(var(--ct-warning-rgb), var(--ct-bg-opacity)) !important;
}

.bg-danger {
  --ct-bg-opacity: 1;
  background-color: rgba(var(--ct-danger-rgb), var(--ct-bg-opacity)) !important;
}

.bg-light {
  --ct-bg-opacity: 1;
  background-color: rgba(var(--ct-light-rgb), var(--ct-bg-opacity)) !important;
}

.bg-dark {
  --ct-bg-opacity: 1;
  background-color: rgba(var(--ct-dark-rgb), var(--ct-bg-opacity)) !important;
}

.bg-pink {
  --ct-bg-opacity: 1;
  background-color: rgba(var(--ct-pink-rgb), var(--ct-bg-opacity)) !important;
}

.bg-blue {
  --ct-bg-opacity: 1;
  background-color: rgba(var(--ct-blue-rgb), var(--ct-bg-opacity)) !important;
}

.bg-black {
  --ct-bg-opacity: 1;
  background-color: rgba(var(--ct-black-rgb), var(--ct-bg-opacity)) !important;
}

.bg-white {
  --ct-bg-opacity: 1;
  background-color: rgba(var(--ct-white-rgb), var(--ct-bg-opacity)) !important;
}

.bg-body {
  --ct-bg-opacity: 1;
  background-color: rgba(var(--ct-body-bg-rgb), var(--ct-bg-opacity)) !important;
}

.bg-transparent {
  --ct-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --ct-bg-opacity: 1;
  background-color: rgba(var(--ct-secondary-bg-rgb), var(--ct-bg-opacity)) !important;
}

.bg-body-tertiary {
  --ct-bg-opacity: 1;
  background-color: rgba(var(--ct-tertiary-bg-rgb), var(--ct-bg-opacity)) !important;
}

.bg-body-emphasis {
  --ct-bg-opacity: 1;
  background-color: rgba(var(--ct-emphasis-bg-rgb), var(--ct-bg-opacity)) !important;
}

.bg-opacity-10 {
  --ct-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --ct-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --ct-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --ct-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --ct-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--ct-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--ct-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--ct-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--ct-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--ct-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--ct-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--ct-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--ct-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--ct-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--ct-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--ct-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--ct-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--ct-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--ct-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--ct-border-radius-2xl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--ct-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--ct-border-radius) !important;
  border-top-right-radius: var(--ct-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--ct-border-radius-sm) !important;
  border-top-right-radius: var(--ct-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--ct-border-radius) !important;
  border-top-right-radius: var(--ct-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--ct-border-radius-lg) !important;
  border-top-right-radius: var(--ct-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--ct-border-radius-xl) !important;
  border-top-right-radius: var(--ct-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--ct-border-radius-2xl) !important;
  border-top-right-radius: var(--ct-border-radius-2xl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--ct-border-radius-pill) !important;
  border-top-right-radius: var(--ct-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--ct-border-radius) !important;
  border-bottom-right-radius: var(--ct-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--ct-border-radius-sm) !important;
  border-bottom-right-radius: var(--ct-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--ct-border-radius) !important;
  border-bottom-right-radius: var(--ct-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--ct-border-radius-lg) !important;
  border-bottom-right-radius: var(--ct-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--ct-border-radius-xl) !important;
  border-bottom-right-radius: var(--ct-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--ct-border-radius-2xl) !important;
  border-bottom-right-radius: var(--ct-border-radius-2xl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--ct-border-radius-pill) !important;
  border-bottom-right-radius: var(--ct-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--ct-border-radius) !important;
  border-bottom-left-radius: var(--ct-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--ct-border-radius-sm) !important;
  border-bottom-left-radius: var(--ct-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--ct-border-radius) !important;
  border-bottom-left-radius: var(--ct-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--ct-border-radius-lg) !important;
  border-bottom-left-radius: var(--ct-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--ct-border-radius-xl) !important;
  border-bottom-left-radius: var(--ct-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--ct-border-radius-2xl) !important;
  border-bottom-left-radius: var(--ct-border-radius-2xl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--ct-border-radius-pill) !important;
  border-bottom-left-radius: var(--ct-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--ct-border-radius) !important;
  border-top-left-radius: var(--ct-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--ct-border-radius-sm) !important;
  border-top-left-radius: var(--ct-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--ct-border-radius) !important;
  border-top-left-radius: var(--ct-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--ct-border-radius-lg) !important;
  border-top-left-radius: var(--ct-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--ct-border-radius-xl) !important;
  border-top-left-radius: var(--ct-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--ct-border-radius-2xl) !important;
  border-top-left-radius: var(--ct-border-radius-2xl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--ct-border-radius-pill) !important;
  border-top-left-radius: var(--ct-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.375rem !important;
  }
  .m-sm-2 {
    margin: 0.75rem !important;
  }
  .m-sm-3 {
    margin: 1.5rem !important;
  }
  .m-sm-4 {
    margin: 2.25rem !important;
  }
  .m-sm-5 {
    margin: 4.5rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-sm-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-sm-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-sm-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-sm-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-sm-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.375rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.75rem !important;
  }
  .mt-sm-3 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-4 {
    margin-top: 2.25rem !important;
  }
  .mt-sm-5 {
    margin-top: 4.5rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.375rem !important;
  }
  .me-sm-2 {
    margin-right: 0.75rem !important;
  }
  .me-sm-3 {
    margin-right: 1.5rem !important;
  }
  .me-sm-4 {
    margin-right: 2.25rem !important;
  }
  .me-sm-5 {
    margin-right: 4.5rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.375rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.75rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 2.25rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 4.5rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.375rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.75rem !important;
  }
  .ms-sm-3 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-4 {
    margin-left: 2.25rem !important;
  }
  .ms-sm-5 {
    margin-left: 4.5rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .m-sm-n1 {
    margin: -0.375rem !important;
  }
  .m-sm-n2 {
    margin: -0.75rem !important;
  }
  .m-sm-n3 {
    margin: -1.5rem !important;
  }
  .m-sm-n4 {
    margin: -2.25rem !important;
  }
  .m-sm-n5 {
    margin: -4.5rem !important;
  }
  .mx-sm-n1 {
    margin-right: -0.375rem !important;
    margin-left: -0.375rem !important;
  }
  .mx-sm-n2 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-sm-n3 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-sm-n4 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-sm-n5 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .my-sm-n1 {
    margin-top: -0.375rem !important;
    margin-bottom: -0.375rem !important;
  }
  .my-sm-n2 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-sm-n3 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-sm-n4 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-sm-n5 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .mt-sm-n1 {
    margin-top: -0.375rem !important;
  }
  .mt-sm-n2 {
    margin-top: -0.75rem !important;
  }
  .mt-sm-n3 {
    margin-top: -1.5rem !important;
  }
  .mt-sm-n4 {
    margin-top: -2.25rem !important;
  }
  .mt-sm-n5 {
    margin-top: -4.5rem !important;
  }
  .me-sm-n1 {
    margin-right: -0.375rem !important;
  }
  .me-sm-n2 {
    margin-right: -0.75rem !important;
  }
  .me-sm-n3 {
    margin-right: -1.5rem !important;
  }
  .me-sm-n4 {
    margin-right: -2.25rem !important;
  }
  .me-sm-n5 {
    margin-right: -4.5rem !important;
  }
  .mb-sm-n1 {
    margin-bottom: -0.375rem !important;
  }
  .mb-sm-n2 {
    margin-bottom: -0.75rem !important;
  }
  .mb-sm-n3 {
    margin-bottom: -1.5rem !important;
  }
  .mb-sm-n4 {
    margin-bottom: -2.25rem !important;
  }
  .mb-sm-n5 {
    margin-bottom: -4.5rem !important;
  }
  .ms-sm-n1 {
    margin-left: -0.375rem !important;
  }
  .ms-sm-n2 {
    margin-left: -0.75rem !important;
  }
  .ms-sm-n3 {
    margin-left: -1.5rem !important;
  }
  .ms-sm-n4 {
    margin-left: -2.25rem !important;
  }
  .ms-sm-n5 {
    margin-left: -4.5rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.375rem !important;
  }
  .p-sm-2 {
    padding: 0.75rem !important;
  }
  .p-sm-3 {
    padding: 1.5rem !important;
  }
  .p-sm-4 {
    padding: 2.25rem !important;
  }
  .p-sm-5 {
    padding: 4.5rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-sm-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-sm-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-sm-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-sm-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-sm-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-sm-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.375rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.75rem !important;
  }
  .pt-sm-3 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-4 {
    padding-top: 2.25rem !important;
  }
  .pt-sm-5 {
    padding-top: 4.5rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.375rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.75rem !important;
  }
  .pe-sm-3 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-4 {
    padding-right: 2.25rem !important;
  }
  .pe-sm-5 {
    padding-right: 4.5rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.375rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.75rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 2.25rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 4.5rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.375rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.75rem !important;
  }
  .ps-sm-3 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-4 {
    padding-left: 2.25rem !important;
  }
  .ps-sm-5 {
    padding-left: 4.5rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.375rem !important;
  }
  .gap-sm-2 {
    gap: 0.75rem !important;
  }
  .gap-sm-3 {
    gap: 1.5rem !important;
  }
  .gap-sm-4 {
    gap: 2.25rem !important;
  }
  .gap-sm-5 {
    gap: 4.5rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.375rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.75rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 2.25rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 4.5rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.375rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.75rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 2.25rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 4.5rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.375rem !important;
  }
  .m-md-2 {
    margin: 0.75rem !important;
  }
  .m-md-3 {
    margin: 1.5rem !important;
  }
  .m-md-4 {
    margin: 2.25rem !important;
  }
  .m-md-5 {
    margin: 4.5rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-md-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-md-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-md-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-md-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-md-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-md-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.375rem !important;
  }
  .mt-md-2 {
    margin-top: 0.75rem !important;
  }
  .mt-md-3 {
    margin-top: 1.5rem !important;
  }
  .mt-md-4 {
    margin-top: 2.25rem !important;
  }
  .mt-md-5 {
    margin-top: 4.5rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.375rem !important;
  }
  .me-md-2 {
    margin-right: 0.75rem !important;
  }
  .me-md-3 {
    margin-right: 1.5rem !important;
  }
  .me-md-4 {
    margin-right: 2.25rem !important;
  }
  .me-md-5 {
    margin-right: 4.5rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.375rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.75rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-4 {
    margin-bottom: 2.25rem !important;
  }
  .mb-md-5 {
    margin-bottom: 4.5rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.375rem !important;
  }
  .ms-md-2 {
    margin-left: 0.75rem !important;
  }
  .ms-md-3 {
    margin-left: 1.5rem !important;
  }
  .ms-md-4 {
    margin-left: 2.25rem !important;
  }
  .ms-md-5 {
    margin-left: 4.5rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .m-md-n1 {
    margin: -0.375rem !important;
  }
  .m-md-n2 {
    margin: -0.75rem !important;
  }
  .m-md-n3 {
    margin: -1.5rem !important;
  }
  .m-md-n4 {
    margin: -2.25rem !important;
  }
  .m-md-n5 {
    margin: -4.5rem !important;
  }
  .mx-md-n1 {
    margin-right: -0.375rem !important;
    margin-left: -0.375rem !important;
  }
  .mx-md-n2 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-md-n3 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-md-n4 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-md-n5 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .my-md-n1 {
    margin-top: -0.375rem !important;
    margin-bottom: -0.375rem !important;
  }
  .my-md-n2 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-md-n3 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-md-n4 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-md-n5 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .mt-md-n1 {
    margin-top: -0.375rem !important;
  }
  .mt-md-n2 {
    margin-top: -0.75rem !important;
  }
  .mt-md-n3 {
    margin-top: -1.5rem !important;
  }
  .mt-md-n4 {
    margin-top: -2.25rem !important;
  }
  .mt-md-n5 {
    margin-top: -4.5rem !important;
  }
  .me-md-n1 {
    margin-right: -0.375rem !important;
  }
  .me-md-n2 {
    margin-right: -0.75rem !important;
  }
  .me-md-n3 {
    margin-right: -1.5rem !important;
  }
  .me-md-n4 {
    margin-right: -2.25rem !important;
  }
  .me-md-n5 {
    margin-right: -4.5rem !important;
  }
  .mb-md-n1 {
    margin-bottom: -0.375rem !important;
  }
  .mb-md-n2 {
    margin-bottom: -0.75rem !important;
  }
  .mb-md-n3 {
    margin-bottom: -1.5rem !important;
  }
  .mb-md-n4 {
    margin-bottom: -2.25rem !important;
  }
  .mb-md-n5 {
    margin-bottom: -4.5rem !important;
  }
  .ms-md-n1 {
    margin-left: -0.375rem !important;
  }
  .ms-md-n2 {
    margin-left: -0.75rem !important;
  }
  .ms-md-n3 {
    margin-left: -1.5rem !important;
  }
  .ms-md-n4 {
    margin-left: -2.25rem !important;
  }
  .ms-md-n5 {
    margin-left: -4.5rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.375rem !important;
  }
  .p-md-2 {
    padding: 0.75rem !important;
  }
  .p-md-3 {
    padding: 1.5rem !important;
  }
  .p-md-4 {
    padding: 2.25rem !important;
  }
  .p-md-5 {
    padding: 4.5rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-md-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-md-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-md-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-md-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-md-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-md-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.375rem !important;
  }
  .pt-md-2 {
    padding-top: 0.75rem !important;
  }
  .pt-md-3 {
    padding-top: 1.5rem !important;
  }
  .pt-md-4 {
    padding-top: 2.25rem !important;
  }
  .pt-md-5 {
    padding-top: 4.5rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.375rem !important;
  }
  .pe-md-2 {
    padding-right: 0.75rem !important;
  }
  .pe-md-3 {
    padding-right: 1.5rem !important;
  }
  .pe-md-4 {
    padding-right: 2.25rem !important;
  }
  .pe-md-5 {
    padding-right: 4.5rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.375rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.75rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-4 {
    padding-bottom: 2.25rem !important;
  }
  .pb-md-5 {
    padding-bottom: 4.5rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.375rem !important;
  }
  .ps-md-2 {
    padding-left: 0.75rem !important;
  }
  .ps-md-3 {
    padding-left: 1.5rem !important;
  }
  .ps-md-4 {
    padding-left: 2.25rem !important;
  }
  .ps-md-5 {
    padding-left: 4.5rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.375rem !important;
  }
  .gap-md-2 {
    gap: 0.75rem !important;
  }
  .gap-md-3 {
    gap: 1.5rem !important;
  }
  .gap-md-4 {
    gap: 2.25rem !important;
  }
  .gap-md-5 {
    gap: 4.5rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.375rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.75rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-4 {
    row-gap: 2.25rem !important;
  }
  .row-gap-md-5 {
    row-gap: 4.5rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.375rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.75rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-4 {
    column-gap: 2.25rem !important;
  }
  .column-gap-md-5 {
    column-gap: 4.5rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.375rem !important;
  }
  .m-lg-2 {
    margin: 0.75rem !important;
  }
  .m-lg-3 {
    margin: 1.5rem !important;
  }
  .m-lg-4 {
    margin: 2.25rem !important;
  }
  .m-lg-5 {
    margin: 4.5rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-lg-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-lg-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-lg-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-lg-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-lg-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.375rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.75rem !important;
  }
  .mt-lg-3 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-4 {
    margin-top: 2.25rem !important;
  }
  .mt-lg-5 {
    margin-top: 4.5rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.375rem !important;
  }
  .me-lg-2 {
    margin-right: 0.75rem !important;
  }
  .me-lg-3 {
    margin-right: 1.5rem !important;
  }
  .me-lg-4 {
    margin-right: 2.25rem !important;
  }
  .me-lg-5 {
    margin-right: 4.5rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.375rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.75rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 2.25rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 4.5rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.375rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.75rem !important;
  }
  .ms-lg-3 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-4 {
    margin-left: 2.25rem !important;
  }
  .ms-lg-5 {
    margin-left: 4.5rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .m-lg-n1 {
    margin: -0.375rem !important;
  }
  .m-lg-n2 {
    margin: -0.75rem !important;
  }
  .m-lg-n3 {
    margin: -1.5rem !important;
  }
  .m-lg-n4 {
    margin: -2.25rem !important;
  }
  .m-lg-n5 {
    margin: -4.5rem !important;
  }
  .mx-lg-n1 {
    margin-right: -0.375rem !important;
    margin-left: -0.375rem !important;
  }
  .mx-lg-n2 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-lg-n3 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-lg-n4 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-lg-n5 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .my-lg-n1 {
    margin-top: -0.375rem !important;
    margin-bottom: -0.375rem !important;
  }
  .my-lg-n2 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-lg-n3 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-lg-n4 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-lg-n5 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .mt-lg-n1 {
    margin-top: -0.375rem !important;
  }
  .mt-lg-n2 {
    margin-top: -0.75rem !important;
  }
  .mt-lg-n3 {
    margin-top: -1.5rem !important;
  }
  .mt-lg-n4 {
    margin-top: -2.25rem !important;
  }
  .mt-lg-n5 {
    margin-top: -4.5rem !important;
  }
  .me-lg-n1 {
    margin-right: -0.375rem !important;
  }
  .me-lg-n2 {
    margin-right: -0.75rem !important;
  }
  .me-lg-n3 {
    margin-right: -1.5rem !important;
  }
  .me-lg-n4 {
    margin-right: -2.25rem !important;
  }
  .me-lg-n5 {
    margin-right: -4.5rem !important;
  }
  .mb-lg-n1 {
    margin-bottom: -0.375rem !important;
  }
  .mb-lg-n2 {
    margin-bottom: -0.75rem !important;
  }
  .mb-lg-n3 {
    margin-bottom: -1.5rem !important;
  }
  .mb-lg-n4 {
    margin-bottom: -2.25rem !important;
  }
  .mb-lg-n5 {
    margin-bottom: -4.5rem !important;
  }
  .ms-lg-n1 {
    margin-left: -0.375rem !important;
  }
  .ms-lg-n2 {
    margin-left: -0.75rem !important;
  }
  .ms-lg-n3 {
    margin-left: -1.5rem !important;
  }
  .ms-lg-n4 {
    margin-left: -2.25rem !important;
  }
  .ms-lg-n5 {
    margin-left: -4.5rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.375rem !important;
  }
  .p-lg-2 {
    padding: 0.75rem !important;
  }
  .p-lg-3 {
    padding: 1.5rem !important;
  }
  .p-lg-4 {
    padding: 2.25rem !important;
  }
  .p-lg-5 {
    padding: 4.5rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-lg-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-lg-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-lg-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-lg-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-lg-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-lg-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.375rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.75rem !important;
  }
  .pt-lg-3 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-4 {
    padding-top: 2.25rem !important;
  }
  .pt-lg-5 {
    padding-top: 4.5rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.375rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.75rem !important;
  }
  .pe-lg-3 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-4 {
    padding-right: 2.25rem !important;
  }
  .pe-lg-5 {
    padding-right: 4.5rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.375rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.75rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 2.25rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 4.5rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.375rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.75rem !important;
  }
  .ps-lg-3 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-4 {
    padding-left: 2.25rem !important;
  }
  .ps-lg-5 {
    padding-left: 4.5rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.375rem !important;
  }
  .gap-lg-2 {
    gap: 0.75rem !important;
  }
  .gap-lg-3 {
    gap: 1.5rem !important;
  }
  .gap-lg-4 {
    gap: 2.25rem !important;
  }
  .gap-lg-5 {
    gap: 4.5rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.375rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.75rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 2.25rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 4.5rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.375rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.75rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 2.25rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 4.5rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.375rem !important;
  }
  .m-xl-2 {
    margin: 0.75rem !important;
  }
  .m-xl-3 {
    margin: 1.5rem !important;
  }
  .m-xl-4 {
    margin: 2.25rem !important;
  }
  .m-xl-5 {
    margin: 4.5rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-xl-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-xl-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-xl-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-xl-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-xl-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.375rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.75rem !important;
  }
  .mt-xl-3 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-4 {
    margin-top: 2.25rem !important;
  }
  .mt-xl-5 {
    margin-top: 4.5rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.375rem !important;
  }
  .me-xl-2 {
    margin-right: 0.75rem !important;
  }
  .me-xl-3 {
    margin-right: 1.5rem !important;
  }
  .me-xl-4 {
    margin-right: 2.25rem !important;
  }
  .me-xl-5 {
    margin-right: 4.5rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.375rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.75rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 2.25rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 4.5rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.375rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.75rem !important;
  }
  .ms-xl-3 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-4 {
    margin-left: 2.25rem !important;
  }
  .ms-xl-5 {
    margin-left: 4.5rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .m-xl-n1 {
    margin: -0.375rem !important;
  }
  .m-xl-n2 {
    margin: -0.75rem !important;
  }
  .m-xl-n3 {
    margin: -1.5rem !important;
  }
  .m-xl-n4 {
    margin: -2.25rem !important;
  }
  .m-xl-n5 {
    margin: -4.5rem !important;
  }
  .mx-xl-n1 {
    margin-right: -0.375rem !important;
    margin-left: -0.375rem !important;
  }
  .mx-xl-n2 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-xl-n3 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xl-n4 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-xl-n5 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .my-xl-n1 {
    margin-top: -0.375rem !important;
    margin-bottom: -0.375rem !important;
  }
  .my-xl-n2 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-xl-n3 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xl-n4 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-xl-n5 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .mt-xl-n1 {
    margin-top: -0.375rem !important;
  }
  .mt-xl-n2 {
    margin-top: -0.75rem !important;
  }
  .mt-xl-n3 {
    margin-top: -1.5rem !important;
  }
  .mt-xl-n4 {
    margin-top: -2.25rem !important;
  }
  .mt-xl-n5 {
    margin-top: -4.5rem !important;
  }
  .me-xl-n1 {
    margin-right: -0.375rem !important;
  }
  .me-xl-n2 {
    margin-right: -0.75rem !important;
  }
  .me-xl-n3 {
    margin-right: -1.5rem !important;
  }
  .me-xl-n4 {
    margin-right: -2.25rem !important;
  }
  .me-xl-n5 {
    margin-right: -4.5rem !important;
  }
  .mb-xl-n1 {
    margin-bottom: -0.375rem !important;
  }
  .mb-xl-n2 {
    margin-bottom: -0.75rem !important;
  }
  .mb-xl-n3 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xl-n4 {
    margin-bottom: -2.25rem !important;
  }
  .mb-xl-n5 {
    margin-bottom: -4.5rem !important;
  }
  .ms-xl-n1 {
    margin-left: -0.375rem !important;
  }
  .ms-xl-n2 {
    margin-left: -0.75rem !important;
  }
  .ms-xl-n3 {
    margin-left: -1.5rem !important;
  }
  .ms-xl-n4 {
    margin-left: -2.25rem !important;
  }
  .ms-xl-n5 {
    margin-left: -4.5rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.375rem !important;
  }
  .p-xl-2 {
    padding: 0.75rem !important;
  }
  .p-xl-3 {
    padding: 1.5rem !important;
  }
  .p-xl-4 {
    padding: 2.25rem !important;
  }
  .p-xl-5 {
    padding: 4.5rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-xl-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-xl-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-xl-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-xl-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-xl-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-xl-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.375rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.75rem !important;
  }
  .pt-xl-3 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-4 {
    padding-top: 2.25rem !important;
  }
  .pt-xl-5 {
    padding-top: 4.5rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.375rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.75rem !important;
  }
  .pe-xl-3 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-4 {
    padding-right: 2.25rem !important;
  }
  .pe-xl-5 {
    padding-right: 4.5rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.375rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.75rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 2.25rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 4.5rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.375rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.75rem !important;
  }
  .ps-xl-3 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-4 {
    padding-left: 2.25rem !important;
  }
  .ps-xl-5 {
    padding-left: 4.5rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.375rem !important;
  }
  .gap-xl-2 {
    gap: 0.75rem !important;
  }
  .gap-xl-3 {
    gap: 1.5rem !important;
  }
  .gap-xl-4 {
    gap: 2.25rem !important;
  }
  .gap-xl-5 {
    gap: 4.5rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.375rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.75rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 2.25rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 4.5rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.375rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.75rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 2.25rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 4.5rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.375rem !important;
  }
  .m-xxl-2 {
    margin: 0.75rem !important;
  }
  .m-xxl-3 {
    margin: 1.5rem !important;
  }
  .m-xxl-4 {
    margin: 2.25rem !important;
  }
  .m-xxl-5 {
    margin: 4.5rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-xxl-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-xxl-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-xxl-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.375rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.75rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-4 {
    margin-top: 2.25rem !important;
  }
  .mt-xxl-5 {
    margin-top: 4.5rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.375rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.75rem !important;
  }
  .me-xxl-3 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-4 {
    margin-right: 2.25rem !important;
  }
  .me-xxl-5 {
    margin-right: 4.5rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.375rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.75rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 2.25rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 4.5rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.375rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.75rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-4 {
    margin-left: 2.25rem !important;
  }
  .ms-xxl-5 {
    margin-left: 4.5rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .m-xxl-n1 {
    margin: -0.375rem !important;
  }
  .m-xxl-n2 {
    margin: -0.75rem !important;
  }
  .m-xxl-n3 {
    margin: -1.5rem !important;
  }
  .m-xxl-n4 {
    margin: -2.25rem !important;
  }
  .m-xxl-n5 {
    margin: -4.5rem !important;
  }
  .mx-xxl-n1 {
    margin-right: -0.375rem !important;
    margin-left: -0.375rem !important;
  }
  .mx-xxl-n2 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-xxl-n3 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xxl-n4 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-xxl-n5 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .my-xxl-n1 {
    margin-top: -0.375rem !important;
    margin-bottom: -0.375rem !important;
  }
  .my-xxl-n2 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-xxl-n3 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xxl-n4 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-xxl-n5 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .mt-xxl-n1 {
    margin-top: -0.375rem !important;
  }
  .mt-xxl-n2 {
    margin-top: -0.75rem !important;
  }
  .mt-xxl-n3 {
    margin-top: -1.5rem !important;
  }
  .mt-xxl-n4 {
    margin-top: -2.25rem !important;
  }
  .mt-xxl-n5 {
    margin-top: -4.5rem !important;
  }
  .me-xxl-n1 {
    margin-right: -0.375rem !important;
  }
  .me-xxl-n2 {
    margin-right: -0.75rem !important;
  }
  .me-xxl-n3 {
    margin-right: -1.5rem !important;
  }
  .me-xxl-n4 {
    margin-right: -2.25rem !important;
  }
  .me-xxl-n5 {
    margin-right: -4.5rem !important;
  }
  .mb-xxl-n1 {
    margin-bottom: -0.375rem !important;
  }
  .mb-xxl-n2 {
    margin-bottom: -0.75rem !important;
  }
  .mb-xxl-n3 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xxl-n4 {
    margin-bottom: -2.25rem !important;
  }
  .mb-xxl-n5 {
    margin-bottom: -4.5rem !important;
  }
  .ms-xxl-n1 {
    margin-left: -0.375rem !important;
  }
  .ms-xxl-n2 {
    margin-left: -0.75rem !important;
  }
  .ms-xxl-n3 {
    margin-left: -1.5rem !important;
  }
  .ms-xxl-n4 {
    margin-left: -2.25rem !important;
  }
  .ms-xxl-n5 {
    margin-left: -4.5rem !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.375rem !important;
  }
  .p-xxl-2 {
    padding: 0.75rem !important;
  }
  .p-xxl-3 {
    padding: 1.5rem !important;
  }
  .p-xxl-4 {
    padding: 2.25rem !important;
  }
  .p-xxl-5 {
    padding: 4.5rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-xxl-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-xxl-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-xxl-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-xxl-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.375rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.75rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-4 {
    padding-top: 2.25rem !important;
  }
  .pt-xxl-5 {
    padding-top: 4.5rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.375rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.75rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-4 {
    padding-right: 2.25rem !important;
  }
  .pe-xxl-5 {
    padding-right: 4.5rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.375rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.75rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 2.25rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 4.5rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.375rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.75rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-4 {
    padding-left: 2.25rem !important;
  }
  .ps-xxl-5 {
    padding-left: 4.5rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.375rem !important;
  }
  .gap-xxl-2 {
    gap: 0.75rem !important;
  }
  .gap-xxl-3 {
    gap: 1.5rem !important;
  }
  .gap-xxl-4 {
    gap: 2.25rem !important;
  }
  .gap-xxl-5 {
    gap: 4.5rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.375rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.75rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 2.25rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 4.5rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.375rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.75rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 2.25rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 4.5rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.25rem !important;
  }
  .fs-2 {
    font-size: 1.875rem !important;
  }
  .fs-3 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
.custom-accordion .accordion-arrow {
  font-size: 1.2rem;
  position: absolute;
  right: 0;
}
.custom-accordion a.collapsed i.accordion-arrow:before {
  content: "\\f0142";
}

.alert-primary {
  --ct-alert-color: rgb(71.4, 61.6, 154.7);
  --ct-alert-bg: rgba(102, 88, 221, 0.18);
  --ct-alert-border-color: rgba(102, 88, 221, 0.18);
}
.alert-primary .alert-link {
  --ct-alert-color: rgb(71.4, 61.6, 154.7);
}

.alert-secondary {
  --ct-alert-color: rgb(75.6, 81.9, 87.5);
  --ct-alert-bg: rgba(108, 117, 125, 0.18);
  --ct-alert-border-color: rgba(108, 117, 125, 0.18);
}
.alert-secondary .alert-link {
  --ct-alert-color: rgb(75.6, 81.9, 87.5);
}

.alert-success {
  --ct-alert-color: rgb(18.2, 131.6, 109.2);
  --ct-alert-bg: rgba(26, 188, 156, 0.18);
  --ct-alert-border-color: rgba(26, 188, 156, 0.18);
}
.alert-success .alert-link {
  --ct-alert-color: rgb(18.2, 131.6, 109.2);
}

.alert-info {
  --ct-alert-color: rgb(46.9, 133.7, 160.3);
  --ct-alert-bg: rgba(67, 191, 229, 0.18);
  --ct-alert-border-color: rgba(67, 191, 229, 0.18);
}
.alert-info .alert-link {
  --ct-alert-color: rgb(46.9, 133.7, 160.3);
}

.alert-warning {
  --ct-alert-color: rgb(172.9, 128.8, 52.5);
  --ct-alert-bg: rgba(247, 184, 75, 0.18);
  --ct-alert-border-color: rgba(247, 184, 75, 0.18);
}
.alert-warning .alert-link {
  --ct-alert-color: rgb(172.9, 128.8, 52.5);
}

.alert-danger {
  --ct-alert-color: rgb(168.7, 59.5, 75.6);
  --ct-alert-bg: rgba(241, 85, 108, 0.18);
  --ct-alert-border-color: rgba(241, 85, 108, 0.18);
}
.alert-danger .alert-link {
  --ct-alert-color: rgb(168.7, 59.5, 75.6);
}

.alert-light {
  --ct-alert-color: rgb(170.1, 172.9, 174.3);
  --ct-alert-bg: rgba(243, 247, 249, 0.18);
  --ct-alert-border-color: rgba(243, 247, 249, 0.18);
}
.alert-light .alert-link {
  --ct-alert-color: rgb(170.1, 172.9, 174.3);
}

.alert-dark {
  --ct-alert-color: rgb(35, 40.6, 49);
  --ct-alert-bg: rgba(50, 58, 70, 0.18);
  --ct-alert-border-color: rgba(50, 58, 70, 0.18);
}
.alert-dark .alert-link {
  --ct-alert-color: rgb(35, 40.6, 49);
}

.alert-pink {
  --ct-alert-color: rgb(172.2, 79.8, 116.9);
  --ct-alert-bg: rgba(246, 114, 167, 0.18);
  --ct-alert-border-color: rgba(246, 114, 167, 0.18);
}
.alert-pink .alert-link {
  --ct-alert-color: rgb(172.2, 79.8, 116.9);
}

.alert-blue {
  --ct-alert-color: rgb(51.8, 90.3, 148.4);
  --ct-alert-bg: rgba(74, 129, 212, 0.18);
  --ct-alert-border-color: rgba(74, 129, 212, 0.18);
}
.alert-blue .alert-link {
  --ct-alert-color: rgb(51.8, 90.3, 148.4);
}

.alert-outline-primary {
  --ct-alert-color: var(--ct-primary-text);
  --ct-alert-bg: transparent;
  --ct-alert-border-color: var(--ct-primary-border-subtle);
  --ct-alert-link-color: var(--ct-primary-text);
}

.alert-outline-secondary {
  --ct-alert-color: var(--ct-secondary-text);
  --ct-alert-bg: transparent;
  --ct-alert-border-color: var(--ct-secondary-border-subtle);
  --ct-alert-link-color: var(--ct-secondary-text);
}

.alert-outline-success {
  --ct-alert-color: var(--ct-success-text);
  --ct-alert-bg: transparent;
  --ct-alert-border-color: var(--ct-success-border-subtle);
  --ct-alert-link-color: var(--ct-success-text);
}

.alert-outline-info {
  --ct-alert-color: var(--ct-info-text);
  --ct-alert-bg: transparent;
  --ct-alert-border-color: var(--ct-info-border-subtle);
  --ct-alert-link-color: var(--ct-info-text);
}

.alert-outline-warning {
  --ct-alert-color: var(--ct-warning-text);
  --ct-alert-bg: transparent;
  --ct-alert-border-color: var(--ct-warning-border-subtle);
  --ct-alert-link-color: var(--ct-warning-text);
}

.alert-outline-danger {
  --ct-alert-color: var(--ct-danger-text);
  --ct-alert-bg: transparent;
  --ct-alert-border-color: var(--ct-danger-border-subtle);
  --ct-alert-link-color: var(--ct-danger-text);
}

.alert-outline-light {
  --ct-alert-color: var(--ct-light-text);
  --ct-alert-bg: transparent;
  --ct-alert-border-color: var(--ct-light-border-subtle);
  --ct-alert-link-color: var(--ct-light-text);
}

.alert-outline-dark {
  --ct-alert-color: var(--ct-dark-text);
  --ct-alert-bg: transparent;
  --ct-alert-border-color: var(--ct-dark-border-subtle);
  --ct-alert-link-color: var(--ct-dark-text);
}

.alert-outline-pink {
  --ct-alert-color: var(--ct-pink-text);
  --ct-alert-bg: transparent;
  --ct-alert-border-color: var(--ct-pink-border-subtle);
  --ct-alert-link-color: var(--ct-pink-text);
}

.alert-outline-blue {
  --ct-alert-color: var(--ct-blue-text);
  --ct-alert-bg: transparent;
  --ct-alert-border-color: var(--ct-blue-border-subtle);
  --ct-alert-link-color: var(--ct-blue-text);
}

.avatar-xs {
  height: 1.5rem;
  width: 1.5rem;
}

.avatar-sm {
  height: 2.25rem;
  width: 2.25rem;
}

.avatar-md {
  height: 3.5rem;
  width: 3.5rem;
}

.avatar-lg {
  height: 4.5rem;
  width: 4.5rem;
}

.avatar-xl {
  height: 6rem;
  width: 6rem;
}

.avatar-xxl {
  height: 7.5rem;
  width: 7.5rem;
}

.avatar-title {
  align-items: center;
  color: var(--ct-card-bg);
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.avatar-group {
  padding-left: 12px;
}
.avatar-group .avatar-group-item {
  margin: 0 0 10px -12px;
  display: inline-block;
  border: 2px solid var(--ct-card-bg);
  border-radius: 50%;
}

.breadcrumb-item > a {
  color: var(--ct-gray-700);
}
.breadcrumb-item + .breadcrumb-item::before {
  font-family: "Material Design Icons";
}

.btn .mdi:before {
  line-height: initial;
}
.btn .spinner-grow,
.btn .spinner-border {
  vertical-align: middle;
}
.btn-rounded {
  border-radius: 50%;
}
.btn-xs {
  padding: 0.2rem 0.6rem;
  font-size: 0.75rem;
  border-radius: 0.15rem;
}
.btn-label {
  margin: -0.55rem 0.9rem -0.55rem -0.9rem;
  padding: 0.6rem 0.9rem;
}
.btn-label-right {
  margin: -0.45rem -0.9rem -0.45rem 0.9rem;
  padding: 0.45rem 0.9rem;
  display: inline-block;
}
.btn i {
  display: inline-block;
}

button:focus {
  outline: none;
}

.btn-soft-primary {
  --ct-btn-color: #6658dd;
  --ct-btn-bg: rgba(102, 88, 221, 0.1);
  --ct-btn-border-color: transparent;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: #6658dd;
  --ct-btn-hover-border-color: #6658dd;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: #6658dd;
  --ct-btn-active-border-color: #6658dd;
  --ct-btn-disabled-color: #6658dd;
  --ct-btn-disabled-bg: #6658dd;
  --ct-btn-disabled-border-color: #6658dd;
  --ct-btn-focus-shadow-rgb: 0 0 0 \$btn-focus-width rgba(\$bg, 0.5);
}

.btn-soft-secondary {
  --ct-btn-color: #6c757d;
  --ct-btn-bg: rgba(108, 117, 125, 0.1);
  --ct-btn-border-color: transparent;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: #6c757d;
  --ct-btn-hover-border-color: #6c757d;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: #6c757d;
  --ct-btn-active-border-color: #6c757d;
  --ct-btn-disabled-color: #6c757d;
  --ct-btn-disabled-bg: #6c757d;
  --ct-btn-disabled-border-color: #6c757d;
  --ct-btn-focus-shadow-rgb: 0 0 0 \$btn-focus-width rgba(\$bg, 0.5);
}

.btn-soft-success {
  --ct-btn-color: #1abc9c;
  --ct-btn-bg: rgba(26, 188, 156, 0.1);
  --ct-btn-border-color: transparent;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: #1abc9c;
  --ct-btn-hover-border-color: #1abc9c;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: #1abc9c;
  --ct-btn-active-border-color: #1abc9c;
  --ct-btn-disabled-color: #1abc9c;
  --ct-btn-disabled-bg: #1abc9c;
  --ct-btn-disabled-border-color: #1abc9c;
  --ct-btn-focus-shadow-rgb: 0 0 0 \$btn-focus-width rgba(\$bg, 0.5);
}

.btn-soft-info {
  --ct-btn-color: #43bfe5;
  --ct-btn-bg: rgba(67, 191, 229, 0.1);
  --ct-btn-border-color: transparent;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: #43bfe5;
  --ct-btn-hover-border-color: #43bfe5;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: #43bfe5;
  --ct-btn-active-border-color: #43bfe5;
  --ct-btn-disabled-color: #43bfe5;
  --ct-btn-disabled-bg: #43bfe5;
  --ct-btn-disabled-border-color: #43bfe5;
  --ct-btn-focus-shadow-rgb: 0 0 0 \$btn-focus-width rgba(\$bg, 0.5);
}

.btn-soft-warning {
  --ct-btn-color: #f7b84b;
  --ct-btn-bg: rgba(247, 184, 75, 0.1);
  --ct-btn-border-color: transparent;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: #f7b84b;
  --ct-btn-hover-border-color: #f7b84b;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: #f7b84b;
  --ct-btn-active-border-color: #f7b84b;
  --ct-btn-disabled-color: #f7b84b;
  --ct-btn-disabled-bg: #f7b84b;
  --ct-btn-disabled-border-color: #f7b84b;
  --ct-btn-focus-shadow-rgb: 0 0 0 \$btn-focus-width rgba(\$bg, 0.5);
}

.btn-soft-danger {
  --ct-btn-color: #f1556c;
  --ct-btn-bg: rgba(241, 85, 108, 0.1);
  --ct-btn-border-color: transparent;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: #f1556c;
  --ct-btn-hover-border-color: #f1556c;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: #f1556c;
  --ct-btn-active-border-color: #f1556c;
  --ct-btn-disabled-color: #f1556c;
  --ct-btn-disabled-bg: #f1556c;
  --ct-btn-disabled-border-color: #f1556c;
  --ct-btn-focus-shadow-rgb: 0 0 0 \$btn-focus-width rgba(\$bg, 0.5);
}

.btn-soft-light {
  --ct-btn-color: #f3f7f9;
  --ct-btn-bg: rgba(243, 247, 249, 0.1);
  --ct-btn-border-color: transparent;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: #f3f7f9;
  --ct-btn-hover-border-color: #f3f7f9;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: #f3f7f9;
  --ct-btn-active-border-color: #f3f7f9;
  --ct-btn-disabled-color: #f3f7f9;
  --ct-btn-disabled-bg: #f3f7f9;
  --ct-btn-disabled-border-color: #f3f7f9;
  --ct-btn-focus-shadow-rgb: 0 0 0 \$btn-focus-width rgba(\$bg, 0.5);
}

.btn-soft-dark {
  --ct-btn-color: #323a46;
  --ct-btn-bg: rgba(50, 58, 70, 0.1);
  --ct-btn-border-color: transparent;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: #323a46;
  --ct-btn-hover-border-color: #323a46;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: #323a46;
  --ct-btn-active-border-color: #323a46;
  --ct-btn-disabled-color: #323a46;
  --ct-btn-disabled-bg: #323a46;
  --ct-btn-disabled-border-color: #323a46;
  --ct-btn-focus-shadow-rgb: 0 0 0 \$btn-focus-width rgba(\$bg, 0.5);
}

.btn-soft-pink {
  --ct-btn-color: #f672a7;
  --ct-btn-bg: rgba(246, 114, 167, 0.1);
  --ct-btn-border-color: transparent;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: #f672a7;
  --ct-btn-hover-border-color: #f672a7;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: #f672a7;
  --ct-btn-active-border-color: #f672a7;
  --ct-btn-disabled-color: #f672a7;
  --ct-btn-disabled-bg: #f672a7;
  --ct-btn-disabled-border-color: #f672a7;
  --ct-btn-focus-shadow-rgb: 0 0 0 \$btn-focus-width rgba(\$bg, 0.5);
}

.btn-soft-blue {
  --ct-btn-color: #4a81d4;
  --ct-btn-bg: rgba(74, 129, 212, 0.1);
  --ct-btn-border-color: transparent;
  --ct-btn-hover-color: #fff;
  --ct-btn-hover-bg: #4a81d4;
  --ct-btn-hover-border-color: #4a81d4;
  --ct-btn-active-color: #fff;
  --ct-btn-active-bg: #4a81d4;
  --ct-btn-active-border-color: #4a81d4;
  --ct-btn-disabled-color: #4a81d4;
  --ct-btn-disabled-bg: #4a81d4;
  --ct-btn-disabled-border-color: #4a81d4;
  --ct-btn-focus-shadow-rgb: 0 0 0 \$btn-focus-width rgba(\$bg, 0.5);
}

.btn-white,
.btn-outline-light {
  --ct-btn-color: var(--ct-gray-900);
  --ct-btn-hover-bg: var(--ct-gray-100);
  --ct-btn-border-color: var(--ct-gray-300);
  --ct-btn-hover-border-color: var(--ct-gray-100);
}

html[data-bs-theme=dark] .btn-light {
  --ct-btn-color: var(--ct-gray-900);
  --ct-btn-bg: var(--ct-gray-300);
  --ct-btn-border-color: var(--ct-gray-300);
  --ct-btn-hover-color: var(--ct-gray-900);
  --ct-btn-hover-bg: var(--ct-gray-300);
  --ct-btn-hover-border-color: var(--ct-gray-300);
  --ct-btn-active-color: var(--ct-gray-900);
  --ct-btn-active-bg: var(--ct-gray-300);
  --ct-btn-active-border-color: var(--ct-gray-300);
}
html[data-bs-theme=dark] .btn-outline-dark {
  --ct-btn-color: var(--ct-gray-900);
}
html[data-bs-theme=dark] .btn-outline-light,
html[data-bs-theme=dark] .btn-outline-dark {
  --ct-btn-hover-color: var(--ct-gray-900);
  --ct-btn-color: var(--ct-gray-900);
}
html[data-bs-theme=dark] .btn-soft-dark {
  --ct-btn-hover-bg: var(--ct-light);
  --ct-btn-hover-border-color: var(--ct-light);
}

.card {
  box-shadow: var(--ct-box-shadow-sm);
  margin-bottom: 24px;
}

.card-drop {
  font-size: 20px;
  line-height: 0;
  color: inherit;
}

.card-widgets {
  float: right;
  height: 16px;
}
.card-widgets > a {
  color: inherit;
  font-size: 18px;
  display: inline-block;
  line-height: 1;
}
.card-widgets > a.collapsed i:before {
  content: "\\f0415";
}

.card-title,
.card-header {
  margin-top: 0;
}

.card-disabled {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: var(--ct-border-radius);
  background: rgba(var(--ct-secondary-bg-rgb), 0.8);
  cursor: progress;
}
.card-disabled .card-portlets-loader {
  background-color: var(--ct-gray-900);
  animation: rotatebox 1.2s infinite ease-in-out;
  height: 30px;
  width: 30px;
  position: absolute;
  left: 50%;
  top: 50%;
  border-radius: 3px;
  margin-left: -12px;
  margin-top: -12px;
}

@keyframes rotatebox {
  0% {
    transform: perspective(120px) rotateX(0deg) rotateY(0deg);
  }
  50% {
    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
  }
  100% {
    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
  }
}
.header-title {
  font-size: 1rem;
  margin: 0 0 7px 0;
}

.sub-header {
  font-size: 0.875rem;
  margin-bottom: 24px;
  color: var(--ct-gray);
}

.form-check-primary .form-check-input:checked,
.form-radio-primary .form-check-input:checked {
  background-color: #6658dd;
  border-color: #6658dd;
}

.form-check-secondary .form-check-input:checked,
.form-radio-secondary .form-check-input:checked {
  background-color: #6c757d;
  border-color: #6c757d;
}

.form-check-success .form-check-input:checked,
.form-radio-success .form-check-input:checked {
  background-color: #1abc9c;
  border-color: #1abc9c;
}

.form-check-info .form-check-input:checked,
.form-radio-info .form-check-input:checked {
  background-color: #43bfe5;
  border-color: #43bfe5;
}

.form-check-warning .form-check-input:checked,
.form-radio-warning .form-check-input:checked {
  background-color: #f7b84b;
  border-color: #f7b84b;
}

.form-check-danger .form-check-input:checked,
.form-radio-danger .form-check-input:checked {
  background-color: #f1556c;
  border-color: #f1556c;
}

.form-check-light .form-check-input:checked,
.form-radio-light .form-check-input:checked {
  background-color: #f3f7f9;
  border-color: #f3f7f9;
}

.form-check-dark .form-check-input:checked,
.form-radio-dark .form-check-input:checked {
  background-color: #323a46;
  border-color: #323a46;
}

.form-check-pink .form-check-input:checked,
.form-radio-pink .form-check-input:checked {
  background-color: #f672a7;
  border-color: #f672a7;
}

.form-check-blue .form-check-input:checked,
.form-radio-blue .form-check-input:checked {
  background-color: #4a81d4;
  border-color: #4a81d4;
}

.card-radio {
  padding: 0;
}
.card-radio .form-check-label {
  background-color: var(--ct-secondary-bg);
  border: 1px solid var(--ct-border-color);
  border-radius: var(--ct-border-radius);
  padding: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  position: relative;
  padding-right: 32px;
}
.card-radio .form-check-label:hover {
  cursor: pointer;
}
.card-radio .form-check-input {
  display: none;
}
.card-radio .form-check-input:checked + .form-check-label:before {
  content: "\\f05e0";
  font-family: "Material Design Icons";
  position: absolute;
  bottom: 2px;
  right: 6px;
  font-size: 16px;
  color: #6658dd;
}
.card-radio.dark .form-check-input:checked + .form-check-label:before {
  color: #fff;
}

.dropdown-menu {
  padding: 0.3rem;
  box-shadow: var(--ct-box-shadow);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  top: 100%;
}
.dropdown-menu.show {
  top: 100% !important;
}
.dropdown-menu i {
  display: inline-block;
}

.dropdown-menu-end {
  right: 0 !important;
  left: auto !important;
}

.dropdown-menu[data-popper-placement^=right],
.dropdown-menu[data-popper-placement^=top],
.dropdown-menu[data-popper-placement^=left] {
  top: auto !important;
  animation: none !important;
}

@keyframes DropDownSlide {
  100% {
    transform: translateY(0);
  }
  0% {
    transform: translateY(15px);
  }
}
.dropdown-mega {
  position: static !important;
}

.dropdown-megamenu {
  padding: 20px;
  left: 20px !important;
  right: 20px !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-position: right bottom;
  background-repeat: no-repeat;
}

html[dir=rtl] .dropdown-megamenu {
  left: 60px !important;
  right: -20px !important;
}

.megamenu-list li {
  padding: 5px 20px 5px 25px;
  position: relative;
}
.megamenu-list li a {
  color: var(--ct-body-color);
}
.megamenu-list li a:hover {
  color: #6658dd;
}
.megamenu-list li:before {
  content: "\\f0142";
  position: absolute;
  left: 0;
  font-family: "Material Design Icons";
}

html[dir=ltr] .megamenu-list li:before {
  content: "\\f0141";
}

.dropdown-icon-item {
  display: block;
  border-radius: 3px;
  line-height: 34px;
  text-align: center;
  padding: 15px 0 9px;
  display: block;
  border: 1px solid transparent;
  color: var(--ct-body-color);
}
.dropdown-icon-item img {
  height: 24px;
}
.dropdown-icon-item span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dropdown-icon-item:hover {
  background-color: var(--ct-light);
}

@media (min-width: 992px) {
  .dropdown-mega-menu-xl {
    width: 40rem;
  }
  .dropdown-mega-menu-lg {
    width: 26rem;
  }
}
.dropdown-menu {
  box-shadow: var(--ct-box-shadow);
}

.dropdown-header {
  margin-top: 0;
}

.dropdown-menu-animated.dropdown-menu-end[style] {
  left: auto;
  right: 0;
}

.hover-dropdown:hover .dropdown-menu {
  display: block !important;
  top: 100% !important;
}

.dropdown-menu-animated {
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  position: absolute;
  margin: 0;
  z-index: 1000;
}
.dropdown-menu-animated.show {
  top: 100% !important;
}
.dropdown-menu-animated i {
  display: inline-block;
}
.dropdown-menu-animated.dropdown-menu[data-popper-placement^=right], .dropdown-menu-animated.dropdown-menu[data-popper-placement^=top], .dropdown-menu-animated.dropdown-menu[data-popper-placement^=left] {
  top: auto !important;
  animation: none !important;
}

@keyframes DropDownSlide {
  100% {
    transform: translateY(0);
  }
  0% {
    transform: translateY(10px);
  }
}
@media (min-width: 576px) {
  .dropdown-lg {
    width: 320px;
  }
}
.dropdown-toggle.arrow-none:after {
  display: none;
}

.notification-list {
  margin-left: 0;
}
.notification-list .noti-title {
  background-color: transparent;
  padding: 15px 20px;
}
.notification-list .noti-icon-badge {
  position: absolute;
  top: 16px;
  right: 14px;
}
.notification-list .notify-item {
  padding: 10px 20px;
}
.notification-list .notify-item.unread-noti {
  background-color: var(--ct-light);
}
.notification-list .notify-item.read-noti {
  background-color: transparent;
  transition: all 0.2s ease-in-out;
}
.notification-list .notify-item.read-noti:hover {
  background-color: var(--ct-light);
}
.notification-list .notify-item .card-body {
  padding: 14px;
}
.notification-list .notify-item .card-body .noti-close-btn {
  position: absolute;
  top: 3px;
  right: 5px;
}
.notification-list .notify-item .card-body .noti-item-title {
  margin: 0 0 2px;
}
.notification-list .notify-item .card-body .noti-item-title,
.notification-list .notify-item .card-body .noti-item-subtitle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.notification-list .notify-item .notify-icon {
  float: left;
  height: 36px;
  width: 36px;
  line-height: 36px;
  text-align: center;
  border-radius: 50%;
  color: #fff;
}
.notification-list .notify-item .notify-details {
  margin-bottom: 0;
  overflow: hidden;
  margin-left: 45px;
}
.notification-list .notify-item .notify-details b {
  font-weight: 500;
}
.notification-list .notify-item .notify-details small, .notification-list .notify-item .notify-details .small {
  display: block;
}

.profile-dropdown {
  min-width: 170px;
}
.profile-dropdown i,
.profile-dropdown span {
  vertical-align: middle;
}

input.form-control[type=color],
input.form-control[type=range] {
  min-height: 39px;
}

select.form-control:not([size]):not([multiple]) {
  height: calc(1.5em + 0.9rem + 2px);
}

select.form-control-sm:not([size]):not([multiple]) {
  height: calc(1.5em + 0.56rem + 2px);
}

.form-control-light {
  background-color: var(--ct-light) !important;
  border-color: var(--ct-light) !important;
}

.comment-area-box .form-control {
  border-color: var(--ct-gray-300);
  border-radius: var(--ct-border-radius) var(--ct-border-radius) 0 0;
}
.comment-area-box .comment-area-btn {
  background-color: var(--ct-gray-100);
  padding: 10px;
  border: 1px solid var(--ct-gray-300);
  border-top: none;
  border-radius: 0 0 var(--ct-border-radius) var(--ct-border-radius);
}

.search-bar .form-control {
  padding-left: 40px;
  padding-right: 20px;
  border-radius: 30px;
}
.search-bar span {
  position: absolute;
  z-index: 10;
  font-size: 16px;
  line-height: calc(1.5em + 0.9rem + 2px);
  left: 13px;
  top: -2px;
  color: var(--ct-gray);
}

.password-eye {
  cursor: pointer;
}
.password-eye:before {
  font-family: "Material Design Icons";
  content: "\\f06d0";
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  vertical-align: middle;
  line-height: 1.2;
  font-size: 16px;
}

.show-password .password-eye:before {
  content: "\\f06d1";
}

.badge {
  box-shadow: var(--ct-box-shadow);
}

.badge-soft-primary {
  color: #6658dd;
  background-color: rgba(102, 88, 221, 0.18);
  box-shadow: none;
}

.badge-outline-primary {
  color: #6658dd;
  border: 1px solid #6658dd;
  background-color: transparent;
  box-shadow: none;
}

.badge-soft-secondary {
  color: #6c757d;
  background-color: rgba(108, 117, 125, 0.18);
  box-shadow: none;
}

.badge-outline-secondary {
  color: #6c757d;
  border: 1px solid #6c757d;
  background-color: transparent;
  box-shadow: none;
}

.badge-soft-success {
  color: #1abc9c;
  background-color: rgba(26, 188, 156, 0.18);
  box-shadow: none;
}

.badge-outline-success {
  color: #1abc9c;
  border: 1px solid #1abc9c;
  background-color: transparent;
  box-shadow: none;
}

.badge-soft-info {
  color: #43bfe5;
  background-color: rgba(67, 191, 229, 0.18);
  box-shadow: none;
}

.badge-outline-info {
  color: #43bfe5;
  border: 1px solid #43bfe5;
  background-color: transparent;
  box-shadow: none;
}

.badge-soft-warning {
  color: #f7b84b;
  background-color: rgba(247, 184, 75, 0.18);
  box-shadow: none;
}

.badge-outline-warning {
  color: #f7b84b;
  border: 1px solid #f7b84b;
  background-color: transparent;
  box-shadow: none;
}

.badge-soft-danger {
  color: #f1556c;
  background-color: rgba(241, 85, 108, 0.18);
  box-shadow: none;
}

.badge-outline-danger {
  color: #f1556c;
  border: 1px solid #f1556c;
  background-color: transparent;
  box-shadow: none;
}

.badge-soft-light {
  color: #f3f7f9;
  background-color: rgba(243, 247, 249, 0.18);
  box-shadow: none;
}

.badge-outline-light {
  color: #f3f7f9;
  border: 1px solid #f3f7f9;
  background-color: transparent;
  box-shadow: none;
}

.badge-soft-dark {
  color: #323a46;
  background-color: rgba(50, 58, 70, 0.18);
  box-shadow: none;
}

.badge-outline-dark {
  color: #323a46;
  border: 1px solid #323a46;
  background-color: transparent;
  box-shadow: none;
}

.badge-soft-pink {
  color: #f672a7;
  background-color: rgba(246, 114, 167, 0.18);
  box-shadow: none;
}

.badge-outline-pink {
  color: #f672a7;
  border: 1px solid #f672a7;
  background-color: transparent;
  box-shadow: none;
}

.badge-soft-blue {
  color: #4a81d4;
  background-color: rgba(74, 129, 212, 0.18);
  box-shadow: none;
}

.badge-outline-blue {
  color: #4a81d4;
  border: 1px solid #4a81d4;
  background-color: transparent;
  box-shadow: none;
}

.badge {
  vertical-align: middle;
}
.badge.badge-lg {
  padding: 0.5em 1em;
  font-size: 0.85em;
}

.modal-title {
  margin-top: 0;
}

.modal-full-width {
  width: 95%;
  max-width: none;
}

.modal-top {
  margin: 0 auto;
}

.modal-right {
  position: absolute;
  right: 0;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  height: 100%;
  margin: 0;
  background-color: var(--ct-secondary-bg);
  align-content: center;
  transform: translate(25%, 0) !important;
}
.modal-right button.btn-close {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1;
}

.modal.show .modal-right,
.modal.show .modal-left {
  transform: translate(0, 0) !important;
}

.modal-bottom {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-end;
  height: 100%;
  margin: 0 auto;
  align-content: center;
}

.modal-colored-header {
  color: #fff;
  border-radius: 0;
}

.modal-filled {
  color: #fff;
}
.modal-filled .modal-header {
  background-color: rgba(255, 255, 255, 0.07);
}
.modal-filled .modal-header,
.modal-filled .modal-footer {
  border: none;
}

.nav-tabs > li > a,
.nav-pills > li > a {
  color: var(--ct-gray-700);
  font-weight: 600;
}

.nav-pills > a {
  color: var(--ct-gray-700);
  font-weight: 600;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: auto;
}

.navtab-bg .nav-link {
  background-color: var(--ct-light);
  margin: 0 5px;
}

.nav-bordered {
  border-bottom: 2px solid var(--ct-border-color) !important;
}
.nav-bordered .nav-item {
  margin-bottom: -1px;
}
.nav-bordered li a {
  border: 0 !important;
  padding: 10px 20px;
}
.nav-bordered a.active {
  border-bottom: 2px solid #6658dd !important;
}

.tab-content {
  padding: 20px 0 0 0;
}

.pagination-rounded .page-link {
  border-radius: 30px !important;
  margin: 0 3px !important;
  border: none;
}

.popover-header {
  margin-top: 0;
}

.primary-popover {
  --ct-popover-max-width: 200px !important;
  --ct-popover-border-color: var(--ct-primary) !important;
  --ct-popover-header-bg: var(--ct-primary) !important;
  --ct-popover-header-color: var(--ct-white) !important;
  --ct-popover-body-padding-x: 1rem !important;
  --ct-popover-body-padding-y: .5rem !important;
}

.secondary-popover {
  --ct-popover-max-width: 200px !important;
  --ct-popover-border-color: var(--ct-secondary) !important;
  --ct-popover-header-bg: var(--ct-secondary) !important;
  --ct-popover-header-color: var(--ct-white) !important;
  --ct-popover-body-padding-x: 1rem !important;
  --ct-popover-body-padding-y: .5rem !important;
}

.success-popover {
  --ct-popover-max-width: 200px !important;
  --ct-popover-border-color: var(--ct-success) !important;
  --ct-popover-header-bg: var(--ct-success) !important;
  --ct-popover-header-color: var(--ct-white) !important;
  --ct-popover-body-padding-x: 1rem !important;
  --ct-popover-body-padding-y: .5rem !important;
}

.info-popover {
  --ct-popover-max-width: 200px !important;
  --ct-popover-border-color: var(--ct-info) !important;
  --ct-popover-header-bg: var(--ct-info) !important;
  --ct-popover-header-color: var(--ct-white) !important;
  --ct-popover-body-padding-x: 1rem !important;
  --ct-popover-body-padding-y: .5rem !important;
}

.warning-popover {
  --ct-popover-max-width: 200px !important;
  --ct-popover-border-color: var(--ct-warning) !important;
  --ct-popover-header-bg: var(--ct-warning) !important;
  --ct-popover-header-color: var(--ct-white) !important;
  --ct-popover-body-padding-x: 1rem !important;
  --ct-popover-body-padding-y: .5rem !important;
}

.danger-popover {
  --ct-popover-max-width: 200px !important;
  --ct-popover-border-color: var(--ct-danger) !important;
  --ct-popover-header-bg: var(--ct-danger) !important;
  --ct-popover-header-color: var(--ct-white) !important;
  --ct-popover-body-padding-x: 1rem !important;
  --ct-popover-body-padding-y: .5rem !important;
}

.light-popover {
  --ct-popover-max-width: 200px !important;
  --ct-popover-border-color: var(--ct-light) !important;
  --ct-popover-header-bg: var(--ct-light) !important;
  --ct-popover-header-color: var(--ct-white) !important;
  --ct-popover-body-padding-x: 1rem !important;
  --ct-popover-body-padding-y: .5rem !important;
}

.dark-popover {
  --ct-popover-max-width: 200px !important;
  --ct-popover-border-color: var(--ct-dark) !important;
  --ct-popover-header-bg: var(--ct-dark) !important;
  --ct-popover-header-color: var(--ct-white) !important;
  --ct-popover-body-padding-x: 1rem !important;
  --ct-popover-body-padding-y: .5rem !important;
}

.pink-popover {
  --ct-popover-max-width: 200px !important;
  --ct-popover-border-color: var(--ct-pink) !important;
  --ct-popover-header-bg: var(--ct-pink) !important;
  --ct-popover-header-color: var(--ct-white) !important;
  --ct-popover-body-padding-x: 1rem !important;
  --ct-popover-body-padding-y: .5rem !important;
}

.blue-popover {
  --ct-popover-max-width: 200px !important;
  --ct-popover-border-color: var(--ct-blue) !important;
  --ct-popover-header-bg: var(--ct-blue) !important;
  --ct-popover-header-color: var(--ct-white) !important;
  --ct-popover-body-padding-x: 1rem !important;
  --ct-popover-body-padding-y: .5rem !important;
}

@media print {
  .app-menu,
  .end-bar,
  .page-title-box,
  .navbar-custom,
  .footer {
    display: none;
  }
  .card-body,
  .content-page,
  .end-bar,
  .content,
  body {
    padding: 0;
    margin: 0;
  }
  .card {
    box-shadow: none;
  }
}
.progress-sm {
  height: 5px;
}

.progress-md {
  height: 8px;
}

.progress-lg {
  height: 12px;
}

.progress-xl {
  height: 15px;
}

/* Progressbar Vertical */
.progress-vertical {
  min-height: 250px;
  height: 250px;
  width: 10px;
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
}
.progress-vertical .progress-bar {
  width: 100%;
}
.progress-vertical.progress-xl {
  width: 15px;
}
.progress-vertical.progress-lg {
  width: 12px;
}
.progress-vertical.progress-md {
  width: 8px;
}
.progress-vertical.progress-sm {
  width: 5px;
}

.progress-vertical-bottom {
  min-height: 250px;
  height: 250px;
  position: relative;
  width: 10px;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
}
.progress-vertical-bottom .progress-bar {
  width: 100%;
  bottom: 0;
  position: absolute;
}
.progress-vertical-bottom.progress-xl {
  width: 15px;
}
.progress-vertical-bottom.progress-lg {
  width: 12px;
}
.progress-vertical-bottom.progress-md {
  width: 8px;
}
.progress-vertical-bottom.progress-sm {
  width: 5px;
}

html {
  position: relative;
  min-height: 100%;
}

@supports (-webkit-overflow-scrolling: touch) {
  body {
    cursor: pointer;
  }
}
body {
  overflow-x: hidden;
}

button,
a {
  outline: none !important;
}

label {
  font-weight: 600;
}

address.address-lg {
  line-height: 24px;
}

b,
strong {
  font-weight: 700;
}

.ribbon-box {
  position: relative;
  /* Ribbon two */
}
.ribbon-box .ribbon {
  position: relative;
  clear: both;
  padding: 5px 12px;
  margin-bottom: 15px;
  box-shadow: 2px 5px 10px rgba(50, 58, 70, 0.15);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}
.ribbon-box .ribbon:before {
  content: " ";
  border-style: solid;
  border-width: 10px;
  display: block;
  position: absolute;
  bottom: -10px;
  left: 0;
  margin-bottom: -10px;
  z-index: -1;
}
.ribbon-box .ribbon.float-start {
  margin-left: -30px;
  border-radius: 0 3px 3px 0;
}
.ribbon-box .ribbon.float-end {
  margin-right: -30px;
  border-radius: 3px 0 0 3px;
}
.ribbon-box .ribbon.float-end:before {
  right: 0;
}
.ribbon-box .ribbon.float-center span {
  margin: 0 auto 20px auto;
}
.ribbon-box .ribbon-content {
  clear: both;
}
.ribbon-box .ribbon-primary {
  background: #6658dd;
}
.ribbon-box .ribbon-primary:before {
  border-color: rgb(82.5895522388, 66.8134328358, 216.6865671642) transparent transparent;
}
.ribbon-box .ribbon-secondary {
  background: #6c757d;
}
.ribbon-box .ribbon-secondary:before {
  border-color: rgb(96.1802575107, 104.19527897, 111.3197424893) transparent transparent;
}
.ribbon-box .ribbon-success {
  background: #1abc9c;
}
.ribbon-box .ribbon-success:before {
  border-color: rgb(22.9018691589, 165.5981308411, 137.4112149533) transparent transparent;
}
.ribbon-box .ribbon-info {
  background: #43bfe5;
}
.ribbon-box .ribbon-info:before {
  border-color: rgb(44.5981308411, 183.3738317757, 225.9018691589) transparent transparent;
}
.ribbon-box .ribbon-warning {
  background: #f7b84b;
}
.ribbon-box .ribbon-warning:before {
  border-color: rgb(245.914893617, 174.3696808511, 50.585106383) transparent transparent;
}
.ribbon-box .ribbon-danger {
  background: #f1556c;
}
.ribbon-box .ribbon-danger:before {
  border-color: rgb(239.0597826087, 61.4402173913, 87.6277173913) transparent transparent;
}
.ribbon-box .ribbon-light {
  background: #f3f7f9;
}
.ribbon-box .ribbon-light:before {
  border-color: rgb(226, 235.6666666667, 240.5) transparent transparent;
}
.ribbon-box .ribbon-dark {
  background: #323a46;
}
.ribbon-box .ribbon-dark:before {
  border-color: rgb(39.375, 45.675, 55.125) transparent transparent;
}
.ribbon-box .ribbon-pink {
  background: #f672a7;
}
.ribbon-box .ribbon-pink:before {
  border-color: rgb(244.47, 90.03, 152.04) transparent transparent;
}
.ribbon-box .ribbon-blue {
  background: #4a81d4;
}
.ribbon-box .ribbon-blue:before {
  border-color: rgb(53.3950892857, 114.65625, 207.1049107143) transparent transparent;
}
.ribbon-box .ribbon-two {
  position: absolute;
  left: -5px;
  top: -5px;
  z-index: 1;
  overflow: hidden;
  width: 75px;
  height: 75px;
  text-align: right;
}
.ribbon-box .ribbon-two span {
  font-size: 13px;
  color: #fff;
  text-align: center;
  line-height: 20px;
  transform: rotate(-45deg);
  width: 100px;
  display: block;
  box-shadow: 0 0 8px 0 rgba(50, 58, 70, 0.08), 0 1px 0 0 rgba(50, 58, 70, 0.03);
  position: absolute;
  top: 19px;
  left: -21px;
  font-weight: 600;
}
.ribbon-box .ribbon-two span:before {
  content: "";
  position: absolute;
  left: 0;
  top: 100%;
  z-index: -1;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
}
.ribbon-box .ribbon-two span:after {
  content: "";
  position: absolute;
  right: 0;
  top: 100%;
  z-index: -1;
  border-left: 3px solid transparent;
  border-bottom: 3px solid transparent;
}
.ribbon-box .ribbon-two-primary span {
  background: #6658dd;
}
.ribbon-box .ribbon-two-primary span:before {
  border-left: 3px solid rgb(82.5895522388, 66.8134328358, 216.6865671642);
  border-top: 3px solid rgb(82.5895522388, 66.8134328358, 216.6865671642);
}
.ribbon-box .ribbon-two-primary span:after {
  border-right: 3px solid rgb(82.5895522388, 66.8134328358, 216.6865671642);
  border-top: 3px solid rgb(82.5895522388, 66.8134328358, 216.6865671642);
}
.ribbon-box .ribbon-two-secondary span {
  background: #6c757d;
}
.ribbon-box .ribbon-two-secondary span:before {
  border-left: 3px solid rgb(96.1802575107, 104.19527897, 111.3197424893);
  border-top: 3px solid rgb(96.1802575107, 104.19527897, 111.3197424893);
}
.ribbon-box .ribbon-two-secondary span:after {
  border-right: 3px solid rgb(96.1802575107, 104.19527897, 111.3197424893);
  border-top: 3px solid rgb(96.1802575107, 104.19527897, 111.3197424893);
}
.ribbon-box .ribbon-two-success span {
  background: #1abc9c;
}
.ribbon-box .ribbon-two-success span:before {
  border-left: 3px solid rgb(22.9018691589, 165.5981308411, 137.4112149533);
  border-top: 3px solid rgb(22.9018691589, 165.5981308411, 137.4112149533);
}
.ribbon-box .ribbon-two-success span:after {
  border-right: 3px solid rgb(22.9018691589, 165.5981308411, 137.4112149533);
  border-top: 3px solid rgb(22.9018691589, 165.5981308411, 137.4112149533);
}
.ribbon-box .ribbon-two-info span {
  background: #43bfe5;
}
.ribbon-box .ribbon-two-info span:before {
  border-left: 3px solid rgb(44.5981308411, 183.3738317757, 225.9018691589);
  border-top: 3px solid rgb(44.5981308411, 183.3738317757, 225.9018691589);
}
.ribbon-box .ribbon-two-info span:after {
  border-right: 3px solid rgb(44.5981308411, 183.3738317757, 225.9018691589);
  border-top: 3px solid rgb(44.5981308411, 183.3738317757, 225.9018691589);
}
.ribbon-box .ribbon-two-warning span {
  background: #f7b84b;
}
.ribbon-box .ribbon-two-warning span:before {
  border-left: 3px solid rgb(245.914893617, 174.3696808511, 50.585106383);
  border-top: 3px solid rgb(245.914893617, 174.3696808511, 50.585106383);
}
.ribbon-box .ribbon-two-warning span:after {
  border-right: 3px solid rgb(245.914893617, 174.3696808511, 50.585106383);
  border-top: 3px solid rgb(245.914893617, 174.3696808511, 50.585106383);
}
.ribbon-box .ribbon-two-danger span {
  background: #f1556c;
}
.ribbon-box .ribbon-two-danger span:before {
  border-left: 3px solid rgb(239.0597826087, 61.4402173913, 87.6277173913);
  border-top: 3px solid rgb(239.0597826087, 61.4402173913, 87.6277173913);
}
.ribbon-box .ribbon-two-danger span:after {
  border-right: 3px solid rgb(239.0597826087, 61.4402173913, 87.6277173913);
  border-top: 3px solid rgb(239.0597826087, 61.4402173913, 87.6277173913);
}
.ribbon-box .ribbon-two-light span {
  background: #f3f7f9;
}
.ribbon-box .ribbon-two-light span:before {
  border-left: 3px solid rgb(226, 235.6666666667, 240.5);
  border-top: 3px solid rgb(226, 235.6666666667, 240.5);
}
.ribbon-box .ribbon-two-light span:after {
  border-right: 3px solid rgb(226, 235.6666666667, 240.5);
  border-top: 3px solid rgb(226, 235.6666666667, 240.5);
}
.ribbon-box .ribbon-two-dark span {
  background: #323a46;
}
.ribbon-box .ribbon-two-dark span:before {
  border-left: 3px solid rgb(39.375, 45.675, 55.125);
  border-top: 3px solid rgb(39.375, 45.675, 55.125);
}
.ribbon-box .ribbon-two-dark span:after {
  border-right: 3px solid rgb(39.375, 45.675, 55.125);
  border-top: 3px solid rgb(39.375, 45.675, 55.125);
}
.ribbon-box .ribbon-two-pink span {
  background: #f672a7;
}
.ribbon-box .ribbon-two-pink span:before {
  border-left: 3px solid rgb(244.47, 90.03, 152.04);
  border-top: 3px solid rgb(244.47, 90.03, 152.04);
}
.ribbon-box .ribbon-two-pink span:after {
  border-right: 3px solid rgb(244.47, 90.03, 152.04);
  border-top: 3px solid rgb(244.47, 90.03, 152.04);
}
.ribbon-box .ribbon-two-blue span {
  background: #4a81d4;
}
.ribbon-box .ribbon-two-blue span:before {
  border-left: 3px solid rgb(53.3950892857, 114.65625, 207.1049107143);
  border-top: 3px solid rgb(53.3950892857, 114.65625, 207.1049107143);
}
.ribbon-box .ribbon-two-blue span:after {
  border-right: 3px solid rgb(53.3950892857, 114.65625, 207.1049107143);
  border-top: 3px solid rgb(53.3950892857, 114.65625, 207.1049107143);
}

input[data-switch] {
  display: none;
}
input[data-switch] + label {
  width: 56px;
  height: 24px;
  background-color: var(--ct-gray-100);
  background-image: none;
  border-radius: 2rem;
  cursor: pointer;
  display: inline-block;
  text-align: center;
  position: relative;
  transition: all 0.1s ease-in-out;
}
input[data-switch] + label:before {
  color: var(--ct-secondary-bg-subtle);
  content: attr(data-off-label);
  display: block;
  font-family: inherit;
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 24px;
  position: absolute;
  right: 3px;
  margin: 0 0.21667rem;
  top: 0;
  text-align: center;
  min-width: 1.66667rem;
  overflow: hidden;
  transition: all 0.1s ease-in-out;
}
input[data-switch] + label:after {
  content: "";
  position: absolute;
  left: 4px;
  background-color: var(--ct-body-color);
  box-shadow: none;
  border-radius: 2rem;
  height: 18px;
  width: 18px;
  top: 3px;
  transition: all 0.1s ease-in-out;
}
input[data-switch]:checked + label {
  background-color: #6658dd;
}
input[data-switch]:checked + label:before {
  color: #fff;
  content: attr(data-on-label);
  right: auto;
  left: 4px;
}
input[data-switch]:checked + label:after {
  left: 34px;
  background-color: var(--ct-gray-100);
}

input[data-switch=bool] + label {
  background-color: #f1556c;
}

input:disabled + label {
  opacity: 0.5;
  cursor: default;
}

input[data-switch=bool] + label:before,
input[data-switch=bool]:checked + label:before {
  color: #fff !important;
}

input[data-switch=bool] + label:after {
  background-color: var(--ct-gray-100);
}

input[data-switch=primary]:checked + label {
  background-color: #6658dd;
}

input[data-switch=secondary]:checked + label {
  background-color: #6c757d;
}

input[data-switch=success]:checked + label {
  background-color: #1abc9c;
}

input[data-switch=info]:checked + label {
  background-color: #43bfe5;
}

input[data-switch=warning]:checked + label {
  background-color: #f7b84b;
}

input[data-switch=danger]:checked + label {
  background-color: #f1556c;
}

input[data-switch=light]:checked + label {
  background-color: #f3f7f9;
}

input[data-switch=dark]:checked + label {
  background-color: #323a46;
}

input[data-switch=pink]:checked + label {
  background-color: #f672a7;
}

input[data-switch=blue]:checked + label {
  background-color: #4a81d4;
}

.table-centered th,
.table-centered td {
  vertical-align: middle !important;
}

.table .table-user img {
  height: 30px;
  width: 30px;
}
.table .action-icon {
  color: var(--ct-gray-600);
  font-size: 1.2rem;
  display: inline-block;
  padding: 0 3px;
}
.table .action-icon:hover {
  color: var(--ct-gray-700);
}
.table > :not(caption) > * > * {
  background-color: var(--ct-table-bg) !important;
}
.table.table-bordered tbody {
  border-top: 1px solid;
  border-top-color: inherit;
}

.table-sm .action-icon {
  font-size: 1rem;
}

.table-nowrap th,
.table-nowrap td {
  white-space: nowrap;
}

html[data-bs-theme=dark] .table-light {
  --ct-table-bg: #3e4954;
  --ct-table-border-color: var(--ct-border-color);
  color: var(--ct-body-color);
}
html[data-bs-theme=dark] .table-dark {
  --ct-table-bg: var(--ct-light);
}
html[data-bs-theme=dark] .table-dark tbody,
html[data-bs-theme=dark] .table-dark tr {
  border-color: var(--ct-gray-300);
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 10px 0;
}

.font-10 {
  font-size: 10px !important;
}

.font-11 {
  font-size: 11px !important;
}

.font-12 {
  font-size: 12px !important;
}

.font-13 {
  font-size: 13px !important;
}

.font-14 {
  font-size: 14px !important;
}

.font-15 {
  font-size: 15px !important;
}

.font-16 {
  font-size: 16px !important;
}

.font-17 {
  font-size: 17px !important;
}

.font-18 {
  font-size: 18px !important;
}

.font-19 {
  font-size: 19px !important;
}

.font-20 {
  font-size: 20px !important;
}

.font-21 {
  font-size: 21px !important;
}

.font-22 {
  font-size: 22px !important;
}

.font-23 {
  font-size: 23px !important;
}

.font-24 {
  font-size: 24px !important;
}

.font-36 {
  font-size: 36px !important;
}

.font-48 {
  font-size: 48px !important;
}

.fw-medium {
  font-weight: 500;
}

.fw-semibold {
  font-weight: 600;
}

.primary-tooltip {
  --ct-tooltip-bg: var(--ct-primary) !important;
  --ct-tooltip-color: white !important;
}

.secondary-tooltip {
  --ct-tooltip-bg: var(--ct-secondary) !important;
  --ct-tooltip-color: white !important;
}

.success-tooltip {
  --ct-tooltip-bg: var(--ct-success) !important;
  --ct-tooltip-color: white !important;
}

.info-tooltip {
  --ct-tooltip-bg: var(--ct-info) !important;
  --ct-tooltip-color: white !important;
}

.warning-tooltip {
  --ct-tooltip-bg: var(--ct-warning) !important;
  --ct-tooltip-color: white !important;
}

.danger-tooltip {
  --ct-tooltip-bg: var(--ct-danger) !important;
  --ct-tooltip-color: white !important;
}

.light-tooltip {
  --ct-tooltip-bg: var(--ct-light) !important;
  --ct-tooltip-color: white !important;
}

.dark-tooltip {
  --ct-tooltip-bg: var(--ct-dark) !important;
  --ct-tooltip-color: white !important;
}

.pink-tooltip {
  --ct-tooltip-bg: var(--ct-pink) !important;
  --ct-tooltip-color: white !important;
}

.blue-tooltip {
  --ct-tooltip-bg: var(--ct-blue) !important;
  --ct-tooltip-color: white !important;
}

.bg-soft-primary {
  --ct-bg-opacity: 0.25;
  background-color: rgba(var(--ct-primary-rgb), var(--ct-bg-opacity)) !important;
}

.bg-soft-secondary {
  --ct-bg-opacity: 0.25;
  background-color: rgba(var(--ct-secondary-rgb), var(--ct-bg-opacity)) !important;
}

.bg-soft-success {
  --ct-bg-opacity: 0.25;
  background-color: rgba(var(--ct-success-rgb), var(--ct-bg-opacity)) !important;
}

.bg-soft-info {
  --ct-bg-opacity: 0.25;
  background-color: rgba(var(--ct-info-rgb), var(--ct-bg-opacity)) !important;
}

.bg-soft-warning {
  --ct-bg-opacity: 0.25;
  background-color: rgba(var(--ct-warning-rgb), var(--ct-bg-opacity)) !important;
}

.bg-soft-danger {
  --ct-bg-opacity: 0.25;
  background-color: rgba(var(--ct-danger-rgb), var(--ct-bg-opacity)) !important;
}

.bg-soft-light {
  --ct-bg-opacity: 0.25;
  background-color: rgba(var(--ct-light-rgb), var(--ct-bg-opacity)) !important;
}

.bg-soft-dark {
  --ct-bg-opacity: 0.25;
  background-color: rgba(var(--ct-dark-rgb), var(--ct-bg-opacity)) !important;
}

.bg-soft-pink {
  --ct-bg-opacity: 0.25;
  background-color: rgba(var(--ct-pink-rgb), var(--ct-bg-opacity)) !important;
}

.bg-soft-blue {
  --ct-bg-opacity: 0.25;
  background-color: rgba(var(--ct-blue-rgb), var(--ct-bg-opacity)) !important;
}

.bg-ghost {
  --ct-bg-opacity: 0.4;
}

.border-dashed {
  border-style: dashed !important;
}

:not(pre) > code[class*=language-],
pre[class*=language-] {
  background: transparent;
}

code[class*=language-],
pre[class*=language-] {
  color: black;
  background: none;
  text-shadow: 0 1px white;
  font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
  font-size: 1em;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;
  tab-size: 4;
  hyphens: none;
}

pre[class*=language-]::selection,
pre[class*=language-] ::selection,
code[class*=language-]::selection,
code[class*=language-] ::selection {
  text-shadow: none;
  background: #b3d4fc;
}

@media print {
  code[class*=language-],
  pre[class*=language-] {
    text-shadow: none;
  }
}
/* Code blocks */
pre[class*=language-] {
  padding: 1em;
  margin: 0;
  overflow: auto;
}

/* Inline code */
:not(pre) > code[class*=language-] {
  padding: 0.1em;
  border-radius: 0.3em;
  white-space: normal;
}

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: slategray;
}

.token.punctuation {
  color: #6658dd;
}

.token.namespace {
  opacity: 0.7;
}

.token.property,
.token.tag,
.token.boolean,
.token.number,
.token.constant,
.token.symbol,
.token.deleted {
  color: #6658dd;
}

.token.selector,
.token.attr-name,
.token.string,
.token.char,
.token.builtin,
.token.inserted {
  color: #1abc9c;
}

.token.operator,
.token.entity,
.token.url,
.language-css .token.string,
.style .token.string {
  color: #9a6e3a;
  /* This background color was intended by the author of this theme. */
  background: transparent;
}

.token.atrule,
.token.attr-value,
.token.keyword {
  color: #f1556c;
}

.token.function,
.token.class-name {
  color: #dd4a68;
}

.token.regex,
.token.important,
.token.variable {
  color: #e90;
}

.token.important,
.token.bold {
  font-weight: bold;
}

.token.italic {
  font-style: italic;
}

.token.entity {
  cursor: help;
}

code[class*=language-],
pre[class*=language-] {
  color: var(--ct-secondary-color);
  text-shadow: none;
  max-height: 220px;
}

.tab-pane.code {
  position: relative;
}
.tab-pane.code pre::-webkit-scrollbar {
  -webkit-appearance: none;
}
.tab-pane.code pre::-webkit-scrollbar:vertical {
  width: 5px;
  margin-right: 5px;
}
.tab-pane.code pre::-webkit-scrollbar:horizontal {
  height: 5px;
}
.tab-pane.code pre::-webkit-scrollbar-thumb {
  background-color: rgba(var(--ct-dark-rgb), 0.2);
  border-radius: 10px;
  margin-right: 5px;
  border: none;
}
.tab-pane.code pre::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: transparent;
}
.tab-pane.code pre::-webkit-scrollbar-corner {
  background-color: transparent;
}
.tab-pane.code .btn-copy-clipboard {
  position: absolute;
  right: 8px;
  top: 10px;
  background-color: var(--ct-secondary-bg);
  border: 1px solid #1abc9c;
  color: #1abc9c;
  padding: 0.28rem 0.8rem;
  font-size: 0.875rem;
  border-radius: 0.15rem;
  font-weight: 400;
  line-height: 1.5;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
.tab-pane.code .btn-copy-clipboard:hover, .tab-pane.code .btn-copy-clipboard:focus, .tab-pane.code .btn-copy-clipboard:active {
  background-color: #1abc9c;
  color: #fff;
}

.widget-flat {
  position: relative;
  overflow: hidden;
}
.widget-flat i.widget-icon {
  font-size: 36px;
}

.inbox-widget .inbox-item {
  border-bottom: 1px solid var(--ct-gray-300);
  overflow: hidden;
  padding: 0.625rem 0;
  position: relative;
}
.inbox-widget .inbox-item:last-of-type {
  border-bottom: none;
}
.inbox-widget .inbox-item .inbox-item-img {
  display: block;
  float: left;
  margin-right: 15px;
  width: 40px;
}
.inbox-widget .inbox-item .inbox-item-img img {
  width: 40px;
}
.inbox-widget .inbox-item .inbox-item-author {
  display: block;
  margin-bottom: 3px;
}
.inbox-widget .inbox-item .inbox-item-text {
  color: var(--ct-gray);
  display: block;
  font-size: 0.8125rem;
  margin: 0;
  overflow: hidden;
}
.inbox-widget .inbox-item .inbox-item-date {
  color: var(--ct-gray-600);
  font-size: 0.6875rem;
  position: absolute;
  right: 5px;
  top: 10px;
}

/* Chat widget */
.conversation-list {
  list-style: none;
  padding: 0 15px;
}
.conversation-list li {
  margin-bottom: 20px;
}
.conversation-list li .conversation-actions {
  float: right;
  display: none;
}
.conversation-list li:hover .conversation-actions {
  display: block;
}
.conversation-list .chat-avatar {
  float: left;
  text-align: center;
  width: 42px;
}
.conversation-list .chat-avatar img {
  border-radius: 100%;
  width: 100%;
}
.conversation-list .chat-avatar i {
  font-size: 12px;
  font-style: normal;
}
.conversation-list .ctext-wrap {
  background: var(--ct-light);
  border-radius: 3px;
  display: inline-block;
  padding: 12px;
  position: relative;
}
.conversation-list .ctext-wrap i {
  display: block;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  position: relative;
}
.conversation-list .ctext-wrap p {
  margin: 0;
  padding-top: 3px;
}
.conversation-list .ctext-wrap:after {
  left: -10px;
  top: 0;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-top-color: var(--ct-light);
  border-width: 6px;
  margin-right: -1px;
  border-right-color: var(--ct-light);
}
.conversation-list .conversation-text {
  float: left;
  font-size: 12px;
  margin-left: 12px;
  width: 70%;
}
.conversation-list .odd .chat-avatar {
  float: right !important;
}
.conversation-list .odd .conversation-text {
  float: right !important;
  margin-right: 12px;
  text-align: right;
  width: 70% !important;
}
.conversation-list .odd .ctext-wrap {
  background-color: var(--ct-light);
}
.conversation-list .odd .ctext-wrap:after {
  border-color: transparent;
  border-left-color: var(--ct-light);
  border-top-color: var(--ct-light);
  right: -10px !important;
  left: auto;
}
.conversation-list .odd .conversation-actions {
  float: left;
}

.horizontal-steps {
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.horizontal-steps:before {
  content: "";
  display: block;
  position: absolute;
  width: 100%;
  height: 0.2em;
  background-color: var(--ct-gray-100);
}
.horizontal-steps .process-line {
  display: block;
  position: absolute;
  width: 50%;
  height: 0.2em;
  background-color: #6658dd;
}
.horizontal-steps .horizontal-steps-content {
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.horizontal-steps .horizontal-steps-content .step-item {
  display: block;
  position: relative;
  bottom: calc(100% + 1em);
  height: 8px;
  width: 8px;
  margin: 0 2em;
  box-sizing: content-box;
  color: #6658dd;
  background-color: currentColor;
  border: 0.25em solid var(--ct-gray-900);
  border-radius: 50%;
  z-index: 5;
}
.horizontal-steps .horizontal-steps-content .step-item:first-child {
  margin-left: 0;
}
.horizontal-steps .horizontal-steps-content .step-item:last-child {
  margin-right: 0;
  color: #1abc9c;
}
.horizontal-steps .horizontal-steps-content .step-item span {
  position: absolute;
  top: calc(100% + 1em);
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  color: var(--ct-body-color);
}
.horizontal-steps .horizontal-steps-content .step-item.current:before {
  content: "";
  display: block;
  position: absolute;
  top: 48%;
  left: 48%;
  padding: 1em;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  z-index: -1;
  animation-name: animation-steps-current;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-out;
}
.horizontal-steps .horizontal-steps-content .step-item.current span {
  color: #6658dd !important;
}

@keyframes animation-steps-current {
  from {
    transform: translate(-50%, -50%) scale(0);
    opacity: 1;
  }
  to {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0;
  }
}
@media (max-width: 767.98px) {
  .horizontal-steps .horizontal-steps-content .step-item span {
    white-space: inherit;
  }
}
#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--ct-secondary-bg);
  z-index: 9999;
}

#status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}

.spinner {
  margin: 0 auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 5px solid var(--ct-gray-300);
  border-right: 5px solid var(--ct-gray-300);
  border-bottom: 5px solid var(--ct-gray-300);
  border-left: 5px solid var(--ct-primary);
  transform: translateZ(0);
  animation: SpinnerAnimation 1.1s infinite linear;
}

.spinner,
.spinner:after {
  border-radius: 50%;
  width: 40px;
  height: 40px;
}

@keyframes SpinnerAnimation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.hero-section {
  position: relative;
  padding: 80px 0 120px 0;
}
.hero-section:after {
  content: " ";
  background-image: linear-gradient(to bottom, #6379c3, #546ee5);
  position: absolute;
  top: -400px;
  right: 0;
  bottom: 0;
  z-index: -1;
  width: 100%;
  border-radius: 0;
  transform: skewY(-3deg);
}
.hero-section .hero-title {
  line-height: 42px;
}

/*
Template Name: Ubold - Bootstrap 5 Landing Page Tamplat
Author: CoderThemes
Email: coderthemes@gmail.com
File: Main scss file
*/
/*******************************
01.Helper
02.Navbar
03.Home
04.Features
05.Demo
06.Pricing
07.Faqs
08.Testionial
09.Contact
10.Cta
11.Footer
12.Responsive
********************************/
@font-face {
  font-family: "Cerebri Sans,sans-serif";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  src: local("Cerebri-sans Light"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff");
  font-weight: 300;
}
@font-face {
  font-family: "Cerebri Sans,sans-serif";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  src: local("Cerebri-sans Regular"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("woff");
  font-weight: 400;
}
@font-face {
  font-family: "Cerebri Sans,sans-serif";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  src: local("Cerebri-sans Medium"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff");
  font-weight: 500;
}
@font-face {
  font-family: "Cerebri Sans,sans-serif";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  src: local("Cerebri-sans Semibold"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff");
  font-weight: 600;
}
@font-face {
  font-family: "Cerebri Sans,sans-serif";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  src: local("Cerebri-sans Bold"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("woff");
  font-weight: 700;
}
/*******************
    1.Helper
*******************/
h1, .h1,
h2,
.h2,
h3,
.h3,
h4,
.h4,
h5,
.h5,
h6,
.h6 {
  font-family: "Cerebri Sans,sans-serif";
}

h3, .h3 {
  line-height: 30px;
}

a {
  text-decoration: none !important;
  outline: none;
}

p {
  line-height: 1.6;
  font-size: 15px;
}

#landing {
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  background-color: #ffffff;
  /**BACK TO TOP**/
  /******************
      2.Navbar
  *******************/
  /*--- navbar sticky ---*/
  /*******************
      3.Home
  *******************/
  /*******************
      4.features
  ********************/
  /*******************
      5.demo
  ********************/
  /*******************
      6.pricing
  ********************/
  /*******************
      7.faqs
  ********************/
  /*******************
      8.testionial
  ********************/
  /*******************
      9.contact
  ********************/
  /*******************
      10.cta
  ********************/
  /*******************
      11.footer
  ********************/
  /******************
      12.Responsive
  *******************/
}
#landing .section {
  position: relative;
  padding-top: 80px;
  padding-bottom: 80px;
}
#landing .section-sm {
  position: relative;
  padding-top: 60px;
  padding-bottom: 60px;
}
#landing html {
  scroll-padding-top: 59px; /* height of sticky header */
}
#landing .row > * {
  position: relative;
}
@media (min-width: 1400px) {
  #landing .container {
    max-width: 1140px;
  }
}
#landing .bg-gradient {
  background: linear-gradient(to left, #673ab7, #3e1e8c) !important;
}
#landing .back-to-top-btn {
  position: fixed;
  padding: 0px 3px !important;
  bottom: 10px;
  right: 20px;
  display: none;
  text-align: center;
  border-radius: 3px;
}
#landing .back-to-top-btn i {
  font-size: 22px;
  line-height: 28px;
}
#landing .navbar-custom {
  padding: 20px 0px;
  width: 100%;
  border-radius: 0px;
  z-index: 999;
  margin-bottom: 0px;
  transition: all 0.5s ease-in-out;
}
#landing .navbar-custom .logo .logo-light {
  display: inline-block;
}
#landing .navbar-custom .logo .logo-dark {
  display: none;
}
#landing .navbar-custom .navbar-nav .nav-item .nav-link {
  line-height: 26px;
  color: rgba(255, 255, 255, 0.6);
  transition: all 0.4s;
  background-color: transparent !important;
  padding: 6px 10px;
  margin: 0 7px;
  font-weight: 600;
}
#landing .navbar-custom .navbar-nav .nav-item .nav-link:hover, #landing .navbar-custom .navbar-nav .nav-item .nav-link.active, #landing .navbar-custom .navbar-nav .nav-item .nav-link:active {
  color: #ffffff;
}
#landing .navbar-toggler {
  font-size: 24px;
  margin-top: 5px;
  margin-bottom: 0px;
  color: #ffffff;
}
#landing .nav-sticky.navbar-custom {
  margin-top: 0px;
  padding: 10px 0px;
  background-color: #ffffff;
  box-shadow: 0 10px 33px -14px rgba(0, 0, 0, 0.1);
}
#landing .nav-sticky.navbar-custom .logo .logo-dark {
  display: inline-block;
}
#landing .nav-sticky.navbar-custom .logo .logo-light {
  display: none;
}
#landing .nav-sticky.navbar-custom .navbar-nav .nav-item .nav-link {
  color: rgba(40, 40, 46, 0.8);
}
#landing .nav-sticky.navbar-custom .navbar-nav .nav-item .nav-link:hover, #landing .nav-sticky.navbar-custom .navbar-nav .nav-item .nav-link.active, #landing .nav-sticky.navbar-custom .navbar-nav .nav-item .nav-link:active {
  color: #673ab7;
}
#landing .bg-home {
  position: relative;
  padding: 200px 0px 180px 0px;
}
#landing .home-center {
  display: table;
  width: 100%;
  height: 100%;
}
#landing .home-desc-center {
  display: table-cell;
  vertical-align: middle;
}
#landing .home-title .home-desc {
  max-width: 605px;
  font-size: 16px;
}
#landing .home-title .subscribe input {
  padding: 10px 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  height: 43px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.1);
}
#landing .home-title .subscribe input::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.6);
}
#landing .home-title .subscribe input:-moz-placeholder {
  color: rgba(255, 255, 255, 0.6);
}
#landing .home-title .subscribe input::-moz-placeholder {
  color: rgba(255, 255, 255, 0.6);
}
#landing .home-title .subscribe input:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.6);
}
#landing .home-title .subscribe .btn {
  min-height: 43px;
}
#landing .home-title .subscribe .form-control:focus {
  outline: 0;
  box-shadow: none;
}
#landing .home-first-img {
  position: relative;
  z-index: 2;
  max-width: 300px;
}
#landing .home-second-img {
  position: absolute;
  max-width: 250px;
  top: 50%;
  transform: translateY(-50%);
  left: 61px;
  right: 0px;
  z-index: 1;
  opacity: 0.8;
}
#landing .home-third-img {
  position: absolute;
  right: 0px;
  max-width: 200px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.7;
}
#landing .clients {
  position: relative;
  top: -70px;
  box-shadow: 0 10px 35px 0 rgba(152, 166, 173, 0.1);
  border-radius: 8px;
  margin-bottom: -70px;
}
#landing .clients .client-images img {
  margin: 10px auto;
  opacity: 0.7;
}
#landing .features-box {
  padding: 30px;
  text-align: center;
}
#landing .features-box .features-img img {
  max-height: 60px;
}
#landing .features-icon i {
  display: inline-block;
  width: 48px;
  height: 48px;
  background: linear-gradient(to left, #673ab7, #3e1e8c);
  border-radius: 7px;
  line-height: 48px;
}
#landing .demo-box,
#landing .testi-desc {
  box-shadow: 0 10px 35px 0 rgba(152, 166, 173, 0.1);
  border-radius: 7px;
}
#landing .pricing-plan {
  position: relative;
  overflow: hidden;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border-radius: 9px;
  max-width: 370px;
  margin: 0px auto;
}
#landing .pricing-plan .lable {
  background-color: #f9f9f9;
  color: #673ab7;
  font-size: 12px;
  font-weight: 700;
  right: -26px;
  padding: 2px 25px;
  position: absolute;
  text-transform: uppercase;
  top: 20px;
  transform: rotate(45deg);
}
#landing .pricing-plan.active {
  background-image: linear-gradient(120deg, #63e4ec 0%, #3db9dc 100%);
}
#landing .pricing-list {
  padding-left: 20px;
}
#landing .pricing-list li {
  padding-left: 25px;
  position: relative;
}
#landing .pricing-list li i {
  position: absolute;
  left: 0;
}
#landing .bg-shape {
  position: absolute;
  bottom: -1px;
  left: 0px;
  right: 0px;
}
#landing .bg-shape img {
  width: 100%;
}
#landing .faq-question-q-box {
  height: 30px;
  width: 30px;
  color: #673ab7;
  text-align: center;
  border-radius: 50%;
  float: left;
  font-weight: 700;
  line-height: 30px;
  background-color: rgba(103, 58, 183, 0.15);
}
#landing .faq-question {
  margin-top: 0;
  margin-left: 50px;
  font-size: 16px;
}
#landing .faq-answer {
  margin-left: 50px;
  font-size: 14.5px;
}
#landing .testi-box .testi-desc {
  position: relative;
}
#landing .testi-box .testi-desc:before {
  content: "";
  position: absolute;
  width: 14px;
  height: 14px;
  background: #ffffff;
  bottom: -6px;
  left: 48px;
  transform: rotate(45deg);
}
#landing .testi-box .testi-img img {
  max-width: 48px;
}
#landing .custom-form {
  box-shadow: 0 10px 35px 0 rgba(152, 166, 173, 0.1);
  border-radius: 8px;
}
#landing .custom-form .form-group {
  margin-bottom: 1.5rem;
}
#landing .custom-form .form-group .form-control {
  height: 43px;
}
#landing .custom-form .form-group textarea.form-control {
  height: auto;
}
#landing .error {
  margin: 8px 0px;
  display: none;
  color: #ff5d48;
}
#landing #ajaxsuccess {
  font-size: 16px;
  width: 100%;
  display: none;
  clear: both;
  margin: 8px 0px;
}
#landing .error_message {
  padding: 10px;
  margin-bottom: 20px;
  text-align: center;
  color: #806027;
  background-color: #fdf1db;
  border-color: #fdebcd;
  border-radius: 5px;
  font-size: 14px;
}
#landing .contact-loader {
  display: none;
}
#landing #success_page {
  text-align: center;
  margin-bottom: 50px;
}
#landing #success_page h3, #landing #success_page .h3 {
  color: #10c469;
  font-size: 22px;
}
#landing .cta {
  background-image: linear-gradient(120deg, #63e4ec 0%, #3db9dc 100%);
  border-radius: 8px;
}
#landing .footer {
  position: unset;
  height: unset;
  padding: 60px 0px 20px 0px;
}
#landing .footer .footer-list li {
  padding: 7px 0px;
}
#landing .footer .footer-list li a {
  color: rgba(255, 255, 255, 0.4);
  transition: all 0.4s;
}
#landing .footer .footer-list li a:hover {
  color: #ffffff;
}
#landing .footer .social-links li a {
  color: rgba(255, 255, 255, 0.4);
  font-size: 18px;
  padding: 0px 5px;
  transition: all 0.4s;
}
#landing .footer .social-links li a:hover {
  color: #ffffff;
}
@media (min-width: 200px) and (max-width: 1199px) {
  #landing .container-fluid, #landing .container-sm, #landing .container-md, #landing .container-lg, #landing .container-xl, #landing .container-xxl {
    max-width: 95%;
  }
}
@media (min-width: 1200px) {
  #landing .container-fluid, #landing .container-sm, #landing .container-md, #landing .container-lg, #landing .container-xl, #landing .container-xxl {
    max-width: 85%;
  }
}
@media (min-width: 1600px) {
  #landing .container-fluid, #landing .container-sm, #landing .container-md, #landing .container-lg, #landing .container-xl, #landing .container-xxl {
    max-width: 70%;
  }
}
@media (min-width: 200px) and (max-width: 768px) {
  #landing .navbar-custom {
    margin-top: 0px;
    padding: 10px 0px !important;
    background-color: #ffffff !important;
    box-shadow: 0 10px 33px -14px rgba(0, 0, 0, 0.1);
  }
  #landing .navbar-custom .logo .logo-dark {
    display: inline-block;
  }
  #landing .navbar-custom .logo .logo-light {
    display: none;
  }
  #landing .navbar-custom .navbar-nav .nav-item .nav-link {
    transition: all 0.4s;
    color: rgba(40, 40, 46, 0.8) !important;
    margin: 0px;
    padding: 6px 0px;
  }
  #landing .navbar-custom .navbar-nav .nav-item .nav-link:hover, #landing .navbar-custom .navbar-nav .nav-item .nav-link.active, #landing .navbar-custom .navbar-nav .nav-item .nav-link:active {
    color: #673ab7 !important;
  }
  #landing .navbar-toggler {
    font-size: 24px;
    margin-top: 0px;
    margin-bottom: 0px;
    color: #28282e;
  }
  #landing .bg-home {
    padding: 130px 0px 120px 0px;
  }
  #landing .mo-mb-20 {
    margin-bottom: 20px !important;
  }
}
@media (max-width: 425px) {
  #landing .home-title h1, #landing .home-title .h1 {
    font-size: 34px;
  }
  #landing .home-img {
    display: none;
  }
  #landing .features-content,
  #landing .cta,
  #landing .custom-form {
    padding: 24px !important;
  }
  #landing .pull-none {
    float: none !important;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/Landing.scss","webpack://./src/assets/scss/config/default/bootstrap.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./src/assets/scss/config/default/_variables-default.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/scss/custom/components/_accordions.scss","webpack://./src/assets/scss/custom/components/_alert.scss","webpack://./src/assets/scss/custom/components/_avatar.scss","webpack://./src/assets/scss/custom/components/_breadcrumb.scss","webpack://./src/assets/scss/custom/components/_buttons.scss","webpack://./src/assets/scss/custom/components/_card.scss","webpack://./src/assets/scss/custom/components/_custom-forms.scss","webpack://./src/assets/scss/custom/components/_dropdown.scss","webpack://./src/assets/scss/custom/components/_forms.scss","webpack://./src/assets/scss/custom/components/_badge.scss","webpack://./src/assets/scss/custom/components/_modal.scss","webpack://./src/assets/scss/custom/components/_nav.scss","webpack://./src/assets/scss/custom/components/_pagination.scss","webpack://./src/assets/scss/custom/components/_popover.scss","webpack://./src/assets/scss/custom/components/_print.scss","webpack://./src/assets/scss/custom/components/_progress.scss","webpack://./src/assets/scss/custom/components/_reboot.scss","webpack://./src/assets/scss/custom/components/_ribbons.scss","webpack://./src/assets/scss/custom/components/_switch.scss","webpack://./src/assets/scss/custom/components/_tables.scss","webpack://./src/assets/scss/custom/components/_type.scss","webpack://./src/assets/scss/custom/components/_tooltip.scss","webpack://./src/assets/scss/custom/components/_utilities.scss","webpack://./src/assets/scss/custom/components/_docs.scss","webpack://./src/assets/scss/custom/components/_widgets.scss","webpack://./src/assets/scss/custom/components/_steps.scss","webpack://./src/assets/scss/custom/components/_preloader.scss","webpack://./src/assets/scss/custom/components/_hero.scss","webpack://./src/assets/scss/config/landing/app.scss","webpack://./src/assets/scss/config/landing/_variable.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;;CAAA;ACCE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,yBAAA;EAAA,4BAAA;EAAA,2BAAA;EAIA,yCAAA;EAAA,4BAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,wBAAA;EAAA,uBAAA;EAIA,gDAAA;EAAA,iCAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,oDAAA;EAAA,qCAAA;EAAA,oDAAA;EAAA,iDAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EACA,kCAAA;EACA,+BAAA;EAMA,0CAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC+OI,6BALI;EDxOR,0BAAA;EACA,0BAAA;EACA,wBAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,6BAAA;EACA,uCAAA;EACA,uBAAA;EACA,oCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,yBAAA;EACA,mCAAA;EAKA,qBAAA;EACA,+BAAA;EAIE,2BAAA;EAGF,wBAAA;EACA,iCAAA;EACA,0BAAA;EAEA,8CAAA;EACA,sCAAA;EAMA,wBAAA;EACA,yCAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,2BAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,8BAAA;EAGA,qCAAA;EACA,2CAAA;EACA,2CAAA;EACA,iDAAA;EAEA,yBAAA;EAGA,uCAAA;EACA,qDAAA;EAME,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AHYJ;;AG3IA;AAAA;;EA4HE,yCAAA;AHeF;AAAA;;AK5HI;EFuHA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,4BAAA;EACA,sCAAA;EAEA,6BAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,yBAAA;EACA,gCAAA;EAEA,yBAAA;EAEA,2CAAA;EACA,4BAAA;EACA,2CAAA;EACA,wCAAA;EACA,yCAAA;EACA,wCAAA;EACA,wBAAA;EACA,uBAAA;EAEA,6CAAA;EACA,iCAAA;EACA,4CAAA;EACA,0CAAA;EACA,2CAAA;EACA,0CAAA;EACA,6BAAA;EACA,4BAAA;EAEA,kDAAA;EACA,qCAAA;EACA,kDAAA;EACA,8CAAA;EACA,+CAAA;EACA,+CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,wBAAA;EAEA,yCAAA;EACA,+CAAA;EACA,kCAAA;EACA,wCAAA;EAEA,yCAAA;EAEA,0BAAA;EACA,wDAAA;AHFJ;;AM9KA;;;EAGE,sBAAA;ANiLF;;AMlKI;EANJ;IAOM,uBAAA;ENsKJ;AACF;;AMzJA;EACE,SAAA;EACA,uCAAA;EFmPI,mCALI;EE5OR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AN4JF;;AMnJA;EACE,gBAAA;EACA,cC+lB4B;ED9lB5B,SAAA;EACA,qBAAA;EACA,aComB4B;AP9c9B;;AM5IA;EACE,aAAA;EACA,sBCsiB4B;EDriB5B,uCC3EyB;ED6EzB,gBCsiB4B;EDriB5B,gBCsiB4B;EDriB5B,uCAAA;AN8IF;;AM3IA;EF6MQ,gCAAA;AJ9DR;AIpGI;EE3CJ;IFoNQ,kBAAA;EJjEN;AACF;;AM/IA;EFwMQ,mCAAA;AJrDR;AI7GI;EEtCJ;IF+MQ,mBAAA;EJxDN;AACF;;AMnJA;EFmMQ,iCAAA;AJ5CR;AItHI;EEjCJ;IF0MQ,iBAAA;EJ/CN;AACF;;AMvJA;EF0LM,mBALI;AJ1BV;;AMtJA;EFqLM,oBALI;AJtBV;;AMrJA;EFgLM,kBALI;AJlBV;;AM9IA;EACE,aAAA;EACA,mBC8U0B;AP7L5B;;AMvIA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;AN0IF;;AMpIA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ANuIF;;AMjIA;;EAEE,kBAAA;ANoIF;;AMjIA;;;EAGE,aAAA;EACA,mBAAA;ANoIF;;AMjIA;;;;EAIE,gBAAA;ANoIF;;AMjIA;EACE,gBC2a4B;APvS9B;;AM/HA;EACE,qBAAA;EACA,cAAA;ANkIF;;AM5HA;EACE,gBAAA;AN+HF;;AMvHA;;EAEE,mBCoZ4B;AP1R9B;;AMlHA;EFmFM,kBALI;AJwCV;;AM/GA;EACE,iBC8d4B;ED7d5B,wCAAA;ANkHF;;AMzGA;;EAEE,kBAAA;EF+DI,iBALI;EExDR,cAAA;EACA,wBAAA;AN4GF;;AMzGA;EAAM,eAAA;AN6GN;;AM5GA;EAAM,WAAA;ANgHN;;AM3GA;EACE,gEAAA;EACA,qBCgNwC;APlG1C;AM5GE;EACE,mDAAA;AN8GJ;;AMnGE;EAEE,cAAA;EACA,qBAAA;ANqGJ;;AM9FA;;;;EAIE,qCC+T4B;EH1SxB,cALI;AJkFV;;AM1FA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFSI,gBALI;AJ0FV;AMzFE;EFII,kBALI;EEGN,cAAA;EACA,kBAAA;AN2FJ;;AMvFA;EFHM,gBALI;EEUR,2BAAA;EACA,qBAAA;AN0FF;AMvFE;EACE,cAAA;ANyFJ;;AMrFA;EACE,sBAAA;EFfI,gBALI;EEsBR,2BCu2CkC;EDt2ClC,wCC8+BkC;EClxChC,qBAAA;AR6XJ;AMtFE;EACE,UAAA;EFtBE,cALI;AJoHV;;AM9EA;EACE,gBAAA;ANiFF;;AM3EA;;EAEE,sBAAA;AN8EF;;AMtEA;EACE,oBAAA;EACA,yBAAA;ANyEF;;AMtEA;EACE,oBCqW4B;EDpW5B,uBCoW4B;EDnW5B,qBC2T4B;ED1T5B,gBAAA;ANyEF;;AMlEA;EAEE,mBAAA;EACA,gCAAA;ANoEF;;AMjEA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;ANoEF;;AM5DA;EACE,qBAAA;AN+DF;;AMzDA;EAEE,gBAAA;AN2DF;;AMnDA;EACE,UAAA;ANsDF;;AMjDA;;;;;EAKE,SAAA;EACA,oBAAA;EFrHI,kBALI;EE4HR,oBAAA;ANoDF;;AMhDA;;EAEE,oBAAA;ANmDF;;AM9CA;EACE,eAAA;ANiDF;;AM9CA;EAGE,iBAAA;AN+CF;AM5CE;EACE,UAAA;AN8CJ;;AMvCA;EACE,wBAAA;AN0CF;;AMlCA;;;;EAIE,0BAAA;ANqCF;AMlCI;;;;EACE,eAAA;ANuCN;;AMhCA;EACE,UAAA;EACA,kBAAA;ANmCF;;AM9BA;EACE,gBAAA;ANiCF;;AMvBA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AN0BF;;AMlBA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBC2L4B;EHrYtB,iCAAA;EE6MN,oBAAA;ANoBF;AInYI;EEwWJ;IF/LQ,iBAAA;EJ8NN;AACF;AMvBE;EACE,WAAA;ANyBJ;;AMlBA;;;;;;;EAOE,UAAA;ANqBF;;AMlBA;EACE,YAAA;ANqBF;;AMZA;EACE,oBAAA;EACA,6BAAA;ANeF;;AMPA;;;;;;;CAAA;AAWA;EACE,wBAAA;ANOF;;AMFA;EACE,UAAA;ANKF;;AMEA;EACE,aAAA;EACA,0BAAA;ANCF;;AMIA;EACE,qBAAA;ANDF;;AMMA;EACE,SAAA;ANHF;;AMUA;EACE,kBAAA;EACA,eAAA;ANPF;;AMeA;EACE,wBAAA;ANZF;;AMoBA;EACE,wBAAA;ANjBF;;ASnjBA;ELyQM,qBALI;EKlQR,gBFsnB4B;APhE9B;;ASjjBE;ELsQM,iCAAA;EKlQJ,gBFumBkB;EEtmBlB,gBFslB0B;APpC9B;AIndI;EKpGF;IL6QM,eAAA;EJ8SN;AACF;;AS5jBE;ELsQM,iCAAA;EKlQJ,gBFumBkB;EEtmBlB,gBFslB0B;APzB9B;AI9dI;EKpGF;IL6QM,iBAAA;EJyTN;AACF;;ASvkBE;ELsQM,iCAAA;EKlQJ,gBFumBkB;EEtmBlB,gBFslB0B;APd9B;AIzeI;EKpGF;IL6QM,eAAA;EJoUN;AACF;;ASllBE;ELsQM,iCAAA;EKlQJ,gBFumBkB;EEtmBlB,gBFslB0B;APH9B;AIpfI;EKpGF;IL6QM,iBAAA;EJ+UN;AACF;;AS7lBE;ELsQM,iCAAA;EKlQJ,gBFumBkB;EEtmBlB,gBFslB0B;APQ9B;AI/fI;EKpGF;IL6QM,eAAA;EJ0VN;AACF;;ASxmBE;ELsQM,iCAAA;EKlQJ,gBFumBkB;EEtmBlB,gBFslB0B;APmB9B;AI1gBI;EKpGF;IL6QM,iBAAA;EJqWN;AACF;;AS3lBA;ECvDE,eAAA;EACA,gBAAA;AVspBF;;AS3lBA;EC5DE,eAAA;EACA,gBAAA;AV2pBF;;AS7lBA;EACE,qBAAA;ATgmBF;AS9lBE;EACE,oBF+mB0B;APf9B;;AStlBA;ELoNM,kBALI;EK7MR,yBAAA;ATylBF;;ASrlBA;EACE,qBF+UO;EHlIH,qBALI;AJiZV;AStlBE;EACE,gBAAA;ATwlBJ;;ASplBA;EACE,mBAAA;EACA,qBFqUO;EHlIH,kBALI;EK5LR,cFhES;APupBX;ASrlBE;EACE,aAAA;ATulBJ;;AWvrBA;ECIE,eAAA;EAGA,YAAA;AZqrBF;;AWtrBA;EACE,gBJ8gDkC;EI7gDlC,wCJsxCkC;EIrxClC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;AZ8rBF;;AWhrBA;EAEE,qBAAA;AXkrBF;;AW/qBA;EACE,sBAAA;EACA,cAAA;AXkrBF;;AW/qBA;EP+PM,kBALI;EOxPR,gCJigDkC;AP/0BpC;;AaptBE;;;;;;;ECHA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AdiuBF;;Ae3qBI;EF5CE;IACE,gBNwde;EPmQrB;AACF;AejrBI;EF5CE;IACE,gBNwde;EPwQrB;AACF;AetrBI;EF5CE;IACE,gBNwde;EP6QrB;AACF;Ae3rBI;EF5CE;IACE,iBNwde;EPkRrB;AACF;AehsBI;EF5CE;IACE,iBNwde;EPuRrB;AACF;AgB/vBE;ECAA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AjBiwBF;AgBrwBI;ECaF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AjB2vBF;;AiB5sBM;EACE,SAAA;AjB+sBR;;AiB5sBM;EApCJ,cAAA;EACA,WAAA;AjBovBF;;AiBtuBE;EACE,cAAA;EACA,WAAA;AjByuBJ;;AiB3uBE;EACE,cAAA;EACA,UAAA;AjB8uBJ;;AiBhvBE;EACE,cAAA;EACA,qBAAA;AjBmvBJ;;AiBrvBE;EACE,cAAA;EACA,UAAA;AjBwvBJ;;AiB1vBE;EACE,cAAA;EACA,UAAA;AjB6vBJ;;AiB/vBE;EACE,cAAA;EACA,qBAAA;AjBkwBJ;;AiBnuBM;EAhDJ,cAAA;EACA,WAAA;AjBuxBF;;AiBluBU;EAhEN,cAAA;EACA,kBAAA;AjBsyBJ;;AiBvuBU;EAhEN,cAAA;EACA,mBAAA;AjB2yBJ;;AiB5uBU;EAhEN,cAAA;EACA,UAAA;AjBgzBJ;;AiBjvBU;EAhEN,cAAA;EACA,mBAAA;AjBqzBJ;;AiBtvBU;EAhEN,cAAA;EACA,mBAAA;AjB0zBJ;;AiB3vBU;EAhEN,cAAA;EACA,UAAA;AjB+zBJ;;AiBhwBU;EAhEN,cAAA;EACA,mBAAA;AjBo0BJ;;AiBrwBU;EAhEN,cAAA;EACA,mBAAA;AjBy0BJ;;AiB1wBU;EAhEN,cAAA;EACA,UAAA;AjB80BJ;;AiB/wBU;EAhEN,cAAA;EACA,mBAAA;AjBm1BJ;;AiBpxBU;EAhEN,cAAA;EACA,mBAAA;AjBw1BJ;;AiBzxBU;EAhEN,cAAA;EACA,WAAA;AjB61BJ;;AiBtxBY;EAxDV,wBAAA;AjBk1BF;;AiB1xBY;EAxDV,yBAAA;AjBs1BF;;AiB9xBY;EAxDV,gBAAA;AjB01BF;;AiBlyBY;EAxDV,yBAAA;AjB81BF;;AiBtyBY;EAxDV,yBAAA;AjBk2BF;;AiB1yBY;EAxDV,gBAAA;AjBs2BF;;AiB9yBY;EAxDV,yBAAA;AjB02BF;;AiBlzBY;EAxDV,yBAAA;AjB82BF;;AiBtzBY;EAxDV,gBAAA;AjBk3BF;;AiB1zBY;EAxDV,yBAAA;AjBs3BF;;AiB9zBY;EAxDV,yBAAA;AjB03BF;;AiBvzBQ;;EAEE,gBAAA;AjB0zBV;;AiBvzBQ;;EAEE,gBAAA;AjB0zBV;;AiBj0BQ;;EAEE,uBAAA;AjBo0BV;;AiBj0BQ;;EAEE,uBAAA;AjBo0BV;;AiB30BQ;;EAEE,sBAAA;AjB80BV;;AiB30BQ;;EAEE,sBAAA;AjB80BV;;AiBr1BQ;;EAEE,qBAAA;AjBw1BV;;AiBr1BQ;;EAEE,qBAAA;AjBw1BV;;AiB/1BQ;;EAEE,sBAAA;AjBk2BV;;AiB/1BQ;;EAEE,sBAAA;AjBk2BV;;AiBz2BQ;;EAEE,qBAAA;AjB42BV;;AiBz2BQ;;EAEE,qBAAA;AjB42BV;;Aet6BI;EEUE;IACE,SAAA;EjBg6BN;EiB75BI;IApCJ,cAAA;IACA,WAAA;EjBo8BA;EiBt7BA;IACE,cAAA;IACA,WAAA;EjBw7BF;EiB17BA;IACE,cAAA;IACA,UAAA;EjB47BF;EiB97BA;IACE,cAAA;IACA,qBAAA;EjBg8BF;EiBl8BA;IACE,cAAA;IACA,UAAA;EjBo8BF;EiBt8BA;IACE,cAAA;IACA,UAAA;EjBw8BF;EiB18BA;IACE,cAAA;IACA,qBAAA;EjB48BF;EiB76BI;IAhDJ,cAAA;IACA,WAAA;EjBg+BA;EiB36BQ;IAhEN,cAAA;IACA,kBAAA;EjB8+BF;EiB/6BQ;IAhEN,cAAA;IACA,mBAAA;EjBk/BF;EiBn7BQ;IAhEN,cAAA;IACA,UAAA;EjBs/BF;EiBv7BQ;IAhEN,cAAA;IACA,mBAAA;EjB0/BF;EiB37BQ;IAhEN,cAAA;IACA,mBAAA;EjB8/BF;EiB/7BQ;IAhEN,cAAA;IACA,UAAA;EjBkgCF;EiBn8BQ;IAhEN,cAAA;IACA,mBAAA;EjBsgCF;EiBv8BQ;IAhEN,cAAA;IACA,mBAAA;EjB0gCF;EiB38BQ;IAhEN,cAAA;IACA,UAAA;EjB8gCF;EiB/8BQ;IAhEN,cAAA;IACA,mBAAA;EjBkhCF;EiBn9BQ;IAhEN,cAAA;IACA,mBAAA;EjBshCF;EiBv9BQ;IAhEN,cAAA;IACA,WAAA;EjB0hCF;EiBn9BU;IAxDV,cAAA;EjB8gCA;EiBt9BU;IAxDV,wBAAA;EjBihCA;EiBz9BU;IAxDV,yBAAA;EjBohCA;EiB59BU;IAxDV,gBAAA;EjBuhCA;EiB/9BU;IAxDV,yBAAA;EjB0hCA;EiBl+BU;IAxDV,yBAAA;EjB6hCA;EiBr+BU;IAxDV,gBAAA;EjBgiCA;EiBx+BU;IAxDV,yBAAA;EjBmiCA;EiB3+BU;IAxDV,yBAAA;EjBsiCA;EiB9+BU;IAxDV,gBAAA;EjByiCA;EiBj/BU;IAxDV,yBAAA;EjB4iCA;EiBp/BU;IAxDV,yBAAA;EjB+iCA;EiB5+BM;;IAEE,gBAAA;EjB8+BR;EiB3+BM;;IAEE,gBAAA;EjB6+BR;EiBp/BM;;IAEE,uBAAA;EjBs/BR;EiBn/BM;;IAEE,uBAAA;EjBq/BR;EiB5/BM;;IAEE,sBAAA;EjB8/BR;EiB3/BM;;IAEE,sBAAA;EjB6/BR;EiBpgCM;;IAEE,qBAAA;EjBsgCR;EiBngCM;;IAEE,qBAAA;EjBqgCR;EiB5gCM;;IAEE,sBAAA;EjB8gCR;EiB3gCM;;IAEE,sBAAA;EjB6gCR;EiBphCM;;IAEE,qBAAA;EjBshCR;EiBnhCM;;IAEE,qBAAA;EjBqhCR;AACF;AehlCI;EEUE;IACE,SAAA;EjBykCN;EiBtkCI;IApCJ,cAAA;IACA,WAAA;EjB6mCA;EiB/lCA;IACE,cAAA;IACA,WAAA;EjBimCF;EiBnmCA;IACE,cAAA;IACA,UAAA;EjBqmCF;EiBvmCA;IACE,cAAA;IACA,qBAAA;EjBymCF;EiB3mCA;IACE,cAAA;IACA,UAAA;EjB6mCF;EiB/mCA;IACE,cAAA;IACA,UAAA;EjBinCF;EiBnnCA;IACE,cAAA;IACA,qBAAA;EjBqnCF;EiBtlCI;IAhDJ,cAAA;IACA,WAAA;EjByoCA;EiBplCQ;IAhEN,cAAA;IACA,kBAAA;EjBupCF;EiBxlCQ;IAhEN,cAAA;IACA,mBAAA;EjB2pCF;EiB5lCQ;IAhEN,cAAA;IACA,UAAA;EjB+pCF;EiBhmCQ;IAhEN,cAAA;IACA,mBAAA;EjBmqCF;EiBpmCQ;IAhEN,cAAA;IACA,mBAAA;EjBuqCF;EiBxmCQ;IAhEN,cAAA;IACA,UAAA;EjB2qCF;EiB5mCQ;IAhEN,cAAA;IACA,mBAAA;EjB+qCF;EiBhnCQ;IAhEN,cAAA;IACA,mBAAA;EjBmrCF;EiBpnCQ;IAhEN,cAAA;IACA,UAAA;EjBurCF;EiBxnCQ;IAhEN,cAAA;IACA,mBAAA;EjB2rCF;EiB5nCQ;IAhEN,cAAA;IACA,mBAAA;EjB+rCF;EiBhoCQ;IAhEN,cAAA;IACA,WAAA;EjBmsCF;EiB5nCU;IAxDV,cAAA;EjBurCA;EiB/nCU;IAxDV,wBAAA;EjB0rCA;EiBloCU;IAxDV,yBAAA;EjB6rCA;EiBroCU;IAxDV,gBAAA;EjBgsCA;EiBxoCU;IAxDV,yBAAA;EjBmsCA;EiB3oCU;IAxDV,yBAAA;EjBssCA;EiB9oCU;IAxDV,gBAAA;EjBysCA;EiBjpCU;IAxDV,yBAAA;EjB4sCA;EiBppCU;IAxDV,yBAAA;EjB+sCA;EiBvpCU;IAxDV,gBAAA;EjBktCA;EiB1pCU;IAxDV,yBAAA;EjBqtCA;EiB7pCU;IAxDV,yBAAA;EjBwtCA;EiBrpCM;;IAEE,gBAAA;EjBupCR;EiBppCM;;IAEE,gBAAA;EjBspCR;EiB7pCM;;IAEE,uBAAA;EjB+pCR;EiB5pCM;;IAEE,uBAAA;EjB8pCR;EiBrqCM;;IAEE,sBAAA;EjBuqCR;EiBpqCM;;IAEE,sBAAA;EjBsqCR;EiB7qCM;;IAEE,qBAAA;EjB+qCR;EiB5qCM;;IAEE,qBAAA;EjB8qCR;EiBrrCM;;IAEE,sBAAA;EjBurCR;EiBprCM;;IAEE,sBAAA;EjBsrCR;EiB7rCM;;IAEE,qBAAA;EjB+rCR;EiB5rCM;;IAEE,qBAAA;EjB8rCR;AACF;AezvCI;EEUE;IACE,SAAA;EjBkvCN;EiB/uCI;IApCJ,cAAA;IACA,WAAA;EjBsxCA;EiBxwCA;IACE,cAAA;IACA,WAAA;EjB0wCF;EiB5wCA;IACE,cAAA;IACA,UAAA;EjB8wCF;EiBhxCA;IACE,cAAA;IACA,qBAAA;EjBkxCF;EiBpxCA;IACE,cAAA;IACA,UAAA;EjBsxCF;EiBxxCA;IACE,cAAA;IACA,UAAA;EjB0xCF;EiB5xCA;IACE,cAAA;IACA,qBAAA;EjB8xCF;EiB/vCI;IAhDJ,cAAA;IACA,WAAA;EjBkzCA;EiB7vCQ;IAhEN,cAAA;IACA,kBAAA;EjBg0CF;EiBjwCQ;IAhEN,cAAA;IACA,mBAAA;EjBo0CF;EiBrwCQ;IAhEN,cAAA;IACA,UAAA;EjBw0CF;EiBzwCQ;IAhEN,cAAA;IACA,mBAAA;EjB40CF;EiB7wCQ;IAhEN,cAAA;IACA,mBAAA;EjBg1CF;EiBjxCQ;IAhEN,cAAA;IACA,UAAA;EjBo1CF;EiBrxCQ;IAhEN,cAAA;IACA,mBAAA;EjBw1CF;EiBzxCQ;IAhEN,cAAA;IACA,mBAAA;EjB41CF;EiB7xCQ;IAhEN,cAAA;IACA,UAAA;EjBg2CF;EiBjyCQ;IAhEN,cAAA;IACA,mBAAA;EjBo2CF;EiBryCQ;IAhEN,cAAA;IACA,mBAAA;EjBw2CF;EiBzyCQ;IAhEN,cAAA;IACA,WAAA;EjB42CF;EiBryCU;IAxDV,cAAA;EjBg2CA;EiBxyCU;IAxDV,wBAAA;EjBm2CA;EiB3yCU;IAxDV,yBAAA;EjBs2CA;EiB9yCU;IAxDV,gBAAA;EjBy2CA;EiBjzCU;IAxDV,yBAAA;EjB42CA;EiBpzCU;IAxDV,yBAAA;EjB+2CA;EiBvzCU;IAxDV,gBAAA;EjBk3CA;EiB1zCU;IAxDV,yBAAA;EjBq3CA;EiB7zCU;IAxDV,yBAAA;EjBw3CA;EiBh0CU;IAxDV,gBAAA;EjB23CA;EiBn0CU;IAxDV,yBAAA;EjB83CA;EiBt0CU;IAxDV,yBAAA;EjBi4CA;EiB9zCM;;IAEE,gBAAA;EjBg0CR;EiB7zCM;;IAEE,gBAAA;EjB+zCR;EiBt0CM;;IAEE,uBAAA;EjBw0CR;EiBr0CM;;IAEE,uBAAA;EjBu0CR;EiB90CM;;IAEE,sBAAA;EjBg1CR;EiB70CM;;IAEE,sBAAA;EjB+0CR;EiBt1CM;;IAEE,qBAAA;EjBw1CR;EiBr1CM;;IAEE,qBAAA;EjBu1CR;EiB91CM;;IAEE,sBAAA;EjBg2CR;EiB71CM;;IAEE,sBAAA;EjB+1CR;EiBt2CM;;IAEE,qBAAA;EjBw2CR;EiBr2CM;;IAEE,qBAAA;EjBu2CR;AACF;Ael6CI;EEUE;IACE,SAAA;EjB25CN;EiBx5CI;IApCJ,cAAA;IACA,WAAA;EjB+7CA;EiBj7CA;IACE,cAAA;IACA,WAAA;EjBm7CF;EiBr7CA;IACE,cAAA;IACA,UAAA;EjBu7CF;EiBz7CA;IACE,cAAA;IACA,qBAAA;EjB27CF;EiB77CA;IACE,cAAA;IACA,UAAA;EjB+7CF;EiBj8CA;IACE,cAAA;IACA,UAAA;EjBm8CF;EiBr8CA;IACE,cAAA;IACA,qBAAA;EjBu8CF;EiBx6CI;IAhDJ,cAAA;IACA,WAAA;EjB29CA;EiBt6CQ;IAhEN,cAAA;IACA,kBAAA;EjBy+CF;EiB16CQ;IAhEN,cAAA;IACA,mBAAA;EjB6+CF;EiB96CQ;IAhEN,cAAA;IACA,UAAA;EjBi/CF;EiBl7CQ;IAhEN,cAAA;IACA,mBAAA;EjBq/CF;EiBt7CQ;IAhEN,cAAA;IACA,mBAAA;EjBy/CF;EiB17CQ;IAhEN,cAAA;IACA,UAAA;EjB6/CF;EiB97CQ;IAhEN,cAAA;IACA,mBAAA;EjBigDF;EiBl8CQ;IAhEN,cAAA;IACA,mBAAA;EjBqgDF;EiBt8CQ;IAhEN,cAAA;IACA,UAAA;EjBygDF;EiB18CQ;IAhEN,cAAA;IACA,mBAAA;EjB6gDF;EiB98CQ;IAhEN,cAAA;IACA,mBAAA;EjBihDF;EiBl9CQ;IAhEN,cAAA;IACA,WAAA;EjBqhDF;EiB98CU;IAxDV,cAAA;EjBygDA;EiBj9CU;IAxDV,wBAAA;EjB4gDA;EiBp9CU;IAxDV,yBAAA;EjB+gDA;EiBv9CU;IAxDV,gBAAA;EjBkhDA;EiB19CU;IAxDV,yBAAA;EjBqhDA;EiB79CU;IAxDV,yBAAA;EjBwhDA;EiBh+CU;IAxDV,gBAAA;EjB2hDA;EiBn+CU;IAxDV,yBAAA;EjB8hDA;EiBt+CU;IAxDV,yBAAA;EjBiiDA;EiBz+CU;IAxDV,gBAAA;EjBoiDA;EiB5+CU;IAxDV,yBAAA;EjBuiDA;EiB/+CU;IAxDV,yBAAA;EjB0iDA;EiBv+CM;;IAEE,gBAAA;EjBy+CR;EiBt+CM;;IAEE,gBAAA;EjBw+CR;EiB/+CM;;IAEE,uBAAA;EjBi/CR;EiB9+CM;;IAEE,uBAAA;EjBg/CR;EiBv/CM;;IAEE,sBAAA;EjBy/CR;EiBt/CM;;IAEE,sBAAA;EjBw/CR;EiB//CM;;IAEE,qBAAA;EjBigDR;EiB9/CM;;IAEE,qBAAA;EjBggDR;EiBvgDM;;IAEE,sBAAA;EjBygDR;EiBtgDM;;IAEE,sBAAA;EjBwgDR;EiB/gDM;;IAEE,qBAAA;EjBihDR;EiB9gDM;;IAEE,qBAAA;EjBghDR;AACF;Ae3kDI;EEUE;IACE,SAAA;EjBokDN;EiBjkDI;IApCJ,cAAA;IACA,WAAA;EjBwmDA;EiB1lDA;IACE,cAAA;IACA,WAAA;EjB4lDF;EiB9lDA;IACE,cAAA;IACA,UAAA;EjBgmDF;EiBlmDA;IACE,cAAA;IACA,qBAAA;EjBomDF;EiBtmDA;IACE,cAAA;IACA,UAAA;EjBwmDF;EiB1mDA;IACE,cAAA;IACA,UAAA;EjB4mDF;EiB9mDA;IACE,cAAA;IACA,qBAAA;EjBgnDF;EiBjlDI;IAhDJ,cAAA;IACA,WAAA;EjBooDA;EiB/kDQ;IAhEN,cAAA;IACA,kBAAA;EjBkpDF;EiBnlDQ;IAhEN,cAAA;IACA,mBAAA;EjBspDF;EiBvlDQ;IAhEN,cAAA;IACA,UAAA;EjB0pDF;EiB3lDQ;IAhEN,cAAA;IACA,mBAAA;EjB8pDF;EiB/lDQ;IAhEN,cAAA;IACA,mBAAA;EjBkqDF;EiBnmDQ;IAhEN,cAAA;IACA,UAAA;EjBsqDF;EiBvmDQ;IAhEN,cAAA;IACA,mBAAA;EjB0qDF;EiB3mDQ;IAhEN,cAAA;IACA,mBAAA;EjB8qDF;EiB/mDQ;IAhEN,cAAA;IACA,UAAA;EjBkrDF;EiBnnDQ;IAhEN,cAAA;IACA,mBAAA;EjBsrDF;EiBvnDQ;IAhEN,cAAA;IACA,mBAAA;EjB0rDF;EiB3nDQ;IAhEN,cAAA;IACA,WAAA;EjB8rDF;EiBvnDU;IAxDV,cAAA;EjBkrDA;EiB1nDU;IAxDV,wBAAA;EjBqrDA;EiB7nDU;IAxDV,yBAAA;EjBwrDA;EiBhoDU;IAxDV,gBAAA;EjB2rDA;EiBnoDU;IAxDV,yBAAA;EjB8rDA;EiBtoDU;IAxDV,yBAAA;EjBisDA;EiBzoDU;IAxDV,gBAAA;EjBosDA;EiB5oDU;IAxDV,yBAAA;EjBusDA;EiB/oDU;IAxDV,yBAAA;EjB0sDA;EiBlpDU;IAxDV,gBAAA;EjB6sDA;EiBrpDU;IAxDV,yBAAA;EjBgtDA;EiBxpDU;IAxDV,yBAAA;EjBmtDA;EiBhpDM;;IAEE,gBAAA;EjBkpDR;EiB/oDM;;IAEE,gBAAA;EjBipDR;EiBxpDM;;IAEE,uBAAA;EjB0pDR;EiBvpDM;;IAEE,uBAAA;EjBypDR;EiBhqDM;;IAEE,sBAAA;EjBkqDR;EiB/pDM;;IAEE,sBAAA;EjBiqDR;EiBxqDM;;IAEE,qBAAA;EjB0qDR;EiBvqDM;;IAEE,qBAAA;EjByqDR;EiBhrDM;;IAEE,sBAAA;EjBkrDR;EiB/qDM;;IAEE,sBAAA;EjBirDR;EiBxrDM;;IAEE,qBAAA;EjB0rDR;EiBvrDM;;IAEE,qBAAA;EjByrDR;AACF;AkB/yDA;EACE,sCAAA;EACA,0BAAA;EACA,+CAAA;EACA,iCAAA;EACA,8CAAA;EACA,2CAAA;EACA,6CAAA;EACA,wCAAA;EACA,4CAAA;EACA,yCAAA;EAEA,WAAA;EACA,qBXsZO;EWrZP,4BAAA;EACA,mBXorB4B;EWnrB5B,0CAAA;AlBgzDF;AkBzyDE;EACE,wBAAA;EACA,oCAAA;EACA,2CX8rB0B;EW7rB1B,wDAAA;AlB2yDJ;AkBxyDE;EACE,uBAAA;AlB0yDJ;AkBvyDE;EACE,sBAAA;AlByyDJ;;AkBryDA;EACE,yEAAA;AlBwyDF;;AkBjyDA;EACE,iBAAA;AlBoyDF;;AkB1xDE;EACE,sBAAA;AlB6xDJ;;AkB9wDE;EACE,sCAAA;AlBixDJ;AkB9wDI;EACE,sCAAA;AlBgxDN;;AkBzwDE;EACE,sBAAA;AlB4wDJ;AkBzwDE;EACE,mBAAA;AlB2wDJ;;AkBjwDE;EACE,gDAAA;EACA,oCAAA;AlBowDJ;;AkB9vDE;EACE,gDAAA;EACA,oCAAA;AlBiwDJ;;AkBzvDA;EACE,+CAAA;EACA,mCAAA;AlB4vDF;;AkBpvDE;EACE,8CAAA;EACA,kCAAA;AlBuvDJ;;AmB53DE;EAOE,yBAAA;EACA,uCAAA;EACA,oDAAA;EACA,mDAAA;EACA,iCAAA;EACA,iDAAA;EACA,gCAAA;EACA,iDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AnBw3DJ;;AmB14DE;EAOE,yBAAA;EACA,qCAAA;EACA,mDAAA;EACA,oDAAA;EACA,iCAAA;EACA,gDAAA;EACA,gCAAA;EACA,kDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AnBs4DJ;;AmBx5DE;EAOE,yBAAA;EACA,uCAAA;EACA,oDAAA;EACA,kDAAA;EACA,iCAAA;EACA,iDAAA;EACA,gCAAA;EACA,gDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AnBo5DJ;;AmBt6DE;EAOE,yBAAA;EACA,uCAAA;EACA,oDAAA;EACA,qDAAA;EACA,iCAAA;EACA,iDAAA;EACA,gCAAA;EACA,mDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AnBk6DJ;;AmBp7DE;EAOE,yBAAA;EACA,qCAAA;EACA,mDAAA;EACA,oDAAA;EACA,iCAAA;EACA,gDAAA;EACA,gCAAA;EACA,kDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AnBg7DJ;;AmBl8DE;EAOE,yBAAA;EACA,qCAAA;EACA,mDAAA;EACA,oDAAA;EACA,iCAAA;EACA,gDAAA;EACA,gCAAA;EACA,kDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AnB87DJ;;AmBh9DE;EAOE,yBAAA;EACA,sBAAA;EACA,iDAAA;EACA,qDAAA;EACA,iCAAA;EACA,8CAAA;EACA,gCAAA;EACA,mDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AnB48DJ;;AmB99DE;EAOE,sBAAA;EACA,sBAAA;EACA,8CAAA;EACA,kDAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnB09DJ;;AkBh1DI;EACE,gBAAA;EACA,iCAAA;AlBm1DN;;Aev6DI;EGkFA;IACE,gBAAA;IACA,iCAAA;ElBy1DJ;AACF;Ae96DI;EGkFA;IACE,gBAAA;IACA,iCAAA;ElB+1DJ;AACF;Aep7DI;EGkFA;IACE,gBAAA;IACA,iCAAA;ElBq2DJ;AACF;Ae17DI;EGkFA;IACE,gBAAA;IACA,iCAAA;ElB22DJ;AACF;Aeh8DI;EGkFA;IACE,gBAAA;IACA,iCAAA;ElBi3DJ;AACF;AoB9gEA;EACE,qBb80BsC;APksCxC;;AoBvgEA;EACE,gCAAA;EACA,mCAAA;EACA,gBAAA;EhBoRI,kBALI;EgB3QR,gBb6kB4B;AP27C9B;;AoBpgEA;EACE,+BAAA;EACA,kCAAA;EhB0QI,qBALI;AJmwDV;;AoBpgEA;EACE,gCAAA;EACA,mCAAA;EhBoQI,sBALI;AJywDV;;AqBriEA;EACE,mBds0BsC;EHtiBlC,kBALI;EiBvRR,qBdipB4B;APq5C9B;;AsB3iEA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;ElB8RI,mBALI;EkBtRR,gBfglB4B;Ee/kB5B,gBfulB4B;EetlB5B,2Bfm2BsC;Eel2BtC,wCf61BsC;Ee51BtC,4BAAA;EACA,wCAAA;EACA,gBAAA;EdGE,sCAAA;EeHE,wEDMJ;AtByiEF;AuB3iEM;EDhBN;ICiBQ,gBAAA;EvB8iEN;AACF;AsB5iEE;EACE,gBAAA;AtB8iEJ;AsB5iEI;EACE,eAAA;AtB8iEN;AsBziEE;EACE,2Bf60BoC;Ee50BpC,wCfu0BoC;Eet0BpC,oCfq1BoC;Eep1BpC,UAAA;EAKE,gBfk1BkC;APqtCxC;AsBhiEE;EAEE,aAAA;AtBiiEJ;AsB5hEE;EACE,cAAA;EACA,UAAA;AtB8hEJ;AsB1hEE;EACE,gCf+zBoC;Ee7zBpC,UAAA;AtB2hEJ;AsBnhEE;EAEE,oDfiyBoC;Ee9xBpC,UAAA;AtBkhEJ;AsB9gEE;EACE,uBAAA;EACA,wBAAA;EACA,yBfwqB0B;EevqB1B,2BfyxBoC;EiB32BtC,oCjB4gCgC;Eex7B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BfqxBoC;EepxBpC,gBAAA;EC7EE,qID8EF;AtBghEJ;AuB1lEM;ED8DJ;IC7DM,gBAAA;EvB6lEN;AACF;AsBlhEE;EACE,oCf+6B8B;APqmClC;;AsB3gEA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBfkf4B;Eejf5B,2Bf8wBsC;Ee7wBtC,6BAAA;EACA,yBAAA;EACA,mBAAA;AtB8gEF;AsB5gEE;EACE,UAAA;AtB8gEJ;AsB3gEE;EAEE,gBAAA;EACA,eAAA;AtB4gEJ;;AsBjgEA;EACE,uCf+vBsC;Ee9vBtC,uBAAA;ElB2JI,sBALI;EI7QN,yCAAA;AR6nEJ;AsBlgEE;EACE,uBAAA;EACA,wBAAA;EACA,yBfwnB0B;AP44C9B;;AsBhgEA;EACE,oCfmvBsC;EelvBtC,oBAAA;ElB8II,qBALI;EI7QN,yCAAA;ARyoEJ;AsBjgEE;EACE,oBAAA;EACA,qBAAA;EACA,uBf+mB0B;APo5C9B;;AsB3/DE;EACE,sCfguBoC;AP8xCxC;AsB3/DE;EACE,uCf6tBoC;APgyCxC;AsB1/DE;EACE,oCf0tBoC;APkyCxC;;AsBv/DA;EACE,WfwtBsC;EevtBtC,kCfitBsC;EehtBtC,gBfqkB4B;APq7C9B;AsBx/DE;EACE,eAAA;AtB0/DJ;AsBv/DE;EACE,oBAAA;Ed3KA,sCAAA;ARqqEJ;AsBt/DE;Ed/KE,sCAAA;ARwqEJ;AsBr/DE;EAAoB,mCfksBkB;APszCxC;AsBv/DE;EAAoB,gCfksBkB;APwzCxC;;AyB5rEA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,sCAAA;EACA,sCAAA;ErB0RI,mBALI;EqBlRR,gBlB4kB4B;EkB3kB5B,gBlBmlB4B;EkBllB5B,2BlB+1BsC;EkB91BtC,wClBy1BsC;EkBx1BtC,mFAAA;EACA,4BAAA;EACA,wClBs8BkC;EkBr8BlC,0BlBs8BkC;EkBr8BlC,wCAAA;EjBHE,sCAAA;EeHE,wEESJ;EACA,gBAAA;AzB4rEF;AuBlsEM;EEfN;IFgBQ,gBAAA;EvBqsEN;AACF;AyB/rEE;EACE,oClB41BoC;EkB31BpC,UAAA;EAKE,gBlBu8B4B;APsvClC;AyBzrEE;EAEE,qBlBs6BgC;EkBr6BhC,sBAAA;AzB0rEJ;AyBvrEE;EAEE,oDlB6zBoC;AP23CxC;AyBnrEE;EACE,kBAAA;EACA,uCAAA;AzBqrEJ;;AyBjrEA;EACE,oBlB6sB4B;EkB5sB5B,uBlB4sB4B;EkB3sB5B,oBlB4sB4B;EHpexB,sBALI;EI7QN,yCAAA;ARguEJ;;AyBjrEA;EACE,mBlBysB4B;EkBxsB5B,sBlBwsB4B;EkBvsB5B,kBlBwsB4B;EHxexB,qBALI;EI7QN,yCAAA;ARwuEJ;;AyB/qEI;EACE,gEAAA;AzBkrEN;;A0B3vEA;EACE,cAAA;EACA,qBnB44BwC;EmB34BxC,qBnB44BwC;EmB34BxC,gBnB44BwC;APk3C1C;A0B5vEE;EACE,WAAA;EACA,qBAAA;A1B8vEJ;;A0B1vEA;EACE,sBnBk4BwC;EmBj4BxC,eAAA;EACA,iBAAA;A1B6vEF;A0B3vEE;EACE,YAAA;EACA,sBAAA;EACA,cAAA;A1B6vEJ;;A0BzvEA;EACE,0CAAA;EAEA,cnBk3BwC;EmBj3BxC,enBi3BwC;EmBh3BxC,oBAAA;EACA,mBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,wCnBo3BwC;EmBn3BxC,gBAAA;EACA,yBAAA;EH1BI,mJG2BJ;A1B2vEF;AuBlxEM;EGQN;IHPQ,gBAAA;EvBqxEN;AACF;A0B9vEE;ElB1BE,qBAAA;AR2xEJ;A0B7vEE;EAEE,kBnB22BsC;APm5C1C;A0B3vEE;EACE,uBnBk2BsC;AP25C1C;A0B1vEE;EACE,oCnB8zBoC;EmB7zBpC,UAAA;EACA,gBnBm2BsC;APy5C1C;A0BzvEE;EACE,yBnBLS;EmBMT,qBnBNS;APiwEb;A0BzvEI;EAII,iEAAA;A1BwvER;A0BpvEI;EAII,iEAAA;A1BmvER;A0B9uEE;EACE,yBnB1BS;EmB2BT,qBnB3BS;EmBgCP,iEAAA;A1B4uEN;A0BxuEE;EACE,oBAAA;EACA,YAAA;EACA,YnB00BuC;APg6C3C;A0BnuEI;EACE,eAAA;EACA,YnBi0BqC;APo6C3C;;A0BvtEA;EACE,mBnB4zBgC;AP85ClC;A0BxtEE;EACE,4DAAA;EAEA,UnBszB8B;EmBrzB9B,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBhHA,kBAAA;EeHE,iDGqHF;A1BytEJ;AuB10EM;EGyGJ;IHxGM,gBAAA;EvB60EN;AACF;A0B5tEI;EACE,4DAAA;A1B8tEN;A0B3tEI;EACE,iCnBqzB4B;EmBhzB1B,4DAAA;A1BytER;A0BptEE;EACE,oBnBgyB8B;EmB/xB9B,eAAA;A1BstEJ;A0BptEI;EACE,oBAAA;EACA,cAAA;A1BstEN;;A0BjtEA;EACE,qBAAA;EACA,kBnB8wBgC;APs8ClC;;A0BjtEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A1BotEF;A0BhtEI;EACE,oBAAA;EACA,YAAA;EACA,anB8nBwB;APolD9B;;A0B3sEI;EACE,4DAAA;A1B8sEN;;A2Bh4EA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;A3Bm4EF;A2Bj4EE;EACE,UAAA;A3Bm4EJ;A2B/3EI;EAA0B,mCpBq/Ba;AP64C3C;A2Bj4EI;EAA0B,mCpBo/Ba;APg5C3C;A2Bj4EE;EACE,SAAA;A3Bm4EJ;A2Bh4EE;EACE,WpBs+BuC;EoBr+BvC,YpBq+BuC;EoBp+BvC,oBAAA;EHzBF,yBjBwDW;EoB7BT,SpBq+BuC;ECj/BvC,mBAAA;EeHE,oHIkBF;EJlBE,4GIkBF;EACA,gBAAA;A3Bi4EJ;AuBh5EM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;EvBm5EN;AACF;A2Bp4EI;EHjCF,0CjBqgCyC;APm6C3C;A2Bl4EE;EACE,WpB+8B8B;EoB98B9B,cpB+8B8B;EoB98B9B,kBAAA;EACA,epB88B8B;EoB78B9B,oCpB88B8B;EoB78B9B,yBAAA;EnB7BA,mBAAA;ARk6EJ;A2Bh4EE;EACE,WpB28BuC;EoB18BvC,YpB08BuC;EiB7/BzC,yBjBwDW;EoBHT,SpB28BuC;ECj/BvC,mBAAA;EeHE,iHI4CF;EJ5CE,4GI4CF;EACA,gBAAA;A3Bi4EJ;AuB16EM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;EvB66EN;AACF;A2Bp4EI;EH3DF,0CjBqgCyC;AP67C3C;A2Bl4EE;EACE,WpBq7B8B;EoBp7B9B,cpBq7B8B;EoBp7B9B,kBAAA;EACA,epBo7B8B;EoBn7B9B,oCpBo7B8B;EoBn7B9B,yBAAA;EnBvDA,mBAAA;AR47EJ;A2Bh4EE;EACE,oBAAA;A3Bk4EJ;A2Bh4EI;EACE,2CpBu7BqC;AP28C3C;A2B/3EI;EACE,2CpBm7BqC;AP88C3C;;A4Bx9EA;EACE,kBAAA;A5B29EF;A4Bz9EE;EACE,kBAAA;EACA,QrB42BoC;EqB32BpC,SrB22BoC;EqB12BpC,6EAAA;EACA,erBmhCoC;EqBlhCpC,WAAA;EACA,wCrBg2BoC;ECv1BpC,sCAAA;ARm9EJ;A4Bx9EE;;;EAGE,0BrBogC8B;EqBngC9B,iBrBogC8B;APs9ClC;A4Bv9EE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qBAAA;ELlBE,gEKmBF;A5By9EJ;AuBx+EM;EKCJ;ILAM,gBAAA;EvB2+EN;AACF;A4B39EE;;EAEE,oBAAA;A5B69EJ;A4B39EI;;EACE,kBAAA;A5B89EN;A4B39EI;;;EAEE,qBrBy+B4B;EqBx+B5B,wBrBy+B4B;APq/ClC;A4B39EI;;EACE,qBrBo+B4B;EqBn+B5B,wBrBo+B4B;AP0/ClC;A4B19EE;EACE,qBrB89B8B;EqB79B9B,wBrB89B8B;AP8/ClC;A4Br9EI;;;;EACE,arBw9B4B;EqBv9B5B,8DrBw9B4B;APkgDlC;A4Br9EI;EACE,arBi9B4B;EqBh9B5B,8DrBi9B4B;APsgDlC;A4Bl9EI;EACE,mBAAA;A5Bo9EN;A4Bh9EE;EACE,crBnDO;APqgFX;;A6BriFA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A7BwiFF;A6BtiFE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A7BwiFJ;A6BpiFE;;;EAGE,UAAA;A7BsiFJ;A6BhiFE;EACE,kBAAA;EACA,UAAA;A7BkiFJ;A6BhiFI;EACE,UAAA;A7BkiFN;;A6BvhFA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EzBoPI,mBALI;EyB7OR,gBtBuiB4B;EsBtiB5B,gBtB8iB4B;EsB7iB5B,2BtB0zBsC;EsBzzBtC,kBAAA;EACA,mBAAA;EACA,oCtBi5BsC;EsBh5BtC,wCAAA;ErBtCE,sCAAA;ARikFJ;;A6BjhFA;;;;EAIE,oBAAA;EzB8NI,qBALI;EI7QN,yCAAA;AR0kFJ;;A6BjhFA;;;;EAIE,uBAAA;EzBqNI,sBALI;EI7QN,yCAAA;ARmlFJ;;A6BjhFA;;EAEE,qBAAA;A7BohFF;;A6BvgFI;;;;ErBjEA,0BAAA;EACA,6BAAA;AR+kFJ;A6BtgFI;;;;ErB1EA,0BAAA;EACA,6BAAA;ARslFJ;A6BhgFE;EACE,iBAAA;ErB1EA,yBAAA;EACA,4BAAA;AR6kFJ;A6BhgFE;;ErB9EE,yBAAA;EACA,4BAAA;ARklFJ;;A8B1mFE;EACE,aAAA;EACA,WAAA;EACA,mBvB8yBoC;EHtiBlC,kBALI;E0BhQN,6BvBkhCqB;AP0lDzB;;A8BzmFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;E1B2PE,sBALI;E0BnPN,WvBqgCqB;EuBpgCrB,mCvBogCqB;EC/hCrB,qBAAA;ARuoFJ;;A8BvmFI;;;;EAEE,cAAA;A9B4mFN;;A8B3pFI;EAqDE,+BvBu/BmB;EuBp/BjB,mCvBq0BgC;EuBp0BhC,yDAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;A9BwmFR;A8BrmFM;EACE,+BvB4+BiB;EuB3+BjB,2DvB2+BiB;AP4nDzB;;A8BxqFI;EA0EI,mCvBmzBgC;EuBlzBhC,gFAAA;A9BkmFR;;A8B7qFI;EAkFE,+BvB09BmB;APqoDzB;A8B5lFQ;EAEE,iEAAA;EACA,sBvBi4B8B;EuBh4B9B,6DAAA;EACA,yEAAA;A9B6lFV;A8BzlFM;EACE,+BvB68BiB;EuB58BjB,2DvB48BiB;AP+oDzB;;A8B3rFI;EAwGI,wCAAA;A9BulFR;;A8B/rFI;EA+GE,+BvB67BmB;APupDzB;A8BllFM;EACE,wCvB07BiB;AP0pDzB;A8BjlFM;EACE,2DvBs7BiB;AP6pDzB;A8BhlFM;EACE,6BvBk7BiB;APgqDzB;;A8B7kFI;EACE,kBAAA;A9BglFN;;A8BhtFI;;;;;EA0IM,UAAA;A9B8kFV;;A8BpsFE;EACE,aAAA;EACA,WAAA;EACA,mBvB8yBoC;EHtiBlC,kBALI;E0BhQN,4BvBkhCqB;APorDzB;;A8BnsFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;E1B2PE,sBALI;E0BnPN,WvBqgCqB;EuBpgCrB,kCvBogCqB;EC/hCrB,qBAAA;ARiuFJ;;A8BjsFI;;;;EAEE,cAAA;A9BssFN;;A8BrvFI;EAqDE,8BvBu/BmB;EuBp/BjB,mCvBq0BgC;EuBp0BhC,0DAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;A9BksFR;A8B/rFM;EACE,8BvB4+BiB;EuB3+BjB,0DvB2+BiB;APstDzB;;A8BlwFI;EA0EI,mCvBmzBgC;EuBlzBhC,gFAAA;A9B4rFR;;A8BvwFI;EAkFE,8BvB09BmB;AP+tDzB;A8BtrFQ;EAEE,kEAAA;EACA,sBvBi4B8B;EuBh4B9B,6DAAA;EACA,yEAAA;A9BurFV;A8BnrFM;EACE,8BvB68BiB;EuB58BjB,0DvB48BiB;APyuDzB;;A8BrxFI;EAwGI,wCAAA;A9BirFR;;A8BzxFI;EA+GE,8BvB67BmB;APivDzB;A8B5qFM;EACE,uCvB07BiB;APovDzB;A8B3qFM;EACE,0DvBs7BiB;APuvDzB;A8B1qFM;EACE,4BvBk7BiB;AP0vDzB;;A8BvqFI;EACE,kBAAA;A9B0qFN;;A8B1yFI;;;;;EA4IM,UAAA;A9BsqFV;;A+BpzFA;EAEE,0BAAA;EACA,2BAAA;EACA,sBAAA;E3B6RI,4BALI;E2BtRR,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,oCAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E3B4QI,kCALI;E2BrQR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EAGA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;A/BizFF;AuBr0FM;EQhBN;IRiBQ,gBAAA;EvBw0FN;AACF;A+BpzFE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;A/BqzFJ;A+BlzFE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;A/BmzFJ;A+BhzFE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;A/B8yFN;A+B1yFE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;A/BwyFN;A+BpyFE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;A/BgyFJ;A+B7xFI;EAKI,0CAAA;A/B2xFR;A+BtxFE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;A/BqxFJ;;A+BzwFE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EACA,mDAAA;EACA,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCm3FF;;A+B1xFE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,wCAAA;EACA,2BAAA;EACA,wCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCo4FF;;A+B3yFE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EACA,oDAAA;EACA,uCAAA;EACA,2BAAA;EACA,2CAAA;EACA,iDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCq5FF;;A+B5zFE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6CAAA;EACA,oDAAA;EACA,uCAAA;EACA,2BAAA;EACA,2CAAA;EACA,wDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCs6FF;;A+B70FE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0CAAA;EACA,kDAAA;EACA,uCAAA;EACA,8BAAA;EACA,0CAAA;EACA,mDAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AhCu7FF;;A+B91FE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,wCAAA;EACA,2BAAA;EACA,wCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCw8FF;;A+B/2FE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,8CAAA;EACA,qDAAA;EACA,wCAAA;EACA,8BAAA;EACA,4CAAA;EACA,yDAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AhCy9FF;;A+Bh4FE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,sCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC0+FF;;A+Bj5FE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,oDAAA;EACA,wCAAA;EACA,2BAAA;EACA,2CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC2/FF;;A+Bl6FE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,oDAAA;EACA,wCAAA;EACA,2BAAA;EACA,2CAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC4gGF;;A+Bz5FE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCogGF;;A+B16FE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCqhGF;;A+B37FE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCsiGF;;A+B58FE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCujGF;;A+B79FE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCwkGF;;A+B9+FE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCylGF;;A+B//FE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC0mGF;;A+BhhGE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC2nGF;;A+BjiGE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC4oGF;;A+BljGE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC6pGF;;A+BvjGA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,yBAAA;EACA,wCAAA;EAEA,qBxBsRwC;APmyF1C;A+B/iGE;EACE,0BAAA;A/BijGJ;A+B9iGE;EACE,gCAAA;A/BgjGJ;;A+BriGA;ECxIE,0BAAA;EACA,wBAAA;E5BoOI,8BALI;E4B7NR,kDAAA;AhCirGF;;A+BxiGA;EC5IE,2BAAA;EACA,0BAAA;E5BoOI,+BALI;E4B7NR,kDAAA;AhCwrGF;;AiC3vGA;EVgBM,gCUfJ;AjC8vGF;AuB3uGM;EUpBN;IVqBQ,gBAAA;EvB8uGN;AACF;AiCjwGE;EACE,UAAA;AjCmwGJ;;AiC7vGE;EACE,aAAA;AjCgwGJ;;AiC5vGA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AjC+vGF;AuB7vGM;EULN;IVMQ,gBAAA;EvBgwGN;AACF;AiClwGE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AjCowGJ;AuBvwGM;EUAJ;IVCM,gBAAA;EvB0wGN;AACF;;AkC/xGA;;;;;;EAME,kBAAA;AlCkyGF;;AkC/xGA;EACE,mBAAA;AlCkyGF;;AkC3xGA;EAEE,0BAAA;EACA,8BAAA;EACA,gCAAA;EACA,gCAAA;EACA,8BAAA;E9B6QI,iCALI;E8BtQR,yCAAA;EACA,wCAAA;EACA,kDAAA;EACA,oDAAA;EACA,+BAAA;EACA,sEAAA;EACA,gDAAA;EACA,wCAAA;EACA,8CAAA;EACA,8CAAA;EACA,8CAAA;EACA,4CAAA;EACA,+CAAA;EACA,6CAAA;EACA,qDAAA;EACA,oCAAA;EACA,sCAAA;EACA,mCAAA;EACA,sCAAA;EACA,uCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E9BgPI,uCALI;E8BzOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;ARq0GJ;AkCxxGE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AlC0xGJ;;AkClwGI;EACE,oBAAA;AlCqwGN;AkCnwGM;EACE,WAAA;EACA,OAAA;AlCqwGR;;AkCjwGI;EACE,kBAAA;AlCowGN;AkClwGM;EACE,QAAA;EACA,UAAA;AlCowGR;;Ae9yGI;EmB4BA;IACE,oBAAA;ElCsxGJ;EkCpxGI;IACE,WAAA;IACA,OAAA;ElCsxGN;EkClxGE;IACE,kBAAA;ElCoxGJ;EkClxGI;IACE,QAAA;IACA,UAAA;ElCoxGN;AACF;Ae/zGI;EmB4BA;IACE,oBAAA;ElCsyGJ;EkCpyGI;IACE,WAAA;IACA,OAAA;ElCsyGN;EkClyGE;IACE,kBAAA;ElCoyGJ;EkClyGI;IACE,QAAA;IACA,UAAA;ElCoyGN;AACF;Ae/0GI;EmB4BA;IACE,oBAAA;ElCszGJ;EkCpzGI;IACE,WAAA;IACA,OAAA;ElCszGN;EkClzGE;IACE,kBAAA;ElCozGJ;EkClzGI;IACE,QAAA;IACA,UAAA;ElCozGN;AACF;Ae/1GI;EmB4BA;IACE,oBAAA;ElCs0GJ;EkCp0GI;IACE,WAAA;IACA,OAAA;ElCs0GN;EkCl0GE;IACE,kBAAA;ElCo0GJ;EkCl0GI;IACE,QAAA;IACA,UAAA;ElCo0GN;AACF;Ae/2GI;EmB4BA;IACE,oBAAA;ElCs1GJ;EkCp1GI;IACE,WAAA;IACA,OAAA;ElCs1GN;EkCl1GE;IACE,kBAAA;ElCo1GJ;EkCl1GI;IACE,QAAA;IACA,UAAA;ElCo1GN;AACF;AkC30GE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AlC60GJ;AkCp0GE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AlCs0GJ;AkCj0GI;EACE,iBAAA;AlCm0GN;;AkC7zGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AlCg0GJ;AkC3zGI;EACE,iBAAA;AlC6zGN;;AkCtzGA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AlCyzGF;;AkCnzGA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB3Bua4B;E2Bta5B,oCAAA;EACA,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,uDAAA;AR49GJ;AkCnzGE;EAEE,0CAAA;EV1LF,kDU4LuB;AlCmzGzB;AkChzGE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AlCizGzB;AkC9yGE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AlC+yGJ;;AkCzyGA;EACE,cAAA;AlC4yGF;;AkCxyGA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E9ByEI,sBALI;E8BlER,sCAAA;EACA,mBAAA;AlC2yGF;;AkCvyGA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AlC0yGF;;AkCtyGA;EAEE,4BAAA;EACA,yBAAA;EACA,kDAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,gDAAA;EACA,sDAAA;EACA,+CAAA;EACA,6CAAA;EACA,0CAAA;EACA,mCAAA;AlCwyGF;;AmC9hHA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AnCiiHF;AmC/hHE;;EACE,kBAAA;EACA,cAAA;AnCkiHJ;AmC7hHE;;;;;;;;;;;;EAME,UAAA;AnCqiHJ;;AmChiHA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AnCmiHF;AmCjiHE;EACE,WAAA;AnCmiHJ;;AmC/hHA;E3BhBI,sCAAA;ARmjHJ;AmC/hHE;;EAEE,8CAAA;AnCiiHJ;AmC7hHE;;;E3BVE,0BAAA;EACA,6BAAA;AR4iHJ;AmCzhHE;;;E3BNE,yBAAA;EACA,4BAAA;ARoiHJ;;AmC5gHA;EACE,uBAAA;EACA,sBAAA;AnC+gHF;AmC7gHE;EAGE,cAAA;AnC6gHJ;AmC1gHE;EACE,eAAA;AnC4gHJ;;AmCxgHA;EACE,qBAAA;EACA,oBAAA;AnC2gHF;;AmCxgHA;EACE,sBAAA;EACA,qBAAA;AnC2gHF;;AmCv/GA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AnC0/GF;AmCx/GE;;EAEE,WAAA;AnC0/GJ;AmCv/GE;;EAEE,6CAAA;AnCy/GJ;AmCr/GE;;E3B1FE,6BAAA;EACA,4BAAA;ARmlHJ;AmCr/GE;;E3B7GE,yBAAA;EACA,0BAAA;ARsmHJ;;AoC9nHA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ApC6nHF;;AoC1nHA;EACE,cAAA;EACA,kEAAA;EhC4QI,uCALI;EgCrQR,2CAAA;EACA,+BAAA;EbZI,oGacJ;ApC4nHF;AuBtoHM;EaGN;IbFQ,gBAAA;EvByoHN;AACF;AoC/nHE;EAEE,qCAAA;ApCgoHJ;AoC3nHE;EACE,wCAAA;EACA,oBAAA;EACA,eAAA;ApC6nHJ;;AoCrnHA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,4GAAA;EAGA,oFAAA;ApCqnHF;AoCnnHE;EACE,yDAAA;EACA,gBAAA;EACA,yDAAA;E5BtCA,wDAAA;EACA,yDAAA;AR4pHJ;AoCpnHI;EAGE,kBAAA;EACA,wDAAA;ApConHN;AoCjnHI;EAEE,wCAAA;EACA,6BAAA;EACA,yBAAA;ApCknHN;AoC9mHE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;ApCgnHJ;AoC7mHE;EAEE,sDAAA;E5BjEA,yBAAA;EACA,0BAAA;ARgrHJ;;AoCrmHA;EAEE,qDAAA;EACA,sCAAA;EACA,sCAAA;ApCumHF;AoCpmHE;EACE,gBAAA;EACA,SAAA;E5B9FA,gDAAA;ARqsHJ;AoCpmHI;EACE,wCAAA;EACA,6BAAA;EACA,yBAAA;ApCsmHN;AoClmHE;;EAEE,4CAAA;EZzHF,oDY0HuB;ApComHzB;;AoC1lHE;;EAEE,cAAA;EACA,kBAAA;ApC6lHJ;;AoCxlHE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;ApC2lHJ;;AoCrlHE;;EACE,WAAA;ApCylHJ;;AoC/kHE;EACE,aAAA;ApCklHJ;AoChlHE;EACE,cAAA;ApCklHJ;;AqCtvHA;EAEE,wBAAA;EACA,8BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,yCAAA;EACA,kCAAA;EACA,uCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,yCAAA;EACA,qEAAA;EACA,oDAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;ArCsvHF;AqChvHE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;ArCwvHJ;AqCpuHA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;EjCkOI,2CALI;EiC3NR,mCAAA;EAEA,mBAAA;ArCquHF;AqCnuHE;EAEE,yCAAA;ArCouHJ;;AqC1tHA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArCytHF;AqCvtHE;;EAEE,oCAAA;ArCytHJ;AqCttHE;EACE,gBAAA;ArCwtHJ;;AqC/sHA;EACE,mB9Bi/BkC;E8Bh/BlC,sB9Bg/BkC;E8B/+BlC,6BAAA;ArCktHF;AqChtHE;;;EAGE,oCAAA;ArCktHJ;;AqCrsHA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;ArCssHF;;AqClsHA;EACE,8EAAA;EjCiJI,6CALI;EiC1IR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E7BtIE,qDAAA;EeHE,+Cc2IJ;ArCqsHF;AuB50HM;Ec+HN;Id9HQ,gBAAA;EvB+0HN;AACF;AqCxsHE;EACE,qBAAA;ArC0sHJ;AqCvsHE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;ArCysHJ;;AqCnsHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;ArCssHF;;AqCnsHA;EACE,yCAAA;EACA,gBAAA;ArCssHF;;Ae9zHI;EsBoIA;IAEI,iBAAA;IACA,2BAAA;ErC6rHN;EqC3rHM;IACE,mBAAA;ErC6rHR;EqC3rHQ;IACE,kBAAA;ErC6rHV;EqC1rHQ;IACE,kDAAA;IACA,iDAAA;ErC4rHV;EqCxrHM;IACE,iBAAA;ErC0rHR;EqCvrHM;IACE,wBAAA;IACA,gBAAA;ErCyrHR;EqCtrHM;IACE,aAAA;ErCwrHR;EqCrrHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id5NJ,gBc8NI;ErCqrHR;EqClrHQ;IACE,aAAA;ErCorHV;EqCjrHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCmrHV;AACF;Ae92HI;EsBoIA;IAEI,iBAAA;IACA,2BAAA;ErC4uHN;EqC1uHM;IACE,mBAAA;ErC4uHR;EqC1uHQ;IACE,kBAAA;ErC4uHV;EqCzuHQ;IACE,kDAAA;IACA,iDAAA;ErC2uHV;EqCvuHM;IACE,iBAAA;ErCyuHR;EqCtuHM;IACE,wBAAA;IACA,gBAAA;ErCwuHR;EqCruHM;IACE,aAAA;ErCuuHR;EqCpuHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id5NJ,gBc8NI;ErCouHR;EqCjuHQ;IACE,aAAA;ErCmuHV;EqChuHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCkuHV;AACF;Ae75HI;EsBoIA;IAEI,iBAAA;IACA,2BAAA;ErC2xHN;EqCzxHM;IACE,mBAAA;ErC2xHR;EqCzxHQ;IACE,kBAAA;ErC2xHV;EqCxxHQ;IACE,kDAAA;IACA,iDAAA;ErC0xHV;EqCtxHM;IACE,iBAAA;ErCwxHR;EqCrxHM;IACE,wBAAA;IACA,gBAAA;ErCuxHR;EqCpxHM;IACE,aAAA;ErCsxHR;EqCnxHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id5NJ,gBc8NI;ErCmxHR;EqChxHQ;IACE,aAAA;ErCkxHV;EqC/wHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCixHV;AACF;Ae58HI;EsBoIA;IAEI,iBAAA;IACA,2BAAA;ErC00HN;EqCx0HM;IACE,mBAAA;ErC00HR;EqCx0HQ;IACE,kBAAA;ErC00HV;EqCv0HQ;IACE,kDAAA;IACA,iDAAA;ErCy0HV;EqCr0HM;IACE,iBAAA;ErCu0HR;EqCp0HM;IACE,wBAAA;IACA,gBAAA;ErCs0HR;EqCn0HM;IACE,aAAA;ErCq0HR;EqCl0HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id5NJ,gBc8NI;ErCk0HR;EqC/zHQ;IACE,aAAA;ErCi0HV;EqC9zHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCg0HV;AACF;Ae3/HI;EsBoIA;IAEI,iBAAA;IACA,2BAAA;ErCy3HN;EqCv3HM;IACE,mBAAA;ErCy3HR;EqCv3HQ;IACE,kBAAA;ErCy3HV;EqCt3HQ;IACE,kDAAA;IACA,iDAAA;ErCw3HV;EqCp3HM;IACE,iBAAA;ErCs3HR;EqCn3HM;IACE,wBAAA;IACA,gBAAA;ErCq3HR;EqCl3HM;IACE,aAAA;ErCo3HR;EqCj3HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id5NJ,gBc8NI;ErCi3HR;EqC92HQ;IACE,aAAA;ErCg3HV;EqC72HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC+2HV;AACF;AqCt6HI;EAEI,iBAAA;EACA,2BAAA;ArCu6HR;AqCr6HQ;EACE,mBAAA;ArCu6HV;AqCr6HU;EACE,kBAAA;ArCu6HZ;AqCp6HU;EACE,kDAAA;EACA,iDAAA;ArCs6HZ;AqCl6HQ;EACE,iBAAA;ArCo6HV;AqCj6HQ;EACE,wBAAA;EACA,gBAAA;ArCm6HV;AqCh6HQ;EACE,aAAA;ArCk6HV;AqC/5HQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ed5NJ,gBc8NI;ArC+5HV;AqC55HU;EACE,aAAA;ArC85HZ;AqC35HU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;ArC65HZ;;AqC54HA;EAEE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;ArC84HF;;AqCx4HI;EACE,qEAAA;ArC24HN;;AsCjqIA;EAEE,0BAAA;EACA,0BAAA;EACA,iCAAA;EACA,uBAAA;EACA,0BAAA;EACA,oDAAA;EACA,8CAAA;EACA,gDAAA;EACA,6CAAA;EACA,6FAAA;EACA,iCAAA;EACA,+BAAA;EACA,wCAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oCAAA;EACA,qCAAA;EACA,4BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E9BhBE,2CAAA;ARkrIJ;AsC9pIE;EACE,eAAA;EACA,cAAA;AtCgqIJ;AsC7pIE;EACE,mBAAA;EACA,sBAAA;AtC+pIJ;AsC7pII;EACE,mBAAA;E9BrBF,0DAAA;EACA,2DAAA;ARqrIJ;AsC7pII;EACE,sBAAA;E9BZF,8DAAA;EACA,6DAAA;AR4qIJ;AsC1pIE;;EAEE,aAAA;AtC4pIJ;;AsCxpIA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AtCypIF;;AsCtpIA;EACE,4CAAA;EACA,iCAAA;AtCypIF;;AsCtpIA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AtCypIF;;AsCtpIA;EACE,gBAAA;AtCypIF;;AsCjpIE;EACE,oCAAA;AtCopIJ;;AsC5oIA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AtC+oIF;AsC7oIE;E9B5FE,wFAAA;AR4uIJ;;AsC3oIA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AtC8oIF;AsC5oIE;E9BvGE,wFAAA;ARsvIJ;;AsCroIA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AtCwoIF;AsCtoIE;EACE,mCAAA;EACA,sCAAA;AtCwoIJ;;AsCpoIA;EACE,uDAAA;EACA,sDAAA;AtCuoIF;;AsCnoIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E9BzIE,iDAAA;ARgxIJ;;AsCnoIA;;;EAGE,WAAA;AtCsoIF;;AsCnoIA;;E9B1II,0DAAA;EACA,2DAAA;ARkxIJ;;AsCpoIA;;E9BjII,8DAAA;EACA,6DAAA;AR0wIJ;;AsC7nIE;EACE,0CAAA;AtCgoIJ;Ae1vII;EuBsHJ;IAQI,aAAA;IACA,mBAAA;EtCgoIF;EsC7nIE;IAEE,SAAA;IACA,gBAAA;EtC8nIJ;EsC5nII;IACE,cAAA;IACA,cAAA;EtC8nIN;EsCznIM;I9B1KJ,0BAAA;IACA,6BAAA;ERsyIF;EsC1nIQ;;IAGE,0BAAA;EtC2nIV;EsCznIQ;;IAGE,6BAAA;EtC0nIV;EsCtnIM;I9B3KJ,yBAAA;IACA,4BAAA;ERoyIF;EsCvnIQ;;IAGE,yBAAA;EtCwnIV;EsCtnIQ;;IAGE,4BAAA;EtCunIV;AACF;;AuC31IA;EAEE,0CAAA;EACA,yCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,6DAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,mDAAA;EACA,qDAAA;AvC61IF;;AuCz1IA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EnCiQI,mBALI;EmC1PR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;E/BtBE,gBAAA;E+BwBF,qBAAA;EhB3BI,0CgB4BJ;AvC41IF;AuBp3IM;EgBWN;IhBVQ,gBAAA;EvBu3IN;AACF;AuC/1IE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AvCi2IJ;AuC/1II;EACE,qDAAA;EACA,iDAAA;AvCi2IN;AuC51IE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EhBlDE,mDgBmDF;AvC81IJ;AuB74IM;EgBsCJ;IhBrCM,gBAAA;EvBg5IN;AACF;AuCh2IE;EACE,UAAA;AvCk2IJ;AuC/1IE;EACE,UAAA;EACA,wDAAA;EACA,UAAA;EACA,oDAAA;AvCi2IJ;;AuC71IA;EACE,gBAAA;AvCg2IF;;AuC71IA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AvCg2IF;AuC91IE;E/B/DE,yDAAA;EACA,0DAAA;ARg6IJ;AuC/1II;E/BlEA,+DAAA;EACA,gEAAA;ARo6IJ;AuC91IE;EACE,aAAA;AvCg2IJ;AuC51IE;E/B9DE,6DAAA;EACA,4DAAA;AR65IJ;AuC51IM;E/BlEF,mEAAA;EACA,kEAAA;ARi6IJ;AuC31II;E/BvEA,6DAAA;EACA,4DAAA;ARq6IJ;;AuCz1IA;EACE,8EAAA;AvC41IF;;AuCn1IE;EACE,eAAA;AvCs1IJ;AuCn1IE;EACE,eAAA;EACA,cAAA;E/BpHA,gBAAA;AR08IJ;AuCn1II;EAAgB,aAAA;AvCs1IpB;AuCr1II;EAAe,gBAAA;AvCw1InB;AuCr1IM;E/B3HF,gBAAA;ARm9IJ;;AuC90II;EACE,iEAAA;EACA,wEAAA;AvCi1IN;;AwC3+IA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,qDAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;EpCqRI,yCALI;EoC9QR,gBAAA;EACA,yCAAA;EhCAE,iDAAA;AR2+IJ;;AwCr+IE;EACE,iDAAA;AxCw+IJ;AwCt+II;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,iGAAA;AxCw+IN;AwCp+IE;EACE,6CAAA;AxCs+IJ;;AyC3gJA;EAEE,kCAAA;EACA,mCAAA;ErCkSI,mCALI;EqC3RR,qCAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,2CAAA;EACA,4CAAA;EACA,0DAAA;EACA,oDAAA;EACA,gDAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;E/BpBA,eAAA;EACA,gBAAA;AVgiJF;;AyCzgJA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;ErCsQI,yCALI;EqC/PR,iCAAA;EAEA,yCAAA;EACA,iFAAA;ElBpBI,qIkBqBJ;AzC2gJF;AuB5hJM;EkBQN;IlBPQ,gBAAA;EvB+hJN;AACF;AyC9gJE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;AzC+gJJ;AyC5gJE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UlCmsCgC;EkClsChC,iDAAA;AzC8gJJ;AyC3gJE;EAEE,UAAA;EACA,wCAAA;EjBtDF,gDiBuDuB;EACrB,sDAAA;AzC4gJJ;AyCzgJE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;AzC0gJJ;;AyCrgJE;EACE,8ClCsqCgC;APk2GpC;AyCngJM;EjC9BF,0DAAA;EACA,6DAAA;ARoiJJ;AyCjgJM;EjClDF,2DAAA;EACA,8DAAA;ARsjJJ;;AyCp/IA;EClGE,iCAAA;EACA,kCAAA;EtCgSI,qCALI;EsCzRR,yDAAA;A1C0lJF;;AyCv/IA;ECtGE,iCAAA;EACA,kCAAA;EtCgSI,sCALI;EsCzRR,yDAAA;A1CimJF;;A2CnmJA;EAEE,2BAAA;EACA,4BAAA;EvC6RI,4BALI;EuCtRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;EvCqRI,oCALI;EuC9QR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EnCJE,4CAAA;ARwmJJ;A2C/lJE;EACE,aAAA;A3CimJJ;;A2C5lJA;EACE,kBAAA;EACA,SAAA;A3C+lJF;;A4C/nJA;EAEE,0BAAA;EACA,6BAAA;EACA,4BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;EpCHE,4CAAA;ARmoJJ;;A4C3nJA;EAEE,cAAA;A5C6nJF;;A4CznJA;EACE,gBrC2jB4B;EqC1jB5B,iCAAA;A5C4nJF;;A4CpnJA;EACE,sBrC47C8B;AP2rGhC;A4CpnJE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A5CsnJJ;;A4C9mJE;EACE,wCAAA;EACA,0CAAA;EACA,wDAAA;EACA,6CAAA;A5CinJJ;;A4CrnJE;EACE,0CAAA;EACA,4CAAA;EACA,0DAAA;EACA,+CAAA;A5CwnJJ;;A4C5nJE;EACE,wCAAA;EACA,0CAAA;EACA,wDAAA;EACA,6CAAA;A5C+nJJ;;A4CnoJE;EACE,qCAAA;EACA,uCAAA;EACA,qDAAA;EACA,0CAAA;A5CsoJJ;;A4C1oJE;EACE,wCAAA;EACA,0CAAA;EACA,wDAAA;EACA,6CAAA;A5C6oJJ;;A4CjpJE;EACE,uCAAA;EACA,yCAAA;EACA,uDAAA;EACA,4CAAA;A5CopJJ;;A4CxpJE;EACE,sCAAA;EACA,wCAAA;EACA,sDAAA;EACA,2CAAA;A5C2pJJ;;A4C/pJE;EACE,qCAAA;EACA,uCAAA;EACA,qDAAA;EACA,0CAAA;A5CkqJJ;;A4CtqJE;EACE,qCAAA;EACA,uCAAA;EACA,qDAAA;EACA,0CAAA;A5CyqJJ;;A4C7qJE;EACE,qCAAA;EACA,uCAAA;EACA,qDAAA;EACA,0CAAA;A5CgrJJ;;A6C5uJE;EACE;IAAK,2BtC0+C2B;EPswGlC;AACF;A6C5uJA;;EAGE,0BAAA;EzCwRI,mCALI;EyCjRR,iCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;EzC4QI,uCALI;EyCrQR,uCAAA;ErCRE,+CAAA;ARovJJ;;A6CvuJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EtBxBI,6CsByBJ;A7C0uJF;AuB/vJM;EsBYN;ItBXQ,gBAAA;EvBkwJN;AACF;;A6C5uJA;ErBAE,qMAAA;EqBEA,oEAAA;A7C+uJF;;A6C5uJA;EACE,iBAAA;A7C+uJF;;A6C5uJA;EACE,WAAA;A7C+uJF;;A6C3uJE;EACE,kDAAA;A7C8uJJ;A6C3uJM;EAJJ;IAKM,eAAA;E7C8uJN;AACF;;A8C1yJA;EAEE,2CAAA;EACA,0CAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,sCAAA;EACA,uCAAA;EACA,uDAAA;EACA,4DAAA;EACA,mDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,mDAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EtCXE,iDAAA;ARozJJ;;A8CryJA;EACE,qBAAA;EACA,sBAAA;A9CwyJF;A8CtyJE;EAEE,oCAAA;EACA,0BAAA;A9CuyJJ;;A8C9xJA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;A9CiyJF;A8C9xJE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;A9C+xJJ;A8C5xJE;EACE,+CAAA;EACA,uDAAA;A9C8xJJ;;A8CtxJA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EAEA,yCAAA;EACA,iFAAA;A9CwxJF;A8CtxJE;EtCvDE,+BAAA;EACA,gCAAA;ARg1JJ;A8CtxJE;EtC7CE,mCAAA;EACA,kCAAA;ARs0JJ;A8CtxJE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;A9CuxJJ;A8CnxJE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;A9CqxJJ;A8CjxJE;EACE,mBAAA;A9CmxJJ;A8CjxJI;EACE,wDAAA;EACA,mDAAA;A9CmxJN;;A8CtwJI;EACE,mBAAA;A9CywJN;A8CtwJQ;EtCvDJ,6DAAA;EAZA,0BAAA;AR60JJ;A8CrwJQ;EtCxEJ,2DAAA;EAYA,4BAAA;ARq0JJ;A8CpwJQ;EACE,aAAA;A9CswJV;A8CnwJQ;EACE,mDAAA;EACA,oBAAA;A9CqwJV;A8CnwJU;EACE,yDAAA;EACA,oDAAA;A9CqwJZ;;Ae31JI;E+B8DA;IACE,mBAAA;E9CiyJJ;E8C9xJM;ItCvDJ,6DAAA;IAZA,0BAAA;ERq2JF;E8C7xJM;ItCxEJ,2DAAA;IAYA,4BAAA;ER61JF;E8C5xJM;IACE,aAAA;E9C8xJR;E8C3xJM;IACE,mDAAA;IACA,oBAAA;E9C6xJR;E8C3xJQ;IACE,yDAAA;IACA,oDAAA;E9C6xJV;AACF;Aep3JI;E+B8DA;IACE,mBAAA;E9CyzJJ;E8CtzJM;ItCvDJ,6DAAA;IAZA,0BAAA;ER63JF;E8CrzJM;ItCxEJ,2DAAA;IAYA,4BAAA;ERq3JF;E8CpzJM;IACE,aAAA;E9CszJR;E8CnzJM;IACE,mDAAA;IACA,oBAAA;E9CqzJR;E8CnzJQ;IACE,yDAAA;IACA,oDAAA;E9CqzJV;AACF;Ae54JI;E+B8DA;IACE,mBAAA;E9Ci1JJ;E8C90JM;ItCvDJ,6DAAA;IAZA,0BAAA;ERq5JF;E8C70JM;ItCxEJ,2DAAA;IAYA,4BAAA;ER64JF;E8C50JM;IACE,aAAA;E9C80JR;E8C30JM;IACE,mDAAA;IACA,oBAAA;E9C60JR;E8C30JQ;IACE,yDAAA;IACA,oDAAA;E9C60JV;AACF;Aep6JI;E+B8DA;IACE,mBAAA;E9Cy2JJ;E8Ct2JM;ItCvDJ,6DAAA;IAZA,0BAAA;ER66JF;E8Cr2JM;ItCxEJ,2DAAA;IAYA,4BAAA;ERq6JF;E8Cp2JM;IACE,aAAA;E9Cs2JR;E8Cn2JM;IACE,mDAAA;IACA,oBAAA;E9Cq2JR;E8Cn2JQ;IACE,yDAAA;IACA,oDAAA;E9Cq2JV;AACF;Ae57JI;E+B8DA;IACE,mBAAA;E9Ci4JJ;E8C93JM;ItCvDJ,6DAAA;IAZA,0BAAA;ERq8JF;E8C73JM;ItCxEJ,2DAAA;IAYA,4BAAA;ER67JF;E8C53JM;IACE,aAAA;E9C83JR;E8C33JM;IACE,mDAAA;IACA,oBAAA;E9C63JR;E8C33JQ;IACE,yDAAA;IACA,oDAAA;E9C63JV;AACF;A8Ch3JA;EtChJI,gBAAA;ARmgKJ;A8Ch3JE;EACE,mDAAA;A9Ck3JJ;A8Ch3JI;EACE,sBAAA;A9Ck3JN;;A8Cr2JE;EACE,6CAAA;EACA,+CAAA;EACA,6DAAA;A9Cw2JJ;A8Cr2JM;EAEE,4DAAA;EACA,gEAAA;A9Cs2JR;A8Cn2JM;EACE,sDAAA;EACA,iDAAA;EACA,2DAAA;A9Cq2JR;;A8Cp3JE;EACE,+CAAA;EACA,iDAAA;EACA,+DAAA;A9Cu3JJ;A8Cp3JM;EAEE,4DAAA;EACA,kEAAA;A9Cq3JR;A8Cl3JM;EACE,sDAAA;EACA,mDAAA;EACA,6DAAA;A9Co3JR;;A8Cn4JE;EACE,6CAAA;EACA,+CAAA;EACA,6DAAA;A9Cs4JJ;A8Cn4JM;EAEE,4DAAA;EACA,gEAAA;A9Co4JR;A8Cj4JM;EACE,sDAAA;EACA,iDAAA;EACA,2DAAA;A9Cm4JR;;A8Cl5JE;EACE,0CAAA;EACA,4CAAA;EACA,0DAAA;A9Cq5JJ;A8Cl5JM;EAEE,4DAAA;EACA,6DAAA;A9Cm5JR;A8Ch5JM;EACE,sDAAA;EACA,8CAAA;EACA,wDAAA;A9Ck5JR;;A8Cj6JE;EACE,6CAAA;EACA,+CAAA;EACA,6DAAA;A9Co6JJ;A8Cj6JM;EAEE,4DAAA;EACA,gEAAA;A9Ck6JR;A8C/5JM;EACE,sDAAA;EACA,iDAAA;EACA,2DAAA;A9Ci6JR;;A8Ch7JE;EACE,4CAAA;EACA,8CAAA;EACA,4DAAA;A9Cm7JJ;A8Ch7JM;EAEE,4DAAA;EACA,+DAAA;A9Ci7JR;A8C96JM;EACE,sDAAA;EACA,gDAAA;EACA,0DAAA;A9Cg7JR;;A8C/7JE;EACE,2CAAA;EACA,6CAAA;EACA,2DAAA;A9Ck8JJ;A8C/7JM;EAEE,4DAAA;EACA,8DAAA;A9Cg8JR;A8C77JM;EACE,sDAAA;EACA,+CAAA;EACA,yDAAA;A9C+7JR;;A8C98JE;EACE,0CAAA;EACA,4CAAA;EACA,0DAAA;A9Ci9JJ;A8C98JM;EAEE,4DAAA;EACA,6DAAA;A9C+8JR;A8C58JM;EACE,sDAAA;EACA,8CAAA;EACA,wDAAA;A9C88JR;;A8C79JE;EACE,0CAAA;EACA,4CAAA;EACA,0DAAA;A9Cg+JJ;A8C79JM;EAEE,4DAAA;EACA,6DAAA;A9C89JR;A8C39JM;EACE,sDAAA;EACA,8CAAA;EACA,wDAAA;A9C69JR;;A8C5+JE;EACE,0CAAA;EACA,4CAAA;EACA,0DAAA;A9C++JJ;A8C5+JM;EAEE,4DAAA;EACA,6DAAA;A9C6+JR;A8C1+JM;EACE,sDAAA;EACA,8CAAA;EACA,wDAAA;A9C4+JR;;A+C7qKA;EACE,0BAAA;EACA,2DAAA;EACA,yBAAA;EACA,iCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAEA,uBAAA;EACA,UxComD2B;EwCnmD3B,WxCmmD2B;EwClmD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;EvCFE,sBAAA;EuCIF,oCAAA;A/C+qKF;A+C5qKE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;A/C8qKJ;A+C3qKE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;A/C6qKJ;A+C1qKE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;A/C2qKJ;;A+CnqKA;EAHE,wCAAA;A/C0qKF;;A+CjqKI;EATF,wCAAA;A/C8qKF;;AgD7tKA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;E5C+RI,8BALI;E4CxRR,yBAAA;EACA,qCAAA;EACA,+CAAA;EACA,+CAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,sDAAA;EAGA,gCAAA;EACA,eAAA;E5CiRI,oCALI;E4C1QR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;ExCRE,4CAAA;ARsuKJ;AgD3tKE;EACE,UAAA;AhD6tKJ;AgD1tKE;EACE,aAAA;AhD4tKJ;;AgDxtKA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AhD0tKF;AgDxtKE;EACE,sCAAA;AhD0tKJ;;AgDttKA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;ExChCE,0FAAA;EACA,2FAAA;AR0vKJ;AgDxtKE;EACE,oDAAA;EACA,sCAAA;AhD0tKJ;;AgDttKA;EACE,kCAAA;EACA,qBAAA;AhDytKF;;AiDvxKA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AjDqxKF;;AiD9wKA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AjDgxKF;AiD7wKE;E1B5CI,mC0B6CF;EACA,8B1Cs5CgC;APy3HpC;AuBzzKM;E0BwCJ;I1BvCM,gBAAA;EvB4zKN;AACF;AiDlxKE;EACE,e1Co5CgC;APg4HpC;AiDhxKE;EACE,sB1Ci5CgC;APi4HpC;;AiD9wKA;EACE,+CAAA;AjDixKF;AiD/wKE;EACE,gBAAA;EACA,gBAAA;AjDixKJ;AiD9wKE;EACE,gBAAA;AjDgxKJ;;AiD5wKA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AjD+wKF;;AiD3wKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EzCrFE,4CAAA;EyCyFF,UAAA;AjD2wKF;;AiDvwKA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AjD6wK9D;AkDz3KE;EAAS,UAAA;AlD43KX;AkD33KE;EAAS,mCD2GiF;AjDmxK5F;;AiD9wKA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,uCAAA;EACA,4FAAA;EzCtGE,2DAAA;EACA,4DAAA;ARw3KJ;AiDhxKE;EACE,kGAAA;EACA,sJAAA;AjDkxKJ;;AiD7wKA;EACE,gBAAA;EACA,8CAAA;AjDgxKF;;AiD3wKA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AjD4wKF;;AiDxwKA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;EzC1HE,+DAAA;EACA,8DAAA;ARs4KJ;AiDvwKE;EACE,8CAAA;AjDywKJ;;Aer3KI;EkCkHF;IACE,0BAAA;IACA,2CAAA;EjDuwKF;EiDnwKA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EjDqwKF;EiDlwKA;IACE,uBAAA;EjDowKF;AACF;Aep4KI;EkCoIF;;IAEE,uBAAA;EjDmwKF;AACF;Ae14KI;EkC2IF;IACE,wBAAA;EjDkwKF;AACF;AiDzvKI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AjD2vKN;AiDzvKM;EACE,YAAA;EACA,SAAA;EzC1MJ,gBAAA;ARs8KJ;AiDxvKM;;EzC9MF,gBAAA;AR08KJ;AiDvvKM;EACE,gBAAA;AjDyvKR;;Aep5KI;EkCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjD+wKJ;EiD7wKI;IACE,YAAA;IACA,SAAA;IzC1MJ,gBAAA;ER09KF;EiD5wKI;;IzC9MF,gBAAA;ER89KF;EiD3wKI;IACE,gBAAA;EjD6wKN;AACF;Aez6KI;EkCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDmyKJ;EiDjyKI;IACE,YAAA;IACA,SAAA;IzC1MJ,gBAAA;ER8+KF;EiDhyKI;;IzC9MF,gBAAA;ERk/KF;EiD/xKI;IACE,gBAAA;EjDiyKN;AACF;Ae77KI;EkCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDuzKJ;EiDrzKI;IACE,YAAA;IACA,SAAA;IzC1MJ,gBAAA;ERkgLF;EiDpzKI;;IzC9MF,gBAAA;ERsgLF;EiDnzKI;IACE,gBAAA;EjDqzKN;AACF;Aej9KI;EkCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjD20KJ;EiDz0KI;IACE,YAAA;IACA,SAAA;IzC1MJ,gBAAA;ERshLF;EiDx0KI;;IzC9MF,gBAAA;ER0hLF;EiDv0KI;IACE,gBAAA;EjDy0KN;AACF;Aer+KI;EkCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjD+1KJ;EiD71KI;IACE,YAAA;IACA,SAAA;IzC1MJ,gBAAA;ER0iLF;EiD51KI;;IzC9MF,gBAAA;ER8iLF;EiD31KI;IACE,gBAAA;EjD61KN;AACF;AmDpkLA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,sBAAA;E/C8RI,mCALI;E+CvRR,wBAAA;EACA,qBAAA;EACA,kCAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,uCAAA;EACA,gCAAA;ECnBA,sC7C6kB4B;E6C3kB5B,kBAAA;EACA,gB7CslB4B;E6CrlB5B,gB7C6lB4B;E6C5lB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EhDsRI,sCALI;E+CrQR,qBAAA;EACA,UAAA;AnD4kLF;AmD1kLE;EAAS,kCAAA;AnD6kLX;AmD3kLE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AnD6kLJ;AmD3kLI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnD6kLN;;AmDxkLA;EACE,SAAA;AnD2kLF;AmDzkLE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AnD2kLJ;;AmDvkLA,qBAAA;AACA;EACE,OAAA;EACA,qCAAA;EACA,qCAAA;AnD0kLF;AmDxkLE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AnD0kLJ;;AmDtkLA,mBAAA;AAEA;EACE,MAAA;AnDwkLF;AmDtkLE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AnDwkLJ;;AmDpkLA,qBAAA;AACA;EACE,QAAA;EACA,qCAAA;EACA,qCAAA;AnDukLF;AmDrkLE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AnDukLJ;;AmDnkLA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E3ClGE,8CAAA;ARwpLJ;;AqD3qLA;EAEE,yBAAA;EACA,6BAAA;EjDkSI,mCALI;EiD3RR,uCAAA;EACA,iDAAA;EACA,iDAAA;EACA,sDAAA;EACA,6FAAA;EACA,6CAAA;EACA,qCAAA;EACA,qCAAA;EjDyRI,uCALI;EiDlRR,mDAAA;EACA,8CAAA;EACA,oCAAA;EACA,mCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC7C6kB4B;E6C3kB5B,kBAAA;EACA,gB7CslB4B;E6CrlB5B,gB7C6lB4B;E6C5lB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EhDsRI,sCALI;EiDhQR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E7ChBE,8CAAA;ARssLJ;AqDlrLE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ArDorLJ;AqDlrLI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;ArDmrLN;;AqD7qLE;EACE,oFAAA;ArDgrLJ;AqD9qLI;EAEE,wFAAA;ArD+qLN;AqD5qLI;EACE,SAAA;EACA,gDAAA;ArD8qLN;AqD3qLI;EACE,sCAAA;EACA,sCAAA;ArD6qLN;;AqDxqLA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;ArD0qLJ;AqDxqLI;EAEE,kIAAA;ArDyqLN;AqDtqLI;EACE,OAAA;EACA,kDAAA;ArDwqLN;AqDrqLI;EACE,oCAAA;EACA,wCAAA;ArDuqLN;;AqDlqLA,mBAAA;AAGE;EACE,iFAAA;ArDmqLJ;AqDjqLI;EAEE,wFAAA;ArDkqLN;AqD/pLI;EACE,MAAA;EACA,mDAAA;ArDiqLN;AqD9pLI;EACE,mCAAA;EACA,yCAAA;ArDgqLN;AqD3pLE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;ArD6pLJ;;AqDzpLA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;ArD2pLJ;AqDzpLI;EAEE,kIAAA;ArD0pLN;AqDvpLI;EACE,QAAA;EACA,iDAAA;ArDypLN;AqDtpLI;EACE,qCAAA;EACA,uCAAA;ArDwpLN;;AqDnpLA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;EjDiHI,6CALI;EiD1GR,qCAAA;EACA,6CAAA;EACA,kFAAA;E7C5JE,6DAAA;EACA,8DAAA;ARkyLJ;AqDpoLE;EACE,aAAA;ArDsoLJ;;AqDloLA;EACE,0EAAA;EACA,mCAAA;ArDqoLF;;AsD1zLA;EACE,kBAAA;AtD6zLF;;AsD1zLA;EACE,mBAAA;AtD6zLF;;AsD1zLA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AtD6zLF;AuDn1LE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvDq1LJ;;AsD9zLA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;E/BlBI,sC+BmBJ;AtDi0LF;AuBh1LM;E+BQN;I/BPQ,gBAAA;EvBm1LN;AACF;;AsDn0LA;;;EAGE,cAAA;AtDs0LF;;AsDn0LA;;EAEE,2BAAA;AtDs0LF;;AsDn0LA;;EAEE,4BAAA;AtDs0LF;;AsD7zLE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AtDg0LJ;AsD7zLE;;;EAGE,UAAA;EACA,UAAA;AtD+zLJ;AsD5zLE;;EAEE,UAAA;EACA,UAAA;E/B5DE,2B+B6DF;AtD8zLJ;AuBv3LM;E+BqDJ;;I/BpDM,gBAAA;EvB23LN;AACF;;AsD3zLA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,U/Ci+CmC;E+Ch+CnC,UAAA;EACA,W/CpES;E+CqET,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,Y/C49CmC;EgBljD/B,8B+BuFJ;AtD6zLF;AuBh5LM;E+BkEN;;I/BjEQ,gBAAA;EvBo5LN;AACF;AsDh0LE;;;EAEE,W/C9EO;E+C+EP,qBAAA;EACA,UAAA;EACA,Y/Co9CiC;AP+2IrC;;AsDh0LA;EACE,OAAA;AtDm0LF;;AsDh0LA;EACE,QAAA;AtDm0LF;;AsD9zLA;;EAEE,qBAAA;EACA,W/Cq9CmC;E+Cp9CnC,Y/Co9CmC;E+Cn9CnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AtDi0LF;;AsD9zLA;;;;;;;GAAA;AAQA;EACE,0DAAA;AtDi0LF;;AsD/zLA;EACE,0DAAA;AtDk0LF;;AsD1zLA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iB/C65CmC;E+C55CnC,mBAAA;EACA,gB/C25CmC;E+C15CnC,gBAAA;AtD4zLF;AsD1zLE;EACE,uBAAA;EACA,cAAA;EACA,W/C05CiC;E+Cz5CjC,W/C05CiC;E+Cz5CjC,UAAA;EACA,iB/C05CiC;E+Cz5CjC,gB/Cy5CiC;E+Cx5CjC,mBAAA;EACA,eAAA;EACA,sB/CrJO;E+CsJP,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,Y/Ci5CiC;EgB1jD/B,6B+B0KF;AtD2zLJ;AuBj+LM;E+BqJJ;I/BpJM,gBAAA;EvBo+LN;AACF;AsD7zLE;EACE,U/C84CiC;APi7IrC;;AsDtzLA;EACE,kBAAA;EACA,UAAA;EACA,e/Cw4CmC;E+Cv4CnC,SAAA;EACA,oB/Cq4CmC;E+Cp4CnC,uB/Co4CmC;E+Cn4CnC,W/ChLS;E+CiLT,kBAAA;AtDyzLF;;AsDnzLE;;EAEE,gC/Cu4CiC;AP+6IrC;AsDnzLE;EACE,sB/CnLO;APw+LX;AsDlzLE;EACE,W/CvLO;AP2+LX;;AsD9zLE;;EAEE,gC/Cu4CiC;AP07IrC;AsD9zLE;EACE,sB/CnLO;APm/LX;AsD7zLE;EACE,W/CvLO;APs/LX;;AwD1hMA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AxD4hMF;;AwDxhMA;EACE;IAAK,0CAAA;ExD4hML;AACF;AwDzhMA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AxDwhMF;;AwDrhMA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AxDuhMF;;AwD9gMA;EACE;IACE,mBAAA;ExDihMF;EwD/gMA;IACE,UAAA;IACA,eAAA;ExDihMF;AACF;AwD7gMA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AxD4gMF;;AwDzgMA;EACE,wBAAA;EACA,yBAAA;AxD4gMF;;AwDxgME;EACE;;IAEE,kCAAA;ExD2gMJ;AACF;AyD3lMA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,yCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;AzD4lMF;;Ae/hMI;E0C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IlC5BA,0CkC8BA;EzD6kMJ;AACF;AuBxmMM;EkCYJ;IlCXM,gBAAA;EvB2mMN;AACF;AerjMI;E0C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDolMN;EyDjlMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDmlMN;EyDhlMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDklMN;EyD/kMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDilMN;EyD9kMI;IAEE,eAAA;EzD+kMN;EyD5kMI;IAGE,mBAAA;EzD4kMN;AACF;AezmMI;E0C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzD2kMN;EyDzkMM;IACE,aAAA;EzD2kMR;EyDxkMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDykMR;AACF;;Ae7mMI;E0C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IlC5BA,0CkC8BA;EzD2pMJ;AACF;AuBtrMM;EkCYJ;IlCXM,gBAAA;EvByrMN;AACF;AenoMI;E0C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDkqMN;EyD/pMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDiqMN;EyD9pMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDgqMN;EyD7pMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD+pMN;EyD5pMI;IAEE,eAAA;EzD6pMN;EyD1pMI;IAGE,mBAAA;EzD0pMN;AACF;AevrMI;E0C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDypMN;EyDvpMM;IACE,aAAA;EzDypMR;EyDtpMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDupMR;AACF;;Ae3rMI;E0C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IlC5BA,0CkC8BA;EzDyuMJ;AACF;AuBpwMM;EkCYJ;IlCXM,gBAAA;EvBuwMN;AACF;AejtMI;E0C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDgvMN;EyD7uMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD+uMN;EyD5uMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD8uMN;EyD3uMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD6uMN;EyD1uMI;IAEE,eAAA;EzD2uMN;EyDxuMI;IAGE,mBAAA;EzDwuMN;AACF;AerwMI;E0C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDuuMN;EyDruMM;IACE,aAAA;EzDuuMR;EyDpuMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDquMR;AACF;;AezwMI;E0C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IlC5BA,0CkC8BA;EzDuzMJ;AACF;AuBl1MM;EkCYJ;IlCXM,gBAAA;EvBq1MN;AACF;Ae/xMI;E0C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzD8zMN;EyD3zMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD6zMN;EyD1zMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD4zMN;EyDzzMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD2zMN;EyDxzMI;IAEE,eAAA;EzDyzMN;EyDtzMI;IAGE,mBAAA;EzDszMN;AACF;Aen1MI;E0C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDqzMN;EyDnzMM;IACE,aAAA;EzDqzMR;EyDlzMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDmzMR;AACF;;Aev1MI;E0C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IlC5BA,0CkC8BA;EzDq4MJ;AACF;AuBh6MM;EkCYJ;IlCXM,gBAAA;EvBm6MN;AACF;Ae72MI;E0C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzD44MN;EyDz4MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD24MN;EyDx4MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD04MN;EyDv4MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDy4MN;EyDt4MI;IAEE,eAAA;EzDu4MN;EyDp4MI;IAGE,mBAAA;EzDo4MN;AACF;Aej6MI;E0C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDm4MN;EyDj4MM;IACE,aAAA;EzDm4MR;EyDh4MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDi4MR;AACF;;AyDj9ME;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;ElC5BA,0CkC8BA;AzDk9MN;AuB5+MM;EkCYJ;IlCXM,gBAAA;EvB++MN;AACF;AyDr9MM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;AzDu9MR;AyDp9MM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;AzDs9MR;AyDn9MM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;AzDq9MR;AyDl9MM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;AzDo9MR;AyDj9MM;EAEE,eAAA;AzDk9MR;AyD/8MM;EAGE,mBAAA;AzD+8MR;;AyDp7MA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a3C0kCkC;E2CzkClC,YAAA;EACA,aAAA;EACA,sB3CgCS;AP4gNX;AkDziNE;EAAS,UAAA;AlD4iNX;AkD3iNE;EAAS,Y3Cu7CyB;APunKpC;;AyDh8MA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oEAAA;AzDm8MF;AyDj8ME;EACE,4FAAA;EACA,sDAAA;EACA,wDAAA;EACA,yDAAA;AzDm8MJ;;AyD/7MA;EACE,gBAAA;EACA,kDAAA;AzDk8MF;;AyD/7MA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;AzDk8MF;;A0DllNA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YnDwwCkC;AP60KpC;A0DnlNE;EACE,qBAAA;EACA,WAAA;A1DqlNJ;;A0DhlNA;EACE,iBAAA;A1DmlNF;;A0DhlNA;EACE,iBAAA;A1DmlNF;;A0DhlNA;EACE,iBAAA;A1DmlNF;;A0D9kNE;EACE,mDAAA;A1DilNJ;;A0D7kNA;EACE;IACE,YnD2uCgC;EPq2KlC;AACF;A0D7kNA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;A1D+kNF;;A0D5kNA;EACE;IACE,uBAAA;E1D+kNF;AACF;AuD9nNE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvDgoNJ;;A2DhoNE;EACE,sBAAA;EACA,wEAAA;A3DmoNJ;;A2DroNE;EACE,sBAAA;EACA,yEAAA;A3DwoNJ;;A2D1oNE;EACE,sBAAA;EACA,wEAAA;A3D6oNJ;;A2D/oNE;EACE,sBAAA;EACA,wEAAA;A3DkpNJ;;A2DppNE;EACE,yBAAA;EACA,wEAAA;A3DupNJ;;A2DzpNE;EACE,sBAAA;EACA,wEAAA;A3D4pNJ;;A2D9pNE;EACE,yBAAA;EACA,yEAAA;A3DiqNJ;;A2DnqNE;EACE,sBAAA;EACA,sEAAA;A3DsqNJ;;A2DxqNE;EACE,sBAAA;EACA,yEAAA;A3D2qNJ;;A2D7qNE;EACE,sBAAA;EACA,wEAAA;A3DgrNJ;;A4DtrNE;EACE,yBAAA;A5DyrNJ;A4DtrNM;EAEE,yCAAA;A5DurNR;;A4D7rNE;EACE,yBAAA;A5DgsNJ;A4D7rNM;EAEE,0CAAA;A5D8rNR;;A4DpsNE;EACE,yBAAA;A5DusNJ;A4DpsNM;EAEE,yCAAA;A5DqsNR;;A4D3sNE;EACE,yBAAA;A5D8sNJ;A4D3sNM;EAEE,4CAAA;A5D4sNR;;A4DltNE;EACE,yBAAA;A5DqtNJ;A4DltNM;EAEE,yCAAA;A5DmtNR;;A4DztNE;EACE,yBAAA;A5D4tNJ;A4DztNM;EAEE,0CAAA;A5D0tNR;;A4DhuNE;EACE,yBAAA;A5DmuNJ;A4DhuNM;EAEE,0CAAA;A5DiuNR;;A4DvuNE;EACE,yBAAA;A5D0uNJ;A4DvuNM;EAEE,uCAAA;A5DwuNR;;A4D9uNE;EACE,yBAAA;A5DivNJ;A4D9uNM;EAEE,0CAAA;A5D+uNR;;A4DrvNE;EACE,yBAAA;A5DwvNJ;A4DrvNM;EAEE,0CAAA;A5DsvNR;;A6D3vNA;EACE,kBAAA;EACA,WAAA;A7D8vNF;A6D5vNE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;A7D8vNJ;A6D3vNE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A7D6vNJ;;A6DxvNE;EACE,uBAAA;A7D2vNJ;;A6D5vNE;EACE,sBAAA;A7D+vNJ;;A6DhwNE;EACE,yBAAA;A7DmwNJ;;A6DpwNE;EACE,iCAAA;A7DuwNJ;;A8D5xNA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,avDukCkC;APwtLpC;;A8D5xNA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,avD+jCkC;APguLpC;;A8DvxNI;EACE,gBAAA;EACA,MAAA;EACA,avDmjC8B;APuuLpC;;A8DvxNI;EACE,gBAAA;EACA,SAAA;EACA,avD6iC8B;AP6uLpC;;Ae3vNI;E+CxCA;IACE,gBAAA;IACA,MAAA;IACA,avDmjC8B;EPovLlC;E8DpyNE;IACE,gBAAA;IACA,SAAA;IACA,avD6iC8B;EPyvLlC;AACF;AexwNI;E+CxCA;IACE,gBAAA;IACA,MAAA;IACA,avDmjC8B;EPgwLlC;E8DhzNE;IACE,gBAAA;IACA,SAAA;IACA,avD6iC8B;EPqwLlC;AACF;AepxNI;E+CxCA;IACE,gBAAA;IACA,MAAA;IACA,avDmjC8B;EP4wLlC;E8D5zNE;IACE,gBAAA;IACA,SAAA;IACA,avD6iC8B;EPixLlC;AACF;AehyNI;E+CxCA;IACE,gBAAA;IACA,MAAA;IACA,avDmjC8B;EPwxLlC;E8Dx0NE;IACE,gBAAA;IACA,SAAA;IACA,avD6iC8B;EP6xLlC;AACF;Ae5yNI;E+CxCA;IACE,gBAAA;IACA,MAAA;IACA,avDmjC8B;EPoyLlC;E8Dp1NE;IACE,gBAAA;IACA,SAAA;IACA,avD6iC8B;EPyyLlC;AACF;A+Dt3NA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;A/Dw3NF;;A+Dr3NA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;A/Dw3NF;;AgEh4NA;;ECIE,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AjEi4NF;;AkE54NE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U3D+bsC;E2D9btC,WAAA;AlE+4NJ;;AmEv5NA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;ApE25NF;;AqEj6NA;EACE,qBAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;EACA,8BAAA;EACA,a9DsqB4B;AP8vM9B;;AsEx2NQ;EAOI,mCAAA;AtEq2NZ;;AsE52NQ;EAOI,8BAAA;AtEy2NZ;;AsEh3NQ;EAOI,iCAAA;AtE62NZ;;AsEp3NQ;EAOI,iCAAA;AtEi3NZ;;AsEx3NQ;EAOI,sCAAA;AtEq3NZ;;AsE53NQ;EAOI,mCAAA;AtEy3NZ;;AsEh4NQ;EAOI,sBAAA;AtE63NZ;;AsEp4NQ;EAOI,uBAAA;AtEi4NZ;;AsEx4NQ;EAOI,sBAAA;AtEq4NZ;;AsE54NQ;EAOI,8BAAA;AtEy4NZ;;AsEh5NQ;EAOI,4BAAA;AtE64NZ;;AsEp5NQ;EAOI,2BAAA;AtEi5NZ;;AsEx5NQ;EAOI,iCAAA;AtEq5NZ;;AsE55NQ;EAOI,2BAAA;AtEy5NZ;;AsEh6NQ;EAOI,qBAAA;AtE65NZ;;AsEp6NQ;EAOI,wBAAA;AtEi6NZ;;AsEx6NQ;EAOI,uBAAA;AtEq6NZ;;AsE56NQ;EAOI,wBAAA;AtEy6NZ;;AsEh7NQ;EAOI,qBAAA;AtE66NZ;;AsEp7NQ;EAOI,yBAAA;AtEi7NZ;;AsEx7NQ;EAOI,2BAAA;AtEq7NZ;;AsE57NQ;EAOI,4BAAA;AtEy7NZ;;AsEh8NQ;EAOI,2BAAA;AtE67NZ;;AsEp8NQ;EAOI,2BAAA;AtEi8NZ;;AsEx8NQ;EAOI,6BAAA;AtEq8NZ;;AsE58NQ;EAOI,8BAAA;AtEy8NZ;;AsEh9NQ;EAOI,6BAAA;AtE68NZ;;AsEp9NQ;EAOI,2BAAA;AtEi9NZ;;AsEx9NQ;EAOI,6BAAA;AtEq9NZ;;AsE59NQ;EAOI,8BAAA;AtEy9NZ;;AsEh+NQ;EAOI,6BAAA;AtE69NZ;;AsEp+NQ;EAOI,0BAAA;AtEi+NZ;;AsEx+NQ;EAOI,gCAAA;AtEq+NZ;;AsE5+NQ;EAOI,yBAAA;AtEy+NZ;;AsEh/NQ;EAOI,wBAAA;AtE6+NZ;;AsEp/NQ;EAOI,yBAAA;AtEi/NZ;;AsEx/NQ;EAOI,6BAAA;AtEq/NZ;;AsE5/NQ;EAOI,8BAAA;AtEy/NZ;;AsEhgOQ;EAOI,wBAAA;AtE6/NZ;;AsEpgOQ;EAOI,+BAAA;AtEigOZ;;AsExgOQ;EAOI,wBAAA;AtEqgOZ;;AsE5gOQ;EAOI,2CAAA;AtEygOZ;;AsEhhOQ;EAOI,8CAAA;AtE6gOZ;;AsEphOQ;EAOI,8CAAA;AtEihOZ;;AsExhOQ;EAOI,2BAAA;AtEqhOZ;;AsE5hOQ;EAOI,2BAAA;AtEyhOZ;;AsEhiOQ;EAOI,6BAAA;AtE6hOZ;;AsEpiOQ;EAOI,6BAAA;AtEiiOZ;;AsExiOQ;EAOI,0BAAA;AtEqiOZ;;AsE5iOQ;EAOI,2BAAA;AtEyiOZ;;AsEhjOQ;EAOI,iBAAA;AtE6iOZ;;AsEpjOQ;EAOI,mBAAA;AtEijOZ;;AsExjOQ;EAOI,oBAAA;AtEqjOZ;;AsE5jOQ;EAOI,oBAAA;AtEyjOZ;;AsEhkOQ;EAOI,sBAAA;AtE6jOZ;;AsEpkOQ;EAOI,uBAAA;AtEikOZ;;AsExkOQ;EAOI,kBAAA;AtEqkOZ;;AsE5kOQ;EAOI,oBAAA;AtEykOZ;;AsEhlOQ;EAOI,qBAAA;AtE6kOZ;;AsEplOQ;EAOI,mBAAA;AtEilOZ;;AsExlOQ;EAOI,qBAAA;AtEqlOZ;;AsE5lOQ;EAOI,sBAAA;AtEylOZ;;AsEhmOQ;EAOI,2CAAA;AtE6lOZ;;AsEpmOQ;EAOI,sCAAA;AtEimOZ;;AsExmOQ;EAOI,sCAAA;AtEqmOZ;;AsE5mOQ;EAOI,uFAAA;AtEymOZ;;AsEhnOQ;EAOI,oBAAA;AtE6mOZ;;AsEpnOQ;EAOI,2FAAA;AtEinOZ;;AsExnOQ;EAOI,wBAAA;AtEqnOZ;;AsE5nOQ;EAOI,6FAAA;AtEynOZ;;AsEhoOQ;EAOI,0BAAA;AtE6nOZ;;AsEpoOQ;EAOI,8FAAA;AtEioOZ;;AsExoOQ;EAOI,2BAAA;AtEqoOZ;;AsE5oOQ;EAOI,4FAAA;AtEyoOZ;;AsEhpOQ;EAOI,yBAAA;AtE6oOZ;;AsEppOQ;EAIQ,sBAAA;EAGJ,8EAAA;AtEkpOZ;;AsEzpOQ;EAIQ,sBAAA;EAGJ,gFAAA;AtEupOZ;;AsE9pOQ;EAIQ,sBAAA;EAGJ,8EAAA;AtE4pOZ;;AsEnqOQ;EAIQ,sBAAA;EAGJ,2EAAA;AtEiqOZ;;AsExqOQ;EAIQ,sBAAA;EAGJ,8EAAA;AtEsqOZ;;AsE7qOQ;EAIQ,sBAAA;EAGJ,6EAAA;AtE2qOZ;;AsElrOQ;EAIQ,sBAAA;EAGJ,4EAAA;AtEgrOZ;;AsEvrOQ;EAIQ,sBAAA;EAGJ,2EAAA;AtEqrOZ;;AsE5rOQ;EAIQ,sBAAA;EAGJ,2EAAA;AtE0rOZ;;AsEjsOQ;EAIQ,sBAAA;EAGJ,2EAAA;AtE+rOZ;;AsEtsOQ;EAIQ,sBAAA;EAGJ,4EAAA;AtEosOZ;;AsE3sOQ;EAOI,wDAAA;AtEwsOZ;;AsE/sOQ;EAOI,0DAAA;AtE4sOZ;;AsEntOQ;EAOI,wDAAA;AtEgtOZ;;AsEvtOQ;EAOI,qDAAA;AtEotOZ;;AsE3tOQ;EAOI,wDAAA;AtEwtOZ;;AsE/tOQ;EAOI,uDAAA;AtE4tOZ;;AsEnuOQ;EAOI,sDAAA;AtEguOZ;;AsEvuOQ;EAOI,qDAAA;AtEouOZ;;AsErvOQ;EACE,oBAAA;AtEwvOV;;AsEzvOQ;EACE,sBAAA;AtE4vOV;;AsE7vOQ;EACE,sBAAA;AtEgwOV;;AsEjwOQ;EACE,sBAAA;AtEowOV;;AsErwOQ;EACE,sBAAA;AtEwwOV;;AsEzwOQ;EACE,sBAAA;AtE4wOV;;AsE7wOQ;EACE,wBAAA;AtEgxOV;;AsEjxOQ;EACE,yBAAA;AtEoxOV;;AsErxOQ;EACE,wBAAA;AtEwxOV;;AsEzxOQ;EACE,yBAAA;AtE4xOV;;AsE7xOQ;EACE,sBAAA;AtEgyOV;;AsEvxOQ;EAOI,qBAAA;AtEoxOZ;;AsE3xOQ;EAOI,qBAAA;AtEwxOZ;;AsE/xOQ;EAOI,qBAAA;AtE4xOZ;;AsEnyOQ;EAOI,sBAAA;AtEgyOZ;;AsEvyOQ;EAOI,sBAAA;AtEoyOZ;;AsE3yOQ;EAOI,0BAAA;AtEwyOZ;;AsE/yOQ;EAOI,uBAAA;AtE4yOZ;;AsEnzOQ;EAOI,2BAAA;AtEgzOZ;;AsEvzOQ;EAOI,sBAAA;AtEozOZ;;AsE3zOQ;EAOI,sBAAA;AtEwzOZ;;AsE/zOQ;EAOI,sBAAA;AtE4zOZ;;AsEn0OQ;EAOI,uBAAA;AtEg0OZ;;AsEv0OQ;EAOI,uBAAA;AtEo0OZ;;AsE30OQ;EAOI,2BAAA;AtEw0OZ;;AsE/0OQ;EAOI,wBAAA;AtE40OZ;;AsEn1OQ;EAOI,4BAAA;AtEg1OZ;;AsEv1OQ;EAOI,yBAAA;AtEo1OZ;;AsE31OQ;EAOI,8BAAA;AtEw1OZ;;AsE/1OQ;EAOI,iCAAA;AtE41OZ;;AsEn2OQ;EAOI,sCAAA;AtEg2OZ;;AsEv2OQ;EAOI,yCAAA;AtEo2OZ;;AsE32OQ;EAOI,uBAAA;AtEw2OZ;;AsE/2OQ;EAOI,uBAAA;AtE42OZ;;AsEn3OQ;EAOI,yBAAA;AtEg3OZ;;AsEv3OQ;EAOI,yBAAA;AtEo3OZ;;AsE33OQ;EAOI,0BAAA;AtEw3OZ;;AsE/3OQ;EAOI,4BAAA;AtE43OZ;;AsEn4OQ;EAOI,kCAAA;AtEg4OZ;;AsEv4OQ;EAOI,sCAAA;AtEo4OZ;;AsE34OQ;EAOI,oCAAA;AtEw4OZ;;AsE/4OQ;EAOI,kCAAA;AtE44OZ;;AsEn5OQ;EAOI,yCAAA;AtEg5OZ;;AsEv5OQ;EAOI,wCAAA;AtEo5OZ;;AsE35OQ;EAOI,wCAAA;AtEw5OZ;;AsE/5OQ;EAOI,kCAAA;AtE45OZ;;AsEn6OQ;EAOI,gCAAA;AtEg6OZ;;AsEv6OQ;EAOI,8BAAA;AtEo6OZ;;AsE36OQ;EAOI,gCAAA;AtEw6OZ;;AsE/6OQ;EAOI,+BAAA;AtE46OZ;;AsEn7OQ;EAOI,oCAAA;AtEg7OZ;;AsEv7OQ;EAOI,kCAAA;AtEo7OZ;;AsE37OQ;EAOI,gCAAA;AtEw7OZ;;AsE/7OQ;EAOI,uCAAA;AtE47OZ;;AsEn8OQ;EAOI,sCAAA;AtEg8OZ;;AsEv8OQ;EAOI,iCAAA;AtEo8OZ;;AsE38OQ;EAOI,2BAAA;AtEw8OZ;;AsE/8OQ;EAOI,iCAAA;AtE48OZ;;AsEn9OQ;EAOI,+BAAA;AtEg9OZ;;AsEv9OQ;EAOI,6BAAA;AtEo9OZ;;AsE39OQ;EAOI,+BAAA;AtEw9OZ;;AsE/9OQ;EAOI,8BAAA;AtE49OZ;;AsEn+OQ;EAOI,oBAAA;AtEg+OZ;;AsEv+OQ;EAOI,mBAAA;AtEo+OZ;;AsE3+OQ;EAOI,mBAAA;AtEw+OZ;;AsE/+OQ;EAOI,mBAAA;AtE4+OZ;;AsEn/OQ;EAOI,mBAAA;AtEg/OZ;;AsEv/OQ;EAOI,mBAAA;AtEo/OZ;;AsE3/OQ;EAOI,mBAAA;AtEw/OZ;;AsE//OQ;EAOI,mBAAA;AtE4/OZ;;AsEngPQ;EAOI,oBAAA;AtEggPZ;;AsEvgPQ;EAOI,2BAAA;AtEogPZ;;AsE3gPQ;EAOI,0BAAA;AtEwgPZ;;AsE/gPQ;EAOI,yBAAA;AtE4gPZ;;AsEnhPQ;EAOI,0BAAA;AtEghPZ;;AsEvhPQ;EAOI,yBAAA;AtEohPZ;;AsE3hPQ;EAOI,uBAAA;AtEwhPZ;;AsE/hPQ;EAOI,0BAAA;EAAA,yBAAA;AtE6hPZ;;AsEpiPQ;EAOI,iCAAA;EAAA,gCAAA;AtEkiPZ;;AsEziPQ;EAOI,gCAAA;EAAA,+BAAA;AtEuiPZ;;AsE9iPQ;EAOI,+BAAA;EAAA,8BAAA;AtE4iPZ;;AsEnjPQ;EAOI,gCAAA;EAAA,+BAAA;AtEijPZ;;AsExjPQ;EAOI,+BAAA;EAAA,8BAAA;AtEsjPZ;;AsE7jPQ;EAOI,6BAAA;EAAA,4BAAA;AtE2jPZ;;AsElkPQ;EAOI,wBAAA;EAAA,2BAAA;AtEgkPZ;;AsEvkPQ;EAOI,+BAAA;EAAA,kCAAA;AtEqkPZ;;AsE5kPQ;EAOI,8BAAA;EAAA,iCAAA;AtE0kPZ;;AsEjlPQ;EAOI,6BAAA;EAAA,gCAAA;AtE+kPZ;;AsEtlPQ;EAOI,8BAAA;EAAA,iCAAA;AtEolPZ;;AsE3lPQ;EAOI,6BAAA;EAAA,gCAAA;AtEylPZ;;AsEhmPQ;EAOI,2BAAA;EAAA,8BAAA;AtE8lPZ;;AsErmPQ;EAOI,wBAAA;AtEkmPZ;;AsEzmPQ;EAOI,+BAAA;AtEsmPZ;;AsE7mPQ;EAOI,8BAAA;AtE0mPZ;;AsEjnPQ;EAOI,6BAAA;AtE8mPZ;;AsErnPQ;EAOI,8BAAA;AtEknPZ;;AsEznPQ;EAOI,6BAAA;AtEsnPZ;;AsE7nPQ;EAOI,2BAAA;AtE0nPZ;;AsEjoPQ;EAOI,0BAAA;AtE8nPZ;;AsEroPQ;EAOI,iCAAA;AtEkoPZ;;AsEzoPQ;EAOI,gCAAA;AtEsoPZ;;AsE7oPQ;EAOI,+BAAA;AtE0oPZ;;AsEjpPQ;EAOI,gCAAA;AtE8oPZ;;AsErpPQ;EAOI,+BAAA;AtEkpPZ;;AsEzpPQ;EAOI,6BAAA;AtEspPZ;;AsE7pPQ;EAOI,2BAAA;AtE0pPZ;;AsEjqPQ;EAOI,kCAAA;AtE8pPZ;;AsErqPQ;EAOI,iCAAA;AtEkqPZ;;AsEzqPQ;EAOI,gCAAA;AtEsqPZ;;AsE7qPQ;EAOI,iCAAA;AtE0qPZ;;AsEjrPQ;EAOI,gCAAA;AtE8qPZ;;AsErrPQ;EAOI,8BAAA;AtEkrPZ;;AsEzrPQ;EAOI,yBAAA;AtEsrPZ;;AsE7rPQ;EAOI,gCAAA;AtE0rPZ;;AsEjsPQ;EAOI,+BAAA;AtE8rPZ;;AsErsPQ;EAOI,8BAAA;AtEksPZ;;AsEzsPQ;EAOI,+BAAA;AtEssPZ;;AsE7sPQ;EAOI,8BAAA;AtE0sPZ;;AsEjtPQ;EAOI,4BAAA;AtE8sPZ;;AsErtPQ;EAOI,4BAAA;AtEktPZ;;AsEztPQ;EAOI,2BAAA;AtEstPZ;;AsE7tPQ;EAOI,0BAAA;AtE0tPZ;;AsEjuPQ;EAOI,2BAAA;AtE8tPZ;;AsEruPQ;EAOI,0BAAA;AtEkuPZ;;AsEzuPQ;EAOI,kCAAA;EAAA,iCAAA;AtEuuPZ;;AsE9uPQ;EAOI,iCAAA;EAAA,gCAAA;AtE4uPZ;;AsEnvPQ;EAOI,gCAAA;EAAA,+BAAA;AtEivPZ;;AsExvPQ;EAOI,iCAAA;EAAA,gCAAA;AtEsvPZ;;AsE7vPQ;EAOI,gCAAA;EAAA,+BAAA;AtE2vPZ;;AsElwPQ;EAOI,gCAAA;EAAA,mCAAA;AtEgwPZ;;AsEvwPQ;EAOI,+BAAA;EAAA,kCAAA;AtEqwPZ;;AsE5wPQ;EAOI,8BAAA;EAAA,iCAAA;AtE0wPZ;;AsEjxPQ;EAOI,+BAAA;EAAA,kCAAA;AtE+wPZ;;AsEtxPQ;EAOI,8BAAA;EAAA,iCAAA;AtEoxPZ;;AsE3xPQ;EAOI,gCAAA;AtEwxPZ;;AsE/xPQ;EAOI,+BAAA;AtE4xPZ;;AsEnyPQ;EAOI,8BAAA;AtEgyPZ;;AsEvyPQ;EAOI,+BAAA;AtEoyPZ;;AsE3yPQ;EAOI,8BAAA;AtEwyPZ;;AsE/yPQ;EAOI,kCAAA;AtE4yPZ;;AsEnzPQ;EAOI,iCAAA;AtEgzPZ;;AsEvzPQ;EAOI,gCAAA;AtEozPZ;;AsE3zPQ;EAOI,iCAAA;AtEwzPZ;;AsE/zPQ;EAOI,gCAAA;AtE4zPZ;;AsEn0PQ;EAOI,mCAAA;AtEg0PZ;;AsEv0PQ;EAOI,kCAAA;AtEo0PZ;;AsE30PQ;EAOI,iCAAA;AtEw0PZ;;AsE/0PQ;EAOI,kCAAA;AtE40PZ;;AsEn1PQ;EAOI,iCAAA;AtEg1PZ;;AsEv1PQ;EAOI,iCAAA;AtEo1PZ;;AsE31PQ;EAOI,gCAAA;AtEw1PZ;;AsE/1PQ;EAOI,+BAAA;AtE41PZ;;AsEn2PQ;EAOI,gCAAA;AtEg2PZ;;AsEv2PQ;EAOI,+BAAA;AtEo2PZ;;AsE32PQ;EAOI,qBAAA;AtEw2PZ;;AsE/2PQ;EAOI,4BAAA;AtE42PZ;;AsEn3PQ;EAOI,2BAAA;AtEg3PZ;;AsEv3PQ;EAOI,0BAAA;AtEo3PZ;;AsE33PQ;EAOI,2BAAA;AtEw3PZ;;AsE/3PQ;EAOI,0BAAA;AtE43PZ;;AsEn4PQ;EAOI,2BAAA;EAAA,0BAAA;AtEi4PZ;;AsEx4PQ;EAOI,kCAAA;EAAA,iCAAA;AtEs4PZ;;AsE74PQ;EAOI,iCAAA;EAAA,gCAAA;AtE24PZ;;AsEl5PQ;EAOI,gCAAA;EAAA,+BAAA;AtEg5PZ;;AsEv5PQ;EAOI,iCAAA;EAAA,gCAAA;AtEq5PZ;;AsE55PQ;EAOI,gCAAA;EAAA,+BAAA;AtE05PZ;;AsEj6PQ;EAOI,yBAAA;EAAA,4BAAA;AtE+5PZ;;AsEt6PQ;EAOI,gCAAA;EAAA,mCAAA;AtEo6PZ;;AsE36PQ;EAOI,+BAAA;EAAA,kCAAA;AtEy6PZ;;AsEh7PQ;EAOI,8BAAA;EAAA,iCAAA;AtE86PZ;;AsEr7PQ;EAOI,+BAAA;EAAA,kCAAA;AtEm7PZ;;AsE17PQ;EAOI,8BAAA;EAAA,iCAAA;AtEw7PZ;;AsE/7PQ;EAOI,yBAAA;AtE47PZ;;AsEn8PQ;EAOI,gCAAA;AtEg8PZ;;AsEv8PQ;EAOI,+BAAA;AtEo8PZ;;AsE38PQ;EAOI,8BAAA;AtEw8PZ;;AsE/8PQ;EAOI,+BAAA;AtE48PZ;;AsEn9PQ;EAOI,8BAAA;AtEg9PZ;;AsEv9PQ;EAOI,2BAAA;AtEo9PZ;;AsE39PQ;EAOI,kCAAA;AtEw9PZ;;AsE/9PQ;EAOI,iCAAA;AtE49PZ;;AsEn+PQ;EAOI,gCAAA;AtEg+PZ;;AsEv+PQ;EAOI,iCAAA;AtEo+PZ;;AsE3+PQ;EAOI,gCAAA;AtEw+PZ;;AsE/+PQ;EAOI,4BAAA;AtE4+PZ;;AsEn/PQ;EAOI,mCAAA;AtEg/PZ;;AsEv/PQ;EAOI,kCAAA;AtEo/PZ;;AsE3/PQ;EAOI,iCAAA;AtEw/PZ;;AsE//PQ;EAOI,kCAAA;AtE4/PZ;;AsEngQQ;EAOI,iCAAA;AtEggQZ;;AsEvgQQ;EAOI,0BAAA;AtEogQZ;;AsE3gQQ;EAOI,iCAAA;AtEwgQZ;;AsE/gQQ;EAOI,gCAAA;AtE4gQZ;;AsEnhQQ;EAOI,+BAAA;AtEghQZ;;AsEvhQQ;EAOI,gCAAA;AtEohQZ;;AsE3hQQ;EAOI,+BAAA;AtEwhQZ;;AsE/hQQ;EAOI,iBAAA;AtE4hQZ;;AsEniQQ;EAOI,wBAAA;AtEgiQZ;;AsEviQQ;EAOI,uBAAA;AtEoiQZ;;AsE3iQQ;EAOI,sBAAA;AtEwiQZ;;AsE/iQQ;EAOI,uBAAA;AtE4iQZ;;AsEnjQQ;EAOI,sBAAA;AtEgjQZ;;AsEvjQQ;EAOI,qBAAA;AtEojQZ;;AsE3jQQ;EAOI,4BAAA;AtEwjQZ;;AsE/jQQ;EAOI,2BAAA;AtE4jQZ;;AsEnkQQ;EAOI,0BAAA;AtEgkQZ;;AsEvkQQ;EAOI,2BAAA;AtEokQZ;;AsE3kQQ;EAOI,0BAAA;AtEwkQZ;;AsE/kQQ;EAOI,wBAAA;AtE4kQZ;;AsEnlQQ;EAOI,+BAAA;AtEglQZ;;AsEvlQQ;EAOI,8BAAA;AtEolQZ;;AsE3lQQ;EAOI,6BAAA;AtEwlQZ;;AsE/lQQ;EAOI,8BAAA;AtE4lQZ;;AsEnmQQ;EAOI,6BAAA;AtEgmQZ;;AsEvmQQ;EAOI,gDAAA;AtEomQZ;;AsE3mQQ;EAOI,2CAAA;AtEwmQZ;;AsE/mQQ;EAOI,8CAAA;AtE4mQZ;;AsEnnQQ;EAOI,4CAAA;AtEgnQZ;;AsEvnQQ;EAOI,8BAAA;AtEonQZ;;AsE3nQQ;EAOI,+BAAA;AtEwnQZ;;AsE/nQQ;EAOI,6BAAA;AtE4nQZ;;AsEnoQQ;EAOI,6BAAA;AtEgoQZ;;AsEvoQQ;EAOI,6BAAA;AtEooQZ;;AsE3oQQ;EAOI,+BAAA;AtEwoQZ;;AsE/oQQ;EAOI,2BAAA;AtE4oQZ;;AsEnpQQ;EAOI,2BAAA;AtEgpQZ;;AsEvpQQ;EAOI,2BAAA;AtEopQZ;;AsE3pQQ;EAOI,2BAAA;AtEwpQZ;;AsE/pQQ;EAOI,2BAAA;AtE4pQZ;;AsEnqQQ;EAOI,8BAAA;AtEgqQZ;;AsEvqQQ;EAOI,yBAAA;AtEoqQZ;;AsE3qQQ;EAOI,4BAAA;AtEwqQZ;;AsE/qQQ;EAOI,2BAAA;AtE4qQZ;;AsEnrQQ;EAOI,yBAAA;AtEgrQZ;;AsEvrQQ;EAOI,2BAAA;AtEorQZ;;AsE3rQQ;EAOI,4BAAA;AtEwrQZ;;AsE/rQQ;EAOI,6BAAA;AtE4rQZ;;AsEnsQQ;EAOI,gCAAA;AtEgsQZ;;AsEvsQQ;EAOI,qCAAA;AtEosQZ;;AsE3sQQ;EAOI,wCAAA;AtEwsQZ;;AsE/sQQ;EAOI,oCAAA;AtE4sQZ;;AsEntQQ;EAOI,oCAAA;AtEgtQZ;;AsEvtQQ;EAOI,qCAAA;AtEotQZ;;AsE3tQQ;EAOI,8BAAA;AtEwtQZ;;AsE/tQQ;EAOI,8BAAA;AtE4tQZ;;AsEjvQQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AtEkuQZ;;AsE/sQQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;AtEwuQZ;;AsE/uQQ;EAIQ,oBAAA;EAGJ,uEAAA;AtE6uQZ;;AsEpvQQ;EAIQ,oBAAA;EAGJ,qEAAA;AtEkvQZ;;AsEzvQQ;EAIQ,oBAAA;EAGJ,kEAAA;AtEuvQZ;;AsE9vQQ;EAIQ,oBAAA;EAGJ,qEAAA;AtE4vQZ;;AsEnwQQ;EAIQ,oBAAA;EAGJ,oEAAA;AtEiwQZ;;AsExwQQ;EAIQ,oBAAA;EAGJ,mEAAA;AtEswQZ;;AsE7wQQ;EAIQ,oBAAA;EAGJ,kEAAA;AtE2wQZ;;AsElxQQ;EAIQ,oBAAA;EAGJ,kEAAA;AtEgxQZ;;AsEvxQQ;EAIQ,oBAAA;EAGJ,kEAAA;AtEqxQZ;;AsE5xQQ;EAIQ,oBAAA;EAGJ,mEAAA;AtE0xQZ;;AsEjyQQ;EAIQ,oBAAA;EAGJ,mEAAA;AtE+xQZ;;AsEtyQQ;EAIQ,oBAAA;EAGJ,wEAAA;AtEoyQZ;;AsE3yQQ;EAIQ,oBAAA;EAGJ,gCAAA;AtEyyQZ;;AsEhzQQ;EAIQ,oBAAA;EAGJ,oCAAA;AtE8yQZ;;AsErzQQ;EAIQ,oBAAA;EAGJ,0CAAA;AtEmzQZ;;AsE1zQQ;EAIQ,oBAAA;EAGJ,2CAAA;AtEwzQZ;;AsE/zQQ;EAIQ,oBAAA;EAGJ,0CAAA;AtE6zQZ;;AsEp0QQ;EAIQ,oBAAA;EAGJ,0CAAA;AtEk0QZ;;AsEz0QQ;EAIQ,oBAAA;EAGJ,yBAAA;AtEu0QZ;;AsEx1QQ;EACE,uBAAA;AtE21QV;;AsE51QQ;EACE,sBAAA;AtE+1QV;;AsEh2QQ;EACE,uBAAA;AtEm2QV;;AsEp2QQ;EACE,oBAAA;AtEu2QV;;AsE91QQ;EAOI,wCAAA;AtE21QZ;;AsEl2QQ;EAOI,0CAAA;AtE+1QZ;;AsEt2QQ;EAOI,wCAAA;AtEm2QZ;;AsE12QQ;EAOI,qCAAA;AtEu2QZ;;AsE92QQ;EAOI,wCAAA;AtE22QZ;;AsEl3QQ;EAOI,uCAAA;AtE+2QZ;;AsEt3QQ;EAOI,sCAAA;AtEm3QZ;;AsE13QQ;EAOI,qCAAA;AtEu3QZ;;AsE93QQ;EAIQ,kBAAA;EAGJ,8EAAA;AtE43QZ;;AsEn4QQ;EAIQ,kBAAA;EAGJ,gFAAA;AtEi4QZ;;AsEx4QQ;EAIQ,kBAAA;EAGJ,8EAAA;AtEs4QZ;;AsE74QQ;EAIQ,kBAAA;EAGJ,2EAAA;AtE24QZ;;AsEl5QQ;EAIQ,kBAAA;EAGJ,8EAAA;AtEg5QZ;;AsEv5QQ;EAIQ,kBAAA;EAGJ,6EAAA;AtEq5QZ;;AsE55QQ;EAIQ,kBAAA;EAGJ,4EAAA;AtE05QZ;;AsEj6QQ;EAIQ,kBAAA;EAGJ,2EAAA;AtE+5QZ;;AsEt6QQ;EAIQ,kBAAA;EAGJ,2EAAA;AtEo6QZ;;AsE36QQ;EAIQ,kBAAA;EAGJ,2EAAA;AtEy6QZ;;AsEh7QQ;EAIQ,kBAAA;EAGJ,4EAAA;AtE86QZ;;AsEr7QQ;EAIQ,kBAAA;EAGJ,4EAAA;AtEm7QZ;;AsE17QQ;EAIQ,kBAAA;EAGJ,8EAAA;AtEw7QZ;;AsE/7QQ;EAIQ,kBAAA;EAGJ,wCAAA;AtE67QZ;;AsEp8QQ;EAIQ,kBAAA;EAGJ,mFAAA;AtEk8QZ;;AsEz8QQ;EAIQ,kBAAA;EAGJ,kFAAA;AtEu8QZ;;AsE98QQ;EAIQ,kBAAA;EAGJ,kFAAA;AtE48QZ;;AsE79QQ;EACE,oBAAA;AtEg+QV;;AsEj+QQ;EACE,qBAAA;AtEo+QV;;AsEr+QQ;EACE,oBAAA;AtEw+QV;;AsEz+QQ;EACE,qBAAA;AtE4+QV;;AsE7+QQ;EACE,kBAAA;AtEg/QV;;AsEv+QQ;EAOI,wDAAA;AtEo+QZ;;AsE3+QQ;EAOI,0DAAA;AtEw+QZ;;AsE/+QQ;EAOI,wDAAA;AtE4+QZ;;AsEn/QQ;EAOI,qDAAA;AtEg/QZ;;AsEv/QQ;EAOI,wDAAA;AtEo/QZ;;AsE3/QQ;EAOI,uDAAA;AtEw/QZ;;AsE//QQ;EAOI,sDAAA;AtE4/QZ;;AsEngRQ;EAOI,qDAAA;AtEggRZ;;AsEvgRQ;EAOI,+CAAA;AtEogRZ;;AsE3gRQ;EAOI,mCAAA;UAAA,2BAAA;AtEwgRZ;;AsE/gRQ;EAOI,oCAAA;UAAA,4BAAA;AtE4gRZ;;AsEnhRQ;EAOI,oCAAA;UAAA,4BAAA;AtEghRZ;;AsEvhRQ;EAOI,+BAAA;AtEohRZ;;AsE3hRQ;EAOI,+BAAA;AtEwhRZ;;AsE/hRQ;EAOI,iDAAA;AtE4hRZ;;AsEniRQ;EAOI,2BAAA;AtEgiRZ;;AsEviRQ;EAOI,oDAAA;AtEoiRZ;;AsE3iRQ;EAOI,iDAAA;AtEwiRZ;;AsE/iRQ;EAOI,oDAAA;AtE4iRZ;;AsEnjRQ;EAOI,oDAAA;AtEgjRZ;;AsEvjRQ;EAOI,qDAAA;AtEojRZ;;AsE3jRQ;EAOI,6BAAA;AtEwjRZ;;AsE/jRQ;EAOI,sDAAA;AtE4jRZ;;AsEnkRQ;EAOI,0DAAA;EAAA,2DAAA;AtEikRZ;;AsExkRQ;EAOI,oCAAA;EAAA,qCAAA;AtEskRZ;;AsE7kRQ;EAOI,6DAAA;EAAA,8DAAA;AtE2kRZ;;AsEllRQ;EAOI,0DAAA;EAAA,2DAAA;AtEglRZ;;AsEvlRQ;EAOI,6DAAA;EAAA,8DAAA;AtEqlRZ;;AsE5lRQ;EAOI,6DAAA;EAAA,8DAAA;AtE0lRZ;;AsEjmRQ;EAOI,8DAAA;EAAA,+DAAA;AtE+lRZ;;AsEtmRQ;EAOI,sCAAA;EAAA,uCAAA;AtEomRZ;;AsE3mRQ;EAOI,+DAAA;EAAA,gEAAA;AtEymRZ;;AsEhnRQ;EAOI,2DAAA;EAAA,8DAAA;AtE8mRZ;;AsErnRQ;EAOI,qCAAA;EAAA,wCAAA;AtEmnRZ;;AsE1nRQ;EAOI,8DAAA;EAAA,iEAAA;AtEwnRZ;;AsE/nRQ;EAOI,2DAAA;EAAA,8DAAA;AtE6nRZ;;AsEpoRQ;EAOI,8DAAA;EAAA,iEAAA;AtEkoRZ;;AsEzoRQ;EAOI,8DAAA;EAAA,iEAAA;AtEuoRZ;;AsE9oRQ;EAOI,+DAAA;EAAA,kEAAA;AtE4oRZ;;AsEnpRQ;EAOI,uCAAA;EAAA,0CAAA;AtEipRZ;;AsExpRQ;EAOI,gEAAA;EAAA,mEAAA;AtEspRZ;;AsE7pRQ;EAOI,8DAAA;EAAA,6DAAA;AtE2pRZ;;AsElqRQ;EAOI,wCAAA;EAAA,uCAAA;AtEgqRZ;;AsEvqRQ;EAOI,iEAAA;EAAA,gEAAA;AtEqqRZ;;AsE5qRQ;EAOI,8DAAA;EAAA,6DAAA;AtE0qRZ;;AsEjrRQ;EAOI,iEAAA;EAAA,gEAAA;AtE+qRZ;;AsEtrRQ;EAOI,iEAAA;EAAA,gEAAA;AtEorRZ;;AsE3rRQ;EAOI,kEAAA;EAAA,iEAAA;AtEyrRZ;;AsEhsRQ;EAOI,0CAAA;EAAA,yCAAA;AtE8rRZ;;AsErsRQ;EAOI,mEAAA;EAAA,kEAAA;AtEmsRZ;;AsE1sRQ;EAOI,6DAAA;EAAA,0DAAA;AtEwsRZ;;AsE/sRQ;EAOI,uCAAA;EAAA,oCAAA;AtE6sRZ;;AsEptRQ;EAOI,gEAAA;EAAA,6DAAA;AtEktRZ;;AsEztRQ;EAOI,6DAAA;EAAA,0DAAA;AtEutRZ;;AsE9tRQ;EAOI,gEAAA;EAAA,6DAAA;AtE4tRZ;;AsEnuRQ;EAOI,gEAAA;EAAA,6DAAA;AtEiuRZ;;AsExuRQ;EAOI,iEAAA;EAAA,8DAAA;AtEsuRZ;;AsE7uRQ;EAOI,yCAAA;EAAA,sCAAA;AtE2uRZ;;AsElvRQ;EAOI,kEAAA;EAAA,+DAAA;AtEgvRZ;;AsEvvRQ;EAOI,8BAAA;AtEovRZ;;AsE3vRQ;EAOI,6BAAA;AtEwvRZ;;AsE/vRQ;EAOI,sBAAA;AtE4vRZ;;AsEnwRQ;EAOI,qBAAA;AtEgwRZ;;AsEvwRQ;EAOI,qBAAA;AtEowRZ;;AsE3wRQ;EAOI,qBAAA;AtEwwRZ;;AsE/wRQ;EAOI,qBAAA;AtE4wRZ;;AetxRI;EuDGI;IAOI,sBAAA;EtEixRV;EsExxRM;IAOI,uBAAA;EtEoxRV;EsE3xRM;IAOI,sBAAA;EtEuxRV;EsE9xRM;IAOI,8BAAA;EtE0xRV;EsEjyRM;IAOI,4BAAA;EtE6xRV;EsEpyRM;IAOI,2BAAA;EtEgyRV;EsEvyRM;IAOI,iCAAA;EtEmyRV;EsE1yRM;IAOI,2BAAA;EtEsyRV;EsE7yRM;IAOI,0BAAA;EtEyyRV;EsEhzRM;IAOI,gCAAA;EtE4yRV;EsEnzRM;IAOI,yBAAA;EtE+yRV;EsEtzRM;IAOI,wBAAA;EtEkzRV;EsEzzRM;IAOI,yBAAA;EtEqzRV;EsE5zRM;IAOI,6BAAA;EtEwzRV;EsE/zRM;IAOI,8BAAA;EtE2zRV;EsEl0RM;IAOI,wBAAA;EtE8zRV;EsEr0RM;IAOI,+BAAA;EtEi0RV;EsEx0RM;IAOI,wBAAA;EtEo0RV;EsE30RM;IAOI,yBAAA;EtEu0RV;EsE90RM;IAOI,8BAAA;EtE00RV;EsEj1RM;IAOI,iCAAA;EtE60RV;EsEp1RM;IAOI,sCAAA;EtEg1RV;EsEv1RM;IAOI,yCAAA;EtEm1RV;EsE11RM;IAOI,uBAAA;EtEs1RV;EsE71RM;IAOI,uBAAA;EtEy1RV;EsEh2RM;IAOI,yBAAA;EtE41RV;EsEn2RM;IAOI,yBAAA;EtE+1RV;EsEt2RM;IAOI,0BAAA;EtEk2RV;EsEz2RM;IAOI,4BAAA;EtEq2RV;EsE52RM;IAOI,kCAAA;EtEw2RV;EsE/2RM;IAOI,sCAAA;EtE22RV;EsEl3RM;IAOI,oCAAA;EtE82RV;EsEr3RM;IAOI,kCAAA;EtEi3RV;EsEx3RM;IAOI,yCAAA;EtEo3RV;EsE33RM;IAOI,wCAAA;EtEu3RV;EsE93RM;IAOI,wCAAA;EtE03RV;EsEj4RM;IAOI,kCAAA;EtE63RV;EsEp4RM;IAOI,gCAAA;EtEg4RV;EsEv4RM;IAOI,8BAAA;EtEm4RV;EsE14RM;IAOI,gCAAA;EtEs4RV;EsE74RM;IAOI,+BAAA;EtEy4RV;EsEh5RM;IAOI,oCAAA;EtE44RV;EsEn5RM;IAOI,kCAAA;EtE+4RV;EsEt5RM;IAOI,gCAAA;EtEk5RV;EsEz5RM;IAOI,uCAAA;EtEq5RV;EsE55RM;IAOI,sCAAA;EtEw5RV;EsE/5RM;IAOI,iCAAA;EtE25RV;EsEl6RM;IAOI,2BAAA;EtE85RV;EsEr6RM;IAOI,iCAAA;EtEi6RV;EsEx6RM;IAOI,+BAAA;EtEo6RV;EsE36RM;IAOI,6BAAA;EtEu6RV;EsE96RM;IAOI,+BAAA;EtE06RV;EsEj7RM;IAOI,8BAAA;EtE66RV;EsEp7RM;IAOI,oBAAA;EtEg7RV;EsEv7RM;IAOI,mBAAA;EtEm7RV;EsE17RM;IAOI,mBAAA;EtEs7RV;EsE77RM;IAOI,mBAAA;EtEy7RV;EsEh8RM;IAOI,mBAAA;EtE47RV;EsEn8RM;IAOI,mBAAA;EtE+7RV;EsEt8RM;IAOI,mBAAA;EtEk8RV;EsEz8RM;IAOI,mBAAA;EtEq8RV;EsE58RM;IAOI,oBAAA;EtEw8RV;EsE/8RM;IAOI,2BAAA;EtE28RV;EsEl9RM;IAOI,0BAAA;EtE88RV;EsEr9RM;IAOI,yBAAA;EtEi9RV;EsEx9RM;IAOI,0BAAA;EtEo9RV;EsE39RM;IAOI,yBAAA;EtEu9RV;EsE99RM;IAOI,uBAAA;EtE09RV;EsEj+RM;IAOI,0BAAA;IAAA,yBAAA;EtE89RV;EsEr+RM;IAOI,iCAAA;IAAA,gCAAA;EtEk+RV;EsEz+RM;IAOI,gCAAA;IAAA,+BAAA;EtEs+RV;EsE7+RM;IAOI,+BAAA;IAAA,8BAAA;EtE0+RV;EsEj/RM;IAOI,gCAAA;IAAA,+BAAA;EtE8+RV;EsEr/RM;IAOI,+BAAA;IAAA,8BAAA;EtEk/RV;EsEz/RM;IAOI,6BAAA;IAAA,4BAAA;EtEs/RV;EsE7/RM;IAOI,wBAAA;IAAA,2BAAA;EtE0/RV;EsEjgSM;IAOI,+BAAA;IAAA,kCAAA;EtE8/RV;EsErgSM;IAOI,8BAAA;IAAA,iCAAA;EtEkgSV;EsEzgSM;IAOI,6BAAA;IAAA,gCAAA;EtEsgSV;EsE7gSM;IAOI,8BAAA;IAAA,iCAAA;EtE0gSV;EsEjhSM;IAOI,6BAAA;IAAA,gCAAA;EtE8gSV;EsErhSM;IAOI,2BAAA;IAAA,8BAAA;EtEkhSV;EsEzhSM;IAOI,wBAAA;EtEqhSV;EsE5hSM;IAOI,+BAAA;EtEwhSV;EsE/hSM;IAOI,8BAAA;EtE2hSV;EsEliSM;IAOI,6BAAA;EtE8hSV;EsEriSM;IAOI,8BAAA;EtEiiSV;EsExiSM;IAOI,6BAAA;EtEoiSV;EsE3iSM;IAOI,2BAAA;EtEuiSV;EsE9iSM;IAOI,0BAAA;EtE0iSV;EsEjjSM;IAOI,iCAAA;EtE6iSV;EsEpjSM;IAOI,gCAAA;EtEgjSV;EsEvjSM;IAOI,+BAAA;EtEmjSV;EsE1jSM;IAOI,gCAAA;EtEsjSV;EsE7jSM;IAOI,+BAAA;EtEyjSV;EsEhkSM;IAOI,6BAAA;EtE4jSV;EsEnkSM;IAOI,2BAAA;EtE+jSV;EsEtkSM;IAOI,kCAAA;EtEkkSV;EsEzkSM;IAOI,iCAAA;EtEqkSV;EsE5kSM;IAOI,gCAAA;EtEwkSV;EsE/kSM;IAOI,iCAAA;EtE2kSV;EsEllSM;IAOI,gCAAA;EtE8kSV;EsErlSM;IAOI,8BAAA;EtEilSV;EsExlSM;IAOI,yBAAA;EtEolSV;EsE3lSM;IAOI,gCAAA;EtEulSV;EsE9lSM;IAOI,+BAAA;EtE0lSV;EsEjmSM;IAOI,8BAAA;EtE6lSV;EsEpmSM;IAOI,+BAAA;EtEgmSV;EsEvmSM;IAOI,8BAAA;EtEmmSV;EsE1mSM;IAOI,4BAAA;EtEsmSV;EsE7mSM;IAOI,4BAAA;EtEymSV;EsEhnSM;IAOI,2BAAA;EtE4mSV;EsEnnSM;IAOI,0BAAA;EtE+mSV;EsEtnSM;IAOI,2BAAA;EtEknSV;EsEznSM;IAOI,0BAAA;EtEqnSV;EsE5nSM;IAOI,kCAAA;IAAA,iCAAA;EtEynSV;EsEhoSM;IAOI,iCAAA;IAAA,gCAAA;EtE6nSV;EsEpoSM;IAOI,gCAAA;IAAA,+BAAA;EtEioSV;EsExoSM;IAOI,iCAAA;IAAA,gCAAA;EtEqoSV;EsE5oSM;IAOI,gCAAA;IAAA,+BAAA;EtEyoSV;EsEhpSM;IAOI,gCAAA;IAAA,mCAAA;EtE6oSV;EsEppSM;IAOI,+BAAA;IAAA,kCAAA;EtEipSV;EsExpSM;IAOI,8BAAA;IAAA,iCAAA;EtEqpSV;EsE5pSM;IAOI,+BAAA;IAAA,kCAAA;EtEypSV;EsEhqSM;IAOI,8BAAA;IAAA,iCAAA;EtE6pSV;EsEpqSM;IAOI,gCAAA;EtEgqSV;EsEvqSM;IAOI,+BAAA;EtEmqSV;EsE1qSM;IAOI,8BAAA;EtEsqSV;EsE7qSM;IAOI,+BAAA;EtEyqSV;EsEhrSM;IAOI,8BAAA;EtE4qSV;EsEnrSM;IAOI,kCAAA;EtE+qSV;EsEtrSM;IAOI,iCAAA;EtEkrSV;EsEzrSM;IAOI,gCAAA;EtEqrSV;EsE5rSM;IAOI,iCAAA;EtEwrSV;EsE/rSM;IAOI,gCAAA;EtE2rSV;EsElsSM;IAOI,mCAAA;EtE8rSV;EsErsSM;IAOI,kCAAA;EtEisSV;EsExsSM;IAOI,iCAAA;EtEosSV;EsE3sSM;IAOI,kCAAA;EtEusSV;EsE9sSM;IAOI,iCAAA;EtE0sSV;EsEjtSM;IAOI,iCAAA;EtE6sSV;EsEptSM;IAOI,gCAAA;EtEgtSV;EsEvtSM;IAOI,+BAAA;EtEmtSV;EsE1tSM;IAOI,gCAAA;EtEstSV;EsE7tSM;IAOI,+BAAA;EtEytSV;EsEhuSM;IAOI,qBAAA;EtE4tSV;EsEnuSM;IAOI,4BAAA;EtE+tSV;EsEtuSM;IAOI,2BAAA;EtEkuSV;EsEzuSM;IAOI,0BAAA;EtEquSV;EsE5uSM;IAOI,2BAAA;EtEwuSV;EsE/uSM;IAOI,0BAAA;EtE2uSV;EsElvSM;IAOI,2BAAA;IAAA,0BAAA;EtE+uSV;EsEtvSM;IAOI,kCAAA;IAAA,iCAAA;EtEmvSV;EsE1vSM;IAOI,iCAAA;IAAA,gCAAA;EtEuvSV;EsE9vSM;IAOI,gCAAA;IAAA,+BAAA;EtE2vSV;EsElwSM;IAOI,iCAAA;IAAA,gCAAA;EtE+vSV;EsEtwSM;IAOI,gCAAA;IAAA,+BAAA;EtEmwSV;EsE1wSM;IAOI,yBAAA;IAAA,4BAAA;EtEuwSV;EsE9wSM;IAOI,gCAAA;IAAA,mCAAA;EtE2wSV;EsElxSM;IAOI,+BAAA;IAAA,kCAAA;EtE+wSV;EsEtxSM;IAOI,8BAAA;IAAA,iCAAA;EtEmxSV;EsE1xSM;IAOI,+BAAA;IAAA,kCAAA;EtEuxSV;EsE9xSM;IAOI,8BAAA;IAAA,iCAAA;EtE2xSV;EsElySM;IAOI,yBAAA;EtE8xSV;EsErySM;IAOI,gCAAA;EtEiySV;EsExySM;IAOI,+BAAA;EtEoySV;EsE3ySM;IAOI,8BAAA;EtEuySV;EsE9ySM;IAOI,+BAAA;EtE0ySV;EsEjzSM;IAOI,8BAAA;EtE6ySV;EsEpzSM;IAOI,2BAAA;EtEgzSV;EsEvzSM;IAOI,kCAAA;EtEmzSV;EsE1zSM;IAOI,iCAAA;EtEszSV;EsE7zSM;IAOI,gCAAA;EtEyzSV;EsEh0SM;IAOI,iCAAA;EtE4zSV;EsEn0SM;IAOI,gCAAA;EtE+zSV;EsEt0SM;IAOI,4BAAA;EtEk0SV;EsEz0SM;IAOI,mCAAA;EtEq0SV;EsE50SM;IAOI,kCAAA;EtEw0SV;EsE/0SM;IAOI,iCAAA;EtE20SV;EsEl1SM;IAOI,kCAAA;EtE80SV;EsEr1SM;IAOI,iCAAA;EtEi1SV;EsEx1SM;IAOI,0BAAA;EtEo1SV;EsE31SM;IAOI,iCAAA;EtEu1SV;EsE91SM;IAOI,gCAAA;EtE01SV;EsEj2SM;IAOI,+BAAA;EtE61SV;EsEp2SM;IAOI,gCAAA;EtEg2SV;EsEv2SM;IAOI,+BAAA;EtEm2SV;EsE12SM;IAOI,iBAAA;EtEs2SV;EsE72SM;IAOI,wBAAA;EtEy2SV;EsEh3SM;IAOI,uBAAA;EtE42SV;EsEn3SM;IAOI,sBAAA;EtE+2SV;EsEt3SM;IAOI,uBAAA;EtEk3SV;EsEz3SM;IAOI,sBAAA;EtEq3SV;EsE53SM;IAOI,qBAAA;EtEw3SV;EsE/3SM;IAOI,4BAAA;EtE23SV;EsEl4SM;IAOI,2BAAA;EtE83SV;EsEr4SM;IAOI,0BAAA;EtEi4SV;EsEx4SM;IAOI,2BAAA;EtEo4SV;EsE34SM;IAOI,0BAAA;EtEu4SV;EsE94SM;IAOI,wBAAA;EtE04SV;EsEj5SM;IAOI,+BAAA;EtE64SV;EsEp5SM;IAOI,8BAAA;EtEg5SV;EsEv5SM;IAOI,6BAAA;EtEm5SV;EsE15SM;IAOI,8BAAA;EtEs5SV;EsE75SM;IAOI,6BAAA;EtEy5SV;EsEh6SM;IAOI,2BAAA;EtE45SV;EsEn6SM;IAOI,4BAAA;EtE+5SV;EsEt6SM;IAOI,6BAAA;EtEk6SV;AACF;Ae76SI;EuDGI;IAOI,sBAAA;EtEu6SV;EsE96SM;IAOI,uBAAA;EtE06SV;EsEj7SM;IAOI,sBAAA;EtE66SV;EsEp7SM;IAOI,8BAAA;EtEg7SV;EsEv7SM;IAOI,4BAAA;EtEm7SV;EsE17SM;IAOI,2BAAA;EtEs7SV;EsE77SM;IAOI,iCAAA;EtEy7SV;EsEh8SM;IAOI,2BAAA;EtE47SV;EsEn8SM;IAOI,0BAAA;EtE+7SV;EsEt8SM;IAOI,gCAAA;EtEk8SV;EsEz8SM;IAOI,yBAAA;EtEq8SV;EsE58SM;IAOI,wBAAA;EtEw8SV;EsE/8SM;IAOI,yBAAA;EtE28SV;EsEl9SM;IAOI,6BAAA;EtE88SV;EsEr9SM;IAOI,8BAAA;EtEi9SV;EsEx9SM;IAOI,wBAAA;EtEo9SV;EsE39SM;IAOI,+BAAA;EtEu9SV;EsE99SM;IAOI,wBAAA;EtE09SV;EsEj+SM;IAOI,yBAAA;EtE69SV;EsEp+SM;IAOI,8BAAA;EtEg+SV;EsEv+SM;IAOI,iCAAA;EtEm+SV;EsE1+SM;IAOI,sCAAA;EtEs+SV;EsE7+SM;IAOI,yCAAA;EtEy+SV;EsEh/SM;IAOI,uBAAA;EtE4+SV;EsEn/SM;IAOI,uBAAA;EtE++SV;EsEt/SM;IAOI,yBAAA;EtEk/SV;EsEz/SM;IAOI,yBAAA;EtEq/SV;EsE5/SM;IAOI,0BAAA;EtEw/SV;EsE//SM;IAOI,4BAAA;EtE2/SV;EsElgTM;IAOI,kCAAA;EtE8/SV;EsErgTM;IAOI,sCAAA;EtEigTV;EsExgTM;IAOI,oCAAA;EtEogTV;EsE3gTM;IAOI,kCAAA;EtEugTV;EsE9gTM;IAOI,yCAAA;EtE0gTV;EsEjhTM;IAOI,wCAAA;EtE6gTV;EsEphTM;IAOI,wCAAA;EtEghTV;EsEvhTM;IAOI,kCAAA;EtEmhTV;EsE1hTM;IAOI,gCAAA;EtEshTV;EsE7hTM;IAOI,8BAAA;EtEyhTV;EsEhiTM;IAOI,gCAAA;EtE4hTV;EsEniTM;IAOI,+BAAA;EtE+hTV;EsEtiTM;IAOI,oCAAA;EtEkiTV;EsEziTM;IAOI,kCAAA;EtEqiTV;EsE5iTM;IAOI,gCAAA;EtEwiTV;EsE/iTM;IAOI,uCAAA;EtE2iTV;EsEljTM;IAOI,sCAAA;EtE8iTV;EsErjTM;IAOI,iCAAA;EtEijTV;EsExjTM;IAOI,2BAAA;EtEojTV;EsE3jTM;IAOI,iCAAA;EtEujTV;EsE9jTM;IAOI,+BAAA;EtE0jTV;EsEjkTM;IAOI,6BAAA;EtE6jTV;EsEpkTM;IAOI,+BAAA;EtEgkTV;EsEvkTM;IAOI,8BAAA;EtEmkTV;EsE1kTM;IAOI,oBAAA;EtEskTV;EsE7kTM;IAOI,mBAAA;EtEykTV;EsEhlTM;IAOI,mBAAA;EtE4kTV;EsEnlTM;IAOI,mBAAA;EtE+kTV;EsEtlTM;IAOI,mBAAA;EtEklTV;EsEzlTM;IAOI,mBAAA;EtEqlTV;EsE5lTM;IAOI,mBAAA;EtEwlTV;EsE/lTM;IAOI,mBAAA;EtE2lTV;EsElmTM;IAOI,oBAAA;EtE8lTV;EsErmTM;IAOI,2BAAA;EtEimTV;EsExmTM;IAOI,0BAAA;EtEomTV;EsE3mTM;IAOI,yBAAA;EtEumTV;EsE9mTM;IAOI,0BAAA;EtE0mTV;EsEjnTM;IAOI,yBAAA;EtE6mTV;EsEpnTM;IAOI,uBAAA;EtEgnTV;EsEvnTM;IAOI,0BAAA;IAAA,yBAAA;EtEonTV;EsE3nTM;IAOI,iCAAA;IAAA,gCAAA;EtEwnTV;EsE/nTM;IAOI,gCAAA;IAAA,+BAAA;EtE4nTV;EsEnoTM;IAOI,+BAAA;IAAA,8BAAA;EtEgoTV;EsEvoTM;IAOI,gCAAA;IAAA,+BAAA;EtEooTV;EsE3oTM;IAOI,+BAAA;IAAA,8BAAA;EtEwoTV;EsE/oTM;IAOI,6BAAA;IAAA,4BAAA;EtE4oTV;EsEnpTM;IAOI,wBAAA;IAAA,2BAAA;EtEgpTV;EsEvpTM;IAOI,+BAAA;IAAA,kCAAA;EtEopTV;EsE3pTM;IAOI,8BAAA;IAAA,iCAAA;EtEwpTV;EsE/pTM;IAOI,6BAAA;IAAA,gCAAA;EtE4pTV;EsEnqTM;IAOI,8BAAA;IAAA,iCAAA;EtEgqTV;EsEvqTM;IAOI,6BAAA;IAAA,gCAAA;EtEoqTV;EsE3qTM;IAOI,2BAAA;IAAA,8BAAA;EtEwqTV;EsE/qTM;IAOI,wBAAA;EtE2qTV;EsElrTM;IAOI,+BAAA;EtE8qTV;EsErrTM;IAOI,8BAAA;EtEirTV;EsExrTM;IAOI,6BAAA;EtEorTV;EsE3rTM;IAOI,8BAAA;EtEurTV;EsE9rTM;IAOI,6BAAA;EtE0rTV;EsEjsTM;IAOI,2BAAA;EtE6rTV;EsEpsTM;IAOI,0BAAA;EtEgsTV;EsEvsTM;IAOI,iCAAA;EtEmsTV;EsE1sTM;IAOI,gCAAA;EtEssTV;EsE7sTM;IAOI,+BAAA;EtEysTV;EsEhtTM;IAOI,gCAAA;EtE4sTV;EsEntTM;IAOI,+BAAA;EtE+sTV;EsEttTM;IAOI,6BAAA;EtEktTV;EsEztTM;IAOI,2BAAA;EtEqtTV;EsE5tTM;IAOI,kCAAA;EtEwtTV;EsE/tTM;IAOI,iCAAA;EtE2tTV;EsEluTM;IAOI,gCAAA;EtE8tTV;EsEruTM;IAOI,iCAAA;EtEiuTV;EsExuTM;IAOI,gCAAA;EtEouTV;EsE3uTM;IAOI,8BAAA;EtEuuTV;EsE9uTM;IAOI,yBAAA;EtE0uTV;EsEjvTM;IAOI,gCAAA;EtE6uTV;EsEpvTM;IAOI,+BAAA;EtEgvTV;EsEvvTM;IAOI,8BAAA;EtEmvTV;EsE1vTM;IAOI,+BAAA;EtEsvTV;EsE7vTM;IAOI,8BAAA;EtEyvTV;EsEhwTM;IAOI,4BAAA;EtE4vTV;EsEnwTM;IAOI,4BAAA;EtE+vTV;EsEtwTM;IAOI,2BAAA;EtEkwTV;EsEzwTM;IAOI,0BAAA;EtEqwTV;EsE5wTM;IAOI,2BAAA;EtEwwTV;EsE/wTM;IAOI,0BAAA;EtE2wTV;EsElxTM;IAOI,kCAAA;IAAA,iCAAA;EtE+wTV;EsEtxTM;IAOI,iCAAA;IAAA,gCAAA;EtEmxTV;EsE1xTM;IAOI,gCAAA;IAAA,+BAAA;EtEuxTV;EsE9xTM;IAOI,iCAAA;IAAA,gCAAA;EtE2xTV;EsElyTM;IAOI,gCAAA;IAAA,+BAAA;EtE+xTV;EsEtyTM;IAOI,gCAAA;IAAA,mCAAA;EtEmyTV;EsE1yTM;IAOI,+BAAA;IAAA,kCAAA;EtEuyTV;EsE9yTM;IAOI,8BAAA;IAAA,iCAAA;EtE2yTV;EsElzTM;IAOI,+BAAA;IAAA,kCAAA;EtE+yTV;EsEtzTM;IAOI,8BAAA;IAAA,iCAAA;EtEmzTV;EsE1zTM;IAOI,gCAAA;EtEszTV;EsE7zTM;IAOI,+BAAA;EtEyzTV;EsEh0TM;IAOI,8BAAA;EtE4zTV;EsEn0TM;IAOI,+BAAA;EtE+zTV;EsEt0TM;IAOI,8BAAA;EtEk0TV;EsEz0TM;IAOI,kCAAA;EtEq0TV;EsE50TM;IAOI,iCAAA;EtEw0TV;EsE/0TM;IAOI,gCAAA;EtE20TV;EsEl1TM;IAOI,iCAAA;EtE80TV;EsEr1TM;IAOI,gCAAA;EtEi1TV;EsEx1TM;IAOI,mCAAA;EtEo1TV;EsE31TM;IAOI,kCAAA;EtEu1TV;EsE91TM;IAOI,iCAAA;EtE01TV;EsEj2TM;IAOI,kCAAA;EtE61TV;EsEp2TM;IAOI,iCAAA;EtEg2TV;EsEv2TM;IAOI,iCAAA;EtEm2TV;EsE12TM;IAOI,gCAAA;EtEs2TV;EsE72TM;IAOI,+BAAA;EtEy2TV;EsEh3TM;IAOI,gCAAA;EtE42TV;EsEn3TM;IAOI,+BAAA;EtE+2TV;EsEt3TM;IAOI,qBAAA;EtEk3TV;EsEz3TM;IAOI,4BAAA;EtEq3TV;EsE53TM;IAOI,2BAAA;EtEw3TV;EsE/3TM;IAOI,0BAAA;EtE23TV;EsEl4TM;IAOI,2BAAA;EtE83TV;EsEr4TM;IAOI,0BAAA;EtEi4TV;EsEx4TM;IAOI,2BAAA;IAAA,0BAAA;EtEq4TV;EsE54TM;IAOI,kCAAA;IAAA,iCAAA;EtEy4TV;EsEh5TM;IAOI,iCAAA;IAAA,gCAAA;EtE64TV;EsEp5TM;IAOI,gCAAA;IAAA,+BAAA;EtEi5TV;EsEx5TM;IAOI,iCAAA;IAAA,gCAAA;EtEq5TV;EsE55TM;IAOI,gCAAA;IAAA,+BAAA;EtEy5TV;EsEh6TM;IAOI,yBAAA;IAAA,4BAAA;EtE65TV;EsEp6TM;IAOI,gCAAA;IAAA,mCAAA;EtEi6TV;EsEx6TM;IAOI,+BAAA;IAAA,kCAAA;EtEq6TV;EsE56TM;IAOI,8BAAA;IAAA,iCAAA;EtEy6TV;EsEh7TM;IAOI,+BAAA;IAAA,kCAAA;EtE66TV;EsEp7TM;IAOI,8BAAA;IAAA,iCAAA;EtEi7TV;EsEx7TM;IAOI,yBAAA;EtEo7TV;EsE37TM;IAOI,gCAAA;EtEu7TV;EsE97TM;IAOI,+BAAA;EtE07TV;EsEj8TM;IAOI,8BAAA;EtE67TV;EsEp8TM;IAOI,+BAAA;EtEg8TV;EsEv8TM;IAOI,8BAAA;EtEm8TV;EsE18TM;IAOI,2BAAA;EtEs8TV;EsE78TM;IAOI,kCAAA;EtEy8TV;EsEh9TM;IAOI,iCAAA;EtE48TV;EsEn9TM;IAOI,gCAAA;EtE+8TV;EsEt9TM;IAOI,iCAAA;EtEk9TV;EsEz9TM;IAOI,gCAAA;EtEq9TV;EsE59TM;IAOI,4BAAA;EtEw9TV;EsE/9TM;IAOI,mCAAA;EtE29TV;EsEl+TM;IAOI,kCAAA;EtE89TV;EsEr+TM;IAOI,iCAAA;EtEi+TV;EsEx+TM;IAOI,kCAAA;EtEo+TV;EsE3+TM;IAOI,iCAAA;EtEu+TV;EsE9+TM;IAOI,0BAAA;EtE0+TV;EsEj/TM;IAOI,iCAAA;EtE6+TV;EsEp/TM;IAOI,gCAAA;EtEg/TV;EsEv/TM;IAOI,+BAAA;EtEm/TV;EsE1/TM;IAOI,gCAAA;EtEs/TV;EsE7/TM;IAOI,+BAAA;EtEy/TV;EsEhgUM;IAOI,iBAAA;EtE4/TV;EsEngUM;IAOI,wBAAA;EtE+/TV;EsEtgUM;IAOI,uBAAA;EtEkgUV;EsEzgUM;IAOI,sBAAA;EtEqgUV;EsE5gUM;IAOI,uBAAA;EtEwgUV;EsE/gUM;IAOI,sBAAA;EtE2gUV;EsElhUM;IAOI,qBAAA;EtE8gUV;EsErhUM;IAOI,4BAAA;EtEihUV;EsExhUM;IAOI,2BAAA;EtEohUV;EsE3hUM;IAOI,0BAAA;EtEuhUV;EsE9hUM;IAOI,2BAAA;EtE0hUV;EsEjiUM;IAOI,0BAAA;EtE6hUV;EsEpiUM;IAOI,wBAAA;EtEgiUV;EsEviUM;IAOI,+BAAA;EtEmiUV;EsE1iUM;IAOI,8BAAA;EtEsiUV;EsE7iUM;IAOI,6BAAA;EtEyiUV;EsEhjUM;IAOI,8BAAA;EtE4iUV;EsEnjUM;IAOI,6BAAA;EtE+iUV;EsEtjUM;IAOI,2BAAA;EtEkjUV;EsEzjUM;IAOI,4BAAA;EtEqjUV;EsE5jUM;IAOI,6BAAA;EtEwjUV;AACF;AenkUI;EuDGI;IAOI,sBAAA;EtE6jUV;EsEpkUM;IAOI,uBAAA;EtEgkUV;EsEvkUM;IAOI,sBAAA;EtEmkUV;EsE1kUM;IAOI,8BAAA;EtEskUV;EsE7kUM;IAOI,4BAAA;EtEykUV;EsEhlUM;IAOI,2BAAA;EtE4kUV;EsEnlUM;IAOI,iCAAA;EtE+kUV;EsEtlUM;IAOI,2BAAA;EtEklUV;EsEzlUM;IAOI,0BAAA;EtEqlUV;EsE5lUM;IAOI,gCAAA;EtEwlUV;EsE/lUM;IAOI,yBAAA;EtE2lUV;EsElmUM;IAOI,wBAAA;EtE8lUV;EsErmUM;IAOI,yBAAA;EtEimUV;EsExmUM;IAOI,6BAAA;EtEomUV;EsE3mUM;IAOI,8BAAA;EtEumUV;EsE9mUM;IAOI,wBAAA;EtE0mUV;EsEjnUM;IAOI,+BAAA;EtE6mUV;EsEpnUM;IAOI,wBAAA;EtEgnUV;EsEvnUM;IAOI,yBAAA;EtEmnUV;EsE1nUM;IAOI,8BAAA;EtEsnUV;EsE7nUM;IAOI,iCAAA;EtEynUV;EsEhoUM;IAOI,sCAAA;EtE4nUV;EsEnoUM;IAOI,yCAAA;EtE+nUV;EsEtoUM;IAOI,uBAAA;EtEkoUV;EsEzoUM;IAOI,uBAAA;EtEqoUV;EsE5oUM;IAOI,yBAAA;EtEwoUV;EsE/oUM;IAOI,yBAAA;EtE2oUV;EsElpUM;IAOI,0BAAA;EtE8oUV;EsErpUM;IAOI,4BAAA;EtEipUV;EsExpUM;IAOI,kCAAA;EtEopUV;EsE3pUM;IAOI,sCAAA;EtEupUV;EsE9pUM;IAOI,oCAAA;EtE0pUV;EsEjqUM;IAOI,kCAAA;EtE6pUV;EsEpqUM;IAOI,yCAAA;EtEgqUV;EsEvqUM;IAOI,wCAAA;EtEmqUV;EsE1qUM;IAOI,wCAAA;EtEsqUV;EsE7qUM;IAOI,kCAAA;EtEyqUV;EsEhrUM;IAOI,gCAAA;EtE4qUV;EsEnrUM;IAOI,8BAAA;EtE+qUV;EsEtrUM;IAOI,gCAAA;EtEkrUV;EsEzrUM;IAOI,+BAAA;EtEqrUV;EsE5rUM;IAOI,oCAAA;EtEwrUV;EsE/rUM;IAOI,kCAAA;EtE2rUV;EsElsUM;IAOI,gCAAA;EtE8rUV;EsErsUM;IAOI,uCAAA;EtEisUV;EsExsUM;IAOI,sCAAA;EtEosUV;EsE3sUM;IAOI,iCAAA;EtEusUV;EsE9sUM;IAOI,2BAAA;EtE0sUV;EsEjtUM;IAOI,iCAAA;EtE6sUV;EsEptUM;IAOI,+BAAA;EtEgtUV;EsEvtUM;IAOI,6BAAA;EtEmtUV;EsE1tUM;IAOI,+BAAA;EtEstUV;EsE7tUM;IAOI,8BAAA;EtEytUV;EsEhuUM;IAOI,oBAAA;EtE4tUV;EsEnuUM;IAOI,mBAAA;EtE+tUV;EsEtuUM;IAOI,mBAAA;EtEkuUV;EsEzuUM;IAOI,mBAAA;EtEquUV;EsE5uUM;IAOI,mBAAA;EtEwuUV;EsE/uUM;IAOI,mBAAA;EtE2uUV;EsElvUM;IAOI,mBAAA;EtE8uUV;EsErvUM;IAOI,mBAAA;EtEivUV;EsExvUM;IAOI,oBAAA;EtEovUV;EsE3vUM;IAOI,2BAAA;EtEuvUV;EsE9vUM;IAOI,0BAAA;EtE0vUV;EsEjwUM;IAOI,yBAAA;EtE6vUV;EsEpwUM;IAOI,0BAAA;EtEgwUV;EsEvwUM;IAOI,yBAAA;EtEmwUV;EsE1wUM;IAOI,uBAAA;EtEswUV;EsE7wUM;IAOI,0BAAA;IAAA,yBAAA;EtE0wUV;EsEjxUM;IAOI,iCAAA;IAAA,gCAAA;EtE8wUV;EsErxUM;IAOI,gCAAA;IAAA,+BAAA;EtEkxUV;EsEzxUM;IAOI,+BAAA;IAAA,8BAAA;EtEsxUV;EsE7xUM;IAOI,gCAAA;IAAA,+BAAA;EtE0xUV;EsEjyUM;IAOI,+BAAA;IAAA,8BAAA;EtE8xUV;EsEryUM;IAOI,6BAAA;IAAA,4BAAA;EtEkyUV;EsEzyUM;IAOI,wBAAA;IAAA,2BAAA;EtEsyUV;EsE7yUM;IAOI,+BAAA;IAAA,kCAAA;EtE0yUV;EsEjzUM;IAOI,8BAAA;IAAA,iCAAA;EtE8yUV;EsErzUM;IAOI,6BAAA;IAAA,gCAAA;EtEkzUV;EsEzzUM;IAOI,8BAAA;IAAA,iCAAA;EtEszUV;EsE7zUM;IAOI,6BAAA;IAAA,gCAAA;EtE0zUV;EsEj0UM;IAOI,2BAAA;IAAA,8BAAA;EtE8zUV;EsEr0UM;IAOI,wBAAA;EtEi0UV;EsEx0UM;IAOI,+BAAA;EtEo0UV;EsE30UM;IAOI,8BAAA;EtEu0UV;EsE90UM;IAOI,6BAAA;EtE00UV;EsEj1UM;IAOI,8BAAA;EtE60UV;EsEp1UM;IAOI,6BAAA;EtEg1UV;EsEv1UM;IAOI,2BAAA;EtEm1UV;EsE11UM;IAOI,0BAAA;EtEs1UV;EsE71UM;IAOI,iCAAA;EtEy1UV;EsEh2UM;IAOI,gCAAA;EtE41UV;EsEn2UM;IAOI,+BAAA;EtE+1UV;EsEt2UM;IAOI,gCAAA;EtEk2UV;EsEz2UM;IAOI,+BAAA;EtEq2UV;EsE52UM;IAOI,6BAAA;EtEw2UV;EsE/2UM;IAOI,2BAAA;EtE22UV;EsEl3UM;IAOI,kCAAA;EtE82UV;EsEr3UM;IAOI,iCAAA;EtEi3UV;EsEx3UM;IAOI,gCAAA;EtEo3UV;EsE33UM;IAOI,iCAAA;EtEu3UV;EsE93UM;IAOI,gCAAA;EtE03UV;EsEj4UM;IAOI,8BAAA;EtE63UV;EsEp4UM;IAOI,yBAAA;EtEg4UV;EsEv4UM;IAOI,gCAAA;EtEm4UV;EsE14UM;IAOI,+BAAA;EtEs4UV;EsE74UM;IAOI,8BAAA;EtEy4UV;EsEh5UM;IAOI,+BAAA;EtE44UV;EsEn5UM;IAOI,8BAAA;EtE+4UV;EsEt5UM;IAOI,4BAAA;EtEk5UV;EsEz5UM;IAOI,4BAAA;EtEq5UV;EsE55UM;IAOI,2BAAA;EtEw5UV;EsE/5UM;IAOI,0BAAA;EtE25UV;EsEl6UM;IAOI,2BAAA;EtE85UV;EsEr6UM;IAOI,0BAAA;EtEi6UV;EsEx6UM;IAOI,kCAAA;IAAA,iCAAA;EtEq6UV;EsE56UM;IAOI,iCAAA;IAAA,gCAAA;EtEy6UV;EsEh7UM;IAOI,gCAAA;IAAA,+BAAA;EtE66UV;EsEp7UM;IAOI,iCAAA;IAAA,gCAAA;EtEi7UV;EsEx7UM;IAOI,gCAAA;IAAA,+BAAA;EtEq7UV;EsE57UM;IAOI,gCAAA;IAAA,mCAAA;EtEy7UV;EsEh8UM;IAOI,+BAAA;IAAA,kCAAA;EtE67UV;EsEp8UM;IAOI,8BAAA;IAAA,iCAAA;EtEi8UV;EsEx8UM;IAOI,+BAAA;IAAA,kCAAA;EtEq8UV;EsE58UM;IAOI,8BAAA;IAAA,iCAAA;EtEy8UV;EsEh9UM;IAOI,gCAAA;EtE48UV;EsEn9UM;IAOI,+BAAA;EtE+8UV;EsEt9UM;IAOI,8BAAA;EtEk9UV;EsEz9UM;IAOI,+BAAA;EtEq9UV;EsE59UM;IAOI,8BAAA;EtEw9UV;EsE/9UM;IAOI,kCAAA;EtE29UV;EsEl+UM;IAOI,iCAAA;EtE89UV;EsEr+UM;IAOI,gCAAA;EtEi+UV;EsEx+UM;IAOI,iCAAA;EtEo+UV;EsE3+UM;IAOI,gCAAA;EtEu+UV;EsE9+UM;IAOI,mCAAA;EtE0+UV;EsEj/UM;IAOI,kCAAA;EtE6+UV;EsEp/UM;IAOI,iCAAA;EtEg/UV;EsEv/UM;IAOI,kCAAA;EtEm/UV;EsE1/UM;IAOI,iCAAA;EtEs/UV;EsE7/UM;IAOI,iCAAA;EtEy/UV;EsEhgVM;IAOI,gCAAA;EtE4/UV;EsEngVM;IAOI,+BAAA;EtE+/UV;EsEtgVM;IAOI,gCAAA;EtEkgVV;EsEzgVM;IAOI,+BAAA;EtEqgVV;EsE5gVM;IAOI,qBAAA;EtEwgVV;EsE/gVM;IAOI,4BAAA;EtE2gVV;EsElhVM;IAOI,2BAAA;EtE8gVV;EsErhVM;IAOI,0BAAA;EtEihVV;EsExhVM;IAOI,2BAAA;EtEohVV;EsE3hVM;IAOI,0BAAA;EtEuhVV;EsE9hVM;IAOI,2BAAA;IAAA,0BAAA;EtE2hVV;EsEliVM;IAOI,kCAAA;IAAA,iCAAA;EtE+hVV;EsEtiVM;IAOI,iCAAA;IAAA,gCAAA;EtEmiVV;EsE1iVM;IAOI,gCAAA;IAAA,+BAAA;EtEuiVV;EsE9iVM;IAOI,iCAAA;IAAA,gCAAA;EtE2iVV;EsEljVM;IAOI,gCAAA;IAAA,+BAAA;EtE+iVV;EsEtjVM;IAOI,yBAAA;IAAA,4BAAA;EtEmjVV;EsE1jVM;IAOI,gCAAA;IAAA,mCAAA;EtEujVV;EsE9jVM;IAOI,+BAAA;IAAA,kCAAA;EtE2jVV;EsElkVM;IAOI,8BAAA;IAAA,iCAAA;EtE+jVV;EsEtkVM;IAOI,+BAAA;IAAA,kCAAA;EtEmkVV;EsE1kVM;IAOI,8BAAA;IAAA,iCAAA;EtEukVV;EsE9kVM;IAOI,yBAAA;EtE0kVV;EsEjlVM;IAOI,gCAAA;EtE6kVV;EsEplVM;IAOI,+BAAA;EtEglVV;EsEvlVM;IAOI,8BAAA;EtEmlVV;EsE1lVM;IAOI,+BAAA;EtEslVV;EsE7lVM;IAOI,8BAAA;EtEylVV;EsEhmVM;IAOI,2BAAA;EtE4lVV;EsEnmVM;IAOI,kCAAA;EtE+lVV;EsEtmVM;IAOI,iCAAA;EtEkmVV;EsEzmVM;IAOI,gCAAA;EtEqmVV;EsE5mVM;IAOI,iCAAA;EtEwmVV;EsE/mVM;IAOI,gCAAA;EtE2mVV;EsElnVM;IAOI,4BAAA;EtE8mVV;EsErnVM;IAOI,mCAAA;EtEinVV;EsExnVM;IAOI,kCAAA;EtEonVV;EsE3nVM;IAOI,iCAAA;EtEunVV;EsE9nVM;IAOI,kCAAA;EtE0nVV;EsEjoVM;IAOI,iCAAA;EtE6nVV;EsEpoVM;IAOI,0BAAA;EtEgoVV;EsEvoVM;IAOI,iCAAA;EtEmoVV;EsE1oVM;IAOI,gCAAA;EtEsoVV;EsE7oVM;IAOI,+BAAA;EtEyoVV;EsEhpVM;IAOI,gCAAA;EtE4oVV;EsEnpVM;IAOI,+BAAA;EtE+oVV;EsEtpVM;IAOI,iBAAA;EtEkpVV;EsEzpVM;IAOI,wBAAA;EtEqpVV;EsE5pVM;IAOI,uBAAA;EtEwpVV;EsE/pVM;IAOI,sBAAA;EtE2pVV;EsElqVM;IAOI,uBAAA;EtE8pVV;EsErqVM;IAOI,sBAAA;EtEiqVV;EsExqVM;IAOI,qBAAA;EtEoqVV;EsE3qVM;IAOI,4BAAA;EtEuqVV;EsE9qVM;IAOI,2BAAA;EtE0qVV;EsEjrVM;IAOI,0BAAA;EtE6qVV;EsEprVM;IAOI,2BAAA;EtEgrVV;EsEvrVM;IAOI,0BAAA;EtEmrVV;EsE1rVM;IAOI,wBAAA;EtEsrVV;EsE7rVM;IAOI,+BAAA;EtEyrVV;EsEhsVM;IAOI,8BAAA;EtE4rVV;EsEnsVM;IAOI,6BAAA;EtE+rVV;EsEtsVM;IAOI,8BAAA;EtEksVV;EsEzsVM;IAOI,6BAAA;EtEqsVV;EsE5sVM;IAOI,2BAAA;EtEwsVV;EsE/sVM;IAOI,4BAAA;EtE2sVV;EsEltVM;IAOI,6BAAA;EtE8sVV;AACF;AeztVI;EuDGI;IAOI,sBAAA;EtEmtVV;EsE1tVM;IAOI,uBAAA;EtEstVV;EsE7tVM;IAOI,sBAAA;EtEytVV;EsEhuVM;IAOI,8BAAA;EtE4tVV;EsEnuVM;IAOI,4BAAA;EtE+tVV;EsEtuVM;IAOI,2BAAA;EtEkuVV;EsEzuVM;IAOI,iCAAA;EtEquVV;EsE5uVM;IAOI,2BAAA;EtEwuVV;EsE/uVM;IAOI,0BAAA;EtE2uVV;EsElvVM;IAOI,gCAAA;EtE8uVV;EsErvVM;IAOI,yBAAA;EtEivVV;EsExvVM;IAOI,wBAAA;EtEovVV;EsE3vVM;IAOI,yBAAA;EtEuvVV;EsE9vVM;IAOI,6BAAA;EtE0vVV;EsEjwVM;IAOI,8BAAA;EtE6vVV;EsEpwVM;IAOI,wBAAA;EtEgwVV;EsEvwVM;IAOI,+BAAA;EtEmwVV;EsE1wVM;IAOI,wBAAA;EtEswVV;EsE7wVM;IAOI,yBAAA;EtEywVV;EsEhxVM;IAOI,8BAAA;EtE4wVV;EsEnxVM;IAOI,iCAAA;EtE+wVV;EsEtxVM;IAOI,sCAAA;EtEkxVV;EsEzxVM;IAOI,yCAAA;EtEqxVV;EsE5xVM;IAOI,uBAAA;EtEwxVV;EsE/xVM;IAOI,uBAAA;EtE2xVV;EsElyVM;IAOI,yBAAA;EtE8xVV;EsEryVM;IAOI,yBAAA;EtEiyVV;EsExyVM;IAOI,0BAAA;EtEoyVV;EsE3yVM;IAOI,4BAAA;EtEuyVV;EsE9yVM;IAOI,kCAAA;EtE0yVV;EsEjzVM;IAOI,sCAAA;EtE6yVV;EsEpzVM;IAOI,oCAAA;EtEgzVV;EsEvzVM;IAOI,kCAAA;EtEmzVV;EsE1zVM;IAOI,yCAAA;EtEszVV;EsE7zVM;IAOI,wCAAA;EtEyzVV;EsEh0VM;IAOI,wCAAA;EtE4zVV;EsEn0VM;IAOI,kCAAA;EtE+zVV;EsEt0VM;IAOI,gCAAA;EtEk0VV;EsEz0VM;IAOI,8BAAA;EtEq0VV;EsE50VM;IAOI,gCAAA;EtEw0VV;EsE/0VM;IAOI,+BAAA;EtE20VV;EsEl1VM;IAOI,oCAAA;EtE80VV;EsEr1VM;IAOI,kCAAA;EtEi1VV;EsEx1VM;IAOI,gCAAA;EtEo1VV;EsE31VM;IAOI,uCAAA;EtEu1VV;EsE91VM;IAOI,sCAAA;EtE01VV;EsEj2VM;IAOI,iCAAA;EtE61VV;EsEp2VM;IAOI,2BAAA;EtEg2VV;EsEv2VM;IAOI,iCAAA;EtEm2VV;EsE12VM;IAOI,+BAAA;EtEs2VV;EsE72VM;IAOI,6BAAA;EtEy2VV;EsEh3VM;IAOI,+BAAA;EtE42VV;EsEn3VM;IAOI,8BAAA;EtE+2VV;EsEt3VM;IAOI,oBAAA;EtEk3VV;EsEz3VM;IAOI,mBAAA;EtEq3VV;EsE53VM;IAOI,mBAAA;EtEw3VV;EsE/3VM;IAOI,mBAAA;EtE23VV;EsEl4VM;IAOI,mBAAA;EtE83VV;EsEr4VM;IAOI,mBAAA;EtEi4VV;EsEx4VM;IAOI,mBAAA;EtEo4VV;EsE34VM;IAOI,mBAAA;EtEu4VV;EsE94VM;IAOI,oBAAA;EtE04VV;EsEj5VM;IAOI,2BAAA;EtE64VV;EsEp5VM;IAOI,0BAAA;EtEg5VV;EsEv5VM;IAOI,yBAAA;EtEm5VV;EsE15VM;IAOI,0BAAA;EtEs5VV;EsE75VM;IAOI,yBAAA;EtEy5VV;EsEh6VM;IAOI,uBAAA;EtE45VV;EsEn6VM;IAOI,0BAAA;IAAA,yBAAA;EtEg6VV;EsEv6VM;IAOI,iCAAA;IAAA,gCAAA;EtEo6VV;EsE36VM;IAOI,gCAAA;IAAA,+BAAA;EtEw6VV;EsE/6VM;IAOI,+BAAA;IAAA,8BAAA;EtE46VV;EsEn7VM;IAOI,gCAAA;IAAA,+BAAA;EtEg7VV;EsEv7VM;IAOI,+BAAA;IAAA,8BAAA;EtEo7VV;EsE37VM;IAOI,6BAAA;IAAA,4BAAA;EtEw7VV;EsE/7VM;IAOI,wBAAA;IAAA,2BAAA;EtE47VV;EsEn8VM;IAOI,+BAAA;IAAA,kCAAA;EtEg8VV;EsEv8VM;IAOI,8BAAA;IAAA,iCAAA;EtEo8VV;EsE38VM;IAOI,6BAAA;IAAA,gCAAA;EtEw8VV;EsE/8VM;IAOI,8BAAA;IAAA,iCAAA;EtE48VV;EsEn9VM;IAOI,6BAAA;IAAA,gCAAA;EtEg9VV;EsEv9VM;IAOI,2BAAA;IAAA,8BAAA;EtEo9VV;EsE39VM;IAOI,wBAAA;EtEu9VV;EsE99VM;IAOI,+BAAA;EtE09VV;EsEj+VM;IAOI,8BAAA;EtE69VV;EsEp+VM;IAOI,6BAAA;EtEg+VV;EsEv+VM;IAOI,8BAAA;EtEm+VV;EsE1+VM;IAOI,6BAAA;EtEs+VV;EsE7+VM;IAOI,2BAAA;EtEy+VV;EsEh/VM;IAOI,0BAAA;EtE4+VV;EsEn/VM;IAOI,iCAAA;EtE++VV;EsEt/VM;IAOI,gCAAA;EtEk/VV;EsEz/VM;IAOI,+BAAA;EtEq/VV;EsE5/VM;IAOI,gCAAA;EtEw/VV;EsE//VM;IAOI,+BAAA;EtE2/VV;EsElgWM;IAOI,6BAAA;EtE8/VV;EsErgWM;IAOI,2BAAA;EtEigWV;EsExgWM;IAOI,kCAAA;EtEogWV;EsE3gWM;IAOI,iCAAA;EtEugWV;EsE9gWM;IAOI,gCAAA;EtE0gWV;EsEjhWM;IAOI,iCAAA;EtE6gWV;EsEphWM;IAOI,gCAAA;EtEghWV;EsEvhWM;IAOI,8BAAA;EtEmhWV;EsE1hWM;IAOI,yBAAA;EtEshWV;EsE7hWM;IAOI,gCAAA;EtEyhWV;EsEhiWM;IAOI,+BAAA;EtE4hWV;EsEniWM;IAOI,8BAAA;EtE+hWV;EsEtiWM;IAOI,+BAAA;EtEkiWV;EsEziWM;IAOI,8BAAA;EtEqiWV;EsE5iWM;IAOI,4BAAA;EtEwiWV;EsE/iWM;IAOI,4BAAA;EtE2iWV;EsEljWM;IAOI,2BAAA;EtE8iWV;EsErjWM;IAOI,0BAAA;EtEijWV;EsExjWM;IAOI,2BAAA;EtEojWV;EsE3jWM;IAOI,0BAAA;EtEujWV;EsE9jWM;IAOI,kCAAA;IAAA,iCAAA;EtE2jWV;EsElkWM;IAOI,iCAAA;IAAA,gCAAA;EtE+jWV;EsEtkWM;IAOI,gCAAA;IAAA,+BAAA;EtEmkWV;EsE1kWM;IAOI,iCAAA;IAAA,gCAAA;EtEukWV;EsE9kWM;IAOI,gCAAA;IAAA,+BAAA;EtE2kWV;EsEllWM;IAOI,gCAAA;IAAA,mCAAA;EtE+kWV;EsEtlWM;IAOI,+BAAA;IAAA,kCAAA;EtEmlWV;EsE1lWM;IAOI,8BAAA;IAAA,iCAAA;EtEulWV;EsE9lWM;IAOI,+BAAA;IAAA,kCAAA;EtE2lWV;EsElmWM;IAOI,8BAAA;IAAA,iCAAA;EtE+lWV;EsEtmWM;IAOI,gCAAA;EtEkmWV;EsEzmWM;IAOI,+BAAA;EtEqmWV;EsE5mWM;IAOI,8BAAA;EtEwmWV;EsE/mWM;IAOI,+BAAA;EtE2mWV;EsElnWM;IAOI,8BAAA;EtE8mWV;EsErnWM;IAOI,kCAAA;EtEinWV;EsExnWM;IAOI,iCAAA;EtEonWV;EsE3nWM;IAOI,gCAAA;EtEunWV;EsE9nWM;IAOI,iCAAA;EtE0nWV;EsEjoWM;IAOI,gCAAA;EtE6nWV;EsEpoWM;IAOI,mCAAA;EtEgoWV;EsEvoWM;IAOI,kCAAA;EtEmoWV;EsE1oWM;IAOI,iCAAA;EtEsoWV;EsE7oWM;IAOI,kCAAA;EtEyoWV;EsEhpWM;IAOI,iCAAA;EtE4oWV;EsEnpWM;IAOI,iCAAA;EtE+oWV;EsEtpWM;IAOI,gCAAA;EtEkpWV;EsEzpWM;IAOI,+BAAA;EtEqpWV;EsE5pWM;IAOI,gCAAA;EtEwpWV;EsE/pWM;IAOI,+BAAA;EtE2pWV;EsElqWM;IAOI,qBAAA;EtE8pWV;EsErqWM;IAOI,4BAAA;EtEiqWV;EsExqWM;IAOI,2BAAA;EtEoqWV;EsE3qWM;IAOI,0BAAA;EtEuqWV;EsE9qWM;IAOI,2BAAA;EtE0qWV;EsEjrWM;IAOI,0BAAA;EtE6qWV;EsEprWM;IAOI,2BAAA;IAAA,0BAAA;EtEirWV;EsExrWM;IAOI,kCAAA;IAAA,iCAAA;EtEqrWV;EsE5rWM;IAOI,iCAAA;IAAA,gCAAA;EtEyrWV;EsEhsWM;IAOI,gCAAA;IAAA,+BAAA;EtE6rWV;EsEpsWM;IAOI,iCAAA;IAAA,gCAAA;EtEisWV;EsExsWM;IAOI,gCAAA;IAAA,+BAAA;EtEqsWV;EsE5sWM;IAOI,yBAAA;IAAA,4BAAA;EtEysWV;EsEhtWM;IAOI,gCAAA;IAAA,mCAAA;EtE6sWV;EsEptWM;IAOI,+BAAA;IAAA,kCAAA;EtEitWV;EsExtWM;IAOI,8BAAA;IAAA,iCAAA;EtEqtWV;EsE5tWM;IAOI,+BAAA;IAAA,kCAAA;EtEytWV;EsEhuWM;IAOI,8BAAA;IAAA,iCAAA;EtE6tWV;EsEpuWM;IAOI,yBAAA;EtEguWV;EsEvuWM;IAOI,gCAAA;EtEmuWV;EsE1uWM;IAOI,+BAAA;EtEsuWV;EsE7uWM;IAOI,8BAAA;EtEyuWV;EsEhvWM;IAOI,+BAAA;EtE4uWV;EsEnvWM;IAOI,8BAAA;EtE+uWV;EsEtvWM;IAOI,2BAAA;EtEkvWV;EsEzvWM;IAOI,kCAAA;EtEqvWV;EsE5vWM;IAOI,iCAAA;EtEwvWV;EsE/vWM;IAOI,gCAAA;EtE2vWV;EsElwWM;IAOI,iCAAA;EtE8vWV;EsErwWM;IAOI,gCAAA;EtEiwWV;EsExwWM;IAOI,4BAAA;EtEowWV;EsE3wWM;IAOI,mCAAA;EtEuwWV;EsE9wWM;IAOI,kCAAA;EtE0wWV;EsEjxWM;IAOI,iCAAA;EtE6wWV;EsEpxWM;IAOI,kCAAA;EtEgxWV;EsEvxWM;IAOI,iCAAA;EtEmxWV;EsE1xWM;IAOI,0BAAA;EtEsxWV;EsE7xWM;IAOI,iCAAA;EtEyxWV;EsEhyWM;IAOI,gCAAA;EtE4xWV;EsEnyWM;IAOI,+BAAA;EtE+xWV;EsEtyWM;IAOI,gCAAA;EtEkyWV;EsEzyWM;IAOI,+BAAA;EtEqyWV;EsE5yWM;IAOI,iBAAA;EtEwyWV;EsE/yWM;IAOI,wBAAA;EtE2yWV;EsElzWM;IAOI,uBAAA;EtE8yWV;EsErzWM;IAOI,sBAAA;EtEizWV;EsExzWM;IAOI,uBAAA;EtEozWV;EsE3zWM;IAOI,sBAAA;EtEuzWV;EsE9zWM;IAOI,qBAAA;EtE0zWV;EsEj0WM;IAOI,4BAAA;EtE6zWV;EsEp0WM;IAOI,2BAAA;EtEg0WV;EsEv0WM;IAOI,0BAAA;EtEm0WV;EsE10WM;IAOI,2BAAA;EtEs0WV;EsE70WM;IAOI,0BAAA;EtEy0WV;EsEh1WM;IAOI,wBAAA;EtE40WV;EsEn1WM;IAOI,+BAAA;EtE+0WV;EsEt1WM;IAOI,8BAAA;EtEk1WV;EsEz1WM;IAOI,6BAAA;EtEq1WV;EsE51WM;IAOI,8BAAA;EtEw1WV;EsE/1WM;IAOI,6BAAA;EtE21WV;EsEl2WM;IAOI,2BAAA;EtE81WV;EsEr2WM;IAOI,4BAAA;EtEi2WV;EsEx2WM;IAOI,6BAAA;EtEo2WV;AACF;Ae/2WI;EuDGI;IAOI,sBAAA;EtEy2WV;EsEh3WM;IAOI,uBAAA;EtE42WV;EsEn3WM;IAOI,sBAAA;EtE+2WV;EsEt3WM;IAOI,8BAAA;EtEk3WV;EsEz3WM;IAOI,4BAAA;EtEq3WV;EsE53WM;IAOI,2BAAA;EtEw3WV;EsE/3WM;IAOI,iCAAA;EtE23WV;EsEl4WM;IAOI,2BAAA;EtE83WV;EsEr4WM;IAOI,0BAAA;EtEi4WV;EsEx4WM;IAOI,gCAAA;EtEo4WV;EsE34WM;IAOI,yBAAA;EtEu4WV;EsE94WM;IAOI,wBAAA;EtE04WV;EsEj5WM;IAOI,yBAAA;EtE64WV;EsEp5WM;IAOI,6BAAA;EtEg5WV;EsEv5WM;IAOI,8BAAA;EtEm5WV;EsE15WM;IAOI,wBAAA;EtEs5WV;EsE75WM;IAOI,+BAAA;EtEy5WV;EsEh6WM;IAOI,wBAAA;EtE45WV;EsEn6WM;IAOI,yBAAA;EtE+5WV;EsEt6WM;IAOI,8BAAA;EtEk6WV;EsEz6WM;IAOI,iCAAA;EtEq6WV;EsE56WM;IAOI,sCAAA;EtEw6WV;EsE/6WM;IAOI,yCAAA;EtE26WV;EsEl7WM;IAOI,uBAAA;EtE86WV;EsEr7WM;IAOI,uBAAA;EtEi7WV;EsEx7WM;IAOI,yBAAA;EtEo7WV;EsE37WM;IAOI,yBAAA;EtEu7WV;EsE97WM;IAOI,0BAAA;EtE07WV;EsEj8WM;IAOI,4BAAA;EtE67WV;EsEp8WM;IAOI,kCAAA;EtEg8WV;EsEv8WM;IAOI,sCAAA;EtEm8WV;EsE18WM;IAOI,oCAAA;EtEs8WV;EsE78WM;IAOI,kCAAA;EtEy8WV;EsEh9WM;IAOI,yCAAA;EtE48WV;EsEn9WM;IAOI,wCAAA;EtE+8WV;EsEt9WM;IAOI,wCAAA;EtEk9WV;EsEz9WM;IAOI,kCAAA;EtEq9WV;EsE59WM;IAOI,gCAAA;EtEw9WV;EsE/9WM;IAOI,8BAAA;EtE29WV;EsEl+WM;IAOI,gCAAA;EtE89WV;EsEr+WM;IAOI,+BAAA;EtEi+WV;EsEx+WM;IAOI,oCAAA;EtEo+WV;EsE3+WM;IAOI,kCAAA;EtEu+WV;EsE9+WM;IAOI,gCAAA;EtE0+WV;EsEj/WM;IAOI,uCAAA;EtE6+WV;EsEp/WM;IAOI,sCAAA;EtEg/WV;EsEv/WM;IAOI,iCAAA;EtEm/WV;EsE1/WM;IAOI,2BAAA;EtEs/WV;EsE7/WM;IAOI,iCAAA;EtEy/WV;EsEhgXM;IAOI,+BAAA;EtE4/WV;EsEngXM;IAOI,6BAAA;EtE+/WV;EsEtgXM;IAOI,+BAAA;EtEkgXV;EsEzgXM;IAOI,8BAAA;EtEqgXV;EsE5gXM;IAOI,oBAAA;EtEwgXV;EsE/gXM;IAOI,mBAAA;EtE2gXV;EsElhXM;IAOI,mBAAA;EtE8gXV;EsErhXM;IAOI,mBAAA;EtEihXV;EsExhXM;IAOI,mBAAA;EtEohXV;EsE3hXM;IAOI,mBAAA;EtEuhXV;EsE9hXM;IAOI,mBAAA;EtE0hXV;EsEjiXM;IAOI,mBAAA;EtE6hXV;EsEpiXM;IAOI,oBAAA;EtEgiXV;EsEviXM;IAOI,2BAAA;EtEmiXV;EsE1iXM;IAOI,0BAAA;EtEsiXV;EsE7iXM;IAOI,yBAAA;EtEyiXV;EsEhjXM;IAOI,0BAAA;EtE4iXV;EsEnjXM;IAOI,yBAAA;EtE+iXV;EsEtjXM;IAOI,uBAAA;EtEkjXV;EsEzjXM;IAOI,0BAAA;IAAA,yBAAA;EtEsjXV;EsE7jXM;IAOI,iCAAA;IAAA,gCAAA;EtE0jXV;EsEjkXM;IAOI,gCAAA;IAAA,+BAAA;EtE8jXV;EsErkXM;IAOI,+BAAA;IAAA,8BAAA;EtEkkXV;EsEzkXM;IAOI,gCAAA;IAAA,+BAAA;EtEskXV;EsE7kXM;IAOI,+BAAA;IAAA,8BAAA;EtE0kXV;EsEjlXM;IAOI,6BAAA;IAAA,4BAAA;EtE8kXV;EsErlXM;IAOI,wBAAA;IAAA,2BAAA;EtEklXV;EsEzlXM;IAOI,+BAAA;IAAA,kCAAA;EtEslXV;EsE7lXM;IAOI,8BAAA;IAAA,iCAAA;EtE0lXV;EsEjmXM;IAOI,6BAAA;IAAA,gCAAA;EtE8lXV;EsErmXM;IAOI,8BAAA;IAAA,iCAAA;EtEkmXV;EsEzmXM;IAOI,6BAAA;IAAA,gCAAA;EtEsmXV;EsE7mXM;IAOI,2BAAA;IAAA,8BAAA;EtE0mXV;EsEjnXM;IAOI,wBAAA;EtE6mXV;EsEpnXM;IAOI,+BAAA;EtEgnXV;EsEvnXM;IAOI,8BAAA;EtEmnXV;EsE1nXM;IAOI,6BAAA;EtEsnXV;EsE7nXM;IAOI,8BAAA;EtEynXV;EsEhoXM;IAOI,6BAAA;EtE4nXV;EsEnoXM;IAOI,2BAAA;EtE+nXV;EsEtoXM;IAOI,0BAAA;EtEkoXV;EsEzoXM;IAOI,iCAAA;EtEqoXV;EsE5oXM;IAOI,gCAAA;EtEwoXV;EsE/oXM;IAOI,+BAAA;EtE2oXV;EsElpXM;IAOI,gCAAA;EtE8oXV;EsErpXM;IAOI,+BAAA;EtEipXV;EsExpXM;IAOI,6BAAA;EtEopXV;EsE3pXM;IAOI,2BAAA;EtEupXV;EsE9pXM;IAOI,kCAAA;EtE0pXV;EsEjqXM;IAOI,iCAAA;EtE6pXV;EsEpqXM;IAOI,gCAAA;EtEgqXV;EsEvqXM;IAOI,iCAAA;EtEmqXV;EsE1qXM;IAOI,gCAAA;EtEsqXV;EsE7qXM;IAOI,8BAAA;EtEyqXV;EsEhrXM;IAOI,yBAAA;EtE4qXV;EsEnrXM;IAOI,gCAAA;EtE+qXV;EsEtrXM;IAOI,+BAAA;EtEkrXV;EsEzrXM;IAOI,8BAAA;EtEqrXV;EsE5rXM;IAOI,+BAAA;EtEwrXV;EsE/rXM;IAOI,8BAAA;EtE2rXV;EsElsXM;IAOI,4BAAA;EtE8rXV;EsErsXM;IAOI,4BAAA;EtEisXV;EsExsXM;IAOI,2BAAA;EtEosXV;EsE3sXM;IAOI,0BAAA;EtEusXV;EsE9sXM;IAOI,2BAAA;EtE0sXV;EsEjtXM;IAOI,0BAAA;EtE6sXV;EsEptXM;IAOI,kCAAA;IAAA,iCAAA;EtEitXV;EsExtXM;IAOI,iCAAA;IAAA,gCAAA;EtEqtXV;EsE5tXM;IAOI,gCAAA;IAAA,+BAAA;EtEytXV;EsEhuXM;IAOI,iCAAA;IAAA,gCAAA;EtE6tXV;EsEpuXM;IAOI,gCAAA;IAAA,+BAAA;EtEiuXV;EsExuXM;IAOI,gCAAA;IAAA,mCAAA;EtEquXV;EsE5uXM;IAOI,+BAAA;IAAA,kCAAA;EtEyuXV;EsEhvXM;IAOI,8BAAA;IAAA,iCAAA;EtE6uXV;EsEpvXM;IAOI,+BAAA;IAAA,kCAAA;EtEivXV;EsExvXM;IAOI,8BAAA;IAAA,iCAAA;EtEqvXV;EsE5vXM;IAOI,gCAAA;EtEwvXV;EsE/vXM;IAOI,+BAAA;EtE2vXV;EsElwXM;IAOI,8BAAA;EtE8vXV;EsErwXM;IAOI,+BAAA;EtEiwXV;EsExwXM;IAOI,8BAAA;EtEowXV;EsE3wXM;IAOI,kCAAA;EtEuwXV;EsE9wXM;IAOI,iCAAA;EtE0wXV;EsEjxXM;IAOI,gCAAA;EtE6wXV;EsEpxXM;IAOI,iCAAA;EtEgxXV;EsEvxXM;IAOI,gCAAA;EtEmxXV;EsE1xXM;IAOI,mCAAA;EtEsxXV;EsE7xXM;IAOI,kCAAA;EtEyxXV;EsEhyXM;IAOI,iCAAA;EtE4xXV;EsEnyXM;IAOI,kCAAA;EtE+xXV;EsEtyXM;IAOI,iCAAA;EtEkyXV;EsEzyXM;IAOI,iCAAA;EtEqyXV;EsE5yXM;IAOI,gCAAA;EtEwyXV;EsE/yXM;IAOI,+BAAA;EtE2yXV;EsElzXM;IAOI,gCAAA;EtE8yXV;EsErzXM;IAOI,+BAAA;EtEizXV;EsExzXM;IAOI,qBAAA;EtEozXV;EsE3zXM;IAOI,4BAAA;EtEuzXV;EsE9zXM;IAOI,2BAAA;EtE0zXV;EsEj0XM;IAOI,0BAAA;EtE6zXV;EsEp0XM;IAOI,2BAAA;EtEg0XV;EsEv0XM;IAOI,0BAAA;EtEm0XV;EsE10XM;IAOI,2BAAA;IAAA,0BAAA;EtEu0XV;EsE90XM;IAOI,kCAAA;IAAA,iCAAA;EtE20XV;EsEl1XM;IAOI,iCAAA;IAAA,gCAAA;EtE+0XV;EsEt1XM;IAOI,gCAAA;IAAA,+BAAA;EtEm1XV;EsE11XM;IAOI,iCAAA;IAAA,gCAAA;EtEu1XV;EsE91XM;IAOI,gCAAA;IAAA,+BAAA;EtE21XV;EsEl2XM;IAOI,yBAAA;IAAA,4BAAA;EtE+1XV;EsEt2XM;IAOI,gCAAA;IAAA,mCAAA;EtEm2XV;EsE12XM;IAOI,+BAAA;IAAA,kCAAA;EtEu2XV;EsE92XM;IAOI,8BAAA;IAAA,iCAAA;EtE22XV;EsEl3XM;IAOI,+BAAA;IAAA,kCAAA;EtE+2XV;EsEt3XM;IAOI,8BAAA;IAAA,iCAAA;EtEm3XV;EsE13XM;IAOI,yBAAA;EtEs3XV;EsE73XM;IAOI,gCAAA;EtEy3XV;EsEh4XM;IAOI,+BAAA;EtE43XV;EsEn4XM;IAOI,8BAAA;EtE+3XV;EsEt4XM;IAOI,+BAAA;EtEk4XV;EsEz4XM;IAOI,8BAAA;EtEq4XV;EsE54XM;IAOI,2BAAA;EtEw4XV;EsE/4XM;IAOI,kCAAA;EtE24XV;EsEl5XM;IAOI,iCAAA;EtE84XV;EsEr5XM;IAOI,gCAAA;EtEi5XV;EsEx5XM;IAOI,iCAAA;EtEo5XV;EsE35XM;IAOI,gCAAA;EtEu5XV;EsE95XM;IAOI,4BAAA;EtE05XV;EsEj6XM;IAOI,mCAAA;EtE65XV;EsEp6XM;IAOI,kCAAA;EtEg6XV;EsEv6XM;IAOI,iCAAA;EtEm6XV;EsE16XM;IAOI,kCAAA;EtEs6XV;EsE76XM;IAOI,iCAAA;EtEy6XV;EsEh7XM;IAOI,0BAAA;EtE46XV;EsEn7XM;IAOI,iCAAA;EtE+6XV;EsEt7XM;IAOI,gCAAA;EtEk7XV;EsEz7XM;IAOI,+BAAA;EtEq7XV;EsE57XM;IAOI,gCAAA;EtEw7XV;EsE/7XM;IAOI,+BAAA;EtE27XV;EsEl8XM;IAOI,iBAAA;EtE87XV;EsEr8XM;IAOI,wBAAA;EtEi8XV;EsEx8XM;IAOI,uBAAA;EtEo8XV;EsE38XM;IAOI,sBAAA;EtEu8XV;EsE98XM;IAOI,uBAAA;EtE08XV;EsEj9XM;IAOI,sBAAA;EtE68XV;EsEp9XM;IAOI,qBAAA;EtEg9XV;EsEv9XM;IAOI,4BAAA;EtEm9XV;EsE19XM;IAOI,2BAAA;EtEs9XV;EsE79XM;IAOI,0BAAA;EtEy9XV;EsEh+XM;IAOI,2BAAA;EtE49XV;EsEn+XM;IAOI,0BAAA;EtE+9XV;EsEt+XM;IAOI,wBAAA;EtEk+XV;EsEz+XM;IAOI,+BAAA;EtEq+XV;EsE5+XM;IAOI,8BAAA;EtEw+XV;EsE/+XM;IAOI,6BAAA;EtE2+XV;EsEl/XM;IAOI,8BAAA;EtE8+XV;EsEr/XM;IAOI,6BAAA;EtEi/XV;EsEx/XM;IAOI,2BAAA;EtEo/XV;EsE3/XM;IAOI,4BAAA;EtEu/XV;EsE9/XM;IAOI,6BAAA;EtE0/XV;AACF;AuEjjYA;ED+CQ;IAOI,6BAAA;EtE+/XV;EsEtgYM;IAOI,8BAAA;EtEkgYV;EsEzgYM;IAOI,4BAAA;EtEqgYV;AACF;AuEziYA;ED4BQ;IAOI,0BAAA;EtE0gYV;EsEjhYM;IAOI,gCAAA;EtE6gYV;EsEphYM;IAOI,yBAAA;EtEghYV;EsEvhYM;IAOI,wBAAA;EtEmhYV;EsE1hYM;IAOI,yBAAA;EtEshYV;EsE7hYM;IAOI,6BAAA;EtEyhYV;EsEhiYM;IAOI,8BAAA;EtE4hYV;EsEniYM;IAOI,wBAAA;EtE+hYV;EsEtiYM;IAOI,+BAAA;EtEkiYV;EsEziYM;IAOI,wBAAA;EtEqiYV;AACF;AwE1mYI;EACI,iBAAA;EACA,kBAAA;EACA,QAAA;AxE4mYR;AwEvmYgB;EACI,iBAAA;AxEymYpB;;AyEjnYI;EACI,wCAAA;EACA,uCAAA;EACA,iDAAA;AzEonYR;AyEnnYQ;EACI,wCAAA;AzEqnYZ;;AyE1nYI;EACI,uCAAA;EACA,wCAAA;EACA,kDAAA;AzE6nYR;AyE5nYQ;EACI,uCAAA;AzE8nYZ;;AyEnoYI;EACI,yCAAA;EACA,uCAAA;EACA,iDAAA;AzEsoYR;AyEroYQ;EACI,yCAAA;AzEuoYZ;;AyE5oYI;EACI,yCAAA;EACA,uCAAA;EACA,iDAAA;AzE+oYR;AyE9oYQ;EACI,yCAAA;AzEgpYZ;;AyErpYI;EACI,yCAAA;EACA,uCAAA;EACA,iDAAA;AzEwpYR;AyEvpYQ;EACI,yCAAA;AzEypYZ;;AyE9pYI;EACI,wCAAA;EACA,uCAAA;EACA,iDAAA;AzEiqYR;AyEhqYQ;EACI,wCAAA;AzEkqYZ;;AyEvqYI;EACI,0CAAA;EACA,wCAAA;EACA,kDAAA;AzE0qYR;AyEzqYQ;EACI,0CAAA;AzE2qYZ;;AyEhrYI;EACI,mCAAA;EACA,qCAAA;EACA,+CAAA;AzEmrYR;AyElrYQ;EACI,mCAAA;AzEorYZ;;AyEzrYI;EACI,yCAAA;EACA,wCAAA;EACA,kDAAA;AzE4rYR;AyE3rYQ;EACI,yCAAA;AzE6rYZ;;AyElsYI;EACI,wCAAA;EACA,uCAAA;EACA,iDAAA;AzEqsYR;AyEpsYQ;EACI,wCAAA;AzEssYZ;;AyE/rYI;EACI,wCAAA;EACA,0BAAA;EACA,wDAAA;EACA,6CAAA;AzEksYR;;AyEtsYI;EACI,0CAAA;EACA,0BAAA;EACA,0DAAA;EACA,+CAAA;AzEysYR;;AyE7sYI;EACI,wCAAA;EACA,0BAAA;EACA,wDAAA;EACA,6CAAA;AzEgtYR;;AyEptYI;EACI,qCAAA;EACA,0BAAA;EACA,qDAAA;EACA,0CAAA;AzEutYR;;AyE3tYI;EACI,wCAAA;EACA,0BAAA;EACA,wDAAA;EACA,6CAAA;AzE8tYR;;AyEluYI;EACI,uCAAA;EACA,0BAAA;EACA,uDAAA;EACA,4CAAA;AzEquYR;;AyEzuYI;EACI,sCAAA;EACA,0BAAA;EACA,sDAAA;EACA,2CAAA;AzE4uYR;;AyEhvYI;EACI,qCAAA;EACA,0BAAA;EACA,qDAAA;EACA,0CAAA;AzEmvYR;;AyEvvYI;EACI,qCAAA;EACA,0BAAA;EACA,qDAAA;EACA,0CAAA;AzE0vYR;;AyE9vYI;EACI,qCAAA;EACA,0BAAA;EACA,qDAAA;EACA,0CAAA;AzEiwYR;;A0EnxYA;EACI,cAAA;EACA,aAAA;A1EsxYJ;;A0EnxYA;EACI,eAAA;EACA,cAAA;A1EsxYJ;;A0EnxYA;EACI,cAAA;EACA,aAAA;A1EsxYJ;;A0EnxYA;EACI,cAAA;EACA,aAAA;A1EsxYJ;;A0EnxYA;EACI,YAAA;EACA,WAAA;A1EsxYJ;;A0EnxYA;EACI,cAAA;EACA,aAAA;A1EsxYJ;;A0EnxYA;EACI,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;A1EsxYJ;;A0EnxYA;EACI,kBAAA;A1EsxYJ;A0EpxYI;EACI,sBAAA;EACA,qBAAA;EACA,mCAAA;EACA,kBAAA;A1EsxYR;;A2Eh0YI;EACI,yBAAA;A3Em0YR;A2Eh0YQ;EACI,oCAAA;A3Ek0YZ;;A4Ez0YQ;EACI,oBAAA;A5E40YZ;A4Ex0YI;;EAEI,sBAAA;A5E00YR;A4Ev0YI;EACI,kBAAA;A5Ey0YR;A4Et0YI;EACI,sBAAA;EACA,kBAAA;EACA,sBAAA;A5Ew0YR;A4Ep0YI;EACI,wCAAA;EACA,sBAAA;A5Es0YR;A4En0YI;EACI,wCAAA;EACA,uBAAA;EACA,qBAAA;A5Eq0YR;A4El0YI;EACI,qBAAA;A5Eo0YR;;A4Eh0YA;EACI,aAAA;A5Em0YJ;;A4E5yYI;EAjBA,uBAAA;EACA,oCAAA;EACA,kCAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;EACA,gEAAA;A5Ei0YJ;;A4E5zYI;EAjBA,uBAAA;EACA,qCAAA;EACA,kCAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;EACA,gEAAA;A5Ei1YJ;;A4E50YI;EAjBA,uBAAA;EACA,oCAAA;EACA,kCAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;EACA,gEAAA;A5Ei2YJ;;A4E51YI;EAjBA,uBAAA;EACA,oCAAA;EACA,kCAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;EACA,gEAAA;A5Ei3YJ;;A4E52YI;EAjBA,uBAAA;EACA,oCAAA;EACA,kCAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;EACA,gEAAA;A5Ei4YJ;;A4E53YI;EAjBA,uBAAA;EACA,oCAAA;EACA,kCAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;EACA,gEAAA;A5Ei5YJ;;A4E54YI;EAjBA,uBAAA;EACA,qCAAA;EACA,kCAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;EACA,gEAAA;A5Ei6YJ;;A4E55YI;EAjBA,uBAAA;EACA,kCAAA;EACA,kCAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;EACA,gEAAA;A5Ei7YJ;;A4E56YI;EAjBA,uBAAA;EACA,qCAAA;EACA,kCAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;EACA,gEAAA;A5Ei8YJ;;A4E57YI;EAjBA,uBAAA;EACA,oCAAA;EACA,kCAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;EACA,gEAAA;A5Ei9YJ;;A4Et8YA;;EAEI,kCAAA;EACA,qCAAA;EACA,yCAAA;EACA,+CAAA;A5Ey8YJ;;A4En8YI;EACI,kCAAA;EACA,+BAAA;EACA,yCAAA;EACA,wCAAA;EACA,qCAAA;EACA,+CAAA;EACA,yCAAA;EACA,sCAAA;EACA,gDAAA;A5Es8YR;A4En8YI;EACI,kCAAA;A5Eq8YR;A4El8YI;;EAEI,wCAAA;EACA,kCAAA;A5Eo8YR;A4Ej8YI;EACI,kCAAA;EACA,4CAAA;A5Em8YR;;A6E3iZA;EACI,mCtEwxCgC;EsEvxChC,mBtEuf0B;APujY9B;;A6E3iZA;EACI,eAAA;EACA,cAAA;EACA,cAAA;A7E8iZJ;;A6E3iZA;EACI,YAAA;EACA,YAAA;A7E8iZJ;A6E5iZI;EACI,cAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;A7E8iZR;A6E1iZgB;EACI,iBAAA;A7E4iZpB;;A6EpiZA;;EAEI,aAAA;A7EuiZJ;;A6EniZA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,sCtE4uCgC;EsE3uChC,iDAAA;EACA,gBAAA;A7EsiZJ;A6EpiZI;EACI,oCAAA;EACA,8CAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;A7EsiZR;;A6EliZA;EACI;IACI,yDAAA;E7EqiZN;E6EliZE;IACI,8DAAA;E7EoiZN;E6EjiZE;IACI,iEAAA;E7EmiZN;AACF;A6EhiZA;EACI,eAAA;EACA,iBAAA;A7EkiZJ;;A6E/hZA;EACI,mBAAA;EACA,mBtEsa0B;EsEra1B,qBtEkkB0B;APg+X9B;;A8ElnZY;;EACI,yBvEmUD;EuElUC,qBvEkUD;APozYf;;A8ExnZY;;EACI,yBvEmUD;EuElUC,qBvEkUD;AP0zYf;;A8E9nZY;;EACI,yBvEmUD;EuElUC,qBvEkUD;APg0Yf;;A8EpoZY;;EACI,yBvEmUD;EuElUC,qBvEkUD;APs0Yf;;A8E1oZY;;EACI,yBvEmUD;EuElUC,qBvEkUD;AP40Yf;;A8EhpZY;;EACI,yBvEmUD;EuElUC,qBvEkUD;APk1Yf;;A8EtpZY;;EACI,yBvEmUD;EuElUC,qBvEkUD;APw1Yf;;A8E5pZY;;EACI,yBvEmUD;EuElUC,qBvEkUD;AP81Yf;;A8ElqZY;;EACI,yBvEmUD;EuElUC,qBvEkUD;APo2Yf;;A8ExqZY;;EACI,yBvEmUD;EuElUC,qBvEkUD;AP02Yf;;A8ErqZA;EACI,UAAA;A9EwqZJ;A8EtqZI;EACI,wCvEgxC4B;EuE/wC5B,wCAAA;EACA,sCAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;A9EwqZR;A8EtqZQ;EACI,eAAA;A9EwqZZ;A8EpqZI;EACI,aAAA;A9EsqZR;A8EnqZY;EACI,iBAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,cvEYH;APypZb;A8E7pZgB;EACI,WvE3BT;AP0rZX;;A+EltZA;EACI,eAAA;EACA,gCxE4hB0B;EwE3hB1B,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,SAAA;A/EqtZJ;A+EntZI;EACI,oBAAA;A/EqtZR;A+EltZI;EACI,qBAAA;A/EotZR;;A+E9sZA;EACI,mBAAA;EACA,qBAAA;A/EitZJ;;A+E9sZA;;;EAGI,oBAAA;EACA,0BAAA;A/EitZJ;;A+E9sZA;EACI;IACI,wBAAA;E/EitZN;E+E9sZE;IACI,2BAAA;E/EgtZN;AACF;A+E1sZA;EACI,2BAAA;A/E4sZJ;;A+EzsZA;EACI,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,0DAAA;EACA,iCAAA;EACA,4BAAA;A/E4sZJ;;A+EzsZA;EACI,qBAAA;EACA,uBAAA;A/E4sZJ;;A+ExsZI;EACI,0BAAA;EACA,kBAAA;A/E2sZR;A+EzsZQ;EACI,2BxEqnCwB;APslXpC;A+EzsZY;EACI,cxEjBH;AP4tZb;A+EvsZQ;EACI,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,oCAAA;A/EysZZ;;A+ElsZQ;EACI,iBAAA;A/EqsZZ;;A+E/rZA;EACI,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,6BAAA;EACA,2BxEolCgC;AP8mXpC;A+EhsZI;EACI,YAAA;A/EksZR;A+E/rZI;EACI,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A/EisZR;A+E9rZI;EACI,iCxEwkC4B;APwnXpC;;Ae1vZI;EgEgEA;IACI,YAAA;E/E8rZN;E+E3rZE;IACI,YAAA;E/E6rZN;AACF;A+E1rZA;EACI,gCAAA;A/E4rZJ;;A+EzrZA;EACI,aAAA;A/E4rZJ;;A+ExrZI;EACI,UAAA;EACA,QAAA;A/E2rZR;;A+ErrZQ;EACI,yBAAA;EACA,oBAAA;A/EwrZZ;;A+ElrZA;EACI,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;A/EqrZJ;A+EnrZI;EACI,oBAAA;A/EqrZR;A+ElrZI;EACI,qBAAA;A/EorZR;A+EjrZI;EAGI,oBAAA;EACA,0BAAA;A/EirZR;;A+E7qZA;EACI;IACI,wBAAA;E/EgrZN;E+E7qZE;IACI,2BAAA;E/E+qZN;AACF;A+E3qZA;EACI;IACI,YAAA;E/E6qZN;AACF;A+EtqZQ;EACI,aAAA;A/EwqZZ;;A+EjqZA;EACI,cAAA;A/EoqZJ;A+ElqZI;EACI,6BAAA;EACA,kBAAA;A/EoqZR;A+EjqZI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;A/EmqZR;A+E/pZI;EACI,kBAAA;A/EiqZR;A+E/pZQ;EACI,iCAAA;A/EiqZZ;A+E9pZQ;EACI,6BAAA;EACA,gCAAA;A/EgqZZ;A+E9pZY;EACI,iCAAA;A/EgqZhB;A+E5pZQ;EACI,aAAA;A/E8pZZ;A+E5pZY;EACI,kBAAA;EACA,QAAA;EACA,UAAA;A/E8pZhB;A+E3pZY;EACI,eAAA;A/E6pZhB;A+E1pZY;;EAEI,gBAAA;EACA,uBAAA;EACA,mBAAA;A/E4pZhB;A+ExpZQ;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WxEnPD;AP64ZX;A+EvpZQ;EACI,gBAAA;EACA,gBAAA;EACA,iBAAA;A/EypZZ;A+EvpZY;EACI,gBAAA;A/EypZhB;A+EtpZY;EACI,cAAA;A/EwpZhB;;A+ElpZA;EACI,gBAAA;A/EqpZJ;A+EnpZI;;EAEI,sBAAA;A/EqpZR;;AgFv7ZA;;EAEI,gBAAA;AhF07ZJ;;AgFt7ZI;EACI,kCzEy3BgC;APgkYxC;;AgFp7ZI;EACI,mCzEo3BgC;APmkYxC;;AgFl7ZA;EACI,4CAAA;EACA,wCAAA;AhFq7ZJ;;AgF/6ZI;EACI,gCAAA;EACA,kEAAA;AhFk7ZR;AgF/6ZI;EACI,oCAAA;EACA,aAAA;EACA,oCAAA;EACA,gBAAA;EACA,kEAAA;AhFi7ZR;;AgFz6ZI;EACI,kBAAA;EACA,mBAAA;EACA,mBAAA;AhF46ZR;AgFz6ZI;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,uCzE00BgC;EyEz0BhC,UAAA;EACA,SAAA;EACA,qBzE0lBsB;APi1Y9B;;AgFt6ZA;EACI,eAAA;AhFy6ZJ;AgFv6ZI;EACI,oCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;AhFy6ZR;;AgFn6ZQ;EACI,iBAAA;AhFs6ZZ;;AiF1/ZA;EACI,gC1EgiB0B;AP69Y9B;;AiFv+ZI;EAjBA,c1EmUW;E0ElUX,0CAAA;EACA,gBAAA;AjF4/ZJ;;AiFx+ZI;EAdA,c1E2TW;E0E1TX,yBAAA;EACA,6BAAA;EACA,gBAAA;AjF0/ZJ;;AiFp/ZI;EAjBA,c1EmUW;E0ElUX,2CAAA;EACA,gBAAA;AjFygaJ;;AiFr/ZI;EAdA,c1E2TW;E0E1TX,yBAAA;EACA,6BAAA;EACA,gBAAA;AjFugaJ;;AiFjgaI;EAjBA,c1EmUW;E0ElUX,0CAAA;EACA,gBAAA;AjFshaJ;;AiFlgaI;EAdA,c1E2TW;E0E1TX,yBAAA;EACA,6BAAA;EACA,gBAAA;AjFohaJ;;AiF9gaI;EAjBA,c1EmUW;E0ElUX,0CAAA;EACA,gBAAA;AjFmiaJ;;AiF/gaI;EAdA,c1E2TW;E0E1TX,yBAAA;EACA,6BAAA;EACA,gBAAA;AjFiiaJ;;AiF3haI;EAjBA,c1EmUW;E0ElUX,0CAAA;EACA,gBAAA;AjFgjaJ;;AiF5haI;EAdA,c1E2TW;E0E1TX,yBAAA;EACA,6BAAA;EACA,gBAAA;AjF8iaJ;;AiFxiaI;EAjBA,c1EmUW;E0ElUX,0CAAA;EACA,gBAAA;AjF6jaJ;;AiFziaI;EAdA,c1E2TW;E0E1TX,yBAAA;EACA,6BAAA;EACA,gBAAA;AjF2jaJ;;AiFrjaI;EAjBA,c1EmUW;E0ElUX,2CAAA;EACA,gBAAA;AjF0kaJ;;AiFtjaI;EAdA,c1E2TW;E0E1TX,yBAAA;EACA,6BAAA;EACA,gBAAA;AjFwkaJ;;AiFlkaI;EAjBA,c1EmUW;E0ElUX,wCAAA;EACA,gBAAA;AjFulaJ;;AiFnkaI;EAdA,c1E2TW;E0E1TX,yBAAA;EACA,6BAAA;EACA,gBAAA;AjFqlaJ;;AiF/kaI;EAjBA,c1EmUW;E0ElUX,2CAAA;EACA,gBAAA;AjFomaJ;;AiFhlaI;EAdA,c1E2TW;E0E1TX,yBAAA;EACA,6BAAA;EACA,gBAAA;AjFkmaJ;;AiF5laI;EAjBA,c1EmUW;E0ElUX,0CAAA;EACA,gBAAA;AjFinaJ;;AiF7laI;EAdA,c1E2TW;E0E1TX,yBAAA;EACA,6BAAA;EACA,gBAAA;AjF+maJ;;AiF/laA;EACI,sBAAA;AjFkmaJ;AiFhmaI;EACI,kBAAA;EACA,iBAAA;AjFkmaR;;AkFtoaA;EACI,aAAA;AlFyoaJ;;AkFroaA;EACI,UAAA;EACA,eAAA;AlFwoaJ;;AkFpoaA;EACI,cAAA;AlFuoaJ;;AkFnoaA;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,wBAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,wC3EwwCgC;E2EvwChC,qBAAA;EACA,uCAAA;AlFsoaJ;AkFpoaI;EACI,eAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AlFsoaR;;AkFhoaQ;;EAEI,qCAAA;AlFmoaZ;;AkF7naA;EACI,aAAA;EACA,wBAAA;EAEA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;AlFgoaJ;;AkF5naA;EACI,W3EjCO;E2EkCP,gBAAA;AlF+naJ;;AkF3naA;EACI,W3EvCO;APqqaX;AkF5naI;EACI,2CAAA;AlF8naR;AkF3naI;;EAEI,YAAA;AlF6naR;;AmFnsaQ;;EACI,yBAAA;EACA,gB5EmlBkB;APonZ9B;;AmFjsaI;EACI,yBAAA;EACA,gB5E2kBsB;APynZ9B;;AmF7raQ;;EACI,WAAA;AnFisaZ;;AmF1raI;EACI,iCAAA;EACA,aAAA;AnF6raR;;AmFvraA;EACI,0DAAA;AnF0raJ;AmFzraI;EACI,mBAAA;AnF2raR;AmFvraQ;EACI,oBAAA;EACA,kBAAA;AnFyraZ;AmFrraI;EACI,2CAAA;AnFuraR;;AmFnraA;EACI,mBAAA;AnFsraJ;;AoF3uaI;EACI,8BAAA;EACA,wBAAA;EACA,YAAA;ApF8uaR;;AqFnvaA;EACI,aAAA;ArFsvaJ;;AqFhvaI;EACI,wCAAA;EACA,uDAAA;EACA,oDAAA;EACA,qDAAA;EACA,4CAAA;EACA,6CAAA;ArFmvaR;;AqFzvaI;EACI,wCAAA;EACA,yDAAA;EACA,sDAAA;EACA,qDAAA;EACA,4CAAA;EACA,6CAAA;ArF4vaR;;AqFlwaI;EACI,wCAAA;EACA,uDAAA;EACA,oDAAA;EACA,qDAAA;EACA,4CAAA;EACA,6CAAA;ArFqwaR;;AqF3waI;EACI,wCAAA;EACA,oDAAA;EACA,iDAAA;EACA,qDAAA;EACA,4CAAA;EACA,6CAAA;ArF8waR;;AqFpxaI;EACI,wCAAA;EACA,uDAAA;EACA,oDAAA;EACA,qDAAA;EACA,4CAAA;EACA,6CAAA;ArFuxaR;;AqF7xaI;EACI,wCAAA;EACA,sDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4CAAA;EACA,6CAAA;ArFgyaR;;AqFtyaI;EACI,wCAAA;EACA,qDAAA;EACA,kDAAA;EACA,qDAAA;EACA,4CAAA;EACA,6CAAA;ArFyyaR;;AqF/yaI;EACI,wCAAA;EACA,oDAAA;EACA,iDAAA;EACA,qDAAA;EACA,4CAAA;EACA,6CAAA;ArFkzaR;;AqFxzaI;EACI,wCAAA;EACA,oDAAA;EACA,iDAAA;EACA,qDAAA;EACA,4CAAA;EACA,6CAAA;ArF2zaR;;AqFj0aI;EACI,wCAAA;EACA,oDAAA;EACA,iDAAA;EACA,qDAAA;EACA,4CAAA;EACA,6CAAA;ArFo0aR;;AsFh1aA;EACI;;;;;IAKI,aAAA;EtFm1aN;EsFj1aE;;;;;IAKI,UAAA;IACA,SAAA;EtFm1aN;EsFh1aE;IACI,gBAAA;EtFk1aN;AACF;AuFn2aA;EACI,WAAA;AvFq2aJ;;AuFj2aA;EACI,WAAA;AvFo2aJ;;AuFh2aA;EACI,YAAA;AvFm2aJ;;AuF/1aA;EACI,YAAA;AvFk2aJ;;AuF91aA,yBAAA;AACA;EACI,iBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AvFi2aJ;AuF/1aI;EACI,WAAA;AvFi2aR;AuF91aI;EACI,WAAA;AvFg2aR;AuF71aI;EACI,WAAA;AvF+1aR;AuF51aI;EACI,UAAA;AvF81aR;AuF31aI;EACI,UAAA;AvF61aR;;AuFz1aA;EACI,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AvF41aJ;AuF11aI;EACI,WAAA;EACA,SAAA;EACA,kBAAA;AvF41aR;AuFz1aI;EACI,WAAA;AvF21aR;AuFx1aI;EACI,WAAA;AvF01aR;AuFv1aI;EACI,UAAA;AvFy1aR;AuFt1aI;EACI,UAAA;AvFw1aR;;AwF16aA;EACI,kBAAA;EACA,gBAAA;AxF66aJ;;AwFz6aA;EACI;IACI,eAAA;ExF46aN;AACF;AwFz6aA;EACI,kBAAA;AxF26aJ;;AwFx6aA;;EAEI,wBAAA;AxF26aJ;;AwFt6aA;EACI,gBjFgkB0B;APy2Z9B;;AwFr6aA;EACI,iBAAA;AxFw6aJ;;AwFr6aA;;EAEI,gBjFujB0B;APi3Z9B;;AyF18aA;EACI,kBAAA;EA4DA,eAAA;AzFk5aJ;AyF58aI;EACI,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,+CAAA;EACA,WlFiBG;EkFhBH,eAAA;EACA,gBlF6kBsB;APi4Z9B;AyF58aQ;EACI,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,OAAA;EACA,oBAAA;EACA,WAAA;AzF88aZ;AyF38aQ;EACI,kBAAA;EACA,0BAAA;AzF68aZ;AyF18aQ;EACI,mBAAA;EACA,0BAAA;AzF48aZ;AyF18aY;EACI,QAAA;AzF48ahB;AyFv8aY;EACI,wBAAA;AzFy8ahB;AyFp8aI;EACI,WAAA;AzFs8aR;AyFj8aQ;EACI,mBAAA;AzFm8aZ;AyFj8aY;EACI,uFAAA;AzFm8ahB;AyFv8aQ;EACI,mBAAA;AzFy8aZ;AyFv8aY;EACI,sFAAA;AzFy8ahB;AyF78aQ;EACI,mBAAA;AzF+8aZ;AyF78aY;EACI,wFAAA;AzF+8ahB;AyFn9aQ;EACI,mBAAA;AzFq9aZ;AyFn9aY;EACI,wFAAA;AzFq9ahB;AyFz9aQ;EACI,mBAAA;AzF29aZ;AyFz9aY;EACI,sFAAA;AzF29ahB;AyF/9aQ;EACI,mBAAA;AzFi+aZ;AyF/9aY;EACI,uFAAA;AzFi+ahB;AyFr+aQ;EACI,mBAAA;AzFu+aZ;AyFr+aY;EACI,qEAAA;AzFu+ahB;AyF3+aQ;EACI,mBAAA;AzF6+aZ;AyF3+aY;EACI,iEAAA;AzF6+ahB;AyFj/aQ;EACI,mBAAA;AzFm/aZ;AyFj/aY;EACI,gEAAA;AzFm/ahB;AyFv/aQ;EACI,mBAAA;AzFy/aZ;AyFv/aY;EACI,mFAAA;AzFy/ahB;AyFn/aI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AzFq/aR;AyFn/aQ;EACI,eAAA;EACA,WlFhDD;EkFiDC,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,8EAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBlFogBkB;APi/Z9B;AyFn/aY;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,mCAAA;EACA,oCAAA;AzFq/ahB;AyFl/aY;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,kCAAA;EACA,oCAAA;AzFo/ahB;AyF5+aY;EACI,mBAAA;AzF8+ahB;AyF5+agB;EACI,wEAAA;EACA,uEAAA;AzF8+apB;AyF3+agB;EACI,yEAAA;EACA,uEAAA;AzF6+apB;AyFv/aY;EACI,mBAAA;AzFy/ahB;AyFv/agB;EACI,uEAAA;EACA,sEAAA;AzFy/apB;AyFt/agB;EACI,wEAAA;EACA,sEAAA;AzFw/apB;AyFlgbY;EACI,mBAAA;AzFogbhB;AyFlgbgB;EACI,yEAAA;EACA,wEAAA;AzFogbpB;AyFjgbgB;EACI,0EAAA;EACA,wEAAA;AzFmgbpB;AyF7gbY;EACI,mBAAA;AzF+gbhB;AyF7gbgB;EACI,yEAAA;EACA,wEAAA;AzF+gbpB;AyF5gbgB;EACI,0EAAA;EACA,wEAAA;AzF8gbpB;AyFxhbY;EACI,mBAAA;AzF0hbhB;AyFxhbgB;EACI,uEAAA;EACA,sEAAA;AzF0hbpB;AyFvhbgB;EACI,wEAAA;EACA,sEAAA;AzFyhbpB;AyFnibY;EACI,mBAAA;AzFqibhB;AyFnibgB;EACI,wEAAA;EACA,uEAAA;AzFqibpB;AyFlibgB;EACI,yEAAA;EACA,uEAAA;AzFoibpB;AyF9ibY;EACI,mBAAA;AzFgjbhB;AyF9ibgB;EACI,sDAAA;EACA,qDAAA;AzFgjbpB;AyF7ibgB;EACI,uDAAA;EACA,qDAAA;AzF+ibpB;AyFzjbY;EACI,mBAAA;AzF2jbhB;AyFzjbgB;EACI,kDAAA;EACA,iDAAA;AzF2jbpB;AyFxjbgB;EACI,mDAAA;EACA,iDAAA;AzF0jbpB;AyFpkbY;EACI,mBAAA;AzFskbhB;AyFpkbgB;EACI,iDAAA;EACA,gDAAA;AzFskbpB;AyFnkbgB;EACI,kDAAA;EACA,gDAAA;AzFqkbpB;AyF/kbY;EACI,mBAAA;AzFilbhB;AyF/kbgB;EACI,oEAAA;EACA,mEAAA;AzFilbpB;AyF9kbgB;EACI,qEAAA;EACA,mEAAA;AzFglbpB;;A0FvsbA;EACI,aAAA;A1F0sbJ;A0FxsbI;EACI,WAAA;EACA,YAAA;EACA,oCAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gCAAA;A1F0sbR;A0FxsbQ;EACI,oCAAA;EACA,6BAAA;EACA,cAAA;EACA,oBAAA;EACA,gBnFkkBkB;EmFjkBlB,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,MAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gCAAA;A1F0sbZ;A0FvsbQ;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,sCAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,gCAAA;A1FysbZ;A0FpsbQ;EACI,yBnFKC;APisbb;A0FpsbY;EACI,WnF5BL;EmF6BK,4BAAA;EACA,WAAA;EACA,SAAA;A1FssbhB;A0FnsbY;EACI,UAAA;EACA,oCAAA;A1FqsbhB;;A0F9rbI;EACI,yBnFZK;AP6sbb;;A0F5rbI;EACI,YAAA;EACA,eAAA;A1F+rbR;;A0F3rbA;;EAEI,sBAAA;A1F8rbJ;;A0F3rbA;EACI,oCAAA;A1F8rbJ;;A0FzrbI;EACI,yBAAA;A1F4rbR;;A0F7rbI;EACI,yBAAA;A1FgsbR;;A0FjsbI;EACI,yBAAA;A1FosbR;;A0FrsbI;EACI,yBAAA;A1FwsbR;;A0FzsbI;EACI,yBAAA;A1F4sbR;;A0F7sbI;EACI,yBAAA;A1FgtbR;;A0FjtbI;EACI,yBAAA;A1FotbR;;A0FrtbI;EACI,yBAAA;A1FwtbR;;A0FztbI;EACI,yBAAA;A1F4tbR;;A0F7tbI;EACI,yBAAA;A1FgubR;;A2F1zbI;;EAEI,iCAAA;A3F6zbR;;A2FtzbQ;EACI,YAAA;EACA,WAAA;A3FyzbZ;A2FrzbI;EACI,yBAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;A3FuzbR;A2FrzbQ;EACI,yBAAA;A3FuzbZ;A2FlzbI;EACI,+CAAA;A3FozbR;A2FhzbQ;EACI,qBAAA;EACA,yBAAA;A3FkzbZ;;A2F5ybI;EACI,eAAA;A3F+ybR;;A2FxybI;;EAEI,mBAAA;A3F2ybR;;A2FrybI;EACI,sBAAA;EACA,+CAAA;EACA,2BAAA;A3FwybR;A2FrybI;EACI,8BAAA;A3FuybR;A2FrybQ;;EAEI,gCAAA;A3FuybZ;;A4F72bA;;;;;;;;;;;;EAYI,cAAA;A5Fg3bJ;;A4Fx2bI;EACI,0BAAA;A5F22bR;;A4F52bI;EACI,0BAAA;A5F+2bR;;A4Fh3bI;EACI,0BAAA;A5Fm3bR;;A4Fp3bI;EACI,0BAAA;A5Fu3bR;;A4Fx3bI;EACI,0BAAA;A5F23bR;;A4F53bI;EACI,0BAAA;A5F+3bR;;A4Fh4bI;EACI,0BAAA;A5Fm4bR;;A4Fp4bI;EACI,0BAAA;A5Fu4bR;;A4Fx4bI;EACI,0BAAA;A5F24bR;;A4F54bI;EACI,0BAAA;A5F+4bR;;A4Fh5bI;EACI,0BAAA;A5Fm5bR;;A4Fp5bI;EACI,0BAAA;A5Fu5bR;;A4Fx5bI;EACI,0BAAA;A5F25bR;;A4F55bI;EACI,0BAAA;A5F+5bR;;A4Fh6bI;EACI,0BAAA;A5Fm6bR;;A4Fp6bI;EACI,0BAAA;A5Fu6bR;;A4Fx6bI;EACI,0BAAA;A5F26bR;;A4Fr6bA;EACI,gBrF2jB0B;AP62a9B;;A4Fr6bA;EACI,gBrFwjB0B;APg3a9B;;A6Fr8bI;EACI,6CAAA;EACA,oCAAA;A7Fw8bR;;A6F18bI;EACI,+CAAA;EACA,oCAAA;A7F68bR;;A6F/8bI;EACI,6CAAA;EACA,oCAAA;A7Fk9bR;;A6Fp9bI;EACI,0CAAA;EACA,oCAAA;A7Fu9bR;;A6Fz9bI;EACI,6CAAA;EACA,oCAAA;A7F49bR;;A6F99bI;EACI,4CAAA;EACA,oCAAA;A7Fi+bR;;A6Fn+bI;EACI,2CAAA;EACA,oCAAA;A7Fs+bR;;A6Fx+bI;EACI,0CAAA;EACA,oCAAA;A7F2+bR;;A6F7+bI;EACI,0CAAA;EACA,oCAAA;A7Fg/bR;;A6Fl/bI;EACI,0CAAA;EACA,oCAAA;A7Fq/bR;;A8Fz/bI;EACI,qBAAA;EACA,8EAAA;A9F4/bR;;A8F9/bI;EACI,qBAAA;EACA,gFAAA;A9FigcR;;A8FngcI;EACI,qBAAA;EACA,8EAAA;A9FsgcR;;A8FxgcI;EACI,qBAAA;EACA,2EAAA;A9F2gcR;;A8F7gcI;EACI,qBAAA;EACA,8EAAA;A9FghcR;;A8FlhcI;EACI,qBAAA;EACA,6EAAA;A9FqhcR;;A8FvhcI;EACI,qBAAA;EACA,4EAAA;A9F0hcR;;A8F5hcI;EACI,qBAAA;EACA,2EAAA;A9F+hcR;;A8FjicI;EACI,qBAAA;EACA,2EAAA;A9FoicR;;A8FticI;EACI,qBAAA;EACA,2EAAA;A9FyicR;;A8FricA;EACI,oBAAA;A9FwicJ;;A8FpicA;EACI,+BAAA;A9FuicJ;;A+FjjcA;;EAEI,uBAAA;A/FojcJ;;A+FjjcA;;EAEI,YAAA;EACA,gBAAA;EACA,wBAAA;EACA,sEAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;A/FojcJ;;A+FjjcA;;;;EAII,iBAAA;EACA,mBAAA;A/FojcJ;;A+FjjcA;EAEI;;IAEI,iBAAA;E/FmjcN;AACF;A+FhjcA,gBAAA;AACA;EACI,YAAA;EACA,SAAA;EACA,cAAA;A/FkjcJ;;A+F/icA,gBAAA;AACA;EACI,cAAA;EACA,oBAAA;EACA,mBAAA;A/FkjcJ;;A+F/icA;;;;EAII,gBAAA;A/FkjcJ;;A+F/icA;EACI,cxFPS;APyjcb;;A+F/icA;EACI,YAAA;A/FkjcJ;;A+F/icA;;;;;;;EAOI,cxFrBS;APukcb;;A+F/icA;;;;;;EAMI,cxFzBS;AP2kcb;;A+F/icA;;;;;EAKI,cAAA;EACA,oEAAA;EACA,uBAAA;A/FkjcJ;;A+F/icA;;;EAGI,cxF5CS;AP8lcb;;A+F/icA;;EAEI,cAAA;A/FkjcJ;;A+F/icA;;;EAGI,WAAA;A/FkjcJ;;A+F/icA;;EAEI,iBAAA;A/FkjcJ;;A+F/icA;EACI,kBAAA;A/FkjcJ;;A+F/icA;EACI,YAAA;A/FkjcJ;;A+F/icA;;EAEI,gCAAA;EACA,iBAAA;EACA,iBAAA;A/FkjcJ;;A+F9icA;EACI,kBAAA;A/FijcJ;A+F9icQ;EACI,wBAAA;A/FgjcZ;A+F7icQ;EACI,UAAA;EACA,iBAAA;A/F+icZ;A+F5icQ;EACI,WAAA;A/F8icZ;A+F3icQ;EACI,+CAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;A/F6icZ;A+F1icQ;EACI,mBAAA;EACA,6BAAA;A/F4icZ;A+FzicQ;EACI,6BAAA;A/F2icZ;A+FvicI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,wCxFknC4B;EwFjnC5B,yBAAA;EACA,cxFpHK;EwFqHL,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uGAAA;A/FyicR;A+FvicQ;EAGI,yBxF/HC;EwFgID,WxFnKD;AP0scX;;AgGnucA;EACI,kBAAA;EACA,gBAAA;AhGsucJ;AgGpucI;EACI,eAAA;AhGsucR;;AgGhucI;EACI,2CAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AhGmucR;AgGjucQ;EACI,mBAAA;AhGmucZ;AgGhucQ;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AhGkucZ;AgGhucY;EACI,WAAA;AhGkuchB;AgG9tcQ;EAEI,cAAA;EACA,kBAAA;AhG+tcZ;AgG3tcQ;EACI,qBzF6mBkB;EyF5mBlB,cAAA;EACA,oBAAA;EACA,SAAA;EACA,gBAAA;AhG6tcZ;AgG1tcQ;EACI,yBAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AhG4tcZ;;AgGvtcA,gBAAA;AAEA;EACI,gBAAA;EACA,eAAA;AhGytcJ;AgGvtcI;EACI,mBAAA;AhGytcR;AgGvtcQ;EACI,YAAA;EACA,aAAA;AhGytcZ;AgGrtcY;EACI,cAAA;AhGutchB;AgGltcI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;AhGotcR;AgGltcQ;EACI,mBAAA;EACA,WAAA;AhGotcZ;AgGjtcQ;EACI,eAAA;EACA,kBAAA;AhGmtcZ;AgG/scI;EACI,2BAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;AhGitcR;AgG/scQ;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBzF8ekB;EyF7elB,kBAAA;AhGitcZ;AgG9scQ;EACI,SAAA;EACA,gBAAA;AhGgtcZ;AgG7scQ;EACI,WAAA;EACA,MAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;EACA,iCAAA;EACA,iBAAA;EACA,kBAAA;EACA,mCAAA;AhG+scZ;AgG3scI;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;AhG6scR;AgGzscQ;EACI,uBAAA;AhG2scZ;AgGxscQ;EACI,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;AhG0scZ;AgGvscQ;EACI,iCAAA;AhGyscZ;AgGvscY;EACI,yBAAA;EACA,kCAAA;EACA,iCAAA;EACA,uBAAA;EACA,UAAA;AhGyschB;AgGrscQ;EACI,WAAA;AhGuscZ;;AiGz2cA;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AjG42cJ;AiG12cI;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,oCAAA;AjG42cR;AiGz2cI;EACI,cAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,yB1FiCK;AP00cb;AiGx2cI;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AjG02cR;AiGx2cQ;EACI,cAAA;EACA,kBAAA;EACA,wBAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,c1FcC;E0FbD,8BAAA;EACA,uCAAA;EACA,kBAAA;EACA,UAAA;AjG02cZ;AiGx2cY;EACI,cAAA;AjG02chB;AiGv2cY;EACI,eAAA;EACA,c1FOH;APk2cb;AiGt2cY;EACI,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;AjGw2chB;AiGp2cgB;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,uCAAA;EACA,sBAAA;EACA,mCAAA;EACA,mCAAA;AjGs2cpB;AiGn2cgB;EACI,yBAAA;AjGq2cpB;;AiG91cA;EACI;IACI,yCAAA;IACA,UAAA;EjGi2cN;EiG91cE;IACI,yCAAA;IACA,UAAA;EjGg2cN;AACF;Ae73cI;EkFoCY;IACI,oBAAA;EjG41clB;AACF;AkG18cA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,wC3F2xCgC;E2F1xChC,aAAA;AlG48cJ;;AkGz8cA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;AlG48cJ;;AkGz8cA;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,wCAAA;EACA,0CAAA;EACA,2CAAA;EACA,wCAAA;EACA,wBAAA;EACA,gDAAA;AlG48cJ;;AkGz8cA;;EAEI,kBAAA;EACA,WAAA;EACA,YAAA;AlG48cJ;;AkGz8cA;EACI;IACI,uBAAA;ElG48cN;EkGz8cE;IACI,yBAAA;ElG28cN;AACF;AmGz/cA;EACI,kBAAA;EACA,uBAAA;AnG2/cJ;AmGz/cI;EACI,YAAA;EACA,8DAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;AnG2/cR;AmGx/cI;EACI,iBAAA;AnG0/cR;;AoGhhdA;;;;;CAAA;AAOA;;;;;;;;;;;;;gCAAA;AA2BA;EACE,sCAAA;EACA,6CAAA;EACA,yFAAA;EAEA,gBAAA;ApGogdF;AoGjgdA;EACE,sCAAA;EACA,6CAAA;EACA,2FAAA;EAEA,gBAAA;ApGkgdF;AoGhgdA;EACE,sCAAA;EACA,6CAAA;EACA,0FAAA;EAEA,gBAAA;ApGigdF;AoG//cA;EACE,sCAAA;EACA,6CAAA;EACA,4FAAA;EAEA,gBAAA;ApGggdF;AoG9/cA;EACE,sCAAA;EACA,6CAAA;EACA,wFAAA;EAEA,gBAAA;ApG+/cF;AoG5/cA;;mBAAA;AAIA;;;;;;;;;;;EAME,sCCpDsB;ArGsjdxB;;AoG//cA;EACE,iBAAA;ApGkgdF;;AoG//cA;EACE,gCAAA;EACA,aAAA;ApGkgdF;;AoG//cA;EACE,gBAAA;EACA,eAAA;ApGkgdF;;AoGhgdA;EAEE,iCCvEqB;EDwErB,eC5Ec;ED6Ed,yBCpGS;EDoIT,gBAAA;EAkBA;;qBAAA;EA8CA,wBAAA;EA8BA;;qBAAA;EAiGA;;sBAAA;EA0BA;;sBAAA;EAUA;;sBAAA;EAmDA;;sBAAA;EA2BA;;sBAAA;EAyBA;;sBAAA;EAyDA;;sBAAA;EASA;;sBAAA;EAoCA;;qBAAA;ApGqlcF;AoGnidE;EACE,kBAAA;EACA,iBAAA;EACA,oBAAA;ApGqidJ;AoGlidE;EACE,kBAAA;EACA,iBAAA;EACA,oBAAA;ApGoidJ;AoGjidE;EACE,wBAAA,EAAA,4BAAA;ApGmidJ;AoGhidE;EACE,kBAAA;ApGkidJ;AoG/hdE;EACE;IACE,iBAAA;EpGiidJ;AACF;AoG9hdE;EACE,iEAAA;ApGgidJ;AoG3hdE;EACE,eAAA;EACA,2BAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EAGA,kBAAA;ApG6hdJ;AoG5hdI;EACE,eAAA;EACA,iBAAA;ApG8hdN;AoGthdE;EACE,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;ApGwhdJ;AoGthdM;EACE,qBAAA;ApGwhdR;AoGthdM;EACE,aAAA;ApGwhdR;AoGnhdQ;EACE,iBAAA;EACA,+BAAA;EACA,oBAAA;EACA,wCAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;ApGqhdV;AoGphdU;EAGE,cCtLD;ArG0sdX;AoG7gdE;EACE,eAAA;EACA,eAAA;EACA,kBAAA;EACA,cCjMO;ArGgtdX;AoG1gdE;EACE,eAAA;EACA,iBAAA;EACA,yBCzMO;ED0MP,gDAAA;ApG4gdJ;AoG1gdM;EACE,qBAAA;ApG4gdR;AoG1gdM;EACE,aAAA;ApG4gdR;AoGtgdQ;EACE,4BAAA;ApGwgdV;AoGvgdU;EAGE,cC9MI;ArGqtdhB;AoG5/cE;EACE,kBAAA;EACA,4BAAA;ApG8/cJ;AoG3/cE;EACE,cAAA;EACA,WAAA;EACA,YAAA;ApG6/cJ;AoG1/cE;EACE,mBAAA;EACA,sBAAA;ApG4/cJ;AoGx/cI;EACE,gBAAA;EACA,eAAA;ApG0/cN;AoGv/cM;EACE,kBAAA;EACA,0CAAA;EACA,YAAA;EACA,eCzOQ;ED0OR,+BAAA;EACA,oCAAA;ApGy/cR;AoGx/cQ;EACE,+BAAA;ApG0/cV;AoGx/cQ;EACE,+BAAA;ApG0/cV;AoGx/cQ;EACE,+BAAA;ApG0/cV;AoGx/cQ;EACE,+BAAA;ApG0/cV;AoGv/cM;EACE,gBAAA;ApGy/cR;AoGv/cM;EACE,UAAA;EACA,gBAAA;ApGy/cR;AoGp/cE;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;ApGs/cJ;AoGn/cE;EACE,kBAAA;EACA,gBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;ApGq/cJ;AoGl/cE;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;ApGo/cJ;AoGj/cE;EACE,kBAAA;EACA,UAAA;EACA,kDAAA;EACA,kBAAA;EACA,oBAAA;ApGm/cJ;AoGh/cM;EACE,iBAAA;EACA,YAAA;ApGk/cR;AoGz+cE;EACE,aAAA;EACA,kBAAA;ApG2+cJ;AoGx+cM;EACE,gBAAA;ApG0+cR;AoGp+cI;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,sDC9TS;ED+TT,kBAAA;EACA,iBAAA;ApGs+cN;AoG99cE;;EAEE,kDAAA;EACA,kBAAA;ApGg+cJ;AoGz9cE;EACE,kBAAA;EACA,gBAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ApG29cJ;AoG19cI;EACE,yBCjWU;EDkWV,cCvWU;EDwWV,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,wBAAA;ApG49cN;AoGz9cE;EACE,mEAAA;ApG29cJ;AoGx9cE;EACE,kBAAA;ApG09cJ;AoGz9cI;EACE,kBAAA;EACA,kBAAA;ApG29cN;AoGz9cM;EACE,kBAAA;EACA,OAAA;ApG29cR;AoGt9cE;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;ApGw9cJ;AoGv9cI;EACE,WAAA;ApGy9cN;AoGj9cE;EACE,YAAA;EACA,WAAA;EACA,cCpZY;EDqZZ,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;ApGm9cJ;AoGh9cE;EACE,aAAA;EACA,iBAAA;EACA,eAAA;ApGk9cJ;AoG/8cE;EACE,iBAAA;EACA,iBAAA;ApGi9cJ;AoGz8cI;EACE,kBAAA;ApG28cN;AoG18cM;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBCjcG;EDkcH,YAAA;EACA,UAAA;EACA,wBAAA;ApG48cR;AoGx8cM;EACE,eAAA;ApG08cR;AoGj8cE;EACE,kDAAA;EACA,kBAAA;ApGm8cJ;AoGl8cI;EACE,qBAAA;ApGo8cN;AoGn8cM;EACE,YAAA;ApGq8cR;AoGn8cM;EACE,YAAA;ApGq8cR;AoGh8cE;EACE,eAAA;EACA,aAAA;EACA,cCndY;ArGq5dhB;AoG/7cE;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;ApGi8cJ;AoG97cE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;ApGg8cJ;AoG77cE;EACE,aAAA;ApG+7cJ;AoG57cE;EACE,kBAAA;EACA,mBAAA;ApG87cJ;AoG37cE;EACE,cCrfY;EDsfZ,eAAA;ApG67cJ;AoGt7cE;EACE,mEAAA;EACA,kBAAA;ApGw7cJ;AoGj7cE;EACE,eAAA;EACA,aAAA;EACA,0BAAA;ApGm7cJ;AoGj7cM;EACE,gBAAA;ApGm7cR;AoGl7cQ;EACE,+BAAA;EACA,oBAAA;ApGo7cV;AoGn7cU;EACE,cC/hBD;ArGo9dX;AoG76cQ;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;ApG+6cV;AoG96cU;EACE,cC7iBD;ArG69dX;AoGt6cE;EACE;IACE,cAAA;EpGw6cJ;AACF;AoGr6cE;EACE;IACE,cAAA;EpGu6cJ;AACF;AoGp6cE;EACE;IACE,cAAA;EpGs6cJ;AACF;AoGn6cE;EACE;IACE,eAAA;IACA,4BAAA;IACA,oCAAA;IACA,gDAAA;EpGq6cJ;EoGl6cM;IACE,qBAAA;EpGo6cR;EoGl6cM;IACE,aAAA;EpGo6cR;EoG/5cQ;IACE,oBAAA;IACA,uCAAA;IACA,WAAA;IACA,gBAAA;EpGi6cV;EoGh6cU;IAGE,yBAAA;EpGg6cZ;EoG15cE;IACE,eAAA;IACA,eAAA;IACA,kBAAA;IACA,cC3lBU;ErGu/dd;EoG15cE;IACE,4BAAA;EpG45cJ;EoG15cE;IACE,8BAAA;EpG45cJ;AACF;AoGz5cE;EAEI;IACE,eAAA;EpG05cN;EoGv5cE;IACE,aAAA;EpGy5cJ;EoGv5cE;;;IAGE,wBAAA;EpGy5cJ;EoGv5cE;IACE,sBAAA;IACA,kBAAA;EpGy5cJ;AACF","sourcesContent":["@charset \"UTF-8\";\n/*\nTemplate Name: Ubold - Responsive Bootstrap 5 Admin Dashboard\nVersion: 7.0.0\nAuthor: CoderThemes\nEmail: support@coderthemes.com\nFile: Bootstrap Css File\n*/\n/*!\n * Bootstrap  v5.3.0-alpha1 (https://getbootstrap.com/)\n * Copyright 2011-2022 The Bootstrap Authors\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n@import url(\"https://fonts.googleapis.com/css?family=Nunito:400,600,700,900\");\n:root,\n[data-bs-theme=light] {\n  --ct-blue: #4a81d4;\n  --ct-indigo: #675aa9;\n  --ct-purple: #6658dd;\n  --ct-pink: #f672a7;\n  --ct-red: #f1556c;\n  --ct-orange: #fd7e14;\n  --ct-yellow: #f7b84b;\n  --ct-green: #1abc9c;\n  --ct-teal: #02a8b5;\n  --ct-cyan: #43bfe5;\n  --ct-black: #000;\n  --ct-white: #fff;\n  --ct-gray: #98a6ad;\n  --ct-gray-dark: #343a40;\n  --ct-gray-100: #f3f7f9;\n  --ct-gray-200: #f7f7f7;\n  --ct-gray-300: #dee2e6;\n  --ct-gray-400: #ced4da;\n  --ct-gray-500: #adb5bd;\n  --ct-gray-600: #98a6ad;\n  --ct-gray-700: #6c757d;\n  --ct-gray-800: #343a40;\n  --ct-gray-900: #323a46;\n  --ct-primary: #6658dd;\n  --ct-secondary: #6c757d;\n  --ct-success: #1abc9c;\n  --ct-info: #43bfe5;\n  --ct-warning: #f7b84b;\n  --ct-danger: #f1556c;\n  --ct-light: #f3f7f9;\n  --ct-dark: #323a46;\n  --ct-pink: #f672a7;\n  --ct-blue: #4a81d4;\n  --ct-primary-rgb: 102, 88, 221;\n  --ct-secondary-rgb: 108, 117, 125;\n  --ct-success-rgb: 26, 188, 156;\n  --ct-info-rgb: 67, 191, 229;\n  --ct-warning-rgb: 247, 184, 75;\n  --ct-danger-rgb: 241, 85, 108;\n  --ct-light-rgb: 243, 247, 249;\n  --ct-dark-rgb: 50, 58, 70;\n  --ct-pink-rgb: 246, 114, 167;\n  --ct-blue-rgb: 74, 129, 212;\n  --ct-primary-text: rgb(81.6, 70.4, 176.8);\n  --ct-secondary-text: #98a6ad;\n  --ct-success-text: rgb(20.8, 150.4, 124.8);\n  --ct-info-text: rgb(40.2, 114.6, 137.4);\n  --ct-warning-text: rgb(148.2, 110.4, 45);\n  --ct-danger-text: rgb(192.8, 68, 86.4);\n  --ct-light-text: #98a6ad;\n  --ct-dark-text: #6c757d;\n  --ct-primary-bg-subtle: rgb(224.4, 221.6, 248.2);\n  --ct-secondary-bg-subtle: #f3f7f9;\n  --ct-success-bg-subtle: rgb(209.2, 241.6, 235.2);\n  --ct-info-bg-subtle: rgb(217.4, 242.2, 249.8);\n  --ct-warning-bg-subtle: rgb(253.4, 240.8, 219);\n  --ct-danger-bg-subtle: rgb(252.2, 221, 225.6);\n  --ct-light-bg-subtle: #f9fbfc;\n  --ct-dark-bg-subtle: #ced4da;\n  --ct-primary-border-subtle: rgb(193.8, 188.2, 241.4);\n  --ct-secondary-border-subtle: #f7f7f7;\n  --ct-success-border-subtle: rgb(163.4, 228.2, 215.4);\n  --ct-info-border-subtle: rgb(179.8, 229.4, 244.6);\n  --ct-warning-border-subtle: rgb(251.8, 226.6, 183);\n  --ct-danger-border-subtle: rgb(249.4, 187, 196.2);\n  --ct-light-border-subtle: #f7f7f7;\n  --ct-dark-border-subtle: #adb5bd;\n  --ct-white-rgb: 255, 255, 255;\n  --ct-black-rgb: 0, 0, 0;\n  --ct-body-color-rgb: 108, 117, 125;\n  --ct-body-bg-rgb: 245, 246, 248;\n  --ct-font-sans-serif: \"Nunito\", sans-serif;\n  --ct-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --ct-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n  --ct-body-font-family: var(--ct-font-sans-serif);\n  --ct-body-font-size: 0.875rem;\n  --ct-body-font-weight: 400;\n  --ct-body-line-height: 1.5;\n  --ct-body-color: #6c757d;\n  --ct-emphasis-color: #000;\n  --ct-emphasis-color-rgb: 0, 0, 0;\n  --ct-secondary-color: #6c757d;\n  --ct-secondary-color-rgb: 108, 117, 125;\n  --ct-secondary-bg: #fff;\n  --ct-secondary-bg-rgb: 255, 255, 255;\n  --ct-tertiary-color: rgba(108, 117, 125, 0.5);\n  --ct-tertiary-color-rgb: 108, 117, 125;\n  --ct-tertiary-bg: #e9ecef;\n  --ct-tertiary-bg-rgb: 233, 236, 239;\n  --ct-body-bg: #f5f6f8;\n  --ct-body-bg-rgb: 245, 246, 248;\n  --ct-heading-color: #343a40;\n  --ct-link-color: #6658dd;\n  --ct-link-color-rgb: 102, 88, 221;\n  --ct-link-decoration: none;\n  --ct-link-hover-color: rgb(86.7, 74.8, 187.85);\n  --ct-link-hover-color-rgb: 87, 75, 188;\n  --ct-code-color: #43bfe5;\n  --ct-highlight-bg: rgb(253.4, 240.8, 219);\n  --ct-border-width: 1px;\n  --ct-border-style: solid;\n  --ct-border-color: #dee2e6;\n  --ct-border-color-translucent: rgba(0, 0, 0, 0.175);\n  --ct-border-radius: 0.25rem;\n  --ct-border-radius-sm: 0.2rem;\n  --ct-border-radius-lg: 0.3rem;\n  --ct-border-radius-xl: 1rem;\n  --ct-border-radius-2xl: 2rem;\n  --ct-border-radius-pill: 50rem;\n  --ct-box-shadow: var(--ct-box-shadow);\n  --ct-box-shadow-sm: var(--ct-box-shadow-sm);\n  --ct-box-shadow-lg: var(--ct-box-shadow-lg);\n  --ct-box-shadow-inset: var(--ct-box-shadow-inset);\n  --ct-emphasis-color: #000;\n  --ct-form-control-bg: var(--ct-body-bg);\n  --ct-form-control-disabled-bg: var(--ct-secondary-bg);\n  --ct-highlight-bg: rgb(253.4, 240.8, 219);\n  --ct-breakpoint-xs: 0;\n  --ct-breakpoint-sm: 576px;\n  --ct-breakpoint-md: 768px;\n  --ct-breakpoint-lg: 992px;\n  --ct-breakpoint-xl: 1200px;\n  --ct-breakpoint-xxl: 1400px;\n}\n\n[data-bs-theme=dark] {\n  --ct-body-color: #94a0ad;\n  --ct-body-color-rgb: 148, 160, 173;\n  --ct-body-bg: #303841;\n  --ct-body-bg-rgb: 48, 56, 65;\n  --ct-emphasis-color: #f3f7f9;\n  --ct-emphasis-color-rgb: 243, 247, 249;\n  --ct-secondary-color: #94a0ad;\n  --ct-secondary-color-rgb: 148, 160, 173;\n  --ct-secondary-bg: #36404a;\n  --ct-secondary-bg-rgb: 54, 64, 74;\n  --ct-tertiary-color: rgba(148, 160, 173, 0.5);\n  --ct-tertiary-color-rgb: 148, 160, 173;\n  --ct-tertiary-bg: #333a43;\n  --ct-tertiary-bg-rgb: 51, 58, 67;\n  --ct-emphasis-color: #fff;\n  --ct-primary-text: rgb(163.2, 154.8, 234.6);\n  --ct-secondary-text: #dee2e6;\n  --ct-success-text: rgb(117.6, 214.8, 195.6);\n  --ct-info-text: rgb(142.2, 216.6, 239.4);\n  --ct-warning-text: rgb(250.2, 212.4, 147);\n  --ct-danger-text: rgb(246.6, 153, 166.8);\n  --ct-light-text: #f3f7f9;\n  --ct-dark-text: #dee2e6;\n  --ct-primary-bg-subtle: rgb(20.4, 17.6, 44.2);\n  --ct-secondary-bg-subtle: #323a46;\n  --ct-success-bg-subtle: rgb(5.2, 37.6, 31.2);\n  --ct-info-bg-subtle: rgb(13.4, 38.2, 45.8);\n  --ct-warning-bg-subtle: rgb(49.4, 36.8, 15);\n  --ct-danger-bg-subtle: rgb(48.2, 17, 21.6);\n  --ct-light-bg-subtle: #343a40;\n  --ct-dark-bg-subtle: #1a1d20;\n  --ct-primary-border-subtle: rgb(61.2, 52.8, 132.6);\n  --ct-secondary-border-subtle: #6c757d;\n  --ct-success-border-subtle: rgb(15.6, 112.8, 93.6);\n  --ct-info-border-subtle: rgb(26.8, 76.4, 91.6);\n  --ct-warning-border-subtle: rgb(98.8, 73.6, 30);\n  --ct-danger-border-subtle: rgb(144.6, 51, 64.8);\n  --ct-light-border-subtle: #6c757d;\n  --ct-dark-border-subtle: #343a40;\n  --ct-heading-color: #fff;\n  --ct-link-color: rgb(163.2, 154.8, 234.6);\n  --ct-link-hover-color: rgb(193.8, 188.2, 241.4);\n  --ct-link-color-rgb: 163, 155, 235;\n  --ct-link-hover-color-rgb: 194, 188, 241;\n  --ct-code-color: rgb(249.6, 170.4, 202.2);\n  --ct-border-color: #424e5a;\n  --ct-border-color-translucent: rgba(255, 255, 255, 0.15);\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  :root {\n    scroll-behavior: smooth;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: var(--ct-body-font-family);\n  font-size: var(--ct-body-font-size);\n  font-weight: var(--ct-body-font-weight);\n  line-height: var(--ct-body-line-height);\n  color: var(--ct-body-color);\n  text-align: var(--ct-body-text-align);\n  background-color: var(--ct-body-bg);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n  margin: 1.5rem 0;\n  color: inherit;\n  border: 0;\n  border-top: 1px solid;\n  opacity: 0.25;\n}\n\nh6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n  margin-top: 0;\n  margin-bottom: 0.75rem;\n  font-family: \"Cerebri Sans\", sans-serif;\n  font-weight: 500;\n  line-height: 1.1;\n  color: var(--ct-heading-color, inherit);\n}\n\nh1, .h1 {\n  font-size: calc(1.35rem + 1.2vw);\n}\n@media (min-width: 1200px) {\n  h1, .h1 {\n    font-size: 2.25rem;\n  }\n}\n\nh2, .h2 {\n  font-size: calc(1.3125rem + 0.75vw);\n}\n@media (min-width: 1200px) {\n  h2, .h2 {\n    font-size: 1.875rem;\n  }\n}\n\nh3, .h3 {\n  font-size: calc(1.275rem + 0.3vw);\n}\n@media (min-width: 1200px) {\n  h3, .h3 {\n    font-size: 1.5rem;\n  }\n}\n\nh4, .h4 {\n  font-size: 1.125rem;\n}\n\nh5, .h5 {\n  font-size: 0.9375rem;\n}\n\nh6, .h6 {\n  font-size: 0.75rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall, .small {\n  font-size: 0.75rem;\n}\n\nmark, .mark {\n  padding: 0.1875em;\n  background-color: var(--ct-highlight-bg);\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: rgba(var(--ct-link-color-rgb), var(--ct-link-opacity, 1));\n  text-decoration: none;\n}\na:hover {\n  --ct-link-color-rgb: var(--ct-link-hover-color-rgb);\n}\n\na:not([href]):not([class]), a:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--ct-font-monospace);\n  font-size: 1em;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 87.5%;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 87.5%;\n  color: var(--ct-code-color);\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 87.5%;\n  color: var(--ct-body-color);\n  background-color: var(--ct-secondary-bg);\n  border-radius: 0.2rem;\n}\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.85rem;\n  padding-bottom: 0.85rem;\n  color: var(--ct-gray);\n  text-align: left;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\nselect:disabled {\n  opacity: 1;\n}\n\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: calc(1.275rem + 0.3vw);\n  line-height: inherit;\n}\n@media (min-width: 1200px) {\n  legend {\n    font-size: 1.5rem;\n  }\n}\nlegend + * {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  outline-offset: -2px;\n  -webkit-appearance: textfield;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::file-selector-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.09375rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: calc(1.625rem + 4.5vw);\n  font-weight: 300;\n  line-height: 1.1;\n}\n@media (min-width: 1200px) {\n  .display-1 {\n    font-size: 5rem;\n  }\n}\n\n.display-2 {\n  font-size: calc(1.575rem + 3.9vw);\n  font-weight: 300;\n  line-height: 1.1;\n}\n@media (min-width: 1200px) {\n  .display-2 {\n    font-size: 4.5rem;\n  }\n}\n\n.display-3 {\n  font-size: calc(1.525rem + 3.3vw);\n  font-weight: 300;\n  line-height: 1.1;\n}\n@media (min-width: 1200px) {\n  .display-3 {\n    font-size: 4rem;\n  }\n}\n\n.display-4 {\n  font-size: calc(1.475rem + 2.7vw);\n  font-weight: 300;\n  line-height: 1.1;\n}\n@media (min-width: 1200px) {\n  .display-4 {\n    font-size: 3.5rem;\n  }\n}\n\n.display-5 {\n  font-size: calc(1.425rem + 2.1vw);\n  font-weight: 300;\n  line-height: 1.1;\n}\n@media (min-width: 1200px) {\n  .display-5 {\n    font-size: 3rem;\n  }\n}\n\n.display-6 {\n  font-size: calc(1.375rem + 1.5vw);\n  font-weight: 300;\n  line-height: 1.1;\n}\n@media (min-width: 1200px) {\n  .display-6 {\n    font-size: 2.5rem;\n  }\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1.5rem;\n  font-size: 1.09375rem;\n}\n.blockquote > :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1.5rem;\n  margin-bottom: 1.5rem;\n  font-size: 0.75rem;\n  color: #98a6ad;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: var(--ct-secondary-bg);\n  border: var(--ct-border-width) solid var(--ct-border-color);\n  border-radius: var(--ct-border-radius);\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.75rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 0.75rem;\n  color: var(--ct-secondary-color);\n}\n\n.container,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  --ct-gutter-x: 24px;\n  --ct-gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--ct-gutter-x) * 0.5);\n  padding-left: calc(var(--ct-gutter-x) * 0.5);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1140px;\n  }\n}\n@media (min-width: 1400px) {\n  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1320px;\n  }\n}\n.row {\n  --ct-gutter-x: 24px;\n  --ct-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--ct-gutter-y));\n  margin-right: calc(-0.5 * var(--ct-gutter-x));\n  margin-left: calc(-0.5 * var(--ct-gutter-x));\n}\n.row > * {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--ct-gutter-x) * 0.5);\n  padding-left: calc(var(--ct-gutter-x) * 0.5);\n  margin-top: var(--ct-gutter-y);\n}\n\n.col {\n  flex: 1 0 0%;\n}\n\n.row-cols-auto > * {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 auto;\n  width: 33.3333333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 auto;\n  width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 auto;\n  width: 16.6666666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.col-1 {\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n\n.col-2 {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-3 {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n\n.col-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n\n.col-8 {\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n\n.col-9 {\n  flex: 0 0 auto;\n  width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n\n.col-11 {\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n\n.col-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n.g-0,\n.gx-0 {\n  --ct-gutter-x: 0;\n}\n\n.g-0,\n.gy-0 {\n  --ct-gutter-y: 0;\n}\n\n.g-1,\n.gx-1 {\n  --ct-gutter-x: 0.375rem;\n}\n\n.g-1,\n.gy-1 {\n  --ct-gutter-y: 0.375rem;\n}\n\n.g-2,\n.gx-2 {\n  --ct-gutter-x: 0.75rem;\n}\n\n.g-2,\n.gy-2 {\n  --ct-gutter-y: 0.75rem;\n}\n\n.g-3,\n.gx-3 {\n  --ct-gutter-x: 1.5rem;\n}\n\n.g-3,\n.gy-3 {\n  --ct-gutter-y: 1.5rem;\n}\n\n.g-4,\n.gx-4 {\n  --ct-gutter-x: 2.25rem;\n}\n\n.g-4,\n.gy-4 {\n  --ct-gutter-y: 2.25rem;\n}\n\n.g-5,\n.gx-5 {\n  --ct-gutter-x: 4.5rem;\n}\n\n.g-5,\n.gy-5 {\n  --ct-gutter-y: 4.5rem;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex: 1 0 0%;\n  }\n  .row-cols-sm-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-sm-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-sm-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-sm-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-sm-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-sm-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-sm-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-sm-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-sm-0,\n  .gx-sm-0 {\n    --ct-gutter-x: 0;\n  }\n  .g-sm-0,\n  .gy-sm-0 {\n    --ct-gutter-y: 0;\n  }\n  .g-sm-1,\n  .gx-sm-1 {\n    --ct-gutter-x: 0.375rem;\n  }\n  .g-sm-1,\n  .gy-sm-1 {\n    --ct-gutter-y: 0.375rem;\n  }\n  .g-sm-2,\n  .gx-sm-2 {\n    --ct-gutter-x: 0.75rem;\n  }\n  .g-sm-2,\n  .gy-sm-2 {\n    --ct-gutter-y: 0.75rem;\n  }\n  .g-sm-3,\n  .gx-sm-3 {\n    --ct-gutter-x: 1.5rem;\n  }\n  .g-sm-3,\n  .gy-sm-3 {\n    --ct-gutter-y: 1.5rem;\n  }\n  .g-sm-4,\n  .gx-sm-4 {\n    --ct-gutter-x: 2.25rem;\n  }\n  .g-sm-4,\n  .gy-sm-4 {\n    --ct-gutter-y: 2.25rem;\n  }\n  .g-sm-5,\n  .gx-sm-5 {\n    --ct-gutter-x: 4.5rem;\n  }\n  .g-sm-5,\n  .gy-sm-5 {\n    --ct-gutter-y: 4.5rem;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex: 1 0 0%;\n  }\n  .row-cols-md-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-md-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-md-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-md-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-md-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-md-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-md-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-md-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-md-0,\n  .gx-md-0 {\n    --ct-gutter-x: 0;\n  }\n  .g-md-0,\n  .gy-md-0 {\n    --ct-gutter-y: 0;\n  }\n  .g-md-1,\n  .gx-md-1 {\n    --ct-gutter-x: 0.375rem;\n  }\n  .g-md-1,\n  .gy-md-1 {\n    --ct-gutter-y: 0.375rem;\n  }\n  .g-md-2,\n  .gx-md-2 {\n    --ct-gutter-x: 0.75rem;\n  }\n  .g-md-2,\n  .gy-md-2 {\n    --ct-gutter-y: 0.75rem;\n  }\n  .g-md-3,\n  .gx-md-3 {\n    --ct-gutter-x: 1.5rem;\n  }\n  .g-md-3,\n  .gy-md-3 {\n    --ct-gutter-y: 1.5rem;\n  }\n  .g-md-4,\n  .gx-md-4 {\n    --ct-gutter-x: 2.25rem;\n  }\n  .g-md-4,\n  .gy-md-4 {\n    --ct-gutter-y: 2.25rem;\n  }\n  .g-md-5,\n  .gx-md-5 {\n    --ct-gutter-x: 4.5rem;\n  }\n  .g-md-5,\n  .gy-md-5 {\n    --ct-gutter-y: 4.5rem;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex: 1 0 0%;\n  }\n  .row-cols-lg-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-lg-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-lg-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-lg-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-lg-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-lg-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-lg-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-lg-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-lg-0,\n  .gx-lg-0 {\n    --ct-gutter-x: 0;\n  }\n  .g-lg-0,\n  .gy-lg-0 {\n    --ct-gutter-y: 0;\n  }\n  .g-lg-1,\n  .gx-lg-1 {\n    --ct-gutter-x: 0.375rem;\n  }\n  .g-lg-1,\n  .gy-lg-1 {\n    --ct-gutter-y: 0.375rem;\n  }\n  .g-lg-2,\n  .gx-lg-2 {\n    --ct-gutter-x: 0.75rem;\n  }\n  .g-lg-2,\n  .gy-lg-2 {\n    --ct-gutter-y: 0.75rem;\n  }\n  .g-lg-3,\n  .gx-lg-3 {\n    --ct-gutter-x: 1.5rem;\n  }\n  .g-lg-3,\n  .gy-lg-3 {\n    --ct-gutter-y: 1.5rem;\n  }\n  .g-lg-4,\n  .gx-lg-4 {\n    --ct-gutter-x: 2.25rem;\n  }\n  .g-lg-4,\n  .gy-lg-4 {\n    --ct-gutter-y: 2.25rem;\n  }\n  .g-lg-5,\n  .gx-lg-5 {\n    --ct-gutter-x: 4.5rem;\n  }\n  .g-lg-5,\n  .gy-lg-5 {\n    --ct-gutter-y: 4.5rem;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xl-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-xl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xl-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xl-0,\n  .gx-xl-0 {\n    --ct-gutter-x: 0;\n  }\n  .g-xl-0,\n  .gy-xl-0 {\n    --ct-gutter-y: 0;\n  }\n  .g-xl-1,\n  .gx-xl-1 {\n    --ct-gutter-x: 0.375rem;\n  }\n  .g-xl-1,\n  .gy-xl-1 {\n    --ct-gutter-y: 0.375rem;\n  }\n  .g-xl-2,\n  .gx-xl-2 {\n    --ct-gutter-x: 0.75rem;\n  }\n  .g-xl-2,\n  .gy-xl-2 {\n    --ct-gutter-y: 0.75rem;\n  }\n  .g-xl-3,\n  .gx-xl-3 {\n    --ct-gutter-x: 1.5rem;\n  }\n  .g-xl-3,\n  .gy-xl-3 {\n    --ct-gutter-y: 1.5rem;\n  }\n  .g-xl-4,\n  .gx-xl-4 {\n    --ct-gutter-x: 2.25rem;\n  }\n  .g-xl-4,\n  .gy-xl-4 {\n    --ct-gutter-y: 2.25rem;\n  }\n  .g-xl-5,\n  .gx-xl-5 {\n    --ct-gutter-x: 4.5rem;\n  }\n  .g-xl-5,\n  .gy-xl-5 {\n    --ct-gutter-y: 4.5rem;\n  }\n}\n@media (min-width: 1400px) {\n  .col-xxl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-xxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n  .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n  .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n  .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n  .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xxl-0,\n  .gx-xxl-0 {\n    --ct-gutter-x: 0;\n  }\n  .g-xxl-0,\n  .gy-xxl-0 {\n    --ct-gutter-y: 0;\n  }\n  .g-xxl-1,\n  .gx-xxl-1 {\n    --ct-gutter-x: 0.375rem;\n  }\n  .g-xxl-1,\n  .gy-xxl-1 {\n    --ct-gutter-y: 0.375rem;\n  }\n  .g-xxl-2,\n  .gx-xxl-2 {\n    --ct-gutter-x: 0.75rem;\n  }\n  .g-xxl-2,\n  .gy-xxl-2 {\n    --ct-gutter-y: 0.75rem;\n  }\n  .g-xxl-3,\n  .gx-xxl-3 {\n    --ct-gutter-x: 1.5rem;\n  }\n  .g-xxl-3,\n  .gy-xxl-3 {\n    --ct-gutter-y: 1.5rem;\n  }\n  .g-xxl-4,\n  .gx-xxl-4 {\n    --ct-gutter-x: 2.25rem;\n  }\n  .g-xxl-4,\n  .gy-xxl-4 {\n    --ct-gutter-y: 2.25rem;\n  }\n  .g-xxl-5,\n  .gx-xxl-5 {\n    --ct-gutter-x: 4.5rem;\n  }\n  .g-xxl-5,\n  .gy-xxl-5 {\n    --ct-gutter-y: 4.5rem;\n  }\n}\n.table {\n  --ct-table-color: var(--ct-body-color);\n  --ct-table-bg: transparent;\n  --ct-table-border-color: var(--ct-border-color);\n  --ct-table-accent-bg: transparent;\n  --ct-table-striped-color: var(--ct-body-color);\n  --ct-table-striped-bg: rgba(0, 0, 0, 0.025);\n  --ct-table-active-color: var(--ct-body-color);\n  --ct-table-active-bg: rgba(0, 0, 0, 0.1);\n  --ct-table-hover-color: var(--ct-body-color);\n  --ct-table-hover-bg: rgba(0, 0, 0, 0.075);\n  width: 100%;\n  margin-bottom: 1.5rem;\n  color: var(--ct-table-color);\n  vertical-align: top;\n  border-color: var(--ct-table-border-color);\n}\n.table > :not(caption) > * > * {\n  padding: 0.85rem 0.85rem;\n  background-color: var(--ct-table-bg);\n  border-bottom-width: var(--ct-border-width);\n  box-shadow: inset 0 0 0 9999px var(--ct-table-accent-bg);\n}\n.table > tbody {\n  vertical-align: inherit;\n}\n.table > thead {\n  vertical-align: bottom;\n}\n\n.table-group-divider {\n  border-top: calc(var(--ct-border-width) * 2) solid var(--ct-border-color);\n}\n\n.caption-top {\n  caption-side: top;\n}\n\n.table-sm > :not(caption) > * > * {\n  padding: 0.5rem 0.5rem;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: var(--ct-border-width) 0;\n}\n.table-bordered > :not(caption) > * > * {\n  border-width: 0 var(--ct-border-width);\n}\n\n.table-borderless > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n.table-borderless > :not(:first-child) {\n  border-top-width: 0;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n  --ct-table-accent-bg: var(--ct-table-striped-bg);\n  color: var(--ct-table-striped-color);\n}\n\n.table-striped-columns > :not(caption) > tr > :nth-child(even) {\n  --ct-table-accent-bg: var(--ct-table-striped-bg);\n  color: var(--ct-table-striped-color);\n}\n\n.table-active {\n  --ct-table-accent-bg: var(--ct-table-active-bg);\n  color: var(--ct-table-active-color);\n}\n\n.table-hover > tbody > tr:hover > * {\n  --ct-table-accent-bg: var(--ct-table-hover-bg);\n  color: var(--ct-table-hover-color);\n}\n\n.table-primary {\n  --ct-table-color: #323a46;\n  --ct-table-bg: rgb(224.4, 221.6, 248.2);\n  --ct-table-border-color: rgb(206.96, 205.24, 230.38);\n  --ct-table-striped-bg: rgb(220.04, 217.51, 243.745);\n  --ct-table-striped-color: #323a46;\n  --ct-table-active-bg: rgb(206.96, 205.24, 230.38);\n  --ct-table-active-color: #323a46;\n  --ct-table-hover-bg: rgb(211.32, 209.33, 234.835);\n  --ct-table-hover-color: #323a46;\n  color: var(--ct-table-color);\n  border-color: var(--ct-table-border-color);\n}\n\n.table-secondary {\n  --ct-table-color: #323a46;\n  --ct-table-bg: rgb(225.6, 227.4, 229);\n  --ct-table-border-color: rgb(208.04, 210.46, 213.1);\n  --ct-table-striped-bg: rgb(221.21, 223.165, 225.025);\n  --ct-table-striped-color: #323a46;\n  --ct-table-active-bg: rgb(208.04, 210.46, 213.1);\n  --ct-table-active-color: #323a46;\n  --ct-table-hover-bg: rgb(212.43, 214.695, 217.075);\n  --ct-table-hover-color: #323a46;\n  color: var(--ct-table-color);\n  border-color: var(--ct-table-border-color);\n}\n\n.table-success {\n  --ct-table-color: #323a46;\n  --ct-table-bg: rgb(209.2, 241.6, 235.2);\n  --ct-table-border-color: rgb(193.28, 223.24, 218.68);\n  --ct-table-striped-bg: rgb(205.22, 237.01, 231.07);\n  --ct-table-striped-color: #323a46;\n  --ct-table-active-bg: rgb(193.28, 223.24, 218.68);\n  --ct-table-active-color: #323a46;\n  --ct-table-hover-bg: rgb(197.26, 227.83, 222.81);\n  --ct-table-hover-color: #323a46;\n  color: var(--ct-table-color);\n  border-color: var(--ct-table-border-color);\n}\n\n.table-info {\n  --ct-table-color: #323a46;\n  --ct-table-bg: rgb(217.4, 242.2, 249.8);\n  --ct-table-border-color: rgb(200.66, 223.78, 231.82);\n  --ct-table-striped-bg: rgb(213.215, 237.595, 245.305);\n  --ct-table-striped-color: #323a46;\n  --ct-table-active-bg: rgb(200.66, 223.78, 231.82);\n  --ct-table-active-color: #323a46;\n  --ct-table-hover-bg: rgb(204.845, 228.385, 236.315);\n  --ct-table-hover-color: #323a46;\n  color: var(--ct-table-color);\n  border-color: var(--ct-table-border-color);\n}\n\n.table-warning {\n  --ct-table-color: #323a46;\n  --ct-table-bg: rgb(253.4, 240.8, 219);\n  --ct-table-border-color: rgb(233.06, 222.52, 204.1);\n  --ct-table-striped-bg: rgb(248.315, 236.23, 215.275);\n  --ct-table-striped-color: #323a46;\n  --ct-table-active-bg: rgb(233.06, 222.52, 204.1);\n  --ct-table-active-color: #323a46;\n  --ct-table-hover-bg: rgb(238.145, 227.09, 207.825);\n  --ct-table-hover-color: #323a46;\n  color: var(--ct-table-color);\n  border-color: var(--ct-table-border-color);\n}\n\n.table-danger {\n  --ct-table-color: #323a46;\n  --ct-table-bg: rgb(252.2, 221, 225.6);\n  --ct-table-border-color: rgb(231.98, 204.7, 210.04);\n  --ct-table-striped-bg: rgb(247.145, 216.925, 221.71);\n  --ct-table-striped-color: #323a46;\n  --ct-table-active-bg: rgb(231.98, 204.7, 210.04);\n  --ct-table-active-color: #323a46;\n  --ct-table-hover-bg: rgb(237.035, 208.775, 213.93);\n  --ct-table-hover-color: #323a46;\n  color: var(--ct-table-color);\n  border-color: var(--ct-table-border-color);\n}\n\n.table-light {\n  --ct-table-color: #323a46;\n  --ct-table-bg: #f3f7f9;\n  --ct-table-border-color: rgb(223.7, 228.1, 231.1);\n  --ct-table-striped-bg: rgb(238.175, 242.275, 244.525);\n  --ct-table-striped-color: #323a46;\n  --ct-table-active-bg: rgb(223.7, 228.1, 231.1);\n  --ct-table-active-color: #323a46;\n  --ct-table-hover-bg: rgb(228.525, 232.825, 235.575);\n  --ct-table-hover-color: #323a46;\n  color: var(--ct-table-color);\n  border-color: var(--ct-table-border-color);\n}\n\n.table-dark {\n  --ct-table-color: #fff;\n  --ct-table-bg: #323a46;\n  --ct-table-border-color: rgb(70.5, 77.7, 88.5);\n  --ct-table-striped-bg: rgb(55.125, 62.925, 74.625);\n  --ct-table-striped-color: #fff;\n  --ct-table-active-bg: rgb(70.5, 77.7, 88.5);\n  --ct-table-active-color: #fff;\n  --ct-table-hover-bg: rgb(65.375, 72.775, 83.875);\n  --ct-table-hover-color: #fff;\n  color: var(--ct-table-color);\n  border-color: var(--ct-table-border-color);\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1399.98px) {\n  .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n.form-label {\n  margin-bottom: 0.5rem;\n}\n\n.col-form-label {\n  padding-top: calc(0.45rem + 1px);\n  padding-bottom: calc(0.45rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  font-size: 1.09375rem;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.28rem + 1px);\n  padding-bottom: calc(0.28rem + 1px);\n  font-size: 0.765625rem;\n}\n\n.form-text {\n  margin-top: 0.25rem;\n  font-size: 0.75rem;\n  color: var(--ct-gray);\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.45rem 0.9rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--ct-body-color);\n  background-color: var(--ct-secondary-bg);\n  background-clip: padding-box;\n  border: 1px solid var(--ct-border-color);\n  appearance: none;\n  border-radius: var(--ct-border-radius);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control[type=file] {\n  overflow: hidden;\n}\n.form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control:focus {\n  color: var(--ct-body-color);\n  background-color: var(--ct-secondary-bg);\n  border-color: var(--ct-border-color);\n  outline: 0;\n  box-shadow: none;\n}\n.form-control::-webkit-date-and-time-value {\n  height: 1.5em;\n}\n.form-control::-webkit-datetime-edit {\n  display: block;\n  padding: 0;\n}\n.form-control::placeholder {\n  color: var(--ct-secondary-color);\n  opacity: 1;\n}\n.form-control:disabled {\n  background-color: var(--ct-form-control-disabled-bg);\n  opacity: 1;\n}\n.form-control::file-selector-button {\n  padding: 0.45rem 0.9rem;\n  margin: -0.45rem -0.9rem;\n  margin-inline-end: 0.9rem;\n  color: var(--ct-body-color);\n  background-color: var(--ct-gray-100);\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: 1px;\n  border-radius: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::file-selector-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: var(--ct-gray-100);\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.45rem 0;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: var(--ct-body-color);\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.form-control-plaintext:focus {\n  outline: 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  min-height: calc(1.5em + 0.56rem + 2px);\n  padding: 0.28rem 0.8rem;\n  font-size: 0.765625rem;\n  border-radius: var(--ct-border-radius-sm);\n}\n.form-control-sm::file-selector-button {\n  padding: 0.28rem 0.8rem;\n  margin: -0.28rem -0.8rem;\n  margin-inline-end: 0.8rem;\n}\n\n.form-control-lg {\n  min-height: calc(1.5em + 1rem + 2px);\n  padding: 0.5rem 1rem;\n  font-size: 1.09375rem;\n  border-radius: var(--ct-border-radius-lg);\n}\n.form-control-lg::file-selector-button {\n  padding: 0.5rem 1rem;\n  margin: -0.5rem -1rem;\n  margin-inline-end: 1rem;\n}\n\ntextarea.form-control {\n  min-height: calc(1.5em + 0.9rem + 2px);\n}\ntextarea.form-control-sm {\n  min-height: calc(1.5em + 0.56rem + 2px);\n}\ntextarea.form-control-lg {\n  min-height: calc(1.5em + 1rem + 2px);\n}\n\n.form-control-color {\n  width: 3rem;\n  height: calc(1.5em + 0.9rem + 2px);\n  padding: 0.45rem;\n}\n.form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control-color::-moz-color-swatch {\n  border: 0 !important;\n  border-radius: var(--ct-border-radius);\n}\n.form-control-color::-webkit-color-swatch {\n  border-radius: var(--ct-border-radius);\n}\n.form-control-color.form-control-sm {\n  height: calc(1.5em + 0.56rem + 2px);\n}\n.form-control-color.form-control-lg {\n  height: calc(1.5em + 1rem + 2px);\n}\n\n.form-select {\n  --ct-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%238b96a0' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n  display: block;\n  width: 100%;\n  padding: 0.45rem 2.7rem 0.45rem 0.9rem;\n  -moz-padding-start: calc(0.9rem - 3px);\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--ct-body-color);\n  background-color: var(--ct-secondary-bg);\n  background-image: var(--ct-form-select-bg-img), var(--ct-form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: right 0.9rem center;\n  background-size: 14px 10px;\n  border: 1px solid var(--ct-border-color);\n  border-radius: var(--ct-border-radius);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-select {\n    transition: none;\n  }\n}\n.form-select:focus {\n  border-color: var(--ct-border-color);\n  outline: 0;\n  box-shadow: none;\n}\n.form-select[multiple], .form-select[size]:not([size=\"1\"]) {\n  padding-right: 0.9rem;\n  background-image: none;\n}\n.form-select:disabled {\n  background-color: var(--ct-form-control-disabled-bg);\n}\n.form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 var(--ct-body-color);\n}\n\n.form-select-sm {\n  padding-top: 0.28rem;\n  padding-bottom: 0.28rem;\n  padding-left: 0.8rem;\n  font-size: 0.765625rem;\n  border-radius: var(--ct-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: 1.09375rem;\n  border-radius: var(--ct-border-radius-lg);\n}\n\n[data-bs-theme=dark] .form-select {\n  --ct-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%2394a0ad' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n}\n\n.form-check {\n  display: block;\n  min-height: 1.3125rem;\n  padding-left: 1.643em;\n  margin-bottom: 0;\n}\n.form-check .form-check-input {\n  float: left;\n  margin-left: -1.643em;\n}\n\n.form-check-reverse {\n  padding-right: 1.643em;\n  padding-left: 0;\n  text-align: right;\n}\n.form-check-reverse .form-check-input {\n  float: right;\n  margin-right: -1.643em;\n  margin-left: 0;\n}\n\n.form-check-input {\n  --ct-form-check-bg: var(--ct-secondary-bg);\n  width: 1.143em;\n  height: 1.143em;\n  margin-top: 0.1785em;\n  vertical-align: top;\n  background-color: var(--ct-form-check-bg);\n  background-image: var(--ct-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: 1px solid var(--ct-border-color);\n  appearance: none;\n  print-color-adjust: exact;\n  transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-check-input {\n    transition: none;\n  }\n}\n.form-check-input[type=checkbox] {\n  border-radius: 0.25em;\n}\n.form-check-input[type=radio] {\n  border-radius: 50%;\n}\n.form-check-input:active {\n  filter: brightness(90%);\n}\n.form-check-input:focus {\n  border-color: var(--ct-border-color);\n  outline: 0;\n  box-shadow: none;\n}\n.form-check-input:checked {\n  background-color: #6658dd;\n  border-color: #6658dd;\n}\n.form-check-input:checked[type=checkbox] {\n  --ct-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n}\n.form-check-input:checked[type=radio] {\n  --ct-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: #6658dd;\n  border-color: #6658dd;\n  --ct-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.form-switch {\n  padding-left: 2.5em;\n}\n.form-switch .form-check-input {\n  --ct-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%238b96a0' opacity='0.5'/%3e%3c/svg%3e\");\n  width: 2em;\n  margin-left: -2.5em;\n  background-image: var(--ct-form-switch-bg);\n  background-position: left center;\n  border-radius: 2em;\n  transition: background-position 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-switch .form-check-input {\n    transition: none;\n  }\n}\n.form-switch .form-check-input:focus {\n  --ct-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='var%28--ct-border-color%29'/%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  --ct-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-switch.form-check-reverse {\n  padding-right: 2.5em;\n  padding-left: 0;\n}\n.form-switch.form-check-reverse .form-check-input {\n  margin-right: -2.5em;\n  margin-left: 0;\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.btn-check[disabled] + .btn, .btn-check:disabled + .btn {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.65;\n}\n\n[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {\n  --ct-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\");\n}\n\n.form-range {\n  width: 100%;\n  height: 1.3rem;\n  padding: 0;\n  background-color: transparent;\n  appearance: none;\n}\n.form-range:focus {\n  outline: 0;\n}\n.form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #f5f6f8, none;\n}\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #f5f6f8, none;\n}\n.form-range::-moz-focus-outer {\n  border: 0;\n}\n.form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  background-color: #6658dd;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.form-range::-webkit-slider-thumb:active {\n  background-color: rgb(209.1, 204.9, 244.8);\n}\n.form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--ct-gray-100);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  background-color: #6658dd;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.form-range::-moz-range-thumb:active {\n  background-color: rgb(209.1, 204.9, 244.8);\n}\n.form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--ct-gray-100);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range:disabled {\n  pointer-events: none;\n}\n.form-range:disabled::-webkit-slider-thumb {\n  background-color: var(--ct-secondary-color);\n}\n.form-range:disabled::-moz-range-thumb {\n  background-color: var(--ct-secondary-color);\n}\n\n.form-floating {\n  position: relative;\n}\n.form-floating::before:not(.form-control:disabled) {\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  width: calc(100% - (calc(calc(0.375em + 0.225rem) + calc(0.75em + 0.45rem))));\n  height: 1.875em;\n  content: \"\";\n  background-color: var(--ct-secondary-bg);\n  border-radius: var(--ct-border-radius);\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext,\n.form-floating > .form-select {\n  height: calc(3.5rem + 2px);\n  line-height: 1.25;\n}\n.form-floating > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding: 1rem 0.9rem;\n  overflow: hidden;\n  text-align: start;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  border: 1px solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-floating > label {\n    transition: none;\n  }\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext {\n  padding: 1rem 0.9rem;\n}\n.form-floating > .form-control::placeholder,\n.form-floating > .form-control-plaintext::placeholder {\n  color: transparent;\n}\n.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),\n.form-floating > .form-control-plaintext:focus,\n.form-floating > .form-control-plaintext:not(:placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:-webkit-autofill,\n.form-floating > .form-control-plaintext:-webkit-autofill {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-select {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-control-plaintext ~ label,\n.form-floating > .form-select ~ label {\n  opacity: 0.65;\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control:-webkit-autofill ~ label {\n  opacity: 0.65;\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control-plaintext ~ label {\n  border-width: 1px 0;\n}\n.form-floating > .form-control:disabled ~ label {\n  color: #98a6ad;\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-select,\n.input-group > .form-floating {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n.input-group > .form-control:focus,\n.input-group > .form-select:focus,\n.input-group > .form-floating:focus-within {\n  z-index: 5;\n}\n.input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group .btn:focus {\n  z-index: 5;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.45rem 0.9rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--ct-body-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--ct-gray-100);\n  border: 1px solid var(--ct-border-color);\n  border-radius: var(--ct-border-radius);\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.09375rem;\n  border-radius: var(--ct-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: 0.28rem 0.8rem;\n  font-size: 0.765625rem;\n  border-radius: var(--ct-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: 3.6rem;\n}\n\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: -1px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .form-floating:not(:first-child) > .form-control,\n.input-group > .form-floating:not(:first-child) > .form-select {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.75rem;\n  color: var(--ct-success-text);\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.4rem 0.8rem;\n  margin-top: 0.1rem;\n  font-size: 0.765625rem;\n  color: #fff;\n  background-color: var(--ct-success);\n  border-radius: 0.2rem;\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: var(--ct-success);\n  padding-right: calc(1.5em + 0.9rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%231abc9c' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.225rem) center;\n  background-size: calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: var(--ct-success);\n  box-shadow: 0 0 0 0.15rem rgba(var(--ct-success-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.9rem);\n  background-position: top calc(0.375em + 0.225rem) right calc(0.375em + 0.225rem);\n}\n\n.was-validated .form-select:valid, .form-select.is-valid {\n  border-color: var(--ct-success);\n}\n.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size=\"1\"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size=\"1\"] {\n  --ct-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%231abc9c' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  padding-right: 4.95rem;\n  background-position: right 0.9rem center, center right 2.7rem;\n  background-size: 14px 10px, calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);\n}\n.was-validated .form-select:valid:focus, .form-select.is-valid:focus {\n  border-color: var(--ct-success);\n  box-shadow: 0 0 0 0.15rem rgba(var(--ct-success-rgb), 0.25);\n}\n\n.was-validated .form-control-color:valid, .form-control-color.is-valid {\n  width: calc(3rem + calc(1.5em + 0.9rem));\n}\n\n.was-validated .form-check-input:valid, .form-check-input.is-valid {\n  border-color: var(--ct-success);\n}\n.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {\n  background-color: var(--ct-success-text);\n}\n.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0.15rem rgba(var(--ct-success-rgb), 0.25);\n}\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: var(--ct-success-text);\n}\n\n.form-check-inline .form-check-input ~ .valid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,\n.was-validated .input-group > .form-select:not(:focus):valid,\n.input-group > .form-select:not(:focus).is-valid,\n.was-validated .input-group > .form-floating:not(:focus-within):valid,\n.input-group > .form-floating:not(:focus-within).is-valid {\n  z-index: 3;\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.75rem;\n  color: var(--ct-danger-text);\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.4rem 0.8rem;\n  margin-top: 0.1rem;\n  font-size: 0.765625rem;\n  color: #fff;\n  background-color: var(--ct-danger);\n  border-radius: 0.2rem;\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: var(--ct-danger);\n  padding-right: calc(1.5em + 0.9rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f1556c'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f1556c' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.225rem) center;\n  background-size: calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: var(--ct-danger);\n  box-shadow: 0 0 0 0.15rem rgba(var(--ct-danger-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.9rem);\n  background-position: top calc(0.375em + 0.225rem) right calc(0.375em + 0.225rem);\n}\n\n.was-validated .form-select:invalid, .form-select.is-invalid {\n  border-color: var(--ct-danger);\n}\n.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size=\"1\"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size=\"1\"] {\n  --ct-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f1556c'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f1556c' stroke='none'/%3e%3c/svg%3e\");\n  padding-right: 4.95rem;\n  background-position: right 0.9rem center, center right 2.7rem;\n  background-size: 14px 10px, calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);\n}\n.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {\n  border-color: var(--ct-danger);\n  box-shadow: 0 0 0 0.15rem rgba(var(--ct-danger-rgb), 0.25);\n}\n\n.was-validated .form-control-color:invalid, .form-control-color.is-invalid {\n  width: calc(3rem + calc(1.5em + 0.9rem));\n}\n\n.was-validated .form-check-input:invalid, .form-check-input.is-invalid {\n  border-color: var(--ct-danger);\n}\n.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {\n  background-color: var(--ct-danger-text);\n}\n.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0.15rem rgba(var(--ct-danger-rgb), 0.25);\n}\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: var(--ct-danger-text);\n}\n\n.form-check-inline .form-check-input ~ .invalid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,\n.was-validated .input-group > .form-select:not(:focus):invalid,\n.input-group > .form-select:not(:focus).is-invalid,\n.was-validated .input-group > .form-floating:not(:focus-within):invalid,\n.input-group > .form-floating:not(:focus-within).is-invalid {\n  z-index: 4;\n}\n\n.btn {\n  --ct-btn-padding-x: 0.9rem;\n  --ct-btn-padding-y: 0.45rem;\n  --ct-btn-font-family: ;\n  --ct-btn-font-size: 0.875rem;\n  --ct-btn-font-weight: 400;\n  --ct-btn-line-height: 1.5;\n  --ct-btn-color: #6c757d;\n  --ct-btn-bg: transparent;\n  --ct-btn-border-width: var(--ct-border-width);\n  --ct-btn-border-color: transparent;\n  --ct-btn-border-radius: var(--ct-border-radius);\n  --ct-btn-hover-border-color: transparent;\n  --ct-btn-box-shadow: 0px 2px 6px 0px;\n  --ct-btn-disabled-opacity: 0.65;\n  --ct-btn-focus-box-shadow: 0 0 0 0.15rem rgba(var(--ct-btn-focus-shadow-rgb), .5);\n  display: inline-block;\n  padding: var(--ct-btn-padding-y) var(--ct-btn-padding-x);\n  font-family: var(--ct-btn-font-family);\n  font-size: var(--ct-btn-font-size);\n  font-weight: var(--ct-btn-font-weight);\n  line-height: var(--ct-btn-line-height);\n  color: var(--ct-btn-color);\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  border: var(--ct-btn-border-width) solid var(--ct-btn-border-color);\n  border-radius: var(--ct-btn-border-radius);\n  background-color: var(--ct-btn-bg);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: var(--ct-btn-hover-color);\n  background-color: var(--ct-btn-hover-bg);\n  border-color: var(--ct-btn-hover-border-color);\n}\n.btn-check + .btn:hover {\n  color: var(--ct-btn-color);\n  background-color: var(--ct-btn-bg);\n  border-color: var(--ct-btn-border-color);\n}\n.btn:focus-visible {\n  color: var(--ct-btn-hover-color);\n  background-color: var(--ct-btn-hover-bg);\n  border-color: var(--ct-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--ct-btn-focus-box-shadow);\n}\n.btn-check:focus-visible + .btn {\n  border-color: var(--ct-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--ct-btn-focus-box-shadow);\n}\n.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {\n  color: var(--ct-btn-active-color);\n  background-color: var(--ct-btn-active-bg);\n  border-color: var(--ct-btn-active-border-color);\n}\n.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {\n  box-shadow: var(--ct-btn-focus-box-shadow);\n}\n.btn:disabled, .btn.disabled, fieldset:disabled .btn {\n  color: var(--ct-btn-disabled-color);\n  pointer-events: none;\n  background-color: var(--ct-btn-disabled-bg);\n  border-color: var(--ct-btn-disabled-border-color);\n  opacity: var(--ct-btn-disabled-opacity);\n}\n\n.btn-primary {\n  --ct-btn-color: #fff;\n  --ct-btn-bg: #6658dd;\n  --ct-btn-border-color: #6658dd;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: rgb(86.7, 74.8, 187.85);\n  --ct-btn-hover-border-color: rgb(81.6, 70.4, 176.8);\n  --ct-btn-focus-shadow-rgb: 125, 113, 226;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: rgb(81.6, 70.4, 176.8);\n  --ct-btn-active-border-color: rgb(76.5, 66, 165.75);\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #fff;\n  --ct-btn-disabled-bg: #6658dd;\n  --ct-btn-disabled-border-color: #6658dd;\n}\n\n.btn-secondary {\n  --ct-btn-color: #fff;\n  --ct-btn-bg: #6c757d;\n  --ct-btn-border-color: #6c757d;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: rgb(91.8, 99.45, 106.25);\n  --ct-btn-hover-border-color: rgb(86.4, 93.6, 100);\n  --ct-btn-focus-shadow-rgb: 130, 138, 145;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: rgb(86.4, 93.6, 100);\n  --ct-btn-active-border-color: rgb(81, 87.75, 93.75);\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #fff;\n  --ct-btn-disabled-bg: #6c757d;\n  --ct-btn-disabled-border-color: #6c757d;\n}\n\n.btn-success {\n  --ct-btn-color: #fff;\n  --ct-btn-bg: #1abc9c;\n  --ct-btn-border-color: #1abc9c;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: rgb(22.1, 159.8, 132.6);\n  --ct-btn-hover-border-color: rgb(20.8, 150.4, 124.8);\n  --ct-btn-focus-shadow-rgb: 60, 198, 171;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: rgb(20.8, 150.4, 124.8);\n  --ct-btn-active-border-color: rgb(19.5, 141, 117);\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #fff;\n  --ct-btn-disabled-bg: #1abc9c;\n  --ct-btn-disabled-border-color: #1abc9c;\n}\n\n.btn-info {\n  --ct-btn-color: #fff;\n  --ct-btn-bg: #43bfe5;\n  --ct-btn-border-color: #43bfe5;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: rgb(56.95, 162.35, 194.65);\n  --ct-btn-hover-border-color: rgb(53.6, 152.8, 183.2);\n  --ct-btn-focus-shadow-rgb: 95, 201, 233;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: rgb(53.6, 152.8, 183.2);\n  --ct-btn-active-border-color: rgb(50.25, 143.25, 171.75);\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #fff;\n  --ct-btn-disabled-bg: #43bfe5;\n  --ct-btn-disabled-border-color: #43bfe5;\n}\n\n.btn-warning {\n  --ct-btn-color: #323a46;\n  --ct-btn-bg: #f7b84b;\n  --ct-btn-border-color: #f7b84b;\n  --ct-btn-hover-color: #323a46;\n  --ct-btn-hover-bg: rgb(248.2, 194.65, 102);\n  --ct-btn-hover-border-color: rgb(247.8, 191.1, 93);\n  --ct-btn-focus-shadow-rgb: 217, 165, 74;\n  --ct-btn-active-color: #323a46;\n  --ct-btn-active-bg: rgb(248.6, 198.2, 111);\n  --ct-btn-active-border-color: rgb(247.8, 191.1, 93);\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #323a46;\n  --ct-btn-disabled-bg: #f7b84b;\n  --ct-btn-disabled-border-color: #f7b84b;\n}\n\n.btn-danger {\n  --ct-btn-color: #fff;\n  --ct-btn-bg: #f1556c;\n  --ct-btn-border-color: #f1556c;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: rgb(204.85, 72.25, 91.8);\n  --ct-btn-hover-border-color: rgb(192.8, 68, 86.4);\n  --ct-btn-focus-shadow-rgb: 243, 111, 130;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: rgb(192.8, 68, 86.4);\n  --ct-btn-active-border-color: rgb(180.75, 63.75, 81);\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #fff;\n  --ct-btn-disabled-bg: #f1556c;\n  --ct-btn-disabled-border-color: #f1556c;\n}\n\n.btn-light {\n  --ct-btn-color: #323a46;\n  --ct-btn-bg: #f3f7f9;\n  --ct-btn-border-color: #f3f7f9;\n  --ct-btn-hover-color: #323a46;\n  --ct-btn-hover-bg: rgb(206.55, 209.95, 211.65);\n  --ct-btn-hover-border-color: rgb(194.4, 197.6, 199.2);\n  --ct-btn-focus-shadow-rgb: 214, 219, 222;\n  --ct-btn-active-color: #323a46;\n  --ct-btn-active-bg: rgb(194.4, 197.6, 199.2);\n  --ct-btn-active-border-color: rgb(182.25, 185.25, 186.75);\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #323a46;\n  --ct-btn-disabled-bg: #f3f7f9;\n  --ct-btn-disabled-border-color: #f3f7f9;\n}\n\n.btn-dark {\n  --ct-btn-color: #fff;\n  --ct-btn-bg: #323a46;\n  --ct-btn-border-color: #323a46;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: rgb(80.75, 87.55, 97.75);\n  --ct-btn-hover-border-color: rgb(70.5, 77.7, 88.5);\n  --ct-btn-focus-shadow-rgb: 81, 88, 98;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: rgb(91, 97.4, 107);\n  --ct-btn-active-border-color: rgb(70.5, 77.7, 88.5);\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #fff;\n  --ct-btn-disabled-bg: #323a46;\n  --ct-btn-disabled-border-color: #323a46;\n}\n\n.btn-pink {\n  --ct-btn-color: #fff;\n  --ct-btn-bg: #f672a7;\n  --ct-btn-border-color: #f672a7;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: rgb(209.1, 96.9, 141.95);\n  --ct-btn-hover-border-color: rgb(196.8, 91.2, 133.6);\n  --ct-btn-focus-shadow-rgb: 247, 135, 180;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: rgb(196.8, 91.2, 133.6);\n  --ct-btn-active-border-color: rgb(184.5, 85.5, 125.25);\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #fff;\n  --ct-btn-disabled-bg: #f672a7;\n  --ct-btn-disabled-border-color: #f672a7;\n}\n\n.btn-blue {\n  --ct-btn-color: #fff;\n  --ct-btn-bg: #4a81d4;\n  --ct-btn-border-color: #4a81d4;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: rgb(62.9, 109.65, 180.2);\n  --ct-btn-hover-border-color: rgb(59.2, 103.2, 169.6);\n  --ct-btn-focus-shadow-rgb: 101, 148, 218;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: rgb(59.2, 103.2, 169.6);\n  --ct-btn-active-border-color: rgb(55.5, 96.75, 159);\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #fff;\n  --ct-btn-disabled-bg: #4a81d4;\n  --ct-btn-disabled-border-color: #4a81d4;\n}\n\n.btn-outline-primary {\n  --ct-btn-color: #6658dd;\n  --ct-btn-border-color: #6658dd;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: #6658dd;\n  --ct-btn-hover-border-color: #6658dd;\n  --ct-btn-focus-shadow-rgb: 102, 88, 221;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: #6658dd;\n  --ct-btn-active-border-color: #6658dd;\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #6658dd;\n  --ct-btn-disabled-bg: transparent;\n  --ct-btn-disabled-border-color: #6658dd;\n  --ct-gradient: none;\n}\n\n.btn-outline-secondary {\n  --ct-btn-color: #6c757d;\n  --ct-btn-border-color: #6c757d;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: #6c757d;\n  --ct-btn-hover-border-color: #6c757d;\n  --ct-btn-focus-shadow-rgb: 108, 117, 125;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: #6c757d;\n  --ct-btn-active-border-color: #6c757d;\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #6c757d;\n  --ct-btn-disabled-bg: transparent;\n  --ct-btn-disabled-border-color: #6c757d;\n  --ct-gradient: none;\n}\n\n.btn-outline-success {\n  --ct-btn-color: #1abc9c;\n  --ct-btn-border-color: #1abc9c;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: #1abc9c;\n  --ct-btn-hover-border-color: #1abc9c;\n  --ct-btn-focus-shadow-rgb: 26, 188, 156;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: #1abc9c;\n  --ct-btn-active-border-color: #1abc9c;\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #1abc9c;\n  --ct-btn-disabled-bg: transparent;\n  --ct-btn-disabled-border-color: #1abc9c;\n  --ct-gradient: none;\n}\n\n.btn-outline-info {\n  --ct-btn-color: #43bfe5;\n  --ct-btn-border-color: #43bfe5;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: #43bfe5;\n  --ct-btn-hover-border-color: #43bfe5;\n  --ct-btn-focus-shadow-rgb: 67, 191, 229;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: #43bfe5;\n  --ct-btn-active-border-color: #43bfe5;\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #43bfe5;\n  --ct-btn-disabled-bg: transparent;\n  --ct-btn-disabled-border-color: #43bfe5;\n  --ct-gradient: none;\n}\n\n.btn-outline-warning {\n  --ct-btn-color: #f7b84b;\n  --ct-btn-border-color: #f7b84b;\n  --ct-btn-hover-color: #323a46;\n  --ct-btn-hover-bg: #f7b84b;\n  --ct-btn-hover-border-color: #f7b84b;\n  --ct-btn-focus-shadow-rgb: 247, 184, 75;\n  --ct-btn-active-color: #323a46;\n  --ct-btn-active-bg: #f7b84b;\n  --ct-btn-active-border-color: #f7b84b;\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #f7b84b;\n  --ct-btn-disabled-bg: transparent;\n  --ct-btn-disabled-border-color: #f7b84b;\n  --ct-gradient: none;\n}\n\n.btn-outline-danger {\n  --ct-btn-color: #f1556c;\n  --ct-btn-border-color: #f1556c;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: #f1556c;\n  --ct-btn-hover-border-color: #f1556c;\n  --ct-btn-focus-shadow-rgb: 241, 85, 108;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: #f1556c;\n  --ct-btn-active-border-color: #f1556c;\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #f1556c;\n  --ct-btn-disabled-bg: transparent;\n  --ct-btn-disabled-border-color: #f1556c;\n  --ct-gradient: none;\n}\n\n.btn-outline-light {\n  --ct-btn-color: #f3f7f9;\n  --ct-btn-border-color: #f3f7f9;\n  --ct-btn-hover-color: #323a46;\n  --ct-btn-hover-bg: #f3f7f9;\n  --ct-btn-hover-border-color: #f3f7f9;\n  --ct-btn-focus-shadow-rgb: 243, 247, 249;\n  --ct-btn-active-color: #323a46;\n  --ct-btn-active-bg: #f3f7f9;\n  --ct-btn-active-border-color: #f3f7f9;\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #f3f7f9;\n  --ct-btn-disabled-bg: transparent;\n  --ct-btn-disabled-border-color: #f3f7f9;\n  --ct-gradient: none;\n}\n\n.btn-outline-dark {\n  --ct-btn-color: #323a46;\n  --ct-btn-border-color: #323a46;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: #323a46;\n  --ct-btn-hover-border-color: #323a46;\n  --ct-btn-focus-shadow-rgb: 50, 58, 70;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: #323a46;\n  --ct-btn-active-border-color: #323a46;\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #323a46;\n  --ct-btn-disabled-bg: transparent;\n  --ct-btn-disabled-border-color: #323a46;\n  --ct-gradient: none;\n}\n\n.btn-outline-pink {\n  --ct-btn-color: #f672a7;\n  --ct-btn-border-color: #f672a7;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: #f672a7;\n  --ct-btn-hover-border-color: #f672a7;\n  --ct-btn-focus-shadow-rgb: 246, 114, 167;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: #f672a7;\n  --ct-btn-active-border-color: #f672a7;\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #f672a7;\n  --ct-btn-disabled-bg: transparent;\n  --ct-btn-disabled-border-color: #f672a7;\n  --ct-gradient: none;\n}\n\n.btn-outline-blue {\n  --ct-btn-color: #4a81d4;\n  --ct-btn-border-color: #4a81d4;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: #4a81d4;\n  --ct-btn-hover-border-color: #4a81d4;\n  --ct-btn-focus-shadow-rgb: 74, 129, 212;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: #4a81d4;\n  --ct-btn-active-border-color: #4a81d4;\n  --ct-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-disabled-color: #4a81d4;\n  --ct-btn-disabled-bg: transparent;\n  --ct-btn-disabled-border-color: #4a81d4;\n  --ct-gradient: none;\n}\n\n.btn-link {\n  --ct-btn-font-weight: 400;\n  --ct-btn-color: var(--ct-link-color);\n  --ct-btn-bg: transparent;\n  --ct-btn-border-color: transparent;\n  --ct-btn-hover-color: var(--ct-link-hover-color);\n  --ct-btn-hover-border-color: transparent;\n  --ct-btn-active-color: var(--ct-link-hover-color);\n  --ct-btn-active-border-color: transparent;\n  --ct-btn-disabled-color: #98a6ad;\n  --ct-btn-disabled-border-color: transparent;\n  --ct-btn-box-shadow: none;\n  --ct-btn-focus-shadow-rgb: 125, 113, 226;\n  text-decoration: none;\n}\n.btn-link:focus-visible {\n  color: var(--ct-btn-color);\n}\n.btn-link:hover {\n  color: var(--ct-btn-hover-color);\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  --ct-btn-padding-y: 0.5rem;\n  --ct-btn-padding-x: 1rem;\n  --ct-btn-font-size: 1.09375rem;\n  --ct-btn-border-radius: var(--ct-border-radius-lg);\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  --ct-btn-padding-y: 0.28rem;\n  --ct-btn-padding-x: 0.8rem;\n  --ct-btn-font-size: 0.765625rem;\n  --ct-btn-border-radius: var(--ct-border-radius-sm);\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n.collapsing.collapse-horizontal {\n  width: 0;\n  height: auto;\n  transition: width 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing.collapse-horizontal {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n\n.dropdown-menu {\n  --ct-dropdown-zindex: 1000;\n  --ct-dropdown-min-width: 10rem;\n  --ct-dropdown-padding-x: 0.25rem;\n  --ct-dropdown-padding-y: 0.25rem;\n  --ct-dropdown-spacer: 0.125rem;\n  --ct-dropdown-font-size: 0.875rem;\n  --ct-dropdown-color: var(--ct-body-color);\n  --ct-dropdown-bg: var(--ct-secondary-bg);\n  --ct-dropdown-border-color: var(--ct-border-color);\n  --ct-dropdown-border-radius: var(--ct-border-radius);\n  --ct-dropdown-border-width: 1px;\n  --ct-dropdown-inner-border-radius: calc(var(--ct-border-radius) - 1px);\n  --ct-dropdown-divider-bg: var(--ct-border-color);\n  --ct-dropdown-divider-margin-y: 0.375rem;\n  --ct-dropdown-box-shadow: var(--ct-box-shadow);\n  --ct-dropdown-link-color: var(--ct-body-color);\n  --ct-dropdown-link-hover-color: var(--ct-dark);\n  --ct-dropdown-link-hover-bg: var(--ct-light);\n  --ct-dropdown-link-active-color: var(--ct-dark);\n  --ct-dropdown-link-active-bg: var(--ct-light);\n  --ct-dropdown-link-disabled-color: var(--ct-gray-500);\n  --ct-dropdown-item-padding-x: 1.5rem;\n  --ct-dropdown-item-padding-y: 0.375rem;\n  --ct-dropdown-header-color: inherit;\n  --ct-dropdown-header-padding-x: 1.5rem;\n  --ct-dropdown-header-padding-y: 0.25rem;\n  position: absolute;\n  z-index: var(--ct-dropdown-zindex);\n  display: none;\n  min-width: var(--ct-dropdown-min-width);\n  padding: var(--ct-dropdown-padding-y) var(--ct-dropdown-padding-x);\n  margin: 0;\n  font-size: var(--ct-dropdown-font-size);\n  color: var(--ct-dropdown-color);\n  text-align: left;\n  list-style: none;\n  background-color: var(--ct-dropdown-bg);\n  background-clip: padding-box;\n  border: var(--ct-dropdown-border-width) solid var(--ct-dropdown-border-color);\n  border-radius: var(--ct-dropdown-border-radius);\n}\n.dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: var(--ct-dropdown-spacer);\n}\n\n.dropdown-menu-start {\n  --bs-position: start;\n}\n.dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-end {\n  --bs-position: end;\n}\n.dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1400px) {\n  .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: var(--ct-dropdown-spacer);\n}\n.dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: var(--ct-dropdown-spacer);\n}\n.dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: var(--ct-dropdown-spacer);\n}\n.dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: var(--ct-dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--ct-dropdown-divider-bg);\n  opacity: 1;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: var(--ct-dropdown-item-padding-y) var(--ct-dropdown-item-padding-x);\n  clear: both;\n  font-weight: 400;\n  color: var(--ct-dropdown-link-color);\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  border-radius: var(--ct-dropdown-item-border-radius, 0);\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: var(--ct-dropdown-link-hover-color);\n  background-color: var(--ct-dropdown-link-hover-bg);\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: var(--ct-dropdown-link-active-color);\n  text-decoration: none;\n  background-color: var(--ct-dropdown-link-active-bg);\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: var(--ct-dropdown-link-disabled-color);\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: var(--ct-dropdown-header-padding-y) var(--ct-dropdown-header-padding-x);\n  margin-bottom: 0;\n  font-size: 0.765625rem;\n  color: var(--ct-dropdown-header-color);\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: var(--ct-dropdown-item-padding-y) var(--ct-dropdown-item-padding-x);\n  color: var(--ct-dropdown-link-color);\n}\n\n.dropdown-menu-dark {\n  --ct-dropdown-color: #dee2e6;\n  --ct-dropdown-bg: #343a40;\n  --ct-dropdown-border-color: var(--ct-border-color);\n  --ct-dropdown-box-shadow: ;\n  --ct-dropdown-link-color: #dee2e6;\n  --ct-dropdown-link-hover-color: #fff;\n  --ct-dropdown-divider-bg: var(--ct-border-color);\n  --ct-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);\n  --ct-dropdown-link-active-color: var(--ct-dark);\n  --ct-dropdown-link-active-bg: var(--ct-light);\n  --ct-dropdown-link-disabled-color: #adb5bd;\n  --ct-dropdown-header-color: #adb5bd;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn-check:checked + .btn,\n.btn-group > .btn-check:focus + .btn,\n.btn-group > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn-check:checked + .btn,\n.btn-group-vertical > .btn-check:focus + .btn,\n.btn-group-vertical > .btn:hover,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group {\n  border-radius: var(--ct-border-radius);\n}\n.btn-group > :not(.btn-check:first-child) + .btn,\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: calc(var(--ct-border-width) * -1);\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn.dropdown-toggle-split:first-child,\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:nth-child(n+3),\n.btn-group > :not(.btn-check) + .btn,\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.675rem;\n  padding-left: 0.675rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.6rem;\n  padding-left: 0.6rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: calc(var(--ct-border-width) * -1);\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn ~ .btn,\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav {\n  --ct-nav-link-padding-x: 1rem;\n  --ct-nav-link-padding-y: 0.5rem;\n  --ct-nav-link-font-weight: ;\n  --ct-nav-link-color: var(--ct-link-color);\n  --ct-nav-link-hover-color: var(--ct-link-hover-color);\n  --ct-nav-link-disabled-color: var(--ct-secondary-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--ct-nav-link-padding-y) var(--ct-nav-link-padding-x);\n  font-size: var(--ct-nav-link-font-size);\n  font-weight: var(--ct-nav-link-font-weight);\n  color: var(--ct-nav-link-color);\n  transition: color 0.3s ease-in-out, background-color 0.3s ease-in-out, border-color 0.3s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .nav-link {\n    transition: none;\n  }\n}\n.nav-link:hover, .nav-link:focus {\n  color: var(--ct-nav-link-hover-color);\n}\n.nav-link.disabled {\n  color: var(--ct-nav-link-disabled-color);\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  --ct-nav-tabs-border-width: var(--ct-border-width);\n  --ct-nav-tabs-border-color: var(--ct-border-color);\n  --ct-nav-tabs-border-radius: var(--ct-border-radius);\n  --ct-nav-tabs-link-hover-border-color: var(--ct-secondary-bg) var(--ct-secondary-bg) var(--ct-border-color);\n  --ct-nav-tabs-link-active-color: var(--ct-emphasis-color);\n  --ct-nav-tabs-link-active-bg: var(--bs-body-bg);\n  --ct-nav-tabs-link-active-border-color: var(--ct-border-color) var(--ct-border-color) var(--ct-border-color);\n  border-bottom: var(--ct-nav-tabs-border-width) solid var(--ct-nav-tabs-border-color);\n}\n.nav-tabs .nav-link {\n  margin-bottom: calc(-1 * var(--ct-nav-tabs-border-width));\n  background: none;\n  border: var(--ct-nav-tabs-border-width) solid transparent;\n  border-top-left-radius: var(--ct-nav-tabs-border-radius);\n  border-top-right-radius: var(--ct-nav-tabs-border-radius);\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  isolation: isolate;\n  border-color: var(--ct-nav-tabs-link-hover-border-color);\n}\n.nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {\n  color: var(--ct-nav-link-disabled-color);\n  background-color: transparent;\n  border-color: transparent;\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: var(--ct-nav-tabs-link-active-color);\n  background-color: var(--ct-nav-tabs-link-active-bg);\n  border-color: var(--ct-nav-tabs-link-active-border-color);\n}\n.nav-tabs .dropdown-menu {\n  margin-top: calc(-1 * var(--ct-nav-tabs-border-width));\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills {\n  --ct-nav-pills-border-radius: var(--ct-border-radius);\n  --ct-nav-pills-link-active-color: #fff;\n  --ct-nav-pills-link-active-bg: #6658dd;\n}\n.nav-pills .nav-link {\n  background: none;\n  border: 0;\n  border-radius: var(--ct-nav-pills-border-radius);\n}\n.nav-pills .nav-link:disabled {\n  color: var(--ct-nav-link-disabled-color);\n  background-color: transparent;\n  border-color: transparent;\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: var(--ct-nav-pills-link-active-color);\n  background-color: var(--ct-nav-pills-link-active-bg);\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  --ct-navbar-padding-x: 0;\n  --ct-navbar-padding-y: 0.75rem;\n  --ct-navbar-color: rgba(var(--ct-emphasis-color-rgb), 0.65);\n  --ct-navbar-hover-color: rgba(var(--ct-emphasis-color-rgb), 0.8);\n  --ct-navbar-disabled-color: rgba(var(--ct-emphasis-color-rgb), 0.3);\n  --ct-navbar-active-color: rgba(var(--ct-emphasis-color-rgb), 1);\n  --ct-navbar-brand-padding-y: 0.3359375rem;\n  --ct-navbar-brand-margin-end: 1rem;\n  --ct-navbar-brand-font-size: 1.09375rem;\n  --ct-navbar-brand-color: rgba(var(--ct-emphasis-color-rgb), 1);\n  --ct-navbar-brand-hover-color: rgba(var(--ct-emphasis-color-rgb), 1);\n  --ct-navbar-nav-link-padding-x: 0.5rem;\n  --ct-navbar-toggler-padding-y: 0.25rem;\n  --ct-navbar-toggler-padding-x: 0.75rem;\n  --ct-navbar-toggler-font-size: 1.09375rem;\n  --ct-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28var%28--ct-emphasis-color-rgb%29, 0.65%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  --ct-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);\n  --ct-navbar-toggler-border-radius: var(--ct-border-radius);\n  --ct-navbar-toggler-focus-width: 0.15rem;\n  --ct-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--ct-navbar-padding-y) var(--ct-navbar-padding-x);\n}\n.navbar > .container,\n.navbar > .container-fluid,\n.navbar > .container-sm,\n.navbar > .container-md,\n.navbar > .container-lg,\n.navbar > .container-xl,\n.navbar > .container-xxl {\n  display: flex;\n  flex-wrap: inherit;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  padding-top: var(--ct-navbar-brand-padding-y);\n  padding-bottom: var(--ct-navbar-brand-padding-y);\n  margin-right: var(--ct-navbar-brand-margin-end);\n  font-size: var(--ct-navbar-brand-font-size);\n  color: var(--ct-navbar-brand-color);\n  white-space: nowrap;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n  color: var(--ct-navbar-brand-hover-color);\n}\n\n.navbar-nav {\n  --ct-nav-link-padding-x: 0;\n  --ct-nav-link-padding-y: 0.5rem;\n  --ct-nav-link-font-weight: ;\n  --ct-nav-link-color: var(--ct-navbar-color);\n  --ct-nav-link-hover-color: var(--ct-navbar-hover-color);\n  --ct-nav-link-disabled-color: var(--ct-navbar-disabled-color);\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .show > .nav-link,\n.navbar-nav .nav-link.active {\n  color: var(--ct-navbar-active-color);\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n}\n\n.navbar-text {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--ct-navbar-color);\n}\n.navbar-text a,\n.navbar-text a:hover,\n.navbar-text a:focus {\n  color: var(--ct-navbar-active-color);\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: var(--ct-navbar-toggler-padding-y) var(--ct-navbar-toggler-padding-x);\n  font-size: var(--ct-navbar-toggler-font-size);\n  line-height: 1;\n  color: var(--ct-navbar-color);\n  background-color: transparent;\n  border: var(--ct-border-width) solid var(--ct-navbar-toggler-border-color);\n  border-radius: var(--ct-navbar-toggler-border-radius);\n  transition: var(--ct-navbar-toggler-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .navbar-toggler {\n    transition: none;\n  }\n}\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  box-shadow: 0 0 0 var(--ct-navbar-toggler-focus-width);\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--ct-navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--ct-scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: var(--ct-navbar-nav-link-padding-x);\n    padding-left: var(--ct-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: var(--ct-navbar-nav-link-padding-x);\n    padding-left: var(--ct-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: var(--ct-navbar-nav-link-padding-x);\n    padding-left: var(--ct-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: var(--ct-navbar-nav-link-padding-x);\n    padding-left: var(--ct-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .navbar-expand-xxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: var(--ct-navbar-nav-link-padding-x);\n    padding-left: var(--ct-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n.navbar-expand {\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: var(--ct-navbar-nav-link-padding-x);\n  padding-left: var(--ct-navbar-nav-link-padding-x);\n}\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n.navbar-expand .offcanvas {\n  position: static;\n  z-index: auto;\n  flex-grow: 1;\n  width: auto !important;\n  height: auto !important;\n  visibility: visible !important;\n  background-color: transparent !important;\n  border: 0 !important;\n  transform: none !important;\n  transition: none;\n}\n.navbar-expand .offcanvas .offcanvas-header {\n  display: none;\n}\n.navbar-expand .offcanvas .offcanvas-body {\n  display: flex;\n  flex-grow: 0;\n  padding: 0;\n  overflow-y: visible;\n}\n\n.navbar-dark {\n  --ct-navbar-color: rgba(255, 255, 255, 0.55);\n  --ct-navbar-hover-color: rgba(255, 255, 255, 0.75);\n  --ct-navbar-disabled-color: rgba(255, 255, 255, 0.25);\n  --ct-navbar-active-color: #fff;\n  --ct-navbar-brand-color: #fff;\n  --ct-navbar-brand-hover-color: #fff;\n  --ct-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\n  --ct-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n[data-bs-theme=dark] .navbar {\n  --ct-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.card {\n  --ct-card-spacer-y: 1.5rem;\n  --ct-card-spacer-x: 1.5rem;\n  --ct-card-title-spacer-y: 0.75rem;\n  --ct-card-title-color: ;\n  --ct-card-subtitle-color: ;\n  --ct-card-border-width: var(--ct-theme-border-width);\n  --ct-card-border-color: var(--ct-border-color);\n  --ct-card-border-radius: var(--ct-border-radius);\n  --ct-card-box-shadow: var(--ct-box-shadow-sm);\n  --ct-card-inner-border-radius: calc(var(--ct-border-radius) - (var(--ct-theme-border-width)));\n  --ct-card-cap-padding-y: 1.125rem;\n  --ct-card-cap-padding-x: 1.5rem;\n  --ct-card-cap-bg: var(--ct-secondary-bg);\n  --ct-card-cap-color: ;\n  --ct-card-height: ;\n  --ct-card-color: ;\n  --ct-card-bg: var(--ct-secondary-bg);\n  --ct-card-img-overlay-padding: 1.5rem;\n  --ct-card-group-margin: 12px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: var(--ct-card-height);\n  word-wrap: break-word;\n  background-color: var(--ct-card-bg);\n  background-clip: border-box;\n  border: var(--ct-card-border-width) solid var(--ct-card-border-color);\n  border-radius: var(--ct-card-border-radius);\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: var(--ct-card-inner-border-radius);\n  border-top-right-radius: var(--ct-card-inner-border-radius);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: var(--ct-card-inner-border-radius);\n  border-bottom-left-radius: var(--ct-card-inner-border-radius);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: var(--ct-card-spacer-y) var(--ct-card-spacer-x);\n  color: var(--ct-card-color);\n}\n\n.card-title {\n  margin-bottom: var(--ct-card-title-spacer-y);\n  color: var(--ct-card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-0.5 * var(--ct-card-title-spacer-y));\n  margin-bottom: 0;\n  color: var(--ct-card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link + .card-link {\n  margin-left: var(--ct-card-spacer-x);\n}\n\n.card-header {\n  padding: var(--ct-card-cap-padding-y) var(--ct-card-cap-padding-x);\n  margin-bottom: 0;\n  color: var(--ct-card-cap-color);\n  background-color: var(--ct-card-cap-bg);\n  border-bottom: var(--ct-card-border-width) solid var(--ct-card-border-color);\n}\n.card-header:first-child {\n  border-radius: var(--ct-card-inner-border-radius) var(--ct-card-inner-border-radius) 0 0;\n}\n\n.card-footer {\n  padding: var(--ct-card-cap-padding-y) var(--ct-card-cap-padding-x);\n  color: var(--ct-card-cap-color);\n  background-color: var(--ct-card-cap-bg);\n  border-top: var(--ct-card-border-width) solid var(--ct-card-border-color);\n}\n.card-footer:last-child {\n  border-radius: 0 0 var(--ct-card-inner-border-radius) var(--ct-card-inner-border-radius);\n}\n\n.card-header-tabs {\n  margin-right: calc(-0.5 * var(--ct-card-cap-padding-x));\n  margin-bottom: calc(-1 * var(--ct-card-cap-padding-y));\n  margin-left: calc(-0.5 * var(--ct-card-cap-padding-x));\n  border-bottom: 0;\n}\n.card-header-tabs .nav-link.active {\n  background-color: var(--ct-card-bg);\n  border-bottom-color: var(--ct-card-bg);\n}\n\n.card-header-pills {\n  margin-right: calc(-0.5 * var(--ct-card-cap-padding-x));\n  margin-left: calc(-0.5 * var(--ct-card-cap-padding-x));\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--ct-card-img-overlay-padding);\n  border-radius: var(--ct-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: var(--ct-card-inner-border-radius);\n  border-top-right-radius: var(--ct-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: var(--ct-card-inner-border-radius);\n  border-bottom-left-radius: var(--ct-card-inner-border-radius);\n}\n\n.card-group > .card {\n  margin-bottom: var(--ct-card-group-margin);\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n  .card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n  .card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n  .card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n  .card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.accordion {\n  --ct-accordion-color: var(--ct-body-color);\n  --ct-accordion-bg: var(--ct-secondary-bg);\n  --ct-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n  --ct-accordion-border-color: var(--ct-border-color);\n  --ct-accordion-border-width: var(--ct-border-width);\n  --ct-accordion-border-radius: var(--ct-border-radius);\n  --ct-accordion-inner-border-radius: calc(var(--ct-border-radius) - (var(--ct-border-width)));\n  --ct-accordion-btn-padding-x: 1.25rem;\n  --ct-accordion-btn-padding-y: 1rem;\n  --ct-accordion-btn-color: var(--ct-body-color);\n  --ct-accordion-btn-bg: var(--ct-accordion-bg);\n  --ct-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%236c757d'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --ct-accordion-btn-icon-width: 0.75rem;\n  --ct-accordion-btn-icon-transform: rotate(-180deg);\n  --ct-accordion-btn-icon-transition: transform 0.2s ease-in-out;\n  --ct-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%2881.6, 70.4, 176.8%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --ct-accordion-btn-focus-border-color: var(--ct-border-color);\n  --ct-accordion-btn-focus-box-shadow: 0 0 0 0.15rem rgba(102, 88, 221, 0.25);\n  --ct-accordion-body-padding-x: 1.25rem;\n  --ct-accordion-body-padding-y: 1rem;\n  --ct-accordion-active-color: var(--ct-primary-text);\n  --ct-accordion-active-bg: var(--ct-primary-bg-subtle);\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--ct-accordion-btn-padding-y) var(--ct-accordion-btn-padding-x);\n  font-size: 0.875rem;\n  color: var(--ct-accordion-btn-color);\n  text-align: left;\n  background-color: var(--ct-accordion-btn-bg);\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: var(--ct-accordion-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button {\n    transition: none;\n  }\n}\n.accordion-button:not(.collapsed) {\n  color: var(--ct-accordion-active-color);\n  background-color: var(--ct-accordion-active-bg);\n  box-shadow: inset 0 calc(-1 * var(--ct-accordion-border-width)) 0 var(--ct-accordion-border-color);\n}\n.accordion-button:not(.collapsed)::after {\n  background-image: var(--ct-accordion-btn-active-icon);\n  transform: var(--ct-accordion-btn-icon-transform);\n}\n.accordion-button::after {\n  flex-shrink: 0;\n  width: var(--ct-accordion-btn-icon-width);\n  height: var(--ct-accordion-btn-icon-width);\n  margin-left: auto;\n  content: \"\";\n  background-image: var(--ct-accordion-btn-icon);\n  background-repeat: no-repeat;\n  background-size: var(--ct-accordion-btn-icon-width);\n  transition: var(--ct-accordion-btn-icon-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button::after {\n    transition: none;\n  }\n}\n.accordion-button:hover {\n  z-index: 2;\n}\n.accordion-button:focus {\n  z-index: 3;\n  border-color: var(--ct-accordion-btn-focus-border-color);\n  outline: 0;\n  box-shadow: var(--ct-accordion-btn-focus-box-shadow);\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--ct-accordion-color);\n  background-color: var(--ct-accordion-bg);\n  border: var(--ct-accordion-border-width) solid var(--ct-accordion-border-color);\n}\n.accordion-item:first-of-type {\n  border-top-left-radius: var(--ct-accordion-border-radius);\n  border-top-right-radius: var(--ct-accordion-border-radius);\n}\n.accordion-item:first-of-type .accordion-button {\n  border-top-left-radius: var(--ct-accordion-inner-border-radius);\n  border-top-right-radius: var(--ct-accordion-inner-border-radius);\n}\n.accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n.accordion-item:last-of-type {\n  border-bottom-right-radius: var(--ct-accordion-border-radius);\n  border-bottom-left-radius: var(--ct-accordion-border-radius);\n}\n.accordion-item:last-of-type .accordion-button.collapsed {\n  border-bottom-right-radius: var(--ct-accordion-inner-border-radius);\n  border-bottom-left-radius: var(--ct-accordion-inner-border-radius);\n}\n.accordion-item:last-of-type .accordion-collapse {\n  border-bottom-right-radius: var(--ct-accordion-border-radius);\n  border-bottom-left-radius: var(--ct-accordion-border-radius);\n}\n\n.accordion-body {\n  padding: var(--ct-accordion-body-padding-y) var(--ct-accordion-body-padding-x);\n}\n\n.accordion-flush .accordion-collapse {\n  border-width: 0;\n}\n.accordion-flush .accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.accordion-flush .accordion-item:first-child {\n  border-top: 0;\n}\n.accordion-flush .accordion-item:last-child {\n  border-bottom: 0;\n}\n.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {\n  border-radius: 0;\n}\n\n[data-bs-theme=dark] .accordion-button::after {\n  --ct-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%28163.2, 154.8, 234.6%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --ct-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%28163.2, 154.8, 234.6%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.breadcrumb {\n  --ct-breadcrumb-padding-x: 0;\n  --ct-breadcrumb-padding-y: 0;\n  --ct-breadcrumb-margin-bottom: 1rem;\n  --ct-breadcrumb-bg: ;\n  --ct-breadcrumb-border-radius: ;\n  --ct-breadcrumb-divider-color: var(--ct-secondary-color);\n  --ct-breadcrumb-item-padding-x: 0.5rem;\n  --ct-breadcrumb-item-active-color: var(--ct-gray-500);\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--ct-breadcrumb-padding-y) var(--ct-breadcrumb-padding-x);\n  margin-bottom: var(--ct-breadcrumb-margin-bottom);\n  font-size: var(--ct-breadcrumb-font-size);\n  list-style: none;\n  background-color: var(--ct-breadcrumb-bg);\n  border-radius: var(--ct-breadcrumb-border-radius);\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: var(--ct-breadcrumb-item-padding-x);\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: var(--ct-breadcrumb-item-padding-x);\n  color: var(--ct-breadcrumb-divider-color);\n  content: var(--ct-breadcrumb-divider, \"\\f0142\") /* rtl: var(--ct-breadcrumb-divider, \"\\f0142\") */;\n}\n.breadcrumb-item.active {\n  color: var(--ct-breadcrumb-item-active-color);\n}\n\n.pagination {\n  --ct-pagination-padding-x: 0.75rem;\n  --ct-pagination-padding-y: 0.375rem;\n  --ct-pagination-font-size: 0.875rem;\n  --ct-pagination-color: var(--ct-dark);\n  --ct-pagination-bg: var(--bs-body-bg);\n  --ct-pagination-border-width: var(--ct-border-width);\n  --ct-pagination-border-color: var(--ct-border-color);\n  --ct-pagination-border-radius: var(--ct-border-radius);\n  --ct-pagination-hover-color: var(--ct-dark);\n  --ct-pagination-hover-bg: var(--ct-gray-100);\n  --ct-pagination-hover-border-color: var(--ct-border-color);\n  --ct-pagination-focus-color: rgb(86.7, 74.8, 187.85);\n  --ct-pagination-focus-bg: var(--ct-secondary-bg);\n  --ct-pagination-focus-box-shadow: 0 0 0 0.15rem rgba(102, 88, 221, 0.25);\n  --ct-pagination-active-color: #fff;\n  --ct-pagination-active-bg: #6658dd;\n  --ct-pagination-active-border-color: #6658dd;\n  --ct-pagination-disabled-color: var(--ct-secondary-color);\n  --ct-pagination-disabled-bg: var(--ct-secondary-bg);\n  --ct-pagination-disabled-border-color: var(--ct-border-color);\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--ct-pagination-padding-y) var(--ct-pagination-padding-x);\n  font-size: var(--ct-pagination-font-size);\n  color: var(--ct-pagination-color);\n  background-color: var(--ct-pagination-bg);\n  border: var(--ct-pagination-border-width) solid var(--ct-pagination-border-color);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .page-link {\n    transition: none;\n  }\n}\n.page-link:hover {\n  z-index: 2;\n  color: var(--ct-pagination-hover-color);\n  background-color: var(--ct-pagination-hover-bg);\n  border-color: var(--ct-pagination-hover-border-color);\n}\n.page-link:focus {\n  z-index: 3;\n  color: var(--ct-pagination-focus-color);\n  background-color: var(--ct-pagination-focus-bg);\n  outline: 0;\n  box-shadow: var(--ct-pagination-focus-box-shadow);\n}\n.page-link.active, .active > .page-link {\n  z-index: 3;\n  color: var(--ct-pagination-active-color);\n  background-color: var(--ct-pagination-active-bg);\n  border-color: var(--ct-pagination-active-border-color);\n}\n.page-link.disabled, .disabled > .page-link {\n  color: var(--ct-pagination-disabled-color);\n  pointer-events: none;\n  background-color: var(--ct-pagination-disabled-bg);\n  border-color: var(--ct-pagination-disabled-border-color);\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: calc(var(--ct-border-width) * -1);\n}\n.page-item:first-child .page-link {\n  border-top-left-radius: var(--ct-pagination-border-radius);\n  border-bottom-left-radius: var(--ct-pagination-border-radius);\n}\n.page-item:last-child .page-link {\n  border-top-right-radius: var(--ct-pagination-border-radius);\n  border-bottom-right-radius: var(--ct-pagination-border-radius);\n}\n\n.pagination-lg {\n  --ct-pagination-padding-x: 1.5rem;\n  --ct-pagination-padding-y: 0.75rem;\n  --ct-pagination-font-size: 1.09375rem;\n  --ct-pagination-border-radius: var(--ct-border-radius-lg);\n}\n\n.pagination-sm {\n  --ct-pagination-padding-x: 0.5rem;\n  --ct-pagination-padding-y: 0.25rem;\n  --ct-pagination-font-size: 0.765625rem;\n  --ct-pagination-border-radius: var(--ct-border-radius-sm);\n}\n\n.badge {\n  --ct-badge-padding-x: 0.4em;\n  --ct-badge-padding-y: 0.25em;\n  --ct-badge-font-size: 0.75em;\n  --ct-badge-font-weight: 700;\n  --ct-badge-color: #fff;\n  --ct-badge-border-radius: var(--ct-border-radius);\n  display: inline-block;\n  padding: var(--ct-badge-padding-y) var(--ct-badge-padding-x);\n  font-size: var(--ct-badge-font-size);\n  font-weight: var(--ct-badge-font-weight);\n  line-height: 1;\n  color: var(--ct-badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--ct-badge-border-radius);\n}\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.alert {\n  --ct-alert-bg: transparent;\n  --ct-alert-padding-x: 1.25rem;\n  --ct-alert-padding-y: 0.8rem;\n  --ct-alert-margin-bottom: 1rem;\n  --ct-alert-color: inherit;\n  --ct-alert-border-color: transparent;\n  --ct-alert-border: var(--ct-border-width) solid var(--ct-alert-border-color);\n  --ct-alert-border-radius: var(--ct-border-radius);\n  --ct-alert-link-color: inherit;\n  position: relative;\n  padding: var(--ct-alert-padding-y) var(--ct-alert-padding-x);\n  margin-bottom: var(--ct-alert-margin-bottom);\n  color: var(--ct-alert-color);\n  background-color: var(--ct-alert-bg);\n  border: var(--ct-alert-border);\n  border-radius: var(--ct-alert-border-radius);\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 700;\n  color: var(--ct-alert-link-color);\n}\n\n.alert-dismissible {\n  padding-right: 3.75rem;\n}\n.alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 1rem 1.25rem;\n}\n\n.alert-primary {\n  --ct-alert-color: var(--ct-primary-text);\n  --ct-alert-bg: var(--ct-primary-bg-subtle);\n  --ct-alert-border-color: var(--ct-primary-border-subtle);\n  --ct-alert-link-color: var(--ct-primary-text);\n}\n\n.alert-secondary {\n  --ct-alert-color: var(--ct-secondary-text);\n  --ct-alert-bg: var(--ct-secondary-bg-subtle);\n  --ct-alert-border-color: var(--ct-secondary-border-subtle);\n  --ct-alert-link-color: var(--ct-secondary-text);\n}\n\n.alert-success {\n  --ct-alert-color: var(--ct-success-text);\n  --ct-alert-bg: var(--ct-success-bg-subtle);\n  --ct-alert-border-color: var(--ct-success-border-subtle);\n  --ct-alert-link-color: var(--ct-success-text);\n}\n\n.alert-info {\n  --ct-alert-color: var(--ct-info-text);\n  --ct-alert-bg: var(--ct-info-bg-subtle);\n  --ct-alert-border-color: var(--ct-info-border-subtle);\n  --ct-alert-link-color: var(--ct-info-text);\n}\n\n.alert-warning {\n  --ct-alert-color: var(--ct-warning-text);\n  --ct-alert-bg: var(--ct-warning-bg-subtle);\n  --ct-alert-border-color: var(--ct-warning-border-subtle);\n  --ct-alert-link-color: var(--ct-warning-text);\n}\n\n.alert-danger {\n  --ct-alert-color: var(--ct-danger-text);\n  --ct-alert-bg: var(--ct-danger-bg-subtle);\n  --ct-alert-border-color: var(--ct-danger-border-subtle);\n  --ct-alert-link-color: var(--ct-danger-text);\n}\n\n.alert-light {\n  --ct-alert-color: var(--ct-light-text);\n  --ct-alert-bg: var(--ct-light-bg-subtle);\n  --ct-alert-border-color: var(--ct-light-border-subtle);\n  --ct-alert-link-color: var(--ct-light-text);\n}\n\n.alert-dark {\n  --ct-alert-color: var(--ct-dark-text);\n  --ct-alert-bg: var(--ct-dark-bg-subtle);\n  --ct-alert-border-color: var(--ct-dark-border-subtle);\n  --ct-alert-link-color: var(--ct-dark-text);\n}\n\n.alert-pink {\n  --ct-alert-color: var(--ct-pink-text);\n  --ct-alert-bg: var(--ct-pink-bg-subtle);\n  --ct-alert-border-color: var(--ct-pink-border-subtle);\n  --ct-alert-link-color: var(--ct-pink-text);\n}\n\n.alert-blue {\n  --ct-alert-color: var(--ct-blue-text);\n  --ct-alert-bg: var(--ct-blue-bg-subtle);\n  --ct-alert-border-color: var(--ct-blue-border-subtle);\n  --ct-alert-link-color: var(--ct-blue-text);\n}\n\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: 1rem;\n  }\n}\n.progress,\n.progress-stacked {\n  --ct-progress-height: 1rem;\n  --ct-progress-font-size: 0.65625rem;\n  --ct-progress-bg: var(--ct-light);\n  --ct-progress-border-radius: var(--ct-border-radius);\n  --ct-progress-box-shadow: var(--ct-box-shadow-inset);\n  --ct-progress-bar-color: #fff;\n  --ct-progress-bar-bg: #6658dd;\n  --ct-progress-bar-transition: width 0.6s ease;\n  display: flex;\n  height: var(--ct-progress-height);\n  overflow: hidden;\n  font-size: var(--ct-progress-font-size);\n  background-color: var(--ct-progress-bg);\n  border-radius: var(--ct-progress-border-radius);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--ct-progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--ct-progress-bar-bg);\n  transition: var(--ct-progress-bar-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: var(--ct-progress-height) var(--ct-progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.list-group {\n  --ct-list-group-color: var(--ct-body-color);\n  --ct-list-group-bg: var(--ct-secondary-bg);\n  --ct-list-group-border-color: var(--ct-border-color);\n  --ct-list-group-border-width: var(--ct-border-width);\n  --ct-list-group-border-radius: var(--ct-border-radius);\n  --ct-list-group-item-padding-x: 1.2rem;\n  --ct-list-group-item-padding-y: 0.75rem;\n  --ct-list-group-action-color: var(--ct-secondary-color);\n  --ct-list-group-action-hover-color: var(--ct-emphasis-color);\n  --ct-list-group-action-hover-bg: var(--ct-gray-300);\n  --ct-list-group-action-active-color: var(--ct-body-color);\n  --ct-list-group-action-active-bg: var(--ct-secondary-bg);\n  --ct-list-group-disabled-color: var(--ct-secondary-color);\n  --ct-list-group-disabled-bg: var(--ct-secondary-bg);\n  --ct-list-group-active-color: #fff;\n  --ct-list-group-active-bg: #6658dd;\n  --ct-list-group-active-border-color: #6658dd;\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: var(--ct-list-group-border-radius);\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n.list-group-numbered > .list-group-item::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: var(--ct-list-group-action-color);\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: var(--ct-list-group-action-hover-color);\n  text-decoration: none;\n  background-color: var(--ct-list-group-action-hover-bg);\n}\n.list-group-item-action:active {\n  color: var(--ct-list-group-action-active-color);\n  background-color: var(--ct-list-group-action-active-bg);\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--ct-list-group-item-padding-y) var(--ct-list-group-item-padding-x);\n  color: var(--ct-list-group-color);\n  background-color: var(--ct-list-group-bg);\n  border: var(--ct-list-group-border-width) solid var(--ct-list-group-border-color);\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: var(--ct-list-group-disabled-color);\n  pointer-events: none;\n  background-color: var(--ct-list-group-disabled-bg);\n}\n.list-group-item.active {\n  z-index: 2;\n  color: var(--ct-list-group-active-color);\n  background-color: var(--ct-list-group-active-bg);\n  border-color: var(--ct-list-group-active-border-color);\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: calc(-1 * var(--ct-list-group-border-width));\n  border-top-width: var(--ct-list-group-border-width);\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child:not(:last-child) {\n  border-bottom-left-radius: var(--ct-list-group-border-radius);\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child:not(:first-child) {\n  border-top-right-radius: var(--ct-list-group-border-radius);\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: var(--ct-list-group-border-width);\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: calc(-1 * var(--ct-list-group-border-width));\n  border-left-width: var(--ct-list-group-border-width);\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--ct-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--ct-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: var(--ct-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--ct-list-group-border-width));\n    border-left-width: var(--ct-list-group-border-width);\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--ct-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--ct-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: var(--ct-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--ct-list-group-border-width));\n    border-left-width: var(--ct-list-group-border-width);\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--ct-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--ct-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: var(--ct-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--ct-list-group-border-width));\n    border-left-width: var(--ct-list-group-border-width);\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--ct-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--ct-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: var(--ct-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--ct-list-group-border-width));\n    border-left-width: var(--ct-list-group-border-width);\n  }\n}\n@media (min-width: 1400px) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--ct-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--ct-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n    border-top-width: var(--ct-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--ct-list-group-border-width));\n    border-left-width: var(--ct-list-group-border-width);\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 var(--ct-list-group-border-width);\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n  --ct-list-group-color: var(--ct-primary-text);\n  --ct-list-group-bg: var(--ct-primary-bg-subtle);\n  --ct-list-group-border-color: var(--ct-primary-border-subtle);\n}\n.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {\n  --ct-list-group-action-hover-color: var(--ct-emphasis-color);\n  --ct-list-group-action-hover-bg: var(--ct-primary-border-subtle);\n}\n.list-group-item-primary.list-group-item-action:active {\n  --ct-list-group-active-color: var(--ct-emphasis-color);\n  --ct-list-group-active-bg: var(--ct-primary-text);\n  --ct-list-group-active-border-color: var(--ct-primary-text);\n}\n\n.list-group-item-secondary {\n  --ct-list-group-color: var(--ct-secondary-text);\n  --ct-list-group-bg: var(--ct-secondary-bg-subtle);\n  --ct-list-group-border-color: var(--ct-secondary-border-subtle);\n}\n.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {\n  --ct-list-group-action-hover-color: var(--ct-emphasis-color);\n  --ct-list-group-action-hover-bg: var(--ct-secondary-border-subtle);\n}\n.list-group-item-secondary.list-group-item-action:active {\n  --ct-list-group-active-color: var(--ct-emphasis-color);\n  --ct-list-group-active-bg: var(--ct-secondary-text);\n  --ct-list-group-active-border-color: var(--ct-secondary-text);\n}\n\n.list-group-item-success {\n  --ct-list-group-color: var(--ct-success-text);\n  --ct-list-group-bg: var(--ct-success-bg-subtle);\n  --ct-list-group-border-color: var(--ct-success-border-subtle);\n}\n.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {\n  --ct-list-group-action-hover-color: var(--ct-emphasis-color);\n  --ct-list-group-action-hover-bg: var(--ct-success-border-subtle);\n}\n.list-group-item-success.list-group-item-action:active {\n  --ct-list-group-active-color: var(--ct-emphasis-color);\n  --ct-list-group-active-bg: var(--ct-success-text);\n  --ct-list-group-active-border-color: var(--ct-success-text);\n}\n\n.list-group-item-info {\n  --ct-list-group-color: var(--ct-info-text);\n  --ct-list-group-bg: var(--ct-info-bg-subtle);\n  --ct-list-group-border-color: var(--ct-info-border-subtle);\n}\n.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {\n  --ct-list-group-action-hover-color: var(--ct-emphasis-color);\n  --ct-list-group-action-hover-bg: var(--ct-info-border-subtle);\n}\n.list-group-item-info.list-group-item-action:active {\n  --ct-list-group-active-color: var(--ct-emphasis-color);\n  --ct-list-group-active-bg: var(--ct-info-text);\n  --ct-list-group-active-border-color: var(--ct-info-text);\n}\n\n.list-group-item-warning {\n  --ct-list-group-color: var(--ct-warning-text);\n  --ct-list-group-bg: var(--ct-warning-bg-subtle);\n  --ct-list-group-border-color: var(--ct-warning-border-subtle);\n}\n.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {\n  --ct-list-group-action-hover-color: var(--ct-emphasis-color);\n  --ct-list-group-action-hover-bg: var(--ct-warning-border-subtle);\n}\n.list-group-item-warning.list-group-item-action:active {\n  --ct-list-group-active-color: var(--ct-emphasis-color);\n  --ct-list-group-active-bg: var(--ct-warning-text);\n  --ct-list-group-active-border-color: var(--ct-warning-text);\n}\n\n.list-group-item-danger {\n  --ct-list-group-color: var(--ct-danger-text);\n  --ct-list-group-bg: var(--ct-danger-bg-subtle);\n  --ct-list-group-border-color: var(--ct-danger-border-subtle);\n}\n.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {\n  --ct-list-group-action-hover-color: var(--ct-emphasis-color);\n  --ct-list-group-action-hover-bg: var(--ct-danger-border-subtle);\n}\n.list-group-item-danger.list-group-item-action:active {\n  --ct-list-group-active-color: var(--ct-emphasis-color);\n  --ct-list-group-active-bg: var(--ct-danger-text);\n  --ct-list-group-active-border-color: var(--ct-danger-text);\n}\n\n.list-group-item-light {\n  --ct-list-group-color: var(--ct-light-text);\n  --ct-list-group-bg: var(--ct-light-bg-subtle);\n  --ct-list-group-border-color: var(--ct-light-border-subtle);\n}\n.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {\n  --ct-list-group-action-hover-color: var(--ct-emphasis-color);\n  --ct-list-group-action-hover-bg: var(--ct-light-border-subtle);\n}\n.list-group-item-light.list-group-item-action:active {\n  --ct-list-group-active-color: var(--ct-emphasis-color);\n  --ct-list-group-active-bg: var(--ct-light-text);\n  --ct-list-group-active-border-color: var(--ct-light-text);\n}\n\n.list-group-item-dark {\n  --ct-list-group-color: var(--ct-dark-text);\n  --ct-list-group-bg: var(--ct-dark-bg-subtle);\n  --ct-list-group-border-color: var(--ct-dark-border-subtle);\n}\n.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {\n  --ct-list-group-action-hover-color: var(--ct-emphasis-color);\n  --ct-list-group-action-hover-bg: var(--ct-dark-border-subtle);\n}\n.list-group-item-dark.list-group-item-action:active {\n  --ct-list-group-active-color: var(--ct-emphasis-color);\n  --ct-list-group-active-bg: var(--ct-dark-text);\n  --ct-list-group-active-border-color: var(--ct-dark-text);\n}\n\n.list-group-item-pink {\n  --ct-list-group-color: var(--ct-pink-text);\n  --ct-list-group-bg: var(--ct-pink-bg-subtle);\n  --ct-list-group-border-color: var(--ct-pink-border-subtle);\n}\n.list-group-item-pink.list-group-item-action:hover, .list-group-item-pink.list-group-item-action:focus {\n  --ct-list-group-action-hover-color: var(--ct-emphasis-color);\n  --ct-list-group-action-hover-bg: var(--ct-pink-border-subtle);\n}\n.list-group-item-pink.list-group-item-action:active {\n  --ct-list-group-active-color: var(--ct-emphasis-color);\n  --ct-list-group-active-bg: var(--ct-pink-text);\n  --ct-list-group-active-border-color: var(--ct-pink-text);\n}\n\n.list-group-item-blue {\n  --ct-list-group-color: var(--ct-blue-text);\n  --ct-list-group-bg: var(--ct-blue-bg-subtle);\n  --ct-list-group-border-color: var(--ct-blue-border-subtle);\n}\n.list-group-item-blue.list-group-item-action:hover, .list-group-item-blue.list-group-item-action:focus {\n  --ct-list-group-action-hover-color: var(--ct-emphasis-color);\n  --ct-list-group-action-hover-bg: var(--ct-blue-border-subtle);\n}\n.list-group-item-blue.list-group-item-action:active {\n  --ct-list-group-active-color: var(--ct-emphasis-color);\n  --ct-list-group-active-bg: var(--ct-blue-text);\n  --ct-list-group-active-border-color: var(--ct-blue-text);\n}\n\n.btn-close {\n  --ct-btn-close-color: #000;\n  --ct-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%238b96a0'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\");\n  --ct-btn-close-opacity: 1;\n  --ct-btn-close-hover-opacity: 0.8;\n  --ct-btn-close-focus-shadow: 0 0 0 0.15rem rgba(102, 88, 221, 0.25);\n  --ct-btn-close-focus-opacity: 1;\n  --ct-btn-close-disabled-opacity: 0.25;\n  --ct-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em 0.25em;\n  color: var(--ct-btn-close-color);\n  background: transparent var(--ct-btn-close-bg) center/1em auto no-repeat;\n  border: 0;\n  border-radius: 0.25rem;\n  opacity: var(--ct-btn-close-opacity);\n}\n.btn-close:hover {\n  color: var(--ct-btn-close-color);\n  text-decoration: none;\n  opacity: var(--ct-btn-close-hover-opacity);\n}\n.btn-close:focus {\n  outline: 0;\n  box-shadow: var(--ct-btn-close-focus-shadow);\n  opacity: var(--ct-btn-close-focus-opacity);\n}\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: var(--ct-btn-close-disabled-opacity);\n}\n\n.btn-close-white {\n  filter: var(--ct-btn-close-white-filter);\n}\n\n[data-bs-theme=dark] .btn-close {\n  filter: var(--ct-btn-close-white-filter);\n}\n\n.toast {\n  --ct-toast-zindex: 1090;\n  --ct-toast-padding-x: 0.75rem;\n  --ct-toast-padding-y: 0.5rem;\n  --ct-toast-spacing: 24px;\n  --ct-toast-max-width: 350px;\n  --ct-toast-font-size: 0.875rem;\n  --ct-toast-color: inherit;\n  --ct-toast-bg: var(--ct-secondary-bg);\n  --ct-toast-border-width: var(--ct-border-width);\n  --ct-toast-border-color: var(--ct-border-color);\n  --ct-toast-border-radius: var(--ct-border-radius);\n  --ct-toast-box-shadow: var(--ct-box-shadow);\n  --ct-toast-header-color: var(--ct-secondary-color);\n  --ct-toast-header-bg: rgba(var(--ct-body-bg-rgb), 0.85);\n  --ct-toast-header-border-color: var(--ct-border-color);\n  width: var(--ct-toast-max-width);\n  max-width: 100%;\n  font-size: var(--ct-toast-font-size);\n  color: var(--ct-toast-color);\n  pointer-events: auto;\n  background-color: var(--ct-toast-bg);\n  background-clip: padding-box;\n  border: var(--ct-toast-border-width) solid var(--ct-toast-border-color);\n  box-shadow: var(--ct-toast-box-shadow);\n  border-radius: var(--ct-toast-border-radius);\n}\n.toast.showing {\n  opacity: 0;\n}\n.toast:not(.show) {\n  display: none;\n}\n\n.toast-container {\n  --ct-toast-zindex: 1090;\n  position: absolute;\n  z-index: var(--ct-toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n.toast-container > :not(:last-child) {\n  margin-bottom: var(--ct-toast-spacing);\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--ct-toast-padding-y) var(--ct-toast-padding-x);\n  color: var(--ct-toast-header-color);\n  background-color: var(--ct-toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--ct-toast-border-width) solid var(--ct-toast-header-border-color);\n  border-top-left-radius: calc(var(--ct-toast-border-radius) - var(--ct-toast-border-width));\n  border-top-right-radius: calc(var(--ct-toast-border-radius) - var(--ct-toast-border-width));\n}\n.toast-header .btn-close {\n  margin-right: calc(-0.5 * var(--ct-toast-padding-x));\n  margin-left: var(--ct-toast-padding-x);\n}\n\n.toast-body {\n  padding: var(--ct-toast-padding-x);\n  word-wrap: break-word;\n}\n\n.modal {\n  --ct-modal-zindex: 1055;\n  --ct-modal-width: 500px;\n  --ct-modal-padding: 1rem;\n  --ct-modal-margin: 0.5rem;\n  --ct-modal-color: ;\n  --ct-modal-bg: var(--ct-secondary-bg);\n  --ct-modal-border-color: var(--ct-border-color-translucent);\n  --ct-modal-border-width: var(--ct-border-width);\n  --ct-modal-border-radius: var(--ct-border-radius-lg);\n  --ct-modal-box-shadow: var(--ct-box-shadow-sm);\n  --ct-modal-inner-border-radius: calc(var(--ct-border-radius-lg) - (var(--ct-border-width)));\n  --ct-modal-header-padding-x: 1rem;\n  --ct-modal-header-padding-y: 1rem;\n  --ct-modal-header-padding: 1rem 1rem;\n  --ct-modal-header-border-color: var(--ct-border-color);\n  --ct-modal-header-border-width: var(--ct-border-width);\n  --ct-modal-title-line-height: 1.5;\n  --ct-modal-footer-gap: 0.5rem;\n  --ct-modal-footer-bg: ;\n  --ct-modal-footer-border-color: var(--ct-border-color);\n  --ct-modal-footer-border-width: var(--ct-border-width);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--ct-modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--ct-modal-margin);\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--ct-modal-margin) * 2);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--ct-modal-margin) * 2);\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: var(--ct-modal-color);\n  pointer-events: auto;\n  background-color: var(--ct-modal-bg);\n  background-clip: padding-box;\n  border: var(--ct-modal-border-width) solid var(--ct-modal-border-color);\n  border-radius: var(--ct-modal-border-radius);\n  outline: 0;\n}\n\n.modal-backdrop {\n  --ct-backdrop-zindex: 1050;\n  --ct-backdrop-bg: #000;\n  --ct-backdrop-opacity: 0.5;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--ct-backdrop-zindex);\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--ct-backdrop-bg);\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: var(--ct-backdrop-opacity);\n}\n\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--ct-modal-header-padding);\n  border-bottom: var(--ct-modal-header-border-width) solid var(--ct-modal-header-border-color);\n  border-top-left-radius: var(--ct-modal-inner-border-radius);\n  border-top-right-radius: var(--ct-modal-inner-border-radius);\n}\n.modal-header .btn-close {\n  padding: calc(var(--ct-modal-header-padding-y) * 0.5) calc(var(--ct-modal-header-padding-x) * 0.5);\n  margin: calc(-0.5 * var(--ct-modal-header-padding-y)) calc(-0.5 * var(--ct-modal-header-padding-x)) calc(-0.5 * var(--ct-modal-header-padding-y)) auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--ct-modal-title-line-height);\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: var(--ct-modal-padding);\n}\n\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: calc(var(--ct-modal-padding) - var(--ct-modal-footer-gap) * 0.5);\n  background-color: var(--ct-modal-footer-bg);\n  border-top: var(--ct-modal-footer-border-width) solid var(--ct-modal-footer-border-color);\n  border-bottom-right-radius: var(--ct-modal-inner-border-radius);\n  border-bottom-left-radius: var(--ct-modal-inner-border-radius);\n}\n.modal-footer > * {\n  margin: calc(var(--ct-modal-footer-gap) * 0.5);\n}\n\n@media (min-width: 576px) {\n  .modal {\n    --ct-modal-margin: 1.75rem;\n    --ct-modal-box-shadow: var(--ct-box-shadow);\n  }\n  .modal-dialog {\n    max-width: var(--ct-modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n  .modal-sm {\n    --ct-modal-width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    --ct-modal-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    --ct-modal-width: 1140px;\n  }\n}\n.modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n.modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n.modal-fullscreen .modal-header,\n.modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n.modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n\n@media (max-width: 575.98px) {\n  .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-header,\n  .modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 767.98px) {\n  .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-header,\n  .modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 991.98px) {\n  .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-header,\n  .modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1199.98px) {\n  .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-header,\n  .modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1399.98px) {\n  .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-header,\n  .modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n.tooltip {\n  --ct-tooltip-zindex: 1080;\n  --ct-tooltip-max-width: 200px;\n  --ct-tooltip-padding-x: 0.8rem;\n  --ct-tooltip-padding-y: 0.4rem;\n  --ct-tooltip-margin: 0;\n  --ct-tooltip-font-size: 0.765625rem;\n  --ct-tooltip-color: #fff;\n  --ct-tooltip-bg: #000;\n  --ct-tooltip-border-radius: 0.2rem;\n  --ct-tooltip-opacity: 0.9;\n  --ct-tooltip-arrow-width: 0.8rem;\n  --ct-tooltip-arrow-height: 0.4rem;\n  z-index: var(--ct-tooltip-zindex);\n  display: block;\n  padding: var(--ct-tooltip-arrow-height);\n  margin: var(--ct-tooltip-margin);\n  font-family: var(--ct-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--ct-tooltip-font-size);\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: var(--ct-tooltip-opacity);\n}\n.tooltip .tooltip-arrow {\n  display: block;\n  width: var(--ct-tooltip-arrow-width);\n  height: var(--ct-tooltip-arrow-height);\n}\n.tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: 0;\n}\n.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: var(--ct-tooltip-arrow-height) calc(var(--ct-tooltip-arrow-width) * 0.5) 0;\n  border-top-color: var(--ct-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: 0;\n  width: var(--ct-tooltip-arrow-height);\n  height: var(--ct-tooltip-arrow-width);\n}\n.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: calc(var(--ct-tooltip-arrow-width) * 0.5) var(--ct-tooltip-arrow-height) calc(var(--ct-tooltip-arrow-width) * 0.5) 0;\n  border-right-color: var(--ct-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: 0;\n}\n.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 calc(var(--ct-tooltip-arrow-width) * 0.5) var(--ct-tooltip-arrow-height);\n  border-bottom-color: var(--ct-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: 0;\n  width: var(--ct-tooltip-arrow-height);\n  height: var(--ct-tooltip-arrow-width);\n}\n.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: calc(var(--ct-tooltip-arrow-width) * 0.5) 0 calc(var(--ct-tooltip-arrow-width) * 0.5) var(--ct-tooltip-arrow-height);\n  border-left-color: var(--ct-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.tooltip-inner {\n  max-width: var(--ct-tooltip-max-width);\n  padding: var(--ct-tooltip-padding-y) var(--ct-tooltip-padding-x);\n  color: var(--ct-tooltip-color);\n  text-align: center;\n  background-color: var(--ct-tooltip-bg);\n  border-radius: var(--ct-tooltip-border-radius);\n}\n\n.popover {\n  --ct-popover-zindex: 1070;\n  --ct-popover-max-width: 276px;\n  --ct-popover-font-size: 0.765625rem;\n  --ct-popover-bg: var(--ct-secondary-bg);\n  --ct-popover-border-width: var(--ct-border-width);\n  --ct-popover-border-color: var(--ct-border-color);\n  --ct-popover-border-radius: var(--ct-border-radius-lg);\n  --ct-popover-inner-border-radius: calc(var(--ct-border-radius-lg) - (var(--ct-border-width)));\n  --ct-popover-box-shadow: var(--ct-box-shadow);\n  --ct-popover-header-padding-x: 0.8rem;\n  --ct-popover-header-padding-y: 0.7rem;\n  --ct-popover-header-font-size: 0.875rem;\n  --ct-popover-header-color: var(--ct-headings-color);\n  --ct-popover-header-bg: var(--ct-secondary-bg);\n  --ct-popover-body-padding-x: 0.75rem;\n  --ct-popover-body-padding-y: 0.5rem;\n  --ct-popover-body-color: var(--ct-body-color);\n  --ct-popover-arrow-width: 1rem;\n  --ct-popover-arrow-height: 0.5rem;\n  --ct-popover-arrow-border: var(--ct-popover-border-color);\n  z-index: var(--ct-popover-zindex);\n  display: block;\n  max-width: var(--ct-popover-max-width);\n  font-family: var(--ct-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--ct-popover-font-size);\n  word-wrap: break-word;\n  background-color: var(--ct-popover-bg);\n  background-clip: padding-box;\n  border: var(--ct-popover-border-width) solid var(--ct-popover-border-color);\n  border-radius: var(--ct-popover-border-radius);\n}\n.popover .popover-arrow {\n  display: block;\n  width: var(--ct-popover-arrow-width);\n  height: var(--ct-popover-arrow-height);\n}\n.popover .popover-arrow::before, .popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n  border-width: 0;\n}\n\n.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {\n  bottom: calc(-1 * (var(--ct-popover-arrow-height)) - var(--ct-popover-border-width));\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  border-width: var(--ct-popover-arrow-height) calc(var(--ct-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  bottom: 0;\n  border-top-color: var(--ct-popover-arrow-border);\n}\n.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  bottom: var(--ct-popover-border-width);\n  border-top-color: var(--ct-popover-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {\n  left: calc(-1 * (var(--ct-popover-arrow-height)) - var(--ct-popover-border-width));\n  width: var(--ct-popover-arrow-height);\n  height: var(--ct-popover-arrow-width);\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  border-width: calc(var(--ct-popover-arrow-width) * 0.5) var(--ct-popover-arrow-height) calc(var(--ct-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  left: 0;\n  border-right-color: var(--ct-popover-arrow-border);\n}\n.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  left: var(--ct-popover-border-width);\n  border-right-color: var(--ct-popover-bg);\n}\n\n/* rtl:end:ignore */\n.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {\n  top: calc(-1 * (var(--ct-popover-arrow-height)) - var(--ct-popover-border-width));\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  border-width: 0 calc(var(--ct-popover-arrow-width) * 0.5) var(--ct-popover-arrow-height);\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  top: 0;\n  border-bottom-color: var(--ct-popover-arrow-border);\n}\n.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  top: var(--ct-popover-border-width);\n  border-bottom-color: var(--ct-popover-bg);\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: var(--ct-popover-arrow-width);\n  margin-left: calc(-0.5 * var(--ct-popover-arrow-width));\n  content: \"\";\n  border-bottom: var(--ct-popover-border-width) solid var(--ct-popover-header-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {\n  right: calc(-1 * (var(--ct-popover-arrow-height)) - var(--ct-popover-border-width));\n  width: var(--ct-popover-arrow-height);\n  height: var(--ct-popover-arrow-width);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  border-width: calc(var(--ct-popover-arrow-width) * 0.5) 0 calc(var(--ct-popover-arrow-width) * 0.5) var(--ct-popover-arrow-height);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  right: 0;\n  border-left-color: var(--ct-popover-arrow-border);\n}\n.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  right: var(--ct-popover-border-width);\n  border-left-color: var(--ct-popover-bg);\n}\n\n/* rtl:end:ignore */\n.popover-header {\n  padding: var(--ct-popover-header-padding-y) var(--ct-popover-header-padding-x);\n  margin-bottom: 0;\n  font-size: var(--ct-popover-header-font-size);\n  color: var(--ct-popover-header-color);\n  background-color: var(--ct-popover-header-bg);\n  border-bottom: var(--ct-popover-border-width) solid var(--ct-popover-border-color);\n  border-top-left-radius: var(--ct-popover-inner-border-radius);\n  border-top-right-radius: var(--ct-popover-inner-border-radius);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: var(--ct-popover-body-padding-y) var(--ct-popover-body-padding-x);\n  color: var(--ct-popover-body-color);\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-start,\n  .carousel-fade .active.carousel-item-end {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #fff;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 15%;\n  list-style: none;\n}\n.carousel-indicators [data-bs-target] {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  padding: 0;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators [data-bs-target] {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 1.25rem;\n  left: 15%;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  color: #fff;\n  text-align: center;\n}\n\n.carousel-dark .carousel-control-prev-icon,\n.carousel-dark .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n.carousel-dark .carousel-indicators [data-bs-target] {\n  background-color: #000;\n}\n.carousel-dark .carousel-caption {\n  color: #000;\n}\n\n[data-bs-theme=dark] .carousel .carousel-control-prev-icon,\n[data-bs-theme=dark] .carousel .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target] {\n  background-color: #000;\n}\n[data-bs-theme=dark] .carousel .carousel-caption {\n  color: #000;\n}\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--ct-spinner-width);\n  height: var(--ct-spinner-height);\n  vertical-align: var(--ct-spinner-vertical-align);\n  border-radius: 50%;\n  animation: var(--ct-spinner-animation-speed) linear infinite var(--ct-spinner-animation-name);\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg) /* rtl:ignore */;\n  }\n}\n.spinner-border {\n  --ct-spinner-width: 2rem;\n  --ct-spinner-height: 2rem;\n  --ct-spinner-vertical-align: -0.125em;\n  --ct-spinner-border-width: 0.25em;\n  --ct-spinner-animation-speed: 0.75s;\n  --ct-spinner-animation-name: spinner-border;\n  border: var(--ct-spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  --ct-spinner-width: 1rem;\n  --ct-spinner-height: 1rem;\n  --ct-spinner-border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  --ct-spinner-width: 2rem;\n  --ct-spinner-height: 2rem;\n  --ct-spinner-vertical-align: -0.125em;\n  --ct-spinner-animation-speed: 0.75s;\n  --ct-spinner-animation-name: spinner-grow;\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --ct-spinner-width: 1rem;\n  --ct-spinner-height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n  .spinner-grow {\n    --ct-spinner-animation-speed: 1.5s;\n  }\n}\n.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {\n  --ct-offcanvas-zindex: 1045;\n  --ct-offcanvas-width: 400px;\n  --ct-offcanvas-height: 30vh;\n  --ct-offcanvas-padding-x: 1rem;\n  --ct-offcanvas-padding-y: 1rem;\n  --ct-offcanvas-color: var(--ct-body-color);\n  --ct-offcanvas-bg: var(--ct-secondary-bg);\n  --ct-offcanvas-border-width: var(--ct-border-width);\n  --ct-offcanvas-border-color: var(--ct-border-color-translucent);\n  --ct-offcanvas-box-shadow: var(--ct-box-shadow-sm);\n  --ct-offcanvas-transition: transform 0.3s ease-in-out;\n  --ct-offcanvas-title-line-height: 1.5;\n}\n\n@media (max-width: 575.98px) {\n  .offcanvas-sm {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--ct-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--ct-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--ct-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--ct-offcanvas-transition);\n  }\n}\n@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-sm {\n    transition: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--ct-offcanvas-width);\n    border-right: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-sm.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--ct-offcanvas-width);\n    border-left: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-sm.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--ct-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-sm.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--ct-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 576px) {\n  .offcanvas-sm {\n    --ct-offcanvas-height: auto;\n    --ct-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-sm .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-sm .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .offcanvas-md {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--ct-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--ct-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--ct-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--ct-offcanvas-transition);\n  }\n}\n@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-md {\n    transition: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--ct-offcanvas-width);\n    border-right: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-md.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--ct-offcanvas-width);\n    border-left: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-md.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--ct-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-md.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--ct-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 768px) {\n  .offcanvas-md {\n    --ct-offcanvas-height: auto;\n    --ct-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-md .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-md .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .offcanvas-lg {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--ct-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--ct-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--ct-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--ct-offcanvas-transition);\n  }\n}\n@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-lg {\n    transition: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--ct-offcanvas-width);\n    border-right: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-lg.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--ct-offcanvas-width);\n    border-left: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-lg.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--ct-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-lg.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--ct-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 992px) {\n  .offcanvas-lg {\n    --ct-offcanvas-height: auto;\n    --ct-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-lg .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-lg .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .offcanvas-xl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--ct-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--ct-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--ct-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--ct-offcanvas-transition);\n  }\n}\n@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xl {\n    transition: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--ct-offcanvas-width);\n    border-right: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--ct-offcanvas-width);\n    border-left: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--ct-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--ct-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .offcanvas-xl {\n    --ct-offcanvas-height: auto;\n    --ct-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--ct-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--ct-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--ct-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--ct-offcanvas-transition);\n  }\n}\n@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xxl {\n    transition: none;\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--ct-offcanvas-width);\n    border-right: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xxl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--ct-offcanvas-width);\n    border-left: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xxl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--ct-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xxl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--ct-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .offcanvas-xxl {\n    --ct-offcanvas-height: auto;\n    --ct-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xxl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xxl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n.offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: var(--ct-offcanvas-zindex);\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  color: var(--ct-offcanvas-color);\n  visibility: hidden;\n  background-color: var(--ct-offcanvas-bg);\n  background-clip: padding-box;\n  outline: 0;\n  transition: var(--ct-offcanvas-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .offcanvas {\n    transition: none;\n  }\n}\n.offcanvas.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: var(--ct-offcanvas-width);\n  border-right: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n  transform: translateX(-100%);\n}\n.offcanvas.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: var(--ct-offcanvas-width);\n  border-left: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n  transform: translateX(100%);\n}\n.offcanvas.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: var(--ct-offcanvas-height);\n  max-height: 100%;\n  border-bottom: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n  transform: translateY(-100%);\n}\n.offcanvas.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: var(--ct-offcanvas-height);\n  max-height: 100%;\n  border-top: var(--ct-offcanvas-border-width) solid var(--ct-offcanvas-border-color);\n  transform: translateY(100%);\n}\n.offcanvas.showing, .offcanvas.show:not(.hiding) {\n  transform: none;\n}\n.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {\n  visibility: visible;\n}\n\n.offcanvas-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n}\n.offcanvas-backdrop.fade {\n  opacity: 0;\n}\n.offcanvas-backdrop.show {\n  opacity: 0.5;\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--ct-offcanvas-padding-y) var(--ct-offcanvas-padding-x);\n}\n.offcanvas-header .btn-close {\n  padding: calc(var(--ct-offcanvas-padding-y) * 0.5) calc(var(--ct-offcanvas-padding-x) * 0.5);\n  margin-top: calc(-0.5 * var(--ct-offcanvas-padding-y));\n  margin-right: calc(-0.5 * var(--ct-offcanvas-padding-x));\n  margin-bottom: calc(-0.5 * var(--ct-offcanvas-padding-y));\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--ct-offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--ct-offcanvas-padding-y) var(--ct-offcanvas-padding-x);\n  overflow-y: auto;\n}\n\n.placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: 0.5;\n}\n.placeholder.btn::before {\n  display: inline-block;\n  content: \"\";\n}\n\n.placeholder-xs {\n  min-height: 0.6em;\n}\n\n.placeholder-sm {\n  min-height: 0.8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n.placeholder-glow .placeholder {\n  animation: placeholder-glow 2s ease-in-out infinite;\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: 0.2;\n  }\n}\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.text-bg-primary {\n  color: #fff !important;\n  background-color: RGBA(102, 88, 221, var(--ct-bg-opacity, 1)) !important;\n}\n\n.text-bg-secondary {\n  color: #fff !important;\n  background-color: RGBA(108, 117, 125, var(--ct-bg-opacity, 1)) !important;\n}\n\n.text-bg-success {\n  color: #fff !important;\n  background-color: RGBA(26, 188, 156, var(--ct-bg-opacity, 1)) !important;\n}\n\n.text-bg-info {\n  color: #fff !important;\n  background-color: RGBA(67, 191, 229, var(--ct-bg-opacity, 1)) !important;\n}\n\n.text-bg-warning {\n  color: #323a46 !important;\n  background-color: RGBA(247, 184, 75, var(--ct-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger {\n  color: #fff !important;\n  background-color: RGBA(241, 85, 108, var(--ct-bg-opacity, 1)) !important;\n}\n\n.text-bg-light {\n  color: #323a46 !important;\n  background-color: RGBA(243, 247, 249, var(--ct-bg-opacity, 1)) !important;\n}\n\n.text-bg-dark {\n  color: #fff !important;\n  background-color: RGBA(50, 58, 70, var(--ct-bg-opacity, 1)) !important;\n}\n\n.text-bg-pink {\n  color: #fff !important;\n  background-color: RGBA(246, 114, 167, var(--ct-bg-opacity, 1)) !important;\n}\n\n.text-bg-blue {\n  color: #fff !important;\n  background-color: RGBA(74, 129, 212, var(--ct-bg-opacity, 1)) !important;\n}\n\n.link-primary {\n  color: #6658dd !important;\n}\n.link-primary:hover, .link-primary:focus {\n  color: rgb(86.7, 74.8, 187.85) !important;\n}\n\n.link-secondary {\n  color: #6c757d !important;\n}\n.link-secondary:hover, .link-secondary:focus {\n  color: rgb(91.8, 99.45, 106.25) !important;\n}\n\n.link-success {\n  color: #1abc9c !important;\n}\n.link-success:hover, .link-success:focus {\n  color: rgb(22.1, 159.8, 132.6) !important;\n}\n\n.link-info {\n  color: #43bfe5 !important;\n}\n.link-info:hover, .link-info:focus {\n  color: rgb(56.95, 162.35, 194.65) !important;\n}\n\n.link-warning {\n  color: #f7b84b !important;\n}\n.link-warning:hover, .link-warning:focus {\n  color: rgb(248.2, 194.65, 102) !important;\n}\n\n.link-danger {\n  color: #f1556c !important;\n}\n.link-danger:hover, .link-danger:focus {\n  color: rgb(204.85, 72.25, 91.8) !important;\n}\n\n.link-light {\n  color: #f3f7f9 !important;\n}\n.link-light:hover, .link-light:focus {\n  color: rgb(244.8, 248.2, 249.9) !important;\n}\n\n.link-dark {\n  color: #323a46 !important;\n}\n.link-dark:hover, .link-dark:focus {\n  color: rgb(42.5, 49.3, 59.5) !important;\n}\n\n.link-pink {\n  color: #f672a7 !important;\n}\n.link-pink:hover, .link-pink:focus {\n  color: rgb(209.1, 96.9, 141.95) !important;\n}\n\n.link-blue {\n  color: #4a81d4 !important;\n}\n.link-blue:hover, .link-blue:focus {\n  color: rgb(62.9, 109.65, 180.2) !important;\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--ct-aspect-ratio);\n  content: \"\";\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --ct-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --ct-aspect-ratio: 75%;\n}\n\n.ratio-16x9 {\n  --ct-aspect-ratio: 56.25%;\n}\n\n.ratio-21x9 {\n  --ct-aspect-ratio: 42.8571428571%;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n.sticky-bottom {\n  position: sticky;\n  bottom: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-sm-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-md-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-lg-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1400px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xxl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: 1px;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: 0.25;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.object-fit-contain {\n  object-fit: contain !important;\n}\n\n.object-fit-cover {\n  object-fit: cover !important;\n}\n\n.object-fit-fill {\n  object-fit: fill !important;\n}\n\n.object-fit-scale {\n  object-fit: scale-down !important;\n}\n\n.object-fit-none {\n  object-fit: none !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.overflow-x-auto {\n  overflow-x: auto !important;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden !important;\n}\n\n.overflow-x-visible {\n  overflow-x: visible !important;\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll !important;\n}\n\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden !important;\n}\n\n.overflow-y-visible {\n  overflow-y: visible !important;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: var(--ct-box-shadow) !important;\n}\n\n.shadow-sm {\n  box-shadow: var(--ct-box-shadow-sm) !important;\n}\n\n.shadow-lg {\n  box-shadow: var(--ct-box-shadow-lg) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: var(--ct-border-width) var(--ct-border-style) var(--ct-border-color) !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: var(--ct-border-width) var(--ct-border-style) var(--ct-border-color) !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: var(--ct-border-width) var(--ct-border-style) var(--ct-border-color) !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: var(--ct-border-width) var(--ct-border-style) var(--ct-border-color) !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: var(--ct-border-width) var(--ct-border-style) var(--ct-border-color) !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  --ct-border-opacity: 1;\n  border-color: rgba(var(--ct-primary-rgb), var(--ct-border-opacity)) !important;\n}\n\n.border-secondary {\n  --ct-border-opacity: 1;\n  border-color: rgba(var(--ct-secondary-rgb), var(--ct-border-opacity)) !important;\n}\n\n.border-success {\n  --ct-border-opacity: 1;\n  border-color: rgba(var(--ct-success-rgb), var(--ct-border-opacity)) !important;\n}\n\n.border-info {\n  --ct-border-opacity: 1;\n  border-color: rgba(var(--ct-info-rgb), var(--ct-border-opacity)) !important;\n}\n\n.border-warning {\n  --ct-border-opacity: 1;\n  border-color: rgba(var(--ct-warning-rgb), var(--ct-border-opacity)) !important;\n}\n\n.border-danger {\n  --ct-border-opacity: 1;\n  border-color: rgba(var(--ct-danger-rgb), var(--ct-border-opacity)) !important;\n}\n\n.border-light {\n  --ct-border-opacity: 1;\n  border-color: rgba(var(--ct-light-rgb), var(--ct-border-opacity)) !important;\n}\n\n.border-dark {\n  --ct-border-opacity: 1;\n  border-color: rgba(var(--ct-dark-rgb), var(--ct-border-opacity)) !important;\n}\n\n.border-pink {\n  --ct-border-opacity: 1;\n  border-color: rgba(var(--ct-pink-rgb), var(--ct-border-opacity)) !important;\n}\n\n.border-blue {\n  --ct-border-opacity: 1;\n  border-color: rgba(var(--ct-blue-rgb), var(--ct-border-opacity)) !important;\n}\n\n.border-white {\n  --ct-border-opacity: 1;\n  border-color: rgba(var(--ct-white-rgb), var(--ct-border-opacity)) !important;\n}\n\n.border-primary-subtle {\n  border-color: var(--ct-primary-border-subtle) !important;\n}\n\n.border-secondary-subtle {\n  border-color: var(--ct-secondary-border-subtle) !important;\n}\n\n.border-success-subtle {\n  border-color: var(--ct-success-border-subtle) !important;\n}\n\n.border-info-subtle {\n  border-color: var(--ct-info-border-subtle) !important;\n}\n\n.border-warning-subtle {\n  border-color: var(--ct-warning-border-subtle) !important;\n}\n\n.border-danger-subtle {\n  border-color: var(--ct-danger-border-subtle) !important;\n}\n\n.border-light-subtle {\n  border-color: var(--ct-light-border-subtle) !important;\n}\n\n.border-dark-subtle {\n  border-color: var(--ct-dark-border-subtle) !important;\n}\n\n.border-0 {\n  --ct-border-width: 0;\n}\n\n.border-1 {\n  --ct-border-width: 1px;\n}\n\n.border-2 {\n  --ct-border-width: 2px;\n}\n\n.border-3 {\n  --ct-border-width: 3px;\n}\n\n.border-4 {\n  --ct-border-width: 4px;\n}\n\n.border-5 {\n  --ct-border-width: 5px;\n}\n\n.border-opacity-10 {\n  --ct-border-opacity: 0.1;\n}\n\n.border-opacity-25 {\n  --ct-border-opacity: 0.25;\n}\n\n.border-opacity-50 {\n  --ct-border-opacity: 0.5;\n}\n\n.border-opacity-75 {\n  --ct-border-opacity: 0.75;\n}\n\n.border-opacity-100 {\n  --ct-border-opacity: 1;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.375rem !important;\n}\n\n.m-2 {\n  margin: 0.75rem !important;\n}\n\n.m-3 {\n  margin: 1.5rem !important;\n}\n\n.m-4 {\n  margin: 2.25rem !important;\n}\n\n.m-5 {\n  margin: 4.5rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.375rem !important;\n  margin-left: 0.375rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.75rem !important;\n  margin-left: 0.75rem !important;\n}\n\n.mx-3 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-4 {\n  margin-right: 2.25rem !important;\n  margin-left: 2.25rem !important;\n}\n\n.mx-5 {\n  margin-right: 4.5rem !important;\n  margin-left: 4.5rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.375rem !important;\n  margin-bottom: 0.375rem !important;\n}\n\n.my-2 {\n  margin-top: 0.75rem !important;\n  margin-bottom: 0.75rem !important;\n}\n\n.my-3 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-4 {\n  margin-top: 2.25rem !important;\n  margin-bottom: 2.25rem !important;\n}\n\n.my-5 {\n  margin-top: 4.5rem !important;\n  margin-bottom: 4.5rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.375rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.75rem !important;\n}\n\n.mt-3 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-4 {\n  margin-top: 2.25rem !important;\n}\n\n.mt-5 {\n  margin-top: 4.5rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-1 {\n  margin-right: 0.375rem !important;\n}\n\n.me-2 {\n  margin-right: 0.75rem !important;\n}\n\n.me-3 {\n  margin-right: 1.5rem !important;\n}\n\n.me-4 {\n  margin-right: 2.25rem !important;\n}\n\n.me-5 {\n  margin-right: 4.5rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.375rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.75rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 2.25rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 4.5rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-1 {\n  margin-left: 0.375rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.75rem !important;\n}\n\n.ms-3 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-4 {\n  margin-left: 2.25rem !important;\n}\n\n.ms-5 {\n  margin-left: 4.5rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.m-n1 {\n  margin: -0.375rem !important;\n}\n\n.m-n2 {\n  margin: -0.75rem !important;\n}\n\n.m-n3 {\n  margin: -1.5rem !important;\n}\n\n.m-n4 {\n  margin: -2.25rem !important;\n}\n\n.m-n5 {\n  margin: -4.5rem !important;\n}\n\n.mx-n1 {\n  margin-right: -0.375rem !important;\n  margin-left: -0.375rem !important;\n}\n\n.mx-n2 {\n  margin-right: -0.75rem !important;\n  margin-left: -0.75rem !important;\n}\n\n.mx-n3 {\n  margin-right: -1.5rem !important;\n  margin-left: -1.5rem !important;\n}\n\n.mx-n4 {\n  margin-right: -2.25rem !important;\n  margin-left: -2.25rem !important;\n}\n\n.mx-n5 {\n  margin-right: -4.5rem !important;\n  margin-left: -4.5rem !important;\n}\n\n.my-n1 {\n  margin-top: -0.375rem !important;\n  margin-bottom: -0.375rem !important;\n}\n\n.my-n2 {\n  margin-top: -0.75rem !important;\n  margin-bottom: -0.75rem !important;\n}\n\n.my-n3 {\n  margin-top: -1.5rem !important;\n  margin-bottom: -1.5rem !important;\n}\n\n.my-n4 {\n  margin-top: -2.25rem !important;\n  margin-bottom: -2.25rem !important;\n}\n\n.my-n5 {\n  margin-top: -4.5rem !important;\n  margin-bottom: -4.5rem !important;\n}\n\n.mt-n1 {\n  margin-top: -0.375rem !important;\n}\n\n.mt-n2 {\n  margin-top: -0.75rem !important;\n}\n\n.mt-n3 {\n  margin-top: -1.5rem !important;\n}\n\n.mt-n4 {\n  margin-top: -2.25rem !important;\n}\n\n.mt-n5 {\n  margin-top: -4.5rem !important;\n}\n\n.me-n1 {\n  margin-right: -0.375rem !important;\n}\n\n.me-n2 {\n  margin-right: -0.75rem !important;\n}\n\n.me-n3 {\n  margin-right: -1.5rem !important;\n}\n\n.me-n4 {\n  margin-right: -2.25rem !important;\n}\n\n.me-n5 {\n  margin-right: -4.5rem !important;\n}\n\n.mb-n1 {\n  margin-bottom: -0.375rem !important;\n}\n\n.mb-n2 {\n  margin-bottom: -0.75rem !important;\n}\n\n.mb-n3 {\n  margin-bottom: -1.5rem !important;\n}\n\n.mb-n4 {\n  margin-bottom: -2.25rem !important;\n}\n\n.mb-n5 {\n  margin-bottom: -4.5rem !important;\n}\n\n.ms-n1 {\n  margin-left: -0.375rem !important;\n}\n\n.ms-n2 {\n  margin-left: -0.75rem !important;\n}\n\n.ms-n3 {\n  margin-left: -1.5rem !important;\n}\n\n.ms-n4 {\n  margin-left: -2.25rem !important;\n}\n\n.ms-n5 {\n  margin-left: -4.5rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.375rem !important;\n}\n\n.p-2 {\n  padding: 0.75rem !important;\n}\n\n.p-3 {\n  padding: 1.5rem !important;\n}\n\n.p-4 {\n  padding: 2.25rem !important;\n}\n\n.p-5 {\n  padding: 4.5rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.375rem !important;\n  padding-left: 0.375rem !important;\n}\n\n.px-2 {\n  padding-right: 0.75rem !important;\n  padding-left: 0.75rem !important;\n}\n\n.px-3 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-4 {\n  padding-right: 2.25rem !important;\n  padding-left: 2.25rem !important;\n}\n\n.px-5 {\n  padding-right: 4.5rem !important;\n  padding-left: 4.5rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.375rem !important;\n  padding-bottom: 0.375rem !important;\n}\n\n.py-2 {\n  padding-top: 0.75rem !important;\n  padding-bottom: 0.75rem !important;\n}\n\n.py-3 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-4 {\n  padding-top: 2.25rem !important;\n  padding-bottom: 2.25rem !important;\n}\n\n.py-5 {\n  padding-top: 4.5rem !important;\n  padding-bottom: 4.5rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.375rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.75rem !important;\n}\n\n.pt-3 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-4 {\n  padding-top: 2.25rem !important;\n}\n\n.pt-5 {\n  padding-top: 4.5rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-1 {\n  padding-right: 0.375rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.75rem !important;\n}\n\n.pe-3 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-4 {\n  padding-right: 2.25rem !important;\n}\n\n.pe-5 {\n  padding-right: 4.5rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.375rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.75rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 2.25rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 4.5rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-1 {\n  padding-left: 0.375rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.75rem !important;\n}\n\n.ps-3 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-4 {\n  padding-left: 2.25rem !important;\n}\n\n.ps-5 {\n  padding-left: 4.5rem !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-1 {\n  gap: 0.375rem !important;\n}\n\n.gap-2 {\n  gap: 0.75rem !important;\n}\n\n.gap-3 {\n  gap: 1.5rem !important;\n}\n\n.gap-4 {\n  gap: 2.25rem !important;\n}\n\n.gap-5 {\n  gap: 4.5rem !important;\n}\n\n.row-gap-0 {\n  row-gap: 0 !important;\n}\n\n.row-gap-1 {\n  row-gap: 0.375rem !important;\n}\n\n.row-gap-2 {\n  row-gap: 0.75rem !important;\n}\n\n.row-gap-3 {\n  row-gap: 1.5rem !important;\n}\n\n.row-gap-4 {\n  row-gap: 2.25rem !important;\n}\n\n.row-gap-5 {\n  row-gap: 4.5rem !important;\n}\n\n.column-gap-0 {\n  column-gap: 0 !important;\n}\n\n.column-gap-1 {\n  column-gap: 0.375rem !important;\n}\n\n.column-gap-2 {\n  column-gap: 0.75rem !important;\n}\n\n.column-gap-3 {\n  column-gap: 1.5rem !important;\n}\n\n.column-gap-4 {\n  column-gap: 2.25rem !important;\n}\n\n.column-gap-5 {\n  column-gap: 4.5rem !important;\n}\n\n.font-monospace {\n  font-family: var(--ct-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.35rem + 1.2vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.3125rem + 0.75vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.275rem + 0.3vw) !important;\n}\n\n.fs-4 {\n  font-size: 1.125rem !important;\n}\n\n.fs-5 {\n  font-size: 0.9375rem !important;\n}\n\n.fs-6 {\n  font-size: 0.75rem !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-medium {\n  font-weight: 500 !important;\n}\n\n.fw-semibold {\n  font-weight: 600 !important;\n}\n\n.fw-bold {\n  font-weight: 700 !important;\n}\n\n.fw-bolder {\n  font-weight: bolder !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1.25 !important;\n}\n\n.lh-base {\n  line-height: 1.5 !important;\n}\n\n.lh-lg {\n  line-height: 2 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-primary {\n  --ct-text-opacity: 1;\n  color: rgba(var(--ct-primary-rgb), var(--ct-text-opacity)) !important;\n}\n\n.text-secondary {\n  --ct-text-opacity: 1;\n  color: rgba(var(--ct-secondary-rgb), var(--ct-text-opacity)) !important;\n}\n\n.text-success {\n  --ct-text-opacity: 1;\n  color: rgba(var(--ct-success-rgb), var(--ct-text-opacity)) !important;\n}\n\n.text-info {\n  --ct-text-opacity: 1;\n  color: rgba(var(--ct-info-rgb), var(--ct-text-opacity)) !important;\n}\n\n.text-warning {\n  --ct-text-opacity: 1;\n  color: rgba(var(--ct-warning-rgb), var(--ct-text-opacity)) !important;\n}\n\n.text-danger {\n  --ct-text-opacity: 1;\n  color: rgba(var(--ct-danger-rgb), var(--ct-text-opacity)) !important;\n}\n\n.text-light {\n  --ct-text-opacity: 1;\n  color: rgba(var(--ct-light-rgb), var(--ct-text-opacity)) !important;\n}\n\n.text-dark {\n  --ct-text-opacity: 1;\n  color: rgba(var(--ct-dark-rgb), var(--ct-text-opacity)) !important;\n}\n\n.text-pink {\n  --ct-text-opacity: 1;\n  color: rgba(var(--ct-pink-rgb), var(--ct-text-opacity)) !important;\n}\n\n.text-blue {\n  --ct-text-opacity: 1;\n  color: rgba(var(--ct-blue-rgb), var(--ct-text-opacity)) !important;\n}\n\n.text-black {\n  --ct-text-opacity: 1;\n  color: rgba(var(--ct-black-rgb), var(--ct-text-opacity)) !important;\n}\n\n.text-white {\n  --ct-text-opacity: 1;\n  color: rgba(var(--ct-white-rgb), var(--ct-text-opacity)) !important;\n}\n\n.text-body {\n  --ct-text-opacity: 1;\n  color: rgba(var(--ct-body-color-rgb), var(--ct-text-opacity)) !important;\n}\n\n.text-muted {\n  --ct-text-opacity: 1;\n  color: var(--ct-gray) !important;\n}\n\n.text-black-50 {\n  --ct-text-opacity: 1;\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  --ct-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-body-secondary {\n  --ct-text-opacity: 1;\n  color: var(--ct-secondary-color) !important;\n}\n\n.text-body-tertiary {\n  --ct-text-opacity: 1;\n  color: var(--ct-tertiary-color) !important;\n}\n\n.text-body-emphasis {\n  --ct-text-opacity: 1;\n  color: var(--ct-emphasis-color) !important;\n}\n\n.text-reset {\n  --ct-text-opacity: 1;\n  color: inherit !important;\n}\n\n.text-opacity-25 {\n  --ct-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --ct-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --ct-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --ct-text-opacity: 1;\n}\n\n.text-primary-emphasis {\n  color: var(--ct-primary-text) !important;\n}\n\n.text-secondary-emphasis {\n  color: var(--ct-secondary-text) !important;\n}\n\n.text-success-emphasis {\n  color: var(--ct-success-text) !important;\n}\n\n.text-info-emphasis {\n  color: var(--ct-info-text) !important;\n}\n\n.text-warning-emphasis {\n  color: var(--ct-warning-text) !important;\n}\n\n.text-danger-emphasis {\n  color: var(--ct-danger-text) !important;\n}\n\n.text-light-emphasis {\n  color: var(--ct-light-text) !important;\n}\n\n.text-dark-emphasis {\n  color: var(--ct-dark-text) !important;\n}\n\n.bg-primary {\n  --ct-bg-opacity: 1;\n  background-color: rgba(var(--ct-primary-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-secondary {\n  --ct-bg-opacity: 1;\n  background-color: rgba(var(--ct-secondary-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-success {\n  --ct-bg-opacity: 1;\n  background-color: rgba(var(--ct-success-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-info {\n  --ct-bg-opacity: 1;\n  background-color: rgba(var(--ct-info-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-warning {\n  --ct-bg-opacity: 1;\n  background-color: rgba(var(--ct-warning-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-danger {\n  --ct-bg-opacity: 1;\n  background-color: rgba(var(--ct-danger-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-light {\n  --ct-bg-opacity: 1;\n  background-color: rgba(var(--ct-light-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-dark {\n  --ct-bg-opacity: 1;\n  background-color: rgba(var(--ct-dark-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-pink {\n  --ct-bg-opacity: 1;\n  background-color: rgba(var(--ct-pink-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-blue {\n  --ct-bg-opacity: 1;\n  background-color: rgba(var(--ct-blue-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-black {\n  --ct-bg-opacity: 1;\n  background-color: rgba(var(--ct-black-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-white {\n  --ct-bg-opacity: 1;\n  background-color: rgba(var(--ct-white-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-body {\n  --ct-bg-opacity: 1;\n  background-color: rgba(var(--ct-body-bg-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-transparent {\n  --ct-bg-opacity: 1;\n  background-color: transparent !important;\n}\n\n.bg-body-secondary {\n  --ct-bg-opacity: 1;\n  background-color: rgba(var(--ct-secondary-bg-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-body-tertiary {\n  --ct-bg-opacity: 1;\n  background-color: rgba(var(--ct-tertiary-bg-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-body-emphasis {\n  --ct-bg-opacity: 1;\n  background-color: rgba(var(--ct-emphasis-bg-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-opacity-10 {\n  --ct-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --ct-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --ct-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --ct-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --ct-bg-opacity: 1;\n}\n\n.bg-primary-subtle {\n  background-color: var(--ct-primary-bg-subtle) !important;\n}\n\n.bg-secondary-subtle {\n  background-color: var(--ct-secondary-bg-subtle) !important;\n}\n\n.bg-success-subtle {\n  background-color: var(--ct-success-bg-subtle) !important;\n}\n\n.bg-info-subtle {\n  background-color: var(--ct-info-bg-subtle) !important;\n}\n\n.bg-warning-subtle {\n  background-color: var(--ct-warning-bg-subtle) !important;\n}\n\n.bg-danger-subtle {\n  background-color: var(--ct-danger-bg-subtle) !important;\n}\n\n.bg-light-subtle {\n  background-color: var(--ct-light-bg-subtle) !important;\n}\n\n.bg-dark-subtle {\n  background-color: var(--ct-dark-bg-subtle) !important;\n}\n\n.bg-gradient {\n  background-image: var(--ct-gradient) !important;\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: var(--ct-border-radius) !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: var(--ct-border-radius-sm) !important;\n}\n\n.rounded-2 {\n  border-radius: var(--ct-border-radius) !important;\n}\n\n.rounded-3 {\n  border-radius: var(--ct-border-radius-lg) !important;\n}\n\n.rounded-4 {\n  border-radius: var(--ct-border-radius-xl) !important;\n}\n\n.rounded-5 {\n  border-radius: var(--ct-border-radius-2xl) !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: var(--ct-border-radius-pill) !important;\n}\n\n.rounded-top {\n  border-top-left-radius: var(--ct-border-radius) !important;\n  border-top-right-radius: var(--ct-border-radius) !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-top-1 {\n  border-top-left-radius: var(--ct-border-radius-sm) !important;\n  border-top-right-radius: var(--ct-border-radius-sm) !important;\n}\n\n.rounded-top-2 {\n  border-top-left-radius: var(--ct-border-radius) !important;\n  border-top-right-radius: var(--ct-border-radius) !important;\n}\n\n.rounded-top-3 {\n  border-top-left-radius: var(--ct-border-radius-lg) !important;\n  border-top-right-radius: var(--ct-border-radius-lg) !important;\n}\n\n.rounded-top-4 {\n  border-top-left-radius: var(--ct-border-radius-xl) !important;\n  border-top-right-radius: var(--ct-border-radius-xl) !important;\n}\n\n.rounded-top-5 {\n  border-top-left-radius: var(--ct-border-radius-2xl) !important;\n  border-top-right-radius: var(--ct-border-radius-2xl) !important;\n}\n\n.rounded-top-circle {\n  border-top-left-radius: 50% !important;\n  border-top-right-radius: 50% !important;\n}\n\n.rounded-top-pill {\n  border-top-left-radius: var(--ct-border-radius-pill) !important;\n  border-top-right-radius: var(--ct-border-radius-pill) !important;\n}\n\n.rounded-end {\n  border-top-right-radius: var(--ct-border-radius) !important;\n  border-bottom-right-radius: var(--ct-border-radius) !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-end-1 {\n  border-top-right-radius: var(--ct-border-radius-sm) !important;\n  border-bottom-right-radius: var(--ct-border-radius-sm) !important;\n}\n\n.rounded-end-2 {\n  border-top-right-radius: var(--ct-border-radius) !important;\n  border-bottom-right-radius: var(--ct-border-radius) !important;\n}\n\n.rounded-end-3 {\n  border-top-right-radius: var(--ct-border-radius-lg) !important;\n  border-bottom-right-radius: var(--ct-border-radius-lg) !important;\n}\n\n.rounded-end-4 {\n  border-top-right-radius: var(--ct-border-radius-xl) !important;\n  border-bottom-right-radius: var(--ct-border-radius-xl) !important;\n}\n\n.rounded-end-5 {\n  border-top-right-radius: var(--ct-border-radius-2xl) !important;\n  border-bottom-right-radius: var(--ct-border-radius-2xl) !important;\n}\n\n.rounded-end-circle {\n  border-top-right-radius: 50% !important;\n  border-bottom-right-radius: 50% !important;\n}\n\n.rounded-end-pill {\n  border-top-right-radius: var(--ct-border-radius-pill) !important;\n  border-bottom-right-radius: var(--ct-border-radius-pill) !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: var(--ct-border-radius) !important;\n  border-bottom-left-radius: var(--ct-border-radius) !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-bottom-1 {\n  border-bottom-right-radius: var(--ct-border-radius-sm) !important;\n  border-bottom-left-radius: var(--ct-border-radius-sm) !important;\n}\n\n.rounded-bottom-2 {\n  border-bottom-right-radius: var(--ct-border-radius) !important;\n  border-bottom-left-radius: var(--ct-border-radius) !important;\n}\n\n.rounded-bottom-3 {\n  border-bottom-right-radius: var(--ct-border-radius-lg) !important;\n  border-bottom-left-radius: var(--ct-border-radius-lg) !important;\n}\n\n.rounded-bottom-4 {\n  border-bottom-right-radius: var(--ct-border-radius-xl) !important;\n  border-bottom-left-radius: var(--ct-border-radius-xl) !important;\n}\n\n.rounded-bottom-5 {\n  border-bottom-right-radius: var(--ct-border-radius-2xl) !important;\n  border-bottom-left-radius: var(--ct-border-radius-2xl) !important;\n}\n\n.rounded-bottom-circle {\n  border-bottom-right-radius: 50% !important;\n  border-bottom-left-radius: 50% !important;\n}\n\n.rounded-bottom-pill {\n  border-bottom-right-radius: var(--ct-border-radius-pill) !important;\n  border-bottom-left-radius: var(--ct-border-radius-pill) !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: var(--ct-border-radius) !important;\n  border-top-left-radius: var(--ct-border-radius) !important;\n}\n\n.rounded-start-0 {\n  border-bottom-left-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n}\n\n.rounded-start-1 {\n  border-bottom-left-radius: var(--ct-border-radius-sm) !important;\n  border-top-left-radius: var(--ct-border-radius-sm) !important;\n}\n\n.rounded-start-2 {\n  border-bottom-left-radius: var(--ct-border-radius) !important;\n  border-top-left-radius: var(--ct-border-radius) !important;\n}\n\n.rounded-start-3 {\n  border-bottom-left-radius: var(--ct-border-radius-lg) !important;\n  border-top-left-radius: var(--ct-border-radius-lg) !important;\n}\n\n.rounded-start-4 {\n  border-bottom-left-radius: var(--ct-border-radius-xl) !important;\n  border-top-left-radius: var(--ct-border-radius-xl) !important;\n}\n\n.rounded-start-5 {\n  border-bottom-left-radius: var(--ct-border-radius-2xl) !important;\n  border-top-left-radius: var(--ct-border-radius-2xl) !important;\n}\n\n.rounded-start-circle {\n  border-bottom-left-radius: 50% !important;\n  border-top-left-radius: 50% !important;\n}\n\n.rounded-start-pill {\n  border-bottom-left-radius: var(--ct-border-radius-pill) !important;\n  border-top-left-radius: var(--ct-border-radius-pill) !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n.z-n1 {\n  z-index: -1 !important;\n}\n\n.z-0 {\n  z-index: 0 !important;\n}\n\n.z-1 {\n  z-index: 1 !important;\n}\n\n.z-2 {\n  z-index: 2 !important;\n}\n\n.z-3 {\n  z-index: 3 !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n  .float-sm-end {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n  .object-fit-sm-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-sm-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-sm-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-sm-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-sm-none {\n    object-fit: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-grid {\n    display: grid !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-sm-none {\n    display: none !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .order-sm-first {\n    order: -1 !important;\n  }\n  .order-sm-0 {\n    order: 0 !important;\n  }\n  .order-sm-1 {\n    order: 1 !important;\n  }\n  .order-sm-2 {\n    order: 2 !important;\n  }\n  .order-sm-3 {\n    order: 3 !important;\n  }\n  .order-sm-4 {\n    order: 4 !important;\n  }\n  .order-sm-5 {\n    order: 5 !important;\n  }\n  .order-sm-last {\n    order: 6 !important;\n  }\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.375rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.75rem !important;\n  }\n  .m-sm-3 {\n    margin: 1.5rem !important;\n  }\n  .m-sm-4 {\n    margin: 2.25rem !important;\n  }\n  .m-sm-5 {\n    margin: 4.5rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-sm-1 {\n    margin-right: 0.375rem !important;\n    margin-left: 0.375rem !important;\n  }\n  .mx-sm-2 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-sm-3 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-sm-4 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-sm-5 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-sm-1 {\n    margin-top: 0.375rem !important;\n    margin-bottom: 0.375rem !important;\n  }\n  .my-sm-2 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-sm-3 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-sm-4 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-sm-5 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mt-sm-1 {\n    margin-top: 0.375rem !important;\n  }\n  .mt-sm-2 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-sm-3 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-sm-4 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-sm-5 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n  .me-sm-1 {\n    margin-right: 0.375rem !important;\n  }\n  .me-sm-2 {\n    margin-right: 0.75rem !important;\n  }\n  .me-sm-3 {\n    margin-right: 1.5rem !important;\n  }\n  .me-sm-4 {\n    margin-right: 2.25rem !important;\n  }\n  .me-sm-5 {\n    margin-right: 4.5rem !important;\n  }\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-sm-1 {\n    margin-bottom: 0.375rem !important;\n  }\n  .mb-sm-2 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-sm-3 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-sm-4 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-sm-5 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n  .ms-sm-1 {\n    margin-left: 0.375rem !important;\n  }\n  .ms-sm-2 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-sm-3 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-sm-4 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-sm-5 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n  .m-sm-n1 {\n    margin: -0.375rem !important;\n  }\n  .m-sm-n2 {\n    margin: -0.75rem !important;\n  }\n  .m-sm-n3 {\n    margin: -1.5rem !important;\n  }\n  .m-sm-n4 {\n    margin: -2.25rem !important;\n  }\n  .m-sm-n5 {\n    margin: -4.5rem !important;\n  }\n  .mx-sm-n1 {\n    margin-right: -0.375rem !important;\n    margin-left: -0.375rem !important;\n  }\n  .mx-sm-n2 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-sm-n3 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-sm-n4 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-sm-n5 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .my-sm-n1 {\n    margin-top: -0.375rem !important;\n    margin-bottom: -0.375rem !important;\n  }\n  .my-sm-n2 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-sm-n3 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-sm-n4 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-sm-n5 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .mt-sm-n1 {\n    margin-top: -0.375rem !important;\n  }\n  .mt-sm-n2 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-sm-n3 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-sm-n4 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-sm-n5 {\n    margin-top: -4.5rem !important;\n  }\n  .me-sm-n1 {\n    margin-right: -0.375rem !important;\n  }\n  .me-sm-n2 {\n    margin-right: -0.75rem !important;\n  }\n  .me-sm-n3 {\n    margin-right: -1.5rem !important;\n  }\n  .me-sm-n4 {\n    margin-right: -2.25rem !important;\n  }\n  .me-sm-n5 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-sm-n1 {\n    margin-bottom: -0.375rem !important;\n  }\n  .mb-sm-n2 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-sm-n3 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-sm-n4 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-sm-n5 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ms-sm-n1 {\n    margin-left: -0.375rem !important;\n  }\n  .ms-sm-n2 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-sm-n3 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-sm-n4 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-sm-n5 {\n    margin-left: -4.5rem !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.375rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.75rem !important;\n  }\n  .p-sm-3 {\n    padding: 1.5rem !important;\n  }\n  .p-sm-4 {\n    padding: 2.25rem !important;\n  }\n  .p-sm-5 {\n    padding: 4.5rem !important;\n  }\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-sm-1 {\n    padding-right: 0.375rem !important;\n    padding-left: 0.375rem !important;\n  }\n  .px-sm-2 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-sm-3 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-sm-4 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-sm-5 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-sm-1 {\n    padding-top: 0.375rem !important;\n    padding-bottom: 0.375rem !important;\n  }\n  .py-sm-2 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-sm-3 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-sm-4 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-sm-5 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pt-sm-1 {\n    padding-top: 0.375rem !important;\n  }\n  .pt-sm-2 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-sm-3 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-sm-4 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-sm-5 {\n    padding-top: 4.5rem !important;\n  }\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pe-sm-1 {\n    padding-right: 0.375rem !important;\n  }\n  .pe-sm-2 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-sm-3 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-sm-4 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-sm-5 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-sm-1 {\n    padding-bottom: 0.375rem !important;\n  }\n  .pb-sm-2 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-sm-3 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-sm-4 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-sm-5 {\n    padding-bottom: 4.5rem !important;\n  }\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n  .ps-sm-1 {\n    padding-left: 0.375rem !important;\n  }\n  .ps-sm-2 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-sm-3 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-sm-4 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-sm-5 {\n    padding-left: 4.5rem !important;\n  }\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n  .gap-sm-1 {\n    gap: 0.375rem !important;\n  }\n  .gap-sm-2 {\n    gap: 0.75rem !important;\n  }\n  .gap-sm-3 {\n    gap: 1.5rem !important;\n  }\n  .gap-sm-4 {\n    gap: 2.25rem !important;\n  }\n  .gap-sm-5 {\n    gap: 4.5rem !important;\n  }\n  .row-gap-sm-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-sm-1 {\n    row-gap: 0.375rem !important;\n  }\n  .row-gap-sm-2 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-sm-3 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-sm-4 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-sm-5 {\n    row-gap: 4.5rem !important;\n  }\n  .column-gap-sm-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-sm-1 {\n    column-gap: 0.375rem !important;\n  }\n  .column-gap-sm-2 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-sm-3 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-sm-4 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-sm-5 {\n    column-gap: 4.5rem !important;\n  }\n  .text-sm-start {\n    text-align: left !important;\n  }\n  .text-sm-end {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n  .float-md-end {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n  .object-fit-md-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-md-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-md-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-md-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-md-none {\n    object-fit: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-grid {\n    display: grid !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-md-none {\n    display: none !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .order-md-first {\n    order: -1 !important;\n  }\n  .order-md-0 {\n    order: 0 !important;\n  }\n  .order-md-1 {\n    order: 1 !important;\n  }\n  .order-md-2 {\n    order: 2 !important;\n  }\n  .order-md-3 {\n    order: 3 !important;\n  }\n  .order-md-4 {\n    order: 4 !important;\n  }\n  .order-md-5 {\n    order: 5 !important;\n  }\n  .order-md-last {\n    order: 6 !important;\n  }\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.375rem !important;\n  }\n  .m-md-2 {\n    margin: 0.75rem !important;\n  }\n  .m-md-3 {\n    margin: 1.5rem !important;\n  }\n  .m-md-4 {\n    margin: 2.25rem !important;\n  }\n  .m-md-5 {\n    margin: 4.5rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-md-1 {\n    margin-right: 0.375rem !important;\n    margin-left: 0.375rem !important;\n  }\n  .mx-md-2 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-md-3 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-md-4 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-md-5 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-md-1 {\n    margin-top: 0.375rem !important;\n    margin-bottom: 0.375rem !important;\n  }\n  .my-md-2 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-md-3 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-md-4 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-md-5 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n  .mt-md-1 {\n    margin-top: 0.375rem !important;\n  }\n  .mt-md-2 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-md-3 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-md-4 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-md-5 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n  .me-md-1 {\n    margin-right: 0.375rem !important;\n  }\n  .me-md-2 {\n    margin-right: 0.75rem !important;\n  }\n  .me-md-3 {\n    margin-right: 1.5rem !important;\n  }\n  .me-md-4 {\n    margin-right: 2.25rem !important;\n  }\n  .me-md-5 {\n    margin-right: 4.5rem !important;\n  }\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-md-1 {\n    margin-bottom: 0.375rem !important;\n  }\n  .mb-md-2 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-md-3 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-md-4 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-md-5 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n  .ms-md-1 {\n    margin-left: 0.375rem !important;\n  }\n  .ms-md-2 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-md-3 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-md-4 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-md-5 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n  .m-md-n1 {\n    margin: -0.375rem !important;\n  }\n  .m-md-n2 {\n    margin: -0.75rem !important;\n  }\n  .m-md-n3 {\n    margin: -1.5rem !important;\n  }\n  .m-md-n4 {\n    margin: -2.25rem !important;\n  }\n  .m-md-n5 {\n    margin: -4.5rem !important;\n  }\n  .mx-md-n1 {\n    margin-right: -0.375rem !important;\n    margin-left: -0.375rem !important;\n  }\n  .mx-md-n2 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-md-n3 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-md-n4 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-md-n5 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .my-md-n1 {\n    margin-top: -0.375rem !important;\n    margin-bottom: -0.375rem !important;\n  }\n  .my-md-n2 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-md-n3 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-md-n4 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-md-n5 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .mt-md-n1 {\n    margin-top: -0.375rem !important;\n  }\n  .mt-md-n2 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-md-n3 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-md-n4 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-md-n5 {\n    margin-top: -4.5rem !important;\n  }\n  .me-md-n1 {\n    margin-right: -0.375rem !important;\n  }\n  .me-md-n2 {\n    margin-right: -0.75rem !important;\n  }\n  .me-md-n3 {\n    margin-right: -1.5rem !important;\n  }\n  .me-md-n4 {\n    margin-right: -2.25rem !important;\n  }\n  .me-md-n5 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-md-n1 {\n    margin-bottom: -0.375rem !important;\n  }\n  .mb-md-n2 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-md-n3 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-md-n4 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-md-n5 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ms-md-n1 {\n    margin-left: -0.375rem !important;\n  }\n  .ms-md-n2 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-md-n3 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-md-n4 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-md-n5 {\n    margin-left: -4.5rem !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.375rem !important;\n  }\n  .p-md-2 {\n    padding: 0.75rem !important;\n  }\n  .p-md-3 {\n    padding: 1.5rem !important;\n  }\n  .p-md-4 {\n    padding: 2.25rem !important;\n  }\n  .p-md-5 {\n    padding: 4.5rem !important;\n  }\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-md-1 {\n    padding-right: 0.375rem !important;\n    padding-left: 0.375rem !important;\n  }\n  .px-md-2 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-md-3 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-md-4 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-md-5 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-md-1 {\n    padding-top: 0.375rem !important;\n    padding-bottom: 0.375rem !important;\n  }\n  .py-md-2 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-md-3 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-md-4 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-md-5 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n  .pt-md-1 {\n    padding-top: 0.375rem !important;\n  }\n  .pt-md-2 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-md-3 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-md-4 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-md-5 {\n    padding-top: 4.5rem !important;\n  }\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n  .pe-md-1 {\n    padding-right: 0.375rem !important;\n  }\n  .pe-md-2 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-md-3 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-md-4 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-md-5 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-md-1 {\n    padding-bottom: 0.375rem !important;\n  }\n  .pb-md-2 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-md-3 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-md-4 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-md-5 {\n    padding-bottom: 4.5rem !important;\n  }\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n  .ps-md-1 {\n    padding-left: 0.375rem !important;\n  }\n  .ps-md-2 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-md-3 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-md-4 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-md-5 {\n    padding-left: 4.5rem !important;\n  }\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n  .gap-md-1 {\n    gap: 0.375rem !important;\n  }\n  .gap-md-2 {\n    gap: 0.75rem !important;\n  }\n  .gap-md-3 {\n    gap: 1.5rem !important;\n  }\n  .gap-md-4 {\n    gap: 2.25rem !important;\n  }\n  .gap-md-5 {\n    gap: 4.5rem !important;\n  }\n  .row-gap-md-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-md-1 {\n    row-gap: 0.375rem !important;\n  }\n  .row-gap-md-2 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-md-3 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-md-4 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-md-5 {\n    row-gap: 4.5rem !important;\n  }\n  .column-gap-md-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-md-1 {\n    column-gap: 0.375rem !important;\n  }\n  .column-gap-md-2 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-md-3 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-md-4 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-md-5 {\n    column-gap: 4.5rem !important;\n  }\n  .text-md-start {\n    text-align: left !important;\n  }\n  .text-md-end {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n  .float-lg-end {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n  .object-fit-lg-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-lg-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-lg-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-lg-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-lg-none {\n    object-fit: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-grid {\n    display: grid !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-lg-none {\n    display: none !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .order-lg-first {\n    order: -1 !important;\n  }\n  .order-lg-0 {\n    order: 0 !important;\n  }\n  .order-lg-1 {\n    order: 1 !important;\n  }\n  .order-lg-2 {\n    order: 2 !important;\n  }\n  .order-lg-3 {\n    order: 3 !important;\n  }\n  .order-lg-4 {\n    order: 4 !important;\n  }\n  .order-lg-5 {\n    order: 5 !important;\n  }\n  .order-lg-last {\n    order: 6 !important;\n  }\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.375rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.75rem !important;\n  }\n  .m-lg-3 {\n    margin: 1.5rem !important;\n  }\n  .m-lg-4 {\n    margin: 2.25rem !important;\n  }\n  .m-lg-5 {\n    margin: 4.5rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-lg-1 {\n    margin-right: 0.375rem !important;\n    margin-left: 0.375rem !important;\n  }\n  .mx-lg-2 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-lg-3 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-lg-4 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-lg-5 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-lg-1 {\n    margin-top: 0.375rem !important;\n    margin-bottom: 0.375rem !important;\n  }\n  .my-lg-2 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-lg-3 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-lg-4 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-lg-5 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mt-lg-1 {\n    margin-top: 0.375rem !important;\n  }\n  .mt-lg-2 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-lg-3 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-lg-4 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-lg-5 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n  .me-lg-1 {\n    margin-right: 0.375rem !important;\n  }\n  .me-lg-2 {\n    margin-right: 0.75rem !important;\n  }\n  .me-lg-3 {\n    margin-right: 1.5rem !important;\n  }\n  .me-lg-4 {\n    margin-right: 2.25rem !important;\n  }\n  .me-lg-5 {\n    margin-right: 4.5rem !important;\n  }\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-lg-1 {\n    margin-bottom: 0.375rem !important;\n  }\n  .mb-lg-2 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-lg-3 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-lg-4 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-lg-5 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n  .ms-lg-1 {\n    margin-left: 0.375rem !important;\n  }\n  .ms-lg-2 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-lg-3 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-lg-4 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-lg-5 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n  .m-lg-n1 {\n    margin: -0.375rem !important;\n  }\n  .m-lg-n2 {\n    margin: -0.75rem !important;\n  }\n  .m-lg-n3 {\n    margin: -1.5rem !important;\n  }\n  .m-lg-n4 {\n    margin: -2.25rem !important;\n  }\n  .m-lg-n5 {\n    margin: -4.5rem !important;\n  }\n  .mx-lg-n1 {\n    margin-right: -0.375rem !important;\n    margin-left: -0.375rem !important;\n  }\n  .mx-lg-n2 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-lg-n3 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-lg-n4 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-lg-n5 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .my-lg-n1 {\n    margin-top: -0.375rem !important;\n    margin-bottom: -0.375rem !important;\n  }\n  .my-lg-n2 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-lg-n3 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-lg-n4 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-lg-n5 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .mt-lg-n1 {\n    margin-top: -0.375rem !important;\n  }\n  .mt-lg-n2 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-lg-n3 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-lg-n4 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-lg-n5 {\n    margin-top: -4.5rem !important;\n  }\n  .me-lg-n1 {\n    margin-right: -0.375rem !important;\n  }\n  .me-lg-n2 {\n    margin-right: -0.75rem !important;\n  }\n  .me-lg-n3 {\n    margin-right: -1.5rem !important;\n  }\n  .me-lg-n4 {\n    margin-right: -2.25rem !important;\n  }\n  .me-lg-n5 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-lg-n1 {\n    margin-bottom: -0.375rem !important;\n  }\n  .mb-lg-n2 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-lg-n3 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-lg-n4 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-lg-n5 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ms-lg-n1 {\n    margin-left: -0.375rem !important;\n  }\n  .ms-lg-n2 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-lg-n3 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-lg-n4 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-lg-n5 {\n    margin-left: -4.5rem !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.375rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.75rem !important;\n  }\n  .p-lg-3 {\n    padding: 1.5rem !important;\n  }\n  .p-lg-4 {\n    padding: 2.25rem !important;\n  }\n  .p-lg-5 {\n    padding: 4.5rem !important;\n  }\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-lg-1 {\n    padding-right: 0.375rem !important;\n    padding-left: 0.375rem !important;\n  }\n  .px-lg-2 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-lg-3 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-lg-4 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-lg-5 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-lg-1 {\n    padding-top: 0.375rem !important;\n    padding-bottom: 0.375rem !important;\n  }\n  .py-lg-2 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-lg-3 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-lg-4 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-lg-5 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pt-lg-1 {\n    padding-top: 0.375rem !important;\n  }\n  .pt-lg-2 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-lg-3 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-lg-4 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-lg-5 {\n    padding-top: 4.5rem !important;\n  }\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pe-lg-1 {\n    padding-right: 0.375rem !important;\n  }\n  .pe-lg-2 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-lg-3 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-lg-4 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-lg-5 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-lg-1 {\n    padding-bottom: 0.375rem !important;\n  }\n  .pb-lg-2 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-lg-3 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-lg-4 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-lg-5 {\n    padding-bottom: 4.5rem !important;\n  }\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n  .ps-lg-1 {\n    padding-left: 0.375rem !important;\n  }\n  .ps-lg-2 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-lg-3 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-lg-4 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-lg-5 {\n    padding-left: 4.5rem !important;\n  }\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n  .gap-lg-1 {\n    gap: 0.375rem !important;\n  }\n  .gap-lg-2 {\n    gap: 0.75rem !important;\n  }\n  .gap-lg-3 {\n    gap: 1.5rem !important;\n  }\n  .gap-lg-4 {\n    gap: 2.25rem !important;\n  }\n  .gap-lg-5 {\n    gap: 4.5rem !important;\n  }\n  .row-gap-lg-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-lg-1 {\n    row-gap: 0.375rem !important;\n  }\n  .row-gap-lg-2 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-lg-3 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-lg-4 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-lg-5 {\n    row-gap: 4.5rem !important;\n  }\n  .column-gap-lg-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-lg-1 {\n    column-gap: 0.375rem !important;\n  }\n  .column-gap-lg-2 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-lg-3 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-lg-4 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-lg-5 {\n    column-gap: 4.5rem !important;\n  }\n  .text-lg-start {\n    text-align: left !important;\n  }\n  .text-lg-end {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n  .float-xl-end {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n  .object-fit-xl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xl-none {\n    object-fit: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-grid {\n    display: grid !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xl-none {\n    display: none !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xl-first {\n    order: -1 !important;\n  }\n  .order-xl-0 {\n    order: 0 !important;\n  }\n  .order-xl-1 {\n    order: 1 !important;\n  }\n  .order-xl-2 {\n    order: 2 !important;\n  }\n  .order-xl-3 {\n    order: 3 !important;\n  }\n  .order-xl-4 {\n    order: 4 !important;\n  }\n  .order-xl-5 {\n    order: 5 !important;\n  }\n  .order-xl-last {\n    order: 6 !important;\n  }\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.375rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.75rem !important;\n  }\n  .m-xl-3 {\n    margin: 1.5rem !important;\n  }\n  .m-xl-4 {\n    margin: 2.25rem !important;\n  }\n  .m-xl-5 {\n    margin: 4.5rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xl-1 {\n    margin-right: 0.375rem !important;\n    margin-left: 0.375rem !important;\n  }\n  .mx-xl-2 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-xl-3 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xl-4 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-xl-5 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xl-1 {\n    margin-top: 0.375rem !important;\n    margin-bottom: 0.375rem !important;\n  }\n  .my-xl-2 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-xl-3 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xl-4 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-xl-5 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xl-1 {\n    margin-top: 0.375rem !important;\n  }\n  .mt-xl-2 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-xl-3 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xl-4 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-xl-5 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xl-1 {\n    margin-right: 0.375rem !important;\n  }\n  .me-xl-2 {\n    margin-right: 0.75rem !important;\n  }\n  .me-xl-3 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xl-4 {\n    margin-right: 2.25rem !important;\n  }\n  .me-xl-5 {\n    margin-right: 4.5rem !important;\n  }\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xl-1 {\n    margin-bottom: 0.375rem !important;\n  }\n  .mb-xl-2 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-xl-3 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xl-4 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-xl-5 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xl-1 {\n    margin-left: 0.375rem !important;\n  }\n  .ms-xl-2 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-xl-3 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xl-4 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-xl-5 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n  .m-xl-n1 {\n    margin: -0.375rem !important;\n  }\n  .m-xl-n2 {\n    margin: -0.75rem !important;\n  }\n  .m-xl-n3 {\n    margin: -1.5rem !important;\n  }\n  .m-xl-n4 {\n    margin: -2.25rem !important;\n  }\n  .m-xl-n5 {\n    margin: -4.5rem !important;\n  }\n  .mx-xl-n1 {\n    margin-right: -0.375rem !important;\n    margin-left: -0.375rem !important;\n  }\n  .mx-xl-n2 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-xl-n3 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-xl-n4 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-xl-n5 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .my-xl-n1 {\n    margin-top: -0.375rem !important;\n    margin-bottom: -0.375rem !important;\n  }\n  .my-xl-n2 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-xl-n3 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-xl-n4 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-xl-n5 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .mt-xl-n1 {\n    margin-top: -0.375rem !important;\n  }\n  .mt-xl-n2 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-xl-n3 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-xl-n4 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-xl-n5 {\n    margin-top: -4.5rem !important;\n  }\n  .me-xl-n1 {\n    margin-right: -0.375rem !important;\n  }\n  .me-xl-n2 {\n    margin-right: -0.75rem !important;\n  }\n  .me-xl-n3 {\n    margin-right: -1.5rem !important;\n  }\n  .me-xl-n4 {\n    margin-right: -2.25rem !important;\n  }\n  .me-xl-n5 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-xl-n1 {\n    margin-bottom: -0.375rem !important;\n  }\n  .mb-xl-n2 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-xl-n3 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-xl-n4 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-xl-n5 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ms-xl-n1 {\n    margin-left: -0.375rem !important;\n  }\n  .ms-xl-n2 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-xl-n3 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-xl-n4 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-xl-n5 {\n    margin-left: -4.5rem !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.375rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.75rem !important;\n  }\n  .p-xl-3 {\n    padding: 1.5rem !important;\n  }\n  .p-xl-4 {\n    padding: 2.25rem !important;\n  }\n  .p-xl-5 {\n    padding: 4.5rem !important;\n  }\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xl-1 {\n    padding-right: 0.375rem !important;\n    padding-left: 0.375rem !important;\n  }\n  .px-xl-2 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-xl-3 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xl-4 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-xl-5 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xl-1 {\n    padding-top: 0.375rem !important;\n    padding-bottom: 0.375rem !important;\n  }\n  .py-xl-2 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-xl-3 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xl-4 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-xl-5 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xl-1 {\n    padding-top: 0.375rem !important;\n  }\n  .pt-xl-2 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-xl-3 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xl-4 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-xl-5 {\n    padding-top: 4.5rem !important;\n  }\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xl-1 {\n    padding-right: 0.375rem !important;\n  }\n  .pe-xl-2 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-xl-3 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xl-4 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-xl-5 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xl-1 {\n    padding-bottom: 0.375rem !important;\n  }\n  .pb-xl-2 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-xl-3 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xl-4 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-xl-5 {\n    padding-bottom: 4.5rem !important;\n  }\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xl-1 {\n    padding-left: 0.375rem !important;\n  }\n  .ps-xl-2 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-xl-3 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xl-4 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-xl-5 {\n    padding-left: 4.5rem !important;\n  }\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n  .gap-xl-1 {\n    gap: 0.375rem !important;\n  }\n  .gap-xl-2 {\n    gap: 0.75rem !important;\n  }\n  .gap-xl-3 {\n    gap: 1.5rem !important;\n  }\n  .gap-xl-4 {\n    gap: 2.25rem !important;\n  }\n  .gap-xl-5 {\n    gap: 4.5rem !important;\n  }\n  .row-gap-xl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xl-1 {\n    row-gap: 0.375rem !important;\n  }\n  .row-gap-xl-2 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-xl-3 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xl-4 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-xl-5 {\n    row-gap: 4.5rem !important;\n  }\n  .column-gap-xl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xl-1 {\n    column-gap: 0.375rem !important;\n  }\n  .column-gap-xl-2 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-xl-3 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xl-4 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-xl-5 {\n    column-gap: 4.5rem !important;\n  }\n  .text-xl-start {\n    text-align: left !important;\n  }\n  .text-xl-end {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1400px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n  .float-xxl-end {\n    float: right !important;\n  }\n  .float-xxl-none {\n    float: none !important;\n  }\n  .object-fit-xxl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xxl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xxl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xxl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xxl-none {\n    object-fit: none !important;\n  }\n  .d-xxl-inline {\n    display: inline !important;\n  }\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xxl-block {\n    display: block !important;\n  }\n  .d-xxl-grid {\n    display: grid !important;\n  }\n  .d-xxl-table {\n    display: table !important;\n  }\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xxl-flex {\n    display: flex !important;\n  }\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xxl-none {\n    display: none !important;\n  }\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xxl-first {\n    order: -1 !important;\n  }\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n  .order-xxl-last {\n    order: 6 !important;\n  }\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n  .m-xxl-1 {\n    margin: 0.375rem !important;\n  }\n  .m-xxl-2 {\n    margin: 0.75rem !important;\n  }\n  .m-xxl-3 {\n    margin: 1.5rem !important;\n  }\n  .m-xxl-4 {\n    margin: 2.25rem !important;\n  }\n  .m-xxl-5 {\n    margin: 4.5rem !important;\n  }\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xxl-1 {\n    margin-right: 0.375rem !important;\n    margin-left: 0.375rem !important;\n  }\n  .mx-xxl-2 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-xxl-3 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xxl-4 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-xxl-5 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xxl-1 {\n    margin-top: 0.375rem !important;\n    margin-bottom: 0.375rem !important;\n  }\n  .my-xxl-2 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-xxl-3 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xxl-4 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-xxl-5 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xxl-1 {\n    margin-top: 0.375rem !important;\n  }\n  .mt-xxl-2 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-xxl-3 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xxl-4 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-xxl-5 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xxl-1 {\n    margin-right: 0.375rem !important;\n  }\n  .me-xxl-2 {\n    margin-right: 0.75rem !important;\n  }\n  .me-xxl-3 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xxl-4 {\n    margin-right: 2.25rem !important;\n  }\n  .me-xxl-5 {\n    margin-right: 4.5rem !important;\n  }\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xxl-1 {\n    margin-bottom: 0.375rem !important;\n  }\n  .mb-xxl-2 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-xxl-3 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xxl-4 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-xxl-5 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xxl-1 {\n    margin-left: 0.375rem !important;\n  }\n  .ms-xxl-2 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-xxl-3 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xxl-4 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-xxl-5 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n  .m-xxl-n1 {\n    margin: -0.375rem !important;\n  }\n  .m-xxl-n2 {\n    margin: -0.75rem !important;\n  }\n  .m-xxl-n3 {\n    margin: -1.5rem !important;\n  }\n  .m-xxl-n4 {\n    margin: -2.25rem !important;\n  }\n  .m-xxl-n5 {\n    margin: -4.5rem !important;\n  }\n  .mx-xxl-n1 {\n    margin-right: -0.375rem !important;\n    margin-left: -0.375rem !important;\n  }\n  .mx-xxl-n2 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-xxl-n3 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-xxl-n4 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-xxl-n5 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .my-xxl-n1 {\n    margin-top: -0.375rem !important;\n    margin-bottom: -0.375rem !important;\n  }\n  .my-xxl-n2 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-xxl-n3 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-xxl-n4 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-xxl-n5 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .mt-xxl-n1 {\n    margin-top: -0.375rem !important;\n  }\n  .mt-xxl-n2 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-xxl-n3 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-xxl-n4 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-xxl-n5 {\n    margin-top: -4.5rem !important;\n  }\n  .me-xxl-n1 {\n    margin-right: -0.375rem !important;\n  }\n  .me-xxl-n2 {\n    margin-right: -0.75rem !important;\n  }\n  .me-xxl-n3 {\n    margin-right: -1.5rem !important;\n  }\n  .me-xxl-n4 {\n    margin-right: -2.25rem !important;\n  }\n  .me-xxl-n5 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-xxl-n1 {\n    margin-bottom: -0.375rem !important;\n  }\n  .mb-xxl-n2 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-xxl-n3 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-xxl-n4 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-xxl-n5 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ms-xxl-n1 {\n    margin-left: -0.375rem !important;\n  }\n  .ms-xxl-n2 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-xxl-n3 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-xxl-n4 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-xxl-n5 {\n    margin-left: -4.5rem !important;\n  }\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n  .p-xxl-1 {\n    padding: 0.375rem !important;\n  }\n  .p-xxl-2 {\n    padding: 0.75rem !important;\n  }\n  .p-xxl-3 {\n    padding: 1.5rem !important;\n  }\n  .p-xxl-4 {\n    padding: 2.25rem !important;\n  }\n  .p-xxl-5 {\n    padding: 4.5rem !important;\n  }\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xxl-1 {\n    padding-right: 0.375rem !important;\n    padding-left: 0.375rem !important;\n  }\n  .px-xxl-2 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-xxl-3 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xxl-4 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-xxl-5 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xxl-1 {\n    padding-top: 0.375rem !important;\n    padding-bottom: 0.375rem !important;\n  }\n  .py-xxl-2 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-xxl-3 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xxl-4 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-xxl-5 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xxl-1 {\n    padding-top: 0.375rem !important;\n  }\n  .pt-xxl-2 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-xxl-3 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xxl-4 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-xxl-5 {\n    padding-top: 4.5rem !important;\n  }\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xxl-1 {\n    padding-right: 0.375rem !important;\n  }\n  .pe-xxl-2 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-xxl-3 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xxl-4 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-xxl-5 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xxl-1 {\n    padding-bottom: 0.375rem !important;\n  }\n  .pb-xxl-2 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-xxl-3 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xxl-4 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-xxl-5 {\n    padding-bottom: 4.5rem !important;\n  }\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xxl-1 {\n    padding-left: 0.375rem !important;\n  }\n  .ps-xxl-2 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-xxl-3 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xxl-4 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-xxl-5 {\n    padding-left: 4.5rem !important;\n  }\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n  .gap-xxl-1 {\n    gap: 0.375rem !important;\n  }\n  .gap-xxl-2 {\n    gap: 0.75rem !important;\n  }\n  .gap-xxl-3 {\n    gap: 1.5rem !important;\n  }\n  .gap-xxl-4 {\n    gap: 2.25rem !important;\n  }\n  .gap-xxl-5 {\n    gap: 4.5rem !important;\n  }\n  .row-gap-xxl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xxl-1 {\n    row-gap: 0.375rem !important;\n  }\n  .row-gap-xxl-2 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-xxl-3 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xxl-4 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-xxl-5 {\n    row-gap: 4.5rem !important;\n  }\n  .column-gap-xxl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xxl-1 {\n    column-gap: 0.375rem !important;\n  }\n  .column-gap-xxl-2 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-xxl-3 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xxl-4 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-xxl-5 {\n    column-gap: 4.5rem !important;\n  }\n  .text-xxl-start {\n    text-align: left !important;\n  }\n  .text-xxl-end {\n    text-align: right !important;\n  }\n  .text-xxl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 2.25rem !important;\n  }\n  .fs-2 {\n    font-size: 1.875rem !important;\n  }\n  .fs-3 {\n    font-size: 1.5rem !important;\n  }\n}\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-grid {\n    display: grid !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-print-none {\n    display: none !important;\n  }\n}\n.custom-accordion .accordion-arrow {\n  font-size: 1.2rem;\n  position: absolute;\n  right: 0;\n}\n.custom-accordion a.collapsed i.accordion-arrow:before {\n  content: \"\\f0142\";\n}\n\n.alert-primary {\n  --ct-alert-color: rgb(71.4, 61.6, 154.7);\n  --ct-alert-bg: rgba(102, 88, 221, 0.18);\n  --ct-alert-border-color: rgba(102, 88, 221, 0.18);\n}\n.alert-primary .alert-link {\n  --ct-alert-color: rgb(71.4, 61.6, 154.7);\n}\n\n.alert-secondary {\n  --ct-alert-color: rgb(75.6, 81.9, 87.5);\n  --ct-alert-bg: rgba(108, 117, 125, 0.18);\n  --ct-alert-border-color: rgba(108, 117, 125, 0.18);\n}\n.alert-secondary .alert-link {\n  --ct-alert-color: rgb(75.6, 81.9, 87.5);\n}\n\n.alert-success {\n  --ct-alert-color: rgb(18.2, 131.6, 109.2);\n  --ct-alert-bg: rgba(26, 188, 156, 0.18);\n  --ct-alert-border-color: rgba(26, 188, 156, 0.18);\n}\n.alert-success .alert-link {\n  --ct-alert-color: rgb(18.2, 131.6, 109.2);\n}\n\n.alert-info {\n  --ct-alert-color: rgb(46.9, 133.7, 160.3);\n  --ct-alert-bg: rgba(67, 191, 229, 0.18);\n  --ct-alert-border-color: rgba(67, 191, 229, 0.18);\n}\n.alert-info .alert-link {\n  --ct-alert-color: rgb(46.9, 133.7, 160.3);\n}\n\n.alert-warning {\n  --ct-alert-color: rgb(172.9, 128.8, 52.5);\n  --ct-alert-bg: rgba(247, 184, 75, 0.18);\n  --ct-alert-border-color: rgba(247, 184, 75, 0.18);\n}\n.alert-warning .alert-link {\n  --ct-alert-color: rgb(172.9, 128.8, 52.5);\n}\n\n.alert-danger {\n  --ct-alert-color: rgb(168.7, 59.5, 75.6);\n  --ct-alert-bg: rgba(241, 85, 108, 0.18);\n  --ct-alert-border-color: rgba(241, 85, 108, 0.18);\n}\n.alert-danger .alert-link {\n  --ct-alert-color: rgb(168.7, 59.5, 75.6);\n}\n\n.alert-light {\n  --ct-alert-color: rgb(170.1, 172.9, 174.3);\n  --ct-alert-bg: rgba(243, 247, 249, 0.18);\n  --ct-alert-border-color: rgba(243, 247, 249, 0.18);\n}\n.alert-light .alert-link {\n  --ct-alert-color: rgb(170.1, 172.9, 174.3);\n}\n\n.alert-dark {\n  --ct-alert-color: rgb(35, 40.6, 49);\n  --ct-alert-bg: rgba(50, 58, 70, 0.18);\n  --ct-alert-border-color: rgba(50, 58, 70, 0.18);\n}\n.alert-dark .alert-link {\n  --ct-alert-color: rgb(35, 40.6, 49);\n}\n\n.alert-pink {\n  --ct-alert-color: rgb(172.2, 79.8, 116.9);\n  --ct-alert-bg: rgba(246, 114, 167, 0.18);\n  --ct-alert-border-color: rgba(246, 114, 167, 0.18);\n}\n.alert-pink .alert-link {\n  --ct-alert-color: rgb(172.2, 79.8, 116.9);\n}\n\n.alert-blue {\n  --ct-alert-color: rgb(51.8, 90.3, 148.4);\n  --ct-alert-bg: rgba(74, 129, 212, 0.18);\n  --ct-alert-border-color: rgba(74, 129, 212, 0.18);\n}\n.alert-blue .alert-link {\n  --ct-alert-color: rgb(51.8, 90.3, 148.4);\n}\n\n.alert-outline-primary {\n  --ct-alert-color: var(--ct-primary-text);\n  --ct-alert-bg: transparent;\n  --ct-alert-border-color: var(--ct-primary-border-subtle);\n  --ct-alert-link-color: var(--ct-primary-text);\n}\n\n.alert-outline-secondary {\n  --ct-alert-color: var(--ct-secondary-text);\n  --ct-alert-bg: transparent;\n  --ct-alert-border-color: var(--ct-secondary-border-subtle);\n  --ct-alert-link-color: var(--ct-secondary-text);\n}\n\n.alert-outline-success {\n  --ct-alert-color: var(--ct-success-text);\n  --ct-alert-bg: transparent;\n  --ct-alert-border-color: var(--ct-success-border-subtle);\n  --ct-alert-link-color: var(--ct-success-text);\n}\n\n.alert-outline-info {\n  --ct-alert-color: var(--ct-info-text);\n  --ct-alert-bg: transparent;\n  --ct-alert-border-color: var(--ct-info-border-subtle);\n  --ct-alert-link-color: var(--ct-info-text);\n}\n\n.alert-outline-warning {\n  --ct-alert-color: var(--ct-warning-text);\n  --ct-alert-bg: transparent;\n  --ct-alert-border-color: var(--ct-warning-border-subtle);\n  --ct-alert-link-color: var(--ct-warning-text);\n}\n\n.alert-outline-danger {\n  --ct-alert-color: var(--ct-danger-text);\n  --ct-alert-bg: transparent;\n  --ct-alert-border-color: var(--ct-danger-border-subtle);\n  --ct-alert-link-color: var(--ct-danger-text);\n}\n\n.alert-outline-light {\n  --ct-alert-color: var(--ct-light-text);\n  --ct-alert-bg: transparent;\n  --ct-alert-border-color: var(--ct-light-border-subtle);\n  --ct-alert-link-color: var(--ct-light-text);\n}\n\n.alert-outline-dark {\n  --ct-alert-color: var(--ct-dark-text);\n  --ct-alert-bg: transparent;\n  --ct-alert-border-color: var(--ct-dark-border-subtle);\n  --ct-alert-link-color: var(--ct-dark-text);\n}\n\n.alert-outline-pink {\n  --ct-alert-color: var(--ct-pink-text);\n  --ct-alert-bg: transparent;\n  --ct-alert-border-color: var(--ct-pink-border-subtle);\n  --ct-alert-link-color: var(--ct-pink-text);\n}\n\n.alert-outline-blue {\n  --ct-alert-color: var(--ct-blue-text);\n  --ct-alert-bg: transparent;\n  --ct-alert-border-color: var(--ct-blue-border-subtle);\n  --ct-alert-link-color: var(--ct-blue-text);\n}\n\n.avatar-xs {\n  height: 1.5rem;\n  width: 1.5rem;\n}\n\n.avatar-sm {\n  height: 2.25rem;\n  width: 2.25rem;\n}\n\n.avatar-md {\n  height: 3.5rem;\n  width: 3.5rem;\n}\n\n.avatar-lg {\n  height: 4.5rem;\n  width: 4.5rem;\n}\n\n.avatar-xl {\n  height: 6rem;\n  width: 6rem;\n}\n\n.avatar-xxl {\n  height: 7.5rem;\n  width: 7.5rem;\n}\n\n.avatar-title {\n  align-items: center;\n  color: var(--ct-card-bg);\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  width: 100%;\n}\n\n.avatar-group {\n  padding-left: 12px;\n}\n.avatar-group .avatar-group-item {\n  margin: 0 0 10px -12px;\n  display: inline-block;\n  border: 2px solid var(--ct-card-bg);\n  border-radius: 50%;\n}\n\n.breadcrumb-item > a {\n  color: var(--ct-gray-700);\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  font-family: \"Material Design Icons\";\n}\n\n.btn .mdi:before {\n  line-height: initial;\n}\n.btn .spinner-grow,\n.btn .spinner-border {\n  vertical-align: middle;\n}\n.btn-rounded {\n  border-radius: 50%;\n}\n.btn-xs {\n  padding: 0.2rem 0.6rem;\n  font-size: 0.75rem;\n  border-radius: 0.15rem;\n}\n.btn-label {\n  margin: -0.55rem 0.9rem -0.55rem -0.9rem;\n  padding: 0.6rem 0.9rem;\n}\n.btn-label-right {\n  margin: -0.45rem -0.9rem -0.45rem 0.9rem;\n  padding: 0.45rem 0.9rem;\n  display: inline-block;\n}\n.btn i {\n  display: inline-block;\n}\n\nbutton:focus {\n  outline: none;\n}\n\n.btn-soft-primary {\n  --ct-btn-color: #6658dd;\n  --ct-btn-bg: rgba(102, 88, 221, 0.1);\n  --ct-btn-border-color: transparent;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: #6658dd;\n  --ct-btn-hover-border-color: #6658dd;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: #6658dd;\n  --ct-btn-active-border-color: #6658dd;\n  --ct-btn-disabled-color: #6658dd;\n  --ct-btn-disabled-bg: #6658dd;\n  --ct-btn-disabled-border-color: #6658dd;\n  --ct-btn-focus-shadow-rgb: 0 0 0 $btn-focus-width rgba($bg, 0.5);\n}\n\n.btn-soft-secondary {\n  --ct-btn-color: #6c757d;\n  --ct-btn-bg: rgba(108, 117, 125, 0.1);\n  --ct-btn-border-color: transparent;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: #6c757d;\n  --ct-btn-hover-border-color: #6c757d;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: #6c757d;\n  --ct-btn-active-border-color: #6c757d;\n  --ct-btn-disabled-color: #6c757d;\n  --ct-btn-disabled-bg: #6c757d;\n  --ct-btn-disabled-border-color: #6c757d;\n  --ct-btn-focus-shadow-rgb: 0 0 0 $btn-focus-width rgba($bg, 0.5);\n}\n\n.btn-soft-success {\n  --ct-btn-color: #1abc9c;\n  --ct-btn-bg: rgba(26, 188, 156, 0.1);\n  --ct-btn-border-color: transparent;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: #1abc9c;\n  --ct-btn-hover-border-color: #1abc9c;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: #1abc9c;\n  --ct-btn-active-border-color: #1abc9c;\n  --ct-btn-disabled-color: #1abc9c;\n  --ct-btn-disabled-bg: #1abc9c;\n  --ct-btn-disabled-border-color: #1abc9c;\n  --ct-btn-focus-shadow-rgb: 0 0 0 $btn-focus-width rgba($bg, 0.5);\n}\n\n.btn-soft-info {\n  --ct-btn-color: #43bfe5;\n  --ct-btn-bg: rgba(67, 191, 229, 0.1);\n  --ct-btn-border-color: transparent;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: #43bfe5;\n  --ct-btn-hover-border-color: #43bfe5;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: #43bfe5;\n  --ct-btn-active-border-color: #43bfe5;\n  --ct-btn-disabled-color: #43bfe5;\n  --ct-btn-disabled-bg: #43bfe5;\n  --ct-btn-disabled-border-color: #43bfe5;\n  --ct-btn-focus-shadow-rgb: 0 0 0 $btn-focus-width rgba($bg, 0.5);\n}\n\n.btn-soft-warning {\n  --ct-btn-color: #f7b84b;\n  --ct-btn-bg: rgba(247, 184, 75, 0.1);\n  --ct-btn-border-color: transparent;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: #f7b84b;\n  --ct-btn-hover-border-color: #f7b84b;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: #f7b84b;\n  --ct-btn-active-border-color: #f7b84b;\n  --ct-btn-disabled-color: #f7b84b;\n  --ct-btn-disabled-bg: #f7b84b;\n  --ct-btn-disabled-border-color: #f7b84b;\n  --ct-btn-focus-shadow-rgb: 0 0 0 $btn-focus-width rgba($bg, 0.5);\n}\n\n.btn-soft-danger {\n  --ct-btn-color: #f1556c;\n  --ct-btn-bg: rgba(241, 85, 108, 0.1);\n  --ct-btn-border-color: transparent;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: #f1556c;\n  --ct-btn-hover-border-color: #f1556c;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: #f1556c;\n  --ct-btn-active-border-color: #f1556c;\n  --ct-btn-disabled-color: #f1556c;\n  --ct-btn-disabled-bg: #f1556c;\n  --ct-btn-disabled-border-color: #f1556c;\n  --ct-btn-focus-shadow-rgb: 0 0 0 $btn-focus-width rgba($bg, 0.5);\n}\n\n.btn-soft-light {\n  --ct-btn-color: #f3f7f9;\n  --ct-btn-bg: rgba(243, 247, 249, 0.1);\n  --ct-btn-border-color: transparent;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: #f3f7f9;\n  --ct-btn-hover-border-color: #f3f7f9;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: #f3f7f9;\n  --ct-btn-active-border-color: #f3f7f9;\n  --ct-btn-disabled-color: #f3f7f9;\n  --ct-btn-disabled-bg: #f3f7f9;\n  --ct-btn-disabled-border-color: #f3f7f9;\n  --ct-btn-focus-shadow-rgb: 0 0 0 $btn-focus-width rgba($bg, 0.5);\n}\n\n.btn-soft-dark {\n  --ct-btn-color: #323a46;\n  --ct-btn-bg: rgba(50, 58, 70, 0.1);\n  --ct-btn-border-color: transparent;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: #323a46;\n  --ct-btn-hover-border-color: #323a46;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: #323a46;\n  --ct-btn-active-border-color: #323a46;\n  --ct-btn-disabled-color: #323a46;\n  --ct-btn-disabled-bg: #323a46;\n  --ct-btn-disabled-border-color: #323a46;\n  --ct-btn-focus-shadow-rgb: 0 0 0 $btn-focus-width rgba($bg, 0.5);\n}\n\n.btn-soft-pink {\n  --ct-btn-color: #f672a7;\n  --ct-btn-bg: rgba(246, 114, 167, 0.1);\n  --ct-btn-border-color: transparent;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: #f672a7;\n  --ct-btn-hover-border-color: #f672a7;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: #f672a7;\n  --ct-btn-active-border-color: #f672a7;\n  --ct-btn-disabled-color: #f672a7;\n  --ct-btn-disabled-bg: #f672a7;\n  --ct-btn-disabled-border-color: #f672a7;\n  --ct-btn-focus-shadow-rgb: 0 0 0 $btn-focus-width rgba($bg, 0.5);\n}\n\n.btn-soft-blue {\n  --ct-btn-color: #4a81d4;\n  --ct-btn-bg: rgba(74, 129, 212, 0.1);\n  --ct-btn-border-color: transparent;\n  --ct-btn-hover-color: #fff;\n  --ct-btn-hover-bg: #4a81d4;\n  --ct-btn-hover-border-color: #4a81d4;\n  --ct-btn-active-color: #fff;\n  --ct-btn-active-bg: #4a81d4;\n  --ct-btn-active-border-color: #4a81d4;\n  --ct-btn-disabled-color: #4a81d4;\n  --ct-btn-disabled-bg: #4a81d4;\n  --ct-btn-disabled-border-color: #4a81d4;\n  --ct-btn-focus-shadow-rgb: 0 0 0 $btn-focus-width rgba($bg, 0.5);\n}\n\n.btn-white,\n.btn-outline-light {\n  --ct-btn-color: var(--ct-gray-900);\n  --ct-btn-hover-bg: var(--ct-gray-100);\n  --ct-btn-border-color: var(--ct-gray-300);\n  --ct-btn-hover-border-color: var(--ct-gray-100);\n}\n\nhtml[data-bs-theme=dark] .btn-light {\n  --ct-btn-color: var(--ct-gray-900);\n  --ct-btn-bg: var(--ct-gray-300);\n  --ct-btn-border-color: var(--ct-gray-300);\n  --ct-btn-hover-color: var(--ct-gray-900);\n  --ct-btn-hover-bg: var(--ct-gray-300);\n  --ct-btn-hover-border-color: var(--ct-gray-300);\n  --ct-btn-active-color: var(--ct-gray-900);\n  --ct-btn-active-bg: var(--ct-gray-300);\n  --ct-btn-active-border-color: var(--ct-gray-300);\n}\nhtml[data-bs-theme=dark] .btn-outline-dark {\n  --ct-btn-color: var(--ct-gray-900);\n}\nhtml[data-bs-theme=dark] .btn-outline-light,\nhtml[data-bs-theme=dark] .btn-outline-dark {\n  --ct-btn-hover-color: var(--ct-gray-900);\n  --ct-btn-color: var(--ct-gray-900);\n}\nhtml[data-bs-theme=dark] .btn-soft-dark {\n  --ct-btn-hover-bg: var(--ct-light);\n  --ct-btn-hover-border-color: var(--ct-light);\n}\n\n.card {\n  box-shadow: var(--ct-box-shadow-sm);\n  margin-bottom: 24px;\n}\n\n.card-drop {\n  font-size: 20px;\n  line-height: 0;\n  color: inherit;\n}\n\n.card-widgets {\n  float: right;\n  height: 16px;\n}\n.card-widgets > a {\n  color: inherit;\n  font-size: 18px;\n  display: inline-block;\n  line-height: 1;\n}\n.card-widgets > a.collapsed i:before {\n  content: \"\\f0415\";\n}\n\n.card-title,\n.card-header {\n  margin-top: 0;\n}\n\n.card-disabled {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  border-radius: var(--ct-border-radius);\n  background: rgba(var(--ct-secondary-bg-rgb), 0.8);\n  cursor: progress;\n}\n.card-disabled .card-portlets-loader {\n  background-color: var(--ct-gray-900);\n  animation: rotatebox 1.2s infinite ease-in-out;\n  height: 30px;\n  width: 30px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  border-radius: 3px;\n  margin-left: -12px;\n  margin-top: -12px;\n}\n\n@keyframes rotatebox {\n  0% {\n    transform: perspective(120px) rotateX(0deg) rotateY(0deg);\n  }\n  50% {\n    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);\n  }\n  100% {\n    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\n  }\n}\n.header-title {\n  font-size: 1rem;\n  margin: 0 0 7px 0;\n}\n\n.sub-header {\n  font-size: 0.875rem;\n  margin-bottom: 24px;\n  color: var(--ct-gray);\n}\n\n.form-check-primary .form-check-input:checked,\n.form-radio-primary .form-check-input:checked {\n  background-color: #6658dd;\n  border-color: #6658dd;\n}\n\n.form-check-secondary .form-check-input:checked,\n.form-radio-secondary .form-check-input:checked {\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.form-check-success .form-check-input:checked,\n.form-radio-success .form-check-input:checked {\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n\n.form-check-info .form-check-input:checked,\n.form-radio-info .form-check-input:checked {\n  background-color: #43bfe5;\n  border-color: #43bfe5;\n}\n\n.form-check-warning .form-check-input:checked,\n.form-radio-warning .form-check-input:checked {\n  background-color: #f7b84b;\n  border-color: #f7b84b;\n}\n\n.form-check-danger .form-check-input:checked,\n.form-radio-danger .form-check-input:checked {\n  background-color: #f1556c;\n  border-color: #f1556c;\n}\n\n.form-check-light .form-check-input:checked,\n.form-radio-light .form-check-input:checked {\n  background-color: #f3f7f9;\n  border-color: #f3f7f9;\n}\n\n.form-check-dark .form-check-input:checked,\n.form-radio-dark .form-check-input:checked {\n  background-color: #323a46;\n  border-color: #323a46;\n}\n\n.form-check-pink .form-check-input:checked,\n.form-radio-pink .form-check-input:checked {\n  background-color: #f672a7;\n  border-color: #f672a7;\n}\n\n.form-check-blue .form-check-input:checked,\n.form-radio-blue .form-check-input:checked {\n  background-color: #4a81d4;\n  border-color: #4a81d4;\n}\n\n.card-radio {\n  padding: 0;\n}\n.card-radio .form-check-label {\n  background-color: var(--ct-secondary-bg);\n  border: 1px solid var(--ct-border-color);\n  border-radius: var(--ct-border-radius);\n  padding: 1rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n  position: relative;\n  padding-right: 32px;\n}\n.card-radio .form-check-label:hover {\n  cursor: pointer;\n}\n.card-radio .form-check-input {\n  display: none;\n}\n.card-radio .form-check-input:checked + .form-check-label:before {\n  content: \"\\f05e0\";\n  font-family: \"Material Design Icons\";\n  position: absolute;\n  bottom: 2px;\n  right: 6px;\n  font-size: 16px;\n  color: #6658dd;\n}\n.card-radio.dark .form-check-input:checked + .form-check-label:before {\n  color: #fff;\n}\n\n.dropdown-menu {\n  padding: 0.3rem;\n  box-shadow: var(--ct-box-shadow);\n  animation-name: DropDownSlide;\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  top: 100%;\n}\n.dropdown-menu.show {\n  top: 100% !important;\n}\n.dropdown-menu i {\n  display: inline-block;\n}\n\n.dropdown-menu-end {\n  right: 0 !important;\n  left: auto !important;\n}\n\n.dropdown-menu[data-popper-placement^=right],\n.dropdown-menu[data-popper-placement^=top],\n.dropdown-menu[data-popper-placement^=left] {\n  top: auto !important;\n  animation: none !important;\n}\n\n@keyframes DropDownSlide {\n  100% {\n    transform: translateY(0);\n  }\n  0% {\n    transform: translateY(15px);\n  }\n}\n.dropdown-mega {\n  position: static !important;\n}\n\n.dropdown-megamenu {\n  padding: 20px;\n  left: 20px !important;\n  right: 20px !important;\n  background-image: url(\"../../../images/megamenu-bg.png\");\n  background-position: right bottom;\n  background-repeat: no-repeat;\n}\n\nhtml[dir=rtl] .dropdown-megamenu {\n  left: 60px !important;\n  right: -20px !important;\n}\n\n.megamenu-list li {\n  padding: 5px 20px 5px 25px;\n  position: relative;\n}\n.megamenu-list li a {\n  color: var(--ct-body-color);\n}\n.megamenu-list li a:hover {\n  color: #6658dd;\n}\n.megamenu-list li:before {\n  content: \"\\f0142\";\n  position: absolute;\n  left: 0;\n  font-family: \"Material Design Icons\";\n}\n\nhtml[dir=ltr] .megamenu-list li:before {\n  content: \"\\f0141\";\n}\n\n.dropdown-icon-item {\n  display: block;\n  border-radius: 3px;\n  line-height: 34px;\n  text-align: center;\n  padding: 15px 0 9px;\n  display: block;\n  border: 1px solid transparent;\n  color: var(--ct-body-color);\n}\n.dropdown-icon-item img {\n  height: 24px;\n}\n.dropdown-icon-item span {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.dropdown-icon-item:hover {\n  background-color: var(--ct-light);\n}\n\n@media (min-width: 992px) {\n  .dropdown-mega-menu-xl {\n    width: 40rem;\n  }\n  .dropdown-mega-menu-lg {\n    width: 26rem;\n  }\n}\n.dropdown-menu {\n  box-shadow: var(--ct-box-shadow);\n}\n\n.dropdown-header {\n  margin-top: 0;\n}\n\n.dropdown-menu-animated.dropdown-menu-end[style] {\n  left: auto;\n  right: 0;\n}\n\n.hover-dropdown:hover .dropdown-menu {\n  display: block !important;\n  top: 100% !important;\n}\n\n.dropdown-menu-animated {\n  animation-name: DropDownSlide;\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  position: absolute;\n  margin: 0;\n  z-index: 1000;\n}\n.dropdown-menu-animated.show {\n  top: 100% !important;\n}\n.dropdown-menu-animated i {\n  display: inline-block;\n}\n.dropdown-menu-animated.dropdown-menu[data-popper-placement^=right], .dropdown-menu-animated.dropdown-menu[data-popper-placement^=top], .dropdown-menu-animated.dropdown-menu[data-popper-placement^=left] {\n  top: auto !important;\n  animation: none !important;\n}\n\n@keyframes DropDownSlide {\n  100% {\n    transform: translateY(0);\n  }\n  0% {\n    transform: translateY(10px);\n  }\n}\n@media (min-width: 576px) {\n  .dropdown-lg {\n    width: 320px;\n  }\n}\n.dropdown-toggle.arrow-none:after {\n  display: none;\n}\n\n.notification-list {\n  margin-left: 0;\n}\n.notification-list .noti-title {\n  background-color: transparent;\n  padding: 15px 20px;\n}\n.notification-list .noti-icon-badge {\n  position: absolute;\n  top: 16px;\n  right: 14px;\n}\n.notification-list .notify-item {\n  padding: 10px 20px;\n}\n.notification-list .notify-item.unread-noti {\n  background-color: var(--ct-light);\n}\n.notification-list .notify-item.read-noti {\n  background-color: transparent;\n  transition: all 0.2s ease-in-out;\n}\n.notification-list .notify-item.read-noti:hover {\n  background-color: var(--ct-light);\n}\n.notification-list .notify-item .card-body {\n  padding: 14px;\n}\n.notification-list .notify-item .card-body .noti-close-btn {\n  position: absolute;\n  top: 3px;\n  right: 5px;\n}\n.notification-list .notify-item .card-body .noti-item-title {\n  margin: 0 0 2px;\n}\n.notification-list .notify-item .card-body .noti-item-title,\n.notification-list .notify-item .card-body .noti-item-subtitle {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.notification-list .notify-item .notify-icon {\n  float: left;\n  height: 36px;\n  width: 36px;\n  line-height: 36px;\n  text-align: center;\n  border-radius: 50%;\n  color: #fff;\n}\n.notification-list .notify-item .notify-details {\n  margin-bottom: 0;\n  overflow: hidden;\n  margin-left: 45px;\n}\n.notification-list .notify-item .notify-details b {\n  font-weight: 500;\n}\n.notification-list .notify-item .notify-details small, .notification-list .notify-item .notify-details .small {\n  display: block;\n}\n\n.profile-dropdown {\n  min-width: 170px;\n}\n.profile-dropdown i,\n.profile-dropdown span {\n  vertical-align: middle;\n}\n\ninput.form-control[type=color],\ninput.form-control[type=range] {\n  min-height: 39px;\n}\n\nselect.form-control:not([size]):not([multiple]) {\n  height: calc(1.5em + 0.9rem + 2px);\n}\n\nselect.form-control-sm:not([size]):not([multiple]) {\n  height: calc(1.5em + 0.56rem + 2px);\n}\n\n.form-control-light {\n  background-color: var(--ct-light) !important;\n  border-color: var(--ct-light) !important;\n}\n\n.comment-area-box .form-control {\n  border-color: var(--ct-gray-300);\n  border-radius: var(--ct-border-radius) var(--ct-border-radius) 0 0;\n}\n.comment-area-box .comment-area-btn {\n  background-color: var(--ct-gray-100);\n  padding: 10px;\n  border: 1px solid var(--ct-gray-300);\n  border-top: none;\n  border-radius: 0 0 var(--ct-border-radius) var(--ct-border-radius);\n}\n\n.search-bar .form-control {\n  padding-left: 40px;\n  padding-right: 20px;\n  border-radius: 30px;\n}\n.search-bar span {\n  position: absolute;\n  z-index: 10;\n  font-size: 16px;\n  line-height: calc(1.5em + 0.9rem + 2px);\n  left: 13px;\n  top: -2px;\n  color: var(--ct-gray);\n}\n\n.password-eye {\n  cursor: pointer;\n}\n.password-eye:before {\n  font-family: \"Material Design Icons\";\n  content: \"\\f06d0\";\n  font-style: normal;\n  font-weight: 400;\n  font-variant: normal;\n  vertical-align: middle;\n  line-height: 1.2;\n  font-size: 16px;\n}\n\n.show-password .password-eye:before {\n  content: \"\\f06d1\";\n}\n\n.badge {\n  box-shadow: var(--ct-box-shadow);\n}\n\n.badge-soft-primary {\n  color: #6658dd;\n  background-color: rgba(102, 88, 221, 0.18);\n  box-shadow: none;\n}\n\n.badge-outline-primary {\n  color: #6658dd;\n  border: 1px solid #6658dd;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.badge-soft-secondary {\n  color: #6c757d;\n  background-color: rgba(108, 117, 125, 0.18);\n  box-shadow: none;\n}\n\n.badge-outline-secondary {\n  color: #6c757d;\n  border: 1px solid #6c757d;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.badge-soft-success {\n  color: #1abc9c;\n  background-color: rgba(26, 188, 156, 0.18);\n  box-shadow: none;\n}\n\n.badge-outline-success {\n  color: #1abc9c;\n  border: 1px solid #1abc9c;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.badge-soft-info {\n  color: #43bfe5;\n  background-color: rgba(67, 191, 229, 0.18);\n  box-shadow: none;\n}\n\n.badge-outline-info {\n  color: #43bfe5;\n  border: 1px solid #43bfe5;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.badge-soft-warning {\n  color: #f7b84b;\n  background-color: rgba(247, 184, 75, 0.18);\n  box-shadow: none;\n}\n\n.badge-outline-warning {\n  color: #f7b84b;\n  border: 1px solid #f7b84b;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.badge-soft-danger {\n  color: #f1556c;\n  background-color: rgba(241, 85, 108, 0.18);\n  box-shadow: none;\n}\n\n.badge-outline-danger {\n  color: #f1556c;\n  border: 1px solid #f1556c;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.badge-soft-light {\n  color: #f3f7f9;\n  background-color: rgba(243, 247, 249, 0.18);\n  box-shadow: none;\n}\n\n.badge-outline-light {\n  color: #f3f7f9;\n  border: 1px solid #f3f7f9;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.badge-soft-dark {\n  color: #323a46;\n  background-color: rgba(50, 58, 70, 0.18);\n  box-shadow: none;\n}\n\n.badge-outline-dark {\n  color: #323a46;\n  border: 1px solid #323a46;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.badge-soft-pink {\n  color: #f672a7;\n  background-color: rgba(246, 114, 167, 0.18);\n  box-shadow: none;\n}\n\n.badge-outline-pink {\n  color: #f672a7;\n  border: 1px solid #f672a7;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.badge-soft-blue {\n  color: #4a81d4;\n  background-color: rgba(74, 129, 212, 0.18);\n  box-shadow: none;\n}\n\n.badge-outline-blue {\n  color: #4a81d4;\n  border: 1px solid #4a81d4;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.badge {\n  vertical-align: middle;\n}\n.badge.badge-lg {\n  padding: 0.5em 1em;\n  font-size: 0.85em;\n}\n\n.modal-title {\n  margin-top: 0;\n}\n\n.modal-full-width {\n  width: 95%;\n  max-width: none;\n}\n\n.modal-top {\n  margin: 0 auto;\n}\n\n.modal-right {\n  position: absolute;\n  right: 0;\n  display: flex;\n  flex-flow: column nowrap;\n  justify-content: center;\n  height: 100%;\n  margin: 0;\n  background-color: var(--ct-secondary-bg);\n  align-content: center;\n  transform: translate(25%, 0) !important;\n}\n.modal-right button.btn-close {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 1;\n}\n\n.modal.show .modal-right,\n.modal.show .modal-left {\n  transform: translate(0, 0) !important;\n}\n\n.modal-bottom {\n  display: flex;\n  flex-flow: column nowrap;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n  height: 100%;\n  margin: 0 auto;\n  align-content: center;\n}\n\n.modal-colored-header {\n  color: #fff;\n  border-radius: 0;\n}\n\n.modal-filled {\n  color: #fff;\n}\n.modal-filled .modal-header {\n  background-color: rgba(255, 255, 255, 0.07);\n}\n.modal-filled .modal-header,\n.modal-filled .modal-footer {\n  border: none;\n}\n\n.nav-tabs > li > a,\n.nav-pills > li > a {\n  color: var(--ct-gray-700);\n  font-weight: 600;\n}\n\n.nav-pills > a {\n  color: var(--ct-gray-700);\n  font-weight: 600;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: auto;\n}\n\n.navtab-bg .nav-link {\n  background-color: var(--ct-light);\n  margin: 0 5px;\n}\n\n.nav-bordered {\n  border-bottom: 2px solid var(--ct-border-color) !important;\n}\n.nav-bordered .nav-item {\n  margin-bottom: -1px;\n}\n.nav-bordered li a {\n  border: 0 !important;\n  padding: 10px 20px;\n}\n.nav-bordered a.active {\n  border-bottom: 2px solid #6658dd !important;\n}\n\n.tab-content {\n  padding: 20px 0 0 0;\n}\n\n.pagination-rounded .page-link {\n  border-radius: 30px !important;\n  margin: 0 3px !important;\n  border: none;\n}\n\n.popover-header {\n  margin-top: 0;\n}\n\n.primary-popover {\n  --ct-popover-max-width: 200px !important;\n  --ct-popover-border-color: var(--ct-primary) !important;\n  --ct-popover-header-bg: var(--ct-primary) !important;\n  --ct-popover-header-color: var(--ct-white) !important;\n  --ct-popover-body-padding-x: 1rem !important;\n  --ct-popover-body-padding-y: .5rem !important;\n}\n\n.secondary-popover {\n  --ct-popover-max-width: 200px !important;\n  --ct-popover-border-color: var(--ct-secondary) !important;\n  --ct-popover-header-bg: var(--ct-secondary) !important;\n  --ct-popover-header-color: var(--ct-white) !important;\n  --ct-popover-body-padding-x: 1rem !important;\n  --ct-popover-body-padding-y: .5rem !important;\n}\n\n.success-popover {\n  --ct-popover-max-width: 200px !important;\n  --ct-popover-border-color: var(--ct-success) !important;\n  --ct-popover-header-bg: var(--ct-success) !important;\n  --ct-popover-header-color: var(--ct-white) !important;\n  --ct-popover-body-padding-x: 1rem !important;\n  --ct-popover-body-padding-y: .5rem !important;\n}\n\n.info-popover {\n  --ct-popover-max-width: 200px !important;\n  --ct-popover-border-color: var(--ct-info) !important;\n  --ct-popover-header-bg: var(--ct-info) !important;\n  --ct-popover-header-color: var(--ct-white) !important;\n  --ct-popover-body-padding-x: 1rem !important;\n  --ct-popover-body-padding-y: .5rem !important;\n}\n\n.warning-popover {\n  --ct-popover-max-width: 200px !important;\n  --ct-popover-border-color: var(--ct-warning) !important;\n  --ct-popover-header-bg: var(--ct-warning) !important;\n  --ct-popover-header-color: var(--ct-white) !important;\n  --ct-popover-body-padding-x: 1rem !important;\n  --ct-popover-body-padding-y: .5rem !important;\n}\n\n.danger-popover {\n  --ct-popover-max-width: 200px !important;\n  --ct-popover-border-color: var(--ct-danger) !important;\n  --ct-popover-header-bg: var(--ct-danger) !important;\n  --ct-popover-header-color: var(--ct-white) !important;\n  --ct-popover-body-padding-x: 1rem !important;\n  --ct-popover-body-padding-y: .5rem !important;\n}\n\n.light-popover {\n  --ct-popover-max-width: 200px !important;\n  --ct-popover-border-color: var(--ct-light) !important;\n  --ct-popover-header-bg: var(--ct-light) !important;\n  --ct-popover-header-color: var(--ct-white) !important;\n  --ct-popover-body-padding-x: 1rem !important;\n  --ct-popover-body-padding-y: .5rem !important;\n}\n\n.dark-popover {\n  --ct-popover-max-width: 200px !important;\n  --ct-popover-border-color: var(--ct-dark) !important;\n  --ct-popover-header-bg: var(--ct-dark) !important;\n  --ct-popover-header-color: var(--ct-white) !important;\n  --ct-popover-body-padding-x: 1rem !important;\n  --ct-popover-body-padding-y: .5rem !important;\n}\n\n.pink-popover {\n  --ct-popover-max-width: 200px !important;\n  --ct-popover-border-color: var(--ct-pink) !important;\n  --ct-popover-header-bg: var(--ct-pink) !important;\n  --ct-popover-header-color: var(--ct-white) !important;\n  --ct-popover-body-padding-x: 1rem !important;\n  --ct-popover-body-padding-y: .5rem !important;\n}\n\n.blue-popover {\n  --ct-popover-max-width: 200px !important;\n  --ct-popover-border-color: var(--ct-blue) !important;\n  --ct-popover-header-bg: var(--ct-blue) !important;\n  --ct-popover-header-color: var(--ct-white) !important;\n  --ct-popover-body-padding-x: 1rem !important;\n  --ct-popover-body-padding-y: .5rem !important;\n}\n\n@media print {\n  .app-menu,\n  .end-bar,\n  .page-title-box,\n  .navbar-custom,\n  .footer {\n    display: none;\n  }\n  .card-body,\n  .content-page,\n  .end-bar,\n  .content,\n  body {\n    padding: 0;\n    margin: 0;\n  }\n  .card {\n    box-shadow: none;\n  }\n}\n.progress-sm {\n  height: 5px;\n}\n\n.progress-md {\n  height: 8px;\n}\n\n.progress-lg {\n  height: 12px;\n}\n\n.progress-xl {\n  height: 15px;\n}\n\n/* Progressbar Vertical */\n.progress-vertical {\n  min-height: 250px;\n  height: 250px;\n  width: 10px;\n  position: relative;\n  display: inline-block;\n  margin-bottom: 0;\n  margin-right: 20px;\n}\n.progress-vertical .progress-bar {\n  width: 100%;\n}\n.progress-vertical.progress-xl {\n  width: 15px;\n}\n.progress-vertical.progress-lg {\n  width: 12px;\n}\n.progress-vertical.progress-md {\n  width: 8px;\n}\n.progress-vertical.progress-sm {\n  width: 5px;\n}\n\n.progress-vertical-bottom {\n  min-height: 250px;\n  height: 250px;\n  position: relative;\n  width: 10px;\n  display: inline-block;\n  margin-bottom: 0;\n  margin-right: 20px;\n}\n.progress-vertical-bottom .progress-bar {\n  width: 100%;\n  bottom: 0;\n  position: absolute;\n}\n.progress-vertical-bottom.progress-xl {\n  width: 15px;\n}\n.progress-vertical-bottom.progress-lg {\n  width: 12px;\n}\n.progress-vertical-bottom.progress-md {\n  width: 8px;\n}\n.progress-vertical-bottom.progress-sm {\n  width: 5px;\n}\n\nhtml {\n  position: relative;\n  min-height: 100%;\n}\n\n@supports (-webkit-overflow-scrolling: touch) {\n  body {\n    cursor: pointer;\n  }\n}\nbody {\n  overflow-x: hidden;\n}\n\nbutton,\na {\n  outline: none !important;\n}\n\nlabel {\n  font-weight: 600;\n}\n\naddress.address-lg {\n  line-height: 24px;\n}\n\nb,\nstrong {\n  font-weight: 700;\n}\n\n.ribbon-box {\n  position: relative;\n  /* Ribbon two */\n}\n.ribbon-box .ribbon {\n  position: relative;\n  clear: both;\n  padding: 5px 12px;\n  margin-bottom: 15px;\n  box-shadow: 2px 5px 10px rgba(50, 58, 70, 0.15);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n}\n.ribbon-box .ribbon:before {\n  content: \" \";\n  border-style: solid;\n  border-width: 10px;\n  display: block;\n  position: absolute;\n  bottom: -10px;\n  left: 0;\n  margin-bottom: -10px;\n  z-index: -1;\n}\n.ribbon-box .ribbon.float-start {\n  margin-left: -30px;\n  border-radius: 0 3px 3px 0;\n}\n.ribbon-box .ribbon.float-end {\n  margin-right: -30px;\n  border-radius: 3px 0 0 3px;\n}\n.ribbon-box .ribbon.float-end:before {\n  right: 0;\n}\n.ribbon-box .ribbon.float-center span {\n  margin: 0 auto 20px auto;\n}\n.ribbon-box .ribbon-content {\n  clear: both;\n}\n.ribbon-box .ribbon-primary {\n  background: #6658dd;\n}\n.ribbon-box .ribbon-primary:before {\n  border-color: rgb(82.5895522388, 66.8134328358, 216.6865671642) transparent transparent;\n}\n.ribbon-box .ribbon-secondary {\n  background: #6c757d;\n}\n.ribbon-box .ribbon-secondary:before {\n  border-color: rgb(96.1802575107, 104.19527897, 111.3197424893) transparent transparent;\n}\n.ribbon-box .ribbon-success {\n  background: #1abc9c;\n}\n.ribbon-box .ribbon-success:before {\n  border-color: rgb(22.9018691589, 165.5981308411, 137.4112149533) transparent transparent;\n}\n.ribbon-box .ribbon-info {\n  background: #43bfe5;\n}\n.ribbon-box .ribbon-info:before {\n  border-color: rgb(44.5981308411, 183.3738317757, 225.9018691589) transparent transparent;\n}\n.ribbon-box .ribbon-warning {\n  background: #f7b84b;\n}\n.ribbon-box .ribbon-warning:before {\n  border-color: rgb(245.914893617, 174.3696808511, 50.585106383) transparent transparent;\n}\n.ribbon-box .ribbon-danger {\n  background: #f1556c;\n}\n.ribbon-box .ribbon-danger:before {\n  border-color: rgb(239.0597826087, 61.4402173913, 87.6277173913) transparent transparent;\n}\n.ribbon-box .ribbon-light {\n  background: #f3f7f9;\n}\n.ribbon-box .ribbon-light:before {\n  border-color: rgb(226, 235.6666666667, 240.5) transparent transparent;\n}\n.ribbon-box .ribbon-dark {\n  background: #323a46;\n}\n.ribbon-box .ribbon-dark:before {\n  border-color: rgb(39.375, 45.675, 55.125) transparent transparent;\n}\n.ribbon-box .ribbon-pink {\n  background: #f672a7;\n}\n.ribbon-box .ribbon-pink:before {\n  border-color: rgb(244.47, 90.03, 152.04) transparent transparent;\n}\n.ribbon-box .ribbon-blue {\n  background: #4a81d4;\n}\n.ribbon-box .ribbon-blue:before {\n  border-color: rgb(53.3950892857, 114.65625, 207.1049107143) transparent transparent;\n}\n.ribbon-box .ribbon-two {\n  position: absolute;\n  left: -5px;\n  top: -5px;\n  z-index: 1;\n  overflow: hidden;\n  width: 75px;\n  height: 75px;\n  text-align: right;\n}\n.ribbon-box .ribbon-two span {\n  font-size: 13px;\n  color: #fff;\n  text-align: center;\n  line-height: 20px;\n  transform: rotate(-45deg);\n  width: 100px;\n  display: block;\n  box-shadow: 0 0 8px 0 rgba(50, 58, 70, 0.08), 0 1px 0 0 rgba(50, 58, 70, 0.03);\n  position: absolute;\n  top: 19px;\n  left: -21px;\n  font-weight: 600;\n}\n.ribbon-box .ribbon-two span:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 100%;\n  z-index: -1;\n  border-right: 3px solid transparent;\n  border-bottom: 3px solid transparent;\n}\n.ribbon-box .ribbon-two span:after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 100%;\n  z-index: -1;\n  border-left: 3px solid transparent;\n  border-bottom: 3px solid transparent;\n}\n.ribbon-box .ribbon-two-primary span {\n  background: #6658dd;\n}\n.ribbon-box .ribbon-two-primary span:before {\n  border-left: 3px solid rgb(82.5895522388, 66.8134328358, 216.6865671642);\n  border-top: 3px solid rgb(82.5895522388, 66.8134328358, 216.6865671642);\n}\n.ribbon-box .ribbon-two-primary span:after {\n  border-right: 3px solid rgb(82.5895522388, 66.8134328358, 216.6865671642);\n  border-top: 3px solid rgb(82.5895522388, 66.8134328358, 216.6865671642);\n}\n.ribbon-box .ribbon-two-secondary span {\n  background: #6c757d;\n}\n.ribbon-box .ribbon-two-secondary span:before {\n  border-left: 3px solid rgb(96.1802575107, 104.19527897, 111.3197424893);\n  border-top: 3px solid rgb(96.1802575107, 104.19527897, 111.3197424893);\n}\n.ribbon-box .ribbon-two-secondary span:after {\n  border-right: 3px solid rgb(96.1802575107, 104.19527897, 111.3197424893);\n  border-top: 3px solid rgb(96.1802575107, 104.19527897, 111.3197424893);\n}\n.ribbon-box .ribbon-two-success span {\n  background: #1abc9c;\n}\n.ribbon-box .ribbon-two-success span:before {\n  border-left: 3px solid rgb(22.9018691589, 165.5981308411, 137.4112149533);\n  border-top: 3px solid rgb(22.9018691589, 165.5981308411, 137.4112149533);\n}\n.ribbon-box .ribbon-two-success span:after {\n  border-right: 3px solid rgb(22.9018691589, 165.5981308411, 137.4112149533);\n  border-top: 3px solid rgb(22.9018691589, 165.5981308411, 137.4112149533);\n}\n.ribbon-box .ribbon-two-info span {\n  background: #43bfe5;\n}\n.ribbon-box .ribbon-two-info span:before {\n  border-left: 3px solid rgb(44.5981308411, 183.3738317757, 225.9018691589);\n  border-top: 3px solid rgb(44.5981308411, 183.3738317757, 225.9018691589);\n}\n.ribbon-box .ribbon-two-info span:after {\n  border-right: 3px solid rgb(44.5981308411, 183.3738317757, 225.9018691589);\n  border-top: 3px solid rgb(44.5981308411, 183.3738317757, 225.9018691589);\n}\n.ribbon-box .ribbon-two-warning span {\n  background: #f7b84b;\n}\n.ribbon-box .ribbon-two-warning span:before {\n  border-left: 3px solid rgb(245.914893617, 174.3696808511, 50.585106383);\n  border-top: 3px solid rgb(245.914893617, 174.3696808511, 50.585106383);\n}\n.ribbon-box .ribbon-two-warning span:after {\n  border-right: 3px solid rgb(245.914893617, 174.3696808511, 50.585106383);\n  border-top: 3px solid rgb(245.914893617, 174.3696808511, 50.585106383);\n}\n.ribbon-box .ribbon-two-danger span {\n  background: #f1556c;\n}\n.ribbon-box .ribbon-two-danger span:before {\n  border-left: 3px solid rgb(239.0597826087, 61.4402173913, 87.6277173913);\n  border-top: 3px solid rgb(239.0597826087, 61.4402173913, 87.6277173913);\n}\n.ribbon-box .ribbon-two-danger span:after {\n  border-right: 3px solid rgb(239.0597826087, 61.4402173913, 87.6277173913);\n  border-top: 3px solid rgb(239.0597826087, 61.4402173913, 87.6277173913);\n}\n.ribbon-box .ribbon-two-light span {\n  background: #f3f7f9;\n}\n.ribbon-box .ribbon-two-light span:before {\n  border-left: 3px solid rgb(226, 235.6666666667, 240.5);\n  border-top: 3px solid rgb(226, 235.6666666667, 240.5);\n}\n.ribbon-box .ribbon-two-light span:after {\n  border-right: 3px solid rgb(226, 235.6666666667, 240.5);\n  border-top: 3px solid rgb(226, 235.6666666667, 240.5);\n}\n.ribbon-box .ribbon-two-dark span {\n  background: #323a46;\n}\n.ribbon-box .ribbon-two-dark span:before {\n  border-left: 3px solid rgb(39.375, 45.675, 55.125);\n  border-top: 3px solid rgb(39.375, 45.675, 55.125);\n}\n.ribbon-box .ribbon-two-dark span:after {\n  border-right: 3px solid rgb(39.375, 45.675, 55.125);\n  border-top: 3px solid rgb(39.375, 45.675, 55.125);\n}\n.ribbon-box .ribbon-two-pink span {\n  background: #f672a7;\n}\n.ribbon-box .ribbon-two-pink span:before {\n  border-left: 3px solid rgb(244.47, 90.03, 152.04);\n  border-top: 3px solid rgb(244.47, 90.03, 152.04);\n}\n.ribbon-box .ribbon-two-pink span:after {\n  border-right: 3px solid rgb(244.47, 90.03, 152.04);\n  border-top: 3px solid rgb(244.47, 90.03, 152.04);\n}\n.ribbon-box .ribbon-two-blue span {\n  background: #4a81d4;\n}\n.ribbon-box .ribbon-two-blue span:before {\n  border-left: 3px solid rgb(53.3950892857, 114.65625, 207.1049107143);\n  border-top: 3px solid rgb(53.3950892857, 114.65625, 207.1049107143);\n}\n.ribbon-box .ribbon-two-blue span:after {\n  border-right: 3px solid rgb(53.3950892857, 114.65625, 207.1049107143);\n  border-top: 3px solid rgb(53.3950892857, 114.65625, 207.1049107143);\n}\n\ninput[data-switch] {\n  display: none;\n}\ninput[data-switch] + label {\n  width: 56px;\n  height: 24px;\n  background-color: var(--ct-gray-100);\n  background-image: none;\n  border-radius: 2rem;\n  cursor: pointer;\n  display: inline-block;\n  text-align: center;\n  position: relative;\n  transition: all 0.1s ease-in-out;\n}\ninput[data-switch] + label:before {\n  color: var(--ct-secondary-bg-subtle);\n  content: attr(data-off-label);\n  display: block;\n  font-family: inherit;\n  font-weight: 600;\n  font-size: 0.75rem;\n  line-height: 24px;\n  position: absolute;\n  right: 3px;\n  margin: 0 0.21667rem;\n  top: 0;\n  text-align: center;\n  min-width: 1.66667rem;\n  overflow: hidden;\n  transition: all 0.1s ease-in-out;\n}\ninput[data-switch] + label:after {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  background-color: var(--ct-body-color);\n  box-shadow: none;\n  border-radius: 2rem;\n  height: 18px;\n  width: 18px;\n  top: 3px;\n  transition: all 0.1s ease-in-out;\n}\ninput[data-switch]:checked + label {\n  background-color: #6658dd;\n}\ninput[data-switch]:checked + label:before {\n  color: #fff;\n  content: attr(data-on-label);\n  right: auto;\n  left: 4px;\n}\ninput[data-switch]:checked + label:after {\n  left: 34px;\n  background-color: var(--ct-gray-100);\n}\n\ninput[data-switch=bool] + label {\n  background-color: #f1556c;\n}\n\ninput:disabled + label {\n  opacity: 0.5;\n  cursor: default;\n}\n\ninput[data-switch=bool] + label:before,\ninput[data-switch=bool]:checked + label:before {\n  color: #fff !important;\n}\n\ninput[data-switch=bool] + label:after {\n  background-color: var(--ct-gray-100);\n}\n\ninput[data-switch=primary]:checked + label {\n  background-color: #6658dd;\n}\n\ninput[data-switch=secondary]:checked + label {\n  background-color: #6c757d;\n}\n\ninput[data-switch=success]:checked + label {\n  background-color: #1abc9c;\n}\n\ninput[data-switch=info]:checked + label {\n  background-color: #43bfe5;\n}\n\ninput[data-switch=warning]:checked + label {\n  background-color: #f7b84b;\n}\n\ninput[data-switch=danger]:checked + label {\n  background-color: #f1556c;\n}\n\ninput[data-switch=light]:checked + label {\n  background-color: #f3f7f9;\n}\n\ninput[data-switch=dark]:checked + label {\n  background-color: #323a46;\n}\n\ninput[data-switch=pink]:checked + label {\n  background-color: #f672a7;\n}\n\ninput[data-switch=blue]:checked + label {\n  background-color: #4a81d4;\n}\n\n.table-centered th,\n.table-centered td {\n  vertical-align: middle !important;\n}\n\n.table .table-user img {\n  height: 30px;\n  width: 30px;\n}\n.table .action-icon {\n  color: var(--ct-gray-600);\n  font-size: 1.2rem;\n  display: inline-block;\n  padding: 0 3px;\n}\n.table .action-icon:hover {\n  color: var(--ct-gray-700);\n}\n.table > :not(caption) > * > * {\n  background-color: var(--ct-table-bg) !important;\n}\n.table.table-bordered tbody {\n  border-top: 1px solid;\n  border-top-color: inherit;\n}\n\n.table-sm .action-icon {\n  font-size: 1rem;\n}\n\n.table-nowrap th,\n.table-nowrap td {\n  white-space: nowrap;\n}\n\nhtml[data-bs-theme=dark] .table-light {\n  --ct-table-bg: #3e4954;\n  --ct-table-border-color: var(--ct-border-color);\n  color: var(--ct-body-color);\n}\nhtml[data-bs-theme=dark] .table-dark {\n  --ct-table-bg: var(--ct-light);\n}\nhtml[data-bs-theme=dark] .table-dark tbody,\nhtml[data-bs-theme=dark] .table-dark tr {\n  border-color: var(--ct-gray-300);\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 10px 0;\n}\n\n.font-10 {\n  font-size: 10px !important;\n}\n\n.font-11 {\n  font-size: 11px !important;\n}\n\n.font-12 {\n  font-size: 12px !important;\n}\n\n.font-13 {\n  font-size: 13px !important;\n}\n\n.font-14 {\n  font-size: 14px !important;\n}\n\n.font-15 {\n  font-size: 15px !important;\n}\n\n.font-16 {\n  font-size: 16px !important;\n}\n\n.font-17 {\n  font-size: 17px !important;\n}\n\n.font-18 {\n  font-size: 18px !important;\n}\n\n.font-19 {\n  font-size: 19px !important;\n}\n\n.font-20 {\n  font-size: 20px !important;\n}\n\n.font-21 {\n  font-size: 21px !important;\n}\n\n.font-22 {\n  font-size: 22px !important;\n}\n\n.font-23 {\n  font-size: 23px !important;\n}\n\n.font-24 {\n  font-size: 24px !important;\n}\n\n.font-36 {\n  font-size: 36px !important;\n}\n\n.font-48 {\n  font-size: 48px !important;\n}\n\n.fw-medium {\n  font-weight: 500;\n}\n\n.fw-semibold {\n  font-weight: 600;\n}\n\n.primary-tooltip {\n  --ct-tooltip-bg: var(--ct-primary) !important;\n  --ct-tooltip-color: white !important;\n}\n\n.secondary-tooltip {\n  --ct-tooltip-bg: var(--ct-secondary) !important;\n  --ct-tooltip-color: white !important;\n}\n\n.success-tooltip {\n  --ct-tooltip-bg: var(--ct-success) !important;\n  --ct-tooltip-color: white !important;\n}\n\n.info-tooltip {\n  --ct-tooltip-bg: var(--ct-info) !important;\n  --ct-tooltip-color: white !important;\n}\n\n.warning-tooltip {\n  --ct-tooltip-bg: var(--ct-warning) !important;\n  --ct-tooltip-color: white !important;\n}\n\n.danger-tooltip {\n  --ct-tooltip-bg: var(--ct-danger) !important;\n  --ct-tooltip-color: white !important;\n}\n\n.light-tooltip {\n  --ct-tooltip-bg: var(--ct-light) !important;\n  --ct-tooltip-color: white !important;\n}\n\n.dark-tooltip {\n  --ct-tooltip-bg: var(--ct-dark) !important;\n  --ct-tooltip-color: white !important;\n}\n\n.pink-tooltip {\n  --ct-tooltip-bg: var(--ct-pink) !important;\n  --ct-tooltip-color: white !important;\n}\n\n.blue-tooltip {\n  --ct-tooltip-bg: var(--ct-blue) !important;\n  --ct-tooltip-color: white !important;\n}\n\n.bg-soft-primary {\n  --ct-bg-opacity: 0.25;\n  background-color: rgba(var(--ct-primary-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-soft-secondary {\n  --ct-bg-opacity: 0.25;\n  background-color: rgba(var(--ct-secondary-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-soft-success {\n  --ct-bg-opacity: 0.25;\n  background-color: rgba(var(--ct-success-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-soft-info {\n  --ct-bg-opacity: 0.25;\n  background-color: rgba(var(--ct-info-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-soft-warning {\n  --ct-bg-opacity: 0.25;\n  background-color: rgba(var(--ct-warning-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-soft-danger {\n  --ct-bg-opacity: 0.25;\n  background-color: rgba(var(--ct-danger-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-soft-light {\n  --ct-bg-opacity: 0.25;\n  background-color: rgba(var(--ct-light-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-soft-dark {\n  --ct-bg-opacity: 0.25;\n  background-color: rgba(var(--ct-dark-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-soft-pink {\n  --ct-bg-opacity: 0.25;\n  background-color: rgba(var(--ct-pink-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-soft-blue {\n  --ct-bg-opacity: 0.25;\n  background-color: rgba(var(--ct-blue-rgb), var(--ct-bg-opacity)) !important;\n}\n\n.bg-ghost {\n  --ct-bg-opacity: 0.4;\n}\n\n.border-dashed {\n  border-style: dashed !important;\n}\n\n:not(pre) > code[class*=language-],\npre[class*=language-] {\n  background: transparent;\n}\n\ncode[class*=language-],\npre[class*=language-] {\n  color: black;\n  background: none;\n  text-shadow: 0 1px white;\n  font-family: Consolas, Monaco, \"Andale Mono\", \"Ubuntu Mono\", monospace;\n  font-size: 1em;\n  text-align: left;\n  white-space: pre;\n  word-spacing: normal;\n  word-break: normal;\n  word-wrap: normal;\n  line-height: 1.5;\n  tab-size: 4;\n  hyphens: none;\n}\n\npre[class*=language-]::selection,\npre[class*=language-] ::selection,\ncode[class*=language-]::selection,\ncode[class*=language-] ::selection {\n  text-shadow: none;\n  background: #b3d4fc;\n}\n\n@media print {\n  code[class*=language-],\n  pre[class*=language-] {\n    text-shadow: none;\n  }\n}\n/* Code blocks */\npre[class*=language-] {\n  padding: 1em;\n  margin: 0;\n  overflow: auto;\n}\n\n/* Inline code */\n:not(pre) > code[class*=language-] {\n  padding: 0.1em;\n  border-radius: 0.3em;\n  white-space: normal;\n}\n\n.token.comment,\n.token.prolog,\n.token.doctype,\n.token.cdata {\n  color: slategray;\n}\n\n.token.punctuation {\n  color: #6658dd;\n}\n\n.token.namespace {\n  opacity: 0.7;\n}\n\n.token.property,\n.token.tag,\n.token.boolean,\n.token.number,\n.token.constant,\n.token.symbol,\n.token.deleted {\n  color: #6658dd;\n}\n\n.token.selector,\n.token.attr-name,\n.token.string,\n.token.char,\n.token.builtin,\n.token.inserted {\n  color: #1abc9c;\n}\n\n.token.operator,\n.token.entity,\n.token.url,\n.language-css .token.string,\n.style .token.string {\n  color: #9a6e3a;\n  /* This background color was intended by the author of this theme. */\n  background: transparent;\n}\n\n.token.atrule,\n.token.attr-value,\n.token.keyword {\n  color: #f1556c;\n}\n\n.token.function,\n.token.class-name {\n  color: #dd4a68;\n}\n\n.token.regex,\n.token.important,\n.token.variable {\n  color: #e90;\n}\n\n.token.important,\n.token.bold {\n  font-weight: bold;\n}\n\n.token.italic {\n  font-style: italic;\n}\n\n.token.entity {\n  cursor: help;\n}\n\ncode[class*=language-],\npre[class*=language-] {\n  color: var(--ct-secondary-color);\n  text-shadow: none;\n  max-height: 220px;\n}\n\n.tab-pane.code {\n  position: relative;\n}\n.tab-pane.code pre::-webkit-scrollbar {\n  -webkit-appearance: none;\n}\n.tab-pane.code pre::-webkit-scrollbar:vertical {\n  width: 5px;\n  margin-right: 5px;\n}\n.tab-pane.code pre::-webkit-scrollbar:horizontal {\n  height: 5px;\n}\n.tab-pane.code pre::-webkit-scrollbar-thumb {\n  background-color: rgba(var(--ct-dark-rgb), 0.2);\n  border-radius: 10px;\n  margin-right: 5px;\n  border: none;\n}\n.tab-pane.code pre::-webkit-scrollbar-track {\n  border-radius: 10px;\n  background-color: transparent;\n}\n.tab-pane.code pre::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n.tab-pane.code .btn-copy-clipboard {\n  position: absolute;\n  right: 8px;\n  top: 10px;\n  background-color: var(--ct-secondary-bg);\n  border: 1px solid #1abc9c;\n  color: #1abc9c;\n  padding: 0.28rem 0.8rem;\n  font-size: 0.875rem;\n  border-radius: 0.15rem;\n  font-weight: 400;\n  line-height: 1.5;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n.tab-pane.code .btn-copy-clipboard:hover, .tab-pane.code .btn-copy-clipboard:focus, .tab-pane.code .btn-copy-clipboard:active {\n  background-color: #1abc9c;\n  color: #fff;\n}\n\n.widget-flat {\n  position: relative;\n  overflow: hidden;\n}\n.widget-flat i.widget-icon {\n  font-size: 36px;\n}\n\n.inbox-widget .inbox-item {\n  border-bottom: 1px solid var(--ct-gray-300);\n  overflow: hidden;\n  padding: 0.625rem 0;\n  position: relative;\n}\n.inbox-widget .inbox-item:last-of-type {\n  border-bottom: none;\n}\n.inbox-widget .inbox-item .inbox-item-img {\n  display: block;\n  float: left;\n  margin-right: 15px;\n  width: 40px;\n}\n.inbox-widget .inbox-item .inbox-item-img img {\n  width: 40px;\n}\n.inbox-widget .inbox-item .inbox-item-author {\n  display: block;\n  margin-bottom: 3px;\n}\n.inbox-widget .inbox-item .inbox-item-text {\n  color: var(--ct-gray);\n  display: block;\n  font-size: 0.8125rem;\n  margin: 0;\n  overflow: hidden;\n}\n.inbox-widget .inbox-item .inbox-item-date {\n  color: var(--ct-gray-600);\n  font-size: 0.6875rem;\n  position: absolute;\n  right: 5px;\n  top: 10px;\n}\n\n/* Chat widget */\n.conversation-list {\n  list-style: none;\n  padding: 0 15px;\n}\n.conversation-list li {\n  margin-bottom: 20px;\n}\n.conversation-list li .conversation-actions {\n  float: right;\n  display: none;\n}\n.conversation-list li:hover .conversation-actions {\n  display: block;\n}\n.conversation-list .chat-avatar {\n  float: left;\n  text-align: center;\n  width: 42px;\n}\n.conversation-list .chat-avatar img {\n  border-radius: 100%;\n  width: 100%;\n}\n.conversation-list .chat-avatar i {\n  font-size: 12px;\n  font-style: normal;\n}\n.conversation-list .ctext-wrap {\n  background: var(--ct-light);\n  border-radius: 3px;\n  display: inline-block;\n  padding: 12px;\n  position: relative;\n}\n.conversation-list .ctext-wrap i {\n  display: block;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  position: relative;\n}\n.conversation-list .ctext-wrap p {\n  margin: 0;\n  padding-top: 3px;\n}\n.conversation-list .ctext-wrap:after {\n  left: -10px;\n  top: 0;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n  border-top-color: var(--ct-light);\n  border-width: 6px;\n  margin-right: -1px;\n  border-right-color: var(--ct-light);\n}\n.conversation-list .conversation-text {\n  float: left;\n  font-size: 12px;\n  margin-left: 12px;\n  width: 70%;\n}\n.conversation-list .odd .chat-avatar {\n  float: right !important;\n}\n.conversation-list .odd .conversation-text {\n  float: right !important;\n  margin-right: 12px;\n  text-align: right;\n  width: 70% !important;\n}\n.conversation-list .odd .ctext-wrap {\n  background-color: var(--ct-light);\n}\n.conversation-list .odd .ctext-wrap:after {\n  border-color: transparent;\n  border-left-color: var(--ct-light);\n  border-top-color: var(--ct-light);\n  right: -10px !important;\n  left: auto;\n}\n.conversation-list .odd .conversation-actions {\n  float: left;\n}\n\n.horizontal-steps {\n  display: flex;\n  position: relative;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.horizontal-steps:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 0.2em;\n  background-color: var(--ct-gray-100);\n}\n.horizontal-steps .process-line {\n  display: block;\n  position: absolute;\n  width: 50%;\n  height: 0.2em;\n  background-color: #6658dd;\n}\n.horizontal-steps .horizontal-steps-content {\n  display: flex;\n  position: relative;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.horizontal-steps .horizontal-steps-content .step-item {\n  display: block;\n  position: relative;\n  bottom: calc(100% + 1em);\n  height: 8px;\n  width: 8px;\n  margin: 0 2em;\n  box-sizing: content-box;\n  color: #6658dd;\n  background-color: currentColor;\n  border: 0.25em solid var(--ct-gray-900);\n  border-radius: 50%;\n  z-index: 5;\n}\n.horizontal-steps .horizontal-steps-content .step-item:first-child {\n  margin-left: 0;\n}\n.horizontal-steps .horizontal-steps-content .step-item:last-child {\n  margin-right: 0;\n  color: #1abc9c;\n}\n.horizontal-steps .horizontal-steps-content .step-item span {\n  position: absolute;\n  top: calc(100% + 1em);\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  color: var(--ct-body-color);\n}\n.horizontal-steps .horizontal-steps-content .step-item.current:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 48%;\n  left: 48%;\n  padding: 1em;\n  background-color: currentColor;\n  border-radius: 50%;\n  opacity: 0;\n  z-index: -1;\n  animation-name: animation-steps-current;\n  animation-duration: 2s;\n  animation-iteration-count: infinite;\n  animation-timing-function: ease-out;\n}\n.horizontal-steps .horizontal-steps-content .step-item.current span {\n  color: #6658dd !important;\n}\n\n@keyframes animation-steps-current {\n  from {\n    transform: translate(-50%, -50%) scale(0);\n    opacity: 1;\n  }\n  to {\n    transform: translate(-50%, -50%) scale(1);\n    opacity: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .horizontal-steps .horizontal-steps-content .step-item span {\n    white-space: inherit;\n  }\n}\n#preloader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--ct-secondary-bg);\n  z-index: 9999;\n}\n\n#status {\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin: -20px 0 0 -20px;\n}\n\n.spinner {\n  margin: 0 auto;\n  font-size: 10px;\n  position: relative;\n  text-indent: -9999em;\n  border-top: 5px solid var(--ct-gray-300);\n  border-right: 5px solid var(--ct-gray-300);\n  border-bottom: 5px solid var(--ct-gray-300);\n  border-left: 5px solid var(--ct-primary);\n  transform: translateZ(0);\n  animation: SpinnerAnimation 1.1s infinite linear;\n}\n\n.spinner,\n.spinner:after {\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n}\n\n@keyframes SpinnerAnimation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.hero-section {\n  position: relative;\n  padding: 80px 0 120px 0;\n}\n.hero-section:after {\n  content: \" \";\n  background-image: linear-gradient(to bottom, #6379c3, #546ee5);\n  position: absolute;\n  top: -400px;\n  right: 0;\n  bottom: 0;\n  z-index: -1;\n  width: 100%;\n  border-radius: 0;\n  transform: skewY(-3deg);\n}\n.hero-section .hero-title {\n  line-height: 42px;\n}\n\n/*\nTemplate Name: Ubold - Bootstrap 5 Landing Page Tamplat\nAuthor: CoderThemes\nEmail: coderthemes@gmail.com\nFile: Main scss file\n*/\n/*******************************\n01.Helper\n02.Navbar\n03.Home\n04.Features\n05.Demo\n06.Pricing\n07.Faqs\n08.Testionial\n09.Contact\n10.Cta\n11.Footer\n12.Responsive\n********************************/\n@font-face {\n  font-family: \"Cerebri Sans,sans-serif\";\n  src: url(\"../../../fonts/cerebrisans-light.eot\");\n  src: local(\"Cerebri-sans Light\"), url(\"../../../fonts/cerebrisans-light.woff\") format(\"woff\");\n  font-weight: 300;\n}\n@font-face {\n  font-family: \"Cerebri Sans,sans-serif\";\n  src: url(\"../../../fonts/cerebrisans-regular.eot\");\n  src: local(\"Cerebri-sans Regular\"), url(\"../../../fonts/cerebrisans-regular.woff\") format(\"woff\");\n  font-weight: 400;\n}\n@font-face {\n  font-family: \"Cerebri Sans,sans-serif\";\n  src: url(\"../../../fonts/cerebrisans-medium.eot\");\n  src: local(\"Cerebri-sans Medium\"), url(\"../../../fonts/cerebrisans-medium.woff\") format(\"woff\");\n  font-weight: 500;\n}\n@font-face {\n  font-family: \"Cerebri Sans,sans-serif\";\n  src: url(\"../../../fonts/cerebrisans-semibold.eot\");\n  src: local(\"Cerebri-sans Semibold\"), url(\"../../../fonts/cerebrisans-semibold.woff\") format(\"woff\");\n  font-weight: 600;\n}\n@font-face {\n  font-family: \"Cerebri Sans,sans-serif\";\n  src: url(\"../../../fonts/cerebrisans-bold.eot\");\n  src: local(\"Cerebri-sans Bold\"), url(\"../../../fonts/cerebrisans-bold.woff\") format(\"woff\");\n  font-weight: 700;\n}\n/*******************\n    1.Helper\n*******************/\nh1, .h1,\nh2,\n.h2,\nh3,\n.h3,\nh4,\n.h4,\nh5,\n.h5,\nh6,\n.h6 {\n  font-family: \"Cerebri Sans,sans-serif\";\n}\n\nh3, .h3 {\n  line-height: 30px;\n}\n\na {\n  text-decoration: none !important;\n  outline: none;\n}\n\np {\n  line-height: 1.6;\n  font-size: 15px;\n}\n\n#landing {\n  font-family: \"Nunito\", sans-serif;\n  font-size: 14px;\n  background-color: #ffffff;\n  /**BACK TO TOP**/\n  /******************\n      2.Navbar\n  *******************/\n  /*--- navbar sticky ---*/\n  /*******************\n      3.Home\n  *******************/\n  /*******************\n      4.features\n  ********************/\n  /*******************\n      5.demo\n  ********************/\n  /*******************\n      6.pricing\n  ********************/\n  /*******************\n      7.faqs\n  ********************/\n  /*******************\n      8.testionial\n  ********************/\n  /*******************\n      9.contact\n  ********************/\n  /*******************\n      10.cta\n  ********************/\n  /*******************\n      11.footer\n  ********************/\n  /******************\n      12.Responsive\n  *******************/\n}\n#landing .section {\n  position: relative;\n  padding-top: 80px;\n  padding-bottom: 80px;\n}\n#landing .section-sm {\n  position: relative;\n  padding-top: 60px;\n  padding-bottom: 60px;\n}\n#landing html {\n  scroll-padding-top: 59px; /* height of sticky header */\n}\n#landing .row > * {\n  position: relative;\n}\n@media (min-width: 1400px) {\n  #landing .container {\n    max-width: 1140px;\n  }\n}\n#landing .bg-gradient {\n  background: linear-gradient(to left, #673ab7, #3e1e8c) !important;\n}\n#landing .back-to-top-btn {\n  position: fixed;\n  padding: 0px 3px !important;\n  bottom: 10px;\n  right: 20px;\n  display: none;\n  text-align: center;\n  -webkit-border-radius: 3px;\n  -moz-border-radius: 3px;\n  border-radius: 3px;\n}\n#landing .back-to-top-btn i {\n  font-size: 22px;\n  line-height: 28px;\n}\n#landing .navbar-custom {\n  padding: 20px 0px;\n  width: 100%;\n  border-radius: 0px;\n  z-index: 999;\n  margin-bottom: 0px;\n  transition: all 0.5s ease-in-out;\n}\n#landing .navbar-custom .logo .logo-light {\n  display: inline-block;\n}\n#landing .navbar-custom .logo .logo-dark {\n  display: none;\n}\n#landing .navbar-custom .navbar-nav .nav-item .nav-link {\n  line-height: 26px;\n  color: rgba(255, 255, 255, 0.6);\n  transition: all 0.4s;\n  background-color: transparent !important;\n  padding: 6px 10px;\n  margin: 0 7px;\n  font-weight: 600;\n}\n#landing .navbar-custom .navbar-nav .nav-item .nav-link:hover, #landing .navbar-custom .navbar-nav .nav-item .nav-link.active, #landing .navbar-custom .navbar-nav .nav-item .nav-link:active {\n  color: #ffffff;\n}\n#landing .navbar-toggler {\n  font-size: 24px;\n  margin-top: 5px;\n  margin-bottom: 0px;\n  color: #ffffff;\n}\n#landing .nav-sticky.navbar-custom {\n  margin-top: 0px;\n  padding: 10px 0px;\n  background-color: #ffffff;\n  box-shadow: 0 10px 33px -14px rgba(0, 0, 0, 0.1);\n}\n#landing .nav-sticky.navbar-custom .logo .logo-dark {\n  display: inline-block;\n}\n#landing .nav-sticky.navbar-custom .logo .logo-light {\n  display: none;\n}\n#landing .nav-sticky.navbar-custom .navbar-nav .nav-item .nav-link {\n  color: rgba(40, 40, 46, 0.8);\n}\n#landing .nav-sticky.navbar-custom .navbar-nav .nav-item .nav-link:hover, #landing .nav-sticky.navbar-custom .navbar-nav .nav-item .nav-link.active, #landing .nav-sticky.navbar-custom .navbar-nav .nav-item .nav-link:active {\n  color: #673ab7;\n}\n#landing .bg-home {\n  position: relative;\n  padding: 200px 0px 180px 0px;\n}\n#landing .home-center {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n#landing .home-desc-center {\n  display: table-cell;\n  vertical-align: middle;\n}\n#landing .home-title .home-desc {\n  max-width: 605px;\n  font-size: 16px;\n}\n#landing .home-title .subscribe input {\n  padding: 10px 20px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  height: 43px;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.6);\n  background: rgba(255, 255, 255, 0.1);\n}\n#landing .home-title .subscribe input::-webkit-input-placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n#landing .home-title .subscribe input:-moz-placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n#landing .home-title .subscribe input::-moz-placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n#landing .home-title .subscribe input:-ms-input-placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n#landing .home-title .subscribe .btn {\n  min-height: 43px;\n}\n#landing .home-title .subscribe .form-control:focus {\n  outline: 0;\n  box-shadow: none;\n}\n#landing .home-first-img {\n  position: relative;\n  z-index: 2;\n  max-width: 300px;\n}\n#landing .home-second-img {\n  position: absolute;\n  max-width: 250px;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 61px;\n  right: 0px;\n  z-index: 1;\n  opacity: 0.8;\n}\n#landing .home-third-img {\n  position: absolute;\n  right: 0px;\n  max-width: 200px;\n  top: 50%;\n  transform: translateY(-50%);\n  opacity: 0.7;\n}\n#landing .clients {\n  position: relative;\n  top: -70px;\n  box-shadow: 0 10px 35px 0 rgba(152, 166, 173, 0.1);\n  border-radius: 8px;\n  margin-bottom: -70px;\n}\n#landing .clients .client-images img {\n  margin: 10px auto;\n  opacity: 0.7;\n}\n#landing .features-box {\n  padding: 30px;\n  text-align: center;\n}\n#landing .features-box .features-img img {\n  max-height: 60px;\n}\n#landing .features-icon i {\n  display: inline-block;\n  width: 48px;\n  height: 48px;\n  background: linear-gradient(to left, #673ab7, #3e1e8c);\n  border-radius: 7px;\n  line-height: 48px;\n}\n#landing .demo-box,\n#landing .testi-desc {\n  box-shadow: 0 10px 35px 0 rgba(152, 166, 173, 0.1);\n  border-radius: 7px;\n}\n#landing .pricing-plan {\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  border-radius: 9px;\n  max-width: 370px;\n  margin: 0px auto;\n}\n#landing .pricing-plan .lable {\n  background-color: #f9f9f9;\n  color: #673ab7;\n  font-size: 12px;\n  font-weight: 700;\n  right: -26px;\n  padding: 2px 25px;\n  position: absolute;\n  text-transform: uppercase;\n  top: 20px;\n  transform: rotate(45deg);\n}\n#landing .pricing-plan.active {\n  background-image: linear-gradient(120deg, #63e4ec 0%, #3db9dc 100%);\n}\n#landing .pricing-list {\n  padding-left: 20px;\n}\n#landing .pricing-list li {\n  padding-left: 25px;\n  position: relative;\n}\n#landing .pricing-list li i {\n  position: absolute;\n  left: 0;\n}\n#landing .bg-shape {\n  position: absolute;\n  bottom: -1px;\n  left: 0px;\n  right: 0px;\n}\n#landing .bg-shape img {\n  width: 100%;\n}\n#landing .faq-question-q-box {\n  height: 30px;\n  width: 30px;\n  color: #673ab7;\n  text-align: center;\n  border-radius: 50%;\n  float: left;\n  font-weight: 700;\n  line-height: 30px;\n  background-color: rgba(103, 58, 183, 0.15);\n}\n#landing .faq-question {\n  margin-top: 0;\n  margin-left: 50px;\n  font-size: 16px;\n}\n#landing .faq-answer {\n  margin-left: 50px;\n  font-size: 14.5px;\n}\n#landing .testi-box .testi-desc {\n  position: relative;\n}\n#landing .testi-box .testi-desc:before {\n  content: \"\";\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  background: #ffffff;\n  bottom: -6px;\n  left: 48px;\n  transform: rotate(45deg);\n}\n#landing .testi-box .testi-img img {\n  max-width: 48px;\n}\n#landing .custom-form {\n  box-shadow: 0 10px 35px 0 rgba(152, 166, 173, 0.1);\n  border-radius: 8px;\n}\n#landing .custom-form .form-group {\n  margin-bottom: 1.5rem;\n}\n#landing .custom-form .form-group .form-control {\n  height: 43px;\n}\n#landing .custom-form .form-group textarea.form-control {\n  height: auto;\n}\n#landing .error {\n  margin: 8px 0px;\n  display: none;\n  color: #ff5d48;\n}\n#landing #ajaxsuccess {\n  font-size: 16px;\n  width: 100%;\n  display: none;\n  clear: both;\n  margin: 8px 0px;\n}\n#landing .error_message {\n  padding: 10px;\n  margin-bottom: 20px;\n  text-align: center;\n  color: #806027;\n  background-color: #fdf1db;\n  border-color: #fdebcd;\n  border-radius: 5px;\n  font-size: 14px;\n}\n#landing .contact-loader {\n  display: none;\n}\n#landing #success_page {\n  text-align: center;\n  margin-bottom: 50px;\n}\n#landing #success_page h3, #landing #success_page .h3 {\n  color: #10c469;\n  font-size: 22px;\n}\n#landing .cta {\n  background-image: linear-gradient(120deg, #63e4ec 0%, #3db9dc 100%);\n  border-radius: 8px;\n}\n#landing .footer {\n  position: unset;\n  height: unset;\n  padding: 60px 0px 20px 0px;\n}\n#landing .footer .footer-list li {\n  padding: 7px 0px;\n}\n#landing .footer .footer-list li a {\n  color: rgba(255, 255, 255, 0.4);\n  transition: all 0.4s;\n}\n#landing .footer .footer-list li a:hover {\n  color: #ffffff;\n}\n#landing .footer .social-links li a {\n  color: rgba(255, 255, 255, 0.4);\n  font-size: 18px;\n  padding: 0px 5px;\n  transition: all 0.4s;\n}\n#landing .footer .social-links li a:hover {\n  color: #ffffff;\n}\n@media (min-width: 200px) and (max-width: 1199px) {\n  #landing .container-fluid, #landing .container-sm, #landing .container-md, #landing .container-lg, #landing .container-xl, #landing .container-xxl {\n    max-width: 95%;\n  }\n}\n@media (min-width: 1200px) {\n  #landing .container-fluid, #landing .container-sm, #landing .container-md, #landing .container-lg, #landing .container-xl, #landing .container-xxl {\n    max-width: 85%;\n  }\n}\n@media (min-width: 1600px) {\n  #landing .container-fluid, #landing .container-sm, #landing .container-md, #landing .container-lg, #landing .container-xl, #landing .container-xxl {\n    max-width: 70%;\n  }\n}\n@media (min-width: 200px) and (max-width: 768px) {\n  #landing .navbar-custom {\n    margin-top: 0px;\n    padding: 10px 0px !important;\n    background-color: #ffffff !important;\n    box-shadow: 0 10px 33px -14px rgba(0, 0, 0, 0.1);\n  }\n  #landing .navbar-custom .logo .logo-dark {\n    display: inline-block;\n  }\n  #landing .navbar-custom .logo .logo-light {\n    display: none;\n  }\n  #landing .navbar-custom .navbar-nav .nav-item .nav-link {\n    transition: all 0.4s;\n    color: rgba(40, 40, 46, 0.8) !important;\n    margin: 0px;\n    padding: 6px 0px;\n  }\n  #landing .navbar-custom .navbar-nav .nav-item .nav-link:hover, #landing .navbar-custom .navbar-nav .nav-item .nav-link.active, #landing .navbar-custom .navbar-nav .nav-item .nav-link:active {\n    color: #673ab7 !important;\n  }\n  #landing .navbar-toggler {\n    font-size: 24px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n    color: #28282e;\n  }\n  #landing .bg-home {\n    padding: 130px 0px 120px 0px;\n  }\n  #landing .mo-mb-20 {\n    margin-bottom: 20px !important;\n  }\n}\n@media (max-width: 425px) {\n  #landing .home-title h1, #landing .home-title .h1 {\n    font-size: 34px;\n  }\n  #landing .home-img {\n    display: none;\n  }\n  #landing .features-content,\n  #landing .cta,\n  #landing .custom-form {\n    padding: 24px !important;\n  }\n  #landing .pull-none {\n    float: none !important;\n    text-align: center;\n  }\n}","/*\nTemplate Name: Ubold - Responsive Bootstrap 5 Admin Dashboard\nVersion: 7.0.0\nAuthor: CoderThemes\nEmail: support@coderthemes.com\nFile: Bootstrap Css File\n*/\n\n// Core files\n@import \"./node_modules/bootstrap/scss/functions\";\n@import \"./node_modules/bootstrap/scss/variables\";\n@import \"variables-default\";\n@import \"variables-dark\";\n@import \"./node_modules/bootstrap/scss/bootstrap\";\n\n// Components\n@import \"../../custom/components/accordions\";\n@import \"../../custom/components/alert\";\n@import \"../../custom/components/avatar\";\n@import \"../../custom/components/breadcrumb\";\n@import \"../../custom/components/buttons\";\n@import \"../../custom/components/card\";\n@import \"../../custom/components/custom-forms\";\n@import \"../../custom/components/dropdown\";\n@import \"../../custom/components/forms\";\n@import \"../../custom/components/mixins\";\n@import \"../../custom/components/badge\";\n@import \"../../custom/components/modal\";\n@import \"../../custom/components/nav\";\n@import \"../../custom/components/pagination\";\n@import \"../../custom/components/popover\";\n@import \"../../custom/components/print\";\n@import \"../../custom/components/progress\";\n@import \"../../custom/components/reboot\";\n@import \"../../custom/components/ribbons\";\n@import \"../../custom/components/switch\";\n@import \"../../custom/components/tables\";\n@import \"../../custom/components/type\";\n@import \"../../custom/components/tooltip\";\n@import \"../../custom/components/utilities\";\n\n// Extra Components\n@import \"../../custom/components/docs\";\n@import \"../../custom/components/widgets\";\n@import \"../../custom/components/social\";\n@import \"../../custom/components/steps\";\n@import \"../../custom/components/preloader\";\n@import \"../../custom/components/hero\";","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.0-alpha1 (https://getbootstrap.com/)\n   * Copyright 2011-2022 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  --#{$prefix}body-color: #{$body-color};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n  // scss-docs-end root-body-variables\n\n  @if $headings-color != null {\n    --#{$prefix}heading-color: #{$headings-color};\n  }\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-2xl: #{$border-radius-2xl};\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  --#{$prefix}emphasis-color: #{$emphasis-color};\n\n  // scss-docs-start form-control-vars\n  --#{$prefix}form-control-bg: var(--#{$prefix}body-bg);\n  --#{$prefix}form-control-disabled-bg: var(--#{$prefix}secondary-bg);\n  // scss-docs-end form-control-vars\n\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$emphasis-color-dark};\n\n    --#{$prefix}primary-text: #{$primary-text-dark};\n    --#{$prefix}secondary-text: #{$secondary-text-dark};\n    --#{$prefix}success-text: #{$success-text-dark};\n    --#{$prefix}info-text: #{$info-text-dark};\n    --#{$prefix}warning-text: #{$warning-text-dark};\n    --#{$prefix}danger-text: #{$danger-text-dark};\n    --#{$prefix}light-text: #{$light-text-dark};\n    --#{$prefix}dark-text: #{$dark-text-dark};\n\n    --#{$prefix}primary-bg-subtle: #{$primary-bg-subtle-dark};\n    --#{$prefix}secondary-bg-subtle: #{$secondary-bg-subtle-dark};\n    --#{$prefix}success-bg-subtle: #{$success-bg-subtle-dark};\n    --#{$prefix}info-bg-subtle: #{$info-bg-subtle-dark};\n    --#{$prefix}warning-bg-subtle: #{$warning-bg-subtle-dark};\n    --#{$prefix}danger-bg-subtle: #{$danger-bg-subtle-dark};\n    --#{$prefix}light-bg-subtle: #{$light-bg-subtle-dark};\n    --#{$prefix}dark-bg-subtle: #{$dark-bg-subtle-dark};\n\n    --#{$prefix}primary-border-subtle: #{$primary-border-subtle-dark};\n    --#{$prefix}secondary-border-subtle: #{$secondary-border-subtle-dark};\n    --#{$prefix}success-border-subtle: #{$success-border-subtle-dark};\n    --#{$prefix}info-border-subtle: #{$info-border-subtle-dark};\n    --#{$prefix}warning-border-subtle: #{$warning-border-subtle-dark};\n    --#{$prefix}danger-border-subtle: #{$danger-border-subtle-dark};\n    --#{$prefix}light-border-subtle: #{$light-border-subtle-dark};\n    --#{$prefix}dark-border-subtle: #{$dark-border-subtle-dark};\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + ' ' + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + ' ' + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      }\n      @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + ' ' + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + ' ' + $value;\n      }\n\n      @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + ' ' +  if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + ' calc(' + $min-width + if($value < 0, ' - ', ' + ') + $variable-width + ')';\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluidVal: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluidVal {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluidVal);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule {\n        #{$property}: if($rfs-mode == max-media-query, $fluidVal, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color, inherit);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. Correct the outline style in Safari.\n// 2. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n\n[type=\"search\"] {\n  outline-offset: -2px; // 1\n  -webkit-appearance: textfield; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// \n// Variables\n//\n\n// Prefix for :root CSS variables\n$prefix:                      'ct-';\n$variable-prefix:             $prefix;\n\n// Body (Main Font Family)\n$font-family-primary:      'Nunito', sans-serif;\n$font-family-secondary:    'Cerebri Sans', sans-serif;\n$body-text-align:           null;\n\n// Body Background and Text Color (Light Mode)\n$body-bg:                   #f5f6f8;\n$body-color:                #6c757d;\n\n$body-emphasis-color:       $black;\n\n$body-secondary-color:      $body-color;  // Body Color\n$body-secondary-bg:         $white; // Card Background\n\n$body-tertiary-color:       rgba($body-color, .5);\n$body-tertiary-bg:          $gray-200;\n\n$emphasis-color:            $black;\n\n// Color system\n\n// scss-docs-start gray-color-variables \n$white:    #fff;\n$gray-100: #f3f7f9;\n$gray-200: #f7f7f7;\n$gray-300: #dee2e6;\n$gray-400: #ced4da;\n$gray-500: #adb5bd;\n$gray-600: #98a6ad;\n$gray-700: #6c757d;\n$gray-800: #343a40;\n$gray-900: #323a46;\n$black:    #000;\n// scss-docs-end gray-color-variables\n\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n);\n// scss-docs-end gray-colors-map\n\n// scss-docs-start color-variables\n$blue:       #4a81d4;\n$indigo:     #675aa9;\n$purple:     #6658dd;\n$pink:       #f672a7;\n$red:        #f1556c;\n$orange:     #fd7e14;\n$yellow:     #f7b84b;\n$green:      #1abc9c;\n$teal:       #02a8b5;\n$cyan:       #43bfe5;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n);\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:    1.8;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $gray-900;\n$color-contrast-light:     $white;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%);\n$blue-200: tint-color($blue, 60%);\n$blue-300: tint-color($blue, 40%);\n$blue-400: tint-color($blue, 20%);\n$blue-500: $blue;\n$blue-600: shade-color($blue, 20%);\n$blue-700: shade-color($blue, 40%);\n$blue-800: shade-color($blue, 60%);\n$blue-900: shade-color($blue, 80%);\n\n$indigo-100: tint-color($indigo, 80%);\n$indigo-200: tint-color($indigo, 60%);\n$indigo-300: tint-color($indigo, 40%);\n$indigo-400: tint-color($indigo, 20%);\n$indigo-500: $indigo;\n$indigo-600: shade-color($indigo, 20%);\n$indigo-700: shade-color($indigo, 40%);\n$indigo-800: shade-color($indigo, 60%);\n$indigo-900: shade-color($indigo, 80%);\n\n$purple-100: tint-color($purple, 80%);\n$purple-200: tint-color($purple, 60%);\n$purple-300: tint-color($purple, 40%);\n$purple-400: tint-color($purple, 20%);\n$purple-500: $purple;\n$purple-600: shade-color($purple, 20%);\n$purple-700: shade-color($purple, 40%);\n$purple-800: shade-color($purple, 60%);\n$purple-900: shade-color($purple, 80%);\n\n$pink-100: tint-color($pink, 80%);\n$pink-200: tint-color($pink, 60%);\n$pink-300: tint-color($pink, 40%);\n$pink-400: tint-color($pink, 20%);\n$pink-500: $pink;\n$pink-600: shade-color($pink, 20%);\n$pink-700: shade-color($pink, 40%);\n$pink-800: shade-color($pink, 60%);\n$pink-900: shade-color($pink, 80%);\n\n$red-100: tint-color($red, 80%);\n$red-200: tint-color($red, 60%);\n$red-300: tint-color($red, 40%);\n$red-400: tint-color($red, 20%);\n$red-500: $red;\n$red-600: shade-color($red, 20%);\n$red-700: shade-color($red, 40%);\n$red-800: shade-color($red, 60%);\n$red-900: shade-color($red, 80%);\n\n$orange-100: tint-color($orange, 80%);\n$orange-200: tint-color($orange, 60%);\n$orange-300: tint-color($orange, 40%);\n$orange-400: tint-color($orange, 20%);\n$orange-500: $orange;\n$orange-600: shade-color($orange, 20%);\n$orange-700: shade-color($orange, 40%);\n$orange-800: shade-color($orange, 60%);\n$orange-900: shade-color($orange, 80%);\n\n$yellow-100: tint-color($yellow, 80%);\n$yellow-200: tint-color($yellow, 60%);\n$yellow-300: tint-color($yellow, 40%);\n$yellow-400: tint-color($yellow, 20%);\n$yellow-500: $yellow;\n$yellow-600: shade-color($yellow, 20%);\n$yellow-700: shade-color($yellow, 40%);\n$yellow-800: shade-color($yellow, 60%);\n$yellow-900: shade-color($yellow, 80%);\n\n$green-100: tint-color($green, 80%);\n$green-200: tint-color($green, 60%);\n$green-300: tint-color($green, 40%);\n$green-400: tint-color($green, 20%);\n$green-500: $green;\n$green-600: shade-color($green, 20%);\n$green-700: shade-color($green, 40%);\n$green-800: shade-color($green, 60%);\n$green-900: shade-color($green, 80%);\n\n$teal-100: tint-color($teal, 80%);\n$teal-200: tint-color($teal, 60%);\n$teal-300: tint-color($teal, 40%);\n$teal-400: tint-color($teal, 20%);\n$teal-500: $teal;\n$teal-600: shade-color($teal, 20%);\n$teal-700: shade-color($teal, 40%);\n$teal-800: shade-color($teal, 60%);\n$teal-900: shade-color($teal, 80%);\n\n$cyan-100: tint-color($cyan, 80%);\n$cyan-200: tint-color($cyan, 60%);\n$cyan-300: tint-color($cyan, 40%);\n$cyan-400: tint-color($cyan, 20%);\n$cyan-500: $cyan;\n$cyan-600: shade-color($cyan, 20%);\n$cyan-700: shade-color($cyan, 40%);\n$cyan-800: shade-color($cyan, 60%);\n$cyan-900: shade-color($cyan, 80%);\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n);\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n);\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n);\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n);\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n);\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n);\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n);\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n);\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n);\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n);\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $purple;\n$secondary:     $gray-700;\n$success:       $green;\n$info:          $cyan;\n$warning:       $yellow;\n$danger:        $red;\n$blue:          $blue;\n$light:         $gray-100;\n$dark:          $gray-900;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark,\n  \"pink\":       $pink,\n  \"blue\":       $blue,\n);\n// scss-docs-end theme-colors-map\n\n// scss-docs-start sass-light-mode-vars\n$primary-text:            $purple-600;\n$secondary-text:          $gray-600;\n$success-text:            $green-600;\n$info-text:               $cyan-700;\n$warning-text:            $yellow-700;\n$danger-text:             $red-600;\n$light-text:              $gray-600;\n$dark-text:               $gray-700;\n\n$primary-bg-subtle:       $purple-100;\n$secondary-bg-subtle:     $gray-100;\n$success-bg-subtle:       $green-100;\n$info-bg-subtle:          $cyan-100;\n$warning-bg-subtle:       $yellow-100;\n$danger-bg-subtle:        $red-100;\n$light-bg-subtle:         mix($gray-100, $white);\n$dark-bg-subtle:          $gray-400;\n\n$primary-border-subtle:   $purple-200;\n$secondary-border-subtle: $gray-200;\n$success-border-subtle:   $green-200;\n$info-border-subtle:      $cyan-200;\n$warning-border-subtle:   $yellow-200;\n$danger-border-subtle:    $red-200;\n$light-border-subtle:     $gray-200;\n$dark-border-subtle:      $gray-500;\n\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n);\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                false;\n$enable-rounded:              true;\n$enable-shadows:              false;\n$enable-gradients:            false;\n$enable-transitions:          true;\n$enable-reduced-motion:       true;\n$enable-smooth-scroll:        true;\n$enable-grid-classes:         true;\n$enable-container-classes:    true;\n$enable-cssgrid:              false;\n$enable-button-pointers:      true;\n$enable-rfs:                  true;\n$enable-validation-icons:     true;\n$enable-negative-margins:     true;\n$enable-deprecation-messages: true;\n$enable-important-utilities:  true;\n\n$enable-dark-mode:            true;\n$color-mode-type:             data; // `data` or `media-query`\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0));\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1.5rem;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n);\n\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n);\n// scss-docs-end position-map\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary;\n$link-decoration:                         none;\n$link-shade-percentage:                   15%;\n$link-hover-color:                        shade-color($primary, $link-shade-percentage);\n$link-hover-decoration:                   null;\n\n$stretched-link-pseudo-element:           after;\n$stretched-link-z-index:                  1;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n);\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n);\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12;\n$grid-gutter-width:           24px;\n$grid-row-columns:            6;\n\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px;\n$border-widths: (\n  0: 0,\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n);\n\n$border-style:                solid;\n$border-color:                $gray-300;\n$border-color-translucent:    rgba($black, .175);\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .25rem;\n$border-radius-sm:            .2rem;\n$border-radius-lg:            .3rem;\n$border-radius-xl:            1rem;\n$border-radius-2xl:           2rem;\n$border-radius-pill:          50rem;\n// scss-docs-end border-radius-variables\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  var(--#{$prefix}box-shadow); \n$box-shadow-sm:               var(--#{$prefix}box-shadow-sm);\n$box-shadow-lg:               var(--#{$prefix}box-shadow-lg);\n$box-shadow-inset:            var(--#{$prefix}box-shadow-inset);\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white;\n$component-active-bg:         $primary;\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em;\n$caret-vertical-align:        $caret-width * .85;\n$caret-spacing:               $caret-width * .85;\n// scss-docs-end caret-variables\n\n$transition-base:             all .25s ease-in-out;\n$transition-fade:             opacity .15s linear;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease;\n$transition-collapse-width:   width .35s ease;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n);\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      $font-family-primary;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif);\n$font-family-code:            var(--#{$prefix}font-monospace);\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null;\n$font-size-base:              0.875rem; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875;\n$font-size-lg:                $font-size-base * 1.25;\n\n$font-weight-lighter:         lighter;\n$font-weight-light:           300;\n$font-weight-normal:          400;\n$font-weight-medium:          500;\n$font-weight-semibold:        600;\n$font-weight-bold:            700;\n$font-weight-bolder:          bolder;\n\n$font-weight-base:            $font-weight-normal;\n\n$line-height-base:            1.5;\n$line-height-sm:              1.25;\n$line-height-lg:              2;\n\n$h1-font-size:                2.25rem;\n$h2-font-size:                1.875rem;\n$h3-font-size:                1.5rem;\n$h4-font-size:                1.125rem;\n$h5-font-size:                0.9375rem;\n$h6-font-size:                0.75rem;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n);\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5;\n$headings-font-family:        $font-family-secondary;\n$headings-font-style:         null;\n$headings-font-weight:        500;\n$headings-line-height:        1.1;\n$headings-color:              #343a40;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n);\n\n$display-font-family: null;\n$display-font-style:  null;\n$display-font-weight: 300;\n$display-line-height: $headings-line-height;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25;\n$lead-font-weight:            300;\n\n$small-font-size:             0.75rem;\n\n$sub-sup-font-size:           .75em;\n\n$text-muted:                  var(--#{$prefix}gray);\n\n$initialism-font-size:        $small-font-size;\n\n$blockquote-margin-y:         $spacer;\n$blockquote-font-size:        $font-size-base * 1.25;\n$blockquote-footer-color:     $gray-600;\n$blockquote-footer-font-size: $small-font-size;\n\n$hr-margin-y:                 $spacer;\n$hr-color:                    inherit;\n// fusv-disable\n$hr-bg-color:                 null; // Deprecated in v5.2.0\n$hr-height:                   null; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null; // Allows for inherited colors\n$hr-border-width:             1px;\n$hr-opacity:                  .25;\n\n$legend-margin-bottom:        0.5rem;\n$legend-font-size:            1.5rem;\n$legend-font-weight:          null;\n\n$mark-padding:                .2em;\n\n$dt-font-weight:              $font-weight-bold;\n\n$list-inline-padding:         .5rem;\n\n$mark-padding:                .1875em;\n$mark-bg:                     $yellow-100;\n// scss-docs-end type-variables\n\n//\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .85rem;\n$table-cell-padding-x:        .85rem;\n$table-cell-padding-y-sm:     .5rem;\n$table-cell-padding-x-sm:     .5rem;\n\n$table-cell-vertical-align:   top;\n\n$table-color:                 var(--#{$prefix}body-color);\n$table-bg:                    transparent;\n$table-accent-bg:             transparent;\n\n$table-th-font-weight:        null;\n\n$table-striped-color:         $table-color;\n$table-striped-bg-factor:     .025;\n$table-striped-bg:            rgba($black, $table-striped-bg-factor);\n\n$table-active-color:          $table-color;\n$table-active-bg-factor:      .1;\n$table-active-bg:             rgba($black, $table-active-bg-factor);\n\n$table-hover-color:           $table-color;\n$table-hover-bg-factor:       .075;\n$table-hover-bg:              rgba($black, $table-hover-bg-factor);\n\n$table-border-factor:         .1;\n$table-border-width:          var(--#{$prefix}border-width);\n$table-border-color:          var(--#{$prefix}border-color);\n\n$table-striped-order:         odd;\n$table-striped-columns-order: even;\n\n$table-group-separator-color: var(--#{$prefix}border-color);\n\n$table-caption-color:        $text-muted;\n\n$table-bg-scale:              -80%;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n);\n// scss-docs-end table-loop\n\n//\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .45rem;\n$input-btn-padding-x:         .90rem;\n$input-btn-font-family:       null;\n$input-btn-font-size:         $font-size-base;\n$input-btn-line-height:       $line-height-base;\n\n$input-btn-focus-width:         .15rem;\n$input-btn-focus-color-opacity: .25;\n$input-btn-focus-color:         rgba($primary, .25);\n$input-btn-focus-blur:          0;\n$input-btn-focus-box-shadow:    0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color;\n\n$input-btn-padding-y-sm:      .28rem;\n$input-btn-padding-x-sm:      .8rem;\n$input-btn-font-size-sm:      $font-size-sm;\n\n$input-btn-padding-y-lg:      .5rem;\n$input-btn-padding-x-lg:      1rem;\n$input-btn-font-size-lg:      $font-size-lg;\n\n$input-btn-border-width:      var(--#{$prefix}border-width);\n// scss-docs-end input-btn-variables\n\n//\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-padding-y:               $input-btn-padding-y;\n$btn-padding-x:               $input-btn-padding-x;\n$btn-font-family:             $input-btn-font-family;\n$btn-font-size:               $input-btn-font-size;\n$btn-line-height:             $input-btn-line-height;\n$btn-white-space:             null; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm;\n$btn-padding-x-sm:            $input-btn-padding-x-sm;\n$btn-font-size-sm:            $input-btn-font-size-sm;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg;\n$btn-padding-x-lg:            $input-btn-padding-x-lg;\n$btn-font-size-lg:            $input-btn-font-size-lg;\n\n$btn-border-width:            $input-btn-border-width;\n\n$btn-font-weight:             $font-weight-normal;\n$btn-box-shadow:              0px 2px 6px 0px; // button box shadow\n$btn-focus-width:             $input-btn-focus-width;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow;\n$btn-disabled-opacity:        .65;\n$btn-active-box-shadow:        inset 0 3px 5px rgba($black, .125);\n\n$btn-link-color:              var(--#{$prefix}link-color);\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color);\n$btn-link-disabled-color:     $gray-600;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius);\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm);\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg);\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$btn-hover-bg-shade-amount:       15%;\n$btn-hover-bg-tint-amount:        15%;\n$btn-hover-border-shade-amount:   20%;\n$btn-hover-border-tint-amount:    10%;\n$btn-active-bg-shade-amount:      20%;\n$btn-active-bg-tint-amount:       20%;\n$btn-active-border-shade-amount:  25%;\n$btn-active-border-tint-amount:   10%;\n// scss-docs-end btn-variables\n\n//\n// Forms\n//\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem;\n$form-text-font-size:                   $small-font-size;\n$form-text-font-style:                  null;\n$form-text-font-weight:                 null;\n$form-text-color:                       $text-muted;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem;\n$form-label-font-size:                  null;\n$form-label-font-style:                 null;\n$form-label-font-weight:                null;\n$form-label-color:                      null;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y;\n$input-padding-x:                       $input-btn-padding-x;\n$input-font-family:                     $input-btn-font-family;\n$input-font-size:                       $input-btn-font-size;\n$input-font-weight:                     $font-weight-base;\n$input-line-height:                     $input-btn-line-height;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm;\n$input-padding-x-sm:                    $input-btn-padding-x-sm;\n$input-font-size-sm:                    $input-btn-font-size-sm;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg;\n$input-padding-x-lg:                    $input-btn-padding-x-lg;\n$input-font-size-lg:                    $input-btn-font-size-lg;\n\n$input-bg:                              var(--#{$prefix}secondary-bg);\n$input-disabled-color:                  null;\n$input-disabled-bg:                     var(--#{$prefix}form-control-disabled-bg);\n$input-disabled-border-color:           null;\n\n$input-color:                           var(--#{$prefix}body-color);\n$input-border-color:                    var(--#{$prefix}border-color);\n$input-border-width:                    1px;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset);\n\n$input-border-radius:                   var(--#{$prefix}border-radius);\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm);\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg);\n\n$input-focus-bg:                        $input-bg;\n$input-focus-border-color:              var(--#{$prefix}border-color);\n$input-focus-color:                     $input-color;\n$input-focus-width:                     $input-btn-focus-width;\n$input-focus-box-shadow:                none;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color);\n$input-plaintext-color:                 var(--#{$prefix}body-color);\n\n$input-height-border:                   $input-border-width * 2;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2);\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y);\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5);\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false));\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false));\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false));\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$form-color-width:                      3rem;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1.143em;\n$form-check-min-height:                   $font-size-base * $line-height-base;\n$form-check-padding-start:                $form-check-input-width + .5em;\n$form-check-margin-bottom:                0;\n$form-check-label-color:                  null;\n$form-check-label-cursor:                 null;\n$form-check-transition:                   background-color .15s ease-in-out, background-position .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$form-check-input-active-filter:          brightness(90%);\n\n$form-check-input-bg:                     var(--#{$prefix}secondary-bg);\n$form-check-input-border:                 $border-width solid var(--#{$prefix}border-color);\n$form-check-input-border-radius:          .25em;\n$form-check-radio-border-radius:          50%;\n$form-check-input-focus-border:           $input-focus-border-color;\n$form-check-input-focus-box-shadow:       none;\n\n$form-check-input-checked-color:          $component-active-color;\n$form-check-input-checked-bg-color:       $component-active-bg;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\");\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='%23fff'/></svg>\");\n\n$form-check-input-indeterminate-color:          $component-active-color;\n$form-check-input-indeterminate-bg-color:       $component-active-bg;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\");\n\n$form-check-input-disabled-opacity:        .5;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity;\n\n$form-check-inline-margin-end:    1rem;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25);\n$form-switch-width:               2em;\n$form-switch-padding-start:       $form-switch-width + .5em;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#8b96a0' opacity='0.5'/></svg>\");\n$form-switch-border-radius:       $form-switch-width;\n$form-switch-transition:          background-position .15s ease-in-out;\n\n$form-switch-focus-color:         $input-focus-border-color;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\");\n\n$form-switch-checked-color:       $component-active-color;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\");\n$form-switch-checked-bg-position: right center;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y;\n$input-group-addon-padding-x:           $input-padding-x;\n$input-group-addon-font-weight:         $input-font-weight;\n$input-group-addon-color:               $input-color;\n$input-group-addon-bg:                  var(--#{$prefix}gray-100);\n$input-group-addon-border-color:        $input-border-color;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             .45rem;\n$form-select-padding-x:             .90rem;\n$form-select-font-family:           $input-font-family;\n$form-select-font-size:             $input-font-size;\n$form-select-indicator-padding:     $form-select-padding-x * 3; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight;\n$form-select-line-height:           $input-line-height;\n$form-select-color:                 $input-color;\n$form-select-bg:                    $input-bg;\n$form-select-disabled-color:        null;\n$form-select-disabled-bg:           $input-disabled-bg;\n$form-select-disabled-border-color: $input-disabled-border-color;\n$form-select-bg-position:           right $form-select-padding-x center;\n$form-select-bg-size:               14px 10px; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#8b96a0' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\");\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half;\n\n$form-select-border-width:        $input-border-width;\n$form-select-border-color:        $input-border-color;\n$form-select-border-radius:       var(--#{$prefix}border-radius);\n$form-select-box-shadow:          none;\n\n$form-select-focus-border-color:  $input-focus-border-color;\n$form-select-focus-width:         $input-focus-width;\n$form-select-focus-box-shadow:    none;\n\n$form-select-padding-y-sm:        $input-padding-y-sm;\n$form-select-padding-x-sm:        $input-padding-x-sm;\n$form-select-font-size-sm:        $input-font-size-sm;\n$form-select-border-radius-sm:    $input-border-radius-sm;\n\n$form-select-padding-y-lg:        $input-padding-y-lg;\n$form-select-padding-x-lg:        $input-padding-x-lg;\n$form-select-font-size-lg:        $input-font-size-lg;\n$form-select-border-radius-lg:    $input-border-radius-lg;\n\n$form-select-transition:          $input-transition;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100%;\n$form-range-track-height:         .5rem;\n$form-range-track-cursor:         pointer;\n$form-range-track-bg:             var(--#{$prefix}gray-100);\n$form-range-track-border-radius:  1rem;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset);\n\n$form-range-thumb-width:                   1rem;\n$form-range-thumb-height:                  $form-range-thumb-width;\n$form-range-thumb-bg:                      $component-active-bg;\n$form-range-thumb-border:                  0;\n$form-range-thumb-border-radius:           1rem;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1);\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%);\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color);\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color;\n$form-file-button-bg:             var(--#{$prefix}gray-100);\n$form-file-button-hover-bg:       var(--#{$prefix}gray-100);\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:            add(3.5rem, $input-height-border);\n$form-floating-line-height:       1.25;\n$form-floating-padding-x:         $input-padding-x;\n$form-floating-padding-y:         1rem;\n$form-floating-input-padding-t:   1.625rem;\n$form-floating-input-padding-b:   .625rem;\n$form-floating-label-height:            1.875em;\n$form-floating-label-opacity:     .65;\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem);\n$form-floating-label-disabled-color:    $gray-600;\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top;\n$form-feedback-font-size:           $form-text-font-size;\n$form-feedback-font-style:          $form-text-font-style;\n$form-feedback-valid-color:         $success;\n$form-feedback-invalid-color:       $danger;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\");\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\");\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}success-text),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}success),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}danger-text),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}danger),\n  )\n);\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000;\n$zindex-sticky:                     1020;\n$zindex-fixed:                      1030;\n$zindex-offcanvas-backdrop:         1040;\n$zindex-offcanvas:                  1045;\n$zindex-modal-backdrop:             1050;\n$zindex-modal:                      1055;\n$zindex-popover:                    1070;\n$zindex-tooltip:                    1080;\n$zindex-toast:                      1090;\n// scss-docs-end zindex-stack\n\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n);\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem;\n$nav-link-padding-x:                1rem;\n$nav-link-font-size:                null;\n$nav-link-font-weight:              null;\n$nav-link-color:                    var(--#{$prefix}link-color);\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color);\n$nav-link-transition:               color .3s ease-in-out, background-color .3s ease-in-out, border-color .3s ease-in-out;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color);\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color);\n$nav-tabs-border-width:             var(--#{$prefix}border-width);\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius);\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color);\n$nav-tabs-link-active-bg:           $card-bg;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-border-color;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius);\n$nav-pills-link-active-color:       $component-active-color;\n$nav-pills-link-active-bg:          $component-active-bg;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5;\n$navbar-padding-x:                  null;\n\n$navbar-nav-link-padding-x:         .5rem;\n\n$navbar-brand-font-size:            $font-size-lg;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5;\n$navbar-brand-margin-end:           1rem;\n\n$navbar-toggler-padding-y:          .25rem;\n$navbar-toggler-padding-x:          .75rem;\n$navbar-toggler-font-size:          $font-size-lg;\n$navbar-toggler-border-radius:      $btn-border-radius;\n$navbar-toggler-focus-width:        $btn-focus-width;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55);\n$navbar-dark-hover-color:           rgba($white, .75);\n$navbar-dark-active-color:          $white;\n$navbar-dark-disabled-color:        rgba($white, .25);\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-dark-toggler-border-color:  rgba($white, .1);\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65);\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8);\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1);\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), 0.3);\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-light-toggler-border-color: rgba($black, .1);\n\n$navbar-light-brand-color:                $navbar-light-active-color;\n$navbar-light-brand-hover-color:          $navbar-light-active-color;\n$navbar-dark-brand-color:                 $navbar-dark-active-color;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color;\n// scss-docs-end navbar-dark-variables\n\n//\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem;\n$dropdown-padding-x:                .25rem;\n$dropdown-padding-y:                .25rem;\n$dropdown-spacer:                   .125rem;\n$dropdown-font-size:                $font-size-base;\n$dropdown-color:                    var(--#{$prefix}body-color);\n$dropdown-bg:                       var(--#{$prefix}secondary-bg);\n$dropdown-border-color:             var(--#{$prefix}border-color);\n$dropdown-border-radius:            var(--#{$prefix}border-radius);\n$dropdown-border-width:             1px;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width);\n$dropdown-divider-bg:               var(--#{$prefix}border-color);\n$dropdown-divider-margin-y:         $spacer * .25;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow);\n\n$dropdown-link-color:               var(--#{$prefix}body-color);\n$dropdown-link-hover-color:         var(--#{$prefix}dark);\n$dropdown-link-hover-bg:            var(--#{$prefix}light);\n$dropdown-link-active-color:        var(--#{$prefix}dark);\n$dropdown-link-active-bg:           var(--#{$prefix}light);\n$dropdown-link-disabled-color:      var(--#{$prefix}gray-500);\n\n$dropdown-item-padding-y:           $spacer * .25;\n$dropdown-item-padding-x:           $spacer;\n\n$dropdown-header-color:             inherit;\n$dropdown-header-padding-x:         $dropdown-item-padding-x;\n$dropdown-header-padding-y:         $dropdown-padding-y;\n\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x; // Deprecated in v5.2.0\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300;\n$dropdown-dark-bg:                  $gray-800;\n$dropdown-dark-border-color:        $dropdown-border-color;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg;\n$dropdown-dark-box-shadow:          null;\n$dropdown-dark-link-color:          $dropdown-dark-color;\n$dropdown-dark-link-hover-color:    $white;\n$dropdown-dark-link-hover-bg:       rgba($white, .15);\n$dropdown-dark-link-active-color:   $dropdown-link-active-color;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg;\n$dropdown-dark-link-disabled-color: $gray-500;\n$dropdown-dark-header-color:        $gray-500;\n// scss-docs-end dropdown-dark-variables\n\n//\n// Pagination\n//\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem;\n$pagination-padding-x:              .75rem;\n$pagination-padding-y-sm:           .25rem;\n$pagination-padding-x-sm:           .5rem;\n$pagination-padding-y-lg:           .75rem;\n$pagination-padding-x-lg:           1.5rem;\n\n$pagination-font-size:              $font-size-base;\n$pagination-color:                  var(--#{$prefix}dark);\n$pagination-bg:                     $card-bg;\n$pagination-border-width:           var(--#{$prefix}border-width);\n$pagination-border-radius:          var(--#{$prefix}border-radius);\n$pagination-margin-start:           calc($pagination-border-width * -1); // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color);\n\n$pagination-focus-color:            $link-hover-color;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg);\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow;\n$pagination-focus-outline:          0;\n\n$pagination-hover-color:            var(--#{$prefix}dark);\n$pagination-hover-bg:               var(--#{$prefix}gray-100);\n$pagination-hover-border-color:     var(--#{$prefix}border-color);\n\n$pagination-active-color:           $component-active-color;\n$pagination-active-bg:              $component-active-bg;\n$pagination-active-border-color:    $component-active-bg;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color);\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg);\n$pagination-disabled-border-color:  var(--#{$prefix}border-color);\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm);\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg);\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5;\n$placeholder-opacity-min:           .2;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer;\n$card-spacer-x:                     $spacer;\n$card-title-spacer-y:               $spacer * .5;\n$card-title-color:                  null;\n$card-subtitle-color:               null;\n$card-border-width:                 var(--#{$prefix}theme-border-width);\n$card-border-color:                 var(--#{$prefix}border-color);\n$card-border-radius:                var(--#{$prefix}border-radius);\n$card-box-shadow:                   var(--#{$prefix}box-shadow-sm);\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width);\n$card-cap-padding-y:                $card-spacer-y * .75;\n$card-cap-padding-x:                $card-spacer-x;\n$card-cap-bg:                       var(--#{$prefix}secondary-bg);\n$card-cap-color:                    null;\n$card-height:                       null;\n$card-color:                        null;\n$card-bg:                           var(--#{$prefix}secondary-bg);\n$card-img-overlay-padding:          $spacer;\n$card-group-margin:                 $grid-gutter-width * .5;\n// scss-docs-end card-variables\n\n//\n// Accordion\n//\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem;\n$accordion-padding-x:                     1.25rem;\n$accordion-color:                         var(--#{$prefix}body-color);\n$accordion-bg:                            $card-bg;\n$accordion-border-width:                  var(--#{$prefix}border-width);\n$accordion-border-color:                  var(--#{$prefix}border-color);\n$accordion-border-radius:                 var(--#{$prefix}border-radius);\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width);\n\n$accordion-body-padding-y:                $accordion-padding-y;\n$accordion-body-padding-x:                $accordion-padding-x;\n\n$accordion-button-padding-y:              $accordion-padding-y;\n$accordion-button-padding-x:              $accordion-padding-x;\n$accordion-button-color:                  var(--#{$prefix}body-color);\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg);\n$accordion-transition:                    $btn-transition, border-radius .15s ease;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle);\n$accordion-button-active-color:           var(--#{$prefix}primary-text);\n\n$accordion-button-focus-border-color:     $input-focus-border-color;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow;\n\n$accordion-icon-width:                    0.75rem;\n$accordion-icon-color:                    $body-color;\n$accordion-icon-active-color:             $primary-text;\n$accordion-icon-transition:               transform .2s ease-in-out;\n$accordion-icon-transform:                rotate(-180deg);\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n// scss-docs-end accordion-variables\n\n\n//\n// Tooltips\n//\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm;\n$tooltip-max-width:                 200px;\n$tooltip-color:                     $white;\n$tooltip-bg:                        $black;\n$tooltip-border-radius:             0.2rem;\n$tooltip-opacity:                   .9;\n$tooltip-padding-y:                 .4rem;\n$tooltip-padding-x:                 .8rem;\n$tooltip-margin:                    0;\n$tooltip-arrow-width:               .8rem;\n$tooltip-arrow-height:              .4rem;\n$tooltip-arrow-color:               $tooltip-bg;\n// scss-docs-end tooltip-variables\n\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x;\n$form-feedback-tooltip-font-size:     $tooltip-font-size;\n$form-feedback-tooltip-line-height:   null;\n$form-feedback-tooltip-opacity:       $tooltip-opacity;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius;\n// scss-docs-end tooltip-feedback-variables\n\n//\n// Popovers\n//\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm;\n$popover-bg:                        $card-bg;\n$popover-max-width:                 276px;\n$popover-border-width:              var(--#{$prefix}border-width);\n$popover-border-color:              var(--#{$prefix}border-color);\n$popover-border-radius:             var(--#{$prefix}border-radius-lg);\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width);\n$popover-box-shadow:                var(--#{$prefix}box-shadow);\n\n$popover-header-font-size:          $font-size-base;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg);\n$popover-header-color:              var(--#{$prefix}headings-color);\n$popover-header-padding-y:          .7rem;\n$popover-header-padding-x:          .8rem;\n\n$popover-body-color:                var(--#{$prefix}body-color);\n$popover-body-padding-y:            .5rem;\n$popover-body-padding-x:            .75rem;\n\n$popover-arrow-width:               1rem;\n$popover-arrow-height:              .5rem;\n$popover-arrow-color:               $card-bg;\n\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent);\n// scss-docs-end popover-variables\n\n//\n// Toasts\n//\n// scss-docs-start toast-variables\n$toast-max-width:                   350px;\n$toast-padding-x:                   .75rem;\n$toast-padding-y:                   .5rem;\n$toast-font-size:                   .875rem;\n$toast-color:                       inherit;\n$toast-background-color:            $card-bg;\n$toast-border-width:                var(--#{$prefix}border-width);\n$toast-border-color:                var(--#{$prefix}border-color);\n$toast-border-radius:               var(--#{$prefix}border-radius);\n$toast-box-shadow:                  var(--#{$prefix}box-shadow);\n$toast-spacing:                     $container-padding-x;\n\n$toast-header-color:                var(--#{$prefix}secondary-color);\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85);\n$toast-header-border-color:         $toast-border-color;\n// scss-docs-end toast-variables\n\n//\n// Badges\n//\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em;\n$badge-font-weight:                 $font-weight-bold;\n$badge-color:                       $white;\n$badge-padding-y:                   .25em;\n$badge-padding-x:                   .4em;\n$badge-border-radius:               var(--#{$prefix}border-radius);\n// scss-docs-end badge-variables\n\n//\n// Modals\n//\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer - 0.5rem;\n\n$modal-footer-margin-between:       .5rem;\n\n$modal-dialog-margin:               .5rem;\n$modal-dialog-margin-y-sm-up:       1.75rem;\n\n$modal-title-line-height:           $line-height-base;\n\n$modal-content-color:               null;\n$modal-content-bg:                  $card-bg;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent);\n$modal-content-border-width:        var(--#{$prefix}border-width);\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg);\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width);\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm);\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow);\n\n$modal-backdrop-bg:                 $black;\n$modal-backdrop-opacity:            .5;\n\n$modal-header-border-color:         var(--#{$prefix}border-color);\n$modal-header-border-width:         $modal-content-border-width;\n$modal-header-padding-y:            $modal-inner-padding;\n$modal-header-padding-x:            $modal-inner-padding;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null;\n$modal-footer-border-color:         $modal-header-border-color;\n$modal-footer-border-width:         $modal-header-border-width;\n\n$modal-sm:                          300px;\n$modal-md:                          500px;\n$modal-lg:                          800px;\n$modal-xl:                          1140px;\n\n$modal-fade-transform:              translate(0, -50px);\n$modal-show-transform:              none;\n$modal-transition:                  transform .3s ease-out;\n$modal-scale-transform:             scale(1.02);\n// scss-docs-end modal-variables\n\n//\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n// scss-docs-start alert-variables\n$alert-padding-y:               .8rem;\n$alert-padding-x:               1.25rem;\n$alert-margin-bottom:           1rem;\n$alert-border-radius:           var(--#{$prefix}border-radius);\n$alert-link-font-weight:        $font-weight-bold;\n$alert-border-width:            var(--#{$prefix}border-width);\n$alert-bg-scale:                -80%;\n$alert-border-scale:            5%;\n$alert-color-scale:             5%;\n$alert-dismissible-padding-r:   $alert-padding-x * 3; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n//\n// Progress bars\n//\n// scss-docs-start progress-variables\n$progress-height:                   1rem;\n$progress-font-size:                $font-size-base * .75;\n$progress-bg:                       var(--#{$prefix}light);\n$progress-border-radius:            var(--#{$prefix}border-radius);\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset);\n$progress-bar-color:                $white;\n$progress-bar-bg:                   $primary;\n$progress-bar-animation-timing:     1s linear infinite;\n$progress-bar-transition:           width .6s ease;\n// scss-docs-end progress-variables\n\n//\n// List group\n//\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color);\n$list-group-bg:                     $card-bg;\n$list-group-border-color:           var(--#{$prefix}border-color);\n$list-group-border-width:           var(--#{$prefix}border-width);\n$list-group-border-radius:          var(--#{$prefix}border-radius);\n\n$list-group-item-padding-y:         $spacer * .5;\n$list-group-item-padding-x:         $spacer * .8;\n$list-group-item-bg-scale:          -70%;\n$list-group-item-color-scale:       40%;\n\n$list-group-hover-bg:               var(--#{$prefix}gray-300);\n$list-group-active-color:           $component-active-color;\n$list-group-active-bg:              $component-active-bg;\n$list-group-active-border-color:    $list-group-active-bg;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color);\n$list-group-disabled-bg:            $list-group-bg;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color);\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color);\n\n$list-group-action-active-color:    var(--#{$prefix}body-color);\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg);\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem;\n$thumbnail-bg:                      $card-bg;\n$thumbnail-border-width:            var(--#{$prefix}border-width);\n$thumbnail-border-color:            var(--#{$prefix}border-color);\n$thumbnail-border-radius:           var(--#{$prefix}border-radius);\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm);\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size;\n$figure-caption-color:              var(--#{$prefix}secondary-color);\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null;\n$breadcrumb-padding-y:              0;\n$breadcrumb-padding-x:              0;\n$breadcrumb-item-padding-x:         .5rem;\n$breadcrumb-margin-bottom:          1rem;\n$breadcrumb-bg:                     null;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color);\n$breadcrumb-active-color:           var(--#{$prefix}gray-500);\n$breadcrumb-divider:                quote(\"\\F0142\");\n$breadcrumb-divider-flipped:        $breadcrumb-divider;\n$breadcrumb-border-radius:          null;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white;\n$carousel-control-width:             15%;\n$carousel-control-opacity:           .5;\n$carousel-control-hover-opacity:     .9;\n$carousel-control-transition:        opacity .15s ease;\n\n$carousel-indicator-width:           30px;\n$carousel-indicator-height:          3px;\n$carousel-indicator-hit-area-height: 10px;\n$carousel-indicator-spacer:          3px;\n$carousel-indicator-opacity:         .5;\n$carousel-indicator-active-bg:       $white;\n$carousel-indicator-active-opacity:  1;\n$carousel-indicator-transition:      opacity .6s ease;\n\n$carousel-caption-width:             70%;\n$carousel-caption-color:             $white;\n$carousel-caption-padding-y:         1.25rem;\n$carousel-caption-spacer:            1.25rem;\n\n$carousel-control-icon-width:        2rem;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\");\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\");\n\n$carousel-transition-duration:       .6s;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n$carousel-dark-indicator-active-bg:  $black;\n$carousel-dark-caption-color:        $black;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100);\n// scss-docs-end carousel-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem;\n$spinner-height:          $spinner-width;\n$spinner-vertical-align:  -.125em;\n$spinner-border-width:    .25em;\n$spinner-animation-speed: .75s;\n\n$spinner-width-sm:        1rem;\n$spinner-height-sm:       $spinner-width-sm;\n$spinner-border-width-sm: .2em;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em;\n$btn-close-height:           $btn-close-width;\n$btn-close-padding-x:        .25em;\n$btn-close-padding-y:        $btn-close-padding-x;\n$btn-close-color:            $black;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#8b96a0'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\n$btn-close-focus-shadow:     $input-btn-focus-box-shadow;\n$btn-close-opacity:          1;\n$btn-close-hover-opacity:    .8;\n$btn-close-focus-opacity:    1;\n$btn-close-disabled-opacity: .25;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%);\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding;\n$offcanvas-padding-x:               $modal-inner-padding;\n$offcanvas-horizontal-width:        400px;\n$offcanvas-vertical-height:         30vh;\n$offcanvas-transition-duration:     .3s;\n$offcanvas-border-color:            $modal-content-border-color;\n$offcanvas-border-width:            $modal-content-border-width;\n$offcanvas-title-line-height:       $modal-title-line-height;\n$offcanvas-bg-color:                $card-bg;\n$offcanvas-color:                   var(--#{$prefix}body-color);\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    87.5%;\n$code-color:                        $cyan;\n\n$kbd-padding-y:                     .2rem;\n$kbd-padding-x:                     .4rem;\n$kbd-font-size:                     $code-font-size;\n$kbd-color:                         var(--#{$prefix}body-color) ;\n$kbd-bg:                            $card-bg;\n$nested-kbd-font-weight:            null;\n\n$pre-color:                         null;","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: divide(100%, $count);\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  color: var(--#{$prefix}table-color);\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-accent-bg);\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc($table-border-width * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-striped-bg);\n    color: var(--#{$prefix}table-striped-color);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-striped-bg);\n    color: var(--#{$prefix}table-striped-color);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-accent-bg: var(--#{$prefix}table-active-bg);\n  color: var(--#{$prefix}table-active-color);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-hover-bg);\n    color: var(--#{$prefix}table-hover-color);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  // Add some height to date inputs on iOS\n  // https://github.com/twbs/bootstrap/issues/23307\n  // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n  &::-webkit-date-and-time-value {\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  -moz-padding-start: subtract($form-select-padding-x, 3px); // See https://github.com/twbs/bootstrap/issues/32636\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n  appearance: none;\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  appearance: none;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  &::before:not(.form-control:disabled) {\n    position: absolute;\n    top: $input-border-width;\n    left: $input-border-width;\n    width: subtract(100%, add($input-height-inner-quarter, $input-height-inner-half));\n    height: $form-floating-label-height;\n    content: \"\";\n    background-color: $input-bg;\n    @include border-radius($input-border-radius);\n  }\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > .form-control:disabled ~ label {\n    color: $form-floating-label-disabled-color;\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc($input-border-width * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$body-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: none;\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix(color-contrast($primary), $primary, 15%))};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc($btn-border-width * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc($btn-border-width * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    background: none;\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n\n    &.disabled,\n    &:disabled {\n      color: var(--#{$prefix}nav-link-disabled-color);\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n\n    &:disabled {\n      color: var(--#{$prefix}nav-link-disabled-color);\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .show > .nav-link,\n  .nav-link.active {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc($pagination-border-width * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n\n    &.list-group-item-action {\n      &:hover,\n      &:focus {\n        --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n        --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n      }\n\n      &:active {\n        --#{$prefix}list-group-active-color: var(--#{$prefix}emphasis-color);\n        --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text);\n        --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text);\n      }\n    }\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  padding: var(--#{$prefix}tooltip-arrow-height);\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: 0;\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: 0;\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: 0;\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: 0;\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .carousel {\n      @include carousel-dark();\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// stylelint-disable function-name-case\n\n// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  $color-rgb: to-rgb($value);\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA($color-rgb, var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: $value if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: 1px;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix, $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","// \n// accordions.scss\n//\n\n.custom-accordion {\n    .accordion-arrow {\n        font-size: 1.2rem;\n        position: absolute;\n        right: 0;\n    }\n    a {\n        &.collapsed {\n            i.accordion-arrow {\n                &:before {\n                    content: \"\\F0142\";\n                }\n            }\n        }\n    }\n}","//\n// alert.scss\n//\n\n\n@each $color, $value in $theme-colors {\n    .alert-#{$color} {\n        --#{$prefix}alert-color: #{shift-color($value, 30%)};\n        --#{$prefix}alert-bg: #{rgba($value, 0.18)};\n        --#{$prefix}alert-border-color: #{rgba($value, 0.18)};\n        .alert-link {\n            --#{$prefix}alert-color: #{shade-color($value, 30%)};\n        }\n    }\n}\n\n\n@each $state in map-keys($theme-colors) {\n    .alert-outline-#{$state} {\n        --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text);\n        --#{$prefix}alert-bg: transparent;\n        --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n        --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text);\n    }   \n}","//\n// avatar.scss (avatar thumbnail sizes)\n//\n\n.avatar-xs {\n    height: 1.5rem;\n    width: 1.5rem;\n}\n\n.avatar-sm {\n    height: 2.25rem;\n    width: 2.25rem;\n}\n\n.avatar-md {\n    height: 3.5rem;\n    width: 3.5rem;\n}\n\n.avatar-lg {\n    height: 4.5rem;\n    width: 4.5rem;\n}\n\n.avatar-xl {\n    height: 6rem;\n    width: 6rem;\n}\n\n.avatar-xxl {\n    height: 7.5rem;\n    width: 7.5rem;\n}\n\n.avatar-title {\n    align-items: center;\n    color: var(--#{$prefix}card-bg);\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    width: 100%;\n}\n\n.avatar-group {\n    padding-left: 12px;\n\n    .avatar-group-item {\n        margin: 0 0 10px -12px;\n        display: inline-block;\n        border: 2px solid var(--#{$prefix}card-bg);\n        border-radius: 50%;\n    }\n}\n","\n// \n// breadcrumb.scss\n//\n\n\n// Breadcrumb item arrow\n.breadcrumb-item {\n    > a {\n        color: var(--#{$prefix}gray-700);\n    }\n    +.breadcrumb-item {\n        &::before {\n            font-family: \"Material Design Icons\";\n        }\n    }\n}\n","//\n// buttons.scss\n//\n\n.btn {\n    .mdi {\n        &:before {\n            line-height: initial;\n        }\n    }\n\n    .spinner-grow,\n    .spinner-border {\n        vertical-align: middle;\n    }\n\n    &-rounded {\n        border-radius: 50%;\n    }\n\n    &-xs {\n        padding: 0.2rem 0.6rem;\n        font-size: 0.75rem;\n        border-radius: 0.15rem;\n    }\n\n    // Button labels\n    &-label {\n        margin: -0.55rem 0.9rem -0.55rem -0.9rem;\n        padding: 0.6rem 0.9rem;\n    }\n\n    &-label-right {\n        margin: (-$btn-padding-y) (-$btn-padding-x) (-$btn-padding-y) ($btn-padding-x);\n        padding: ($btn-padding-y) ($btn-padding-x);\n        display: inline-block;\n    }\n\n    i {\n        display: inline-block;\n    }\n}\n\nbutton:focus {\n    outline: none;\n}\n\n\n// Button Soft\n@mixin button-variant-soft($bg) {\n    --#{$prefix}btn-color: #{$bg};\n    --#{$prefix}btn-bg: #{rgba($bg, 0.1)};\n    --#{$prefix}btn-border-color: #{transparent};\n    --#{$prefix}btn-hover-color: #{$white};\n    --#{$prefix}btn-hover-bg: #{$bg};\n    --#{$prefix}btn-hover-border-color: #{$bg};\n    --#{$prefix}btn-active-color: #{$white};\n    --#{$prefix}btn-active-bg: #{$bg};\n    --#{$prefix}btn-active-border-color: #{$bg};\n    --#{$prefix}btn-disabled-color: #{$bg};\n    --#{$prefix}btn-disabled-bg: #{$bg};\n    --#{$prefix}btn-disabled-border-color: #{$bg};\n    --#{$prefix}btn-focus-shadow-rgb: 0 0 0 $btn-focus-width rgba($bg, 0.5);\n}\n\n@each $color,\n$value in $theme-colors {\n    .btn-soft-#{$color} {\n        @include button-variant-soft($value);\n    }\n}\n\n// Button White\n.btn-white,\n.btn-outline-light {\n    --#{$prefix}btn-color: var(--#{$prefix}gray-900);\n    --#{$prefix}btn-hover-bg: var(--#{$prefix}gray-100);\n    --#{$prefix}btn-border-color: var(--#{$prefix}gray-300);\n    --#{$prefix}btn-hover-border-color: var(--#{$prefix}gray-100);\n}\n\n// Dark Mode Light/Dark button\nhtml[data-bs-theme=\"dark\"] {\n\n    .btn-light {\n        --#{$prefix}btn-color: var(--#{$prefix}gray-900);\n        --#{$prefix}btn-bg: var(--#{$prefix}gray-300);\n        --#{$prefix}btn-border-color: var(--#{$prefix}gray-300);\n        --#{$prefix}btn-hover-color: var(--#{$prefix}gray-900);\n        --#{$prefix}btn-hover-bg: var(--#{$prefix}gray-300);\n        --#{$prefix}btn-hover-border-color: var(--#{$prefix}gray-300);\n        --#{$prefix}btn-active-color: var(--#{$prefix}gray-900);\n        --#{$prefix}btn-active-bg: var(--#{$prefix}gray-300);\n        --#{$prefix}btn-active-border-color: var(--#{$prefix}gray-300);\n    }\n\n    .btn-outline-dark {\n        --#{$prefix}btn-color: var(--#{$prefix}gray-900);\n    }\n\n    .btn-outline-light,\n    .btn-outline-dark {\n        --#{$prefix}btn-hover-color: var(--#{$prefix}gray-900);\n        --#{$prefix}btn-color: var(--#{$prefix}gray-900);\n    }\n\n    .btn-soft-dark {\n        --#{$prefix}btn-hover-bg: var(--#{$prefix}light);\n        --#{$prefix}btn-hover-border-color: var(--#{$prefix}light);\n    }\n}","//\n// card.scss\n//\n\n.card {\n    box-shadow: $card-box-shadow;\n    margin-bottom: $grid-gutter-width;\n}\n\n.card-drop {\n    font-size: 20px;\n    line-height: 0;\n    color: inherit;\n}\n\n.card-widgets {\n    float: right;\n    height: 16px;\n\n    >a {\n        color: inherit;\n        font-size: 18px;\n        display: inline-block;\n        line-height: 1;\n\n        &.collapsed {\n            i {\n                &:before {\n                    content: \"\\F0415\";\n                }\n            }\n        }\n    }\n}\n\n// Card title / Card Header\n.card-title,\n.card-header {\n    margin-top: 0;\n}\n\n//Card disable loading (Custom Cards)\n.card-disabled {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    border-radius: $card-border-radius;\n    background: rgba(var(--#{$prefix}secondary-bg-rgb), 0.8);\n    cursor: progress;\n\n    .card-portlets-loader {\n        background-color: var(--#{$prefix}gray-900);\n        animation: rotatebox 1.2s infinite ease-in-out;\n        height: 30px;\n        width: 30px;\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        border-radius: 3px;\n        margin-left: -($grid-gutter-width * 0.5);\n        margin-top: -($grid-gutter-width * 0.5);\n    }\n}\n\n@keyframes rotatebox {\n    0% {\n        transform: perspective(120px) rotateX(0deg) rotateY(0deg);\n    }\n\n    50% {\n        transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);\n    }\n\n    100% {\n        transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\n    }\n}\n\n.header-title {\n    font-size: 1rem;\n    margin: 0 0 7px 0;\n}\n\n.sub-header {\n    font-size: 0.875rem;\n    margin-bottom: $grid-gutter-width;\n    color: $text-muted;\n}","//\n// custom-forms.scss\n//\n\n@each $color, $value in $theme-colors {\n    .form-check-#{$color},\n    .form-radio-#{$color} {\n        .form-check-input {\n            &:checked {\n                background-color: $value;\n                border-color: $value;\n            }\n        }\n    }\n}\n\n// card radio\n.card-radio {\n    padding: 0;\n\n    .form-check-label {\n        background-color: $card-bg;\n        border: 1px solid var(--#{$prefix}border-color);\n        border-radius: var(--#{$prefix}border-radius);\n        padding: 1rem;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        display: block;\n        position: relative;\n        padding-right: 32px;\n\n        &:hover {\n            cursor: pointer;\n        }\n    }\n\n    .form-check-input {\n        display: none;\n\n        &:checked + .form-check-label {\n            &:before {\n                content: \"\\f05e0\";\n                font-family: \"Material Design Icons\";\n                position: absolute;\n                bottom: 2px;\n                right: 6px;\n                font-size: 16px;\n                color: $primary;\n            }\n        }\n    }\n\n    &.dark {\n        .form-check-input {\n            &:checked + .form-check-label {\n                &:before {\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n","//\n// dropdown.scss\n//\n\n\n\n.dropdown-menu {\n    padding: 0.3rem;\n    box-shadow: $box-shadow;\n    animation-name: DropDownSlide;\n    animation-duration: .3s;\n    animation-fill-mode: both;\n    top: 100%;\n\n    &.show {\n        top: 100% !important;\n    }\n\n    i {\n        display: inline-block;\n    }\n}\n\n\n\n.dropdown-menu-end {\n    right: 0 !important;\n    left: auto !important;\n}\n\n.dropdown-menu[data-popper-placement^=right],\n.dropdown-menu[data-popper-placement^=top],\n.dropdown-menu[data-popper-placement^=left] {\n    top: auto !important;\n    animation: none !important;\n}\n\n@keyframes DropDownSlide {\n    100% {\n        transform: translateY(0)\n    }\n\n    0% {\n        transform: translateY(15px)\n    }\n}\n\n\n// Dropdown Mega Menu\n\n.dropdown-mega {\n    position: static !important;\n}\n\n.dropdown-megamenu {\n    padding: 20px;\n    left: 20px !important;\n    right: 20px !important;\n    background-image: url(\"../../../images/megamenu-bg.png\");\n    background-position: right bottom;\n    background-repeat: no-repeat;\n}\n\nhtml[dir=\"rtl\"] .dropdown-megamenu {\n    left: 60px !important;\n    right: -20px !important;\n}\n\n.megamenu-list {\n    li {\n        padding: 5px 20px 5px 25px;\n        position: relative;\n\n        a {\n            color: $dropdown-link-color;\n\n            &:hover {\n                color: $primary;\n            }\n        }\n\n        &:before {\n            content: \"\\F0142\";\n            position: absolute;\n            left: 0;\n            font-family: \"Material Design Icons\";\n        }\n    }\n}\n\nhtml[dir=\"ltr\"] .megamenu-list {\n    li {\n        &:before {\n            content: \"\\F0141\";\n        }\n    }\n}\n\n// Dropdown with Icons\n.dropdown-icon-item {\n    display: block;\n    border-radius: 3px;\n    line-height: 34px;\n    text-align: center;\n    padding: 15px 0 9px;\n    display: block;\n    border: 1px solid transparent;\n    color: $dropdown-link-color;\n\n    img {\n        height: 24px;\n    }\n\n    span {\n        display: block;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n\n    &:hover {\n        background-color: $dropdown-link-hover-bg;\n    }\n}\n\n// Dropdown size\n@include media-breakpoint-up(lg) {\n    .dropdown-mega-menu-xl {\n        width: 40rem;\n    }\n\n    .dropdown-mega-menu-lg {\n        width: 26rem;\n    }\n}\n\n.dropdown-menu {\n    box-shadow: var(--#{$prefix}box-shadow);\n}\n\n.dropdown-header {\n    margin-top: 0;\n}\n\n.dropdown-menu-animated {\n    &.dropdown-menu-end[style] {\n        left: auto;\n        right: 0;\n    }\n}\n\n.hover-dropdown {\n    &:hover {\n        .dropdown-menu {\n            display: block !important;\n            top: 100% !important;\n        }\n    }\n}\n\n// Dropdown Animated (Custom)\n.dropdown-menu-animated {\n    animation-name: DropDownSlide;\n    animation-duration: 0.3s;\n    animation-fill-mode: both;\n    position: absolute;\n    margin: 0;\n    z-index: 1000;\n\n    &.show {\n        top: 100% !important;\n    }\n\n    i {\n        display: inline-block;\n    }\n\n    &.dropdown-menu[data-popper-placement^=\"right\"],\n    &.dropdown-menu[data-popper-placement^=\"top\"],\n    &.dropdown-menu[data-popper-placement^=\"left\"] {\n        top: auto !important;\n        animation: none !important;\n    }\n}\n\n@keyframes DropDownSlide {\n    100% {\n        transform: translateY(0);\n    }\n\n    0% {\n        transform: translateY(10px);\n    }\n}\n\n// Dropdown Large (Custom)\n@media (min-width: 576px) {\n    .dropdown-lg {\n        width: 320px;\n    }\n}\n\n\n// Dropdown arrow hide\n.dropdown-toggle {\n    &.arrow-none {\n        &:after {\n            display: none;\n        }\n    }\n}\n\n\n// Notification\n.notification-list {\n    margin-left: 0;\n\n    .noti-title {\n        background-color: transparent;\n        padding: 15px 20px;\n    }\n\n    .noti-icon-badge {\n        position: absolute;\n        top: 16px;\n        right: 14px;\n    }\n    \n\n    .notify-item {\n        padding: 10px 20px;\n\n        &.unread-noti {\n            background-color: var(--#{$prefix}light);\n        }\n\n        &.read-noti {\n            background-color: transparent;\n            transition: all 0.2s ease-in-out;\n\n            &:hover {\n                background-color: var(--#{$prefix}light);\n            }\n        }\n\n        .card-body {\n            padding: 14px;\n\n            .noti-close-btn {\n                position: absolute;\n                top: 3px;\n                right: 5px;\n            }\n\n            .noti-item-title {\n                margin: 0 0 2px;\n            }\n\n            .noti-item-title,\n            .noti-item-subtitle {\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n            }\n        }\n\n        .notify-icon {\n            float: left;\n            height: 36px;\n            width: 36px;\n            line-height: 36px;\n            text-align: center;\n            border-radius: 50%;\n            color: $white;\n        }\n\n        .notify-details {\n            margin-bottom: 0;\n            overflow: hidden;\n            margin-left: 45px;\n\n            b {\n                font-weight: 500;\n            }\n\n            small {\n                display: block;\n            }\n        }\n    }\n}\n\n.profile-dropdown {\n    min-width: 170px;\n\n    i,\n    span {\n        vertical-align: middle;\n    }\n}\n","//\n// forms.scss\n//\n\n// Form-control light\n\n// Form elements (Color and Range)\ninput.form-control[type=\"color\"],\ninput.form-control[type=\"range\"] {\n    min-height: 39px;\n}\n\nselect.form-control {\n    &:not([size]):not([multiple]) {\n        height: $input-height;\n    }\n}\n\nselect.form-control-sm {\n    &:not([size]):not([multiple]) {\n        height: $input-height-sm;\n    }\n}\n\n// Form-control light\n.form-control-light {\n    background-color: var(--#{$prefix}light)  !important;\n    border-color: var(--#{$prefix}light)  !important;\n}\n\n\n// Comment box\n.comment-area-box {\n    .form-control {\n        border-color: var(--#{$prefix}gray-300);\n        border-radius: $input-border-radius $input-border-radius 0 0;\n    }\n\n    .comment-area-btn {\n        background-color: var(--#{$prefix}gray-100);\n        padding: 10px;\n        border: 1px solid var(--#{$prefix}gray-300);\n        border-top: none;\n        border-radius: 0 0 $input-border-radius $input-border-radius;\n    }\n}\n\n\n\n// Search box\n.search-bar {\n    .form-control {\n        padding-left: 40px;\n        padding-right: 20px;\n        border-radius: 30px;\n    }\n\n    span {\n        position: absolute;\n        z-index: 10;\n        font-size: 16px;\n        line-height: $input-height;\n        left: 13px;\n        top: -2px;\n        color: $text-muted;\n    }\n}\n\n// Show/Hide Password\n.password-eye {\n    cursor: pointer;\n\n    &:before {\n        font-family: \"Material Design Icons\";\n        content: \"\\F06D0\";\n        font-style: normal;\n        font-weight: 400;\n        font-variant: normal;\n        vertical-align: middle;\n        line-height: 1.2;\n        font-size: 16px;\n    }\n}\n\n.show-password {\n    .password-eye {\n        &:before {\n            content: \"\\F06D1\";\n        }\n    }\n}","//\n// _badges.scss\n//\n.badge {\n    box-shadow: $box-shadow;\n}\n\n// Lighten badge\n@mixin badge-variant-light($bg) {\n    color: $bg;\n    background-color: rgba($bg, 0.18);\n    box-shadow: none;\n}\n\n// Outline badge\n\n@mixin badge-variant-outline($bg) {\n    color: $bg;\n    border: 1px solid $bg;\n    background-color: transparent;\n    box-shadow: none;\n}\n\n\n@each $color, $value in $theme-colors {\n    // Lighten badge (soft)\n    .badge-soft-#{$color} {\n        @include badge-variant-light($value);\n    }\n\n    // Outline badge\n    .badge-outline-#{$color} {\n        @include badge-variant-outline($value);\n    }\n}\n\n.badge {\n    vertical-align: middle;\n\n    &.badge-lg {\n        padding: $badge-padding-y * 2 $badge-padding-x * 2.5;\n        font-size: $badge-font-size + 0.1em;\n    }\n}","//\n// modal.scss\n//\n\n// Title text within header\n.modal-title {\n    margin-top: 0;\n}\n\n// Modal full width\n.modal-full-width {\n    width: 95%;\n    max-width: none;\n}\n\n// Modal Positions\n.modal-top {\n    margin: 0 auto;\n}\n\n// Right Modal\n.modal-right {\n    position: absolute;\n    right: 0;\n    display: flex;\n    flex-flow: column nowrap;\n    justify-content: center;\n    height: 100%;\n    margin: 0;\n    background-color: $modal-content-bg;\n    align-content: center;\n    transform: translate(25%, 0) !important;\n\n    button.btn-close {\n        position: fixed;\n        top: 20px;\n        right: 20px;\n        z-index: 1;\n    }\n}\n\n.modal {\n    &.show {\n        .modal-right,\n        .modal-left {\n            transform: translate(0, 0) !important;\n        }\n    }\n}\n\n// Bottom modal\n.modal-bottom {\n    display: flex;\n    flex-flow: column nowrap;\n    -ms-flex-pack: end;\n    justify-content: flex-end;\n    height: 100%;\n    margin: 0 auto;\n    align-content: center;\n}\n\n// Colored modal header\n.modal-colored-header {\n    color: $white;\n    border-radius: 0;\n}\n\n// Full filled modals\n.modal-filled {\n    color: $white;\n\n    .modal-header {\n        background-color: rgba($white, 0.07);\n    }\n\n    .modal-header,\n    .modal-footer {\n        border: none;\n    }\n}\n","//\n// nav.scss\n//\n\n.nav-tabs,\n.nav-pills {\n    > li {\n        > a {\n            color: var(--#{$prefix}gray-700);\n            font-weight: $font-weight-semibold;\n        }\n    }\n}\n\n.nav-pills {\n    > a {\n        color: var(--#{$prefix}gray-700);\n        font-weight: $font-weight-semibold;\n    }\n}\n\n.nav-fill,\n.nav-justified {\n    .nav-item {\n        .nav-link {\n            width: auto;\n        }\n    }\n}\n\n//Navtab custom\n.navtab-bg {\n    .nav-link {\n        background-color: var(--#{$prefix}light);\n        margin: 0 5px;\n    }\n}\n\n// Nav bordered\n\n.nav-bordered {\n    border-bottom: 2px solid var(--#{$prefix}border-color) !important;\n    .nav-item {\n        margin-bottom: -1px;\n    }\n\n    li {\n        a {\n            border: 0 !important;\n            padding: 10px 20px;\n        }\n    }\n\n    a.active {\n        border-bottom: 2px solid $primary !important;\n    }\n}\n\n.tab-content {\n    padding: 20px 0 0 0;\n}","//\n// pagination.scss\n//\n\n// Pagination rounded (Custom)\n.pagination-rounded {\n    .page-link {\n        border-radius: 30px !important;\n        margin: 0 3px !important;\n        border: none;\n    }\n}","//\n// popover.scss\n//\n\n.popover-header {\n    margin-top: 0;\n}\n\n\n@each $color,\n$value in $theme-colors {\n    .#{$color}-popover {\n        --#{$prefix}popover-max-width: 200px !important;\n        --#{$prefix}popover-border-color: var(--#{$prefix}#{$color}) !important;\n        --#{$prefix}popover-header-bg: var(--#{$prefix}#{$color}) !important;\n        --#{$prefix}popover-header-color: var(--#{$prefix}white) !important;\n        --#{$prefix}popover-body-padding-x: 1rem !important;\n        --#{$prefix}popover-body-padding-y: .5rem !important;\n    }\n}","//\n// print.scss\n//\n\n// Used invoice page\n@media print {\n    .app-menu,\n    .end-bar,\n    .page-title-box,\n    .navbar-custom,\n    .footer {\n        display: none;\n    }\n    .card-body,\n    .content-page,\n    .end-bar,\n    .content,\n    body {\n        padding: 0;\n        margin: 0;\n    }\n\n    .card {\n        box-shadow: none;\n    }\n}\n","//\n// progress.scss\n//\n\n// Custom height\n\n// Progress height small\n.progress-sm {\n    height: 5px;\n}\n\n// Progress height medium\n.progress-md {\n    height: 8px;\n}\n\n// Progress height large\n.progress-lg {\n    height: 12px;\n}\n\n// Progress height extra large\n.progress-xl {\n    height: 15px;\n}\n\n\n/* Progressbar Vertical */\n.progress-vertical {\n    min-height: 250px;\n    height: 250px;\n    width: 10px;\n    position: relative;\n    display: inline-block;\n    margin-bottom: 0;\n    margin-right: 20px;\n\n    .progress-bar {\n        width: 100%;\n    }\n\n    &.progress-xl {\n        width: 15px;\n    }\n\n    &.progress-lg {\n        width: 12px;\n    }\n\n    &.progress-md {\n        width: 8px;\n    }\n\n    &.progress-sm {\n        width: 5px;\n    }\n}\n\n.progress-vertical-bottom {\n    min-height: 250px;\n    height: 250px;\n    position: relative;\n    width: 10px;\n    display: inline-block;\n    margin-bottom: 0;\n    margin-right: 20px;\n\n    .progress-bar {\n        width: 100%;\n        bottom: 0;\n        position: absolute;\n    }\n\n    &.progress-xl {\n        width: 15px;\n    }\n\n    &.progress-lg {\n        width: 12px;\n    }\n\n    &.progress-md {\n        width: 8px;\n    }\n\n    &.progress-sm {\n        width: 5px;\n    }\n}\n\n","//\n// reboot.scss\n//\n\nhtml {\n    position: relative;\n    min-height: 100%;\n}\n\n// Fix event bubbling on iOS devices\n@supports (-webkit-overflow-scrolling: touch) {\n    body {\n        cursor: pointer;\n    }\n}\n\nbody {\n    overflow-x: hidden;\n}\n\nbutton,\na {\n    outline: none !important;\n}\n\n// Forms\n\nlabel {\n    font-weight: $font-weight-semibold;\n}\n\n// Address\naddress.address-lg {\n    line-height: 24px;\n}\n\nb,\nstrong {\n    font-weight: $font-weight-bold;\n}","//\n// ribbons.scss\n//\n\n.ribbon-box {\n    position: relative;\n\n    .ribbon {\n        position: relative;\n        clear: both;\n        padding: 5px 12px;\n        margin-bottom: 15px;\n        box-shadow: 2px 5px 10px rgba($dark, 0.15);\n        color: $white;\n        font-size: 13px;\n        font-weight: $font-weight-semibold;\n\n        &:before {\n            content: \" \";\n            border-style: solid;\n            border-width: 10px;\n            display: block;\n            position: absolute;\n            bottom: -10px;\n            left: 0;\n            margin-bottom: -10px;\n            z-index: -1;\n        }\n\n        &.float-start {\n            margin-left: -30px;\n            border-radius: 0 3px 3px 0;\n        }\n\n        &.float-end {\n            margin-right: -30px;\n            border-radius: 3px 0 0 3px;\n\n            &:before {\n                right: 0;\n            }\n        }\n\n        &.float-center {\n            span {\n                margin: 0 auto 20px auto;\n            }\n        }\n    }\n\n    .ribbon-content {\n        clear: both;\n    }\n\n    @each $color,\n    $value in $theme-colors {\n        .ribbon-#{$color} {\n            background: ($value);\n\n            &:before {\n                border-color: darken(($value), 5%) transparent transparent;\n            }\n        }\n    }\n\n    /* Ribbon two */\n    .ribbon-two {\n        position: absolute;\n        left: -5px;\n        top: -5px;\n        z-index: 1;\n        overflow: hidden;\n        width: 75px;\n        height: 75px;\n        text-align: right;\n\n        span {\n            font-size: 13px;\n            color: $white;\n            text-align: center;\n            line-height: 20px;\n            transform: rotate(-45deg);\n            width: 100px;\n            display: block;\n            box-shadow: 0 0 8px 0 rgba($dark, 0.08), 0 1px 0 0 rgba($dark, 0.03);\n            position: absolute;\n            top: 19px;\n            left: -21px;\n            font-weight: $font-weight-semibold;\n\n            &:before {\n                content: \"\";\n                position: absolute;\n                left: 0;\n                top: 100%;\n                z-index: -1;\n                border-right: 3px solid transparent;\n                border-bottom: 3px solid transparent;\n            }\n\n            &:after {\n                content: \"\";\n                position: absolute;\n                right: 0;\n                top: 100%;\n                z-index: -1;\n                border-left: 3px solid transparent;\n                border-bottom: 3px solid transparent;\n            }\n        }\n    }\n\n    @each $color,\n    $value in $theme-colors {\n        .ribbon-two-#{$color} {\n            span {\n                background: ($value);\n\n                &:before {\n                    border-left: 3px solid darken(($value), 5%);\n                    border-top: 3px solid darken(($value), 5%);\n                }\n\n                &:after {\n                    border-right: 3px solid darken(($value), 5%);\n                    border-top: 3px solid darken(($value), 5%);\n                }\n            }\n        }\n    }\n}","//\n// switch.scss\n//\n\n//Custom switch\n\ninput[data-switch] {\n    display: none;\n\n    +label {\n        width: 56px;\n        height: 24px;\n        background-color: var(--#{$prefix}gray-100);\n        background-image: none;\n        border-radius: 2rem;\n        cursor: pointer;\n        display: inline-block;\n        text-align: center;\n        position: relative;\n        transition: all 0.1s ease-in-out;\n\n        &:before {\n            color: var(--#{$prefix}secondary-bg-subtle);\n            content: attr(data-off-label);\n            display: block;\n            font-family: inherit;\n            font-weight: $font-weight-semibold;\n            font-size: 0.75rem;\n            line-height: 24px;\n            position: absolute;\n            right: 3px;\n            margin: 0 0.21667rem;\n            top: 0;\n            text-align: center;\n            min-width: 1.66667rem;\n            overflow: hidden;\n            transition: all 0.1s ease-in-out;\n        }\n\n        &:after {\n            content: \"\";\n            position: absolute;\n            left: 4px;\n            background-color: var(--#{$prefix}body-color);\n            box-shadow: none;\n            border-radius: 2rem;\n            height: 18px;\n            width: 18px;\n            top: 3px;\n            transition: all 0.1s ease-in-out;\n        }\n    }\n\n    &:checked {\n        +label {\n            background-color: $primary;\n\n            &:before {\n                color: $white;\n                content: attr(data-on-label);\n                right: auto;\n                left: 4px;\n            }\n\n            &:after {\n                left: 34px;\n                background-color: var(--#{$prefix}gray-100);\n            }\n        }\n    }\n}\n\ninput[data-switch=\"bool\"] {\n    +label {\n        background-color: $danger;\n    }\n}\n\ninput:disabled {\n    +label {\n        opacity: 0.5;\n        cursor: default;\n    }\n}\n\ninput[data-switch=\"bool\"]+label:before,\ninput[data-switch=\"bool\"]:checked+label:before {\n    color: $white  !important;\n}\n\ninput[data-switch=\"bool\"]+label:after {\n    background-color: var(--#{$prefix}gray-100);\n}\n\n@each $color,\n$value in $theme-colors {\n    input[data-switch=\"#{$color}\"]:checked+label {\n        background-color: #{$value};\n    }\n}","//\n// tables.scss\n//\n\n//Table centered (Custom)\n.table-centered {\n\n    th,\n    td {\n        vertical-align: middle !important;\n    }\n}\n\n// Custom table components (Custom)\n.table {\n    .table-user {\n        img {\n            height: 30px;\n            width: 30px;\n        }\n    }\n\n    .action-icon {\n        color: var(--#{$prefix}gray-600);\n        font-size: 1.2rem;\n        display: inline-block;\n        padding: 0 3px;\n\n        &:hover {\n            color: var(--#{$prefix}gray-700);\n        }\n    }\n\n\n    > :not(caption)>*>* {\n        background-color: var(--#{$prefix}table-bg) !important;\n    }\n\n    &.table-bordered {\n        tbody {\n            border-top: $border-width solid;\n            border-top-color: inherit;\n        }\n    }\n}\n\n.table-sm {\n    .action-icon {\n        font-size: 1rem;\n    }\n}\n\n// Tables fluid\n.table-nowrap {\n\n    th,\n    td {\n        white-space: nowrap;\n    }\n}\n\n// Dark Mode light and dark table\nhtml[data-bs-theme=\"dark\"] {\n    .table-light {\n        --#{$prefix}table-bg: #3e4954;\n        --#{$prefix}table-border-color: #{$table-group-separator-color};\n        color: var(--#{$prefix}body-color);\n    }\n\n    .table-dark {\n        --#{$prefix}table-bg: var(--#{$prefix}light);\n\n        tbody,\n        tr {\n            border-color: var(--#{$prefix}gray-300);\n        }\n    }\n}","//\n// type.scss\n//\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin: 10px 0;\n}\n\n// Font sizes (Custom)\n\n$font-size-mixing: 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 36, 48;\n\n@each $font-size-mixing in $font-size-mixing {\n    .font-#{$font-size-mixing} {\n        font-size: #{$font-size-mixing}px !important;\n    }\n}\n\n// Font Weight\n\n.fw-medium {\n    font-weight: $font-weight-medium;\n}\n\n.fw-semibold {\n    font-weight: $font-weight-semibold;\n}","//\n// _tooltip.scss\n//\n\n\n@each $color,\n$value in $theme-colors {\n    .#{$color}-tooltip {\n        --#{$prefix}tooltip-bg: var(--#{$prefix}#{$color}) !important;\n        --#{$prefix}tooltip-color: white !important;\n    }\n}","//\n// utilities.scss\n//\n\n@each $color, $value in $theme-colors {\n    .bg-soft-#{$color} {\n        --#{$prefix}bg-opacity: 0.25;\n        background-color: rgba(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity)) !important;\n    }\n}\n\n.bg-ghost {\n    --#{$prefix}bg-opacity: 0.4;\n}\n\n// border style\n.border-dashed {\n    border-style: dashed !important;\n}","//\n// docs.scss\n//\n//\n// _prismjs.scss\n//\n\n:not(pre)>code[class*=\"language-\"],\npre[class*=\"language-\"] {\n    background: transparent;\n}\n\ncode[class*=\"language-\"],\npre[class*=\"language-\"] {\n    color: black;\n    background: none;\n    text-shadow: 0 1px white;\n    font-family: Consolas, Monaco, \"Andale Mono\", \"Ubuntu Mono\", monospace;\n    font-size: 1em;\n    text-align: left;\n    white-space: pre;\n    word-spacing: normal;\n    word-break: normal;\n    word-wrap: normal;\n    line-height: 1.5;\n    tab-size: 4;\n    hyphens: none;\n}\n\npre[class*=\"language-\"]::selection,\npre[class*=\"language-\"] ::selection,\ncode[class*=\"language-\"]::selection,\ncode[class*=\"language-\"] ::selection {\n    text-shadow: none;\n    background: #b3d4fc;\n}\n\n@media print {\n\n    code[class*=\"language-\"],\n    pre[class*=\"language-\"] {\n        text-shadow: none;\n    }\n}\n\n/* Code blocks */\npre[class*=\"language-\"] {\n    padding: 1em;\n    margin: 0;\n    overflow: auto;\n}\n\n/* Inline code */\n:not(pre)>code[class*=\"language-\"] {\n    padding: 0.1em;\n    border-radius: 0.3em;\n    white-space: normal;\n}\n\n.token.comment,\n.token.prolog,\n.token.doctype,\n.token.cdata {\n    color: slategray;\n}\n\n.token.punctuation {\n    color: $primary;\n}\n\n.token.namespace {\n    opacity: 0.7;\n}\n\n.token.property,\n.token.tag,\n.token.boolean,\n.token.number,\n.token.constant,\n.token.symbol,\n.token.deleted {\n    color: $primary;\n}\n\n.token.selector,\n.token.attr-name,\n.token.string,\n.token.char,\n.token.builtin,\n.token.inserted {\n    color: $success;\n}\n\n.token.operator,\n.token.entity,\n.token.url,\n.language-css .token.string,\n.style .token.string {\n    color: #9a6e3a;\n    /* This background color was intended by the author of this theme. */\n    background: transparent;\n}\n\n.token.atrule,\n.token.attr-value,\n.token.keyword {\n    color: $danger;\n}\n\n.token.function,\n.token.class-name {\n    color: #dd4a68;\n}\n\n.token.regex,\n.token.important,\n.token.variable {\n    color: #e90;\n}\n\n.token.important,\n.token.bold {\n    font-weight: bold;\n}\n\n.token.italic {\n    font-style: italic;\n}\n\n.token.entity {\n    cursor: help;\n}\n\ncode[class*=\"language-\"],\npre[class*=\"language-\"] {\n    color: var(--#{$prefix}secondary-color);\n    text-shadow: none;\n    max-height: 220px;\n}\n\n// Scrollbar\n.tab-pane.code {\n    position: relative;\n\n    pre {\n        &::-webkit-scrollbar {\n            -webkit-appearance: none;\n        }\n\n        &::-webkit-scrollbar:vertical {\n            width: 5px;\n            margin-right: 5px;\n        }\n\n        &::-webkit-scrollbar:horizontal {\n            height: 5px;\n        }\n\n        &::-webkit-scrollbar-thumb {\n            background-color: rgba(var(--#{$prefix}dark-rgb), 0.2);\n            border-radius: 10px;\n            margin-right: 5px;\n            border: none;\n        }\n\n        &::-webkit-scrollbar-track {\n            border-radius: 10px;\n            background-color: transparent;\n        }\n\n        &::-webkit-scrollbar-corner {\n            background-color: transparent;\n        }\n    }\n\n    .btn-copy-clipboard {\n        position: absolute;\n        right: 8px;\n        top: 10px;\n        background-color: $card-bg;\n        border: 1px solid $success;\n        color: $success;\n        padding: 0.28rem 0.8rem;\n        font-size: 0.875rem;\n        border-radius: 0.15rem;\n        font-weight: 400;\n        line-height: 1.5;\n        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out;\n\n        &:hover,\n        &:focus,\n        &:active {\n            background-color: $success;\n            color: $white;\n        }\n    }\n}","// \n// widgets.scss\n//\n\n// Simple tile box\n.widget-flat {\n    position: relative;\n    overflow: hidden;\n\n    i.widget-icon {\n        font-size: 36px;\n    }\n}\n\n// Inbox-widget(Used Profile)\n.inbox-widget {\n    .inbox-item {\n        border-bottom: 1px solid var(--#{$prefix}gray-300);\n        overflow: hidden;\n        padding: 0.625rem 0;\n        position: relative;\n\n        &:last-of-type {\n            border-bottom: none;\n        }\n\n        .inbox-item-img {\n            display: block;\n            float: left;\n            margin-right: 15px;\n            width: 40px;\n\n            img {\n                width: 40px;\n            }\n        }\n\n        .inbox-item-author {\n            // color: $heading-color;\n            display: block;\n            margin-bottom: 3px;\n            // font-weight: $label-font-weight;\n        }\n\n        .inbox-item-text {\n            color: $text-muted;\n            display: block;\n            font-size: 0.8125rem;\n            margin: 0;\n            overflow: hidden;\n        }\n\n        .inbox-item-date {\n            color: var(--#{$prefix}gray-600);\n            font-size: 0.6875rem;\n            position: absolute;\n            right: 5px;\n            top: 10px;\n        }\n    }\n}\n\n/* Chat widget */\n\n.conversation-list {\n    list-style: none;\n    padding: 0 15px;\n\n    li {\n        margin-bottom: 20px;\n\n        .conversation-actions {\n            float: right;\n            display: none;\n        }\n\n        &:hover {\n            .conversation-actions {\n                display: block;\n            }\n        }\n    }\n\n    .chat-avatar {\n        float: left;\n        text-align: center;\n        width: 42px;\n\n        img {\n            border-radius: 100%;\n            width: 100%;\n        }\n\n        i {\n            font-size: 12px;\n            font-style: normal;\n        }\n    }\n\n    .ctext-wrap {\n        background: var(--#{$prefix}light);\n        border-radius: 3px;\n        display: inline-block;\n        padding: 12px;\n        position: relative;\n\n        i {\n            display: block;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: $font-weight-semibold;\n            position: relative;\n        }\n\n        p {\n            margin: 0;\n            padding-top: 3px;\n        }\n\n        &:after {\n            left: -10px;\n            top: 0;\n            border: solid transparent;\n            content: \" \";\n            height: 0;\n            width: 0;\n            position: absolute;\n            pointer-events: none;\n            border-top-color: var(--#{$prefix}light);\n            border-width: 6px;\n            margin-right: -1px;\n            border-right-color: var(--#{$prefix}light);\n        }\n    }\n\n    .conversation-text {\n        float: left;\n        font-size: 12px;\n        margin-left: 12px;\n        width: 70%;\n    }\n\n    .odd {\n        .chat-avatar {\n            float: right !important;\n        }\n\n        .conversation-text {\n            float: right !important;\n            margin-right: 12px;\n            text-align: right;\n            width: 70% !important;\n        }\n\n        .ctext-wrap {\n            background-color: var(--#{$prefix}light);\n\n            &:after {\n                border-color: transparent;\n                border-left-color: var(--#{$prefix}light);\n                border-top-color: var(--#{$prefix}light);\n                right: -10px !important;\n                left: auto;\n            }\n        }\n\n        .conversation-actions {\n            float: left;\n        }\n    }\n}","//\n// horizontal-steps.scss\n//\n\n// Horizontal steps\n.horizontal-steps {\n    display: flex;\n    position: relative;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n\n    &:before {\n        content: \"\";\n        display: block;\n        position: absolute;\n        width: 100%;\n        height: 0.2em;\n        background-color: var(--#{$prefix}gray-100);\n    }\n\n    .process-line {\n        display: block;\n        position: absolute;\n        width: 50%;\n        height: 0.2em;\n        background-color: $primary;\n    }\n\n    .horizontal-steps-content {\n        display: flex;\n        position: relative;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n\n        .step-item {\n            display: block;\n            position: relative;\n            bottom: calc(100% + 1em);\n            height: 8px;\n            width: 8px;\n            margin: 0 2em;\n            box-sizing: content-box;\n            color: $primary;\n            background-color: currentColor;\n            border: 0.25em solid var(--#{$prefix}gray-900);\n            border-radius: 50%;\n            z-index: 5;\n\n            &:first-child {\n                margin-left: 0;\n            }\n\n            &:last-child {\n                margin-right: 0;\n                color: $success;\n            }\n\n            span {\n                position: absolute;\n                top: calc(100% + 1em);\n                left: 50%;\n                transform: translateX(-50%);\n                white-space: nowrap;\n                color: var(--#{$prefix}body-color);\n            }\n\n            &.current {\n                &:before {\n                    content: \"\";\n                    display: block;\n                    position: absolute;\n                    top: 48%;\n                    left: 48%;\n                    padding: 1em;\n                    background-color: currentColor;\n                    border-radius: 50%;\n                    opacity: 0;\n                    z-index: -1;\n                    animation-name: animation-steps-current;\n                    animation-duration: 2s;\n                    animation-iteration-count: infinite;\n                    animation-timing-function: ease-out;\n                }\n\n                span {\n                    color: $primary !important;\n                }\n            }\n        }\n    }\n}\n\n@keyframes animation-steps-current {\n    from {\n        transform: translate(-50%, -50%) scale(0);\n        opacity: 1;\n    }\n\n    to {\n        transform: translate(-50%, -50%) scale(1);\n        opacity: 0;\n    }\n}\n\n@include media-breakpoint-down(md) {\n    .horizontal-steps {\n        .horizontal-steps-content {\n            .step-item {\n                span {\n                    white-space: inherit;\n                }\n            }\n        }\n    }\n}","//\n// preloader.scss\n//\n\n#preloader {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: $card-bg;\n    z-index: 9999;\n}\n\n#status {\n    width: 40px;\n    height: 40px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    margin: -20px 0 0 -20px;\n}\n\n.spinner {\n    margin: 0 auto;\n    font-size: 10px;\n    position: relative;\n    text-indent: -9999em;\n    border-top: 5px solid var(--#{$prefix}gray-300);\n    border-right: 5px solid var(--#{$prefix}gray-300);\n    border-bottom: 5px solid var(--#{$prefix}gray-300);\n    border-left: 5px solid var(--#{$prefix}primary);\n    transform: translateZ(0);\n    animation: SpinnerAnimation 1.1s infinite linear;\n}\n\n.spinner,\n.spinner:after {\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n}\n\n@keyframes SpinnerAnimation {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}","//\n// _hero.scss\n//\n\n.hero-section {\n    position: relative;\n    padding: 80px 0 120px 0;\n\n    &:after {\n        content: \" \";\n        background-image: linear-gradient(to bottom,#6379c3,#546ee5);\n        position: absolute;\n        top: -400px;\n        right: 0;\n        bottom: 0;\n        z-index: -1;\n        width: 100%;\n        border-radius: 0;\n        transform: skewY(-3deg);\n    }\n\n    .hero-title {\n        line-height: 42px;\n    }\n}\n","/*\nTemplate Name: Ubold - Bootstrap 5 Landing Page Tamplat\nAuthor: CoderThemes\nEmail: coderthemes@gmail.com\nFile: Main scss file\n*/\n\n/*******************************\n01.Helper\n02.Navbar\n03.Home\n04.Features\n05.Demo\n06.Pricing\n07.Faqs\n08.Testionial\n09.Contact\n10.Cta\n11.Footer\n12.Responsive\n********************************/\n\n@import \"variable\";\n\n//\n// Google font - Nunito\n//\n\n@import url(\"https://fonts.googleapis.com/css?family=Nunito:400,600,700,900\");\n\n//\n// Premium font - Cerebri Sans\n//\n\n@font-face {\n  font-family: \"Cerebri Sans,sans-serif\";\n  src: url(\"../../../fonts/cerebrisans-light.eot\");\n  src: local(\"Cerebri-sans Light\"),\n    url(\"../../../fonts/cerebrisans-light.woff\") format(\"woff\");\n  font-weight: 300;\n}\n\n@font-face {\n  font-family: \"Cerebri Sans,sans-serif\";\n  src: url(\"../../../fonts/cerebrisans-regular.eot\");\n  src: local(\"Cerebri-sans Regular\"),\n    url(\"../../../fonts/cerebrisans-regular.woff\") format(\"woff\");\n  font-weight: 400;\n}\n@font-face {\n  font-family: \"Cerebri Sans,sans-serif\";\n  src: url(\"../../../fonts/cerebrisans-medium.eot\");\n  src: local(\"Cerebri-sans Medium\"),\n    url(\"../../../fonts/cerebrisans-medium.woff\") format(\"woff\");\n  font-weight: 500;\n}\n@font-face {\n  font-family: \"Cerebri Sans,sans-serif\";\n  src: url(\"../../../fonts/cerebrisans-semibold.eot\");\n  src: local(\"Cerebri-sans Semibold\"),\n    url(\"../../../fonts/cerebrisans-semibold.woff\") format(\"woff\");\n  font-weight: 600;\n}\n@font-face {\n  font-family: \"Cerebri Sans,sans-serif\";\n  src: url(\"../../../fonts/cerebrisans-bold.eot\");\n  src: local(\"Cerebri-sans Bold\"),\n    url(\"../../../fonts/cerebrisans-bold.woff\") format(\"woff\");\n  font-weight: 700;\n}\n\n/*******************\n    1.Helper\n*******************/\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: $font-family-secondary;\n}\n\nh3 {\n  line-height: 30px;\n}\n\na {\n  text-decoration: none !important;\n  outline: none;\n}\n\np {\n  line-height: 1.6;\n  font-size: 15px;\n}\n#landing {\n\n  font-family: $font-family-primary;\n  font-size: $font-base;\n  background-color: $white;\n\n  .section {\n    position: relative;\n    padding-top: 80px;\n    padding-bottom: 80px;\n  }\n\n  .section-sm {\n    position: relative;\n    padding-top: 60px;\n    padding-bottom: 60px;\n  }\n\n  html {\n    scroll-padding-top: 59px; /* height of sticky header */\n  }\n\n  .row > * {\n    position: relative;\n  }\n\n  @media (min-width: 1400px) {\n    .container {\n      max-width: 1140px;\n    }\n  }\n\n  .bg-gradient {\n    background: $bg-gradient !important;\n  }\n\n  /**BACK TO TOP**/\n\n  .back-to-top-btn {\n    position: fixed;\n    padding: 0px 3px !important;\n    bottom: 10px;\n    right: 20px;\n    display: none;\n    text-align: center;\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    border-radius: 3px;\n    i {\n      font-size: 22px;\n      line-height: 28px;\n    }\n  }\n\n  /******************\n    2.Navbar\n*******************/\n\n  .navbar-custom {\n    padding: 20px 0px;\n    width: 100%;\n    border-radius: 0px;\n    z-index: 999;\n    margin-bottom: 0px;\n    transition: all 0.5s ease-in-out;\n    .logo {\n      .logo-light {\n        display: inline-block;\n      }\n      .logo-dark {\n        display: none;\n      }\n    }\n    .navbar-nav {\n      .nav-item {\n        .nav-link {\n          line-height: 26px;\n          color: rgba($white, 0.6);\n          transition: all 0.4s;\n          background-color: transparent !important;\n          padding: 6px 10px;\n          margin: 0 7px;\n          font-weight: 600;\n          &:hover,\n          &.active,\n          &:active {\n            color: $white;\n          }\n        }\n      }\n    }\n  }\n\n  .navbar-toggler {\n    font-size: 24px;\n    margin-top: 5px;\n    margin-bottom: 0px;\n    color: $white;\n  }\n\n  /*--- navbar sticky ---*/\n\n  .nav-sticky.navbar-custom {\n    margin-top: 0px;\n    padding: 10px 0px;\n    background-color: $white;\n    box-shadow: 0 10px 33px -14px rgba($black, 0.1);\n    .logo {\n      .logo-dark {\n        display: inline-block;\n      }\n      .logo-light {\n        display: none;\n      }\n    }\n\n    .navbar-nav {\n      .nav-item {\n        .nav-link {\n          color: rgba($dark, 0.8);\n          &:hover,\n          &.active,\n          &:active {\n            color: $primary;\n          }\n        }\n      }\n    }\n  }\n\n  /*******************\n    3.Home\n*******************/\n\n  .bg-home {\n    position: relative;\n    padding: 200px 0px 180px 0px;\n  }\n\n  .home-center {\n    display: table;\n    width: 100%;\n    height: 100%;\n  }\n\n  .home-desc-center {\n    display: table-cell;\n    vertical-align: middle;\n  }\n\n  .home-title {\n    .home-desc {\n      max-width: 605px;\n      font-size: 16px;\n    }\n    .subscribe {\n      input {\n        padding: 10px 20px;\n        border: 1px solid rgba($white, 0.1);\n        height: 43px;\n        font-size: $font-base;\n        color: rgba($white, 0.6);\n        background: rgba($white, 0.1);\n        &::-webkit-input-placeholder {\n          color: rgba($white, 0.6);\n        }\n        &:-moz-placeholder {\n          color: rgba($white, 0.6);\n        }\n        &::-moz-placeholder {\n          color: rgba($white, 0.6);\n        }\n        &:-ms-input-placeholder {\n          color: rgba($white, 0.6);\n        }\n      }\n      .btn {\n        min-height: 43px;\n      }\n      .form-control:focus {\n        outline: 0;\n        box-shadow: none;\n      }\n    }\n  }\n\n  .home-first-img {\n    position: relative;\n    z-index: 2;\n    max-width: 300px;\n  }\n\n  .home-second-img {\n    position: absolute;\n    max-width: 250px;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 61px;\n    right: 0px;\n    z-index: 1;\n    opacity: 0.8;\n  }\n\n  .home-third-img {\n    position: absolute;\n    right: 0px;\n    max-width: 200px;\n    top: 50%;\n    transform: translateY(-50%);\n    opacity: 0.7;\n  }\n\n  .clients {\n    position: relative;\n    top: -70px;\n    box-shadow: 0 10px 35px 0 rgba($gray-600, 0.1);\n    border-radius: 8px;\n    margin-bottom: -70px;\n\n    .client-images {\n      img {\n        margin: 10px auto;\n        opacity: 0.7;\n      }\n    }\n  }\n\n  /*******************\n    4.features\n********************/\n\n  .features-box {\n    padding: 30px;\n    text-align: center;\n\n    .features-img {\n      img {\n        max-height: 60px;\n      }\n    }\n  }\n\n  .features-icon {\n    i {\n      display: inline-block;\n      width: 48px;\n      height: 48px;\n      background: $bg-gradient;\n      border-radius: 7px;\n      line-height: 48px;\n    }\n  }\n\n  /*******************\n    5.demo\n********************/\n\n  .demo-box,\n  .testi-desc {\n    box-shadow: 0 10px 35px 0 rgba($gray-600, 0.1);\n    border-radius: 7px;\n  }\n\n  /*******************\n    6.pricing\n********************/\n\n  .pricing-plan {\n    position: relative;\n    overflow: hidden;\n    box-shadow: 0 0.125rem 0.25rem rgba($black, 0.075);\n    border-radius: 9px;\n    max-width: 370px;\n    margin: 0px auto;\n    .lable {\n      background-color: $light;\n      color: $primary;\n      font-size: 12px;\n      font-weight: 700;\n      right: -26px;\n      padding: 2px 25px;\n      position: absolute;\n      text-transform: uppercase;\n      top: 20px;\n      transform: rotate(45deg);\n    }\n  }\n  .pricing-plan.active {\n    background-image: linear-gradient(120deg, #63e4ec 0%, #3db9dc 100%);\n  }\n\n  .pricing-list {\n    padding-left: 20px;\n    li {\n      padding-left: 25px;\n      position: relative;\n\n      i {\n        position: absolute;\n        left: 0;\n      }\n    }\n  }\n\n  .bg-shape {\n    position: absolute;\n    bottom: -1px;\n    left: 0px;\n    right: 0px;\n    img {\n      width: 100%;\n    }\n  }\n\n  /*******************\n    7.faqs\n********************/\n\n  .faq-question-q-box {\n    height: 30px;\n    width: 30px;\n    color: $primary;\n    text-align: center;\n    border-radius: 50%;\n    float: left;\n    font-weight: 700;\n    line-height: 30px;\n    background-color: rgba($primary, 0.15);\n  }\n\n  .faq-question {\n    margin-top: 0;\n    margin-left: 50px;\n    font-size: 16px;\n  }\n\n  .faq-answer {\n    margin-left: 50px;\n    font-size: 14.5px;\n  }\n\n  /*******************\n    8.testionial\n********************/\n\n  .testi-box {\n    .testi-desc {\n      position: relative;\n      &:before {\n        content: \"\";\n        position: absolute;\n        width: 14px;\n        height: 14px;\n        background: $white;\n        bottom: -6px;\n        left: 48px;\n        transform: rotate(45deg);\n      }\n    }\n    .testi-img {\n      img {\n        max-width: 48px;\n      }\n    }\n  }\n\n  /*******************\n    9.contact\n********************/\n\n  .custom-form {\n    box-shadow: 0 10px 35px 0 rgba($gray-600, 0.1);\n    border-radius: 8px;\n    .form-group {\n      margin-bottom: 1.5rem;\n      .form-control {\n        height: 43px;\n      }\n      textarea.form-control {\n        height: auto;\n      }\n    }\n  }\n\n  .error {\n    margin: 8px 0px;\n    display: none;\n    color: $danger;\n  }\n\n  #ajaxsuccess {\n    font-size: 16px;\n    width: 100%;\n    display: none;\n    clear: both;\n    margin: 8px 0px;\n  }\n\n  .error_message {\n    padding: 10px;\n    margin-bottom: 20px;\n    text-align: center;\n    color: #806027;\n    background-color: #fdf1db;\n    border-color: #fdebcd;\n    border-radius: 5px;\n    font-size: 14px;\n  }\n\n  .contact-loader {\n    display: none;\n  }\n\n  #success_page {\n    text-align: center;\n    margin-bottom: 50px;\n  }\n\n  #success_page h3 {\n    color: $success;\n    font-size: 22px;\n  }\n\n  /*******************\n    10.cta\n********************/\n\n  .cta {\n    background-image: linear-gradient(120deg, #63e4ec 0%, #3db9dc 100%);\n    border-radius: 8px;\n  }\n\n  /*******************\n    11.footer\n********************/\n\n  .footer {\n    position: unset;\n    height: unset;\n    padding: 60px 0px 20px 0px;\n    .footer-list {\n      li {\n        padding: 7px 0px;\n        a {\n          color: rgba($white, 0.4);\n          transition: all 0.4s;\n          &:hover {\n            color: $white;\n          }\n        }\n      }\n    }\n\n    .social-links {\n      li {\n        a {\n          color: rgba($white, 0.4);\n          font-size: 18px;\n          padding: 0px 5px;\n          transition: all 0.4s;\n          &:hover {\n            color: $white;\n          }\n        }\n      }\n    }\n  }\n\n  /******************\n    12.Responsive\n*******************/\n  @media (min-width: 200px) and (max-width: 1199px) {\n    .container-fluid {\n      max-width: 95%;\n    }\n  }\n\n  @media (min-width: 1200px) {\n    .container-fluid {\n      max-width: 85%;\n    }\n  }\n\n  @media (min-width: 1600px) {\n    .container-fluid {\n      max-width: 70%;\n    }\n  }\n\n  @media (min-width: 200px) and (max-width: 768px) {\n    .navbar-custom {\n      margin-top: 0px;\n      padding: 10px 0px !important;\n      background-color: $white !important;\n      box-shadow: 0 10px 33px -14px rgba($black, 0.1);\n\n      .logo {\n        .logo-dark {\n          display: inline-block;\n        }\n        .logo-light {\n          display: none;\n        }\n      }\n      .navbar-nav {\n        .nav-item {\n          .nav-link {\n            transition: all 0.4s;\n            color: rgba($dark, 0.8) !important;\n            margin: 0px;\n            padding: 6px 0px;\n            &:hover,\n            &.active,\n            &:active {\n              color: $primary !important;\n            }\n          }\n        }\n      }\n    }\n    .navbar-toggler {\n      font-size: 24px;\n      margin-top: 0px;\n      margin-bottom: 0px;\n      color: $dark;\n    }\n    .bg-home {\n      padding: 130px 0px 120px 0px;\n    }\n    .mo-mb-20 {\n      margin-bottom: 20px !important;\n    }\n  }\n\n  @media (max-width: 425px) {\n    .home-title {\n      h1 {\n        font-size: 34px;\n      }\n    }\n    .home-img {\n      display: none;\n    }\n    .features-content,\n    .cta,\n    .custom-form {\n      padding: 24px !important;\n    }\n    .pull-none {\n      float: none !important;\n      text-align: center;\n    }\n  }\n}\n","\n$white:    #ffffff;\n$gray-100: #f3f7f9;\n$gray-200: #f7f7f7;\n$gray-300: #dee2e6;\n$gray-400: #ced4da;\n$gray-500: #adb5bd;\n$gray-600: #98a6ad;\n$gray-700: #6c757d;\n$gray-800: #28282e;\n$gray-900: #323a46;\n$black:    #000000;\n\n\n$primary:       #673ab7;\n$success:       #10c469;\n$info:          #3db9dc;\n$danger:        #ff5d48;\n$dark:          #28282e;\n$light:         #f9f9f9;\n$muted:         #7a7d84;\n\n$lightdark:     #e6e6e6;\n\n$font-base :    14px;\n\n$bg-gradient : linear-gradient(to left, #673ab7, #3e1e8c);\n\n$font-family-primary : 'Nunito', sans-serif;\n$font-family-secondary: \"Cerebri Sans,sans-serif\";"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
